/** Catalogul ROMÂNESC — sursa de adevăr a cheilor.
 *
 *  Tipul `Cheie` iese de aici, deci orice cheie scrisă în fișierul ăsta devine
 *  obligatorie în toate celelalte cataloage: `en.ts` nu compilează fără ea. Un
 *  text nou se scrie mai întâi aici, apoi imediat în restul limbilor — v.
 *  `docs/internationalizare.md`.
 *
 *  CONVENȚII
 *    * cheia e un NUME, `zona.lucru`, niciodată textul însuși;
 *    * `{nume}` marchează un loc gol umplut la rulare, cu ACELEAȘI nume în
 *      toate limbile (testul le compară);
 *    * o cheie terminată în `#n` are trei forme despărțite de `|` — singular,
 *      plural mic, plural cu «de» —, fiindcă româna are trei;
 *    * secțiunile urmează ecranele, ca un text să se găsească de la fișierul în
 *      care e scris.
 */

export const ro = {
  // --- cuvintele care se repetă pe toate ecranele ------------------------
  "comun.se_incarca": "Se încarcă…",
  "comun.salveaza": "Salvează",
  "comun.se_salveaza": "Se salvează…",
  "comun.salvat": "salvat",
  "comun.renunta": "Renunță",
  "comun.creeaza": "Creează",
  "comun.mai_departe": "Mai departe",
  "comun.inapoi": "← Înapoi",
  "comun.adauga": "Adaugă",
  "comun.email": "Email",
  "comun.nume": "Nume",
  "comun.parola": "Parolă",
  "comun.inapoi_la_proiecte": "← Proiectele tale",
  "comun.doar_citire": "Ai doar drept de citire pe proiectul ăsta",

  // --- clientul de API: ce se vede când serverul tace sau se sufocă -------
  "api.server_mut": "Serverul nu răspunde. Verifică legătura și încearcă din nou.",
  "api.esec": "Ceva n-a mers ({stare}) la {metoda} {cale}.",
  "api.esec_incarcare": "Ceva n-a mers ({stare}) la încărcarea fișierelor.",

  // --- interfața căzută: plasa de la rădăcină (`components/InterfataCazuta`) --
  "cadere.titlu": "Ecranul s-a oprit dintr-o eroare.",
  "cadere.text": "Am primit raportul ei. Lucrul salvat e în siguranță; reîncarcă pagina ca să continui.",
  "cadere.cod": "Codul erorii: {cod}",
  "cadere.reincarca": "Reîncarcă pagina",

  // --- meniul contului, colțul din dreapta sus ---------------------------
  "cont.titlu": "Contul tău",
  "cont.proiecte": "Proiecte",
  "cont.tronsoane": "Tronsoane",
  "cont.organizatie": "Organizație",
  "cont.profil": "Profil",
  "cont.iesi": "Ieși din cont",

  // --- refuzurile de acces, ecrane întregi -------------------------------
  "inexistent.negasit": "Not found",
  "fara_acces.titlu": "Nu ai acces la proiectul ăsta",
  "fara_acces.exista_numit": "<b>{proiect}</b> există",
  "fara_acces.exista": "Proiectul există",
  "fara_acces.in_org": " în {organizatie}",
  "fara_acces.explicatie": ", dar contul tău nu e pe lista lui. Cere accesul cuiva care îl administrează.",
  "fara_acces.cine_poate": "Cine îți poate da acces",
  "fara_acces.subiect_mail": "Cerere de acces: {proiect}",
  "fara_acces.proiect_anonim": "proiect",
  "fara_acces.inapoi": "← Proiectele mele",

  // --- banda de rol ------------------------------------------------------
  "rol.banda_citire": "Ai drept de <b>citire</b> pe proiectul ăsta — poți vedea tot, dar nu poți schimba nimic. Accesul îl dă cine administrează proiectul.",

  // --- numele proiectului, în antet și pe titlul dosarului ---------------
  "nume_proiect.camp": "Numele proiectului",
  "nume_proiect.esec": "Nu am putut salva numele.",
  "nume_proiect.redenumeste": "Clic: redenumește proiectul",
  "nume_proiect.salvat": "nume salvat",

  // --- carcasa aplicației: șina din stânga -------------------------------
  "rail.dosar": "Documentele proiectului",
  "rail.verificari": "Verificări",
  "rail.verificari_picate#n": "Verificări — 1 critică sau globală pică|Verificări — {n} critice și globale pică|Verificări — {n} de critice și globale pică",
  "rail.colectie": "Colecția de tronsoane — șabloanele de apartamente",
  "rail.setari": "Setările proiectului — acces, nume, arhivare",
  "rail.aria": "Navigarea proiectului",
  "rail.proiect": "Proiect — soluția la care te uitai",
  "rail.solutii": "Soluțiile proiectului — tot arborele, cu previzualizare",
  "app.se_incarca_viewerul": "Se încarcă viewerul…",

  // --- ecranul de intrare în cont ----------------------------------------
  "login.pitch_titlu": "AI care proiectează lumea fizică",
  "login.pitch_text": "De la certificatul de urbanism la documentația completă: volumetrie, arhitectură, structură, instalații și deviz — cu fiecare cifră explicată și verificată pe lege.",
  "login.beta": "Closed beta · România",
  "login.titlu": "Intră în cont",
  "login.intra": "Intră",
  "login.se_verifica": "Se verifică…",
  "login.sau": "sau",
  "login.google": "Continuă cu Google",
  "login.google_titlu": "Se activează după ce platforma primește un domeniu",
  "login.doar_invitatie": "Acces pe bază de invitație în closed beta.",
  "login.credentiale": "Email sau parolă greșite.",
  "login.esec": "Nu am putut face autentificarea. Încearcă din nou.",

  // --- profilul propriu --------------------------------------------------
  "profil.titlu": "Profil",
  "profil.salvat": "Salvat.",
  "profil.limba_sectiune": "Limba interfeței",
  "profil.limba_eticheta": "Limbă",
  "profil.limba_nota": "Schimbă limba în care ți se scrie platforma. Cifrele, numele de proiecte și documentele rămân cum sunt — se traduce interfața.",
  "profil.limba_esec": "Nu am putut schimba limba.",
  "profil.voce_sectiune": "Asistentul",
  "profil.voce_citeste": "Citește cu voce tare răspunsurile asistentului",
  "profil.voce_nota": "Alegerea ține de browserul ăsta, nu de cont: pe alt calculator asistentul tace până o pornești și acolo.",
  "profil.parola_sectiune": "Parolă",
  "profil.parola_curenta": "Parola curentă",
  "profil.parola_noua": "Parola nouă (minimum 10 caractere)",
  "profil.schimba_parola": "Schimbă parola",
  "profil.parola_schimbata": "Schimbată.",
  "profil.parola_nota": "Schimbarea parolei închide sesiunile de pe celelalte dispozitive. Sesiunea de aici rămâne deschisă.",
  "profil.parola_gresita": "Parola curentă nu e corectă.",
  "profil.parola_esec": "Nu am putut schimba parola.",

  // --- acceptarea unei invitații -----------------------------------------
  "invitatie.pitch_titlu": "Ai fost invitat",
  "invitatie.pitch_text": "Îți alegi o parolă și intri direct în proiectele organizației. Adresa de email e cea pe care a fost trimisă invitația și nu se poate schimba aici.",
  "invitatie.titlu": "Invitație",
  "invitatie.se_verifica": "Verific invitația…",
  "invitatie.creeaza_cont": "Creează-ți contul",
  "invitatie.in_org": "În <b>{organizatie}</b>, ca {rol}.",
  "invitatie.parola_noua": "Parolă (minimum 10 caractere)",
  "invitatie.se_creeaza": "Se creează contul…",
  "invitatie.buton": "Creează contul",
  "invitatie.esec": "Nu am putut finaliza. Încearcă din nou.",
  "invitatie.inexistenta": "Invitația nu există.",
  "invitatie.anulata": "Invitația a fost anulată.",
  "invitatie.folosita": "Invitația a fost deja folosită.",
  "invitatie.expirata": "Invitația a expirat.",
  "invitatie.nefolosibila": "Invitația nu poate fi folosită.",

  // --- organizația: membri și invitații ----------------------------------
  "org.titlu": "Organizație",
  "org.membri": "Membri",
  "org.invitatii": "Invitații",
  "org.dezactivat": "dezactivat",
  "org.reactiveaza": "Reactivează",
  "org.dezactiveaza": "Dezactivează",
  "org.confirma_reactivare": "Reactivezi contul {email}?",
  "org.confirma_dezactivare": "Dezactivezi contul {email}?",
  "org.rol_membru": "membru",
  "org.rol_admin": "admin",
  "org.rol_owner": "owner",
  "org.invita": "Invită",
  "org.link_titlu": "Linkul de invitație.",
  "org.link_text": "Emailul nu se trimite încă (SMTP neconfigurat), deci trimite-l tu. Nu mai poate fi recuperat după ce închizi pagina.",
  "org.nicio_invitatie": "Nicio invitație.",
  "org.expira": "expiră",
  "org.stare_acceptata": "acceptată",
  "org.stare_expirata": "expirată",
  "org.stare_deschisa": "deschisă",
  "org.confirma_stergere_invitatie": "Ștergi invitația pentru {email}?",
  "org.esec_stergere_invitatie": "Nu am putut șterge invitația.",
  "org.esec_invitatie": "Nu am putut crea invitația.",
  "org.esec_stare_cont": "Nu am putut schimba starea contului.",
  "org.email_invalid": "Adresa de email nu e validă.",
  "org.deja_membru": "Persoana e deja membră.",
  "org.deja_invitat": "Există deja o invitație deschisă pentru adresa asta.",
  "org.fara_drept_invitare": "Nu ai dreptul să inviți în organizația asta.",
  "org.nu_te_dezactivezi": "Nu te poți dezactiva pe tine.",
  "org.doar_owner": "Doar un owner poate dezactiva un alt owner.",

  // --- lista de proiecte -------------------------------------------------
  "proiecte.titlu": "Proiecte",
  "proiecte.toate": "Toate",
  "proiecte.cauta": "Caută după nume…",
  "proiecte.nou": "Proiect nou",
  "proiecte.esec_incarcare": "Nu am putut încărca proiectele.",
  "proiecte.esec_creare": "Nu am putut crea proiectul.",
  "proiecte.confirma_arhivare": "Arhivezi „{proiect}”? Nu se șterge nimic, dispare din listă.",
  "proiecte.arhivare_interzisa": "Nu ai drept să arhivezi „{proiect}” — ai doar drept de citire pe el.",
  "proiecte.esec_arhivare": "Nu am putut arhiva „{proiect}”.",
  "proiecte.arhiveaza": "Arhivează proiectul",
  "proiecte.gol_titlu": "Niciun proiect încă.",
  "proiecte.gol_text": "Un proiect ține dosarul, tema și toate soluțiile generate pe el — plan de situație, arhitectură, structură.",
  "proiecte.fara_potrivire": "Niciun proiect nu se potrivește cu „{cautare}”.",
  "proiecte.teren": "{suprafata} m² teren",
  "proiecte.fara_dosar_inca": "încă fără date din dosar",
  "proiecte.se_genereaza": "se generează {ce}",
  "proiecte.neconforme": "{n} neconforme",
  "proiecte.fara_dosar": "fără dosar",
  "proiecte.actualizat": "actualizat {cand}",
  "eticheta.apartament#n": "AP. O CAMERĂ · {s} m² UTILI|AP. {n} CAMERE · {s} m² UTILI|AP. {n} DE CAMERE · {s} m² UTILI",
  "eticheta.apartament_scurt#n": "AP. 1 CAM · {s} m²|AP. {n} CAM · {s} m²|AP. {n} CAM · {s} m²",
  "proiecte.numar#n": "1 proiect|{n} proiecte|{n} de proiecte",
  "proiecte.ruleaza_acum": "{n} rulează acum",
  "proiecte.documente#n": "1 document|{n} documente|{n} de documente",
  "proiecte.azi": "azi, {ora}",
  "proiecte.ieri": "ieri",

  // --- proiectul nou: tipul, apoi numele ---------------------------------
  "tip.complet": "Proiect complet",
  "tip.structura": "Proiect de structură",
  "tip.complet_scurt": "Complet",
  "tip.structura_scurt": "Structură",
  "proiect_nou.eticheta": "Proiect nou",
  "proiect_nou.inapoi_proiecte": "Proiecte",
  "proiect_nou.titlu": "Ce fel de proiect pornești?",
  "proiect_nou.sub": "Alegerea hotărăște ce aduci în dosar și ce generează Optimus pe el.",
  "proiect_nou.incarci": "Încarci",
  "proiect_nou.primesti": "Primești",
  "proiect_nou.pasi#n": "1 pas|{n} pași|{n} de pași",
  "proiect_nou.livrabile#n": "1 livrabil|{n} livrabile|{n} de livrabile",
  "proiect_nou.complet_de_la": "Pornești de la teren",
  "proiect_nou.complet_desc": "Încarci actele terenului, iar Optimus proiectează clădirea întreagă: de la planul de situație până la deviz.",
  "proiect_nou.complet_incarci": "Certificatul de urbanism, PUZ sau PUD, extrasul de carte funciară, studiul geotehnic și planul topografic.",
  "proiect_nou.complet_cta": "Pornește un proiect complet",
  "proiect_nou.complet_desen": "Clădirea întreagă, pe lotul ei",
  "proiect_nou.structura_de_la": "Pornești de la o arhitectură",
  "proiect_nou.structura_desc": "Încarci un proiect de arhitectură existent, iar Optimus proiectează structura pe el, fără să-i schimbe planurile.",
  "proiect_nou.structura_incarci": "Planșele de arhitectură în DWG, pentru fiecare nivel, și studiul geotehnic.",
  "proiect_nou.structura_cta": "Pornește un proiect de structură",
  "proiect_nou.structura_desen": "Scheletul aceleiași clădiri: stâlpi, grinzi, pereți, planșee",
  "proiect_nou.inapoi_alegere": "Înapoi la alegere",
  "proiect_nou.ai_ales": "Ai ales",
  "proiect_nou.schimba": "Schimbă",
  "proiect_nou.nume_titlu": "Cum se numește proiectul?",
  "proiect_nou.nume_camp": "Numele proiectului",
  "proiect_nou.nume_exemplu": "ex. Bloc Olteniței P+4",
  "proiect_nou.nume_nota": "E un nume de lucru — îl poți schimba oricând din dosar.",
  "proiect_nou.organizatia": "Organizația",
  "proiect_nou.creeaza": "Creează proiectul",
  "proiect_nou.se_creeaza": "Se creează…",
  "proiect_nou.urmeaza": "Ce urmează",
  "proiect_nou.fara_organizatie": "Nu faci parte din nicio organizație, deci n-ai unde crea un proiect. Cere o invitație celui care administrează organizația.",
  "proiect_nou.geometrie_titlu": "Cum pornește structura?",
  "proiect_nou.geometrie_sub": "Geometria macro o propune Optimus pe arhitectura ta sau o citește din planșele care o au deja desenată. Calculul de detaliu e același.",
  "proiect_nou.geometrie_macro_ce": "Geometria macro",
  "proiect_nou.geometrie_macro_desc": "Pozițiile și dimensiunile elementelor verticale — stâlpi și pereți de beton — și pozițiile grinzilor, pe fiecare nivel. E scheletul pe care se face tot calculul.",
  "proiect_nou.detaliu_ce": "Calculul de detaliu",
  "proiect_nou.detaliu_desc": "Modelarea fizică a clădirii (element finit, analiză modală și seismică), dimensionarea grinzilor și a plăcilor și armarea tuturor elementelor, astfel încât să treacă verificările din normativ — de exemplu:",
  "proiect_nou.verif_1": "deplasările laterale: driftul la SLS și ULS și efectul de bici (P100-1)",
  "proiect_nou.verif_2": "momentele capabile ale grinzilor și stâlpilor față de cele din analiză (M_Rd ≥ M_Ed) și forța tăietoare pe zone",
  "proiect_nou.verif_3": "ierarhia capacităților în noduri: stâlp tare – grindă slabă (ΣM_Rc ≥ γ_Rd·ΣM_Rb)",
  "proiect_nou.verif_4": "ductilitatea secțiunilor: înălțimea zonei comprimate, confinarea capetelor, procentele de armare minime și maxime",
  "proiect_nou.verif_5": "plăcile: armarea pe momente și săgeata",
  "proiect_nou.verif_6": "fundația: presiunea pe teren față de p_conv, tasările, lunecarea și răsturnarea",
  "proiect_nou.generata_eticheta": "Optimus propune",
  "proiect_nou.generata_nume": "Generează geometria macro și calculul de detaliu",
  "proiect_nou.generata_desc": "Optimus așază elementele verticale și grinzile pe arhitectura importată, caută varianta care trece verificările, apoi face calculul de detaliu pe ea.",
  "proiect_nou.generata_incarci": "Planșele de arhitectură în DWG, pentru fiecare nivel, și studiul geotehnic.",
  "proiect_nou.generata_cta": "Pornește cu geometria generată",
  "proiect_nou.importata_eticheta": "Din planșele tale",
  "proiect_nou.importata_nume": "Importă geometria macro și generează calculul de detaliu",
  "proiect_nou.importata_desc": "Optimus citește din planșe stâlpii, pereții de beton și grinzile desenate pe layerele de structură, le ține pe loc și face calculul de detaliu pe ele: analiza și verificarea unei structuri existente. Ce nu e desenat se completează și se spune.",
  "proiect_nou.importata_incarci": "Planșele în DWG cu structura desenată pe layerele ei — stâlpi, pereți de beton, grinzi —, pentru fiecare nivel, și studiul geotehnic.",
  "proiect_nou.importata_cta": "Pornește cu geometria importată",
  "proiect_nou.geometrie_generata_scurt": "geometria macro generată",
  "proiect_nou.geometrie_importata_scurt": "geometria macro importată din planșe",
  "proiect_nou.oricand": "Oricare ar fi alegerea, din lista de soluții poți porni mai târziu și cealaltă, pe același proiect.",
  "livrabil.situatie": "Plan de situație",
  "livrabil.fatada": "Fațadă",
  "livrabil.apartamente": "Plan de apartamente",
  "livrabil.subsol": "Plan de subsol",
  "livrabil.structura": "Structură",
  "livrabil.sanitare": "Instalații sanitare",
  "livrabil.electrice": "Instalații electrice",
  "livrabil.hvac": "Instalații HVAC",
  "livrabil.deviz": "Deviz complet",
  "livrabil.plan_structura": "Plan de structură",
  "livrabil.plan_structura_desc": "Stâlpi, grinzi, pereți și planșee pe fiecare nivel, plus fundația.",
  "livrabil.deviz_structura": "Deviz de structură",
  "livrabil.deviz_structura_desc": "Betonul, armătura și cofrajul, cu cantitățile și costul lor.",

  // --- bara de pornire a unui proiect ------------------------------------
  "pasi.dosar": "Încarcă documentele",
  "pasi.localizare": "Detalii teren",
  "pasi.tema": "Tema proiectului",
  "pasi.volumetrie": "Volumetria",
  "pasi.fatada": "Fațada",
  "pasi.solutii": "Soluții",
  "pasi.proiect_arhitectura": "Încarcă proiectul",
  "pasi.arhitectura_importata": "Arhitectura importată",

  // --- costuri -----------------------------------------------------------
  "costuri.capcana": "devizul complet al proiectului · costul din registrul soluțiilor e cel COMPARABIL între ramuri (alte capitole)",
  "costuri.fisa": "fișa soluției →",

  // --- navigarea platformei: lanțul, comutatorul, soluțiile pe faze (nav/) ---
  "solutie.amplasarea_n": "Situație {n}",
  "solutie.arhitectura_n": "Arhitectură {n}",
  "solutie.schita": "Schiță",
  "solutie.schita_n": "Structură 0 · schiță",
  "solutie.n": "Structură {n}",
  "solutie.editare_n": "{nume} · Editare {k}",
  "solutie.editare_nr": "{n} · editare {k}",
  "faza.macro": "Geometrie macro",
  "faza.detaliu": "Calcul de detaliu",
  "faza.macro_scurt": "macro",
  "faza.detaliu_scurt": "detaliu",
  "faza.rafinare": "rafinare",
  "faza.rafinare_titlu": "Verificarea pe modelul de conformare n-a trecut; ajustăm geometria o dată, în aceeași soluție",
  "faza.trecerea": "trecerea {k} din {n}",
  "faza.se_opreste": "se oprește…",
  "faza.amplasare": "Amplasare",
  "faza.agent": "Circulație și amenajări",
  "faza.etaje": "Etaje",
  "faza.subsol": "Subsol",
  "faza.import": "Import",
  "faza.recomp": "Recompartimentare",
  "faza.fatada": "Fațadă",
  "durata.sub_minut": "sub un minut",
  "durata.min": "{n} min",
  "durata.ore_min": "{h} h {m} min",
  "faza.nu_trece_motiv": "nu trece: {motiv}",
  "faza.macro_editata": "desenată de tine",
  "faza.macro_importata": "importată din planșe",
  "faza.detaliu_singur": "îl pornești tu, după geometria macro",
  "faza.detaliu_urmeaza": "îl pornești tu",
  "faza.detaliu_la_cerere": "îl pornești tu, când ai terminat de desenat",
  "stare.gata": "gata",
  "stare.nu_trece": "nu trece",
  "stare.in_lucru": "în lucru",
  "stare.la_rand": "la rând",
  "stare.asteapta": "așteaptă",
  "stare.picata": "picată",
  "stare.oprita": "oprită",
  "stare.nepornita": "nepornită",
  "stare.sarit": "sărit",
  "stare.exclus": "exclus",
  "lant.aria": "Lanțul proiectului",
  "lant.situatie": "Situație",
  "lant.arhitectura": "Arhitectură",
  "lant.structura": "Structură",
  "lant.costuri": "Planificare",
  "lant.in_lucru": "{n} în lucru",
  "lant.asteapta": "{n} așteaptă",
  "lant.nu_trec": "{n} nu trec",
  "lant.nimic_pe": "nimic pe {solutie}",
  "lant.nimic": "—",
  "lant.alege": "Alege: {etapa}",
  "lant.faza_aria": "Faza soluției",
  "lant.dupa_detaliu": "— după calculul de detaliu",
  "nav.pe": "pe {solutie}",
  "variante.titlu": "Variante căi de evacuare",
  "variante.fara_scari": "fără scări · {locuri} locuri",
  "variante.cu_scari": "cu {n} scări · {locuri} locuri",
  "variante.preferata": "varianta preferată",
  "variante.necesar": "necesar: {necesar} locuri",
  "nav.fantoma": "{etapa} — se generează",
  "nav.eroare.necunoscuta": "Soluția din adresă nu există.",
  "nav.eroare.necunoscuta_text": "Poate a fost ștearsă, sau refăcută de la zero. Nu te ducem singuri pe alta: alege de aici.",
  "nav.eroare.alta_disciplina": "Soluția din adresă e a altei etape.",
  "nav.eroare.alta_disciplina_text": "Adresa numește un rând care nu e al paginii ăsteia.",
  "nav.eroare.corp_necunoscut": "Corpul din adresă nu e al soluției.",
  "nav.eroare.corp_necunoscut_text": "Alege un corp din meniu, sau deschide soluția fără corp.",
  "nav.eroare.implicita": "Deschide soluția implicită",
  "nav.eroare.registru": "Nu am putut citi soluțiile proiectului.",
  "nav.eroare.registru_text": "Serverul a răspuns: {motiv}. Ecranul nu știe încă ce soluții are proiectul, deci nu arată nimic în locul lor.",
  "nav.eroare.reincearca": "Încearcă din nou",
  "comutator.titlu.site_plan": "Amplasări",
  "comutator.titlu.architecture": "Arhitecturi",
  "comutator.titlu.structure": "Structuri",
  "comutator.gata": "{n} gata",
  "comutator.inchide": "Închide",
  "comutator.filtru": "Filtru",
  "comutator.pe": "Pe {solutie} ({n})",
  "comutator.toate": "Toate ({n})",
  "comutator.fir_curent": "{eticheta} · firul curent",
  "comutator.curenta": "curentă",
  "cand.generata": "generată {cand}",
  "cand.pornita": "pornită {cand}",
  "cand.azi": "azi, {ora}",
  "cand.ieri": "ieri, {ora}",
  "cand.titlu": "Generată: {la}",
  "cand.titlu_pornita": "Pornită: {la} — încă nu s-a terminat",
  "comutator.deschide": "Deschide",
  "comutator.amplasari": "Amplasări",
  "comutator.importate": "Importate",
  "comutator.fara_importate": "Nicio arhitectură importată.",
  "comutator.gol": "Nimic încă.",
  "comutator.fara_arhitectura_str": "fără arhitectură",
  "comutator.aval_arhitectura": "Arhitectură: {solutie}",
  "comutator.arhitectura_vine": "Arhitectură: se generează",
  "comutator.fara_arhitectura": "Arhitectură: nimic încă",
  "comutator.aval_structura": "Structură: {rezumat}",
  "comutator.fara_structura": "fără structură",
  "comutator.schita_in_lucru": "Schiță în lucru",
  "comutator.schita_fara_solutii": "Schiță · fără soluții",
  "comutator.schita_plus#n": "Schiță + 1 soluție|Schiță + {n} soluții|Schiță + {n} de soluții",
  "comutator.solutii#n": "1 soluție|{n} soluții|{n} de soluții",
  "comutator.nota.architecture": "Alegi altă arhitectură: Situația trece pe amplasarea ei, iar Structura pe cea mai nouă soluție gata de pe ea.",
  "comutator.nota.structure": "Alegi altă structură: Situația și Arhitectura trec pe cele de sub ea.",
  "comutator.importa": "Importă arhitectură (DWG)",
  "comutator.toate_solutiile": "Toate soluțiile →",
  "actiune.porneste_detaliat": "Pornește calculul detaliat",
  "actiune.genereaza": "Generează structura",
  "actiune.importa": "Importă structura",
  "actiune.editeaza_macro": "Editează geometria macro",
  "actiune.reia_schita": "Reia schița",
  "actiune.reruleaza": "Rerulează geometria macro",
  "actiune.opreste": "Oprește",
  "actiune.sterge_solutia": "Șterge soluția",
  "actiune.sterge_ramura": "Șterge ramura",
  "actiune.esec": "Nu am putut afla ce s-ar șterge.",
  "actiune.esec_pornire": "Nu am putut porni rularea.",
  "actiune.esec_oprire": "Nu am putut opri rularea.",
  "actiune.esec_stergere": "Nu am putut șterge soluția.",
  "actiune.esec_favorita": "Nu am putut marca soluția ca favorită.",
  "cascada.amplasari#n": "1 amplasare|{n} amplasări|{n} de amplasări",
  "cascada.arhitecturi#n": "1 arhitectură|{n} arhitecturi|{n} de arhitecturi",
  "cascada.schite#n": "1 schiță|{n} schițe|{n} de schițe",
  "cascada.solutii#n": "1 structură|{n} structuri|{n} de structuri",
  "cascada.nimic": "nimic",
  "cascada.confirma_sterge": "Ștergi {ce}? Rulările în curs ({vii}) se opresc. Nu se poate anula.",
  "cascada.confirma_schita": "Reiei schița: se șterg {ce}, cu rulările lor ({vii} în curs). Continui?",
  "cascada.confirma_reruleaza": "Rerulezi geometria macro: calculul de detaliu de acum se șterge, cu costul lui. Rulări în curs care se opresc: {vii}. Continui?",
  "cascada.confirma_detaliu": "Pornești din nou calculul detaliat: detaliul de acum se șterge, cu tot ce a calculat. Rulări în curs care se opresc: {vii}. Continui?",
  "anunt.structura_gata": "{nume} e gata pe {arh} — poți trece pe structură",
  "anunt.fatada_gata": "Fațada · {nume} gata — macheta e întreagă",
  "anunt.fatada_nu_trece": "Fațada · {nume} n-a reușit; a rămas stilul implicit",
  "anunt.editata": "{nume} creată din {din}",
  "anunt.deschide": "Deschide",
  "anunt.inchide": "Închide anunțul",
  "bloc.schimba": "Schimbă ▾",
  "bloc.corp": "Corp {cod}",
  "bloc.favorita": "favorită",
  "bloc.fa_favorita": "Fă favorită",
  "bloc.fa_favorita_titlu": "Fă-o favorită — pe ea se construiește mai departe",
  "bloc.editata_din": "editată de tine din {solutie} · {n} blocate",
  "bloc.editata_blocate": "editată · {n} blocate",
  "bloc.editata_titlu": "Geometria e desenată de om: elementele atinse sunt blocate, iar calculul de detaliu nu le mai mută.",
  "bloc.importata": "importată din planșe",
  "bloc.importata_titlu": "Geometria macro e citită din planșele arhitecturii: pozițiile și secțiunile desenate rămân pe loc, iar calculul de detaliu nu le mută. Ce nu e desenat e completat de Optimus și spus ca atare.",
  "bloc.importa_titlu": "Citește din planșe stâlpii, pereții de beton și grinzile desenate pe layerele de structură și face calculul pe ele; soluția generată rămâne alături.",
  "bloc.import_fara_structura": "Planșele arhitecturii n-au nicio piesă de structură desenată (stâlpi, pereți de beton sau grinzi pe layerele de structură) — n-are ce importa.",
  "bloc.arhitectura_editata": "editată {la}",
  "bloc.nesincronizata": "calculată pe arhitectura dinainte de editare",
  "bloc.circulatie_veche_cu_scari": "circulația e fără cele {n} scări de evacuare ale arhitecturii favorite",
  "bloc.circulatie_veche_fara_scari": "circulația are scări de evacuare pe care arhitectura favorită nu le mai are",
  "bloc.circulatie_veche_titlu": "Arhitectura favorită are alte scări de evacuare la sol decât cele după care s-a trasat circulația. «Refă planul cu agentul» o aduce la zi; nimic nu pornește singur.",
  "bloc.nesincronizata_titlu": "Arhitectura s-a editat după calculul ăsta. «Reia schița» refăce structura pe arhitectura de acum.",
  "bloc.schita_fara_detaliu": "O schiță nu are calcul detaliat: «Generează structura» sau «Importă structura» face întâi geometria macro, iar detaliul se pornește de pe ea.",
  "bloc.schita_fara_rerulare": "Schița nu are geometrie macro de rerulat; «Reia schița» o desenează din nou.",
  "bloc.schita_fara_stergere": "Schița e a arhitecturii și nu se șterge separat; se reface cu «Reia schița».",
  "bloc.editeaza_titlu": "Deschide editorul pe soluția asta; ea rămâne cum e, iar salvarea naște o soluție nouă.",
  "bloc.mai_mult": "Mai multe acțiuni",
  "bloc.incercari_parcare": "Parking Inspector",
  "bloc.incercari_parcare_titlu": "Încercările de parcare ale arhitecturii: împachetarea, rampele, locurile pierdute",
  "bloc.excavatia": "Așezarea pe module",
  "bloc.excavatia_titlu": "Așezarea corpurilor pe module de parcare și excavația hotărâtă de planul de situație: înainte, după și diferența",
  "bloc.pud": "Export PUD",
  "bloc.pud_titlu": "Planșa U3 «Reglementări urbanistice» a PUD-ului, din planul ăsta: PDF, DXF și informațiile cu sursa lor",
  "bloc.refa_excavatia": "Refă excavația",
  "bloc.excavatia_refa_titlu": "Reia planul de situație complet: soluția asta și tot ce stă pe ea se șterg, iar corpurile și excavația se așază din nou pe module de parcare.",
  "cascada.confirma_refa_excavatia": "Refaci excavația: se șterg {ce}, cu rulările lor ({vii} în curs), iar planul de situație se generează din nou, cu corpurile așezate pe module. Continui?",
  "bloc.refa_subsolul": "Regenerează arhitectura subterană",
  "bloc.subsol_titlu": "Reface subsolurile arhitecturii între stâlpii schiței ei de structură, pe același rând; etajele rămân.",
  "ansamblu.titlu": "Soluțiile proiectului",
  "ansamblu.esec": "Nu am putut încărca soluțiile.",
  "ansamblu.solutii#n": "1 soluție|{n} soluții|{n} de soluții",
  "ansamblu.interne": "Arată încercările interne",
  "ansamblu.opreste_tot": "Oprește tot",
  "ansamblu.se_sterg": "Se șterg…",
  "ansamblu.regenereaza": "Regenerează de la zero",
  "ansamblu.regenereaza_titlu": "Oprește tot ce rulează, șterge toate soluțiile și pornește din nou planul de situație, ca după configurarea proiectului; arhitectura și schițele de structură urmează singure după el",
  "ansamblu.regenereaza_titlu_structura": "Oprește tot ce rulează, șterge toate soluțiile și reia importul planșelor din dosar, ca după configurarea proiectului; structura urmează singură după el",
  "ansamblu.se_regenereaza": "Se regenerează…",
  "ansamblu.confirma_regenereaza": "Regenerezi totul de la zero? Rulările în curs se opresc și se șterg TOATE cele {n} soluții ale proiectului ({situatie} amplasări, {arhitectura} arhitecturi, {schite} schițe, {solutii} soluții de structură), apoi generarea pornește din nou, ca după configurarea proiectului. Nu se poate anula.",
  "ansamblu.esec_regenereaza": "Nu am putut regenera soluțiile.",
  "ansamblu.amplasari#n": "1 amplasare|{n} amplasări|{n} de amplasări",
  "ansamblu.arhitecturi#n": "1 arhitectură|{n} arhitecturi|{n} de arhitecturi",
  "ansamblu.schite#n": "1 schiță|{n} schițe|{n} de schițe",
  "ansamblu.solutii_str#n": "1 soluție|{n} soluții|{n} de soluții",
  "ansamblu.nimic_inca": "nimic încă",
  "ansamblu.costuri_gata": "devize pe calculul de detaliu",
  "ansamblu.costuri_dupa": "apar după calculul de detaliu",
  "ansamblu.in_lucru_acum": "în lucru acum",
  "ansamblu.terminate_recent": "terminate recent",
  "ansamblu.col_solutie": "Soluție",
  "ansamblu.col_faze": "Faze",
  "ansamblu.col_cifra": "Cifra-cheie",
  "ansamblu.col_cost": "Cost",
  "ansamblu.col_actiuni": "Acțiuni",
  "ansamblu.gol": "Nicio soluție încă. Pornește din dosar sau din tema proiectului.",
  "ansamblu.parcare": "parcare {livrat}/{necesar}",
  "ansamblu.parcare_necesar": "necesar {necesar} locuri",
  "ansamblu.apartamente#n": "1 apartament|{n} apartamente|{n} de apartamente",
  "ansamblu.corp_sarit": "{cod} sărit",
  "ansamblu.lucrare_vie": "în lucru: {lucrare}",
  "ansamblu.lucrare_picata": "a picat: {lucrare}",
  "ansamblu.lucrari_titlu": "Lucrări pe această arhitectură",
  "ansamblu.incercari_picate#n": "1 încercare picată înainte|{n} încercări picate înainte|{n} de încercări picate înainte",
  "ansamblu.opreste_lucrarea": "Oprește: {lucrare}",
  "ansamblu.lucrare_nota": "Arhitectura se deschide pe ce are acum; lucrarea o rescrie când se termină.",
  "ansamblu.actiuni_pentru": "Acțiuni pentru {nume}",
  "ansamblu.varianta_arhitectura": "+ arhitectură pe ea",
  "ansamblu.alege_rand": "Clic pe un rând îl previzualizează aici; dublu clic deschide soluția.",
  "ansamblu.inchide_previzualizarea": "Închide previzualizarea și arată evenimentele (Esc)",
  "evenimente.titlu": "Evenimente",
  "evenimente.viu": "în direct",
  "evenimente.repaus": "la 30 s",
  "evenimente.gol": "Nu s-a întâmplat încă nimic în proiect.",
  "evenimente.esec": "Nu am putut citi evenimentele.",
  "ansamblu.previzualizare": "previzualizare · {etapa} {pe}",
  "ansamblu.previzualizare_aria": "Previzualizare: {nume}",
  "ansamblu.deschide": "Deschide soluția",
  "ansamblu.apartamente": "Apartamente",
  "ansamblu.niveluri": "Niveluri",
  "ansamblu.pleaca_din": "pleacă din",
  "ansamblu.parcare_eticheta": "Parcare",
  "ansamblu.parcare_titlu": "Locuri de parcare față de necesar: {subsol} în subsol, {sol} la sol. Necesarul: {necesar}, {regula}.",
  "ansamblu.parcare_necesar_titlu": "Câte locuri de parcare cere tema: {necesar}, {regula}. Câte ies se află după arhitectură, când subsolul e desenat.",
  "ansamblu.parcare_regula_architecture": "apartamente × locuri pe apartament — ținta subsolului; locurile de la sol sunt ale planului de situație",
  "ansamblu.parcare_regula_site_plan": "apartamente × locuri pe apartament, plus cota vizitatorilor, care rămân la sol",
  "ansamblu.parcare_subsol": "În subsol",
  "ansamblu.parcare_sol": "La sol",
  "ansamblu.verde_total": "Spațiu verde",
  "ansamblu.verde_pe_sol": "Verde pe sol",
  "ansamblu.rampe_legate": "Rampe legate",
  "ansamblu.in_lucru_nota": "Soluția e în lucru: se deschide pe ce are deja gata.",
  "act.dosar": "Dosar",
  "act.fel.extraction": "Citirea actelor",
  "act.fel.external_architecture": "Importul planșelor de arhitectură",
  "act.fel.basement_architecture": "Refacerea subsolului",
  "act.fel.facade": "Fațada (agentul)",
  "act.fel.recomp": "Recompartimentarea apartamentelor atinse",
  "act.fel.geotech": "Studiul geotehnic",
  "costuri.dupa_detaliu": "Devizul apare după calculul de detaliu; rețetele și tarifele de mai jos sunt ale proiectului.",
  "costuri.fatada_inainte_de_structura": "Anvelopa e pe devizul fațadei; structura apare după calculul de detaliu, până atunci pe reper.",
  "costuri.fatada_structura_in_lucru": "Anvelopa e pe devizul fațadei; structura e în curs de procesare și rămâne pe reper până e gata.",
  "costuri.vezi_solutia": "← la soluție",
  // --- COSTURI · ipotezele, scenariile și asistentul (`viewer/cost/`) -------
  "costuri.tab.ipoteze": "Ipoteze",
  "costuri.tab.rezultate": "Rezultate",
  "costuri.tab.scenarii": "Scenarii",
  "costuri.tab.oferte": "Oferte",
  // ofertele furnizorilor și rețetele/prețurile pe scenariu (`viewer/cost/PanouOferte.tsx`, `CatalogBoq.tsx`)
  "sc.autor.oferta": "ofertă",
  "sc.preturi_proprii": "{n} prețuri și rețete proprii",
  "lc.sc.in_scenariu": "în scenariu",
  "lc.sc.editezi": "Ce editezi",
  "lc.sc.proiectul": "Proiectul",
  "lc.sc.scenariul": "Scenariul «{nume}»",
  "lc.sc.explicatie": "Editezi rețetele și prețurile scenariului «{nume}»: ce schimbi aici rămâne numai pe el, restul urmează proiectul.",
  "lc.sc.pret_impus": "preț din ofertă",
  "lc.sc.pret_impus_d": "lucrarea are prețul de-a gata, {p}; consumurile de mai sus dau numai desfacerea pe material și manoperă",
  "lc.sc.scoate_pret_impus": "Scoate prețul din ofertă",
  "lc.sc.din_oferta": "ofertă",
  "lc.sc.pret_inainte": "înainte de ofertă: {p}",
  "lc.sc.lista_scenariului": "scenariul «{nume}»",
  "of.intro": "Trage aici oferta unui furnizor — o listă de prețuri sau o ofertă de lucrare. O citesc, pun prețurile ei pe rețetele, articolele și resursele proiectului și fac din scenariul curent unul nou, cu ele, ca să vezi ce schimbă. Scenariul de acum rămâne cum e. Oferta intră și în documentele proiectului, la «Rețete & prețuri»; un document urcat acolo se citește la fel, singur, și apare aici.",
  "of.zona_titlu": "Trage oferta aici sau alege fișierul",
  "of.zona_d": "PDF (și scanat), Excel, Word, imagine sau CSV · cel mult 20 MB",
  "of.se_urca": "Se urcă: {n}",
  "of.fara_lista": "Prețurile unei oferte se pun pe lista de cantități, iar proiectul n-are încă una (nici arhitectură, nici structură).",
  "of.niciuna": "Nicio ofertă încă.",
  "of.format": "«{nume}» nu se poate citi: trimite un PDF, Excel, Word, imagine sau CSV.",
  "of.nu_s_a_urcat": "«{nume}» nu s-a urcat: {e}",
  "of.stare.se_citeste": "se citește",
  "of.stare.aplicata": "aplicată",
  "of.stare.eroare": "eroare",
  "of.se_citeste_d": "Se citește oferta și se caută prețul fiecărui lucru din proiect — un minut sau două; o listă de prețuri mare, câteva.",
  "of.scenariu_curent": "scenariul curent: «{nume}»",
  "of.deschide_scenariul": "Deschide scenariul «{nume}»",
  "of.aplica_iar": "Aplică din nou",
  "of.aplica_iar_t": "Încă un scenariu din oferta asta, făcut din scenariul curent",
  "of.sterge": "Șterge",
  "of.sterge_confirma": "Ștergi oferta «{nume}»? Documentul pleacă și din documentele proiectului; scenariul făcut din ea rămâne.",
  "of.preturi_puse": "{n} prețuri puse",
  "of.respinse": "{n} lăsate deoparte",
  "of.respinse_titlu": "Lăsate deoparte",
  "of.impact": "{v} pe costul direct",
  "of.th.tinta": "În proiect",
  "of.th.linie": "Linia din ofertă",
  "of.th.oferta": "Preț ofertă, fără TVA",
  "of.th.acum": "Acum",
  "of.th.nou": "Din ofertă",
  "of.fel_tinta.reteta": "rețetă",
  "of.fel_tinta.articol": "articol",
  "of.fel_tinta.resursa": "resursă",
  "of.fel.lucrare": "cu montaj",
  "of.curs": "curs {c} {m}/€",
  "of.curs_estimat": "curs estimat {c} {m}/€",
  "of.curs_estimat_t": "Moneda ofertei nu are cursul proiectului; cursul e cel estimat la citire, la data ofertei.",
  // --- PIAȚA RESURSELOR (`viewer/cost/ExploreazaPiata.tsx`, `ImportPiata.tsx`) ---
  "piata_res.buton": "Piața",
  "piata_res.buton_t": "Explorează piața: prețurile văzute pentru resursa asta, din mai multe surse",
  "piata_res.chip": "piață",
  "piata_res.titlu": "Explorează piața — {nume} ({um})",
  "piata_res.inchide": "Închide",
  "piata_res.in_proiect": "În proiect",
  "piata_res.fara_tinte": "Lista de cantități a proiectului nu folosește resursa asta: prețul ei nu schimbă nimic.",
  "piata_res.din_piata": "din piață",
  "piata_res.pus_de_om": "pus de om",
  "piata_res.rezumat": "Piața, pe baza catalogului (franco șantier, fără pompă, fără TVA): cel mai mic {min} · median {med} · cel mai mare {max} — {preturi} din {surse}",
  "piata_res.preturi#n": "un preț|{n} prețuri|{n} de prețuri",
  "piata_res.surse#n": "o sursă|{n} surse|{n} de surse",
  "piata_res.colectat": "colectat pe {la}",
  "piata_res.fara_preturi": "Fără prețuri încă — colectarea n-a găsit nimic pentru resursa asta.",
  "piata_res.foloseste_minim": "Folosește cel mai mic: {p}",
  "piata_res.foloseste": "Folosește",
  "piata_res.foloseste_t": "Pune prețul ăsta pe resursele proiectului de mai sus",
  "piata_res.scoate": "Scoate prețul pieței",
  "piata_res.scoate_t": "Ținta revine la prețul de dinaintea importului (cel global)",
  "piata_res.doar_exacte": "numai potrivite exact",
  "piata_res.doar_exacte_t": "Un echivalent (altă clasă de expunere, o marcă veche de oțel) se arată, dar nu se folosește: un preț mic pentru alt produs ar strica tăcut costul.",
  "piata_res.th.sursa": "Sursa",
  "piata_res.th.produs": "Produsul · baza",
  "piata_res.th.vazut": "Văzut",
  "piata_res.th.pe_baza": "{m}/{um} pe bază",
  "piata_res.th.stare": "Stare",
  "piata_res.nivel.1": "Nivelul 1: aproape de tranzacție sau oficial",
  "piata_res.nivel.2": "Nivelul 2: indicativ bun",
  "piata_res.nivel.3": "Nivelul 3: slab",
  "piata_res.livrare.franco": "franco șantier",
  "piata_res.livrare.din_statie": "din stație",
  "piata_res.livrare.franco_cu_pompa": "livrat, cu pompă",
  "piata_res.livrare.din_magazin": "din magazin",
  "piata_res.ajustare.transport": "+transport {v} lei/{um}",
  "piata_res.ajustare.pompa": "−pompa {v} lei/{um}",
  "piata_res.ajustare_t": "Adus pe baza catalogului (franco șantier, fără pompă) cu o ipoteză a colectorului, scrisă aici ca să poată fi judecată.",
  "piata_res.echivalent": "echivalent",
  "piata_res.fara_baza": "nu se poate aduce pe bază",
  "piata_res.cel_mai_mic": "cel mai mic",
  "piata_res.stare.ok": "bun",
  "piata_res.stare.suspect": "suspect",
  "piata_res.stare.respins": "respins",
  "piata_res.cu_tva": "cu TVA",
  "piata_res.fara_tva": "+TVA",
  "piata_res.furnizor": "furnizor: {f}",
  "piata_res.autoritate": "cumpărător: {a}",
  "piata_res.vazut_la": "văzut pe {la}",
  "piata_res.doc.fisa_tehnica": "fișa tehnică",
  "piata_res.doc.dop": "declarația de performanță",
  "piata_res.doc.agrement": "agrementul tehnic",
  "piata_res.doc.alt": "documentul",
  "piata_res.lucrez": "Se pune…",
  "piata_res.pus#n": "Prețul pieței e pus pe o țintă.|Prețul pieței e pus pe {n} ținte.|Prețul pieței e pus pe {n} de ținte.",
  "piata_res.scos#n": "Prețul pieței e scos de pe o țintă.|Prețul pieței e scos de pe {n} ținte.|Prețul pieței e scos de pe {n} de ținte.",
  "piata_res.respinse": "Nu s-a pus pe: {l}",
  "piata_res.fara_curs": "Proiectul n-are cursul leu/euro, deci prețurile pieței nu se pot pune.",
  "piata_res.nu_s_a_citit": "Prețurile pieței nu s-au putut citi: {e}",
  "piata_res.salveaza_intai": "Salvează sau renunță la schimbări înainte de a lua prețuri din piață.",
  "piata_res.pe_proiect": "Prețurile se pun pe proiect: toate scenariile le moștenesc, în afară de ce schimbă fiecare.",
  "piata_res.import.buton": "Importă prețurile pieței",
  "piata_res.import.titlu": "Importă prețurile pieței în proiect",
  "piata_res.import.au_pret#n": "o resursă are preț de piață|{n} resurse au preț de piață|{n} de resurse au preț de piață",
  "piata_res.import.th.resursa": "Resursa",
  "piata_res.import.th.acum": "Acum",
  "piata_res.import.th.piata": "Piața",
  "piata_res.import.th.dif": "Diferența",
  "piata_res.import.importa#n": "Importă una|Importă {n}|Importă {n}",
  "piata_res.import.gol": "Nicio resursă a proiectului n-are încă preț de piață: colectarea n-a găsit nimic pentru ele, sau lista de cantități nu le folosește.",
  "piata_res.motiv.pus_de_om": "pus de om — nu se rescrie fără bifă",
  "piata_res.motiv.fara_curs": "fără cursul proiectului",
  "costuri.tab.boq": "Lista de cantități",
  // --- LISTA DE CANTITĂȚI (`viewer/cost/ListaCantitati.tsx`, `CatalogBoq.tsx`) ---
  "lc.titlu": "Lista de cantități",
  "lc.generata": "generată {la} · catalog {cat} · EUR fără TVA",
  "lc.recalculeaza": "Recalculează",
  "lc.export_tot": "Exportă tot (Excel)",
  "lc.export_subiecte": "Exportă {n} subiecte (Excel)",
  "lc.fara_detaliu": "Lista de cantități se face pe arhitectura din fir; până la calculul de detaliu, cantitățile structurii se estimează pe m² construit.",
  "lc.eroare": "Lista nu s-a putut calcula: {e}",
  "lc.reincearca": "Încearcă din nou",
  "lc.subiecte": "Subiecte",
  "lc.toate": "toate subiectele",
  "lc.cauta": "Caută un articol…",
  "lc.vazut": "{n} articole arătate · {v}",
  "lc.th_pu_total": "P.U. total",
  "lc.th_total": "Total",
  "lc.total_subiect": "TOTAL {s}",
  "lc.subiect.rezumat": "{n} articole, {est} cu cantitate estimată",
  "lc.fara_pret": "resursă fără preț",
  "lc.neaplicate": "{n} articole din catalog n-au cantitate pe acest proiect",
  "lc.plc.direct": "Cost direct",
  "lc.plc.direct_d": "material + servicii {m} · manoperă {l}",
  "lc.plc.general": "Total general (fără TVA)",
  "lc.plc.general_d": "prețul antreprenorului, cu {p}; neprevăzutele stau în rezerva din Rezultate",
  "lc.plc.pe_m2": "Pe m² desfășurat",
  "lc.plc.pe_m2_d": "{a} m² cu tot cu subsol",
  "lc.plc.articole": "Articole",
  "lc.plc.articole_d": "{est} cu cantitate estimată · {dev} din devize · {om} puse de om",
  "lc.plc.proiect": "Apartamente",
  "lc.plc.proiect_d": "{c} corpuri · {s} niveluri de subsol · {p} m² parcaj",
  "lc.rec.direct": "Total cost direct",
  "lc.rec.general": "TOTAL GENERAL (fără TVA)",
  "lc.fel.calculat": "măsurat",
  "lc.fel.estimat": "cantitate estimată",
  "lc.fel.solutie": "din deviz",
  "lc.fel.om": "pus de om",
  "lc.tip.material": "material",
  "lc.tip.manopera": "manoperă",
  "lc.tip.utilaj": "utilaj",
  "lc.tip.transport": "transport",
  "lc.um.ora": "oră",
  "lc.det.cantitatea": "Cantitatea",
  "lc.det.calculata": "măsurat: {v}",
  "lc.det.pe_corpuri": "Pe corpuri",
  "lc.det.specificatii": "Specificații",
  "lc.det.observatii": "Observații",
  "lc.det.pret": "Prețul",
  "lc.det.reteta": "rețeta {cod}",
  "lc.din_deviz.structura": "Articol preluat din devizul structurii: cantitățile vin din calculul de detaliu, prețurile din tarifele proiectului (fila «Prețuri, zonă & norme»).",
  "lc.din_deviz.fatada": "Articol preluat din devizul fațadei: cantitatea din metrajul fețelor, prețul din catalogul fațadei (se corectează din rândul «Anvelopă» al rezultatelor).",
  "lc.res.tip": "Tip",
  "lc.res.resursa": "Resursa",
  "lc.res.consum": "Consum",
  "lc.res.cantitate": "Cantitate",
  "lc.res.pret": "Preț unitar",
  "lc.res.pret_ora": "Preț / oră",
  "lc.res.total": "Total",
  "lc.res.cod": "Cod",
  "lc.res.sursa": "Sursa prețului",
  "lc.res.fara_faza": "Fără fază — macaralele și resursele nefolosite în listă",
  "lc.res.si_la": "și la: {faze}",
  "lc.lista.materiale": "Materiale",
  "lc.lista.manopera": "Manoperă",
  "lc.lista.utilaje": "Utilaje",
  "lc.lista.transport": "Transport",
  "lc.catalog.gasite": "{n} rețete",
  "lc.catalog.nimic": "Nicio rețetă nu trece de filtre.",
  "lc.catalog.din_calcul": "din calculul structurii",
  "lc.catalog.structura_nota": "pe ele stă devizul structurii; tarifele lor sunt în «Prețuri, zonă & norme»",
  "lc.catalog.activitati": "activități",
  "lc.catalog.modificata": "modificată",
  "lc.catalog.ca_global": "ca în catalogul global",
  "lc.catalog.adauga_din_global": "Adaugă din catalogul global ({n})…",
  "lc.catalog.goala": "Rețetele folosite de listă se clonează pe proiect la prima ei calculare; până atunci, adaugă din catalogul global.",
  "lc.catalog.resurse_goale": "Nicio resursă pe proiect încă: se clonează odată cu rețetele folosite, sau se adaugă din catalogul global.",
  "lc.catalog.deschide": "Rețete și resurse",
  "lc.catalog.la_lista": "← Lista",
  "lc.catalog.titlu": "Catalogul listei de cantități",
  "lc.catalog.versiune": "catalog global {v} · {n} schimbări față de el",
  "lc.catalog.retete": "Rețete",
  "lc.catalog.resurse": "Resurse",
  "lc.catalog.explicatie": "Rețetele și resursele folosite de listă sunt clonate pe proiect: ce vezi aici e al proiectului și se editează aici — un consum, un preț, o cantitate pusă de mână, o rețetă ascunsă sau una nouă. Catalogul global rămâne în platformă; din el se mai pot adăuga rețete, iar «Revino la global» aduce înapoi valorile lui.",
  "lc.catalog.din_proiect": "pe proiect",
  "lc.catalog.ascunsa": "ascunsă",
  "lc.catalog.rezerva": "rezervă",
  "lc.catalog.rezerva_t": "Rețetă de rezervă: intră în listă numai cât lipsește {sursa}. Rețeta e fixă, ca oricare alta; estimată e cantitatea ei.",
  "lc.catalog.revino": "Revino la valorile globale",
  "lc.catalog.sterge": "Șterge rețeta",
  "lc.catalog.nume": "Denumirea articolului",
  "lc.catalog.specificatii": "Specificații tehnice",
  "lc.catalog.observatii": "Observații",
  "lc.catalog.cheie": "Cantitatea din antemăsurătoare",
  "lc.catalog.cheie_t": "cheia după care motorul ia cantitatea din soluții; o rețetă fără cheie primește cantitatea de mână",
  "lc.catalog.cantitate_om": "Cantitate pusă pe proiect",
  "lc.catalog.masurat": "măsurat {v}",
  "lc.catalog.platit_in": "plătită în {cod}, macarale × luni",
  "lc.factor.macarale_buc": "Macarale",
  "lc.factor.macara_luni": "Luni pe macara",
  "lc.catalog.ascunde": "nu intră în lista acestui proiect",
  "lc.catalog.scoate": "scoate consumul",
  "lc.catalog.pu": "Preț unitar",
  "lc.catalog.pu_d": "material {m} · manoperă {l} · utilaj {u} · transport {tr}",
  "lc.catalog.alege_resursa": "alege resursa…",
  "lc.catalog.adauga_consum": "Adaugă consum",
  "lc.catalog.sursa": "Sursa prețului: {s}",
  "lc.catalog.alege": "Alege o rețetă din listă ca s-o vezi și s-o schimbi pe proiect.",
  "lc.catalog.adauga_reteta": "+ Rețetă nouă pe proiect",
  "lc.catalog.reteta_noua": "Articol nou",
  "lc.catalog.global_era": "global: {v}",
  "lc.catalog.calcat": "Altcineva a schimbat catalogul între timp; vezi acum versiunea lui. Refă schimbarea, dacă mai e nevoie.",
  "lc.subiect.terasamente": "Terasamente și sprijiniri",
  "lc.subiect.structura": "Structura de rezistență",
  "lc.subiect.arhitectura": "Arhitectură — zidării, finisaje, tâmplărie interioară",
  "lc.subiect.fatada": "Anvelopa — fațadă, tâmplărie exterioară, terase",
  "lc.subiect.electrice": "Instalații electrice și curenți slabi",
  "lc.subiect.sanitare": "Instalații sanitare și stingere incendiu",
  "lc.subiect.termice": "Instalații termice, ventilare și climatizare",
  "lc.subiect.lifturi": "Ascensoare și platforme",
  "lc.subiect.exterioare": "Amenajări exterioare și racorduri",
  "costuri.tab.verificate": "verificate",
  "costuri.tab.de_verificat": "de verificat",
  "costuri.asistent": "Asistentul devizului",
  "costuri.pas.scenarii": "Citesc scenariile proiectului…",
  "costuri.pas.scenarii_gata": "Am citit scenariile.",
  "costuri.pas.deviz": "Citesc devizul…",
  "costuri.pas.deviz_gata": "Am citit devizul.",
  "costuri.pas.articole": "Citesc articolele devizului de execuție…",
  "costuri.pas.articole_gata": "Am citit articolele.",
  "costuri.pas.simuleaza": "Calculez varianta…",
  "costuri.pas.simuleaza_gata": "Am calculat varianta, fără să salvez nimic.",
  "costuri.pas.creeaza": "Fac scenariul nou…",
  "costuri.pas.creeaza_gata": "Am făcut un scenariu nou; cel vechi e tot în «Scenarii».",
  "costuri.pas.alege": "Trec pe scenariul ales…",
  "costuri.pas.alege_gata": "Am trecut pe scenariul ales.",
  "bc.cum.ajustat": "{cum} · × {f} în scenariu = {total}",
  "bc.r.cTerenBani.element": "Teren — partea plătită în bani",
  "bc.r.cTerenBani.obs": "peste cei {p} % din SCD cedați în apartamente",
  "bc.r.cTerenBani.de_unde": "Prețul terenului plătit în bani, scris în ipoteze.",
  "bc.ui.ajustat": "× {f} scenariu",
  "bc.ui.banda": "Profitul net după prețul apartamentelor",
  "bc.ui.fara_solutie": "Rezumatul se face pe o soluție de arhitectură a firului; proiectul n-are încă una.",
  "bc.ui.banda_sub": "restul ipotezelor ca acum",
  "bc.ui.ce_construim": "Ce construim · cantitățile din care iese socoteala",
  "ip.pret_teren_bani": "Prețul terenului plătit în bani",
  "ip.ajutor.cedat": "Vânzătorul primește apartamente la cheie din SCD, în loc de bani.",
  "ip.ajutor.teren_bani": "Zero când terenul se plătește numai în apartamente.",
  "ip.ajutor.pret_ap": "Prețul net pe m² util. Rezultatele arată și cum se mișcă profitul la ±20 %.",
  "ip.piata": "Piața din zonă: {pret}/m² net",
  "ip.piata_pe_finisaj": "{oferte} cu finisaje {clasa} din «Vânzări în zonă», {cerut}/m² cerut, fără TVA",
  "ip.piata_pe_toate": "{oferte} din «Vânzări în zonă», {cerut}/m² cerut, fără TVA",
  "ip.piata_foloseste": "Folosește",
  "ip.piata_folosit": "folosit",
  "ip.piata_t": "Prețul recomandat de profilul zonei. Se aplică numai cu «Folosește»; până atunci rămâne valoarea de acum.",
  "ip.implicit": "implicit",
  "ip.modificat": "modificat",
  "ip.valideaza": "Validează",
  "ip.validata": "validată",
  "ip.validata_de": "Validată de {de} · {la}",
  "ip.scenariul": "Scenariul",
  "ip.alt_scenariu": "Alt scenariu →",
  "ip.ce_decizi": "Ce decizi tu",
  "ip.ce_decizi_sub": "ipotezele dezvoltatorului · EUR, fără TVA",
  "ip.grup.teren": "Terenul",
  "ip.grup.vanzari": "Vânzările",
  "ip.grup.calendar": "Calendarul",
  "ip.din_proiect": "Din proiect",
  "ip.din_proiect_sub": "măsurat sau calculat · se schimbă la sursă",
  "ip.din_program": "din program",
  "ip.ajutor.durata_program": "Durata e a programului de execuție, în luni; se schimbă din fila «Program» — macarale pe perioade, efective, lag-uri —, nu de aici.",
  "ip.repere": "Repere de piață",
  "ip.repere_sub": "rapoarte și prețuri pe m² din proiecte comparabile, până când proiectul are cifra lui",
  "ip.verificate_de": "Ipoteze confirmate de {de} · {la}",
  "ip.raman_implicite": "{n} din {tot} ipoteze au încă valoarea implicită, nevalidată.",
  "ip.retrage": "Retrage confirmarea",
  "ip.la_rezultate": "Rezultate →",
  "ip.sari": "Sari la rezultate",
  "ip.am_verificat": "Am verificat ipotezele → Rezultate",
  "sc.baza": "Bază",
  "sc.calcat": "Altcineva a schimbat scenariile între timp; le vezi acum pe ale lui. Refă schimbarea, dacă mai e nevoie.",
  "sc.fara_abateri": "ipotezele implicite",
  "sc.grafic": "Cost contra randament",
  "sc.grafic_sub": "fiecare punct e un scenariu; clic pe el îl pune în comparație",
  "sc.grafic_aria": "Scenariile, după costul total al investiției și ROI-ul pe an",
  "sc.ax_cost": "Cost total investiție",
  "sc.ax_roi": "ROI pe an",
  "sc.roi": "ROI total",
  "sc.roi_an": "ROI pe an",
  "sc.nume_nou": "Scenariul {n}",
  "sc.intro": "Aceleași măsurători ale proiectului, alte ipoteze. Asistentul face un scenariu nou la fiecare variantă cerută; «Folosește» te întoarce la oricare.",
  "sc.nou": "+ Scenariu nou",
  "sc.lista": "Toate scenariile",
  "sc.lista_sub": "bifează ca să compari cu cel curent",
  "sc.compara": "Compară",
  "sc.compara_cu": "Compară «{nume}» cu scenariul curent",
  "sc.th.scenariu": "Scenariu",
  "sc.th.ce_e_altfel": "Ce e altfel",
  "sc.redenumeste": "Redenumește",
  "sc.curent": "curent",
  "sc.autor.asistent": "asistent",
  "sc.autor.om": "om",
  "sc.foloseste": "Folosește",
  "sc.sterge": "Șterge",
  "sc.comparatie": "Comparația",

  // --- COSTURI · rezumatul de business case (`viewer/cost/`) --------------
  // Rezumatul investiției pe tabul «Devizul»: ipoteze, cantități, costuri pe
  // specialități, vânzări, rezultate. Fiecare rând își spune sursa în panoul
  // care se desface; săpătura și structura au sub ele devizul pe articole.
  "bc.sursa.acte": "acte",
  "bc.sursa.puz": "puz",
  "bc.sursa.proiect": "proiect",
  "bc.sursa.tema": "temă",
  "bc.sursa.referinta": "referință",
  "bc.sursa.formula": "formulă",
  "bc.sursa.ipoteza": "ipoteză",
  "bc.sursa.lege": "lege",
  "bc.obs.masurat_arhitectura": "măsurat pe arhitectură",
  "bc.r.teren.obs_plan": "terenul planului de situație",
  "bc.r.teren.de_unde_plan": "Terenul pe care e desenat planul de situație al firului — același pe care arhitectura își socotește CUT-ul și POT-ul.",
  "bc.r.teren.semnal_acte": "Actele terenului spun {acte} m²; planul de situație e desenat pe {plan} m². Rezumatul merge pe plan.",
  "bc.r.scd.de_unde_masurat": "Suprafața construită desfășurată deasupra cotei zero, măsurată pe arhitectura din fir (registrul cifrelor: placa fiecărui etaj la fața finită a fațadei).",
  "bc.r.suPeGba.de_unde_masurat": "Aria utilă a locuințelor (camere, bucătărie, baie, hol — fără balcoane), măsurată pe arhitectură, împărțită la SCD.",
  "bc.r.terasePeGba.de_unde_masurat": "Balcoanele, loggiile și terasele locuințelor, măsurate pe arhitectură, împărțite la SCD.",
  "bc.r.comPeGba.de_unde_masurat": "Arhitectura măsurată nu are spații comerciale.",
  "bc.r.mpLoc.de_unde_masurat": "ADC-ul subsolului măsurat pe arhitectură, împărțit la locurile numărate în el.",
  "bc.r.apMediu.de_unde_masurat": "Aria utilă măsurată pe arhitectură, împărțită la apartamentele ei.",
  "bc.r.subsol.de_unde_masurat": "ADC-ul subsolului, măsurat pe arhitectură (suma plăcilor de sub cota zero).",
  "bc.r.circ.cum_plan": "{tot} m², din care {trotuare} m² trotuare",
  "bc.taxa.autorizatie": "autorizație",
  "bc.taxa.isc_calitate": "ISC calitate",
  "bc.taxa.isc_control": "ISC control al statului",
  "bc.taxa.csc": "Casa Socială a Constructorilor",
  "bc.taxa.timbru_arhitectura": "timbrul arhitecturii",
  "bc.ui.pret_apartamente": "Preț apartamente",
  "bc.ui.socoteala": "{ale} din {tot} de cifre vin din proiect; restul de {imprumutate} sunt ipoteze sau referințe — scrie pe fiecare rând de unde.",
  "bc.ui.tic": "Cost total investiție",
  "bc.ui.pe_m2_construit": "{v} construit",
  "bc.ui.constructii": "Construcții",
  "bc.ui.din_tic": "{p} din costul total",
  "bc.ui.venituri": "Venituri dezvoltator",
  "bc.ui.din_proiect": "{p} din proiect",
  "bc.ui.profit_net": "Profit net",
  "bc.ui.dupa_impozit": "după impozit {p}",
  "bc.ui.roi_pe_an": "{p} pe an · {n} ani",
  "bc.ui.roi_pe_an_flux": "{p} pe an · banii stau în medie {m} din {n} ani",
  "bc.ui.echilibru": "Preț de echilibru",
  "bc.ui.indiciu": "Apasă pe un rând ca să vezi de unde vine cifra și cum iese; la săpătură și la structură, dedesubt stă și devizul de execuție pe articole.",
  "bc.th.element": "Element",
  "bc.th.cantitate": "Cantitate",
  "bc.th.um": "U.M.",
  "bc.th.parametru": "Preț / parametru",
  "bc.th.valoare": "Valoare ({moneda})",
  "bc.th.din_tic": "% TIC",
  "bc.th.observatii": "Observații",
  // --- glosarul termenilor cu explicație la hover (`viewer/cost/Termeni.tsx`) --
  "termen.explicatie": "Ce înseamnă {ce}",
  "termen.tic.nume": "TIC — costul total al investiției (Total Investment Cost)",
  "termen.tic.ce": "Tot ce plătește investitorul până la vânzare: terenul (în bani și în natură), construcțiile cu taxele și cotele legale, finanțarea, cadastrul, managementul, comisionul de vânzări și rezerva. Pe el se raportează fiecare rând («% TIC») și randamentul: ROI = profit net / TIC.",
  "termen.roi.nume": "ROI — randamentul investiției (Return on Investment)",
  "termen.roi.ce": "Profitul net împărțit la costul total al investiției (TIC). «ROI pe an» împarte cifra la anii cât stau banii imobilizați, în medie: cu programul de execuție cheltuielile ies lună de lună și un euro nu stă toată durata, deci ROI-ul pe an poate ieși mai mare decât cel total; fără program, toți banii stau toată durata proiectului.",
  "termen.gba.nume": "GBA — aria construită brută (Gross Building Area)",
  "termen.gba.ce": "Suma ariilor tuturor nivelurilor, măsurate la fața exterioară a pereților — ce se cheamă în română SCD, suprafața construită desfășurată. Fără altă precizare e cea supraterană; subsolul se spune separat.",
  "termen.scd.nume": "SCD — suprafața construită desfășurată",
  "termen.scd.ce": "Suma ariilor construite ale nivelurilor supraterane, la fața exterioară a pereților: terenul × CUT. Același lucru cu GBA.",
  "termen.adc.nume": "ADC — aria desfășurată construită",
  "termen.adc.ce": "Suma ariilor construite ale nivelurilor; la subsol, suma plăcilor de sub cota zero, cum o măsoară arhitectura.",
  "termen.su.nume": "Su — suprafața utilă",
  "termen.su.ce": "Aria interioară a apartamentului, între fețele pereților, fără balcoane, terase și părți comune. Pe ea se vinde și pe ea e prețul pe m².",
  "termen.cut.nume": "CUT — coeficientul de utilizare a terenului",
  "termen.cut.ce": "Suprafața construită desfășurată împărțită la suprafața terenului. Maximul îl dă PUZ-ul sau regulamentul local; rezumatul folosește CUT-ul soluției desenate.",
  "termen.pot.nume": "POT — procentul de ocupare a terenului",
  "termen.pot.ce": "Amprenta la sol a clădirii împărțită la suprafața terenului, în procente.",
  "termen.puz.nume": "PUZ — Planul Urbanistic Zonal",
  "termen.puz.ce": "Documentația de urbanism care spune ce se poate construi pe teren: CUT, POT, regimul de înălțime, retragerile, funcțiunile.",
  "termen.rlu.nume": "RLU — Regulamentul Local de Urbanism",
  "termen.rlu.ce": "Regulile de construire ale localității, care însoțesc planul urbanistic: retrageri, racorduri la rețele, condiții de autorizare.",
  "termen.cc.nume": "CC — costul construcțiilor",
  "termen.cc.ce": "Totalul lucrărilor de construcție: săpătura, structura, arhitectura, anvelopa, instalațiile, subsolul, spațiile verzi, infrastructura și costurile conexe — fără teren, taxe, finanțare, management și comision. Cotele procentuale (taxe, management, comision, rezervă) se aplică pe el.",
  "termen.isc.nume": "ISC — Inspectoratul de Stat în Construcții",
  "termen.isc.ce": "Autoritatea care controlează calitatea în construcții. Investitorul îi plătește două cote pe valoarea lucrărilor: de calitate (Legea 10/1995) și de control al statului (Legea 50/1991).",
  "termen.tva.nume": "TVA — taxa pe valoarea adăugată",
  "termen.tva.ce": "Toate sumele de aici sunt fără TVA, cum se compară devizele de antreprenor.",
  "termen.xps.nume": "XPS — polistiren extrudat",
  "termen.xps.ce": "Termoizolație rigidă, cu absorbție mică de apă: la soclu, sub cota terenului și pe terase, unde polistirenul obișnuit (EPS) nu rezistă.",
  "termen.psi.nume": "PSI — prevenirea și stingerea incendiilor",
  "termen.psi.ce": "Instalațiile de securitate la incendiu: detecție și alarmare, hidranți, sprinklere, desfumare.",
  "termen.rf.nume": "RF — rezistent la foc",
  "termen.rf.ce": "O ușă sau un perete cu rezistență la foc certificată (de exemplu EI 60), cerut la compartimentarea de incendiu; «fără RF» e ușa obișnuită.",
  "termen.pu.nume": "P.U. — prețul unitar",
  "termen.pu.ce": "Prețul unei unități de măsură a articolului (un m³, un m², un kg, o bucată), separat pe material și pe manoperă.",
  "termen.um.nume": "U.M. — unitatea de măsură",
  "termen.um.ce": "În ce se numără articolul: m³, m², ml, kg, bucăți, ore-om.",
  "termen.lag.nume": "lag — decalajul dintre meserii",
  "termen.lag.ce": "Câte zile lucrătoare după meseria dinainte pornește o meserie, nivel cu nivel. Ținut până la capăt, dă fiecărei meserii o perioadă continuă de contractare, care se încheie la lag + marjă după cea dinainte.",
  "termen.zl.nume": "zl — zile lucrătoare",
  "termen.zl.ce": "Zile de luni până vineri, fără sărbătorile legale, câte 8 ore.",
  "termen.luni_macara.nume": "luni-macara",
  "termen.luni_macara.ce": "O macara-turn închiriată o lună. Suma lor pe tot programul dă costul utilajelor de ridicare.",
  "termen.ore_om.nume": "ore-om",
  "termen.ore_om.ce": "Orele de muncă ale unui singur om: 10 ore-om sunt un om 10 ore sau doi oameni câte 5. Rețetele le dau pe unitatea de măsură a articolului.",
  "termen.front.nume": "front de structură",
  "termen.front.ce": "Un corp a cărui structură se toarnă acum, cu macaralele lui. Câte fronturi merg deodată decide plafonul de macarale al șantierului; corpul următor pornește când se eliberează macarale.",
  "termen.plafon.nume": "plafonul de macarale",
  "termen.plafon.ce": "Cel mai mare număr de macarale-turn care pot lucra deodată pe șantier (implicit 4). Se poate ridica pe perioade, ca să pornească mai multe corpuri în paralel.",
  "termen.echilibru.nume": "prețul de echilibru",
  "termen.echilibru.ce": "Prețul mediu de vânzare al apartamentelor la care profitul brut ajunge la zero: sub el proiectul pierde.",
  "termen.marja.nume": "marja brută",
  "termen.marja.ce": "Profitul brut împărțit la venituri, în procente.",
  "termen.lant_critic.nume": "lanțul critic",
  "termen.lant_critic.ce": "Șirul de etape care dă durata totală: structura, nivel cu nivel, și meseriile care o urmează la lag-ul lor. O zi pierdută pe el întârzie sfârșitul cu o zi; etapele din afara lui au rezervă.",
  "bc.det.sursa_cifrei": "sursa cifrei de pe rând",
  "bc.det.de_unde": "De unde",
  "bc.det.cum_iese": "Cum iese",
  "bc.det.se_schimba_din": "Se schimbă din:",
  "bc.det.pe_articole": "pe articole",
  "bc.det.in_lucru": "în curs de procesare",
  "bc.det.titlu_terasamente": "Devizul de execuție · terasamente",
  "bc.det.titlu_structura": "Devizul de execuție · structura",
  "bc.det.din_deviz": "cantități măsurate pe calculul de detaliu × prețurile din rețete · {versiune}",
  "bc.det.fara_articole": "Devizul calculului de detaliu n-are articole pe capitolul ăsta.",
  "bc.det.tronsoane": "Tronsoanele devizului",
  "bc.det.toate_tronsoanele#n": "Tot tronsonul|Toate cele {n} tronsoane|Toate cele {n} de tronsoane",
  "bc.det.gropi_tot": "Unde pleacă pământul",
  "bc.det.gropi_tot_text": "Pleacă de pe șantier {tot} m³: {groapa} m³ din groapa subsolului comun din afara tronsoanelor, socotită în rezumat, și {fundatii} m³ din devizul tronsoanelor. Groapa autorizată se alege o dată, pe tot volumul; după «Regenerează», prețul pe m³ intră și în rândul săpăturii.",
  "bc.det.corp_complex": "tot complexul",
  "bc.det.sapatura_corp_in_complex": "Săpătura nu e a corpului: groapa se sapă o dată, pe tot subsolul complexului{volum}, și e în devizul soluției.",
  "bc.det.sapatura_corp_volum": " ({n} m³)",
  "bc.det.sapatura_corp_link": "Devizul întregului complex →",
  "bc.det.sapatura_complex_text": "Groapa întregului subsol: {arie} m² × {h} m, {volum} m³ cu adâncirile de sub cele {n} radiere și șanțurile corpurilor; se plătește o singură dată, pe «tot complexul».{corpuri}",
  "bc.det.sapatura_complex_corpuri": " Suma gropilor corpurilor, săpate fiecare pe secțiunea lui, ar fi {n} m³ — fără parcarea dintre ele.",
  "bc.sect.ipoteze": "Ipoteze",
  "bc.sect.cantitati": "Cantități derivate",
  "bc.sect.costuri": "1 · Costuri de dezvoltare",
  "bc.sect.vanzari": "2 · Vânzări la {pret} util",
  "bc.sect.rezultate": "3 · Rezultate și randament",
  "bc.sect.flux": "4 · Banii în timp",
  "bc.r.capitalMax.element": "Capital maxim imobilizat",
  "bc.r.capitalMax.obs": "vârful banilor scoși din buzunar înainte de încasare",
  "bc.r.capitalMax.de_unde": "Fluxul de numerar lunar: cheltuielile se decontează în luna în care se fac — terenul și taxele la început, construcțiile și rezerva după programul de execuție, managementul jumătate la început și jumătate lunar, finanțarea lunar, comisionul, cadastrul și impozitul la vânzare — iar încasarea vine la recepție.",
  "bc.r.capitalMax.de_unde_ipoteza": "Fără program de execuție, toți banii se pun la început și se încasează la sfârșitul duratei asumate: capitalul imobilizat e costul total.",
  "bc.r.capitalMax.cum": "cel mai mare sold negativ al fluxului cumulat, pe {luni} luni",
  "bc.r.capitalAni.element": "Capital-ani imobilizați",
  "bc.r.capitalAni.obs": "fiecare cheltuială × anii până la încasare",
  "bc.r.capitalAni.de_unde": "Suma cheltuielilor lunare înmulțite cu anii rămași până la încasare: banii din ultimul an stau imobilizați un an, cei de la început toată durata.",
  "bc.r.capitalAni.cum": "Σ cheltuiala lunii × anii până la încasare",
  "bc.r.rir.element": "Rata internă de rentabilitate (RIR)",
  "bc.r.rir.obs": "rata anuală la care banii băgați și scoși se echilibrează",
  "bc.r.rir.fara": "fluxul n-are o schimbare de semn: nu se poate calcula",
  "bc.r.rir.de_unde": "Rata anuală la care valoarea actualizată a fluxului lunar e zero, cu încasarea la recepție.",
  "bc.r.rir.cum": "rata lunară la care fluxul pe {luni} luni se echilibrează, dusă la an",
  "bc.r.roiAn.obs_flux": "profit net / capital-ani",
  "bc.r.roiAn.de_unde_flux": "ROI-ul anual pe capitalul imobilizat: profitul net împărțit la capital-ani — fiecare cheltuială lunară × anii cât stă imobilizată până la încasare —, nu la costul total × durată. Cheltuielile se decontează lunar, după programul de execuție.",
  "bc.um.eur_ani": "€·ani",
  "bc.ui.capital_max": "Capital imobilizat",
  "bc.ui.capital_max_sub": "RIR {p} pe an",
  "bc.ui.capital_max_fara": "RIR nedefinită",
  "termen.rir.nume": "RIR — rata internă de rentabilitate",
  "termen.rir.ce": "Rata anuală la care banii băgați și banii scoși se echilibrează, ținând cont de luna fiecăruia: dobânda pe care ar trebui s-o dea o bancă ca să egaleze proiectul.",
  "termen.capital_max.nume": "capitalul maxim imobilizat",
  "termen.capital_max.ce": "Cea mai mare sumă pe care dezvoltatorul o are scoasă din buzunar la un moment dat, înainte de încasare: vârful soldului negativ al fluxului de numerar lunar.",
  "termen.capital_ani.nume": "capital-ani",
  "termen.capital_ani.ce": "Suma cheltuielilor lunare înmulțite cu anii rămași până la încasare. Pe ei se împarte profitul net ca să iasă ROI-ul anual pe capitalul imobilizat: banii din ultimul an stau un an, cei de la început toată durata.",
  "bc.grup.teren": "Teren",
  "bc.grup.sapatura_structura": "Săpătură și structură",
  "bc.grup.arhitectura_instalatii": "Arhitectură, anvelopă și instalații",
  "bc.grup.subsol": "Subsol și parcare",
  "bc.grup.amenajari": "Amenajări și utilități",
  "bc.grup.dezvoltare": "Taxe, finanțare și cote",
  "bc.um.loc": "loc",
  "bc.um.buc": "buc",
  "bc.um.ani": "ani",
  "bc.um.m2_util": "m² util",
  "bc.um.loc_ap": "loc/ap",
  "bc.um.pe_m2_util": "{moneda}/m² util",
  "bc.obs.formula": "formulă",
  "bc.obs.benchmark": "benchmark proiect comparabil",
  "bc.obs.benchmark_scurt": "benchmark",
  "bc.obs.ipoteza": "ipoteză",
  "bc.obs.reper": "reper",
  "bc.obs.reper_subsol": "reper pe m² de subsol",
  "bc.obs.boq": "din lista de cantități",
  "bc.obs.boq_estimat": "din lista de cantități · {p} % din valoare pe cantități estimate",
  "bc.obs.boq_estimat_tot": "cantități estimate pe m² în lista de cantități — nimic desenat încă",
  "bc.de_unde.boq": "Suma celor {n} articole ale rândului din lista de cantități (fila «Lista de cantități»), cost direct — material, manoperă, utilaje, transport — plus sporurile antreprenorului. Articolele cu cantitatea măsurată pe soluție și cele estimate din camere, arii, etaje și subsoluri sunt marcate acolo, fiecare cu explicația ei.",
  "bc.unde.boq": "Fila «Lista de cantități»: rețetele și resursele proiectului, cantitățile puse de mână",
  "bc.unde.program": "fila «Program»: macarale pe perioade, efective, lag-uri",
  "bc.obs.deviz": "devizul de execuție",
  "bc.obs.cota_vigoare": "cota în vigoare",
  "bc.obs.cota_cc": "cotă din CC",
  "bc.obs.numarate_arhitectura": "numărate pe soluția de arhitectură",
  "bc.de_unde.raport_comparabil": "Raport dintr-un proiect comparabil.",
  "bc.de_unde.pret_mana": "Preț de vânzare scris de mână.",
  "bc.de_unde.canonic": "Numărate în documentul canonic al soluției de arhitectură.",
  "bc.de_unde.cota_cc": "Cotă din costul de construcție.",
  "bc.de_unde.reper_scd": "Reper pe m² de SCD pentru un bloc de locuințe cu finisaje medii, București 2026 — preț de antreprenor, fără TVA. Rămâne reper până există proiectul specialității.",
  "bc.de_unde.reper_subsol": "Reper pe m² de subsol pentru parcarea subterană a unui bloc de locuințe, București 2026 — preț de antreprenor, fără TVA.",
  "bc.par.fix": "fix",
  "bc.par.din_cc": "{p} % din CC",
  "bc.par.pe_scd": "{pret} SCD",
  "bc.cum.cu_spor": "cost direct {direct} × {spor} = {total} · sporuri: {sporuri}",
  "bc.cum.deviz_si_lista": "{deviz} din devizul de specialitate + {lista} din articolele listei pe care devizul nu le are: {care}",
  "bc.cum.apartamente": "{su} / {mp} = {n} apartamente",
  "bc.unde.carte_funciara": "Documentele proiectului → Carte funciară",
  "bc.unde.regim_urbanistic": "Localizare → Regim urbanistic",
  "bc.unde.plan_situatie": "Soluții → Plan de situație",
  "bc.unde.arhitectura": "Soluții → Arhitectură",
  "bc.unde.retete": "Calculul de detaliu al structurii, și tabul «Prețuri, zonă & norme» de pe pagina asta",
  "bc.unde.fatada": "Panoul «Fațadă» al arhitecturii: stilul și compoziția schimbă metrajul",
  "bc.unde.gropi": "Harta gropilor din devizul de dedesubt, și tabul «Prețuri, zonă & norme»",
  "bc.r.teren.element": "Suprafață teren",
  "bc.r.teren.obs_acte": "din actele terenului",
  "bc.r.teren.obs_ipoteza": "suprafață ilustrativă",
  "bc.r.teren.de_unde_acte": "Suprafața din actele terenului.",
  "bc.r.teren.de_unde_ipoteza": "Valoare ilustrativă — proiectul n-are încă suprafața terenului.",
  "bc.r.cut.element": "CUT",
  "bc.r.cut.obs": "conform PUZ / RLU aplicabil",
  "bc.r.cut.obs_solutie": "CUT-ul soluției · PUZ: max. {max}",
  "bc.r.cut.de_unde": "Coeficientul de utilizare a terenului din regimul urbanistic.",
  "bc.r.cut.de_unde_solutie": "CUT-ul folosit de planul de situație al firului: rezumatul se face pe soluția desenată, nu pe maximul permis.",
  "bc.r.cut.semnal_rezerva": "PUZ-ul permite {max}; soluția folosește {cut} — {mp} m² de SCD rămân nefolosiți.",
  "bc.r.scd.element": "SCD supraterană (GBA)",
  "bc.r.scd.de_unde": "Suprafața terenului înmulțită cu CUT-ul.",
  "bc.r.cedat.element": "Procent din SCD cedat vânzătorului",
  "bc.r.cedat.obs": "plata terenului în apartamente la cheie",
  "bc.r.cedat.de_unde": "Termenul negocierii: terenul se plătește în apartamente, nu cash.",
  "bc.r.cedat.cum": "{p} % din SCD",
  "bc.r.suPeGba.element": "Su apartamente / GBA",
  "bc.r.suPeGba.de_unde": "Raport preluat dintr-un proiect comparabil.",
  "bc.r.suPeGba.cum": "{raport} → {su} m² utili din {scd} m² GBA",
  "bc.r.suPeGba.semnal": "Nu e măsurat pe soluția acestui proiect.",
  "bc.r.terasePeGba.element": "Terase / GBA",
  "bc.r.terasePeGba.cum": "{raport} → {mp} m² terase",
  "bc.r.comPeGba.element": "Comercial / GBA",
  "bc.r.comPeGba.cum": "{raport} → {mp} m² comercial",
  "bc.r.locuri.element": "Locuri de parcare subterane",
  "bc.r.locuri.obs_estimat": "estimate",
  "bc.r.locuri.de_unde_estimat": "Estimare — proiectul n-are încă o soluție cu parcaje.",
  "bc.r.locuri.cum": "{locuri} × {mp} = {subsol} m² subsol",
  "bc.r.mpLoc.element": "Subsol pe loc de parcare",
  "bc.r.mpLoc.obs": "benchmark (incl. circulații, tehnic)",
  "bc.r.mpLoc.de_unde": "Benchmark care include circulațiile și spațiile tehnice.",
  "bc.r.apMediu.element": "Apartament mediu",
  "bc.r.apMediu.de_unde": "Aria utilă medie dintr-un proiect comparabil.",
  "bc.r.verde.element": "Spații verzi",
  "bc.r.verde.obs": "PUZ: min. {p} % din parcelă",
  "bc.r.verde.obs_proiect": "desenate pe planul de situație · PUZ: min. {minim} m²",
  "bc.r.verde.de_unde": "Minimul cerut de regulament.",
  "bc.r.verde.de_unde_proiect": "Spațiile verzi desenate pe planul de situație al firului.",
  "bc.r.verde.semnal_sub_minim": "Desenate {desenat} m², sub minimul de {minim} m² din PUZ.",
  "bc.r.circ.element": "Circulații de suprafață",
  "bc.r.circ.obs_proiect": "carosabil și trotuare desenate pe planul de situație",
  "bc.r.circ.de_unde_proiect": "Drumurile și trotuarele desenate pe planul de situație al firului, măsurate pe documentul lui (suprapunerile numărate o dată).",
  "bc.r.pTerase.element": "Preț terase",
  "bc.r.pCom.element": "Preț comercial",
  "bc.r.pParc.element": "Preț parcare subterană",
  "bc.r.durata.element": "Durata proiectului",
  "bc.r.durata.obs": "de la antecontract până la predarea ultimei etape",
  "bc.r.durata.de_unde": "Durata asumată a dezvoltării.",
  "bc.r.durata.cum": "{n} ani — împarte ROI-ul ca să dea randamentul anual",
  "bc.r.impozit.element": "Cotă impozit profit",
  "bc.r.impozit.de_unde": "Impozitul pe profit, Codul fiscal art. 17: 16 %, neschimbat în 2026 (verificat la 28.10.2026). Dividendele se impozitează separat, la acționar.",
  "bc.r.gbaRez.element": "GBA suprateran — rezidențial",
  "bc.r.gbaRez.de_unde": "GBA total minus cota comercială.",
  "bc.r.gbaCom.element": "GBA suprateran — comercial",
  "bc.r.gbaCom.de_unde": "Cota comercială din GBA.",
  "bc.r.su.element": "Su apartamente (vandabilă)",
  "bc.r.su.de_unde": "GBA înmulțit cu raportul Su/GBA.",
  "bc.r.terase.element": "Terase / balcoane",
  "bc.r.terase.de_unde": "GBA înmulțit cu raportul terase/GBA.",
  "bc.r.ap.element": "Număr apartamente",
  "bc.r.ap.element_desenate": "Număr apartamente (desenate)",
  "bc.r.ap.obs_formula": "din aria utilă / apartament mediu",
  "bc.r.ap.de_unde_formula": "Aria utilă împărțită la apartamentul mediu.",
  "bc.r.ap.cum_proiect": "{n} apartamente · {mp} m² util mediu",
  "bc.r.ap.semnal": "Referința ar da {ref} apartamente pe aceeași arie utilă — {dif} diferență. Veniturile se socotesc din aria utilă, nu din număr, deci nu se schimbă.",
  "bc.r.subsol.element": "Parcare subterană (GBA subsol)",
  "bc.r.subsol.de_unde": "Locurile înmulțite cu mp pe loc.",
  "bc.r.groapa.element": "Amprenta gropii subsolului",
  "bc.r.groapa.obs": "din planul de situație",
  "bc.r.groapa.de_unde": "Aria excavației desenate pe planul de situație al firului.",
  "bc.r.nivSub.element": "Niveluri de subsol",
  "bc.r.nivSub.de_unde": "Subsolul cerut de locuri, împărțit la amprenta gropii.",
  "bc.r.hGroapa.element": "Adâncimea gropii",
  "bc.r.hGroapa.de_unde": "Nivelurile de subsol × înălțimea unui nivel, plus ce stă sub pardoseala de jos: radierul, egalizarea și balastul.",
  "bc.r.locPerAp.element": "Locuri de parcare per apartament",
  "bc.r.locPerAp.obs": "verificare de normă",
  "bc.r.locPerAp.de_unde": "Locuri împărțite la apartamente — de comparat cu norma din PUZ.",
  "bc.r.cTerenNatura.element": "Teren — plătit în natură",
  "bc.r.cTerenNatura.par": "0 € cash",
  "bc.r.cTerenNatura.obs": "vezi Venituri",
  "bc.r.cTerenNatura.de_unde": "Nu iese bani din proiect: vânzătorul primește apartamente.",
  "bc.r.cTeren.element": "Costuri aferente terenului",
  "bc.r.cTeren.obs": "notar, taxe, CU",
  "bc.r.cTeren.de_unde": "Notar, taxe, alipire, certificat de urbanism.",
  "bc.r.sapatura.element": "Săpătură generală și terasamente",
  "bc.r.sapatura.obs_groapa": "groapa subsolului comun + devizul tronsoanelor",
  "bc.r.sapatura.obs_groapa_plan": "groapa subsolului din planul de situație",
  "bc.r.sapatura.de_unde_deviz": "Articolele de terasamente din devizul de execuție: volume măsurate pe groapa și pe fundațiile calculate, cu transportul la groapa autorizată aleasă pe hartă, plus sporurile antreprenorului.",
  "bc.r.sapatura.de_unde_izolate": "Tronsoanele se calculează izolat, deci devizul structurii are numai săpătura de sub amprentele lor: fundațiile și, unde e cazul, groapa secțiunii lor de subsol. Groapa întregului subsol comun se socotește aici — amprenta din planul de situație × adâncimea, minus ce are deja devizul — la prețul pe m³ al săpăturii din deviz (săpat, încărcat, dus la groapa autorizată), cu aceleași sporuri.",
  "bc.r.sapatura.de_unde_groapa": "Amprenta gropii din planul de situație × adâncimea, la un preț de referință pe m³: săpat, încărcat și dus la groapa autorizată. Devizul pe articole apare după calculul de detaliu.",
  "bc.r.sapatura.de_unde_ref": "Reper pe m² de subsol: săpătură, încărcare și transport. Devizul pe articole apare după calculul de detaliu.",
  "bc.r.sapatura.cum_minus": "− {deviz} m³ deja în devizul tronsoanelor = {rest} m³",
  "bc.r.sapatura.cum_fundatii": "{groapa} + {fundatii} devizul tronsoanelor = {total}",
  "bc.r.sapatura.obs_complex": "devizul de execuție · groapa întregului complex",
  "bc.r.sapatura.de_unde_complex": "Articolele de terasamente din devizul de execuție, pe ÎNTREGUL complex: groapa pe tot subsolul (conturul din arhitectură, până sub placa parcării și balastul ei), adâncirile sub radierele corpurilor și șanțurile lor, cu transportul la groapa autorizată aleasă pe hartă, plus sporurile antreprenorului. Corpurile nu-și mai plătesc fiecare groapa de sub amprenta lui.",
  "bc.r.sapatura.semnal_fara_plan": "Planul de situație nu dă amprenta gropii: subsolul e socotit pe un singur nivel, deci groapa poate ieși mai puțin adâncă și mai largă decât e.",
  "bc.r.sprijiniri.element": "Sprijinirea incintei și epuismente",
  "bc.r.sprijiniri.obs_groapa": "perete ancorat pe conturul gropii",
  "bc.r.sprijiniri.de_unde_groapa": "Groapa trece de adâncimea la care malul stă singur, deci se sprijină. Perimetrul e estimat din amprentă (≈ {factor} × √arie), peretele coboară cu {infigere} m sub fundul gropii, la un preț de referință pe m² de perete; epuismentele sunt în același preț. Devizul structurii nu le are.",
  "bc.r.sprijiniri.de_unde_ref": "Reper pe m² de subsol pentru sprijiniri și epuismente. Devizul structurii nu le are.",
  "bc.r.structura.element": "Structură de rezistență",
  "bc.r.structura.element_tronsoane": "Structură de rezistență — tronsoanele",
  "bc.r.structura.obs_ref": "reper · devizul vine cu calculul de detaliu",
  "bc.r.structura.obs_corpuri#n": "devizul de execuție · un tronson|devizul de execuție · {n} tronsoane|devizul de execuție · {n} de tronsoane",
  "bc.r.structura.obs_in_lucru": "calculul structurii e în curs · reper până atunci",
  "bc.r.structura.de_unde_deviz": "Devizul de execuție al calculului de detaliu: cantitățile măsurate pe geometria și armarea calculate — beton, armătură bară cu bară, cofraj — înmulțite cu prețurile din rețete, plus sporurile antreprenorului. Diversele și TVA nu intră: rezumatul are rezerva lui și e fără TVA.",
  "bc.r.structura.de_unde_ref": "Reper pe m²: {supra} pe SCD supraterană și {sub} pe subsol. Devizul pe articole apare după calculul de detaliu.",
  "bc.r.structura.semnal_banda": "Iese {v} desfășurat, în afara reperului uzual de {min}–{max} — de verificat pe articole.",
  "bc.r.structuraSubsol.element": "Structură — subsolul dintre tronsoane",
  "bc.r.structuraSubsol.obs": "necalculat încă · pe reper",
  "bc.r.structuraSubsol.de_unde": "Tronsoanele se calculează izolat, fiecare cu secțiunea de subsol de sub amprenta lui; subsolul comun dintre ele nu e încă în calcul. Aria lui e subsolul întreg minus ce stă sub tronsoane, la prețul de referință pe m² de subsol — nu la al tronsoanelor: secțiunea de sub un tronson poartă clădirea întreagă și e închisă cu pereți pe toate laturile, subsolul dintre ele poartă doar pământul de deasupra.",
  "bc.r.structuraSubsol.cum_acoperit": "sub tronsoane: {aria} × {sub}/{tot} = {acoperit} m²",
  "bc.r.structuraSubsol.cum_rata": "infrastructura tronsoanelor iese la {rata}, cu tot cu radierele lor",
  "bc.r.structuraSubsol.semnal_fara_arie": "Nu se știe cât din subsol stă sub tronsoane (planul de situație nu dă nivelurile): s-a luat subsolul întreg, care poate număra de două ori secțiunile deja calculate.",
  "bc.r.arhitectura.element": "Arhitectură — compartimentări și finisaje",
  "bc.r.arhitectura.obs": "zidării, șape, tencuieli, pardoseli, uși",
  "bc.r.anvelopa.element": "Anvelopă — fațade, tâmplărie, acoperiș",
  "bc.r.anvelopa.obs": "termosistem / fațadă ventilată, ferestre, terase",
  "bc.r.anvelopa.obs_deviz": "devizul fațadei",
  "bc.r.anvelopa.obs_se_calculeaza": "se calculează din fațadă",
  "bc.r.anvelopa.obs_dupa_fatada": "după fațada arhitecturii",
  "bc.r.anvelopa.de_unde_asteapta": "Rândul vine numai din devizul fațadei arhitecturii din fir, desfăcut pe articole. Până atunci n-are cifră: nici reperul pe m² SCD.",
  "bc.r.anvelopa.semnal_in_afara_totalului": "Anvelopa nu intră încă în total: totalul și profitul cresc când vine devizul fațadei.",
  "bc.r.anvelopa.obs_corpuri#n": "devizul fațadei · un corp|devizul fațadei · {n} corpuri|devizul fațadei · {n} de corpuri",
  "bc.r.anvelopa.de_unde_deviz": "Devizul fațadei arhitecturii din fir: metrajul fiecărui corp (straturile termosistemului, fațada ventilată, placajele, glafurile, balustradele, tâmplăria, terasele) × tarifele fațadei — estimare de piață, de revizuit. Cantitatea e aria izolată a pereților, aticului, obrajilor și soclului.",
  "bc.r.anvelopa.semnal_nepretuite#n": "Un rând de metraj n-are tarif și lipsește din sumă|{n} rânduri de metraj n-au tarif și lipsesc din sumă|{n} de rânduri de metraj n-au tarif și lipsesc din sumă",
  "bc.fat.titlu": "Devizul fațadei",
  "bc.fat.sursa": "prețuri: {versiune}",
  "bc.fat.nepretuite#n": "Fără tarif, în afara sumei: {lista}|Fără tarif, în afara sumei ({n}): {lista}|Fără tarif, în afara sumei ({n}): {lista}",
  "bc.fat.corpuri": "Corpurile",
  "bc.fat.toate_corpurile#n": "Tot corpul|Toate cele {n} corpuri|Toate cele {n} de corpuri",
  "bc.fat.pret_din": "Preț: {sursa}",
  "bc.fat.informative": "Cantități informative",
  "bc.fat.informative_text": "Se arată, nu se plătesc separat: plăcile și rosturile unui placaj plătit pe m², bucățile de tâmplărie.",
  "bc.fat.dibluri_pe_placa": "{n} pe placă de 0,5 m²",
  "bc.fat.camp.cantitate": "Cantitatea",
  "bc.fat.camp.pu_material_eur": "Prețul unitar al materialului, €",
  "bc.fat.camp.pu_manopera_eur": "Prețul unitar al manoperei, €",
  "bc.fat.calculat": "modificat · calculat: {v}",
  "bc.fat.dublu_clic": "Dublu clic ca să modifici",
  "bc.fat.revino": "Înapoi la valoarea calculată",
  "bc.fat.nu_s_a_salvat": "Nu s-a salvat",
  "bc.fat.cum_corectezi": "Dublu clic pe o cantitate sau pe un preț unitar ca să-l modifici; ↺ revine la valoarea calculată. Prețurile se schimbă pe tot proiectul, cantitățile doar pe soluția asta.",
  "bc.fat.modificate#n": "un rând modificat|{n} rânduri modificate|{n} de rânduri modificate",
  "bc.fat.art.adeziv_lipire": "adeziv de lipire",
  "bc.fat.art.dibluri_eps": "dibluri cu rozetă",
  "bc.fat.art.masa_spaclu": "masă de șpaclu (strat de armare)",
  "bc.fat.art.plasa_fibra": "plasă din fibră de sticlă",
  "bc.fat.art.dibluri_vata": "dibluri pentru vată",
  "bc.fat.art.membrana_vant": "membrană anti-vânt",
  "bc.fat.art.amorsa": "amorsă",
  "bc.fat.art.tencuiala_siliconica": "tencuială siliconică",
  "bc.fat.art.suruburi_substructura": "șuruburi autoforante (montant–consolă)",
  "bc.fat.art.prinderi_placaj": "nituri / cleme din inox",
  "bc.fat.art.ancore_piatra": "ancore cu știft pentru piatră",
  "bc.fat.cap.termosistem": "Termosistem",
  "bc.fat.cap.ventilata": "Fațadă ventilată",
  "bc.fat.cap.finisaje": "Finisaje și placaje",
  "bc.fat.cap.glafuri_ornamente": "Glafuri, brâie, ornamente",
  "bc.fat.cap.balustrade": "Balustrade",
  "bc.fat.cap.tamplarie": "Tâmplărie",
  "bc.fat.cap.terase": "Terase, balcoane, logii",
  "bc.fat.cap.cortina": "Perete cortină",
  "bc.fat.el.perete": "perete",
  "bc.fat.el.atic": "atic",
  "bc.fat.el.obraz": "obraz",
  "bc.fat.el.soclu": "soclu",
  "bc.fat.el.intrados": "intrados",
  "bc.fat.el.spalet": "șpalet",
  "bc.fat.el.despartitor": "despărțitor",
  "bc.fat.el.balcon": "balcon",
  "bc.fat.el.terasa": "terasă",
  "bc.fat.el.camp_vitrat": "câmp vitrat",
  "bc.fat.el.glaf": "glaf",
  "bc.fat.el.glaf_atic": "glaf de atic",
  "bc.fat.el.brau": "brâu",
  "bc.fat.el.muchie_placa": "muchia plăcii",
  "bc.fat.el.ornament": "ornament",
  "bc.fat.el.balustrada": "balustradă",
  "bc.fat.el.balustrada_terasa": "balustradă de terasă",
  "bc.fat.el.garda": "gardă",
  "bc.fat.el.ecran": "ecran",
  "bc.fat.el.mana_curenta": "mână curentă",
  "bc.fat.el.profil_sticla": "profil de sticlă",
  "bc.fat.el.fereastra": "fereastră",
  "bc.fat.el.usa": "ușă",
  "bc.fat.el.usa_intrare_bloc": "ușă de intrare în bloc",
  "bc.fat.el.zona_opaca": "zonă opacă (de foc)",
  "bc.fat.el.fereastra_cortina": "fereastră în cortină",
  "bc.fat.el.consola": "console de prindere",
  "bc.fat.el.bariera_foc": "barieră de foc la placă",
  "bc.fat.el.montant": "montanți",
  "bc.fat.el.prag": "prag",
  "bc.fat.el.substructura": "substructură",
  "bc.fat.vitraj.single": "geam simplu",
  "bc.fat.vitraj.double": "geam dublu",
  "bc.fat.vitraj.triple": "geam triplu",
  "bc.fat.deschidere.fixed": "fix",
  "bc.fat.deschidere.casement": "batant",
  "bc.fat.deschidere.tilt_turn": "oscilobatant",
  "bc.fat.deschidere.sliding": "glisant",
  "bc.fat.art.etics": "polistiren (EPS), plăci",
  "bc.fat.art.etics_intrados": "polistiren la intrados, plăci",
  "bc.fat.art.xps_soclu": "polistiren extrudat (XPS) la soclu, plăci",
  "bc.fat.art.tencuiala_baza": "tencuială de bază armată",
  "bc.fat.art.vata_minerala_fatada": "vată bazaltică, plăci",
  "bc.fat.art.substructura_aluminiu": "substructură din aluminiu",
  "bc.fat.art.substructura": "substructură",
  "bc.fat.art.tencuiala_decorativa": "tencuială decorativă",
  "bc.fat.art.placaj_ceramic": "placaj ceramic",
  "bc.fat.art.placaj_metalic": "placaj metalic",
  "bc.fat.art.placaj_hpl": "placaj HPL",
  "bc.fat.art.placaj_piatra": "placaj din piatră",
  "bc.fat.art.piatra_travertin": "travertin",
  "bc.fat.art.piatra_granit": "granit",
  "bc.fat.art.piatra_ardezie": "ardezie",
  "bc.fat.art.piatra_zidita": "piatră zidită",
  "bc.fat.art.lemn_vertical": "lemn vertical",
  "bc.fat.art.lemn_ingust": "lemn îngust",
  "bc.fat.art.lemn_riflaj": "lemn riflaj",
  "bc.fat.art.lemn_panouri": "panouri din lemn",
  "bc.fat.art.caramida_aparenta": "cărămidă aparentă",
  "bc.fat.art.sticla": "sticlă",
  "bc.fat.art.lamele_verticale": "lamele verticale",
  "bc.fat.art.tabla_vopsita": "tablă vopsită",
  "bc.fat.art.tabla_perforata": "tablă perforată",
  "bc.fat.art.perete_verde": "ecran verde (spalier, fără plante)",
  "bc.fat.art.ecran_fix": "ecran fix",
  "bc.fat.art.perete_cortina": "perete-cortină (golul e la tâmplărie)",
  "bc.fat.art.glaf_aluminiu": "glaf din aluminiu",
  "bc.fat.art.glaf_atic": "copertină de atic",
  "bc.fat.art.aluminiu": "profil din aluminiu",
  "bc.fat.art.profil_eps": "profil din polistiren",
  "bc.fat.art.cornisa_eps": "cornișă din polistiren",
  "bc.fat.art.parapet_glass": "balustradă din sticlă",
  "bc.fat.art.parapet_slats": "balustradă din lamele",
  "bc.fat.art.parapet_solid": "parapet plin",
  "bc.fat.art.parapet_planter": "jardinieră",
  "bc.fat.art.parapet_sticla": "balustradă din sticlă",
  "bc.fat.art.parapet_lamele": "balustradă din lamele",
  "bc.fat.art.mana_curenta_otel": "mână curentă din oțel vopsit",
  "bc.fat.art.mana_curenta_aluminiu": "mână curentă din aluminiu",
  "bc.fat.art.mana_curenta_inox": "mână curentă din inox",
  "bc.fat.art.mana_curenta_lemn": "mână curentă din lemn",
  "bc.fat.art.profil_sticla_aluminiu": "profil de sticlă din aluminiu",
  "bc.fat.art.profil_sticla_inox": "profil de sticlă din inox",
  "bc.fat.art.tamplarie_pvc": "tâmplărie PVC",
  "bc.fat.art.tamplarie_aluminiu": "tâmplărie din aluminiu",
  "bc.fat.art.tamplarie_lemn": "tâmplărie din lemn",
  "bc.fat.art.tamplarie_lemn_aluminiu": "tâmplărie lemn-aluminiu",
  "bc.fat.art.usa_intrare_bloc": "ușă de intrare în bloc din aluminiu, cu panou lateral și supralumină",
  "bc.fat.art.cortina_vitrata": "perete cortină montant-traversă, tripan de control solar",
  "bc.fat.art.cortina_opaca": "zonă opacă din sticlă emailată, cu panou izolat",
  "bc.fat.art.fereastra_cortina": "fereastră ascunsă în cortină, oscilobatantă",
  "bc.fat.art.consola_cortina": "consolă cu piesă înglobată în placă",
  "bc.fat.art.bariera_foc_cortina": "barieră de foc și fum, vată minerală și tablă",
  "bc.fat.art.montant_cortina": "montanți de aluminiu",
  "bc.fat.art.prag_aluminiu": "prag din aluminiu",
  "bc.fat.art.sapa_panta": "șapă de pantă",
  "bc.fat.art.hidroizolatie_balcon": "hidroizolație lichidă",
  "bc.fat.art.hidroizolatie": "hidroizolație bituminoasă",
  "bc.fat.art.termoizolatie_terasa": "termoizolație de terasă (XPS)",
  "bc.fat.art.pietris": "pietriș",
  "bc.fat.art.gresie_exterior": "gresie de exterior",
  "bc.fat.art.dale_portelanate": "dale porțelanate",
  "bc.fat.art.dale_terasa": "dale de terasă",
  "bc.fat.art.deck_compozit": "deck compozit",
  "bc.fat.art.deck_lemn": "deck din lemn",
  "bc.fat.art.ploturi_reglabile": "ploturi reglabile",
  "bc.fat.art.ploturi_grinzisoare": "ploturi cu grinzișoare",
  "bc.fat.art.ploturi": "ploturi",
  "bc.fat.art.grinzisoare": "grinzișoare",
  "bc.fat.art.montanti": "montanți din aluminiu (profil T/L)",
  "bc.fat.art.console": "console din aluminiu cu pad termoizolant",
  "bc.fat.art.ancore": "ancore metalice",
  "bc.r.sanitare.element": "Instalații sanitare",
  "bc.r.sanitare.obs": "apă rece și caldă, canalizare, obiecte sanitare",
  "bc.r.termice.element": "Instalații termice și ventilație",
  "bc.r.termice.obs": "centrale / pompe de căldură, distribuție, ventilare",
  "bc.r.electrice.element": "Instalații electrice și curenți slabi",
  "bc.r.electrice.obs": "tablouri, prize, iluminat, interfon, date",
  "bc.r.psi.element": "Instalații de securitate la incendiu",
  "bc.r.psi.obs": "detecție, hidranți, desfumare casa scării",
  "bc.r.lifturi.element": "Ascensoare",
  "bc.r.lifturi.obs": "reper pe m² de SCD",
  "bc.r.lifturi.obs_lista": "{n} desenate · {statii} stații · {platforme} platforme la intrări",
  "bc.r.lifturi.de_unde_lista": "Ascensoarele desenate în arhitectură — puțurile din nuclee, fiecare numărat o dată pe toată înălțimea — cu stațiile lor (puțul pe fiecare nivel, subsolurile incluse) și platformele de la intrări, din lista de cantități: cost direct plus sporurile antreprenorului. Prețul pe bucată e al unui ascensor cu stațiile și platformele lui.",
  "bc.r.subsolHidro.element": "Subsol — hidroizolații",
  "bc.r.subsolHidro.obs": "membrană / cuvă etanșă, protecții",
  "bc.r.subsolInstalatii.element": "Subsol — instalațiile parcării",
  "bc.r.subsolInstalatii.obs": "ventilare și desfumare, sprinklere, iluminat, pompare",
  "bc.r.subsolFinisaje.element": "Subsol — finisajele parcării",
  "bc.r.subsolFinisaje.obs": "pardoseală, marcaje, vopsitorii, uși",
  "bc.r.cVerde.element": "Spații verzi",
  "bc.r.cVerde.obs": "cantitate din PUZ",
  "bc.r.cVerde.obs_proiect": "cantitate din planul de situație",
  "bc.r.cVerde.de_unde": "Cantitatea e minimul din regulament; prețul, din referință.",
  "bc.r.cVerde.de_unde_proiect": "Cantitatea e cea desenată pe planul de situație; prețul, din referință.",
  "bc.r.cCirc.obs_proiect": "cantitate din planul de situație",
  "bc.r.cCirc.de_unde": "Cantitate și preț dintr-un proiect comparabil.",
  "bc.r.cCirc.de_unde_proiect": "Cantitatea e carosabilul și trotuarele desenate pe planul de situație; prețul, dintr-un proiect comparabil.",
  "bc.r.cInfra.element": "Infrastructură publică + utilități",
  "bc.r.cInfra.obs": "racorduri, art. 30–38 RLU",
  "bc.r.cInfra.de_unde": "Racorduri și lucrări cerute de regulament — suma fișei de referință (2 200 000 € la 37 500 m² SCD), dusă la SCD-ul proiectului.",
  "bc.r.cConexe.element": "Costuri conexe construcției",
  "bc.r.cConexe.obs": "arhitecți, consultanți, studii",
  "bc.r.cConexe.de_unde": "Proiectare, consultanță, studii — suma fișei de referință (450 000 € la 37 500 m² SCD), dusă la SCD-ul proiectului.",
  "bc.r.cProgram.element": "Pârghiile programului de execuție",
  "bc.r.cProgram.obs": "ce costă scurtarea: pompă, ore suplimentare, schimburi, cofraje rapide, prefabricate; sau o curte strâmtă",
  "bc.r.cProgram.de_unde": "Programul de execuție: fiecare pârghie activă în setările lui (sau o restricție atinsă) are formula ei de cost; suma intră în construcții, deci și în taxe, management, comision și rezervă.",
  "bc.r.constructii.element": "Total construcții",
  "bc.r.constructii.obs": "{scd} SCD · {construit} construit",
  "bc.r.constructii.de_unde": "Suma specialităților, a amenajărilor și a utilităților — înainte de taxe, finanțare și cotele dezvoltatorului.",
  "bc.r.taxe.element": "Taxe și cote legale pe construcție",
  "bc.r.taxe.obs": "România, 2026 · din valoarea lucrărilor",
  "bc.r.taxe.de_unde": "Ce plătește investitorul pe valoarea lucrărilor, după lege: taxa de autorizare (Codul fiscal art. 474, clădire de locuit), cota ISC de calitate (Legea 10/1995 art. 40), cota ISC de control (Legea 50/1991 art. 30), Casa Socială a Constructorilor (Legea 215/1997) și timbrul arhitecturii (Legea 35/1994). Verificate la 28.10.2026. Organizarea de șantier nu e aici: o are antreprenorul în prețul lui.",
  "bc.r.finant.element": "Finanțare construcție (dobânzi)",
  "bc.r.finant.de_unde": "Costul finanțării — suma fișei de referință (1 150 000 € la 37 500 m² SCD), dusă la SCD-ul proiectului.",
  "bc.r.cadastru.element": "Cadastru, recepții, intabulări",
  "bc.r.cadastru.de_unde": "Suma fișei de referință (90 000 € la 37 500 m² SCD), dusă la SCD-ul proiectului.",
  "bc.r.mgmt.element": "Management dezvoltare",
  "bc.r.comis.element": "Comision vânzări și marketing",
  "bc.r.rezerva.element": "Rezervă",
  "bc.r.rezerva.de_unde": "Rezerva pentru neprevăzute.",
  "bc.r.tic.element": "Total cost investiție (TIC)",
  "bc.r.tic.obs": "{v} construit",
  "bc.r.tic.de_unde": "Costurile de teren, construcție și dezvoltare.",
  "bc.r.vAp.element": "Apartamente (arie utilă netă)",
  "bc.r.vAp.obs": "cota dezvoltatorului",
  "bc.r.vAp.de_unde": "Aria utilă × prețul scenariului × cota dezvoltatorului.",
  "bc.r.vTer.obs": "preț fix pe scenarii",
  "bc.r.vTer.de_unde": "Prețul teraselor nu se schimbă între scenarii.",
  "bc.r.vCom.element": "Comercial",
  "bc.r.vCom.obs": "85 % din GBA e vandabil",
  "bc.r.vCom.de_unde": "85 % din GBA comercial e vandabil; prețul e din ipoteze.",
  "bc.r.vPar.element": "Parcare subterană",
  "bc.r.vPar.obs": "preț pe loc din ipoteze",
  "bc.r.vPar.de_unde": "Preț pe loc din ipoteze.",
  "bc.r.venituri.element": "Total venituri dezvoltator",
  "bc.r.venituri.obs": "{p} % din proiect",
  "bc.r.venituri.de_unde": "Suma celor patru categorii.",
  "bc.r.brut.element": "Profit brut din vânzări",
  "bc.r.brut.obs": "venituri − TIC",
  "bc.r.brut.de_unde": "Veniturile minus costul total al investiției.",
  "bc.r.net.element": "Profit net (după impozit)",
  "bc.r.net.par": "impozit {p} %",
  "bc.r.net.de_unde": "Profitul brut minus impozitul pe profit.",
  "bc.r.marja.element": "Marjă brută pe venituri",
  "bc.r.marja.obs": "profit brut / venituri",
  "bc.r.marja.de_unde": "Cât din venituri rămâne înainte de impozit.",
  "bc.r.roi.element": "Randamentul investiției (ROI)",
  "bc.r.roi.obs": "profit net / TIC",
  "bc.r.roi.de_unde": "Profitul net raportat la costul total.",
  "bc.r.roiAn.element": "ROI pe an",
  "bc.r.roiAn.obs": "pe {n} ani",
  "bc.r.roiAn.de_unde": "ROI împărțit la durata proiectului.",
  "bc.r.roiAn.cum": "ROI / {n} ani",
  "bc.r.prag.element": "Preț de vânzare de echilibru",
  "bc.r.prag.obs": "profit brut = 0",
  "bc.r.prag.de_unde": "Prețul la care profitul brut ajunge zero, restul rămânând la fel.",

  // --- Studio: canvasul disciplinelor ------------------------------------
  "studio.se_incarca_modelul": "Se încarcă modelul 3D…",
  "studio.structura_v": "Structură v{v}",
  "studio.favorita": "favorită",
  "studio.fa_favorita": "fă favorită",
  "studio.fa_favorita_titlu": "Fă-o favorită — pe ea se va construi mai departe",
  "studio.parcare_fara_rampe": "în lucru: {locuri} locuri găsite, se caută rampele",
  "studio.pe_solutie": "pe {solutie}",
  "studio.fara_solutie": "Nicio soluție de {disciplina}.",
  "studio.fara_pe": "Nicio soluție de {disciplina} pe {solutie}.",
  "studio.fara_solutie_text": "Generează una din <b>Soluții</b>, apoi se desenează aici.",
  "studio.gen.site_plan": "Se generează planul de situație",
  "studio.gen.architecture": "Se generează arhitectura",
  "studio.gen.architecture_import": "Se interpretează arhitectura",
  "studio.import_picat": "Soluția arhitecturală nu a putut fi importată",
  "studio.import_picat_text": "Importul planșelor de arhitectură a eșuat.",
  "studio.import_anulat": "Importul planșelor de arhitectură a fost anulat.",
  "studio.import_fara_puls": "Importul planșelor de arhitectură nu mai răspundea și a fost abandonat.",
  "studio.import_inapoi": "Înapoi la documente",
  "studio.gen.structure": "Se generează structura",

  // --- setările proiectului ----------------------------------------------
  "setari.titlu": "Setările proiectului",
  "setari.general": "General",
  "setari.general_descriere": "Numele proiectului, organizația, arhivarea",
  "setari.acces": "Acces",
  "setari.acces_descriere": "Cine vede și cine poate lucra pe proiect",
  "setari.general_doar_citire": "Ai doar drept de citire pe proiectul ăsta — numele și arhivarea le poate schimba cine are drept de lucru.",
  "setari.numele": "Numele proiectului",
  "setari.despre": "Despre proiect",
  "setari.organizatie": "Organizație",
  "setari.creat": "Creat",
  "setari.modificat": "Ultima modificare",
  "setari.arhivare": "Arhivare",
  "setari.arhivare_titlu": "Scoate proiectul din listă.",
  "setari.arhivare_text": "Nu se șterge nimic: dosarul, soluțiile și verificările rămân în bază. Proiectul dispare din listă pentru toată lumea.",
  "setari.sterge_solutii": "Șterge toate soluțiile",
  "setari.sterge_solutii_titlu": "Șterge toate soluțiile proiectului.",
  "setari.sterge_solutii_text": "Plan de situație, arhitectură, structură — cu rulările și rezultatele lor. Dosarul, actele citite și preferințele rămân; schițele pornesc singure din nou pe arhitecturile noi.",
  "setari.confirma_sterge_solutii": "Ștergi TOATE cele {n} soluții ale proiectului ({situatie} amplasări, {arhitectura} arhitecturi, {schite} schițe, {solutii} soluții de structură), cu rulările lor? Rulările în curs se opresc. Nu se poate anula.",
  "setari.sterse_solutii": "Șterse {solutii} soluții, {joburi} rulări, {artefacte} artefacte.",
  "setari.esec_sterge_solutii": "Nu am putut șterge soluțiile.",
  "setari.arhiveaza": "Arhivează",
  "setari.confirma_arhivare": "Arhivezi „{proiect}”?\n\nDispare din lista de proiecte. Nu se șterge nimic — soluțiile, dosarul și verificările rămân.",
  "setari.esec_arhivare": "Nu am putut arhiva proiectul.",

  // --- accesul la proiect ------------------------------------------------
  "acces.rol_viewer": "Vizualizare",
  "acces.rol_editor": "Editare",
  "acces.rol_admin": "Administrare",
  "acces.esti_viewer": "poți vedea proiectul",
  "acces.esti_editor": "poți lucra pe proiect",
  "acces.esti_admin": "administrezi proiectul",
  "acces.esec_citire": "Nu am putut citi accesul la proiect.",
  "acces.esec_schimbare": "Nu am putut schimba accesul.",
  "acces.incuiat_afara": "Nu-ți poți lua singur dreptul de a administra proiectul. Dă întâi rolul „Administrare” altcuiva.",
  "acces.nu_e_membru": "Omul nu e în organizația proiectului. Invită-l întâi acolo.",
  "acces.interzis": "Nu ai dreptul să schimbi accesul la proiectul ăsta.",
  "acces.rol_inexistent": "Rolul ăsta nu există.",
  "acces.doar_vezi": "Poți vedea cine are acces, dar nu-l poți schimba — asta o poate face cine administrează proiectul sau un owner al organizației.",
  "acces.organizatia": "Organizația",
  "acces.toti_din": "Toți din {organizatie}",
  "acces.inclusiv_viitorii": "inclusiv cine intră în echipă de acum înainte",
  "acces.nu_e_pe_org": "proiectul nu e dat pe organizație — doar oamenii de mai jos îl văd",
  "acces.oameni": "Oameni",
  "acces.tu": " — tu",
  "acces.dezactivat": "dezactivat",
  "acces.al_organizatiei": "{rol} al organizației",
  "acces.din_organizatie": "din organizație",
  "acces.scoate": "Scoate accesul",
  "acces.nimeni": "Nimeni în afară de tine.",
  "acces.toti_au_acces": "toți din organizație au deja acces",
  "acces.alege_om": "alege un om din organizație…",
  "acces.fara_acces": "Fără acces",
  "acces.sub_organizatie": " — sub cel al organizației",
  "acces.confirma_scoatere_org": "Scoți accesul întregii organizații {organizatie}? Vor rămâne doar oamenii cărora li s-a dat acces separat.",
  "acces.confirma_scoatere": "Scoți accesul lui {nume} la proiect?",
  // --- scorul unei soluții de structură, explicat ------------------------
  "scor.validari": "validări",
  "scor.cost": "cost",
  "scor.uniformitate": "uniformitate",
  "scor.grila": "grilă",
  "scor.parte": "{nume} {valoare} din {total}",
  "scor.conformare": "+{valoare} conformare ({detaliu})",
  "scor.globale_picate#n": "1 verificare globală picată|{n} verificări globale picate|{n} de verificări globale picate",
  "scor.tipuri_stalpi": "{clase} tipuri de stâlpi la {elemente} elemente",
  "scor.tipuri_grinzi": "{clase} tipuri de grinzi la {elemente} elemente",
  "scor.diametre": "{nr} diametre de armătură",
  "scor.diametre_tinta": " (ținta e {tinta})",
  "scor.travee_modul": "{peModul} din {nr} travee pe modulul de {modul} m",
  "scor.deschideri": "{nr} deschideri distincte",
  "scor.deschideri_dominanta": " (cea mai deasă {metri} m, {travee} travee)",
  "scor.titlu": "Scorul structurii {valoare} — mai mic e mai bun, pe o scară fixă de la 0 la 100.",
  "scor.titlu_fara_cifra": "Scorul structurii — mai mic e mai bun, pe o scară fixă de la 0 la 100.",
  "scor.ponderi": "Verificările picate cântăresc 55 %, costul de construire 10 %, cât de repetitivă e structura 25 % (cu cât are mai puține tipuri diferite de stâlp, de grindă și mai puține diametre de armătură, cu atât e mai ușor de executat și de controlat), iar grila 10 %: 5 % câte travee stau pe modulul de parcare (un număr întreg de locuri între doi stâlpi) și 5 % câte deschideri diferite are cadrul (deschideri egale = același cofraj de grindă, refolosit).",
  "scor.cost_nemasurat": "Costul n-a putut fi așezat pe scară (nu se știe costul soluției de plecare), deci termenul lui e la mijloc.",
  "scor.curat": "«Curat» nu înseamnă scor 0, ci zero verificări picate: chiar și o structură care trece tot costă ceva și are mai mult de un tip de element.",
  "scor.alege_platforma": "Pe scorul ăsta alege platforma din ce soluție merge mai departe.",

  // --- vocabularul disciplinelor -----------------------------------------
  "disciplina.site_plan": "Plan de situație",
  "disciplina.architecture": "Arhitectură",
  "disciplina.structure": "Structură",

  // --- exportul PUD (`pages/Pud.tsx`) -------------------------------------
  "pud.titlu": "Export PUD — planșa U3",
  "pud.inapoi": "← planul de situație",
  "pud.explica": "Planșa «Reglementări urbanistice» se compune din planul de situație, din actele dosarului și din corecțiile de mai jos. Ce lipsește apare pe planșă ca «de completat», nu oprește exportul. Documentația e DRAFT, nesemnată.",
  "pud.genereaza": "Generează planșa",
  "pud.se_genereaza": "Se generează…",
  "pud.regenereaza": "Regenerează",
  "pud.esec_pornire": "Nu am putut porni exportul.",
  "pud.rulare": "Rulare: {stare}",
  "pud.picat": "Exportul a picat: {motiv}",
  "pud.fara_export": "Nicio planșă generată încă pe planul ăsta.",
  "pud.descarca": "Descarcă",
  "pud.descarca_pdf": "PDF",
  "pud.descarca_pdf_titlu": "Planșa U3 ca PDF, la scară, pe coala ei",
  "pud.descarca_dxf": "DXF",
  "pud.descarca_dxf_titlu": "Planșa U3 ca DXF: desenul în metri, pe coordonatele proiectului, pe straturi PUD_*",
  "pud.coala": "{coala} la 1:{scara}",
  "pud.fapte": "Informațiile planșei",
  "pud.fapte_explica": "Fiecare valoare cu sursa ei. Scrie în coloana «corecție» ca să bați sursa; lasă gol ca să revii la ea. Corecțiile se aplică la următoarea generare.",
  "pud.col_fapt": "Informație",
  "pud.col_valoare": "Valoare",
  "pud.col_sursa": "Sursă",
  "pud.col_corectie": "Corecție",
  "pud.stare.cunoscut": "cunoscut",
  "pud.stare.aproximat": "aproximat",
  "pud.stare.lipsa": "lipsă",
  "pud.lipsa#n": "o informație de completat|{n} informații de completat|{n} de informații de completat",
  "pud.salveaza_corectii": "Salvează corecțiile",
  "pud.corectii_salvate": "Corecțiile s-au salvat; generează din nou planșa ca să le vezi.",
  "pud.esec_corectii": "Nu am putut salva corecțiile.",
  "pud.previzualizare": "Previzualizare",
  "pud.avert.acte": "Terenul desenat ({contur} m²) nu are suprafața din acte ({acte} m²). Indicatorii și bilanțul sunt calculați pe terenul desenat; verifică conturul și parcelele din certificat.",
  "pud.avert.balcoane": "Balcoanele și terasele în consolă ({m2} m²) ies din amprentă și nu se verifică față de limita edificabilă; regula pentru console rămâne de stabilit cu echipa de arhitecți.",
  "pud.sursa.certificat_urbanism": "certificatul de urbanism",
  "pud.sursa.carte_funciara": "cartea funciară",
  "pud.sursa.topo": "ridicarea topografică",
  "pud.sursa.puz": "PUZ-ul aplicabil",
  "pud.sursa.document": "planul de situație",
  "pud.sursa.arhitectura": "arhitectura",
  "pud.sursa.avize": "avizele de utilități",
  "pud.sursa.manual": "corectat de om",
  "pud.sursa.osm": "OpenStreetMap",
  "pud.sursa.geocodat": "geocodare",
  "pud.sursa.calculat": "calculat",

  // --- starea unei rulări, oriunde se arată ------------------------------
  "job.in_lucru": "în lucru",
  "job.in_coada": "în coadă",
  "job.pasul": "Pasul {i}/{n}",
  "job.asteapta": "așteaptă",
  "job.pasi_faza": "{i}/{n} · {faza}",
  // Ce așteaptă o rulare în `waiting`, după codul scris de job
  // (`asteapta.motiv_cod`). CE așteaptă, apoi DE CE în paranteză: pastila de
  // pe card păstrează doar prima parte, bara de faze arată tot.
  "asteapta.arhitectura_rampe": "așteaptă arhitectura (rampele alese în subsol; apoi agentul desenează circulația și amenajările)",
  "asteapta.arhitectura_noua": "așteaptă arhitectura nouă (rampele alese; apoi agentul desenează circulația și amenajările)",
  "asteapta.subsol_refacut": "așteaptă subsolul refăcut (rampele alese; apoi agentul desenează circulația și amenajările)",
  "asteapta.schita_structura": "așteaptă schița de structură (stâlpii între care se așază subsolul)",
  // Etapa unui job (`stage_cod`), sub bara de progres. Textul românesc e cel
  // scris de serviciu în `stage` — `etape.test.ts` le cere identice.
  // plan de situație
  "etapa.caut_asezari": "caut așezări",
  "etapa.pregatesc_planul": "pregătesc planul pentru agent: excavația și rampele arhitecturii",
  "etapa.gandesc_planul": "gândesc planul (turul {tur})",
  "etapa.scriu_planul": "scriu planul pe soluție",
  // arhitectură
  "etapa.citesc_planul_de_situatie": "citesc planul de situație",
  "etapa.compartimentez_etajele": "compartimentez etajele",
  "etapa.adaptez_excavatia": "adaptez excavația la benzile de parcare",
  "etapa.citesc_arhitectura": "citesc arhitectura",
  "etapa.citesc_stalpii": "citesc stâlpii din structură",
  "etapa.refac_subsolurile": "refac subsolurile",
  "etapa.refac_subsolul": "refac {subsol}",
  "etapa.caut_rampele": "caut rampele",
  "etapa.grefez_subsolul": "grefez subsolul în arhitectură",
  "etapa.compartimentez_atinse#n": "compartimentez un apartament atins · {faza}|compartimentez {n} apartamente atinse · {faza}|compartimentez {n} de apartamente atinse · {faza}",
  "etapa.scriu_apartamentele": "scriu apartamentele în soluție · {faza}",
  // structură
  "etapa.citesc_studiul_geotehnic": "citesc studiul geotehnic",
  "etapa.astept_studiul_geotehnic": "aștept citirea studiului geotehnic",
  "etapa.hidratez_proiectul": "hidratez proiectul",
  "etapa.lantul_ruleaza": "lanțul rulează",
  "etapa.reia_dupa_repornire": "reia lanțul după repornire",
  "etapa.reia_dupa_oom": "reia de la pasul picat, după OOM",
  "etapa.se_opreste": "se oprește ({motiv})",
  // fațadă
  "etapa.citesc_documentul": "citesc documentul soluției",
  "etapa.aduc_contextul": "aduc vecinii și orașul din jur",
  "etapa.compun_plansa": "compun planșa",
  "etapa.scriu_fisierele": "scriu fișierele",
  "etapa.citesc_referintele": "citesc referințele",
  "etapa.gandesc_stilul": "gândesc stilul (turul {tur})",
  "etapa.imbrac_solutia": "îmbrac soluția cu stilul",
  "etapa.compun_fatada": "compun arhitectura fațadei",
  "etapa.designerul_priveste": "un designer compară imaginile cu referințele",
  "etapa.privesc_inainte": "randez fațada de dinainte",
  "etapa.designerul_verifica": "un designer compară înainte și după cu cererea",
  "etapa.randez_imagini#n": "randez o imagine (seria {serie})|randez {n} imagini (seria {serie})|randez {n} de imagini (seria {serie})",
  // dosarul și importul arhitecturii
  "etapa.citesc_actele": "citesc actele",
  "etapa.caut_campuri": "caut {campuri} în {fisier}",
  "etapa.ma_uit_in": "mă uit în {fisier} ({i}/{n})",
  "etapa.caut_conturul_lotului": "caut conturul lotului",
  "etapa.asez_lotul_dupa_plansa": "așez lotul după planșa cadastrală din certificat",
  "etapa.caut_frontul_stradal": "caut frontul stradal pe hartă",
  "etapa.citesc_limita_zonelor": "citesc limita zonelor de pe planșa de reglementări",
  "etapa.citesc_planse_arhitectura": "citesc planșele de arhitectură",
  "etapa.astept_randul_importului": "aștept rândul: alt proiect își importă acum planșele",
  "etapa.refolosesc_citirea": "refolosesc citirea de dinainte",
  "etapa.emit_documentul": "emit documentul canonic",
  "etapa.clasific_planse": "clasific planșele",
  "etapa.citesc_inaltimile": "citesc înălțimile de pe fațade",
  "etapa.stabilesc_niveluri": "stabilesc stiva de niveluri",
  "etapa.masor_golurile": "măsor golurile pe fațade",
  "etapa.aleg_layerele#n": "aleg layerele pe o planșă|aleg layerele pe {n} planșe|aleg layerele pe {n} de planșe",
  "etapa.gasesc_planul_nivelului": "găsesc planul nivelului pe fiecare planșă",
  "etapa.aliniez_nivelurile": "aliniez nivelurile",
  "etapa.citesc_functiunile": "citesc funcțiunile camerelor",
  // control plane
  "etapa.se_reia": "se reia",
  // Titlul unui pas de structură (`job_step.title_cod`), în nota rulării.
  // Textul românesc e cel scris de `structure/app.py::TITLURI_PAS`.
  "titlu_pas.numerotat": "Pasul {nr} ({pas})",
  "titlu_pas.numerotat_corp": "Pasul {nr} ({pas}) · {corp}",
  "titlu_pas.conformare": "analiza de conformare (7C–9C)",
  "titlu_pas.conformare_corp": "analiza de conformare (7C–9C) · {corp}",
  "titlu_pas.asamblare": "asamblarea corpurilor",
  "titlu_pas.imbinare": "îmbinarea corpurilor",
  "titlu_pas.imbinare_corp": "îmbinarea corpurilor · {corp}",
  "titlu_pas.necunoscut": "pasul «{pas}»",
  "titlu_pas.necunoscut_corp": "pasul «{pas}» · {corp}",
  "timp.acum": "acum",
  "timp.minute": "de {n} min",
  "timp.ore": "de {n} h",

  // --- rezoluția la care s-a măsurat soluția -----------------------------

  // --- boardul de compatibilitate ----------------------------------------


  // --- cardul unei soluții ------------------------------------------------

  // --- panoul unei soluții ------------------------------------------------
  "picate.toate_trec": "Toate verificările trec.",
  "picate.fara_detaliu": "Care anume nu e scris în rezultat.",
  "picate.titlu#n": "1 verificare picată, pe categorii:|{n} verificări picate, pe categorii:|{n} de verificări picate, pe categorii:",
  "picate.rand": "{n} × {eticheta}",
  "picate.abatere_cifre": ": {valoare} față de limita {prag}{um}",

  // --- ecranul Soluții ----------------------------------------------------
  "solutii.se_opreste": "Se oprește…",
  "solutii.opreste_tot_titlu": "Oprește tot ce rulează sau așteaptă pe proiect, la orice disciplină",
  "solutii.oprite": "{n} oprite",
  "solutii.in_oprire": "{n} în curs de oprire",
  "solutii.nu_se_pot_opri": "{lista} — solverul pornit merge până la capăt, dar nu se mai înlănțuie nimic peste el",
  "solutii.nimic_oprit": "Nu era nimic de oprit.",
  "solutii.esec_oprire": "Nu am putut opri rulările.",
  // --- ecranul de verificări (partea de arhitectură) ---------------------
  // Vocabularul VALIDATORULUI — numele verdictelor, propozițiile regulilor,
  // bilanțul — rămâne în română: vine de pe server, împreună cu regulile
  // (`requirement_ro`, `condition_ro`, `detail_ro`). Aici se traduce carcasa.
  "verificari.titlu": "Verificări",
  "verificari.fara_solutie": "Nu e nicio soluție de arhitectură favorită ★ pe proiectul ăsta, iar verificările se rulează pe ea. Alege una din ",
  "verificari.se_ruleaza": "Se rulează verificările…",
  "verificari.serviciu_mut": "Serviciul de verificare nu răspunde. Încearcă din nou.",
  "verificari.esec": "Nu am putut rula verificările.",
  "verificari.esec_elemente": "Nu am putut încărca elementele regulii.",
  "verificari.arata_numai": "Arată numai {stare}",
  "verificari.categorii": "Categorii — arhitectură",
  "verificari.nimic_sub_filtru": "Nimic sub filtrul ăsta.",
  "verificari.inapoi": "Înapoi la capitolele categoriei",
  "verificari.capitole#n": "un capitol|{n} capitole|{n} de capitole",
  "verificari.reguli#n": "o regulă|{n} reguli|{n} de reguli",
  "verificari.norma_capitolului": "Norma capitolului",
  "verificari.pdf_titlu": "{act} — fișier PDF, se descarcă",
  "verificari.link_titlu": "{act} — se deschide pe legislatie.just.ro",
  "verificari.cadran_conforme": "{conforme} din {total} reguli conforme",
  "verificari.cadran_masurate": "{masurate} din {total} reguli măsurate",
  "verificari.cadran_neverificabile": "{n} din {total} neverificabile",
  "verificari.daca": "Dacă",
  "verificari.atunci": "Atunci",
  "verificari.se_aplica_la": "Se aplică la: {ce}",
  "verificari.detalii": "Detalii verificare",
  "verificari.regula_cazuta": "Regula a căzut la rulare.",
  "verificari.se_incarca_elemente": "Se încarcă elementele…",
  "verificari.col_element": "Element",
  "verificari.col_masurat": "Măsurat",
  "verificari.col_prag": "Prag",
  "verificari.col_verdict": "Verdict",
  "verificari.vezi_pe_plansa": "Vezi pe planșă",
  "verificari.mai_multe#n": "arată încă un element|arată încă {n} elemente|arată încă {n} de elemente",
  "verificari.pe_plansa": "{element} · pe planșă",
  "verificari.bilant": "Bilanț pe soluție",
  "verificari.bilant_cifra": " din ",
  "verificari.bilant_conforme": " conforme",
  "verificari.pragul": "pragul: {prag}",
  "verificari.procent_conforme": "{procent} % conforme",
  "verificari.tab_arhitectura": "Arhitectură",
  "verificari.tab_structura": "Structură",
  // --- colecția de tronsoane --------------------------------------------
  "nou.titlu": "Tronson nou",
  "nou.subtitlu": "alege unde poate sta pe bară — de-acolo vine forma lui",
  "nou.cod": "Codul șablonului",
  "nou.nota": "Se naște gol, cu amprenta tipică a categoriei: trage de laturi și de colțuri ca s-o potrivești, iar pe măsură ce pui camere și pereți pe margine, marginea îi urmează. Se salvează ca ciornă — niciun plan n-o folosește până n-o publici.",
  "nou.deschide": "Tronson nou",
  "nou.deschide_titlu": "Începe un șablon de la zero, cu forma tipică a categoriei alese",
  "nou.pornire_titlu": "De unde pornești?",
  "nou.pornire_sub": "forma o are deja — mai rămâne ce scrie pe ea",
  "nou.gol": "Foaie goală",
  "nou.gol_sub": "amprenta tipică a categoriei, fără nicio cameră",
  "nou.existent": "Dintr-un modul",
  "nou.existent_sub": "desenul altui modul din aceeași categorie, copiat ca să-l schimbi",
  "nou.imagine": "Dintr-o imagine",
  "nou.imagine_sub": "un plan scanat sau fotografiat, transcris exact: ziduri, goluri, camere și mobilier la locul lor",
  "nou.alege_modulul": "Modulul de la care pornește",
  "nou.niciun_modul": "Categoria asta n-are încă niciun modul de copiat.",
  "nou.modul_cifre": "{arie} m² util · {flats} ap.",
  "nou.alege_imaginea": "Alege imaginea",
  "nou.schimba_imaginea": "Altă imagine",
  "nou.decupaj_titlu": "Decupează planul",
  "nou.decupaj_sub": "păstrează doar planul modulului",
  "nou.decupaj_nota": "Trage de colțuri sau de laturi; o tragere pe poză desenează alt dreptunghi.",
  "nou.decupaj_px": "Rămân {w} × {h} px din planșă.",
  "nou.decupaj_tot": "Toată imaginea",
  "nou.decupaj_gata": "Folosește decupajul",
  "nou.decupeaza_iar": "Decupează din nou",
  "nou.pdf_necitit": "PDF-ul nu s-a putut citi. Încearcă cu o poză sau cu alt fișier.",
  "nou.pdf_randez": "se pregătește pagina din PDF…",
  "nou.imagine_lipsa": "Alege întâi imaginea.",
  "nou.modul_lipsa": "Alege întâi modulul de la care pornești.",
  "nou.se_citeste": "Se citește planul…",
  // LA CE PAS E CITIREA, sub bară. Pașii sunt ai finalizării
  // (`finalizare::_etapa`): pe o planșă mare unul singur ține minute, iar o
  // bară care curge singură nu spune dacă se lucrează sau s-a agățat.
  "nou.pas_tura": "{pas} · tura {tura}",
  "nou.etapa.pregatire": "Se pregătește planșa",
  "nou.etapa.cote": "Se citesc cotele scrise",
  "nou.etapa.citire": "Se citește desenul",
  "nou.etapa.finalizare": "Se așază planul pe cerneală",
  "nou.pas.la_rand": "își așteaptă rândul",
  "nou.pas.goluri_pe_ziduri": "Se așază golurile pe ziduri",
  "nou.pas.lipeste_fete": "Se lipesc zidurile pe cerneală",
  "nou.pas.aliniaza_ziduri": "Se îndreaptă zidurile",
  "nou.pas.inchide_noduri": "Se închid colțurile",
  "nou.pas.stalpi_praguri": "Se așază stâlpii și pragurile",
  "nou.pas.cote": "Se lipesc cotele și se află scara",
  "nou.pas.sonda_scarii": "Se caută scara din ariile scrise",
  "nou.pas.potriveste_rotunjeste": "Se așază pe cote și pe grila de 5 cm",
  "nou.pas.camere": "Se scot camerele dintre ziduri",
  "nou.pas.mobilier": "Se așază mobilierul",
  "nou.pas.scara": "Se scrie scara",
  "nou.pas.asociaza": "Se leagă zidurile de camere",
  "nou.pas.portanta": "Se află zidurile portante",
  "nou.pas.mobila_din_ziduri": "Se scoate mobila din ziduri",
  "nou.pas.tocurile_golurilor": "Se lipesc tocurile ușilor",
  "import.reia": "încearcă din nou",
  "import.renunta": "Renunță la citire și șterge tronsonul",
  "import.inchide": "Dă la o parte",
  "colectie.redenumeste": "redenumește",

  // --- EXPORTUL PLANȘEI unui modul (viewer/tronson/export) -----------------
  "export.buton": "Export",
  "export.pdf": "PDF",
  "export.pdf_titlu": "Planșa modulului ca PDF: desenul la scară, pe A3 sau A2, cu cartuș",
  "export.dwg": "DWG",
  "export.dwg_titlu": "Planșa modulului ca DWG: desenul în metri, pe layere — ziduri, uși, ferestre, camere, mobilier, cote",
  "export.esuat": "PDF-ul nu s-a putut genera.",
  "export.pornit": "Se exportă «{cod}» în format {format}…",
  "export.gata": "«{cod}» a fost exportat în format {format}.",
  "export.pardoseala": "Pardoseală",
  "export.pereti": "Pereți",
  "export.dwg_esuat": "DWG-ul nu s-a putut genera.",
  "export.dwg_pierdute": "DWG-ul s-a scris, dar la conversie s-au pierdut {n} entități din {din}.",
  "export.titlu_plansa": "Plan modul · secțiune la 1,15 m",
  "export.categorie": "Categorie",
  "export.versiune": "Versiune",
  "export.apartamente": "Apartamente",
  "export.arie_utila": "Arie utilă",
  "export.amprenta": "Amprentă",
  "export.front": "Front",
  "export.scara": "Scara",
  "export.data": "Data",
  "export.autor": "Autor",
  "export.sursa": "Sursă",
  "colectie.redenumeste_titlu": "Alt nume pentru «{cod}»",
  "colectie.redenumeste_camp": "Numele nou",
  "colectie.redenumeste_regula": "Litere mari, cifre, spațiu, «_» și «-», cel mult {n} de semne. Numele leagă modulul de hârtia lui de calc și de etichete; serverul le mută pe toate odată.",
  "import.titlu": "Planșe în citire",
  "import.pornit": "se trimite planșa…",
  "import.gata": "gata — modulul e în colecție",
  "import.esuat": "citirea s-a oprit",
  "nou.import_prea_mica": "Planșa e prea mică: sub 250 px pe latura mare nu se mai vede niciun zid.",
  "nou.import_fara_plan": "Citirea nu s-a încheiat cu un plan în timpul avut. Încearcă din nou; dacă se repetă, planșa e probabil prea ștearsă.",
  "nou.import_refuz": "Modelul a refuzat să citească imaginea.",
  "nou.import_mort": "Citirea s-a oprit pe drum (serviciul a fost repornit).",
  "nou.import_eroare_interna": "Citirea a căzut pe server. Încearcă din nou; dacă se repetă, trimite-ne imaginea.",
  "nou.import_imagine_lipsa": "Imaginea n-a ajuns la server. Încearcă din nou.",
  "calc.titlu": "Calc",
  "calc.pune": "Pune o imagine de trasat sub desen",
  "calc.necalibrat": "necalibrat",
  "calc.latime": "{m} m lat",
  "calc.opacitate": "Cât se vede",
  "calc.ascunde": "Ascunde calcul",
  "calc.arata": "Arată calcul",
  "calc.scoate": "Scoate calcul",
  "colectie.titlu": "Colecție de tronsoane",
  "colectie.subtitlu": "modulele din care se compune o bară — două sau mai multe apartamente de o parte și de alta a unui coridor",
  "colectie.capat": "Capăt",
  "colectie.capat_sub": "închide bara la un capăt — nu are vecin pe o latură",
  "colectie.mijloc": "Mijloc",
  "colectie.mijloc_sub": "se repetă de-a lungul barei, între două module",
  "colectie.colt": "Colț",
  "colectie.colt_sub": "leagă două brațe la 90° — se așază, nu se întinde",
  "colectie.izolat": "Izolat",
  "colectie.izolat_sub": "stă singur pe teren — o locuință întreagă, fără coridor și fără vecin",
  "colectie.camere": "{mix} cam",
  "colectie.dublu_clic": "dublu clic — deschide editorul",
  "prov.titlu": "De unde vine modulul",
  "prov.al_cui": "În colecția lui",
  "prov.desenat_de": "Desenat de",
  "prov.sursa": "Sursa",
  "prov.masurat": "Scara",
  "prov.nota": "Nota versiunii",
  "prov.nota_desenului": "Nota desenului",
  "prov.scris_la": "Scris la",
  "imparte.titlu": "Cine are acces la {cod}",
  "imparte.doar_proprietarul": "Poți vedea cine are acces, dar nu-l poți schimba — asta o poate face doar cel al cărui e modulul.",
  "imparte.niciunul": "Nimeni în afară de tine.",
  "imparte.toata_organizatia": "Toți din {nume}",
  "imparte.vede": "Vizualizare",
  "imparte.scrie": "Editare",
  "imparte.scoate": "Scoate accesul",
  "imparte.da_organizatiei": "Dă acces tuturor din {nume}",
  "imparte.alege_om": "alege un om din organizație…",
  "imparte.toti_au": "toți din organizație au deja acces",
  "imparte.gata": "Gata",
  "colectie.imparte": "acces",
  "colectie.impartit": "primit",
  "colectie.impartit_titlu": "Modulul e al altcuiva și ți s-a dat acces la el",
  "colectie.nucleu": "⌂ nucleu",
  "colectie.ciorna": "ciornă · v{versiune}",
  "colectie.ciorna_titlu": "versiunea {versiune} — salvată, dar nepublicată: niciun plan n-o folosește încă",
  "colectie.editat": "editat · v{versiune}",
  "colectie.editat_titlu": "versiunea {versiune}, a proiectului",
  "colectie.neverificat": "încă neverificat — cifrele se scriu la publicare",
  "colectie.apartamente": "ap.",
  "colectie.util": "m² util",
  "colectie.front": "front {metri} m",
  "colectie.front_rigid": " · rigid",
  "colectie.front_gama": " · {minim}–{maxim}",
  "colectie.editeaza": "Editează →",
  "colectie.vedere_plan": "Plan",
  "colectie.vedere_design": "Design",
  "colectie.vedere_macheta": "Machetă",
  "colectie.scara": "desenat la frontul nominal ({metri} m)",
  "colectie.se_incarca_macheta": "Se încarcă macheta…",
  "colectie.toate_globale": "Toate {n} sunt globale — desenate din planșe, comune tuturor proiectelor.",
  "colectie.unele_ale_proiectului": "{ale} din {n} sunt ale acestui proiect; restul, globale.",
  "colectie.banda": " Bandă de {metri} m.",
  "colectie.ciorne#n": "Una e ciornă|{n} sunt ciorne|{n} sunt ciorne",
  "colectie.ciorne_explicatie": " — se publică din editor ca să intre în planuri. ",
  "colectie.ascunde_ciornele": "ascunde ciornele",
  "colectie.arata_ciornele": "arată ciornele",
  "colectie.se_incarca_modulul": "Se încarcă modulul {cod}…",
  "colectie.sterge_ciorna": "Șterge ciorna",
  "colectie.sterge_ciorna_intrebare": "Ștergi ciornele proiectului pe modulul {cod}?\n\nSe pierd toate versiunile proiectului pe codul ăsta; dacă există un modul global cu același cod, planurile se întorc la el. Nu se poate anula.",
  "colectie.ciorna_stearsa": "Ciorna modulului {cod} a fost ștearsă.",
  // --- etichetele tronsoanelor ------------------------------------------
  // Cuvintele proiectului puse pe module. Vocabularul e al proiectului și poate
  // sta gol: o etichetă scoasă de pe ultimul modul rămâne în listă, ca să fie
  // ALEASĂ, nu tastată din nou.
  "etichete.titlu": "Etichete",
  "etichete.explicatie": "cuvintele proiectului — pune-le pe module ca să le poți găsi și grupa",
  "etichete.niciuna": "fără etichete",
  "etichete.adauga": "+ etichetă",
  "etichete.adauga_titlu": "Alege o etichetă a proiectului sau scrie una nouă",
  "etichete.scoate_titlu": "Scoate «{nume}» de pe modul — eticheta rămâne în proiect",
  "etichete.cauta": "alege sau scrie una nouă",
  "etichete.creeaza": "creează «{nume}»",
  "etichete.nimic_de_ales": "Nicio etichetă în proiect încă — scrie una.",
  "etichete.toate_puse": "Toate etichetele proiectului sunt deja pe modul — scrie una nouă.",
  "etichete.gata": "gata",
  "etichete.plin": "maximum {n} etichete pe un modul",
  // --- dosarul proiectului ----------------------------------------------
  // Numele pieselor de dosar («Certificat de urbanism») vin de la server, cu
  // categoriile; aici se traduce carcasa ecranului.
  "dosar.mort": " · fără semn de viață, probabil oprită — pornește-o din nou",
  "dosar.secunde": "{n} s",
  "dosar.minute": "{n} min",
  "dosar.de_unde.regula": "recunoscut după numele fișierului și al folderului",
  "dosar.de_unde.titlu": "dedus din contextul întregii liste de fișiere",
  "dosar.de_unde.continut": "citit din document — s-a deschis și s-a văzut ce e",
  "dosar.de_unde.manual": "mutat aici de tine",
  "dosar.de_unde.oferte": "urcat ca ofertă, pe Planificare → Oferte",
  "dosar.esec_incarcare": "Nu am putut încărca dosarul.",
  "dosar.altele": "Altele",
  "dosar.neacceptate": "Neacceptate: {fisiere}",
  "dosar.esec_urcare": "Încărcarea a eșuat.",
  "dosar.esec_reprocesare": "Nu am putut reprocesa „{fisier}”.",
  "dosar.se_reproceseaza": "se reprocesează",
  "dosar.se_citeste": "se citește",
  "dosar.se_citeste_oferta": "se citește ca ofertă",
  "dosar.desen_se_pregateste": "se pregătește desenul",
  "dosar.desen_la_rand": "desenul e la rând",
  "dosar.fisiere#n": "{n} document|{n} documente|{n} de documente",
  "dosar.adauga_fisiere": "Adaugă documente",
  "dosar.vezi_solutiile": "Vezi soluțiile",
  "dosar.vezi_solutiile_titlu": "Arhitectura importată din planșe — de pe ea se pornește structura",
  "dosar.structura_genereaza": "Generează structura",
  "dosar.structura_deschide": "Deschide structura",
  "dosar.structura_porneste": "Se pornește…",
  "dosar.structura_motiv_gol": "Se aprinde când sunt în dosar planșele de arhitectură și studiul geotehnic.",
  "dosar.structura_motiv_fara_geo": "Lipsește studiul geotehnic.",
  "dosar.structura_motiv_fara_arh": "Lipsesc planșele de arhitectură.",
  "dosar.structura_motiv_gata": "Planșele se importă, apoi structura pornește singură pe ele.",
  "dosar.structura_motiv_pe_arh": "Structura pornește pe arhitectura importată.",
  "dosar.structura_trage": "Lasă aici tot proiectul, cum îl ai",
  "dosar.structura_trage_rest": " — planșele și studiul se recunosc singure și ajung la locul lor.",
  "dosar.structura_optional": "Opțional",
  "dosar.structura_retete": "cu ele, devizul iese pe prețurile tale — ofertele de aici se citesc singure și apar pe Planificare → Oferte",
  "dosar.loc.cerut": "Cerut · {n} din 2",
  "dosar.loc.arh_titlu": "Proiectul de arhitectură",
  "dosar.loc.arh_desc": "Planșele DWG ale fiecărui nivel — subsol, parter, etaje, acoperiș — și secțiunile, pentru înălțimi.",
  "dosar.loc.geo_titlu": "Studiul geotehnic",
  "dosar.loc.geo_desc": "PDF-ul studiului. Din el se citesc terenul de fundare, apa subterană și seismicitatea.",
  "dosar.loc.geo_nota": "Se citește la fundații, când pornește structura: terenul de fundare, apa subterană, ag și TC.",
  "dosar.loc.lipseste": "lipsește",
  "dosar.loc.blocheaza": "lipsește — fără el structura nu pornește",
  "dosar.loc.in_lucru#n": "se pregătește {n} din {total}|se pregătesc {n} din {total}|se pregătesc {n} din {total}",
  "dosar.loc.planse#n": "1 planșă|{n} planșe|{n} de planșe",
  "dosar.loc.primit": "primit",
  "dosar.loc.trage": "Trage fișierele aici sau",
  "dosar.loc.alege": "alege-le",
  "dosar.plansa.plan_nivel": "plan de nivel",
  "dosar.plansa.sectiune": "secțiune",
  "dosar.plansa.fatada": "fațadă",
  "dosar.plansa.plan_situatie": "plan de situație",
  "dosar.plansa.plan_incadrare": "plan de încadrare",
  "dosar.plansa.releveu": "releveu",
  "dosar.structura_import_ruleaza": "Planșele de arhitectură se importă — așteaptă să se termine importul.",
  "dosar.structura_esec": "Soluția structurală nu a putut fi pornită.",
  "dosar.structura_importa": "Importă structura",
  "dosar.structura_motiv_gata_import": "Planșele se importă, apoi structura desenată în ele se citește și se calculează singură.",
  "dosar.structura_motiv_pe_arh_import": "Structura se importă din planșele arhitecturii.",
  "dosar.continua": "Continuă la Detalii teren",
  "dosar.continua_titlu_citit": "Mergi la pasul următor cu ce s-a citit din acte",
  "dosar.continua_titlu": "Poți continua și fără să citești actele — lotul se poate desena pe hartă",
  "dosar.trage_aici": "Lasă aici toate actele care țin de lot",
  "dosar.trage_aici_rest": " — documentul e clasificat și procesat automat.",
  "dosar.gol.titlu": "Adaugă orice document despre lot, ca să pornim.",
  "dosar.gol.exemple": "De exemplu",
  "dosar.gol.ex_urbanism": "Certificat de urbanism",
  "dosar.gol.ex_plan_zona": "PUZ",
  "dosar.gol.ex_plan_lot": "PUD",
  "dosar.gol.ex_proprietate": "Carte funciară",
  "dosar.gol.ex_geotehnic": "Studiu geotehnic",
  "dosar.gol.ex_topografic": "Studiu topografic",
  "dosar.gol.sari": "Poți sări și direct la Detalii teren, ca să desenezi lotul de mână.",
  "dosar.import_ruleaza": "Se importă soluția externă",
  "dosar.import_esec": "Importul a eșuat",
  "dosar.citire_ruleaza": "Se procesează documentele",
  "dosar.citire_esec": "Procesarea a eșuat",
  "dosar.se_incarca_grup": "Se încarcă",
  "dosar.urcat_din": "{trimis} din {total}",
  "dosar.se_trimite": "se trimite…",
  "dosar.se_incarca_rand": "se încarcă",
  "dosar.necitit": "n-a putut fi citit",
  "dosar.desen_necitit": "desenul n-a putut fi citit",
  "dosar.referinte_lipsa": "referințe lipsă",
  "dosar.reproceseaza_titlu": "Reprocesează {fisier} — recitește actul și, dacă e planșă, se uită din nou în desen (după o schimbare de zonă de interes)",
  "dosar.reproceseaza_aria": "Reprocesează {fisier}",
  "dosar.sterge_aria": "Șterge {fisier}",
  "dosar.confirma_stergere_citit": "Ștergi „{fisier}”?\n\nActele au fost deja citite, iar ce s-a înțeles din el rămâne în datele proiectului până apeși din nou «Citește actele».",
  "dosar.confirma_stergere": "Ștergi „{fisier}”?",
  "dosar.confirma_stergere_oferta": "Ștergi „{fisier}”?\n\nE și oferta de pe Planificare → Oferte și pleacă și de acolo. Scenariul făcut din ea rămâne.",
  "dosar.confirma_stergere_plansa_importata": "Ștergi „{fisier}”?\n\nE planșa din care s-a importat arhitectura ({niveluri}). Arhitectura nu se schimbă odată cu dosarul: după ștergere, ea și structura de pe ea rămân pe o planșă care nu mai e aici, până la un reimport.",
  "dosar.piesa": "Piesa de dosar",
  "dosar.deschide_viewer": "Deschide în viewer",
  "dosar.desen_gata_titlu": "desenul e pregătit — se deschide instantaneu",
  "dosar.desen_lent_titlu": "desenul se parsează la prima deschidere (20–40 s)",
  "dosar.desen_gata": "Desenul e pregătit — se deschide instantaneu.",
  "dosar.desen_gata_insa": " Însă {motiv}.",
  "dosar.desen_eroare": "Desenul n-a putut fi parsat: {motiv}",
  "dosar.desen_in_fundal": "Desenul se pregătește în fundal; până atunci prima deschidere durează cât parsarea planșei.",
  "dosar.marime": "Mărime",
  "dosar.folder": "Folder",
  "dosar.radacina": "rădăcină",
  "dosar.plansa": "Planșa",
  "dosar.de_ce_aici": "De ce a fost clasificat aici",
  "dosar.ce_s_a_intamplat": "Ce s-a întâmplat la citire",
  "dosar.fara_motiv": "fără motiv înregistrat",
  "dosar.reproceseaza_act_titlu": "Aruncă ce s-a derivat din actul ăsta și citește-l din nou",
  "dosar.se_reproceseaza_act": "Se reprocesează…",
  "dosar.reproceseaza_act": "Reprocesează actul",
  "dosar.sterge_fisierul": "Șterge documentul",
  "dosar.oferta": "Oferta",
  "dosar.oferta_se_citeste": "Se citește ca ofertă, pe Planificare → Oferte.",
  "dosar.oferta_aplicata": "Citită ca ofertă: a făcut scenariul «{scenariu}».",
  "dosar.oferta_aplicata_fara": "Citită ca ofertă; scenariul făcut din ea nu mai e în proiect.",
  "dosar.oferta_eroare": "Citirea ca ofertă a eșuat; motivul e pe Planificare → Oferte.",
  "dosar.oferta_necitita": "Se citește singur ca ofertă când proiectul are costuri — o listă de cantități pe care să-i pună prețurile.",
  "dosar.oferta_deschide": "Deschide la Oferte",

  // --- planșele s-au schimbat de la importul arhitecturii ---------------
  "planse.titlu": "Planșele s-au schimbat de la import",
  "planse.text": "Arhitectura importată a ieșit din planșele de atunci și nu se schimbă odată cu dosarul. Structura pornită pe ea lucrează pe o clădire pe care dosarul n-o mai descrie.",
  "planse.stearsa": "„{fisier}” ({niveluri}) a fost ștearsă din dosar",
  "planse.noua": "„{fisier}” e un plan de nivel urcat după import",
  "planse.reimporta": "Reimportă planșele",
  "planse.reimporta_titlu": "Citește planșele de acum într-o arhitectură nouă, care devine favorita ★; structura se caută singură pe ea",
  "planse.se_reimporta": "Pornește reimportul…",
  "planse.esec_reimport": "Reimportul n-a pornit.",
  "planse.confirma_reimport": "Reimportul citește planșele de acum din dosar într-o arhitectură nouă, care devine favorita ★, iar structura se caută singură pe ea.\n\nArhitectura de acum și soluțiile de structură de pe ea rămân în proiect, dar nu mai sunt cele pe care se lucrează. Reimporți?",
  "planse.confirma_pe_vechi": "Planșele s-au schimbat de la importul arhitecturii — {ce}. Structura ar porni pe arhitectura de atunci, nu pe planșele de acum.\n\nPornești totuși structura pe arhitectura veche? Altfel, «Reimportă planșele».",
  "planse.ce_sterse": "șterse din dosar: {fisiere}",
  "planse.ce_noi": "urcate după import: {fisiere}",
  // --- editorul de tronson ------------------------------------------------
  // Paleta, panoul de proprietăți și traducerea probelor stau în
  // `viewer/tronson/editor/` și rămân în română — v. `docs/internationalizare.md`.
  "editor.se_incarca": "Se încarcă modulul {cod}…",
  "editor.bagheta_intrebare": "Modulul are deja {piese} piese de mobilier și {aparate} aparate.\n\nOK — le înlocuiește pe toate cu amenajarea automată.\nAnulează — păstrează mobilierul și trage doar instalația peste el.",
  "editor.bagheta_sarite#n": " O cameră a rămas goală: {motive}.| {n} camere au rămas goale: {motive}.| {n} de camere au rămas goale: {motive}.",
  "editor.bagheta_mobilier": "{piese} piese de mobilier și ",
  "editor.bagheta_raport": "{mobilier}{aparate} aparate electrice.{sarite}",
  "editor.bagheta_titlu": "Amenajat automat: {raport}",
  "editor.cod_nou": "Codul șablonului nou (litere și cifre, de pildă M9):",
  "editor.cod_luat": "Codul {cod} e deja folosit de alt șablon. Alege altul.",
  "editor.cod_invalid": "Codul începe cu o literă și are cel mult 16 litere, cifre, «-» sau «_».",
  "editor.calc_esuat": "Imaginea nu s-a putut citi. Încearcă un JPEG sau un PNG.",
  "editor.inapoi": "Înapoi la colecție",
  "editor.versiune": "v{versiune} · {stare}",
  "editor.publicat": "publicat",
  "editor.ciorna": "ciornă",
  "editor.global": "global — nemodificat",
  "editor.versiuni.titlu": "Versiuni",
  "editor.versiuni.inlocuita": "înlocuită",
  "editor.versiuni.persoana": "om",
  "editor.versiuni.sistem": "sistem",
  "editor.versiuni.din": "din v{v}",
  "editor.versiuni.deschisa": "deschisă",
  "editor.versiuni.eroare": "Versiunile nu s-au putut citi",
  "editor.ascunde_axe": "Ascunde axele de trasare",
  "editor.arata_axe": "Arată axele de trasare — trage de un ax ca să muți toți pereții de pe linia lui",
  "editor.ascunde_etichete": "Ascunde numele și ariile camerelor",
  "editor.arata_etichete": "Arată numele și ariile camerelor",
  "editor.ascunde_obiecte": "Ascunde etichetele obiectelor (uși UME, obloane)",
  "editor.arata_obiecte": "Arată etichetele obiectelor (uși UME, obloane)",
  "editor.ascunde_cote": "Ascunde cotele",
  "editor.arata_cote": "Arată cotele",
  "editor.ascunde_apartamente": "Nu mai colora apartamentele",
  "editor.ascunde_mobilier": "Ascunde mobilierul",
  "editor.arata_mobilier": "Arată mobilierul",
  "editor.arata_apartamente": "Colorează apartamentele",
  "editor.ascunde_foc": "Ascunde culorile de rezistență la foc (ISU)",
  "editor.arata_foc": "Arată culorile de rezistență la foc (ISU)",
  "editor.ascunde_pardoseli": "Ascunde pardoselile — camerele rămân albe",
  "editor.arata_pardoseli": "Arată pardoselile camerelor",
  "editor.estompeaza_electrice": "Estompează instalația electrică — pereții rămân",
  "editor.ascunde_electrice": "Ascunde instalația electrică",
  "editor.arata_electrice": "Arată instalația electrică",
  "editor.inchide": "Închide",
  "editor.nesalvat": "nesalvat",
  "nivel.contur": "Conturul nivelului",
  "nivel.contur_citire": "Conturul e placa nivelului, adică anvelopa în care se refac camerele. Se trage de COLȚURI și de LATURI; un zid de fațadă tras în afară îl duce după el. La salvare se scrie înapoi în soluție, ca poligonul nivelului.",
  "nivel.salveaza": "Salvează în soluție",
  "nivel.salveaza_titlu": "Rescrie pe loc, în documentul soluției, ce ai schimbat pe nivelul ăsta și pe nivelurile bifate",
  "nivel.se_duce_pe": "Se duce și pe",
  "nivel.se_duce_pe_nota": "Nivelurile aceleiași clădiri, cu cât au în comun cu nivelul deschis. O schimbare ajunge numai pe partea lor identică — pe un etaj retras, doar pe porțiunea comună.",
  "nivel.fara_altele": "Clădirea n-are alt nivel cu care să aibă ceva în comun.",
  "nivel.titlu_sect": "Nivelul",
  "nivel.filtru.axe": "Axe",
  "nivel.cladirea": "Clădirea",
  "nivel.inaltime": "Înălțimea nivelului",
  "nivel.scris": "Scris în soluție: {obiecte} obiecte schimbate, {sterse} șterse, pe {niveluri} niveluri.",
  "nivel.inchide_editarea": "Închide editarea",
  "viz.grup.depanare": "Depanare",
  "viz.grup.unelte": "Unelte",
  "viz.rigla": "Riglă",
  "viz.rigla_titlu": "Riglă — două clicuri pe desen și scrie cât e între ele. Tragerea rămâne panoramare.",
  "viz.rigla_stinge_titlu": "Riglă — stinge și șterge măsurile ({n}). Escape face la fel.",
  "viz.editeaza_planul": "Editează planul",
  "viz.editeaza_planul_titlu": "Deschide planul nivelului pe masa de lucru: pereți, axe și cote de tras și de scris",
  "viz.evacuare_recalc": "Recalculează căile de evacuare",
  "viz.evacuare_recalc_titlu": "Reface rutele și traseele de evacuare pe locurile și aleile de acum, cu ieșirile SAS, holurile și coridoarele existente. Nu mută și nu scoate nimic din planșă.",
  "viz.evacuare_recalc_nesalvat": "Salvează întâi editarea parcajului: recalcularea lucrează pe planșa scrisă în soluție.",
  "viz.evacuare_recalc_lucru": "Se recalculează căile de evacuare…",
  "viz.evacuare_recalc_picat": "Recalcularea căilor de evacuare a picat pe nivelul ăsta; traseele de pe planșă sunt cele de dinainte. Eroarea: {eroare}",
  "viz.evacuare_recalc_fara_nivel": "Nivelul ăsta n-are căi de evacuare de refăcut.",
  "viz.evacuare_recalc_ok": "Căile de evacuare sunt refăcute: {iesiri} ieșiri, traseul cel mai lung {lung} m.",
  "viz.evacuare_recalc_gata": "Căile de evacuare sunt refăcute.",
  "viz.evacuare_recalc_fara": "Locuri fără rută sub 40 m: {n}, în roșu pe planșă.",
  "viz.evacuare_recalc_negasite": "Ieșiri care nu mai stau pe fațadă: {iesiri}.",
  "viz.editeaza_parcajul": "Editează parcajul",
  "viz.editeaza_parcajul_titlu": "Mută, adaugă și șterge locuri de parcare pe planșa asta. Se scrie pe loc în soluție; «Refă subsolul» ar rescrie ce ai editat.",
  "parcaj.titlu": "Editare parcaj",
  "parcaj.salveaza_titlu": "Rescrie pe loc, în documentul soluției, locurile mutate, adăugate și șterse",
  "parcaj.unealta.sageata": "Selectează",
  "parcaj.unealta.sageata_titlu": "Apasă pe un loc și trage-l: alunecă pe una din axele lui — pe rând sau pe adâncime, după încotro îl duci; cu ⇧ se mută liber. Săgețile îl împing cu 5 cm (⇧: 50 cm), R îl rotește, Delete îl șterge.",
  "parcaj.unealta.nou": "Loc nou",
  "parcaj.unealta.nou_titlu": "Apasă pe planșă ca să pui un loc de 2,50 × 5,00: ia orientarea vecinului sau a aleii și se lipește de vecini (N)",
  "parcaj.liber": "Liber",
  "parcaj.liber_titlu": "Mutare liberă: locul merge unde îl duci, nu doar pe axa rândului lui — pentru locurile puse greșit față de alee. Fără modul ăsta, ⇧ ținut apăsat face același lucru.",
  "parcaj.unghi": "Unghi",
  "parcaj.unghi_titlu": "Unghiul locului, în grade; scrie o valoare și apasă Enter. Sau trage de mânerul rotund de dincolo de fața locului (⇧: din 15 în 15°).",
  "parcaj.alese": "{n} locuri alese — se mută, se rotesc și se șterg împreună",
  "parcaj.aleea": "Alee · {l} m lungime · {w} m lățime — trage de capete ca s-o lungești sau s-o scurtezi, de mânerul din mijloc ca s-o rotești",
  "parcaj.unghi_alee_titlu": "Unghiul axei aleii, în grade; scrie o valoare și apasă Enter. Sau trage de mânerul rotund din mijlocul ei (⇧: din 15 în 15°). Se rotește în jurul mijlocului, cu aceeași lungime.",
  "parcaj.se_reciteste": "Scris. Se recitește planșa…",
  "parcaj.sterge_aleea_titlu": "Scoate aleea din planșă (Delete). Locurile care intrau doar din ea rămân nedeservite și se văd în chihlimbar; prelungește altă alee până la ele.",
  "parcaj.ales": "Locul {n} · {fel} · {w} × {d} m",
  "parcaj.roteste": "Rotește 90°",
  "parcaj.roteste_titlu": "Întoarce locul cu un sfert de tură în jurul centrului (R)",
  "parcaj.sterge": "Șterge",
  "parcaj.sterge_titlu": "Scoate locul din planșă (Delete)",
  "parcaj.sfat": "Apasă pe un loc ca să-l alegi, apoi trage-l. ⇧+clic alege mai multe. Apasă pe o alee ca să-i tragi capetele.",
  "parcaj.sfat_nou": "Apasă pe planșă unde vrei locul nou. Esc revine la selecție.",
  "parcaj.peste": "Stă peste: {ce}. Nu se poate salva așa.",
  "parcaj.nedeservit": "N-are alee din care să intre (sub 2,5 m de gol în fața uneia din laturi).",
  "parcaj.fel.loc": "alt loc",
  "parcaj.fel.stalp": "un stâlp",
  "parcaj.fel.alee": "o alee",
  "parcaj.fel.camera": "o cameră",
  "parcaj.fel.perete": "un perete",
  "parcaj.fel.rampa": "o rampă",
  "parcaj.fel.culoar": "un culoar PMR",
  "parcaj.fel.contur": "marginea planșeului",
  "parcaj.refuz_suprapuneri": "{n} locuri stau peste ceva. Mută-le întâi — suprapunerile nu se salvează.",
  "parcaj.scris": "Scris în soluție: {mutate} locuri mutate, {noi} noi, {sterse} șterse, {alei} alei schimbate. Verificările și evacuarea calculate înainte pot fi vechi.",
  "parcaj.pleci_nesalvat": "Pleci din editarea parcajului cu modificări nesalvate. Ele se pierd — nimic din ele nu e scris în soluție.\n\nOK — pleacă oricum.\nAnulează — rămâi și salvează.",
  "nivel.corpuri_pe_masa": "Toate corpurile cotei sunt pe planșă, fiecare cu axele lui. Se lucrează pe unul o dată: apasă pe altul ca să-l iei pe masă — ce ai schimbat pe cel lăsat se păstrează până la salvare.",
  "nivel.nu_se_poate": "Nivelul nu s-a putut deschide în editor: {motiv}",
  "nivel.pleci_nesalvat": "Pleci din planul nivelului cu modificări nesalvate. Ele se pierd — nimic din ele nu e scris în soluție.\n\nOK — pleacă oricum.\nAnulează — rămâi și salvează.",
  "editor.salvat": "salvat",
  "editor.salveaza_ciorna": "Salvează ciorna",
  "editor.salveaza_ca_nou": "Salvează ca nou",
  "editor.salveaza_ca_nou_titlu": "Pune desenul deoparte ca șablon nou, sub alt cod, fără să-l schimbe pe cel de față",
  "editor.publica": "Publică",
  "editor.pleci_nesalvat": "Pleci din editor cu modificări nesalvate. Ele se pierd — nimic din ele nu e scris în catalog.\n\nOK — pleacă oricum.\nAnulează — rămâi și salvează ciorna.",
  "editor.urmarea_ciorna": "Salvat ca ciornă, v{versiune}",
  "editor.urmarea_ciorna_sfat": "O ciornă nu intră în niciun plan. «{publica}» o face versiunea finală.",
  "editor.urmarea_publicat": "Publicat: v{versiune} e versiunea finală",
  "editor.urmarea_publicat_sfat": "De-acum planurile proiectului folosesc versiunea asta.",
  "editor.se_incarca_macheta": "Se încarcă macheta…",
  "editor.unealta.perete": "Perete drept",
  "editor.unealta.arc": "Perete curb",
  "editor.unealta.parapet": "Parapet",
  "editor.unealta.balcon": "Balcon",
  "editor.unealta.usa": "Ușă simplă",
  "editor.unealta.usaDubla": "Ușă dublă",
  "editor.unealta.usaGlisanta": "Ușă glisantă",
  "editor.unealta.fereastra": "Fereastră",
  "editor.unealta.camera": "Cameră dreptunghi",
  "editor.unealta.cameraL": "Cameră în L",
  "editor.unealta.cameraT": "Cameră în T",
  "editor.unealta.zonaDesfumare": "Zonă de desfumare",
  "editor.sfat.zona_desfumare": "apasă colț după colț zona, și închide-o apăsând pe primul punct. Se desenează PESTE camera în care stă, fără ziduri în jur",
  "prop.strange_titlu": "Strânge panoul",
  "prop.desfa_titlu": "Desfă panoul",
  "paleta.zona_desfumare": "Zonă de desfumare",
  "editor.unealta.cameraFaraPereti": "Cameră fără pereți",
  "editor.sfat.camera_fara_pereti": "apasă colț după colț camera, și închide-o apăsând pe primul punct sau cu Enter. Nu zidește nimic în jurul ei — felul se alege pe urmă din panou",
  "paleta.camera_fara_pereti": "Cameră fără pereți",
  "editor.unealta.intinde": "Întinde",
  "editor.sfat.intinde": "trage o fereastră peste o bucată de plan, apoi trage de ea. Ce e cuprins întreg se mută, iar zidurile tăiate de fereastră se întind după el — planul rămâne legat",
  "paleta.demoleaza": "Sparge zid",
  "paleta.intinde": "Întinde",
  "paleta.intinde_nota": "tasta S",
  "editor.cota_sterge": "șterge cota",
  "editor.unealta.cota": "Cotă",
  "editor.sfat.cota": "apasă un punct, apoi altul: între ele se scrie măsura. Punctele se lipesc de colțurile zidurilor",
  "paleta.cota": "Cotă",
  "editor.unealta.cameraLibera": "Cameră liberă",
  "editor.unealta.scara": "Scară dreaptă",
  "editor.unealta.scaraU": "Scară în U",
  "editor.unealta.lift": "Lift",
  "editor.unealta.ghena": "Ghenă",
  "editor.unealta.mobila": "Mobilier",
  "editor.unealta.aparat": "Aparat electric",
  "editor.unealta.pensula_pardoseala": "Pensulă — pardoseală",
  "editor.unealta.pensula_pereti": "Pensulă — pereți",
  "editor.sfat.perete": "clic și clic, sau apasă și trage, ca să desenezi un zid",
  "editor.sfat.camera_libera": "apasă din colț în colț; apasă pe primul colț ca să închizi",
  "editor.sfat.camera": "apasă și trage ca să tragi camera, oriunde pe planșă",
  "editor.sfat.parapet": "la fel ca un perete, dar iese de 15 cm și 1,00 m înălțime",
  "editor.sfat.balcon": "trage dreptunghiul lipit de fațadă; laturile libere se închid cu parapet",
  "editor.sfat.scara": "trage prima rampă; scrie treptele, apoi depărtarea dintre rampe",
  "editor.sfat.scara_gata": "apasă unde începe, lângă un zid, și trage încotro urcă; pe urmă se editează ca orice scară",
  "editor.sfat.scara_gata_trage": "trage încotro urcă",
  "editor.sfat.piesa": "apasă unde o vrei; se trage de colțuri ca orice piesă",
  "editor.sfat.mobila": "apasă unde vrei piesa; ține Shift pe ea ca s-o rotești",
  "editor.sfat.aparat": "apasă lângă un perete — aparatul se lipește singur de el",
  "editor.sfat.pensula": "apasă pe camere ca să le dai finisajul ales",
  "editor.sfat.gol": "apasă pe un perete ca să pui un gol în el",
  "editor.afara.titlu": "Spațiu exterior",
  "editor.afara.balcon": "Balcon în consolă",
  "editor.afara.logie": "Logie",
  "editor.afara.locuinta": "Al locuinței",
  "editor.afara.nota_balcon": "în afara benzii: nu intră în suprafața utilă și nici în cea construită",
  "editor.afara.nota_logie": "scobită în volum: nu intră în utilă, dar intră în suprafața construită",
  "editor.esc": "Esc — înapoi la selecție",
  "editor.vedere_plan": "Plan",
  "editor.vedere_design": "Design",
  "editor.vedere_macheta": "Machetă",
  "editor.adauga_ax": "Adaugă axă",
  "editor.ax_are_deja": "Peretele ăsta e deja pe o axă",
  "editor.dubleaza": "Dublează",
  "editor.sterge": "Șterge",
  "editor.editat_la": "Editat {cand}",
  /** CÂT E NESALVAT ora se mișcă pe măsură ce omul desenează, iar la o
   *  renunțare se întoarce la cea scrisă — fără cuvântul ăsta n-ar fi avut
   *  de unde să știe care din cele două citește. */
  "editor.editat_la_nesalvat": "Editat {cand} · nesalvat",
  "editor.intoarce_sensul": "Întoarce sensul",
  "editor.oglindeste_balamaua": "Oglindește balamaua",
  // Eticheta e scurtă ȘI spune tasta: bara selecției are loc de un cuvânt, iar
  // „H"/„V" sunt chiar tastele care fac același lucru, deci butonul le învață
  // pe drum. Explicația întreagă («stânga-dreapta», «față-spate») stă în
  // tooltip, unde se uită cine nu știe.
  "editor.oglindeste_h": "Oglindește H",
  "editor.oglindeste_v": "Oglindește V",
  "editor.deselecteaza": "Deselectează",
  // CELE PATRU ÎNTOARCERI ale obiectului ales — v. `model::intoarcerile`.
  // Etichetele sunt de tooltip, deci întregi: butoanele poartă doar icoane.
  "editor.roteste_stanga": "Rotește un sfert de tur la stânga (R)",
  "editor.roteste_dreapta": "Rotește un sfert de tur la dreapta (R)",
  // DE CE NU SE POATE — scris pe butonul stins, ca lipsa să fie un răspuns, nu
  // o tăcere.
  "editor.intoarceri.camera": "camera nu se întoarce: se întorc zidurile ei",
  "editor.intoarceri.anvelopa": "conturul modulului se schimbă din panou: front, bandă, brațe",
  "editor.intoarceri.gol_rotire": "un gol se rotește odată cu zidul în care stă",
  "editor.intoarceri.fereastra": "o fereastră n-are mână: oglindită, e tot ea",
  "editor.intoarceri.parte": "un dreptunghi oglindit e tot el; rotește-l sau schimbă-i mărimile din panou",
  "editor.intoarceri.nucleu_gol": "nucleul n-are nicio parte de oglindit",
  "editor.intoarceri.nimic": "nu se poate pe ce e ales",
  // TITLURILE OGLINZILOR DIN BARĂ SUNT ALE ECRANULUI, nu ale piesei. Panoul
  // are altele («stânga-dreapta», «față-spate»), și pe bună dreptate: acolo se
  // bifează chiar steagurile piesei, care se citesc pe axa ei. Butonul din bară
  // e o OGLINDĂ pusă peste desen, iar la 90° cele două nu mai sunt același
  // lucru — v. `model::mainaOglindita`.
  "editor.intoarceri.ogl_h": "Oglindește pe orizontală (H)",
  "editor.intoarceri.ogl_v": "Oglindește pe verticală (V)",
  // --- felurile de cameră, cum se scriu pe planșă -------------------------
  "fel.camera.living": "Camera de zi",
  "fel.camera.kitchen": "Bucătărie",
  "fel.camera.bedroom": "Dormitor",
  "fel.camera.dormitor": "Dormitor",
  "fel.camera.bath": "Baie",
  "fel.camera.bath2": "Baie 2",
  "fel.camera.wc": "WC",
  "fel.camera.shower": "Duș",
  "fel.camera.hall": "Hol",
  "fel.camera.hol": "Hol distribuție",
  "fel.camera.administrativ": "Spațiu administrativ",
  "fel.camera.sas": "Sas",
  "fel.camera.balcony": "Balcon",
  "fel.camera.store": "Debara",
  "fel.camera.ghena": "Ghenă",
  "fel.scurt.desfumare": "Desfumare",
  "fel.camera.desfumare": "Zonă de desfumare",
  "fel.camera.tech": "Spațiu tehnic",
  "fel.camera.gospodarie": "Gospodărie apă",
  "fel.camera.scara": "Casă de scară",
  "fel.camera.lift": "Ascensor",
  "fel.camera.office": "Birou",
  "fel.camera.dressing": "Dressing",
  "fel.camera.pantry": "Cămară",
  "fel.camera.terasa": "Terasă",
  "fel.camera.terasa_circulabila": "Terasă circulabilă",
  "fel.camera.garage": "Garaj",
  "fel.camera.boxe": "Boxe",
  "fel.camera.room": "Cameră necunoscută",
  "editor.uneste_camerele": "Unește camerele",
  "editor.mobileaza_camera": "Mobilează camera",
  "editor.mobileaza_camera_titlu": "Pune mobilierul după felul camerei — instalația de acum rămâne neatinsă",
  "editor.instalatia_camerei": "Instalația camerei",
  "editor.camera_fel": "Fel",
  "editor.gol_model": "Model",
  "editor.gol_model_nota": "o foaie cu balama, două foi care se întâlnesc la mijloc, sau o foaie care alunecă pe zid",
  "editor.gol_rol": "Rol",
  "editor.gol_intrare": "ușă de intrare în locuință",
  "editor.gol_intrare_nota": "dedus: dă din coridorul comun într-o cameră; se desenează mai apăsat",
  "editor.gol_interioara": "ușă interioară",
  "editor.gol_rol_scris": "rol scris în document; se desenează după el",
  "editor.gol_latime_exterioara": "Lățime exterioară",
  "editor.gol_latime_exterioara_nota": "golul din zid, de la toc la toc — cota care se scrie pe planșă",
  "editor.gol_latime_interioara": "Lățime interioară",
  "editor.gol_latime_interioara_nota": "lumina ușii, pe unde se trece: golul minus cele două tocuri",
  "editor.gol_toc": "Toc",
  "editor.gol_toc_nota": "lățimea tocului de-a lungul zidului; se scrie în document și pleacă în soluție",
  "fel.usa.single": "simplă",
  "fel.usa.double": "dublă",
  "fel.usa.sliding": "glisantă",
  "editor.camera_fel_nota": "numele de pe planșă, pardoseala implicită și mobilarea automată urmează felul",
  "editor.camera_nume": "Nume",
  "editor.camera_nume_nota": "cuvântul scris pe planșă, când camera nu se cheamă ca felul ei: «Cramă», «Atelier». Felul de deasupra rămâne cel pe care îl citesc motoarele.",
  "editor.sterge_tronson": "Șterge tronsonul",
  "editor.sterge_tronson_titlu": "Șterge tot ce are proiectul pe modulul ăsta — ciorne și versiunea publicată; dacă există un modul global cu același cod, planurile se întorc la el",
  "editor.sterge_tronson_global_titlu": "Modul global, comun tuturor proiectelor — nu se șterge dintr-un proiect. Se pot șterge doar modulele salvate ca noi sau rescrise în proiect.",
  "editor.sterge_tronson_impartit_titlu": "Modul împărțit cu tine — îl poate șterge doar cine l-a desenat.",
  "editor.sterge_tronson_platforma_titlu": "Modul al platformei, comun tuturor proiectelor — ștergerea îl scoate pentru toată lumea.",
  "editor.sterge_tronson_platforma_intrebare": "Ștergi modulul {cod} AL PLATFORMEI?\n\nE unul dintre cele comune, cu care pornește orice proiect: dispare pentru toată lumea, nu doar din ecranul tău. Planurile care îl folosesc rămân fără el. Nu se poate anula.",
  "editor.sterge_tronson_intrebare": "Ștergi tronsonul {cod}?\n\nSe pierd toate versiunile proiectului pe codul ăsta — ciorne și publicată deopotrivă. Dacă există un modul global cu același cod, planurile se întorc la el; altfel tronsonul dispare de tot. Nu se poate anula.",
  // --- localizarea și tema proiectului -----------------------------------
  "loc.dezvoltare.rezidential_colectiv": "Rezidențial — colectiv",
  "loc.dezvoltare.rezidential_individual": "Rezidențial — individual",
  "loc.dezvoltare.birouri": "Birouri",
  "loc.dezvoltare.comercial": "Comercial",
  "loc.dezvoltare.mixt": "Mixt",
  "loc.dezvoltare.industrial": "Industrial",
  "loc.subsol.fara": "Fără subsol",
  "loc.subsol.unul": "Cu subsol",
  "loc.subsol.doua": "Cu două subsoluri",
  "loc.subsol.demisol": "Cu demisol",
  "loc.ap.doua_camere": "Apartamente 2 camere",
  "loc.ap.garsoniera": "Garsonieră",
  "loc.ap.trei_camere": "Apartamente 3 camere",
  "loc.ap.patru_camere": "Apartamente 4 camere",
  "loc.ap.tip_nou": "Tip nou",
  "loc.retragere.strada": "Retragere la stradă",
  "loc.retragere.strada_sub": "de la aliniament, pentru construcții",
  "loc.retragere.vecini": "Retragere la vecini",
  "loc.retragere.vecini_sub": "laterală și posterioară, de la limita de proprietate",
  "loc.retragere.intre": "Între clădiri",
  "loc.retragere.intre_sub": "distanța dintre corpurile de pe parcelă",
  "loc.regim.pot": "POT maxim",
  "loc.regim.pot_sub": "amprentă la sol, din teren",
  "loc.regim.cut": "CUT maxim",
  "loc.regim.cut_sub": "arie desfășurată, ca raport",
  "loc.regim.verde": "Spațiu verde",
  "loc.regim.verde_sub": "minim, din suprafața terenului",
  "loc.regim.verde_sol": "Spațiu verde neescavat",
  "loc.regim.verde_sol_sub": "pe sol natural, din spațiul verde",
  "loc.scurt.certificat_urbanism": "CU",
  "loc.scurt.cadastru": "CF",
  "loc.scurt.plan_topografic": "topo",
  "loc.scurt.studiu_geotehnic": "geo",
  "loc.scurt.solutie_arhitecturala": "memoriu",
  "loc.scurt.solutie_structurala": "structură",
  "loc.scurt.calculat": "contur",
  "loc.lung.certificat_urbanism": "din Certificatul de urbanism",
  "loc.lung.cadastru": "din cartea funciară",
  "loc.lung.plan_topografic": "din planul topografic",
  "loc.lung.studiu_geotehnic": "din studiul geotehnic",
  "loc.lung.solutie_arhitecturala": "din memoriul de arhitectură",
  "loc.lung.solutie_structurala": "din memoriul de structură",
  "loc.lung.calculat": "calculat din contur",
  "loc.din_acte": "din acte",
  "loc.din_acte_scurt": "acte",
  "loc.din_scurt": "din {sursa}",
  "loc.din_fisier": "din {fisier}",
  "loc.schimbat_de_tine": "schimbat de tine",
  "loc.implicit": "implicit",
  "loc.retrageri_pe_laturi": "pe laturi, din act:",
  "loc.expl_baza_implicit": "regula generală: implicitul nostru H/2 = {m} m",
  "loc.expl_baza_act": "regula generală a felului laturii, {sursa}: {m} m",
  "loc.expl_portiune": "porțiune din certificat, {unde}: {m} m",
  "loc.expl_manual": "trasă de mână pe latura asta: {m} m",
  "loc.expl_verdict_manual": "se aplică ce a tras omul; bate tot",
  "loc.expl_verdict_baza": "se aplică regula generală: nicio porțiune din act pe bucata asta",
  "loc.expl_verdict_inlocuieste": "se aplică porțiunea din act: înlocuiește implicitul nostru",
  "loc.expl_verdict_max": "se aplică cea mai mare dintre cerințele actului",
  "loc.punct_nord": "nord", "loc.punct_sud": "sud", "loc.punct_est": "est", "loc.punct_vest": "vest",
  "loc.punct_nord-est": "nord-est", "loc.punct_nord-vest": "nord-vest", "loc.punct_sud-est": "sud-est", "loc.punct_sud-vest": "sud-vest",
  "loc.se_incarca": "se încarcă…",
  "loc.esec_generare": "Nu am putut porni generarea.",
  "loc.marcheaza_zona_chip": "marchează cel puțin o zonă de acces pe contur",
  "loc.fara_contur": "Desenează întâi parcela pe hartă",
  "loc.fara_zona": "Marchează cel puțin o zonă de acces pe conturul parcelei",
  "loc.porneste_titlu": "Caută așezări pe parcela desenată",
  "loc.pornesc": "pornesc…",
  "loc.porneste": "Pornește generarea",
  "loc.adresa_necunoscuta": "încă necunoscută",
  "loc.teren_mp": "{suprafata} m² din acte",
  "loc.teren_contur": "{suprafata} m² din contur",
  "loc.contur_nesigur": "contur nesigur — verifică punctele",
  "loc.contur_nesigur_arii": "aria din puncte {contur} m², în act {act} m²",
  "loc.contur_nesigur_taie": "conturul se taie pe el însuși",
  "loc.contur_nesigur_puncte": "vârfuri de verificat: {puncte}",
  "loc.hasura_titlu": "Ce rămâne din lot după retrageri — hașurat pe hartă. Se reface când schimbi retragerile.",
  "loc.edificabil": "edificabil {suprafata} m²",
  "loc.fara_contur_text": "Actele dau adresa, nu și conturul — n-avem anexă de cadastru sau plan topografic din care să iasă. Desenează terenul pe hartă ca să putem merge mai departe.",
  "loc.deseneaza_terenul": "Desenează terenul",
  "loc.incarca_actele": "Sau încarcă-le în ",
  "loc.dosar": "Încarcă documentele",
  "loc.incarca_actele_rest": " — adresa, conturul și cifrele de urbanism ies singure din ele.",
  "loc.start.titlu": "Unde e lotul?",
  "loc.start.sub": "Din acte n-a ieșit niciun loc în care se construiește. Scrie adresa și îl punem pe hartă.",
  "loc.cere.titlu": "Acum desenează lotul",
  "loc.cere.text": "Dă clic pe fiecare colț al lotului, apoi închide conturul. Tot ce urmează se măsoară pe el.",
  "loc.cauta_adresa": "Str. Fabricii 21, Cluj-Napoca",
  "loc.caut": "caut…",
  "loc.cauta": "Caută",
  "loc.nicio_adresa": "Nicio adresă găsită. Încearcă altfel — strada, numărul, localitatea.",
  "loc.nepotriviri#n": "o nepotrivire între acte|{n} nepotriviri între acte|{n} de nepotriviri între acte",
  "loc.nep.folosit": "se folosește {sursa}",
  "loc.nep.elemente#n": "un element|{n} elemente|{n} de elemente",
  "loc.nep.camp.adresa": "Adresa",
  "loc.nep.camp.suprafata_teren_mp": "Suprafața terenului",
  "loc.nep.camp.suprafata_acte_mp": "Suprafața din acte",
  "loc.nep.camp.suprafata_masurata_mp": "Suprafața măsurată",
  "loc.nep.camp.numar_cadastral": "Numărul cadastral",
  "loc.nep.camp.carte_funciara": "Cartea funciară",
  "loc.nep.camp.categoria_folosinta": "Categoria de folosință",
  "loc.nep.camp.contur": "Conturul",
  "loc.nep.camp.laturi": "Laturile",
  "loc.nep.camp.vecinatati": "Vecinătățile",
  "loc.nep.camp.regim_inaltime": "Regimul de înălțime",
  "loc.nep.camp.pot_max": "POT maxim",
  "loc.nep.camp.cut_max": "CUT maxim",
  "loc.nep.camp.beneficiar": "Beneficiarul",
  "loc.salveaza_terenul": "Salvează terenul",
  "loc.se_salveaza_terenul": "Se salvează noua poziție a terenului: laturile, fronturile și zonele de acces se refac după harta OpenStreetMap…",
  "loc.teren_salvat": "Terenul e salvat pe noua poziție.",
  "loc.muta_terenul": "Mută terenul",
  "loc.roteste_stanga": "Rotește 1° spre stânga",
  "loc.roteste_dreapta": "Rotește 1° spre dreapta",
  "loc.renunta": "renunță",
  "loc.redeseneaza_parcela": "Redesenează parcela",
  "loc.deseneaza_parcela": "Desenează parcela",
  "loc.marcheaza_zone_titlu": "Marchează pe contur zonele în care poate veni accesul carosabil",
  "loc.deseneaza_intai": "Desenează întâi parcela",
  "loc.zone": "Zone de acces ({n})",
  "loc.marcheaza_zona": "Marchează zona de acces",
  "loc.cere_zona.titlu": "Din acte nu reiese frontul stradal. ",
  "loc.cere_zona.text": "Marchează pe hartă zona de pe contur în care poate veni accesul carosabil: două clicuri pe aceeași latură.",
  "loc.zone_din_acte_sub": "frontul stradal citit din {sursa}; poți restrânge zona pe hartă sau adăuga alta",
  "loc.tema": "Tema proiectului",
  "loc.tema_sub": "câmpurile obligatorii au valori propuse — treci prin ele în 30 s",
  "loc.tip_dezvoltare": "Tip dezvoltare",
  "loc.regim_inaltime": "Regim înălțime *",
  "loc.nespecificat": "— nespecificat —",
  "loc.subsoluri": "Subsoluri",
  "loc.etaje": "Etaje peste parter",
  "loc.regim_din_acte": "{regim} (din acte)",
  "tema.regim_pe_zone": "pe zone: {lista}",
  "loc.doar_parter": "niciunul (doar parter)",
  "loc.etaje_n": "{n} (P+{n})",
  "loc.cerinte": "Cerințe de urbanism *",
  "loc.mp": "{suprafata} m²",
  "loc.baza_procente": "procentele se aplică la {suprafata} m², aria conturului",
  "loc.baza_procente_acte": "procentele se aplică la {suprafata} m² din acte — fără contur desenat",
  "loc.contur_vs_acte": "Conturul măsoară {contur} m², certificatul spune {acte} m² ({semn}{procent} %). Toate calculele folosesc conturul; cifra din acte poate aduna parcele suprapuse.",
  "loc.fara_teren": "fără suprafața terenului, procentele n-au din ce da m²",
  "loc.revino_titlu": "Șterge corecțiile tale și revino la ce scrie în acte",
  "loc.revino": "revino la act",
  "loc.retrageri": "Retrageri",
  "loc.metri_titlu": "metri — Enter salvează, Escape renunță",
  "loc.sub_norma_titlu": "sub jumătatea înălțimii de referință ({inaltime} m / 2). Se aplică oricum, iar verificarea de normă o raportează.",
  "loc.sub_h2": "sub H/2 = {metri} m",
  "loc.h2": "H/2 = {metri} m",
  "loc.din_act": "{regula} = {metri} m, cum cere actul",
  "loc.regula_h": "H/{impartitor}",
  "loc.sub_act": "sub {regula} = {metri} m, cât cere actul",
  "loc.formula_scurt": "{raport} × H, minim {minim} m",
  "loc.editeaza_retrageri": "Editează retrageri",
  "loc.salveaza_retrageri": "Salvează retragerile",
  "loc.salveaza_retrageri_titlu": "Scrie retragerile trase pe hartă și iese din editare",
  "loc.retrageri_neatinse": "Nu s-a tras nicio retragere de la intrarea în editare",
  "loc.renunta_retrageri_titlu": "Aruncă retragerile trase de la intrarea în editare și iese din ea; ce scrie în bază rămâne neatins",
  "loc.retrageri_nesalvate": "nesalvat",
  "loc.tras_desen": "tras pe desen: {metri} m",
  "loc.tras_desen_interval": "tras pe desen: între {de_la} și {pana_la} m",
  "loc.tras_desen_titlu": "Retrageri trase de mână pe hartă. Pe fețele pe care au fost trase se aplică ele, nu cerința de aici; «Revino la ce scrie în acte» le șterge.",
  "loc.revino_la_acte": "Revino la ce scrie în acte",
  "loc.revino_la_acte_titlu": "Golește retragerile trase de mână și le lasă pe cele din certificat; se scrie la «Salvează retragerile»",
  "loc.editeaza_retrageri_titlu": "Trage de mânerul fiecărei laturi ca să schimbi retragerea de pe ea; sub cât cere actul, fâșia pierdută se hașurează galben",
  "loc.din_banda": "din CU — pe înălțime",
  "loc.din_formula": "din CU — regulă",
  "loc.din_categorii": "din CU — pe categoria străzii",
  "loc.din_regula_titlu": "Certificatul nu dă un număr, ci o regulă; cifra e regula evaluată pentru clădirea aleasă.",
  "loc.aliniament_categorii": "actul cere {metri} m pentru cea mai strictă categorie de stradă; categoria nu scrie în certificat",
  "loc.h_referinta": "H de referință: {niveluri} niveluri × {hNivel} m = {total} m, la cornișă",
  "loc.fara_regim": "fără regim de înălțime, H/2 n-are din ce ieși",
  "loc.structura_ap": "Structura apartamentelor *",
  "loc.mp_utili": "m² utili",
  "loc.scoate_tipul": "Scoate tipul",
  "loc.total_gresit": "total {procent} % — trebuie 100 %",
  "loc.valori_implicite": "valori implicite",
  "loc.tip_nou": "tip nou",
  "loc.finisaj": "Finisaj țintă",
  "loc.finisaj_placeholder": "Standard",
  "loc.constrangeri": "Constrângeri din certificat",
  "loc.necesita_pud": "necesită P.U.D.",
  "loc.parcele": "Parcele",
  "loc.parcele_total": "{n} · contur {suprafata} m²",
  "loc.parcele_acte": "actele însumează {suprafata} m²",
  "loc.col_cadastral": "Nr. cadastral",
  "loc.bucati": "Bucățile lotului",
  "loc.bucati_total": "{n} cadastre · {suprafata} m² în total",
  "loc.col_adresa": "Adresa",
  "loc.col_acte": "Acte",
  "loc.col_masurat": "Măsurat",
  "loc.col_pot": "POT",
  "loc.bucati_regim_diferit": "Bucățile au POT diferit în acte; lotul poartă o singură cifră, iar edificabilul se desenează din ea.",
  "loc.zone_regim": "Zone de regim",
  "loc.zone_regim_sub": "terenul cade în {n} unități teritoriale, fiecare cu regimul ei",
  "loc.zona_avertisment": "Planul de situație rulează pe tot terenul cu regimul zonei {zona}; zonele nu intră încă în generare.",
  "loc.zona_activa_chip": "folosită la generare",
  "loc.zona_foloseste": "folosește la generare",
  "loc.zona_foloseste_titlu": "Planul de situație va porni cu regimul acestei zone pe tot terenul",
  "loc.zona_arie": "{suprafata} m² · {procent} % din teren",
  "loc.zona_arie_acte": "{suprafata} m² în acte",
  "loc.zona_limita": "Limita zonei",
  "loc.zona_limita_act_fasie": "din act: fâșie de {m} m de la stradă",
  "loc.zona_limita_act_suprafata": "din act: {suprafata} m² de la stradă",
  "loc.zona_limita_rest": "restul terenului",
  "loc.zona_limita_manual": "trasată de tine",
  "loc.zona_limita_plansa_astra": "citită de pe planșă",
  "loc.zona_limita_lipsa": "nu se știe din acte",
  "loc.traseaza_limita": "Trasează limita",
  "loc.traseaza_limita_titlu": "Trage pe hartă linia dintre zona asta și restul terenului",
  "loc.salveaza_limita": "Salvează limita",
  "loc.inverseaza_partea": "Inversează partea",
  "loc.renunta_limita_titlu": "Lasă limita cum era; nu se scrie nimic",
  "loc.limita_sub": "Trage capetele liniei pe contur; partea colorată e zona {zona}.",
  "loc.pozitie_text": "în act: „{text}”",
  "loc.drumuri": "Drumul din acte",
  "loc.cale_acces": "Cale de acces",
  "loc.drumuri_sub": "nu intră în suprafața lotului",
  "loc.col_artera": "Artera",
  "loc.col_gabarit": "Lungime × lățime",
  "loc.gabarit": "{lungime} × {latime} m",
  "loc.drum_de_ce": "Recunoscut ca drum: {motiv}",
  "loc.drum_retragere": "Retragerea de la aliniament, pe laturile lipite de drum",
  "loc.drum_nelipit": "Drumul e la {metri} m de lot, deci nu-i dă front stradal — între ele e teren al altcuiva.",
  "loc.metri": "{metri} m",
  "loc.din_ce_s_a_citit": "Informații suplimentare",
  "loc.fara_acte_citite": "Niciun document încărcat",

  "loc.detalii_teren": "Terenul",
  "loc.detalii_teren_sub": "ce se poate construi pe el, după certificat — schimbă orice cifră citită greșit",
  "loc.la_tema": "Continuă la Tema proiectului",
  "loc.la_tema_titlu": "Pasul următor: ce se construiește pe lotul ăsta",

  "tema.spune.titlu": "Spune-ne ce vrei să construiești",
  "tema.spune.placeholder": "O clădire cu 42 de apartamente peste un garaj subteran, spații comerciale la parter și o curte între cele două tronsoane.",
  "tema.spune.nota_imagini": "Poți scrie și ce-ți place din imaginile de fațadă: ele se numără ca în tava pasului Fațadă — «din prima îmi plac balcoanele, din a doua culoarea». Agentul de fațadă le ia de aici.",
  "tema.fara_abonament": "nu e în abonamentul tău",
  "tema.marime.titlu": "Număr de niveluri",
  "tema.preset": "propus",
  "tema.din_cu": "Certificatul dă {regim}.",
  "tema.peste_cu": "peste {regim}, cât dă certificatul",
  "tema.fara_cu": "Din acte n-a ieșit niciun regim de înălțime — propunerea e de zece etaje.",
  "tema.terase_retrase": "Terase retrase la ultimul etaj (capetele libere se retrag până la prima axă; terasa iese din CUT și se recuperează din amprentă)",
  "tema.inaltimi_diferite": "Etaje jucate în interiorul corpului (bucăți de la regim până la regim − 3, pe rosturi)",
  "tema.corpuri_diferite": "Corpuri cu înălțimi diferite între ele (de la regimul minim până la cel ales)",
  "tema.regim_minim": "Regim minim",
  "tema.calitate.titlu": "Standardul clădirii",
  "tema.calitate.arata": "Setări personalizate",
  "tema.calitate.ascunde": "Ascunde setările",
  "tema.calitate.aparte": "personalizat",
  "tema.calitate.pe_capitole#n": "{n} setare personalizată|{n} setări personalizate|{n} de setări personalizate",
  "tema.nivel.buget": "Buget redus",
  "tema.nivel.buget_sub": "Soluții economice, finisaje de bază, nimic peste ce cere norma.",
  "tema.nivel.standard": "Standard",
  "tema.nivel.standard_sub": "Nivelul obișnuit al pieței, materiale de serie.",
  "tema.nivel.premium": "Premium",
  "tema.nivel.premium_sub": "Materiale superioare, izolare și ventilare peste normă.",
  "tema.nivel.lux": "Lux",
  "tema.nivel.lux_sub": "Fără compromis: materiale alese, sisteme complete.",
  "tema.cap.compartimentare": "Compartimentare",
  "tema.cap.finisaje": "Finisaje",
  "tema.cap.hvac": "Climatizare",
  "tema.cap.sanitare": "Instalații sanitare",
  "tema.cap.electrice": "Instalații electrice",
  "tema.fara_parcela": "desenează lotul în Detalii teren",
  "tema.fara_zona": "marchează o zonă de acces în Detalii teren",
  "tema.la_fatada": "Continuă la Fațadă",
  "tema.la_volumetrie": "Continuă la Volumetrie",
  "tema.la_volumetrie_titlu": "Pasul următor: cum stau clădirile pe teren",
  // Piața din zonă pe brief (`pages/PiataPeBrief.tsx`): starea căutării și
  // configurația recomandată din vânzările din jurul terenului.
  "tema.piata.titlu": "Piața din jurul terenului",
  "tema.piata.la_rand": "Căutarea apartamentelor de vânzare din jurul terenului stă la rând după alta și pornește când se termină aceea.",
  "tema.piata.cat_min": "~{n} min",
  "tema.piata.cat_minim": "cel puțin ~{n} min",
  "tema.piata.cat_necunoscut": "câteva minute",
  "tema.piata.pe": "din {oferte} în jurul terenului, {data}",
  "tema.piata.foloseste_t": "Pune în temă procentele de apartamente și suprafețele din studiu; standardul clădirii rămâne cum e. Le poți schimba oricând.",
  "tema.piata.fara_cautare": "Vânzările din jurul terenului nu s-au căutat încă.",
  "tema.piata.cauta": "Caută acum",
  "tema.piata.eroare": "Căutarea vânzărilor din jurul terenului n-a reușit.",
  "tema.piata.reincearca": "Încearcă din nou",

  // --- Volumetria (pasul 3½: schița de volume pe teren) --------------------
  "vol.titlu": "Cum stau clădirile pe teren?",
  "vol.sub": "Poți lăsa motorul să propună, sau desenezi tu volume aproximative. Schița e o inspirație: motorul ia din ea orientările, numărul de clădiri, formele și pozițiile, dar optimizează pe CUT.",
  "vol.mod.motor": "Las motorul să propună",
  "vol.mod.motor_sub": "Ca până acum: cele trei soluții ies din căutare, fără nicio indicație.",
  "vol.mod.desen": "Desenez volumetria",
  "vol.mod.desen_sub": "Prima soluție va fi cea mai asemănătoare cu schița, a doua cea mai bună după CUT, a treia una diferită.",
  "vol.paleta": "Adaugă",
  "vol.forma.bara": "Bară",
  "vol.forma.L": "L",
  "vol.forma.U": "U",
  "vol.forma.C": "C",
  "vol.sugestii": "Sugestii",
  "vol.sugestii_titlu": "Motorul propune câteva așezări; alege una și modific-o",
  "vol.sugestii_caut": "caut așezări…",
  "vol.sugestii_nimic": "n-a ieșit nicio așezare",
  "vol.sugestii_in": "{n} așezări în {s} s",
  "vol.sterge": "Șterge volumul",
  "vol.sterge_tot": "Șterge tot",
  "vol.anuleaza": "Anulează",
  "vol.refa": "Refă",
  "vol.oglindeste": "Aripile pe cealaltă parte",
  "vol.capat": "Aripa la celălalt capăt",
  "vol.estimat": "estimat",
  "vol.estimat_titlu": "Cifre estimate din volumele desenate, cu regulile motorului. Compunerea din module și terasele reale pot schimba rezultatul; soluțiile nu ar trebui să iasă mult sub ele.",
  "vol.amprenta": "Amprentă",
  "vol.pot": "POT",
  "vol.cut": "CUT",
  "vol.din_max": "din {max}",
  "vol.regim": "{n} niveluri · distanța cerută între corpuri {gap} m",
  "vol.in_afara": "{n} volume ies din zona edificabilă",
  "vol.prea_aproape": "{n} perechi mai apropiate decât distanța cerută",
  "vol.fara_contur": "Desenează lotul în Detalii teren înainte de volumetrie.",
  "vol.fara_acces": "Marchează o zonă de acces în Detalii teren înainte de volumetrie.",
  "vol.gol": "Niciun volum încă: adaugă unul din paletă sau cere sugestii.",
  "vol.estimare_eroare": "Estimarea n-a mers: {motiv}",
  "vol.vecin": "vecin",
  "vol.limita": "limită",
  "vol.la_fatada": "Continuă la Fațadă",
  "vol.legenda_zona": "zona edificabilă",
  "vol.legenda_halo": "distanța cerută în jurul volumului",
  "vol.incadreaza": "Încadrează",
  "vol.incadreaza_titlu": "Lotul întreg la loc (sau dublu-clic pe gol)",
  "tema.la_fatada_titlu": "Pasul următor: cum arată clădirea",

  // --- Fațada (pasul 4) ---------------------------------------------------
  "fat.titlu": "Cum arată clădirea?",
  "fat.sub": "Alege între una și trei fațade care îți plac, chiar din stiluri diferite. Îți pregătim până la trei variante după ele.",
  "fat.sistem.titlu": "Sistemul de fațadă",
  "fat.sistem.sub": "Hotărăște costul și grosimea, nu stilul.",
  "fat.sistem.din_standard": "după standardul clădirii",
  "fat.sistem.cost": "cost relativ",
  "fat.sistem.etics": "Termosistem",
  "fat.sistem.etics_sub": "Polistiren și tencuială decorativă, cu accente de culoare pe volume.",
  "fat.sistem.etics_placari": "Termosistem + placări",
  "fat.sistem.etics_placari_sub": "Tencuială predominantă, placări la parter, la accese și la logii.",
  "fat.sistem.ventilata": "Fațadă ventilată",
  "fat.sistem.ventilata_sub": "Placare pe substructură, vată minerală, tâmplărie din aluminiu.",
  "fat.alege.titlu": "Fațadele care îți plac",
  "fat.alege.max": "una, două sau trei",
  "fat.tab.recomandate": "Recomandate",
  "fat.tab.stiluri": "Pe stiluri",
  "fat.tab.toate": "Toate imaginile",
  "fat.recomandate.sub": "Șase direcții care arată bine pe aproape orice clădire.",
  "fat.alege_pentru_mine": "Alege tu pentru mine",
  "fat.incarca": "Încarcă poza ta",
  "fat.incarca_sub": "O fațadă văzută pe stradă sau pe net. JPG sau PNG; o poți trage aici.",
  "fat.incarca_eroare": "Fișierul nu e o imagine. Încarcă un JPG sau un PNG.",
  "fat.toate_stilurile": "Toate stilurile",
  "fat.stil.vezi#n": "Vezi imaginea|Vezi toate cele {n}|Vezi toate cele {n}",
  "fat.stil.alege": "Alege stilul",
  "fat.stil.ales": "Ales",
  "fat.mai_multe#n": "încă una|încă {n}|încă {n}",
  "fat.mareste": "Mărește",
  "fat.tava.titlu": "Alegerile tale",
  "fat.tava.gol": "Nicio fațadă aleasă încă. Dacă pornești așa, alegem noi trei direcții.",
  "fat.tava.un_stil": "Toate variantele vor avea stilul {stil}.",
  "fat.tava.o_poza": "Toate variantele vor porni de la poza ta.",
  "fat.tava.mai_multe": "Vei primi variante după fiecare alegere: {lista}.",
  "fat.tava.poza_ta": "poza ta",
  "fat.tava.plin": "Poți alege cel mult trei. Scoate una ca să adaugi alta.",
  "fat.tava.scoate": "Scoate",
  "fat.tava.slot_gol": "Alege din imagini",
  "fat.tava.scoasa": "scoasă",
  "fat.tava.scoasa_titlu": "Imaginea a fost scoasă din catalog. Scoate-o din tavă și alege alta.",
  "fat.lupa.alege": "Alege fațada",
  "fat.lupa.aleasa": "Aleasă · {n} din 3",
  "fat.lupa.plin": "Ai ales deja trei",
  "fat.lupa.inchide": "Închide",
  "fat.lupa.inainte": "Imaginea următoare",
  "fat.lupa.inapoi": "Imaginea anterioară",
  "fat.lupa.foto": "Foto:",
  "fat.lupa.ai": "Ilustrație generată cu AI: clădirea nu există.",
  "fat.ai_nota": "Imaginile din catalog sunt ilustrații generate cu AI: clădiri care nu există, arătate doar ca direcții de stil.",
  "fat.lupa.poza_ta": "Poza ta",
  "fat.lupa.poza_ta_sub": "Rămâne în proiect, vizibilă doar echipei lui.",
  // ce se vede pe o imagine din catalog (`MATERIALE`, `ELEMENTE` din fatada/catalog.ts)
  "fat.tag.tencuiala": "tencuială",
  "fat.tag.caramida": "cărămidă",
  "fat.tag.piatra": "piatră",
  "fat.tag.beton": "beton aparent",
  "fat.tag.sticla": "sticlă",
  "fat.tag.metal": "placaj metalic",
  "fat.tag.lemn": "lemn",
  "fat.tag.ceramica": "ceramică",
  "fat.tag.fibrociment": "fibrociment",
  "fat.tag.balcoane": "balcoane",
  "fat.tag.loggii": "logii",
  "fat.tag.terase": "terase",
  "fat.tag.retrageri": "retrageri",
  "fat.tag.console": "volume în consolă",
  "fat.tag.bow_window": "bow-window",
  "fat.tag.lamele": "lamele verticale",
  "fat.tag.brise_soleil": "parasolare",
  "fat.tag.grila": "grilă",
  "fat.tag.rame": "ancadramente",
  "fat.tag.benzi": "benzi orizontale",
  "fat.tag.perforatii": "perforații",
  "fat.tag.vegetatie": "vegetație",
  "fat.tag.curbe": "curbe",
  "fat.tag.arcade": "arcade",
  "fat.tag.cornisa": "cornișă",
  "fat.tag.soclu": "soclu",
  "fat.tag.ferestre_mari": "vitraje de la pardoseală",
  "fat.tag.ferestre_punctuale": "ferestre punctuale",
  "fat.tag.culoare": "culoare",
  "fat.stil.contemporary_urban": "Contemporary Urban",
  "fat.stil.contemporary_urban.desc": "Volume clare, ritm regulat de ferestre și balcoane, paletă neutră.",
  "fat.stil.contemporary_urban.mat": "tencuială · accente antracit · parapet din sticlă",
  "fat.stil.modern_premium": "Modern Premium",
  "fat.stil.modern_premium.desc": "Vitraje ample, profile subțiri, accente de bronz, parter tratat aparte.",
  "fat.stil.modern_premium.mat": "sticlă · metal bronz · ceramică de format mare",
  "fat.stil.minimalist": "Minimalist",
  "fat.stil.minimalist.desc": "Volume foarte curate, puține materiale, suprafețe mari și liniștite.",
  "fat.stil.minimalist.mat": "tencuială albă · goluri adânci · detalii ascunse",
  "fat.stil.contemporary_classic": "Contemporary Classic",
  "fat.stil.contemporary_classic.desc": "Soclu, corp și coronament, ritm vertical, ancadramente simplificate.",
  "fat.stil.contemporary_classic.mat": "piatră · ivory și greige · accente metalice",
  "fat.stil.industrial": "Industrial / Urban Loft",
  "fat.stil.industrial.desc": "Cărămidă aparentă, metal negru, goluri generoase, structura la vedere.",
  "fat.stil.industrial.mat": "cărămidă · metal negru · beton",
  "fat.stil.organic": "Organic / Soft",
  "fat.stil.organic.desc": "Linii curbe, colțuri rotunjite, balcoane fluide, volum sculptural.",
  "fat.stil.organic.mat": "balcoane curbe · parapet din sticlă · alb",
  "fat.stil.biophilic": "Biophilic",
  "fat.stil.biophilic.desc": "Vegetația face parte din fațadă: jardiniere integrate și terase plantate.",
  "fat.stil.biophilic.mat": "jardiniere · terase plantate · lemn",
  "fat.stil.scandinavian": "Scandinavian / Lemn",
  "fat.stil.scandinavian.desc": "Tonuri deschise, lemn, ferestre generoase, detalii discrete.",
  "fat.stil.scandinavian.mat": "lemn · tonuri deschise · ferestre mari",
  "fat.stil.high_tech": "High-Tech",
  "fat.stil.high_tech.desc": "Sticlă, aluminiu, lamele și perforații, geometrie parametrică.",
  "fat.stil.high_tech.mat": "sticlă · aluminiu · lamele",
  "fat.stil.moft": "Fațade MOFT",
  "fat.stil.moft.desc": "Balcoane și volume care se văd de departe: console decalate, culoare, joc.",
  "fat.stil.moft.mat": "console · culoare · geometrie liberă",
  "fat.stil.clasic_istoric": "Clasic istoric",
  "fat.stil.clasic_istoric.desc": "Imobilul clasic european: piatră, balcoane din fier forjat, mansardă.",
  "fat.stil.clasic_istoric.mat": "piatră · fier forjat · mansardă",
  "fat.stil.caramida_nordica": "Cărămidă nordică",
  "fat.stil.caramida_nordica.desc": "Cărămidă pe tot volumul, goluri simple, balcoane metalice ușoare.",
  "fat.stil.caramida_nordica.mat": "cărămidă · balcoane metalice · goluri simple",
  "fat.stil.mediteranean": "Mediteranean",
  "fat.stil.mediteranean.desc": "Alb dominant, terase adânci, umbră și vegetație.",
  "fat.stil.mediteranean.mat": "alb · terase adânci · umbră",
  "fat.stil.art_deco": "Art Deco / Streamline",
  "fat.stil.art_deco.desc": "Colțuri rotunjite, benzi orizontale, balcoane curbe, culori calde.",
  "fat.stil.art_deco.mat": "colțuri rotunde · benzi orizontale · pastel",
  "fat.stil.ceramica": "Placări ceramice",
  "fat.stil.ceramica.desc": "Plăci ceramice pe toată fațada: culoare și textură care durează.",
  "fat.stil.ceramica.mat": "plăci ceramice · culoare · textură",
  "fat.stil.brutalist": "Beton aparent",
  "fat.stil.brutalist.desc": "Beton lăsat la vedere, module repetate, volum puternic.",
  "fat.stil.brutalist.mat": "beton aparent · module · volum",

  // --- de ce nu iese zonă edificabilă (v. `edificabil.ts`) ---------------
  "edificabil.fara_contur": "nu e desenat conturul parcelei",
  "edificabil.fara_retrageri": "nicio retragere, și nici regim de înălțime din care să iasă",
  "edificabil.retrageri_zero": "retrageri de zero — zona e toată parcela",
  "edificabil.acoperit": "retragerile acoperă toată parcela",
  // --- harta: desenarea parcelei și a intrărilor -------------------------
  "harta.strada": "stradă",
  "harta.zona_exact": "acces existent",
  "harta.zona_din": "zonă de acces · din {sursa}",
  "harta.sursa_osm": "harta OpenStreetMap",
  "harta.zona_manual": "zonă de acces · marcată de tine",
  "harta.zona_regim": "{nume} · {suprafata} m²",
  "harta.metri": "{metri} m",
  "harta.esec": "Harta nu s-a putut configura.",
  "harta.inchide_conturul": "clic ca să închizi conturul",
  "harta.trage_coltul": "trage-l; clic-dreapta îl scoate",
  "harta.adauga_colt": "trage ca să adaugi un colț",
  "harta.zona": "clic-dreapta o scoate",
  "harta.trage_ma": "trage-mă",
  "harta.trage_terenul": "trage de pin sau de contur",
  "harta.roteste": "rotește",
  "harta.retragere_din_act": "retragere cerută de act pe porțiunea asta:",
  "harta.desenezi": "Desenezi parcela",
  "harta.ajustezi": "Ajustezi parcela",
  "harta.instructiuni_desen_1": "Clic pe hartă pentru fiecare colț. ",
  "harta.instructiuni_desen_2": "Clic pe primul colț",
  "harta.instructiuni_desen_3": ", sau dublu-clic, închide conturul.",
  "harta.instructiuni_ajustare_1": "Trage colțurile ca să le muți. Trage un ",
  "harta.instructiuni_ajustare_2": "punct de mijloc",
  "harta.instructiuni_ajustare_3": " ca să adaugi un colț nou. ",
  "harta.instructiuni_ajustare_4": "Clic-dreapta",
  "harta.instructiuni_ajustare_5": " pe un colț îl scoate.",
  "harta.colturi#n": " {n} colț| {n} colțuri| {n} de colțuri",
  "harta.arie": "{suprafata} m²",
  "harta.se_potriveste": "se potrivește cu actele",
  "harta.actele_spun": "actele spun {suprafata} m²",
  "harta.diferenta": " ({semn}{procent} %)",
  "harta.fundal_desen": "Fundal OpenStreetMap cât desenezi — pe dalele Google nu se pot trasa limite de proprietate.",
  "harta.se_taie": "conturul se taie pe el însuși — aria nu înseamnă nimic",
  "harta.se_taie_scurt": "conturul se taie pe el însuși",
  "harta.sterge_coltul": "șterge ultimul colț",
  "harta.de_la_zero": "Desenează lotul",
  "harta.gata": "gata",
  "harta.marchezi_zone": "Marchezi zonele de acces",
  "harta.instructiuni_zone_1": "Două clicuri pe aceeași latură",
  "harta.instructiuni_zone_2": " a conturului delimitează zona în care poate veni accesul carosabil. O zonă pusă greșit se scoate cu × din listă sau cu clic-dreapta pe ea.",
  "harta.scoate_zona": "scoate zona",
  "harta.renunta_capat": "renunță la capăt",
  "harta.capat_pus": "primul capăt e pus — clic pe aceeași latură pentru al doilea",
  "harta.zona_departe": "clic chiar pe conturul parcelei — capătul zonei se lipește de limita lotului, nu de axul străzii",
  "harta.zona_alta_latura": "al doilea capăt trebuie să fie pe aceeași latură ca primul",
  "harta.zona_scurta": "zona e mai scurtă de {metri} m — nu încape un acces cu două fire și platforma pietonală",
  "harta.fara_zona": "fără nicio zonă de acces nu se poate genera",
  "harta.fundal_zone": "Fundal OpenStreetMap cât marchezi — zona intră în planul de situație, ca și conturul.",
  // --- legenda muchiilor de descendență ----------------------------------

  // --- paleta editorului: grupele, familiile și cataloagele de obiecte ---
  "mobilier.scara": "Scară dreaptă",
  "mobilier.scaraU": "Scară în U",
  "mobilier.lift": "Lift",
  "mobilier.ghena": "Ghenă",
  "mobilier.canapea": "Canapea",
  "mobilier.canapea_colt": "Canapea de colț",
  "mobilier.fotoliu": "Fotoliu",
  "mobilier.scaun": "Scaun",
  "mobilier.taburet": "Taburet",
  "mobilier.pat": "Pat dublu",
  "mobilier.pat_o_persoana": "Pat o persoană",
  "mobilier.noptiera": "Noptieră",
  "mobilier.dulap": "Dulap",
  "mobilier.masa": "Masă",
  "mobilier.masa_scaune": "Masă cu scaune",
  "mobilier.masa_rotunda": "Masă rotundă",
  "mobilier.masuta_cafea": "Măsuță de cafea",
  "mobilier.masuta": "Măsuță",
  "mobilier.birou": "Birou",
  "mobilier.biblioteca": "Bibliotecă",
  "mobilier.raft": "Raft deschis",
  "mobilier.comoda_tv": "Comodă TV",
  "mobilier.tv": "Televizor",
  "mobilier.insula_bucatarie": "Insula bucatarie custom",
  "mobilier.insula_chiuveta": "Insula bucatarie cu chiuveta",
  "mobilier.corp_bucatarie": "Corp bucătărie",
  "mobilier.corp_sertare": "Corp cu sertare",
  "mobilier.corp_suspendat": "Corp suspendat",
  "mobilier.aragaz": "Aragaz",
  "mobilier.cuptor": "Cuptor",
  "mobilier.hota": "Hotă",
  "mobilier.frigider": "Frigider",
  "mobilier.chiuveta": "Chiuvetă",
  "mobilier.masina_vase": "Mașină de spălat vase",
  "mobilier.masina_spalat": "Mașină de spălat rufe",
  "mobilier.cada": "Cadă",
  "mobilier.cada_ovala": "Cadă ovală",
  "mobilier.dus": "Cabină de duș",
  "mobilier.dus_deschis": "Duș fără cabină",
  "mobilier.wc": "WC",
  "mobilier.wc_suspendat": "WC suspendat",
  "mobilier.lavoar": "Lavoar",
  "mobilier.lavoar_dublu": "Lavoar dublu",
  "mobilier.sezlong": "Șezlong",
  "mobilier.fotoliu_exterior": "Fotoliu de exterior",
  "mobilier.canapea_exterior": "Canapea de exterior",
  "mobilier.masa_exterior": "Masă de exterior",
  "mobilier.masuta_exterior": "Măsuță rotundă",
  "mobilier.umbrela": "Umbrelă",
  "mobilier.planta_terasa": "Plantă de terasă",
  "mobilier.wc_clasic": "WC (simbol de planșă)",
  "mobilier.aragaz_clasic": "Aragaz (simbol de planșă)",
  "mobilier.frigider_clasic": "Frigider (simbol de planșă)",
  "mobilier.masina_vase_clasic": "Mașină de spălat vase (simbol de planșă)",
  "mobilier.covor": "Covor",
  "mobilier.covor_rotund": "Covor rotund",
  "mobilier.veioza": "Veioză",
  "mobilier.planta": "Plantă",
  "mobilier.planta_mica": "Plantă mică",
  "aparat.priza": "Priză schuko",
  "aparat.priza_simpla": "Priză simplă",
  "aparat.priza_date": "Priză internet / date",
  "aparat.priza_dubla": "Priză dublă",
  "aparat.priza_blat": "Priză peste blat",
  "aparat.priza_forta": "Priză de forță",
  "aparat.priza_tv": "Priză TV",
  "aparat.intrerupator": "Întrerupător simplu",
  "aparat.intrerupator_dublu": "Întrerupător dublu",
  "aparat.comutator": "Întrerupător cap scară / cruce",
  "aparat.plafoniera": "Plafonieră",
  "aparat.spot": "Spot",
  "aparat.aplica": "Aplică",
  "aparat.tablou": "Tablou de apartament",
  "aparat.doza": "Doză",
  "circuit.lumina": "Iluminat",
  "circuit.prize": "Prize",
  "circuit.forta": "Forță",
  "circuit.date": "Curenți slabi",
  "categorie.sezut": "Șezut",
  "categorie.dormit": "Dormit",
  "categorie.mese": "Mese și depozitare",
  "categorie.bucatarie": "Bucătărie",
  "categorie.electrocasnice": "Electrocasnice",
  "categorie.sanitare": "Sanitare",
  "categorie.decor": "Iluminat și decor",
  "categorie.biblioteca": "Bibliotecă",
  "paleta.grup.camera": "Creare cameră",
  "paleta.grup.mobilare": "Mobilare",
  "paleta.grup.exterior": "Mobilare exterior",
  "paleta.fam.sezlong": "Șezlong",
  "paleta.fam.sezut_ext": "Fotolii și canapele de exterior",
  "paleta.fam.masa_ext": "Mese de exterior",
  "paleta.fam.umbrela": "Umbrelă și plante",
  "paleta.grup.electrocasnice": "Electrocasnice",
  "paleta.grup.goluri": "Uși și ferestre",
  "paleta.grup.sanitare": "Instalații sanitare",
  "paleta.grup.electrice": "Instalații electrice",
  "paleta.grup.structura": "Structură",
  "paleta.perete": "Perete drept",
  "paleta.camera": "Cameră",
  "paleta.camera_dreptunghi": "Cameră dreptunghi",
  "paleta.camera_l": "Cameră în L",
  "paleta.camera_t": "Cameră în T",
  "paleta.camera_libera": "Cameră liberă",
  "paleta.usa": "Ușă simplă",
  "paleta.usa_dubla": "Ușă dublă",
  "paleta.usa_glisanta": "Ușă glisantă",
  "paleta.fereastra": "Fereastră",
  "paleta.scara": "Scară dreaptă",
  "paleta.scara_u": "Scară în U",
  "paleta.scara_custom": "Scară custom",
  "paleta.scara_gata_dreapta": "Scară dreaptă",
  "paleta.scara_gata_dreapta_podest": "Dreaptă cu podest",
  "paleta.scara_gata_u": "În U",
  "paleta.scara_gata_u_doua": "U cu două podeste",
  "paleta.lift": "Lift",
  "paleta.ghena": "Ghenă",
  "paleta.parapet": "Parapet",
  "paleta.balcon": "Balcon",
  "paleta.fam.canapea": "Canapea",
  "paleta.fam.pat": "Pat",
  "paleta.fam.masa": "Masă",
  "paleta.fam.depozitare": "Dulap",
  "paleta.fam.bucatarie": "Bucătărie",
  "paleta.fam.decor": "Covoare și plante",
  "paleta.fam.insula": "Insula bucatarie custom",
  "paleta.fam.frigider": "Frigider",
  "paleta.fam.aragaz": "Aragaz",
  "paleta.fam.hota": "Hotă",
  "paleta.fam.masina": "Mașină de spălat",
  "paleta.fam.wc": "Vas WC",
  "paleta.fam.lavoar": "Lavoar",
  "paleta.fam.cada": "Cadă și duș",
  "paleta.fam.priza": "Priză",
  "paleta.fam.intrerupator": "Întrerupător",
  "paleta.fam.iluminat": "Corp de iluminat",
  "paleta.fam.tablou": "Tablou",
  "paleta.fam.doza": "Doză",
  "paleta.strange": "strânge",
  "paleta.strange_titlu": "Strânge paleta",
  "paleta.desfa_titlu": "Desfă paleta",
  "prop.electrice.titlu": "Instalație electrică",
  "prop.electrice.gol": "Nimic în camera asta. «Pune instalația» o trage după practica obișnuită, pornind de la mobila care e acum în ea.",
  "prop.electrice.alege": "Alege aparatul — mărimile lui apar mai jos",
  "prop.electrice.sterge": "Șterge aparatul",
  "prop.electrice.adauga": "Adaugă",
  "prop.electrice.pune": "Pune instalația camerei",
  "prop.electrice.pune_titlu": "Pune prizele, întrerupătorul și corpul de iluminat după regulile baghetei — numai în camera asta, restul modulului rămâne cum e",
  "prop.electrice.urmeaza": "urmează {piesa}",
  "prop.electrice.doza#n": "1 modul|{n} module|{n} de module",
  "prop.doza.sect": "Doză",
  "prop.doza.module": "{n} mod.",
  "prop.doza.adauga": "Adaugă",
  "prop.doza.scoate": "Scoate din doză",
  "prop.doza.total#n": "1 modul|{n} module|{n} de module",
  "editor.intoarceri.doza": "doza stă cum o așază zidul",
  "editor.intoarceri.simbol_pe_zid": "simbolul stă pe zid: nu se răstoarnă",
  "editor.intoarceri.priza_fara_mana": "o priză n-are mână: oglindită, e tot ea",
  "prop.doza.gol": "Doza e goală — adaugă prize sau întrerupătoare",
  "prop.doza.circuit_aparate": "După aparate",
  "prop.aparat.urmeaza": "Urmează",
  "prop.aparat.urmeaza_nota": "stă {parte} piesei și se mută odată cu ea",
  "prop.aparat.parte_stanga": "în stânga",
  "prop.aparat.parte_dreapta": "în dreapta",
  "prop.aparat.parte_spate": "în spatele",
  "prop.aparat.dezleaga": "Dezleagă",
  "prop.aparat.dezleaga_titlu": "Rămâne unde e, dar nu-l mai duce piesa",

  // --- finisajele, grupele de aparate și paleta modului Design ---
  "finisaj.parchet_standard": "Parchet standard",
  "finisaj.parchet_stejar": "Parchet stejar",
  "finisaj.parchet_nuc": "Parchet nuc",
  "finisaj.parchet_brad": "Parchet în brad",
  "finisaj.punte": "Punte lemn (exterior)",
  "finisaj.dale_mari": "Dale 60 × 60",
  "finisaj.marmura": "Marmură",
  "finisaj.gresie_baie": "Gresie 20 × 20",
  "finisaj.gresie_bucatarie": "Gresie 30 × 30",
  "finisaj.beton": "Beton șlefuit",
  "finisaj.mocheta": "Mochetă",
  "finisaj.vopsea_alba": "Vopsea albă",
  "finisaj.vopsea_calda": "Vopsea caldă",
  "finisaj.vopsea_gri": "Vopsea gri",
  "finisaj.vopsea_salvie": "Vopsea salvie",
  "finisaj.vopsea_indigo": "Vopsea indigo",
  "finisaj.faianta": "Faianță 20 × 20",
  "finisaj.faianta_mare": "Faianță 30 × 60",
  "finisaj.caramida": "Cărămidă aparentă",
  "finisaj.lambriu": "Lambriu lemn",
  "grupa.prize": "Prize",
  "grupa.comenzi": "Comenzi",
  "grupa.iluminat": "Iluminat",
  "grupa.tablou": "Tablou",
  "design.bagheta_mobilier": "Mobilează automat",
  "design.bagheta_mobilier_sub": "mobilierul, după felul fiecărei camere",
  "design.bagheta_mobilier_titlu": "Pune mobilierul după practica obișnuită de locuință — instalația de acum rămâne neatinsă",
  "design.bagheta_electric": "Instalație automată",
  "design.bagheta_electric_sub": "prize și întrerupătoare, lângă mobilierul de acum",
  "design.bagheta_electric_titlu": "Trage instalația peste mobilierul care e deja pus — mobilierul rămâne neatins",
  "editor.bagheta_intrebare_mobilier": "Modulul are deja {piese} piese de mobilier.\n\nOK — le înlocuiește cu mobilarea automată.\nAnulează — nu se schimbă nimic.",
  "editor.bagheta_intrebare_electric": "Modulul are deja {aparate} aparate electrice.\n\nOK — le înlocuiește cu instalația automată.\nAnulează — nu se schimbă nimic.",
  "design.bagheta": "Amenajează automat",
  "design.bagheta_sub": "mobilier și instalație, după felul fiecărei camere",
  "design.bagheta_titlu": "Mobilează și trage instalația după practica obișnuită de locuință — apoi mută ce nu-ți place",
  "design.selecteaza": "Selectează",
  "design.vopseste": "Vopsește",
  "design.mobilier": "Mobilier",
  "design.finisaje": "Finisaje",
  "design.electrice": "Electrice",
  "design.pardoseala": "Pardoseală",
  "design.pereti": "Pereți",
  "design.circuite": "Circuite",
  "design.la_placa": "la placă",
  "design.de_la_pardoseala": "{n} cm de la pardoseală",
  "design.sub_placa": "sub placă",
  "design.peste_pardoseala": "peste pardoseală",
  "design.modul_finisaj": "modul {n} cm",

  "prop.aparat.sect": "Aparat",
  "prop.aparat.fel": "Fel",
  "prop.aparat.inaltime": "Înălțime montaj",
  "prop.aparat.inaltime_placa": "urmează placa ({n} m)",
  "prop.aparat.inaltime_fel": "cota obișnuită a felului",
  "prop.aparat.cota_bifa": "Cota obișnuită a felului",
  "prop.aparat.rotire": "Rotire",
  "prop.aparat.rotire_nota": "se lipește de zid când e pus; Shift pe el îl întoarce",
  "prop.circuit.sect": "Circuit",
  "prop.circuit.pe": "Pe circuitul",
  "prop.circuit.conductor": "Conductor",
  "prop.circuit.firul": "Firul merge",
  "prop.circuit.firul_nota": "între ele, peretele rămâne fără fire — acolo se bate un cui",
  "prop.circuit.sus": "la 30 cm sub placă",
  "prop.circuit.jos": "la 30 cm peste pardoseală",
  // --- editorul de tronson · restul panoului de proprietăți --------------
  "prop.sect.marimi": "Mărimi",
  "prop.sect.atribute": "Atribute",
  "prop.sect.pozitie": "Poziție",
  "prop.sect.portanta": "Portanță",
  "prop.sect.piesa": "Piesă",
  "prop.sect.finisaje": "Finisaje",
  "prop.categorie": "Categoria",
  "prop.categorie_nota": "unde stă modulul în bară. Se poate schimba oricând — desenul rămâne cum e, se schimbă doar locul lui în ansamblu.",
  "prop.sect.modul": "Modul",
  "prop.sect.alcatuire": "Alcătuire",
  "prop.titlu.anvelopa": "Conturul tronsonului",
  "prop.titlu.nucleu": "Nucleu de scară și lift",
  "prop.titlu.usa": "Ușă",
  "prop.titlu.fereastra": "Fereastră",
  "prop.perete.structural": "Structural",
  "prop.perete.partition": "Compartimentare",
  "prop.perete.facade": "Fațadă",
  "prop.perete.fire": "Antifoc",
  "prop.perete.parapet": "Parapet",
  "prop.perete.parapet_sticla": "Parapet de sticlă",
  "prop.parte.scara": "Scară",
  "prop.parte.lift": "Puț de lift",
  "prop.parte.ghena": "Ghenă",
  "prop.parte.sas": "Sas",
  "prop.parte.boxe": "Boxe",
  "prop.parte.hol": "Hol",
  "prop.material.beton": "Beton armat",
  "prop.material.zidarie": "Zidărie",
  "prop.material.polistiren": "Polistiren",
  "prop.material.gips_carton": "Gips-carton (rigips)",
  "prop.material.sticla": "Sticlă",
  "prop.material.perete_cortina": "Perete cortină",
  "prop.brat": "Braț",
  "prop.brat_nota": "latura pătratului pe care îl ține colțul; amândouă brațele au aceeași măsură",
  "prop.crestatura": "Crestătură",
  "prop.crestatura_nota": "cât lipsește din pătrat, în colțul intrând",
  "prop.front": "Front",
  "prop.front_nota": "pasul la care începe modulul următor",
  "prop.banda": "Adâncime bandă",
  "prop.banda_nota": "comună întregului catalog (15,30 pe toate șapte); schimbată, modulul nu se mai leagă cu celelalte",
  "prop.colturi": "Colțuri",
  "prop.colturi_desenate": "contur tras de mână — forma e a poligonului, nu a cifrelor",
  "prop.colturi_deduse": "contur dedus din cifre; se scrie de la prima tragere",
  "prop.amprenta": "Amprentă",
  "prop.anvelopa_citire": "Conturul e DOAR FORMA pe care modulul o ține, și nimic dinăuntru nu se mișcă după el. Se trage de COLȚURI (pătratele albe) și de LATURI (barele albastre, perpendicular pe ele); dublu clic pe o bară taie latura în două, ca forma să poată căpăta laturi noi. Cifrele de mai sus se recitesc din poligon: frontul e întinderea lui pe x, fiindcă el e pasul la care începe modulul următor. Dacă după aceea ce e desenat nu mai umple forma, sau iese din ea, catalogul o spune la publicare: are o probă pentru acoperire și una pentru zidul de cusătură («front = ultima cameră + 0,30 m»).",
  "prop.latime": "Lățime",
  // «ADÂNCIME» A IEȘIT DIN VOCABULAR (01.10.2026, cerut de arhitect): un
  // obiect se descrie lungime × lățime × înălțime, nu adâncime. Cheia rămâne
  // ca un document mai vechi să n-o caute degeaba.
  "prop.adancime": "Lățime",
  "prop.arie": "Arie",
  "prop.arie_parte_nota": "cât ocupă în amprenta nucleului",
  "prop.fel": "Fel",
  "prop.parte_citire": "Catalogul cere ca bucata să stea în cutia nucleului și să nu se calce cu alta. Dacă iese, se spune la publicare.",
  "prop.muchie_nota": "camerele din jur urmează muchia",
  "prop.front_nucleu_nota": "cât ține nucleul din frontul modulului",
  "prop.scara_adancime": "Adâncimea scării",
  "prop.put_adancime": "Adâncimea puțului",
  "prop.zid_grosime": "Grosimea pereților lui",
  "prop.zid_grosime_nota": "cutia de beton din jurul treptelor și al puțurilor",
  "prop.lifturi": "Lifturi",
  "prop.um_buc": "buc",
  "prop.nucleu_citire": "Desenul scării se reface la salvare, din cifrele astea — ca ariile. Ce se vede acum e transcrierea de pe planșă.",
  "prop.nucleu_lipsa": "Modulul desenează un nucleu, dar nu-i declară măsurile (lipsește <b>core</b> din document).",
  "prop.grosime": "Grosime",
  "prop.lungime": "Lungime",
  "prop.lungime_nota": "se schimbă și trăgând de un capăt",
  "prop.unghi": "Unghi",
  "prop.unghi_nota": "0° e orizontal, 90° vertical",
  "prop.indreapta": "Îndreaptă peretele",
  "prop.indreapta_titlu": "Duce peretele la cel mai apropiat unghi drept, fără să-i schimbe lungimea sau mijlocul",
  "prop.pozitie_y": "Poziție Y",
  "prop.pozitie_x": "Poziție X",
  "prop.pozitie_nota": "fața dinspre care se măsoară; mută doar bucata asta",
  "prop.inaltime": "Înălțime",
  "prop.inaltime_piesa_nota": "înălțimea obișnuită a felului; scrisă, rămâne a piesei",
  "panza.scara_pas_cm": "contratreapta {cm} cm",
  "panza.scara_pas_rau": "contratreapta {cm} cm — prea departe de 14-19, mai scurtează rampele",
  "panza.scara_sens_sus": "rampa urcă în sus",
  "panza.scara_sens_jos": "rampa urcă în jos",
  "panza.scara_sens_stanga": "rampa urcă spre stânga",
  "panza.scara_sens_dreapta": "rampa urcă spre dreapta",
  "panza.scara_latura_sus": "rampa următoare — sus",
  "panza.scara_latura_jos": "rampa următoare — jos",
  "panza.scara_latura_stanga": "rampa următoare — la stânga",
  "panza.scara_latura_dreapta": "rampa următoare — la dreapta",
  "panza.scara_distanta": "depărtarea dintre rampe",
  "panza.scara_contratrepte": "{n} contratrepte puse",
  "panza.scara_ramase": "{n} rămase",
  "prop.sect.scara": "Scară",
  "prop.sect.ax": "Ax",
  "prop.ax_nume": "Nume",
  "prop.ax_lungime": "Lungime desenată",
  "prop.ax_lungime_nota": "numai aspectul: axa rămâne pe locul ei, cu aceiași pereți pe ea",
  "editor.redenumeste": "Redenumește",
  "editor.blocheaza_axele": "Blochează toate axele",
  "editor.deblocheaza_axele": "Deblochează toate axele",
  "editor.axele_blocate_nota": "Axele blocate nu se mai mută, nici trase, nici împinse din tastatură.",
  "prop.trage_latimea": "trage ca să lărgești sau să îngustezi panoul",
  "prop.axe_toate": "Axele",
  "prop.capete_libere": "Lasă capetele libere",
  "prop.capete_legate": "Leagă capetele la loc",
  "prop.capete_libere_nota": "La un capăt care iese în gol, conturul camerei se oprește cu 6 cm înainte de zid — acolo îmbinarea n-are ce închide. Butonul duce camera până în capăt. Îmbinările strânse rămân închise.",
  "prop.ax_blocat": "Blocare",
  "prop.ax_blocat_nota": "O axă blocată nu se mai mută — nici trasă, nici împinsă din tastatură. Mărimile de dedesubt sunt de aspect și rămân la îndemână.",
  "prop.ax_blocheaza": "Blochează",
  "prop.ax_deblocheaza": "Deblochează",
  "prop.ax_libera": "Întinderea",
  "prop.ax_libera_buton": "Cât o cer pereții",
  "prop.sect.scara_rampa": "Rampa aleasă",
  "prop.sect.scara_podest": "Podestul ales",
  "prop.scara_trepte": "Trepte",
  "prop.scara_adanc_treapta": "Lățimea/adâncimea treptei",
  "prop.scara_podest_lung": "Lungime",
  "prop.scara_podest_forma": "Forma",
  "prop.scara_podest_forma_nota": "desenată de mână, din punctele de pe planșă",
  "prop.scara_podest_dreptunghi": "Înapoi la dreptunghi",
  "prop.scara_podest_lat": "Lățime",
  "prop.scara_podest_lung_nota": "de la o rampă la alta — mută rampa a doua",
  "prop.scara_rampa_lat": "Lățimea rampei",
  "prop.scara_rampa_lat_nota": "a toată scara; mută și podestul",
  "prop.scara_lungime": "Lungimea desfășurată",
  "prop.scara_lungime_interval": "Pe nivelul de {h} m: {min}–{max} m",
  "prop.scara_lat_totala": "Lățimea totală",
  "prop.scara_lung_totala": "Lungimea totală",
  "prop.scara_lung_totala_nota": "rampele le dă nivelul; diferența intră în podest, cel puțin cât lățimea rampei",
  "prop.scara_lung_totala_fixa": "podest desenat de mână: adu-l la dreptunghi din panoul lui",
  "prop.scara_lat_totala_nota": "mută ultima rampă; diferența intră în podestul dinaintea ei",
  "prop.scara_adauga_podest": "Adaugă podest",
  "prop.inaltime_scara_nota": "Urmează înălțimea nivelului. Se schimbă din panoul modulului",
  "prop.scara_adanc_podest": "Adâncimea podestului",
  "prop.scara_pas_m": "Înălțimea contratreptei",
  "prop.scara_pas_nota": "a toată scara; lipsă = nivelul împărțit la trepte",
  "prop.scara_trepte_nota": "lungimea rampei iese din ele",
  "prop.scara_rezultat": "Rezultatul scării",
  "prop.scara_contratrepte_nota": "ies din lungimea rampelor; scrise, le întind",
  "prop.scara_pas_derivat": "nivelul împărțit la trepte",
  "prop.scara_ia_pasul": "Ia pasul nivelului",
  "prop.scara_contratrepte": "Contratrepte",
  "prop.scara_pas": "Înălțimea contratreptei",
  "prop.scara_treapta": "Lățimea treptei",
  "prop.scara_rampe": "Pe rampe",
  "prop.scara_nota": "ies din înălțimea nivelului, nu din cutia trasă",
  "scara.eroare.pas": "Contratreapta de {h} cm este în afara intervalului 16,6–17,5 cm (R07).",
  "scara.eroare.blondel": "2h + l = {b} cm este în afara intervalului 62–64 cm (formula lui Blondel).",
  "scara.eroare.treapta": "Treapta de {l} cm este în afara intervalului de confort 28–30 cm.",
  "scara.eroare.lungime": "Lungimea de {L} m este în afara intervalului {min}–{max} m al nivelului de {h} m (R07, formula lui Blondel).",
  "scara.eroare.trepte": "O rampă are {n} contratrepte. Regula cere între 3 și 16 (R14, R15).",
  "scara.eroare.lat": "Lățimea rampei, {w} m, este sub 1,25 m, minimul scării principale la 9 sau mai multe niveluri (R20).",
  "scara.eroare.podest": "Podestul, de {p} m, este mai îngust decât rampa (NP 063, art. 2.2.1.3.c).",
  "scara.eroare.ochi": "Între rampe rămân {g} cm. Regula cere cel puțin 20 cm (F39).",
  "prop.inaltime_nivel_nota": "urmează nivelul ({n} m)",
  "prop.pana_la_placa": "Până la placă",
  "prop.perete_curbat": "Perete curbat",
  "prop.curbura": "Curbură",
  "prop.curbura_drept": "drept — 1 = semicerc",
  "prop.curbura_raza": "rază ≈ {n} m",
  "editor.intoarce_peretele": "Întoarce sensul",
  "prop.straturi.intoarce": "Întoarce sensul peretelui",
  "prop.straturi.intoarce_titlu": "schimbă capătul de început cu cel de sfârșit: straturile trec de partea cealaltă",
  "prop.sect.straturi": "Straturi",
  "prop.straturi.nota": "de la stânga la dreapta, mergând de la capătul de început al peretelui spre cel de sfârșit",
  "prop.straturi.gol": "Perete omogen, dintr-un singur material. Primul strat adăugat păstrează corpul de acum și pune unul nou lângă el.",
  "prop.straturi.adauga_stanga": "Adaugă la stânga",
  "prop.straturi.adauga_dreapta": "Adaugă strat",
  "prop.straturi.adauga_titlu": "un strat nou, lipit de fața din dreapta a peretelui",
  "prop.straturi.adauga_stanga_titlu": "un strat nou, lipit de fața din stânga a peretelui",
  "prop.straturi.total": "Total {n} m, din {c} straturi",
  "prop.straturi.mai_la_stanga": "mai la stânga",
  "prop.straturi.mai_la_dreapta": "mai la dreapta",
  "prop.straturi.sterge": "scoate stratul",
  "prop.straturi.fara_ax": "Peretele n-are ax scris, deci nu se știe unde îi e stânga. Trage o dată de el și straturile devin cu putință.",
  "prop.grosime_din_straturi": "suma straturilor",
  "strat.grupa.structura": "Structură și zidărie",
  "strat.grupa.izolatii": "Izolații",
  "strat.grupa.finisaje": "Finisaje",
  "strat.grupa.bariere": "Folii și bariere",
  "strat.beton": "Beton armat",
  "strat.caramida": "Zidărie de cărămidă",
  "strat.bca": "Zidărie BCA",
  "strat.vata_minerala": "Vată minerală",
  "strat.polistiren": "Polistiren (EPS/XPS)",
  "strat.gol_aer": "Strat de aer",
  "strat.tencuiala": "Tencuială",
  "strat.gips_carton": "Gips-carton",
  "strat.placaj": "Placaj ceramic",
  "strat.lemn": "Lemn",
  "strat.hidroizolatie": "Hidroizolație",
  "strat.bariera_vapori": "Barieră de vapori",
  "prop.tip_perete": "Tip perete",
  "prop.material": "Material",
  "prop.neportant": "Neportant",
  "prop.neportant_nota": "nu duce încărcare la fundație",
  "prop.portant": "Portant",
  "prop.portant_nota": "beton armat — coboară în subsol",
  "prop.pe_fatada": "Pe fațadă",
  "prop.inchide_nucleul": "Închide nucleul",
  "prop.da": "da",
  "prop.nu": "nu",
  "prop.parapet": "Parapet",
  "prop.pe_peretele": "Pe peretele",
  "prop.pe_peretele_nota": "se mută trăgând de gol pe desen",
  "prop.rotire": "Rotire",
  "prop.piesa.teanc": "Teanc",
  "prop.piesa.teanc_nota": "Cine se vede peste cine, când două piese se suprapun.",
  "prop.piesa.in_fata": "Adu în față",
  "prop.piesa.in_spate": "Trimite în spate",
  "prop.piesa.ansamblu": "Ansamblu",
  "prop.piesa.ansamblu_nota": "Piesa se mută împreună cu celelalte din ansamblu.",
  "prop.piesa.separa": "Separă elemente",
  "editor.lipire.roteste": "Rotește",
  "editor.lipire.oglinda_h": "Oglindă ↔",
  "editor.lipire.oglinda_v": "Oglindă ↕",
  "editor.lipire.pune": "clic ca s-o pui · Esc renunță",
  "editor.unealta.demoleaza": "Sparge zid",
  "editor.sfat.demoleaza": "Apasă pe un perete și trage de-a lungul lui: bucata trasă se dărâmă, iar ce rămâne devin ziduri de sine stătătoare.",
  "editor.incadreaza": "Înapoi la tot modulul",
  "editor.uneste_elementele": "Unește elemente",
  "prop.oglindire": "Oglindire",
  "prop.oglindire_nota": "pe axa piesei, după rotire (H / V)",
  "prop.oglindeste_h": "Oglindește stânga-dreapta (H)",
  "prop.oglindeste_v": "Oglindește față-spate (V)",
  "prop.arie_nota": "se recalculează la salvare, pe server",
  "prop.latura": "Latura",
  "prop.pardoseala": "Pardoseală",
  "prop.pereti": "Pereți",
  "prop.implicit_felului": "implicitul felului",
  "prop.modul_pardoselii": "Modulul pardoselii",
  "prop.fara_rost": "fără rost",
  "prop.front_nominal": "Front nominal",
  "prop.front_nominal_nota": "se schimbă din întinderea modulului",
  "prop.nucleu": "Nucleu",
  "prop.nucleu_are": "are nucleu",
  "prop.nucleu_adauga": "Adaugă nucleu",
  "prop.nucleu_nota": "scara, lifturile și ghena prin care urcă oamenii — se pune o dată pe tronsonul care le duce",
  "prop.nucleu_sterge_nota": "se șterge alegându-l pe desen și apăsând «Șterge»",
  "prop.inaltime_nivel": "Înălțime nivel",
  "prop.inaltime_nivel_implicit": "implicitul oricărui perete care nu-și declară alta",
  "prop.camere": "Camere",
  "prop.goluri": "Goluri",
  "prop.piese_mobilier": "Piese mobilier",
  "prop.aparate_electrice": "Aparate electrice",
  "prop.fara_tablou": "niciun tablou — firele pleacă de la el, deci traseele nu se pot desena; «amenajează automat» pune unul",
  // --- editorul de tronson · cifrele și apucătoarele de pe pânză ----------
  "panza.cam_libera_sub": "{n} colțuri · apasă pe primul ca să închizi",
  "panza.balcon_prins": "{arie} m² · lipit de fațadă, restul cu parapet",
  "panza.balcon_departe": "prea departe de clădire — trage-l lângă o fațadă",
  "panza.gol_in_beton": "perete de beton — nu se taie gol aici",
  "panza.latura_cealalta": "{n} m pe cealaltă",
  "panza.spartura_sub": "spărtură",
  "panza.ax_sterge": "Scoate axa {nume} din trasare (zidurile rămân)",
  "panza.ax_adauga": "Adaugă axă pe peretele ăsta",
  "panza.ax_scurteaza": "trage ca să scurtezi sau să lungești axa — numai desenul, nu și poziția ei",
  "panza.ax_titlu": "axul {nume} — trage ca să muți toți cei {n} pereți de pe linia lui",
  "panza.trage_grosimea": "trage ca să schimbi grosimea",
  "panza.podest_adauga": "adaugă un punct pe muchia podestului",
  "panza.podest_trage": "trage punctul; se lipește de colțul rampei. Alt-clic îl scoate",
  "panza.trage_capatul": "trage capătul oriunde: zidul se rotește și se lungește după el",
  "panza.trage_curbura": "trage ca să curbezi peretele",
  "panza.trage_latimea": "trage ca să schimbi lățimea ferestrei, din 5 în 5 cm — celălalt capăt rămâne pe loc",
  "panza.trage_marimea": "trage ca să schimbi mărimea piesei, din 5 în 5 cm — muchia opusă rămâne pe loc",
  "panza.trage_coltul": "trage colțul oriunde în plan",
  "panza.trage_parte": "trage colțul ca să croiești partea; cutia nucleului o urmează",
  "panza.departeaza": "Depărtează",
  "panza.apropie": "Apropie",
  "panza.incadreaza": "Încadrează (0)",
  "panza.reper_xy": "Direcțiile planșei: X spre dreapta, Y în jos",
  "auto.sarit_mica": "{arie} m² — nu încape nimic din catalog",
  "auto.sarit_fara_retea": "felul camerei n-are încă o mobilare scrisă",
  // --- tronsonul, panoul care doar CITEȘTE (colecția) ---------------------
  "citire.parametri": "Parametri",
  "citire.inaltime_urmeaza": "urmează înălțimea nivelului",
  "citire.inaltime_declarata": "declarată — nivelul e {n} m",
  "citire.portant": "Portant",
  "citire.portant_da": "Da — duce încărcarea la fundație",
  "citire.portant_nu": "Nu",
  "citire.apartament": "Apartament",
  "citire.front_minim": "Front minim",
  "citire.front_rigid": "modul rigid — nu se întinde",
  "citire.front_maxim": "Front maxim",
  "citire.implicit": "implicit",
  "citire.nucleu": "Nucleu",
  "citire.nucleu_lifturi#n": "scară + un lift|scară + {n} lifturi|scară + {n} de lifturi",
  "citire.se_citeste": "Se citește. Editarea vine odată cu calea de scriere: o schimbare recalculează ariile și vederea derivată, apoi trece prin probele catalogului.",
  "citire.apasa": "Apasă pe un perete, pe o cameră sau pe un gol ca să-i vezi parametrii.",
  // --- ARHITECTURĂ · vocabularul canonic: numele fiecărui fel -------------
  // Cheile sunt felurile din `viewer/generated/kinds.ts`. Tabelul generat
  // rămâne plasa — un fel adăugat în catalogul canonic și neajuns încă aici se
  // vede pe ecran cu eticheta lui românească, nu cu o cheie crudă.
  "kind.ada": "Loc de parcare adaptat",
  "kind.ada_aisle": "Spațiu de transfer ADA",
  "kind.cat_ladder": "Scară de pisică",
  "kind.aisle": "Alee carosabilă",
  "kind.apron": "Platformă de acces",
  "kind.axis": "Ax structural",
  "kind.balcony": "Balcon",
  "kind.bar": "Segment de bară",
  "kind.basement": "Parcaj subteran",
  "kind.bath": "Baie",
  "kind.bath2": "Baie 2",
  "kind.bazin": "Bazin retenție",
  "kind.bedroom": "Dormitor",
  "kind.boxe": "Boxe",
  "kind.buildable": "Zonă edificabilă",
  "kind.building": "Corp",
  "kind.cantilever": "Placă în consolă",
  "kind.offset": "Placă la altă cotă",
  "kind.steps": "Trepte",
  "kind.platform": "Platformă elevatoare",
  "kind.column": "Stâlp / lamelă",
  "kind.core": "Nucleu",
  "kind.courtyard": "Curte interioară",
  "kind.diggable": "Zonă excavabilă",
  "kind.door": "Ușă",
  "kind.easement": "Servitute / zonă de protecție",
  "kind.ecs": "ECS",
  "kind.entrance": "Acces clădire",
  "kind.ev": "Loc de parcare electric",
  "fatada.titlu": "Fațada",
  "fatada.insp.titlu": "Inspirație",
  "fatada.insp.imaginea": "Imaginea {nr}",
  "fatada.insp.fara_dorinte": "Descrierea din temă nu spune nimic anume despre imaginea asta; agentul a luat din ea ce se potrivea cu celelalte.",
  "fatada.insp.poza_scoasa": "Fotografia «{nume}» nu mai e în temă.",
  "fatada.insp.scoasa": "Imaginea a fost scoasă din catalog.",
  "fatada.insp.inchide": "Închide",
  "fatada.insp.soarta.kept": "luat",
  "fatada.insp.soarta.adapted": "adaptat",
  "fatada.insp.soarta.impossible": "nu se poate",
  "fatada.reguli": "reguli",
  "fatada.desfa": "Desfă",
  "fatada.strange": "Strânge",
  "fatada.porneste_de_la": "Pornește de la…",
  "fatada.aplica_json": "Aplică JSON-ul",
  "fatada.json_stricat": "JSON-ul nu se poate citi sau n-are `rules`.",
  "fatada.suprafata": "Suprafața",
  "fatada.etaje": "Etajele: all, ground, upper, top, 0-5 sau 1,3,5",
  "fatada.portiune": "porțiune (u)",
  "fatada.portiune_ex": "Porțiunea de față, cu ancore: bay[1].start → bay[1].end",
  "fatada.sus": "Mai sus (se aplică mai devreme)",
  "fatada.jos": "Mai jos (câștigă)",
  "fatada.sterge": "Șterge regula",
  "fatada.placi_colorate": "plăci în altă culoare",
  "fatada.placi_lista": "Plăci de fațadă (pe culoare și format)",
  "fatada.placi_material": "Material și culoare",
  "fatada.placi_format": "Format",
  "fatada.placi_buc": "Bucăți",
  "fatada.placi_din_care": "din care, debitate la",
  "fatada.placi_inca": "încă {n} dimensiuni ({buc} plăci)",
  "fatada.placi_mai_putine": "arată mai puține",
  "fatada.material": "Materialul (cheia de cost)",
  "fatada.culoare": "Culoarea",
  "fatada.la": "Ancora pe verticală",
  "fatada.sectiune": "Secțiunea",
  "fatada.finisaj": "finisaj",
  "fatada.brau": "brâu",
  "fatada.balustrada": "balustradă",
  "fatada.fereastra": "fereastră",
  "fatada.tamplarie": "tâmplărie",
  "fatada.profil": "profil",
  "fatada.vitraj": "Vitrajul",
  "fatada.vitraj.single": "simplu",
  "fatada.vitraj.double": "dublu",
  "fatada.vitraj.triple": "triplu",
  "fatada.deschidere": "Deschiderea",
  "fatada.deschidere.fixed": "fix",
  "fatada.deschidere.casement": "batant",
  "fatada.deschidere.tilt_turn": "oscilobatant",
  "fatada.deschidere.sliding": "culisant",
  "fatada.canat": "canat",
  "fatada.canate": "canate",
  "fatada.rama": "ramă",
  "fatada.glaf": "glaf",
  "fatada.glaf_expl": "Glaful exterior, ca panou de fațadă legat de fereastră (ml, m³)",
  "fatada.fara_glaf": "fără glaf",
  "fatada.spalet": "șpalet",
  "fatada.spalet_expl": "Întoarcerea termosistemului în golul ferestrei (perimetru × adâncime)",
  "fatada.cantitati": "Cantități (m², ml, m³)",
  "fatada.previzualizeaza": "Previzualizează",
  "fatada.se_previzualizeaza": "Se reface fațada…",
  "fatada.previzualizat": "Fațada e în machetă ({s} s). Nu s-a salvat nimic.",
  "fatada.salveaza": "Salvează",
  "fatada.se_salveaza": "Se scrie pe soluție…",
  "fatada.salveaza_expl": "Scrie regulile pe soluția deschisă (numai pe ea). Se poate anula cât stai pe proiect.",
  "fatada.salvat": "Fațada e scrisă pe soluția deschisă.",
  "fatada.anuleaza": "Anulează",
  "fatada.se_anuleaza": "Se pune la loc…",
  "fatada.anuleaza_expl": "Pune la loc fațada de dinaintea ultimei schimbări.",
  "fatada.anulat": "Fațada de dinainte e la loc.",
  "fatada.reface": "Refă",
  "fatada.se_reface": "Se reface…",
  "fatada.reface_expl": "Pune înapoi schimbarea tocmai anulată.",
  "fatada.refacut": "Schimbarea e din nou pe fațadă.",
  "fatada.discutie_asteapta": "Se scrie fațada pe soluție — discuția așteaptă câteva clipe.",
  "fatada.calcat": "Fațada s-a schimbat între timp pe soluție; am recitit-o, nu s-a scris nimic.",
  "fatada.pas_panou": "regulile din panou",
  "fatada.regenereaza": "Regenerează arhitectura",
  "fatada.se_porneste": "Se pornește…",
  "fatada.regenereaza_expl": "Pornește o arhitectură nouă din planul de situație, cu stilul proiectului (minute).",
  "fatada.job_pornit": "Arhitectura se regenerează; urmărește-o pe board.",
  "fatada.fara_arh": "Nu e nicio arhitectură pe care să se previzualizeze.",
  "fatada.asistent": "Asistent fațadă",
  "fatada.surf.facade": "fața",
  "fatada.surf.plinth": "soclul",
  "fatada.surf.recess": "logiile",
  "fatada.surf.parapet": "aticul",
  "fatada.surf.soffit": "intradosul",
  "fatada.surf.balcony": "balcoanele",
  "fatada.surf.terrace": "pardoseala teraselor",
  "fatada.surf.loggia": "logiile (pardoseala, balustrada)",
  "fatada.pardoseala": "pardoseală",
  "fatada.pardoseala.tiles": "gresie lipită",
  "fatada.pardoseala.raised": "dale pe ploturi",
  "fatada.pardoseala.deck": "deck",
  "fatada.ancora.slab": "la planșeu",
  "fatada.ancora.floor": "la pardoseală",
  "fatada.ancora.opening.top": "la buiandrug",
  "fatada.ancora.opening.bottom": "la parapet",
  "fatada.ancora.mid": "la mijloc",
  "fatada.sectiune.rect": "dreptunghi",
  "fatada.sectiune.cornice": "cornișă",
  "fatada.sectiune.slope": "pantă",
  "fatada.sectiune.half_round": "semirotund",
  "kind.terasa_circulabila": "Terasă circulabilă",
  "kind.facade": "Perete de fațadă",
  "kind.band": "Brâu în relief",
  "kind.brick": "Cărămidă aparentă",
  "kind.cladding": "Placaj",
  "kind.glazing": "Vitraj (perete-cortină)",
  "kind.curtain_wall": "Perete cortină",
  "kind.glass": "Balustradă sticlă",
  "kind.insulation": "Termoizolație",
  "kind.plaster": "Tencuială decorativă",
  "kind.render": "Tencuială de bază",
  "kind.sill": "Glaf",
  "kind.flooring": "Pardoseală exterioară",
  "kind.slats": "Balustradă lamele",
  "kind.solid": "Balustradă plină",
  "kind.planter": "Jardinieră",
  "kind.subframe": "Substructură fațadă ventilată",
  "kind.screen": "Ecran fix",
  "kind.fdcp": "FDCP",
  "kind.fire": "Perete antifoc",
  "kind.fire_door": "Ușă rezistentă la foc",
  "kind.shelter_door": "Ușă metalică etanșă de protecție",
  "kind.fire_spur": "Acces pompieri",
  "kind.flat": "Apartament",
  "kind.floor": "Placă de planșeu",
  "kind.foundation": "Grindă de fundare",
  "kind.frame": "Grindă de cadru",
  "kind.ghena": "Ghenă / tablou",
  "kind.gospodarie": "Gospodărie apă",
  "kind.green_deep": "Spațiu verde pe sol",
  "kind.green_slab": "Spațiu verde pe placă",
  "kind.hall": "Hol",
  "kind.hol": "Hol distribuție",
  "kind.administrativ": "Spațiu administrativ",
  "kind.kitchen": "Bucătărie",
  "kind.lane": "Alee de circulație",
  "kind.lift": "Ascensor",
  "kind.lintel": "Buiandrug",
  "kind.living": "Camera de zi",
  "kind.loop": "Inel carosabil",
  "kind.neighbour": "Latură la vecin",
  "kind.on_grade": "Placă pe sol",
  "kind.open": "Latură liberă",
  "kind.pad": "Fundație izolată",
  "kind.parapet": "Parapet",
  "kind.partition": "Compartimentare",
  "kind.party": "Perete despărțitor",
  "kind.path": "Alee pietonală",
  "kind.ramp": "Rampă",
  "kind.ramp_access": "Rampă acces parcaj subteran",
  "kind.road": "Drum",
  "kind.room": "Cameră",
  "kind.sas": "SAS",
  "kind.coridor_evacuare": "Coridor de evacuare",
  "kind.casa_scarii_evacuare": "Casă de scară de evacuare",
  "kind.scara": "Casă de scară",
  "kind.shower": "Duș",
  "kind.sidewalk": "Trotuar",
  "kind.site": "Plan de situație",
  "kind.slab_panel": "Ochi de placă",
  "kind.spine": "Drum principal",
  "kind.std": "Loc de parcare",
  "kind.store": "Debara",
  "kind.office": "Birou",
  "kind.dressing": "Dressing",
  "kind.pantry": "Cămară",
  "kind.terasa": "Terasă",
  "kind.tech": "Spațiu tehnic",
  "kind.garage": "Garaj",
  "kind.ala": "Adăpost ALA",
  "kind.ala_sas": "SAS adăpost",
  "kind.ala_gs": "Grup sanitar adăpost",
  "kind.ala_iesire": "Ieșire de salvare adăpost",
  "kind.ala_perete": "Perete adăpost ALA",
  "kind.street": "Latură la stradă",
  "kind.strip": "Fundație continuă",
  "kind.structural": "Perete structural",
  "kind.te": "TE",
  "kind.desfumare": "Zonă de desfumare",
  "kind.te_desfumare": "TE desfumare",
  "kind.tie": "Grindă de legătură",
  "kind.transfer": "Grindă de transfer",
  "kind.tree": "Arbore",
  "kind.tronson": "Tronson",
  "kind.turning_head": "Platformă de întoarcere",
  "kind.wc": "WC serviciu",
  "kind.window": "Fereastră",
  "kind.hatch": "Oblon metalic etanș",
  "kind.access": "Acces pe limita terenului",
  "kind.crossing": "Trecere de pietoni",
  "kind.playground": "Loc de joacă",
  "kind.square": "Piațetă",
  "kind.waste_platform": "Platformă de gunoi",
  "nivel.apartment": "Etaj curent",
  "nivel.basement_storey": "Subsol",
  "nivel.ground": "Parter",
  "nivel.parking": "Subsol parcare",
  "nivel.roof": "Terasă",
  // --- ARHITECTURĂ · inspectorul: ce E obiectul pe care ai apăsat ---------
  "insp.nedeclarat": "nedeclarat",
  "insp.grup.identitate": "Identitate",
  "insp.grup.forma": "Formă",
  "insp.grup.coordonate": "Coordonate",
  "insp.grup.evacuare": "Evacuare",
  "insp.grup.retrageri": "Retrageri",
  "insp.grup.geometrie": "Geometrie",
  "insp.rand.arie": "Arie",
  "insp.rand.gabarit": "Gabarit",
  "insp.rand.colturi": "Colțuri",
  "insp.rand.orientare": "Orientare",
  "insp.rand.centru": "Centru",
  "insp.rand.dimensiuni": "Dimensiuni",
  "insp.rand.sectiune": "Secțiune",
  "insp.rand.tip": "Tip",
  "insp.rand.denumire": "Denumire",
  "insp.rand.lungime": "Lungime",
  "insp.rand.latime": "Lățime",
  "insp.rand.inaltime": "Înălțime",
  "insp.rand.grosime": "Grosime",
  "insp.rand.rezistenta_foc": "Rezistență la foc",
  "insp.rand.cod": "Cod în planșă",
  "insp.rand.lungime_axa": "Lungime axă",
  "insp.rand.numar": "Număr",
  "insp.rand.sus": "Sus",
  "insp.rand.jos": "Jos",
  "insp.rand.de_la": "De la",
  "insp.rand.pana_la": "Până la",
  "insp.rand.usa": "Ușa",
  "insp.rand.nucleu": "Nucleu",
  "insp.rand.nucleu_centru": "centru {xy}",
  "insp.rand.arie_declarata": "Arie declarată",
  "insp.rand.arie_geometrica": "Arie geometrică",
  "insp.rand.lungime_desfasurata": "Lungime desfășurată",
  "insp.rand.utila": "Suprafață utilă",
  "insp.rand.minim_legal": "Minim legal",
  "insp.rand.front": "Front la fațadă",
  "insp.rand.balcon_separat": "Balcon (separat)",
  "insp.rand.camere_desenate": "Camere desenate",
  "insp.rand.camere_locuibile": "Camere locuibile",
  "insp.rand.in_locuinta": "În locuința",
  "insp.rand.al_locuintei": "Al locuinței",
  "insp.rand.ap_pe_nivel": "Apartamente pe nivel",
  "insp.rand.nuclee": "Nuclee",
  "insp.rand.utila_nivel": "Suprafață utilă / nivel",
  "insp.rand.amprenta": "Amprentă",
  "insp.rand.regim": "Regim de înălțime",
  "insp.rand.cornisa": "Înălțime la cornișă",
  "insp.rand.urbanism": "Urbanism",
  "insp.rand.incendiu": "Incendiu",
  "insp.rand.guverneaza": "Guvernează",
  "insp.rand.aliniere": "Aliniere",
  "insp.forma.dreptunghi": " (dreptunghi)",
  "insp.forma.l": " (formă în L)",
  "insp.evac.punct": "Punctul care a cerut-o",
  "insp.evac.fara_scara": "Fără scara asta",
  "insp.evac.niciun_traseu": "niciun traseu",
  "insp.evac.cu_ea": "Cu ea",
  "insp.evac.limita": "Limita normată",
  "insp.evac.toleranta": "Toleranța măsurării",
  "insp.grup.ala": "Adăpost ALA",
  "insp.ala.adapost": "Adăpost",
  "insp.ala.persoane": "Persoane",
  "insp.ala.cladire": "Sub clădirea",
  "insp.ala.adapostire": "Suprafață de adăpostire",
  "insp.ala.necesar": "necesar",
  "insp.ala.calcul": "Calculul necesarului",
  "insp.ala.h": "Înălțime luată în calcul",
  "insp.ala.pe_persoana": "Arie pe persoană",
  "insp.ala.leaga_volum": "leagă volumul",
  "insp.ala.leaga_arie": "leagă aria",
  "insp.ala.tinta": "Ținta unui adăpost plin",
  "insp.ala.arie": "Arie cu SAS și grup sanitar",
  "insp.ala.bucata": "Bucata clădirii",
  "insp.ala.sas": "SAS",
  "insp.ala.grup_sanitar": "Grup sanitar",
  "insp.ala.cabine": "Cabine WC",
  "insp.ala.lavoare": "Lavoare",
  "insp.ala.iesire": "Ieșirea",
  "insp.ala.locuri": "Locuri de parcare luate",
  "insp.ala.neconcordanta": "Neconcordanță",
  "insp.ala.rol": "Rol",
  "insp.ala.gol": "Golul",
  "insp.ala.perete": "Perete",
  "insp.ala.beton_etans": "beton armat, etanș",
  "insp.evac.traseu_sas": "Traseu până la sas",
  "insp.evac.limita_scurt": "Limită",
  "insp.evac.doua_directii": "{n} m (două direcții)",
  "insp.familie.wall": "Perete",
  "insp.familie.opening": "Gol",
  "insp.familie.space": "Spațiu",
  "insp.familie.slab": "Placă",
  "insp.familie.column": "Stâlp",
  "insp.familie.beam": "Grindă",
  "insp.familie.ladder": "Scară",
  "insp.familie.flat": "Apartament",
  "insp.familie.core": "Nucleu",
  "insp.nivel.situatie": "Plan de situație",
  "insp.nivel.parter": "Parter",
  "insp.nivel.subsol": "Nivel {n}",
  "insp.nivel.etaj": "Etaj {n}",
  "insp.chip.nivel_intreg": "nivel întreg",
  "insp.chip.nivel": "nivel {n}",
  "insp.chip.etaj": "etaj {n}",
  "insp.chip.la_sol": "la sol",
  "insp.chip.dizabilitati": "persoane cu dizabilități",
  "insp.chip.nu_se_parcheaza": "nu se parchează",
  "insp.chip.sub_perete": "sub perete de clădire",
  "insp.chip.modul_parcare": "modul de parcare",
  "insp.chip.pe_traversare": "pe traversarea aleii",
  "insp.chip.intoarsa": "întoarsă după casa scării",
  "insp.chip.persoane": "{n} persoane",
  "insp.chip.comuna_parcaj": "comună cu parcajul",
  "insp.chip.proprie": "proprie",
  "insp.chip.situatie": "plan de situație",
  "insp.chip.limita_parcela": "limită de parcelă",
  "insp.chip.spre_strada": "spre stradă",
  "insp.chip.spre_vecin": "spre vecin",
  "insp.chip.retragere_presupusa": "retragere presupusă",
  "insp.titlu.loc_adaptat": "Loc adaptat",
  "insp.titlu.loc_parcare": "Loc de parcare",
  "insp.titlu.fasie_ada": "Fâșie de acces adaptată",
  "insp.titlu.lamela": "Lamelă structurală",
  "insp.titlu.alee": "Alee",
  "insp.rand.eticheta": "Piesa",
  "insp.rand.fel": "Fel",
  "insp.rand.nota": "Nota pasului",
  "insp.rand.sens": "Sens",
  "insp.sens.dublu": "dublu",
  "insp.sens.unic": "unic",
  "insp.chip.dublu_sens": "dublu sens",
  "insp.chip.sens_unic": "sens unic",
  "insp.titlu.stalp": "Stâlp",
  "insp.titlu.perete_antifoc": "Perete antifoc",
  "insp.titlu.usa_antifoc": "Ușă antifoc",
  "insp.titlu.rampa": "Rampă între niveluri",
  "insp.titlu.balcon": "Balcon",
  "insp.titlu.tronson": "Tronson",
  "insp.titlu.coridor": "Coridor comun",
  "insp.titlu.cladire": "Clădirea {id}",
  "insp.titlu.corp": "Corp de clădire",
  "insp.titlu.acces": "Acces clădire",
  "insp.titlu.scara_evacuare": "Scară de evacuare a parcajului",
  "insp.titlu.trotuar": "Trotuar",
  "insp.titlu.trecere": "Trecere de pietoni",
  "insp.titlu.zona": "Zonă exterioară",
  "insp.fel.trotuar": "trotuar",
  "insp.fel.trecere": "trecere de pietoni",
  "insp.fel.zona": "zonă",
  "insp.rand.id_agent": "Id-ul agentului",
  "insp.rand.alee_traversata": "Aleea traversată",
  "insp.rand.niveluri": "Niveluri deservite",
  "insp.rand.tipar": "Tipar",
  "insp.rand.rezistenta": "Rezistență la foc",
  "insp.rand.persoane": "Persoane · fluxuri × lățime",
  "insp.rand.zona_libera": "Zonă fără parcare la sol",
  "insp.titlu.latura": "Latura {n}",
  "insp.stall.adaptat": "adaptat ({w} × {d} m + fâșie 1,50 m)",
  "insp.stall.standard": "standard",
  "insp.stall.dimensiuni": "{w} × {d} m",
  "insp.flat.tip": "{camere} camere / {persoane} persoane",
  "insp.flat.toate_pe_fatada": "{n} — toate pe fațadă",
  "insp.flat.utili": "{eticheta} — {arie}",
  "insp.flat.utili_um": "{eticheta} — {arie} utili",
  "insp.gov.urbanism": "urbanism",
  "insp.gov.incendiu": "incendiu",
  // --- ARHITECTURĂ · normele citate de inspector --------------------------
  // `norm` (indicativul) NU se traduce: e numele actului, iar cine îl caută îl
  // caută așa cum e scris. Se traduce ce cere el, și cât.
  "norma.stall.size": "Loc de parcare autoturism, dimensiuni minime",
  "norma.aisle.width": "Alee de circulație pentru parcare la 90°: dublu sens / sens unic",
  "norma.ada.count": "Locuri pentru persoane cu dizabilități: minimum 4% din total, dar niciodată mai puține de două",
  "norma.ada.strip": "Fâșie de acces comună între două locuri adaptate — nu se parchează și nu o traversează nicio alee",
  "norma.ada.level": "Locurile adaptate stau pe primul nivel subteran, pe un traseu fără trepte până la ieșire",
  "norma.fire.wall": "Perete antifoc între compartimente de incendiu",
  "norma.fire.door": "Ușă rezistentă la foc acolo unde o alee traversează peretele antifoc",
  "norma.fire.core": "Casa scării de evacuare, închidere rezistentă la foc",
  "norma.evac.two_dir": "Distanță maximă de evacuare din parcaj, două direcții de evacuare",
  "norma.evac.dead_end": "Distanță maximă de evacuare în fund de sac (o singură direcție)",
  "norma.ramp.slope": "Pantă maximă a rampei de acces în parcaj acoperit",
  "norma.flat.useful": "Suprafață utilă minimă a locuinței, pe tip",
  "norma.room.living": "Suprafață minimă a camerei de zi",
  "norma.room.bedroom": "Suprafață minimă a dormitoarelor, însumat",
  "norma.room.kitchen": "Suprafață minimă a bucătăriei",
  "norma.room.sanitary": "Dotare sanitară pe număr de camere: de la 3 camere un WC separat",
  "norma.room.store": "Spațiu de depozitare în locuință",
  "norma.room.hall": "Lățime liberă de circulație în locuință",
  "norma.flat.insolation": "Fiecare cameră de locuit are lumină naturală directă și minimum 1½ h de însorire la 21 februarie — de aceea nicio cameră locuibilă nu poate fi interioară",
  "norma.bar.corridor": "Coridor comun de distribuție în clădirea de locuit",
  "norma.flat.balcony": "Balconul se contorizează separat — nu intră în suprafața utilă",
  "norma.evac.flat": "Distanță de la ușa locuinței la casa scării, două direcții",
  "norma.struct.column": "Stâlpul/lamela urcă din radier până la acoperiș și poate sta doar într-un perete; sub clădire linia de stâlpi este chiar peretele",
  "norma.sursa_proiect": "Proiect — vezi structure.py",
  "norma.val.stall_size": "2,50 × 5,50 m",
  "norma.val.aisle_width": "6,00 m / 5,00 m",
  "norma.val.ada_count": "≥ 4%, min. 2",
  "norma.val.ada_strip": "1,50 m",
  "norma.val.hall_width": "1,20 m",
  "norma.val.corridor_width": "1,50 m",
  // --- ARHITECTURĂ · vizualizatorul: bara de sus, straturile, soarele -----
  "viz.doc_necitit": "Documentul soluției nu a putut fi citit.",
  "viz.se_incarca": "se încarcă…",
  "viz.se_incarca_desenul": "Se încarcă desenul…",
  "viz.grup.plansa": "Planșă",
  "viz.grup.corp": "Corp",
  "viz.grup.nivel": "Nivel",
  "viz.grup.vedere": "Vedere",
  "viz.arata_fatada": "Reguli fațadă",
  "viz.arata_insorire": "Însorire fațade",
  "viz.arata_schita": "Schița",
  "viz.arata_schita_titlu": "Volumele desenate de tine, din care a ieșit planul ăsta",
  "viz.arata_evacuare": "Căi de evacuare",
  "viz.arata_evacuare_titlu": "Traseul cel mai lung al fiecărei ieșiri SAS, până în fața locului cel mai îndepărtat (NP 127, 40 m): punctat, cu săgeți spre ieșire, pe alei; fâșie de 0,90 m prin coridoarele dintre locuri",
  "viz.arata_circulatie": "Semne de circulație",
  "viz.arata_circulatie_titlu": "Semnele de circulație ale subsolului, așezate de generator pe aleile finale: «cedează» la gura fiecărei alei secundare, pe dreapta sensului care sosește; săgeata de preselecție cu un loc înainte și cea de sens în primul loc după intersecție; două săgeți la capul rampei; o pereche la mijlocul tronsoanelor de peste 40 m",
  "viz.arata_soare": "Lumină și umbre",
  "viz.arata_soare_titlu": "Rigla soarelui: ora din zi și anotimpul. Macheta se deschide la amiază",
  "viz.arata_oras": "Oraș",
  "viz.arata_oras_titlu": "Clădirile, străzile și parcurile din jurul lotului, pe 2 km, din OpenStreetMap. Albe: înălțimea e cunoscută; gri: e estimată",
  "viz.sit_sub_plan": "Plan de situație",
  "viz.sit_sub_plan_titlu": "Desenează planul de situație sub planșa de nivel, ca să se vadă încotro dă fiecare apartament",
  "viz.grup.afisare": "Afișare",
  "viz.filtru.cote": "Cote",
  "viz.filtru.camere": "Camere",
  "viz.filtru.etichete": "Etichete",
  "viz.filtru.apartamente": "Apartamente",
  "viz.filtru.mobilier": "Mobilier",
  "viz.filtru.foc": "Rezistență la foc",
  "viz.filtru.rampe_acces": "Rampe P → -1",
  "viz.filtru.rampe_interior": "Rampe -1 → -2",
  "viz.filtru.ascunde": "Ascunde: {ce}",
  "viz.filtru.arata": "Arată: {ce}",
  "macheta.ap.garsoniera": "Garsonieră",
  "macheta.ap.camere": "{n} camere",
  "macheta.ap.balcon": "balcon {arie} din {camera}",
  "macheta.ap.balcon_fara": "balcon {arie}",
  "macheta.camera.living": "Living",
  "macheta.camera.bedroom": "Dormitor",
  "macheta.camera.dormitor": "Dormitor",
  "macheta.camera.kitchen": "Bucătărie",
  "macheta.camera.bath": "Baie",
  "macheta.camera.bath2": "Baie",
  "macheta.camera.shower": "Duș",
  "macheta.camera.wc": "WC",
  "macheta.camera.hall": "Hol",
  "macheta.camera.hol": "Hol",
  "macheta.camera.store": "Debara",
  "macheta.camera.balcony": "Balcon",
  "macheta.camera.loggia": "Logie",
  "macheta.camera.terrace": "Terasă",
  "macheta.camera.terasa_circulabila": "Terasă",
  "macheta.camera.scara": "Scară",
  "viz.grup.etaj": "Etaj",
  "viz.etaj.tot": "Tot",
  "viz.etaj.tot_titlu": "Toată clădirea",
  "viz.etaj.parter": "P",
  "viz.etaj.parter_titlu": "Parterul",
  "viz.etaj.titlu": "Etajul {n}",
  "viz.etaj.taste": "Page Up / Page Down: etajul de deasupra / de dedesubt",
  "viz.grup.camera": "Cameră",
  "viz.grup.tus": "Tuș",
  "viz.plan_situatie": "Plan de situație",
  "viz.niveluri": "Niveluri",
  "viz.toate_corpurile": "Toate corpurile",
  "viz.toate_corpurile_titlu": "Planșa de etaj a ansamblului: toate corpurile care ajung la cota asta, în cadrul lor comun",
  "viz.vedere_2d": "2D",
  "viz.vedere_2d_titlu": "Planșa tehnică, alb-negru: poché pe pereți, fără materiale și fără umbre",
  "viz.vedere_3d": "3D",
  "viz.vedere_3d_titlu": "Macheta văzută oblic, tăiată la 1,15 m",
  "viz.sit_plan_titlu": "Planșa A01 — plan de situație desenat, cu cote și bilanț",
  "viz.sit_macheta_titlu": "Amplasamentul ca volum, sub soarele orei și al locului",
  "viz.sit_macheta_gen": "Macheta apare când e gata arhitectura de pe planul ăsta",
  "viz.cote_asezare": "Așezare",
  "viz.cote_asezare_titlu": "Retrageri până la limită, rosturi între corpuri, distanța până la alee și până la parcaj",
  "viz.zona_interzisa": "Zona interzisă",
  "viz.zona_interzisa_titlu": "Hașurează banda în care nu se poate construi — lotul, mai puțin zona edificabilă calculată de motor",
  "viz.cam.ansamblu": "Ansamblu",
  "viz.cam.strada": "Din stradă",
  "viz.cam.curte": "Din curte",
  "viz.cam.pasare": "Pasăre",
  "viz.tus_zi": "Zi",
  "viz.tus_zi_titlu": "Negru pe alb — planșa tipărită",
  "viz.tus_noapte": "Noapte",
  "viz.tus_noapte_titlu": "Alb pe negru — planșa pe ecran, ca în CAD",
  "viz.soare.titlu": "Umbre & însorire",
  "viz.soare.ora_din_zi": "ora din zi",
  "viz.soare.amiaza": "amiază",
  "viz.soare.anotimp": "Anotimp",
  "viz.soare.azimut": "azimut",
  "viz.soare.inaltime": "înălțime",
  "viz.soare.umbra": "umbra",
  "viz.ins.titlu": "Însorire fațade",
  "viz.ins.norma": "21 dec · OMS 119/2014",
  "viz.ins.fara_coordonate": "Documentul n-are coordonate, deci soarele e calculat pentru București. Cifrele de mai jos nu sunt ale amplasamentului.",
  "viz.ins.fara_corpuri": "Niciun corp cu înălțime — n-are ce măsura.",
  "viz.ins.conform": "≥ 1,5 ✓",
  "viz.ins.neconform": "< 1,5 ✗",
  "viz.ins.arh_se_incarca": "se aduce arhitectura înlănțuită… · ",
  "viz.ins.fara_arh": "fără arhitectură înlănțuită — volumele n-au goluri · ",
  "viz.ins.arh_fara_goluri": "arhitectura înlănțuită n-are goluri pe contururi · ",
  "viz.ins.arh_in_lucru": "arhitectura înlănțuită e încă în lucru · ",
  "viz.ins.fatada_in_lucru": "agentul de fațadă lucrează — {stadiu} · ",
  "viz.ins.ferestre#n": "o fereastră din arhitectura înlănțuită · |{n} ferestre din arhitectura înlănțuită · |{n} de ferestre din arhitectura înlănțuită · ",
  "viz.ins.sub_prag": "{n} din {total} fațade sub prag",
  "viz.ins.toate_trec": "toate cele {total} fațade trec pragul",
  "viz.ins.masurare": " · se măsoară la 1,50 m, cu umbrirea dintre corpurile propunerii",
  "viz.cifre.cota": "cota",
  "viz.cifre.utila_fara_balcoane": "fără balcoane și logii",
  "viz.cifre.utila_balcoane": "balcoane și logii",
  "viz.cifre.utila_terase": "terase",
  "viz.cifre.etaj_toate": "{nivel} · toate clădirile",
  "viz.cifre.suprafete": "Suprafețe",
  "viz.gen.titlu": "Suprafețe generale",
  "viz.gen.situatie": "Situație generală",
  "viz.gen.su_fara_terase": "SU (fără terase)",
  "viz.gen.su_terase": "SU terase, balcoane, logii",
  "viz.gen.su_comune": "SU spații comune",
  "viz.gen.st_construit": "ST construit",
  "viz.gen.pct_su_st": "% SU (fără terase) / ST construit",
  "viz.gen.pct_su_st_fara_comune": "% SU (fără terase) / ST fără spații comune",
  "viz.cifre.pe_camere#n": "garsoniere|{n} camere|{n} de camere",
  "viz.cifre.apartamente_rand": "Apartamente",
  "viz.cifre.arie_utila_rand": "Suprafață utilă",
  "viz.cifre.arie_construita": "Suprafață construită",
  "viz.cifre.arie_construita_desf": "Suprafață desfășurată",
  "viz.cifre.cladirea": "Clădirea {cod}",
  "viz.cifre.ansamblu": "Ansamblu",
  "viz.cifre.niveluri#n": "1 nivel|{n} niveluri|{n} de niveluri",
  "viz.cifre.cladiri#n": "1 clădire|{n} clădiri|{n} de clădiri",
  "ind.titlu": "Indicatori",
  "ind.verde": "Spații verzi",
  "ind.pot": "P.O.T.",
  "ind.cut": "C.U.T.",
  "ind.regim": "Regim de înălțime",
  "ind.niv": "niv.",
  "ind.max": "max {v}",
  "ind.supraterana": "Construită supraterană",
  "ind.subterana": "Construită subterană",
  "ind.teren": "Suprafața terenului",
  "ind.verde_total": "Spațiu verde propus",
  "ind.verde_sol": "Verde pe sol",
  "ind.verde_subsol": "Verde peste subsol",
  "ind.sapatura": "Săpătura pentru parcaj",
  "viz.legenda_strange": "Strânge",
  "viz.legenda_strange_aria": "strânge legenda",
  "viz.legenda_arata": "Legenda și scara",
  "viz.legenda_arata_aria": "arată legenda și scara",
  "legenda.isu.titlu": "Legendă ISU",
  "legenda.isu.ala": "Perete adăpost ALA, beton armat ≥ 40 cm",
  "legenda.isu.usa_ei": "Ușă rezistentă la foc, clasa EI₂ (-C: cu autoînchidere)",
  "legenda.isu.um": "Ușă metalică etanșă (UME)",
  "legenda.isu.om": "Oblon metalic etanș (OME)",
  "viz.luna.1": "ianuarie",
  "viz.luna.2": "februarie",
  "viz.luna.3": "martie",
  "viz.luna.4": "aprilie",
  "viz.luna.5": "mai",
  "viz.luna.6": "iunie",
  "viz.luna.7": "iulie",
  "viz.luna.8": "august",
  "viz.luna.9": "septembrie",
  "viz.luna.10": "octombrie",
  "viz.luna.11": "noiembrie",
  "viz.luna.12": "decembrie",
  // --- ARHITECTURĂ · straturile planșei și funcțiunile din legendă --------
  "strat.pereti": "Pereți",
  "strat.pereti_structural": "Structurali",
  "strat.pereti_facade": "De fațadă",
  "strat.pereti_party": "Despărțitori",
  "strat.pereti_partition": "Compartimentări",
  "strat.pereti_fire": "Antifoc",
  "strat.foc": "Rezistență la foc (ISU)",
  "strat.descarcare": "Linii de descărcare (din etaje)",
  "strat.parapete": "Parapeți",
  "strat.repere": "Repere: clădiri și limita terenului",
  "strat.usi": "Uși",
  "strat.ferestre": "Ferestre",
  "strat.spatii": "Spații",
  "strat.materiale": "Materiale (pardoseli)",
  "strat.adancime": "Umbre și adâncime",
  "strat.placi": "Plăci și console",
  "strat.structura": "Structură desenată",
  "strat.dedesubt": "Nivelul de dedesubt (stâlpi și grinzi)",
  "strat.gazde": "Gazde posibile pentru pile",
  "strat.apartamente": "Apartamente",
  "strat.mobilier": "Mobilier",
  "arh.recomp.in_lucru": "se compartimentează…",
  "recomp.titlu": "Recompartimentare",
  "recomp.in_lucru": "Se compartimentează… poți pleca de pe ecran, planul se reîncarcă singur.",
  "recomp.esuat": "Recompartimentarea n-a găsit nimic; apartamentul a rămas cum era.",
  "recomp.se_incarca": "Se încarcă variantele…",
  "recomp.fara_variante": "Nu sunt variante păstrate pentru apartamentul ăsta.",
  "recomp.si_pe_oglinzi": "Aplică și pe cele {n} la fel (oglindite)",
  "recomp.camere_m2": "{m2} m² în camere",
  "recomp.util_m2": "SU {m2} m²",
  "recomp.praguri": "{n} praguri de catalog ratate",
  "recomp.scrisa": "Scrisă în plan",
  "recomp.trimisa": "Se scrie…",
  "recomp.aplica": "Aplică varianta",
  "recomp.eroare": "Nu s-a putut porni scrierea variantei.",
  "recomp.picat": "Varianta nu s-a putut scrie; planul a rămas cum era.",
  "recomp.varianta_n": "Varianta {n} din {m}",
  "recomp.anterioara": "Varianta anterioară",
  "recomp.urmatoarea": "Varianta următoare",
  "recomp.fel.living": "Cameră de zi",
  "recomp.fel.bedroom": "Dormitor",
  "recomp.fel.kitchen": "Bucătărie",
  "recomp.fel.bath": "Baie",
  "recomp.fel.hall": "Hol",
  "recomp.fel.room": "Cameră",
  "recomp.fel.niche": "Nișă",
  "strat.etichete": "Nume camere",
  "strat.obiecte": "Etichete (tipul obiectelor)",
  "strat.parcaj": "Planșa de parcaj — numere, alei",
  "strat.alei": "Alei — lățimea",
  "strat.rampe_acces": "Rampa de acces (parter → -1)",
  "strat.rampe_interior": "Rampa -1 → -2",
  "strat.cote": "Cote",
  "strat.cote_fatada": "Pe fațadă — plin, gol, plin",
  "strat.cote_axe": "Între axele stâlpilor",
  "strat.cote_total": "Total pe latură",
  "strat.cote_camere": "Lumina camerelor",
  "strat.cote_goluri": "Pereți interiori",
  "strat.cote_ala": "Adăposturi ALA — SAS, uși, stâlpi",
  "strat.nuclee": "Nuclee (scară, lift, ghenă)",
  "strat.scari": "Scări de pisică",
  "viz.prag": "prag",
  "strat.circulatie": "Circulație și corpuri",
  "strat.nedesenate": "Obiecte nedesenate",
  "functiune.living": "Camera de zi",
  "functiune.kitchen": "Bucătărie",
  "functiune.bedroom": "Dormitor",
  "functiune.dormitor": "Dormitor",
  "functiune.hall": "Hol",
  "functiune.hol": "Hol de nivel",
  "functiune.administrativ": "Spațiu administrativ",
  "functiune.bath": "Baie",
  "functiune.bath2": "Baie",
  "functiune.shower": "Duș",
  "functiune.wc": "Grup sanitar",
  "functiune.store": "Debara",
  "functiune.balcony": "Balcon",
  "functiune.sas": "Sas",
  "functiune.scara": "Casa scării",
  "functiune.lift": "Ascensor",
  "functiune.ghena": "Ghenă",
  "functiune.bazin": "Bazin",
  "functiune.tech": "Spațiu tehnic",
  "categorie.structura": "Structură",
  "plan.rampa_spre": "rampă → nivel {n}",
  "plan.rampa_dedesubt": "rampă → nivel {n}, sub rampa de acces",
  "plan.materiale_esec": "Materialele machetei nu s-au putut încărca.",
  "plan.terasa_necirculabila": "Terasă necirculabilă",
  "plan.trepte_sus": "SUS · {n} trepte",
  "plan.platforma": "Platformă elevatoare",
  // --- ARHITECTURĂ · verificările: verdictul, socoteala, filtrul ----------
  "verdict.conform": "Conform",
  "verdict.neconform": "Neconform",
  "verdict.necesita_confirmare": "Necesită confirmare",
  "verdict.inaplicabil": "Inaplicabil",
  "verdict.neverificabil": "Neverificabil",
  // Substantivele pe care le numără o regulă, pe FELUL elementului. Sunt
  // enumerabile — `base_kind` e un cod —, deci se traduc aici; eticheta liberă
  // a regulii (`base_label`) vine de la validator și rămâne românească până se
  // face axa de server (v. `docs/internationalizare.md`).
  "subst.flat#n": "un apartament|{n} apartamente|{n} de apartamente",
  "subst.flatRoom#n": "o încăpere|{n} încăperi|{n} de încăperi",
  "subst.balcony#n": "un balcon|{n} balcoane|{n} de balcoane",
  "subst.building#n": "o clădire|{n} clădiri|{n} de clădiri",
  "subst.corridor#n": "un coridor|{n} coridoare|{n} de coridoare",
  "subst.bar#n": "un tronson|{n} tronsoane|{n} de tronsoane",
  "subst.element#n": "un element|{n} elemente|{n} de elemente",
  "val.fara_capitol": "Fără capitol",
  "val.conforme_din": "{conforme} din {total} conforme",
  "val.din": "{conforme} din {total}",
  "val.de_confirmat": "{n} necesită confirmare",
  "val.inaplicabil_alte": "nu se aplică la alte {n}",
  "val.inaplicabil_la": "nu se aplică la {substantiv}",
  "val.instante#n": "o instanță|{n} instanțe|{n} de instanțe",
  "val.neverificabila": "neverificabilă pe acest model",
  "val.fara_instante": "fără instanțe",
  "val.scop.apartamente#n": "un apartament|{n} apartamente|{n} de apartamente",
  "val.scop.niveluri#n": "un nivel|{n} niveluri|{n} de niveluri",
  "val.scop.etaje_identice": "etaje identice, verificate individual",
  "val.scop.elemente#n": "un element|{n} elemente|{n} de elemente",
  "val.scop.masuratori#n": "o măsurătoare|{n} măsurători|{n} de măsurători",
  "val.nicio_neconformitate": "nicio neconformitate",
  "val.filtru_reguli#n": "o regulă|{n} reguli|{n} de reguli",
  // --- ARHITECTURĂ · numele nivelului și de ce nu s-a desenat un obiect ---
  "nivelul.nr": "Nivel {n}",
  "nivelul.parcare": "Parcare · nivel {n}",
  "nivelul.subsol": "Subsol {n}",
  "nivelul.parter": "Parter",
  "nivelul.etaj": "Etaj {n}",
  "motiv.planseu_inexistent": "Planșeu inexistent",
  "motiv.pe_situatie": "Pe planul de situație",
  "motiv.tip_nedesenat": "Tip nedesenat de plan",
  "motiv.pe_fatada": "Pe fațadă și în 3D",
  "motiv.peste_sectiune": "Deasupra tăieturii planului",
  "motiv.tip_organizatoric": "Grupează, nu se desenează",
  "motiv.fara_geometrie": "Fără geometrie",
  // --- PLANUL DE SITUAȚIE · bilanțul planșei A01 și etichetele de pe ea ---
  // Rândurile bilanțului se scriu cu MAJUSCULE și fără diacritice: e convenția
  // planșei tipărite, nu o scăpare — v. `siteGlyphs`.
  "a01.suprafata_teren": "SUPRAFATA TEREN",
  "a01.total_verde": "TOTAL SPATIU VERDE PROPUS",
  "a01.verde_sol": "SPATIU VERDE DEEP GREEN PROPUS",
  "a01.verde_subsol": "SPATIU VERDE PESTE SUBSOL PROPUS",
  "a01.sapatura": "SAPATURA PENTRU PARCAJ",
  "a01.acces": "acces",
  "a01.acces_cladire": "clădire",
  "a01.cota_lungime": "lungime {m} m",
  "a01.cota_latime": "lățime {m} m",
  "a01.rampa_acces": "rampă acces",
  "insp.inchide": "Închide (Esc)",
  "insp.sus": "Selectează locuința întreagă",
  // --- IMPORTUL DE DOCUMENTE · piesele de dosar ---------------------------
  // Etichetele VIN DE LA SERVER, traduse acolo (v. `importer/i18n/`). Cele de
  // aici sunt plasa pentru ecranul desenat înainte să răspundă el.
  "dosar.categorie.certificat_urbanism": "Certificat de urbanism",
  "dosar.categorie.cadastru": "Cadastru & carte funciară",
  "dosar.categorie.plan_topografic": "Plan topografic",
  "dosar.categorie.studiu_geotehnic": "Studiu geotehnic",
  "dosar.categorie.solutie_arhitecturala": "Soluție arhitecturală",
  "dosar.categorie.solutie_structurala": "Soluție structurală",
  "dosar.categorie.retete_preturi": "Rețete & prețuri",
  "dosar.categorie.altele": "Altele",
  "dosar.categorie.mixt": "Document cu mai multe acte",
  "dosar.piesa.pagina": "p. {p}",
  "dosar.piesa.pagini": "p. {de_la}–{pana_la}",
  "dosar.piesa.din": "din {fisier}",
  "dosar.piese": "Ce conține",

  // --- STRUCTURĂ · banii -------------------------------------------------
  "struct.bani.lei": "lei",
  "struct.bani.milioane_lei": "{v} mil. lei",

  // --- STRUCTURĂ · felul elementului -------------------------------------
  "struct.tip.grinda": "grindă",
  "struct.tip.stalp": "stâlp",
  "struct.tip.perete": "perete",
  "struct.tip.lamela": "lamelă (perete structural)",
  "struct.tip.ochi": "ochi de placă",
  "struct.tip.ax": "ax de fundație",
  "struct.tip.placa_sol": "placă pe sol",
  "struct.tip.zidarie": "zid de zidărie confinată",

  // --- STRUCTURĂ · verdictul unui element --------------------------------
  "struct.verdict.conform": "conform",
  "struct.verdict.se_verifica": "SE VERIFICA!",
  "struct.verdict.nu_se_verifica": "NU SE VERIFICA!!!",
  "struct.verdict.atentie": "ATENTIE!!!",
  "struct.verdict.atentie_scurt": "ATENTIE",
  "struct.verdict.la_limita": "de revizuit",
  "struct.verdict.neconform": "neconform",

  // --- STRUCTURĂ · indexul de elemente -----------------------------------
  "struct.elem.criteriu_pmm": "P–M–M în punctul vulnerabil",
  "struct.elem.sect_grosime": "gros. {n} cm",
  "struct.elem.sect_placa": "placă {n} cm",
  "struct.elem.det_L": "L {n} m",
  "struct.elem.det_H": "H {n} m",
  "struct.elem.det_B": "B {n} m",
  "struct.elem.det_h": "h {n} cm",
  "struct.elem.det_stalpi#n": "{n} stâlp|{n} stâlpi|{n} de stâlpi",
  "struct.elem.niv_directie": "direcția {dir}",
  "struct.elem.niv_fundatie": "fundație",
  "struct.elem.niv_jos": "nivelul de jos",
  "struct.elem.ver_presiune_birou": "Presiunea efectivă — metoda biroului",
  "struct.elem.ver_presiune_np112": "Presiunea efectivă — NP 112",
  "struct.elem.ver_desprindere": "Desprinderea tălpii (zona activă)",
  "struct.elem.desprindere_activ": "{n} m activi",
  "struct.elem.ver_tasare": "Tasarea absolută",
  "struct.elem.ver_presiune_model": "Presiunea din model (reacțiuni FEM)",

  // --- STRUCTURĂ · clasa de execuție a elementului -----------------------
  "struct.clasa.identice#n": "{clasa} · {n} element identic|{clasa} · {n} elemente identice|{clasa} · {n} de elemente identice",
  "struct.clasa.singurul": "{clasa} · singurul de felul lui",

  // --- STRUCTURĂ · eticheta unei soluții ---------------------------------

  // --- ASISTENTUL: panoul de chat din editorul de module ------------------
  "asistent.titlu": "Asistent",
  "agent.titlu": "Agentul de fațadă",
  "agent.discutie_blocata": "Agentul de fațadă lucrează…",
  "agent.lucreaza": "lucrează la fațadă",
  "agent.a_terminat": "a terminat",
  "agent.buton_lucreaza": "Agentul de fațadă lucrează — deschide ca să vezi ce face",
  "agent.pas.incep": "Încep varianta {varianta} din {din}, după {referinte} referințe.",
  "agent.pas.citesc_fatada": "Citesc fațadele clădirii.",
  "agent.pas.compun": "Am compus balcoanele și golurile.",
  "agent.pas.compun_refuz": "O parte din compunere n-a încăput; o ajustez.",
  "agent.pas.stil_pus": "Am îmbrăcat clădirea cu stilul ales.",
  "agent.pas.stil_invalid": "Stilul n-a trecut verificarea; îl corectez.",
  "agent.pas.peste_nivel": "Ce am propus trece peste nivelul clădirii; adaptez cu materialele permise.",
  "agent.pas.verific_randarile": "Mă uit la clădire din {n} unghiuri, ca s-o compar cu referințele.",
  "agent.pas.critic": "Un designer a comparat imaginile cu referințele și a făcut observații ({n}); le aplic.",
  "agent.pas.critic_bine": "Un designer a comparat imaginile cu referințele și n-are obiecții.",
  "agent.pas.gata": "Fațada e gata.",
  "agent.pas.editez": "Pornesc de la fațada de acum și schimb numai ce ai cerut.",
  "agent.pas.refac": "Refac fațada de la zero, după poza și cererea ta.",
  "agent.pas.extrag_stilul": "Citesc stilul din poze: cum arată balcoanele, volumele, materialele, culorile.",
  "agent.pas.vitraj_sub_nivel": "Nivelul clădirii cere geam de sus până jos și mai multă sticlă; mai compun o dată.",
  "agent.pas.tipar_necompus": "Ce am citit în poză la balcoane nu e încă în compoziție; mai compun o dată.",
  "agent.pas.privesc_inainte": "Mă uit la fațada de acum, înainte să schimb ceva.",
  "agent.pas.verific_schimbarea": "Mă uit la clădire din {n} unghiuri, ca să văd schimbarea.",
  "agent.pas.critic_editare": "Un designer a comparat înainte și după cu cererea ta și mai cere {n} ajustări; le fac.",
  "agent.pas.critic_editare_bine": "Un designer a comparat înainte și după: schimbarea răspunde cererii.",
  "agent.pas.gata_editare": "Schimbarea e pe fațadă.",
  "agent.pas.oprit": "Oprit la cerere.",
  "agent.pas.picat": "Agentul s-a oprit cu o eroare; soluția a rămas cu stilul de până atunci.",
  "agent.pas.fara_fatada": "Soluția n-are clădiri compartimentate, deci nicio fațadă de îmbrăcat.",
  "agent.cu_eroare": "s-a oprit cu o eroare",
  "agent.pasi#n": "un pas|{n} pași|{n} de pași",
  "agent.depanare.titlu": "Detalii tehnice: ce a cerut modelul fiecărei unelte și ce a primit",
  "agent.depanare.ok": "acceptat",
  "agent.depanare.refuzat": "refuzat",
  "agent.depanare.rezultat": "rezultatul",
  "agent.depanare.argumente": "cererea modelului",
  "agent.meta.varianta": "Varianta {varianta} din {din}",
  "agent.meta.referinte#n": "o referință|{n} referințe|{n} de referințe",
  "agent.meta.unghiuri#n": "un unghi verificat|{n} unghiuri verificate|{n} de unghiuri verificate",
  "agent.meta.observatii#n": "o observație aplicată|{n} observații aplicate|{n} de observații aplicate",
  "agent.scurt.incep": "Varianta {varianta} din {din}",
  "agent.scurt.citesc_fatada": "Fațade citite",
  "agent.scurt.compun": "Balcoane și goluri compuse",
  "agent.scurt.compun_refuz": "Compunere ajustată",
  "agent.scurt.stil_pus": "Stil pus",
  "agent.scurt.stil_invalid": "Stil corectat",
  "agent.scurt.peste_nivel": "Adaptat la nivelul clădirii",
  "agent.scurt.verific_randarile": "Verificată din {n} unghiuri",
  "agent.scurt.critic": "Observații de design: {n}",
  "agent.scurt.critic_bine": "Fără observații de design",
  "agent.scurt.gata": "Gata",
  "agent.scurt.editez": "Pornește de la fațada de acum",
  "agent.scurt.privesc_inainte": "Fațada de acum, privită",
  "agent.scurt.verific_schimbarea": "Schimbarea, din {n} unghiuri",
  "agent.scurt.critic_editare": "Ajustări cerute: {n}",
  "agent.scurt.critic_editare_bine": "Schimbarea răspunde cererii",
  "agent.scurt.gata_editare": "Schimbarea e pe fațadă",
  "agent.scurt.oprit": "Oprit la cerere",
  "agent.scurt.picat": "Oprit cu o eroare",
  "agent.scurt.fara_fatada": "Nicio fațadă de îmbrăcat",
  // --- AGENTUL PLANULUI DE SITUAȚIE (`viewer/plan_agent/AsistentPlan.tsx`; «Refă planul cu agentul» e în meniul soluției) ---
  "agent_plan.titlu": "Agentul planului",
  "agent_plan.asistent": "Asistent plan de situație",
  "agent_plan.lucreaza": "lucrează la plan",
  "agent_plan.discutie_blocata": "Agentul planului lucrează…",
  "agent_plan.buton_lucreaza": "Agentul planului lucrează — deschide ca să vezi ce face",
  "agent_plan.pas.incep": "Pornesc de la terenul gol: circulația, locurile, trotuarele, zonele.",
  "agent_plan.pas.editez": "Pornesc de la planul de acum și schimb numai ce ai cerut.",
  "agent_plan.pas.lot_scris": "Am scris pe planșă: {ce}.",
  "agent_plan.pas.lot_respins": "Un lot n-a trecut verificarea ({n} probleme); îl refac.",
  "agent_plan.pas.gata": "Planul e gata: {locuri} locuri, {verde_pct} % verde.",
  "agent_plan.pas.gata_cu_blocaje": "Planul e gata, cu {n} lucruri pe care nu le-am putut rezolva.",
  "agent_plan.pas.limita": "M-am oprit la limita de lucru; planșa rămâne cu ce am scris până acum.",
  "agent_plan.pas.gata_refuzata": "Am vrut să închid, dar planșa are {n} probleme deschise; mai încerc.",
  "agent_plan.pas.oprit_pe_probleme": "M-am oprit: nu pot închide planul cu {n} probleme deschise; planșa rămâne cu ce am scris.",
  "agent_plan.pas.oprit": "Oprit la cerere.",
  "agent_plan.pas.picat": "Agentul s-a oprit cu o eroare; planșa rămâne cu ce am scris până atunci.",
  "agent_plan.pas.fara_cheie": "Agentul n-a rulat: serverul n-are cheia de model.",
  "agent_plan.scurt.incep": "De la terenul gol",
  "agent_plan.scurt.editez": "Pornește de la planul de acum",
  "agent_plan.scurt.lot_scris": "Scris: {ce}",
  "agent_plan.scurt.lot_respins": "Lot respins ({n})",
  "agent_plan.scurt.gata": "Gata: {locuri} locuri, {verde_pct} % verde",
  "agent_plan.scurt.gata_cu_blocaje": "Gata, cu {n} blocaje",
  "agent_plan.scurt.limita": "Oprit la limită",
  "agent_plan.scurt.oprit": "Oprit la cerere",
  "agent_plan.scurt.picat": "Oprit cu o eroare",
  "agent_plan.scurt.fara_cheie": "N-a rulat: fără cheie",
  "agent_plan.locuri": "Locuri de parcare",
  "agent_plan.din_tinta": "{locuri} din {tinta}",
  "agent_plan.verde": "Spațiu verde",
  "agent_plan.verde_cota": "{pct} % · cota {cota} %",
  "agent_plan.loturi": "{ok} loturi scrise · {respinse} respinse",
  "agent_plan.tururi#n": "un tur|{n} tururi|{n} de tururi",
  "agent_plan.cost": "{cost} $ pe model",
  "agent_plan.revizie": "revizia {n}",
  "agent_plan.blocaje#n": "un blocaj|{n} blocaje|{n} de blocaje",
  "agent_plan.refa": "Refă planul cu agentul",
  "agent_plan.refa_expl": "Pornește agentul de la terenul gol: circulația, locurile, trotuarele și zonele se rescriu pe planul ăsta, lot cu lot (minute).",
  "agent_plan.refa_confirma": "Agentul rescrie circulația, locurile de parcare, trotuarele și zonele planului ăsta de la zero. Planșa de acum se pierde. Continui?",
  "agent_plan.pornit": "Agentul a pornit; planșa se schimbă pe măsură ce scrie.",
  "agent_plan.deja_ruleaza": "Agentul lucrează deja pe planul ăsta; așteaptă-l să termine.",
  "agent_plan.card.pornita": "Agentul a pornit; aștept primii lui pași…",
  "agent_plan.card.din_buton": "la «Refă planul cu agentul»",
  "agent_plan.card.gasita": "rulare pornită înainte de deschiderea paginii",
  "asistent.deschide": "Cere-i asistentului o modificare",
  "asistent.inchide": "Închide asistentul",
  "asistent.conversatie_noua": "Discuție nouă: șterge tot ce s-a vorbit",
  "asistent.golire_esec": "N-am putut șterge discuția de pe server. Panoul e gol, dar ce a fost s-ar putea întoarce la reîncărcare.",
  "asistent.strange": "Strânge panoul",
  "asistent.desfa": "Desfă panoul",
  "asistent.citeste": "Citește răspunsurile cu voce tare",
  "asistent.nu_citi": "Nu mai citi răspunsurile cu voce tare",
  "asistent.dicteaza": "Spune cererea cu vocea",
  "asistent.opreste_dictarea": "Gata — trimite ce am spus",
  "asistent.fara_microfon": "Browserul ăsta nu are recunoaștere de voce. Pe Chrome merge.",
  "asistent.microfon_refuzat": "Microfonul e blocat pentru pagina asta. Dă-i voie din bara de adrese a browserului și încearcă din nou.",
  "asistent.microfon_esec": "N-am putut asculta: {cod}.",
  "asistent.scrie": "Scrie ce vrei să schimbi…",
  "asistent.trimite": "Trimite",
  "asistent.ataseaza_poza": "Atașează o poză (referință de fațadă)",
  "asistent.scoate_poza": "Scoate poza",
  "asistent.poza_prompt": "Scrie stilul de fațadă din poza asta.",
  "asistent.opreste": "Oprește",
  "asistent.se_gandeste": "se gândește…",
  "asistent.rationament": "Raționament",
  "asistent.rationament_arata": "Vezi cum a gândit",
  "asistent.gol_titlu": "Ce vrei să schimbi la modul?",
  "asistent.gol_text": "Spune-i în cuvintele tale. Citește planul, face schimbarea pe desenul deschis și îți arată ce a atins. Salvarea rămâne la tine.",
  "asistent.exemplu_usi": "Pune uși glisante peste tot, mai puțin la intrări",
  "asistent.exemplu_pereti": "Mută pereții de compartimentare cu 12 cm spre coridor",
  "asistent.exemplu_masura": "Cât însumează băile de pe latura A?",
  "asistent.gol_titlu_fatada": "Ce vrei să schimbi la fațadă?",
  "asistent.gol_titlu_situatie": "Ce vrei să schimbi pe planul de situație?",
  "asistent.selectie": "Selecția",
  "asistent.scoate_din_selectie": "Scoate din selecție",
  "asistent.goleste_selectia": "Golește",
  "detalii.titlu_panou": "Detalii element",
  "detalii.cote": "Cote",
  "detalii.cote_titlu": "Arată cotele pe machetă",
  "detalii.inchide": "Închide și deselectează",
  "detalii.anterior": "Elementul ales anterior",
  "detalii.urmator": "Elementul ales următor",
  "detalii.din": "{i} din {n}",
  "detalii.lipsa": "Elementul nu mai e în documentul soluției.",
  "detalii.grup.dimensiuni": "Dimensiuni",
  "detalii.grup.material": "Material",
  "detalii.grup.tamplarie": "Tâmplărie",
  "detalii.grup.balcon": "Balcon",
  "detalii.grup.loc": "Unde stă",
  "detalii.grup.cost": "Costuri",
  "detalii.cost.se_calculeaza": "Se calculează…",
  "detalii.cost.material": "Material",
  "detalii.cost.manopera": "Manoperă",
  "detalii.cost.total": "Total",
  "detalii.cost.nota": "Cost direct, fără sporuri, pe prețurile estimative ale devizului fațadei.",
  "detalii.placa_nr": "Placa",
  "detalii.sectiune": "Secțiune",
  "detalii.profil_mana": "Profil",
  "detalii.v.profil.rect": "dreptunghiular",
  "detalii.v.profil.round": "rotund (țeavă)",
  "material.mana_curenta_otel": "Oțel vopsit",
  "material.mana_curenta_aluminiu": "Aluminiu",
  "material.mana_curenta_inox": "Inox",
  "material.mana_curenta_lemn": "Lemn",
  "material.profil_sticla_aluminiu": "Aluminiu",
  "material.profil_sticla_inox": "Inox",
  "detalii.format": "Format placă (de stoc)",
  "detalii.latime": "Lățime",
  "detalii.inaltime": "Înălțime",
  "detalii.parapet": "Parapet",
  "detalii.suprafata": "Suprafață",
  "detalii.lungime": "Lungime",
  "detalii.grosime": "Grosime",
  "detalii.cota_jos": "Cota de jos (de la pardoseală)",
  "detalii.arie_bruta": "Arie brută",
  "detalii.arie_goluri": "Din care goluri",
  "detalii.arie_neta": "Arie netă",
  "detalii.volum": "Volum",
  "detalii.arie": "Arie",
  "detalii.adancime": "Adâncime",
  "detalii.fel": "Fel",
  "detalii.pe": "Pe",
  "detalii.plantare": "Plantare",
  "detalii.strat": "Strat",
  "detalii.unde": "Pe fațadă",
  "detalii.placi": "Plăci",
  "detalii.rost": "Rost",
  "detalii.material": "Material",
  "detalii.culoare": "Culoare",
  "detalii.rama": "Ramă",
  "detalii.culoare_toc": "Culoarea tocului",
  "detalii.canate": "Canate",
  "detalii.deschidere": "Deschidere",
  "detalii.vitraj": "Vitraj",
  "detalii.profil": "Profil",
  "detalii.adancime_toc": "Adâncimea tocului",
  "detalii.prag": "Prag",
  "detalii.model": "Model",
  "detalii.inchidere": "Închidere",
  "detalii.pe_colt": "Pe colț",
  "detalii.varianta": "Varianta",
  "detalii.compozitie": "Compoziția",
  "detalii.sistem": "Sistem",
  "detalii.montanti": "Montanți",
  "detalii.modul": "Modul",
  "detalii.culoare_sticla": "Culoarea sticlei",
  "detalii.culoare_opac": "Culoarea zonei opace",
  "detalii.arie_vitrata": "Arie vitrată",
  "detalii.arie_opaca": "Arie opacă",
  "detalii.ferestre_cortina": "Ferestre ascunse",
  "detalii.usi": "Uși",
  "detalii.peste_placa": "Peste placă (atic)",
  "detalii.balustrade": "Pe margine",
  "detalii.corp": "Corp",
  "detalii.etaj": "Etaj",
  "detalii.coloana": "Coloana de apartamente",
  "detalii.v.deschidere.fixed": "fix",
  "detalii.v.deschidere.casement": "batant",
  "detalii.v.deschidere.tilt_turn": "oscilobatant",
  "detalii.v.deschidere.sliding": "glisant",
  "detalii.v.vitraj.single": "simplu",
  "detalii.v.vitraj.double": "dublu",
  "detalii.v.vitraj.triple": "triplu",
  "detalii.v.model.single": "o foaie",
  "detalii.v.model.double": "două foi",
  "detalii.v.model.fixed_door": "ușă cu parte fixă",
  "detalii.v.fel.glass": "sticlă",
  "detalii.v.fel.slats": "lamele",
  "detalii.v.fel.solid": "parapet plin",
  "detalii.v.fel.planter": "jardinieră",
  "detalii.v.fel.screen": "ecran fix",
  "detalii.v.fel.plaster": "tencuială",
  "detalii.v.fel.cladding": "placaj",
  "detalii.v.fel.brick": "cărămidă",
  "detalii.v.fel.glazing": "câmp vitrat",
  "detalii.v.fel.curtain_wall": "perete cortină",
  "detalii.v.fel.band": "brâu",
  "detalii.v.fel.sill": "glaf",
  "detalii.v.fel.flooring": "pardoseală",
  "detalii.v.fel.insulation": "termoizolație",
  "detalii.v.fel.render": "tencuială de bază",
  "detalii.v.fel.subframe": "substructură",
  "detalii.v.pe.balcony": "balcon",
  "detalii.v.pe.terrace": "terasă",
  "detalii.v.pe.opening": "fereastră înaltă",
  "detalii.v.pe.loggia": "logie",
  "detalii.v.plantare.hanging": "curgătoare",
  "detalii.v.plantare.upright": "în sus",
  "detalii.v.strat.finish": "finisaj",
  "detalii.v.strat.thermal": "termoizolație",
  "detalii.v.strat.render": "tencuială de bază",
  "detalii.v.strat.relief": "relief",
  "detalii.v.strat.subframe": "substructură",
  "detalii.v.strat.curtain": "perete cortină",
  "detalii.v.varianta_cortina.standard": "montant-traversă",
  "detalii.v.varianta_cortina.horizontal": "numai orizontal (HL)",
  "detalii.v.varianta_cortina.vertical": "numai vertical (VL)",
  "detalii.v.varianta_cortina.structural": "siliconat (SG)",
  "detalii.v.unde.facade": "fațadă",
  "detalii.v.unde.plinth": "soclu",
  "detalii.v.unde.recess": "logie",
  "detalii.v.unde.parapet": "atic",
  "detalii.v.unde.soffit": "intrados",
  "detalii.v.unde.balcony": "balcon",
  "detalii.v.unde.terrace": "terasă",
  "detalii.v.unde.loggia": "logie",
  "detalii.v.unde.reveal": "șpalet",
  "detalii.v.unde.cheek": "obraz de balcon",
  "detalii.v.unde.divider": "despărțitor",
  "detalii.v.unde.floor": "pardoseală",
  "detalii.v.inchidere.box": "cutie (închis lateral)",
  "detalii.v.inchidere.open": "deschis",
  "detalii.v.da.da": "da",
  "detalii.v.etaj.parter": "parter",
  "material.aluminiu": "Aluminiu",
  "material.pvc": "PVC",
  "material.lemn": "Lemn",
  "material.dale_terasa": "Dale de terasă",
  "material.dale_portelanate": "Dale porțelanate",
  "material.gresie_exterior": "Gresie de exterior",
  "material.deck_compozit": "Deck compozit",
  "material.deck_lemn": "Deck din lemn",
  "material.etics": "Termosistem (ETICS)",
  "material.etics_intrados": "Termosistem la intrados",
  "material.glaf_atic": "Glaf de atic",
  "material.glaf_aluminiu": "Glaf de aluminiu",
  "material.hidroizolatie": "Hidroizolație",
  "material.hidroizolatie_balcon": "Hidroizolație de balcon",
  "material.lemn_vertical": "Lemn, scânduri verticale",
  "material.lemn_ingust": "Lemn, șipci înguste",
  "material.lemn_riflaj": "Lemn, riflaj",
  "material.lemn_panouri": "Panouri cu decor de lemn",
  "material.placaj_hpl": "Placaj HPL",
  "material.lamele_verticale": "Lamele verticale",
  "material.panou_metal": "Panou metalic",
  "material.parapet_lamele": "Parapet din lamele",
  "material.parapet_sticla": "Parapet de sticlă",
  "material.piatra_granit": "Granit",
  "material.piatra_travertin": "Travertin",
  "material.piatra_ardezie": "Ardezie",
  "material.piatra_zidita": "Piatră zidită",
  "material.placaj_piatra": "Placaj de piatră",
  "material.pietris": "Pietriș",
  "material.placaj_ceramic": "Placaj ceramic",
  "material.placaj_metalic": "Placaj metalic",
  "material.ploturi_reglabile": "Ploturi reglabile",
  "material.sapa_panta": "Șapă de pantă",
  "material.sticla": "Sticlă",
  "material.perete_cortina": "Perete cortină (montant-traversă)",
  "material.tencuiala_baza": "Tencuială de bază",
  "material.tencuiala_decorativa": "Tencuială decorativă",
  "material.termoizolatie_terasa": "Termoizolație de terasă",
  "material.xps_soclu": "XPS la soclu",
  "material.caramida_aparenta": "Cărămidă aparentă",
  "material.profil_eps": "Profil EPS",
  "material.tabla_perforata": "Tablă perforată",
  "material.perete_verde": "Perete verde",
  "material.prag_aluminiu": "Prag de aluminiu",
  "asistent.gol_text_fatada": "Schimbările mici le fac pe loc; pe cele mari le dau agentului de fațadă. Orice schimbare se poate anula cât stai pe proiect.",
  "asistent.gol_text_situatie": "Spune-i în cuvintele tale. Orice schimbare o face agentul planului, în câteva minute, iar planșa se schimbă sub ochii tăi.",
  "asistent.gol_titlu_costuri": "Ce vrei să afli despre deviz?",
  "asistent.gol_text_costuri": "Îți spun de unde vine fiecare cifră și cum iese. Un «și dacă…» devine un scenariu nou, cu numele lui, iar pagina trece pe el; cel de acum rămâne în «Scenarii».",
  "asistent.exemplu_costuri_de_unde": "De unde vine costul structurii?",
  "asistent.exemplu_costuri_pret": "Și dacă vindem cu 10 % mai scump?",
  "asistent.exemplu_costuri_structura": "Fă-mi un scenariu cu structura cu 10 % mai scumpă și durata de 4 ani",
  "asistent.scrie_costuri": "Întreabă despre deviz sau cere o variantă…",
  "asistent.exemplu_fatada_culoare": "Fă sticla de la balcoane clară, nu neagră.",
  "asistent.exemplu_fatada_material": "Pune lemn pe parapetul de la ultimul etaj.",
  "asistent.exemplu_fatada_poza": "Vreau balcoanele ca în poza asta.",
  "asistent.exemplu_situatie_locuri": "Vreau mai multe locuri de parcare lângă intrare.",
  "asistent.exemplu_situatie_trecere": "Pune o trecere de pietoni în dreptul blocului C2.",
  "asistent.exemplu_situatie_verde": "Mai puțin asfalt, mută locul de joacă spre sud.",
  "asistent.pas.modific": "Schimb fațada…",
  "asistent.pas.modificat": "Am schimbat fațada pe soluție",
  "asistent.pas.predau": "Dau cererea agentului de fațadă…",
  "asistent.pas.predat": "Agentul de fațadă a preluat cererea",
  "asistent.pas.anulez": "Pun la loc fațada de dinainte…",
  "asistent.pas.anulat": "Fațada de dinainte e la loc",
  "asistent.pas.refac": "Pun înapoi schimbarea…",
  "asistent.pas.refacut": "Schimbarea e din nou pe fațadă",
  "asistent.pas.citesc_plan": "Citesc planul de situație…",
  "asistent.pas.citit_plan": "Am citit planul de situație",
  "asistent.pas.predau_plan": "Dau cererea agentului planului…",
  "asistent.pas.predat_plan": "Agentul planului a preluat cererea",
  "asistent.pas.nu_a_mers": "N-a mers",
  "asistent.doar_citire": "Ai drept de citire pe proiectul ăsta: asistentul poate măsura și explica, dar nu poate schimba desenul.",
  "asistent.plan": "Plan de lucru",
  "asistent.se_aplica": "se aplică",
  "asistent.esuat": "n-a mers",
  "asistent.gata": "gata",
  "asistent.captura": "Captura planului",
  "asistent.ocupat": "Discuția are deja un răspuns în lucru. Așteaptă-l sau oprește-l.",
  "asistent.prea_multi_pasi": "Asistentul a făcut prea mulți pași fără să te întrebe. Spune-i mai exact ce vrei.",
  "asistent.esec": "Ceva n-a mers cu asistentul. Discuția e salvată — încearcă din nou.",
  "asistent.pagina_veche": "Pagina e deschisă de dinaintea unei publicări, iar asistentul nu mai poate rula cod. Reîncarcă — dacă ai ceva nesalvat, browserul te întreabă întâi.",
  "asistent.reincarca": "Reîncarcă pagina",
  "asistent.alta_fereastra": "Discuția asta e deschisă și în altă fereastră, care tocmai a scris. Așteaptă un moment și încearcă din nou.",
  "asistent.iesit": "Sesiunea a expirat. Intră din nou în cont.",
  "asistent.fara_acces": "Nu ai drept de scriere pe proiectul ăsta.",
  "asistent.tokeni": "{in} in · {out} out",
  "asistent.socoteala_nota": "Cifrele sunt ale discuției întregi: un răspuns cu unelte înseamnă mai multe cereri către model.",
  "asistent.nou": "Discuție nouă",
  "asistent.incearca": "Încearcă",
  "asistent.arata_pe_macheta": "Arată pe machetă despre ce e vorba",
  "asistent.tasta_clic": "Clic",
  "asistent.tasta_mai_multe": "⇧ + clic",
  "asistent.tasta_zona": "⌥/Alt + trage",
  "asistent.un_element": "un element",
  "asistent.mai_multe_elemente": "mai multe elemente",
  "asistent.o_zona": "o zonă de fațadă",
  "asistent.despre": "despre {ce}",
  "asistent.n_elemente#n": "un element|{n} elemente|{n} de elemente",
  "asistent.arata_tot": "Arată toată selecția",

  // --- STRUCTURĂ · numele celor 19 pași ----------------------------------
  "struct.pas.titlu": "Pasul {nr} — {nume}",
  "struct.pas.scurt": "Pasul {nr}",
  "struct.pas.studiu_geotehnic": "Studiu geotehnic",
  "struct.pas.analiza_arhitectura": "Analiză arhitectură",
  "struct.pas.strategie_arhitecturala": "Strategie structurală",
  "struct.pas.model_structura": "Model structural",
  "struct.pas.fundatie_estimata": "Fundație estimată",
  "struct.pas.rezistenta_fundatie": "Predimensionarea fundației",
  "struct.pas.model_fem": "Modelare structurală (FEM)",
  "struct.pas.incarcari": "Încărcări",
  "struct.pas.seism": "Analiza seismică",
  "struct.pas.deplasari_laterale": "Deplasări laterale (drift)",
  "struct.pas.combinatii": "Combinații",
  "struct.pas.eforturi": "Eforturi finale",
  "struct.pas.armare_grinzi": "Armarea grinzilor",
  "struct.pas.armare_pereti": "Armarea pereților (subsol și lamele)",
  "struct.pas.armare_stalpi": "Armarea stâlpilor + noduri",
  "struct.pas.armare_placa": "Armarea plăcii",
  "struct.pas.verificare_fundatie": "Verificarea fundației (reacțiuni reale)",
  "struct.pas.armare_fundatie": "Armarea grinzilor de fundare",
  "struct.pas.optimizare_structura": "Căutarea soluției (optimizare)",
  "struct.pas.link_cu_ref": "{pas} — deschide cu {ref} selectat",
  "struct.pas.link_verificare": "{pas} — deschide verificarea",

  // --- STRUCTURĂ · cele 6 capitole de citire -----------------------------
  "struct.cap.1.titlu": "Ce am de la client",
  "struct.cap.1.intrebare": "„Ce scrie în documentele mele?”",
  "struct.cap.1.granularitate": "per document · strat · nivel · perete",
  "struct.cap.2.titlu": "Ce structură propun",
  "struct.cap.2.intrebare": "„Ce sistem, și unde pun elementele?”",
  "struct.cap.2.granularitate": "per clădire → element",
  "struct.cap.3.titlu": "Modelul și ce apasă",
  "struct.cap.3.intrebare": "„Modelul e credibil? Cum se mișcă?”",
  "struct.cap.3.granularitate": "per mod · caz · direcție · combinație · nivel",
  "struct.cap.4.titlu": "Fundația",
  "struct.cap.4.intrebare": "„Talpa ține pe reacțiunile reale?”",
  "struct.cap.4.granularitate": "per AX × combinație × metodă · 3 lecturi ale aceleiași presiuni",
  "struct.cap.5.titlu": "Elementul",
  "struct.cap.5.intrebare": "„Elementul ăsta ține, cu ce armătură?”",
  "struct.cap.5.granularitate": "per element × punct × zonă",
  "struct.cap.6.titlu": "Soluția",
  "struct.cap.6.intrebare": "„Am o soluție care trece și cât costă?”",
  "struct.cap.6.granularitate": "per soluție — ramurile arborelui, 4 roluri de fază",
  "struct.cap.ref.p1_geotehnic": "P1 geotehnic",
  "struct.cap.ref.p2_arhitectura": "P2 arhitectură",
  "struct.cap.ref.p3_strategie": "P3 strategie",
  "struct.cap.ref.p4_model": "P4 model",
  "struct.cap.ref.p5_estimare": "P5 estimare",
  "struct.cap.ref.p6_predimensionare": "P6 predimensionare",
  "struct.cap.ref.p17_verificarea": "P17 verificarea",
  "struct.cap.ref.p18_armarea": "P18 armarea →",
  "struct.cap.ref.p18_fundare": "P18 fundare",
  "struct.cap.ref.p19_cautarea": "P19 căutarea",

  // --- STRUCTURĂ · referințele scurte de pe cardul capitolului -----------
  "struct.cap.ref.p7": "P7",
  "struct.cap.ref.p8": "P8",
  "struct.cap.ref.p9": "P9",
  "struct.cap.ref.p10": "P10",
  "struct.cap.ref.p11": "P11",
  "struct.cap.ref.p12": "P12",
  "struct.cap.ref.p13": "P13",
  "struct.cap.ref.p14": "P14",
  "struct.cap.ref.p15": "P15",
  "struct.cap.ref.p16": "P16",

  // --- STRUCTURĂ · Acasă — harta capitolelor -----------------------------
  "struct.acasa.titlu": "Structură — harta capitolelor",
  "struct.acasa.chip": "Structură",
  "struct.acasa.sub": "cei 19 pași de calcul, grupați în 6 capitole de citit — numerotarea 1→18 e ordinea de RULARE, nu de citire",
  "struct.acasa.vezi_pipeline": "vezi pipeline-ul de calcul (19 pași) →",
  "struct.acasa.cap_nr": "CAP. {nr}",
  "struct.acasa.nerulat": "nerulat încă",
  "struct.acasa.partial": "în lucru / parțial",
  "struct.acasa.um_t1": "s · T₁",
  "struct.acasa.um_picate_cost": "picate · {cost} k€",
  "struct.acasa.um_picate": "verificări picate",
  "struct.acasa.um_picate_din": "picate din {total}",
  "struct.acasa.bucla_titlu": "Bucla:",
  "struct.acasa.bucla": "capitolul 6 rescrie capitolul 2 (secțiuni, poziții) și reia capitolele 3–5. De asta <b>Soluția e home-ul</b>, nu ultimul pas: întrebarea cu care intri în proiect e «ce mai pică\», nu «ce scrie în studiul geotehnic\».",

  // --- STRUCTURĂ · antetul unui pas --------------------------------------
  "struct.antet.capitol": "Cap. {nr} — {titlu}",

  // --- STRUCTURĂ · Pipeline — cei 19 pași --------------------------------
  "struct.pipe.titlu": "Pipeline — cei 19 pași de calcul",
  "struct.pipe.ordine": "ordinea de rulare",
  "struct.pipe.harta": "harta capitolelor →",
  "struct.pipe.harta_titlu": "aceiași 19 pași, grupați pe cele 6 capitole de CITIRE — cu cifra fiecărui capitol",
  "struct.pipe.opreste": "Oprește",
  "struct.pipe.opreste_titlu": "Oprește lanțul după pasul curent",
  "struct.pipe.capitolul": "Capitolul {nr}",
  "struct.pipe.imbunatatiri": "Îmbunătățiri viitoare →",
  "struct.pipe.fara_reactiuni": "fără reacțiuni",
  "struct.pipe.fara_reactiuni_titlu": "Fundația e doar PREDIMENSIONATĂ. Verificarea pe reacțiunile reale cere Pașii 7–12 rulați; «Rulează tot» reia singur Pasul 6.",
  "struct.pipe.ruleaza": "rulează",
  "struct.pipe.ruleaza_titlu": "Serverul lucrează la pasul ăsta acum",

  // --- STRUCTURĂ · antetul comun al unui pas -----------------------------
  "struct.antet.pipeline": "Pipeline",
  "struct.antet.verdicte_titlu": "verdictele pasului, așa cum le colectează Pasul 19 pe starea curentă",
  "struct.antet.picate": "{picate} picate din {total}",
  "struct.antet.toate_trec": "{n} verificări · toate trec",
  "struct.antet.la_limita": "{n} de revizuit",
  "struct.antet.fara_verdicte": "fără verdicte proprii — pasul decide, nu verifică",

  // --- STRUCTURĂ · fișa pasului, la hover pe titlu -----------------------
  "struct.fisa.intrebare": "La ce întrebare răspunde",
  "struct.fisa.ce_face": "Ce face",
  "struct.fisa.primeste": "Ce primește, și de unde",
  "struct.fisa.decide": "Ce decide pasul, și nimeni altcineva",
  "struct.fisa.verifica": "Ce verifică",
  "struct.fisa.da_mai_departe": "Cui dă mai departe",
  "struct.fisa.capcane": "⚠ Ce se înțelege greșit cel mai des",
  "struct.fisa.eticheta": "Ce face pasul {nr}",
  "struct.fisa.semn": "ce face pasul",
  "struct.fisa.are_nevoie": "Are nevoie de:",

  // --- STRUCTURĂ · notele pasului ----------------------------------------
  "struct.note.titlu": "Notele pasului",
  "struct.note.ce": "Cum s-au obținut cifrele de mai sus — ce s-a citit, ce s-a completat, ce s-a presupus. Nu sunt verificări: nimic de aici nu pică și nu trece. Verdictele stau în tabelele de verificări ale pasului și se adună în Pasul 19.",
  "struct.note.armarii": "Notele armării",
  "struct.note.armarii_ce": "Diagnostice de calcul pe grinzi individuale — o diagramă de moment care nu are forma așteptată, un reazem tratat altfel. Verdictele grinzilor (inclusiv axialul și torsiunea) sunt în tabelele fiecărei grinzi și se adună în Pasul 19.",
  "struct.note.modelului": "Notele modelului",
  "struct.note.modelului_ce": "Ce a intrat în model și cu ce valoare — pereți turnați din beton în locul zidăriei, axe lățite individual de Pasul 17, elemente completate. Nu sunt verificări; verdictele modelului sunt gate-ul modal și masa participantă, de mai sus.",
  "struct.note.panouri": "Notele panourilor",
  "struct.note.combinatii": "Notele combinațiilor",

  // --- STRUCTURĂ · deciziile pasului -------------------------------------
  "struct.decizii.titlu": "Deciziile pasului",
  "struct.decizii.intro": "Parametri pe care pasul i-a ales sau i-a presupus — nu rezultate de calcul și nu verificări. Se schimbă schimbând intrarea din ultima coloană, urmat de rerularea lanțului.",
  "struct.decizii.col_ce": "Ce s-a decis",
  "struct.decizii.col_valoare": "Valoarea",
  "struct.decizii.col_sursa": "De unde vine",
  "struct.decizii.col_schimba": "Ce schimbă în calcul",
  "struct.decizii.col_cum": "Cum se schimbă",
  "struct.decizii.pas2": "Deciziile Pasului 2",
  "struct.decizii.pas3": "Deciziile Pasului 3",
  "struct.decizii.pas6": "Deciziile Pasului 6",
  "struct.decizii.pas7": "Deciziile Pasului 7",

  // --- STRUCTURĂ · cartonașul de explicație ------------------------------
  "struct.info.pe_scurt": "Pe scurt",
  "struct.info.de_ce": "De ce e așa",
  "struct.info.parametrii": "Parametrii, unul câte unul — și de unde vine fiecare",
  "struct.info.de_unde_vine": "de unde vine: {sursa}",
  "struct.info.explicatie": "Explicație",
  "struct.info.explicatie_pentru": "Explicație: {ce}",
  "struct.hover.mai_jos": "⌄ mai jos — derulează în cartonaș",
  "struct.hover.inchide": "✕ închide (Esc)",
  "struct.hover.fixeaza": "clic = fixează",

  // --- STRUCTURĂ · simbolul explicat -------------------------------------
  "struct.simbol.ce_fel": "Ce fel de cifră e",
  "struct.simbol.formula": "Formula:",
  "struct.simbol.cum_obtinut": "Cum s-a obținut cifra:",
  "struct.simbol.articol": "Articol:",
  "struct.simbol.contexte": "În fiecare verificare înseamnă:",
  "struct.simbol.de_unde_aici": "De unde vine aici:",

  // --- STRUCTURĂ · op-urile refuzate de Pasul 4 --------------------------
  "struct.opuri.titlu": "Op-uri refuzate de validarea Pasului 4: {n}",
  "struct.opuri.grupate#n": ", grupate pe {n} cauză|, grupate pe {n} cauze|, grupate pe {n} de cauze",
  "struct.opuri.col_elemente": "Elementele",
  "struct.opuri.col_context": "Contextul",
  "struct.opuri.col_motiv": "Motivul refuzului",
  "struct.opuri.col_ce": "Ce s-a întâmplat",
  "struct.opuri.aceeasi_cauza#n": "{n} element cu aceeași cauză|{n} elemente cu aceeași cauză|{n} de elemente cu aceeași cauză",

  // --- STRUCTURĂ · bara corpurilor ---------------------------------------
  "struct.corpuri.aria": "Corpurile soluției",
  "struct.corpuri.ansamblu": "ansamblu",
  "struct.corpuri.toate_titlu": "Întregul complex: toate corpurile în același cadru, fiecare analizat separat",
  "struct.corpuri.picate#n": "{cod} — 1 critică sau globală pică|{cod} — {n} critice și globale pică|{cod} — {n} de critice și globale pică",

  // --- STRUCTURĂ · top solicitări ----------------------------------------
  "struct.top.grinzi": "Top solicitări — grinzi",
  "struct.top.stalpi": "Top solicitări — stâlpi",
  "struct.top.sub": "{elemente} elemente × {combinatii} combinații — se arată maximul fiecărui element",
  "struct.top.nota_stalpi": "după axialul maxim; tripletele (N, M₂, M₃) concomitente intră direct în P–M–M la Pasul 15",
  "struct.top.nivel": "Nivel",
  "struct.top.combinatia": "Combinația",
  "struct.top.punctul": "Punctul",
  "struct.top.elementul": "elementul →",

  // --- STRUCTURĂ · evidențierea în 3D ------------------------------------
  "struct.evid.titlu": "Evidențiază",
  "struct.evid.nimic": "nimic",
  "struct.evid.nimic_titlu": "nimic evidențiat: culorile proprii ale scenei",
  "struct.evid.familie_bare": "bare",
  "struct.evid.familie_etrieri": "etrieri",
  "struct.evid.familie_stalpi": "stâlpi",
  "struct.evid.familie_grinzi": "grinzi",
  "struct.evid.familie_fundatie": "grinzi de fundare",
  "struct.evid.tip": "tip {n}",
  "struct.evid.bucati": "{n} buc.",
  "struct.evid.bucati_in": "{n} buc. în {elemente} elemente",
  "struct.evid.elemente": "{n} elemente",
  "struct.evid.rand#n": "{n} tip de {nume}: alege unul ca să vezi unde e în clădire, sau toată familia|{n} tipuri de {nume}: alege unul ca să vezi unde e în clădire, sau toată familia|{n} de tipuri de {nume}: alege unul ca să vezi unde e în clădire, sau toată familia",

  // --- STRUCTURĂ · layerele scenei 3D ------------------------------------
  "struct.layere.fel": "Felul randării",
  "struct.layere.randare": "Randare {nume}",

  // --- STRUCTURĂ · scheletul de încărcare al modelului 3D ----------------
  "struct.schelet.incarca": "Se încarcă modelul 3D",

  // --- STRUCTURĂ · metoda implementată vs normativ -----------------------
  "struct.am.titlu": "Metoda implementată vs normativ",
  "struct.am.intro": "Comportamentul implicit este metoda de lucru a biroului. Verificarea normativă rulează oricum, în paralel — nu înlocuiește, ci însoțește rezultatul. Deschide un punct ca să vezi ambele variante, una lângă alta.",
  "struct.am.nume_atentie": "cu impact pe proiectul acesta",
  "struct.am.puncte#n": "— {n} punct de divergență|— {n} puncte de divergență|— {n} de puncte de divergență",
  "struct.am.din_care": ", din care {n} {nume}",
  "struct.am.stringe": "strânge-le pe toate",
  "struct.am.desfasoara": "desfășoară-le pe toate",
  "struct.am.comutator": "comutator:",
  "struct.am.comutator_titlu": "unde stă comutatorul acestui comportament",
  "struct.am.impact": "Impact pe acest proiect",
  "struct.am.implementat": "Implementat",
  "struct.am.normativ": "Normativ",

  // --- STRUCTURĂ · tabelul γ_Rd ------------------------------------------
  "struct.gamma.titlu": "γ_Rd — suprarezistența la calculul capabil",
  "struct.gamma.sub": " — {sistem}, clasa {clasa}",
  "struct.gamma.explicatie": "γ_Rd acoperă diferența dintre rezistența de calcul a zonei disipative și cea pe care o dezvoltă efectiv (oțelul real e mai tare decât cel de calcul și se consolidează la curgere). Cu cât regimul cere mai multă ductilitate, cu atât zona plastică e împinsă mai adânc în consolidare, deci valorile de la DCH sunt mai mari decât cele de la DCM. La DCL nu se face calcul capabil — eforturile de proiectare sunt cele din analiză (P100-1/2013 §5.2.3.3.1(11) și §5.5.1(1)) —, deci γ_Rd = 1,00 peste tot. Valorile se iau din normativ, după clasa de la Pasul 3: se schimbă singure dacă se schimbă clasa, la rerularea pasului. Extrasul cu articolul fiecărei cifre e în",
  "struct.gamma.coloana": " Coloana din dreapta arată ce ar da ",
  "struct.gamma.pe_aceeasi_clasa": " pe aceeași clasă — ",
  "struct.gamma.nu_difera": "aici nu diferă la nicio verificare",
  "struct.gamma.difera": "diferă la {n} din {total}",
  "struct.gamma.sistem_nota": ". Sistemul e o constantă a metodei («sistem_calcul»); el comută și două formule întregi (ancorarea prin nod și compresiunea diagonalei nodului), nu doar cifrele de mai jos.",
  "struct.gamma.col_verificare": "Verificarea",
  "struct.gamma.col_unde": "Unde intră",
  "struct.gamma.col_sursa": "Sursa",

  // --- STRUCTURĂ · op-urile refuzate (restul) ----------------------------
  "struct.opuri.aplicarea": "aplicarea overlay-ului",
  "struct.opuri.tainuite#n": "{n} avertisment nu a încăput în raportul salvat (serverul păstrează primele 20).|{n} avertismente nu au încăput în raportul salvat (serverul păstrează primele 20).|{n} de avertismente nu au încăput în raportul salvat (serverul păstrează primele 20).",
  "struct.evid.toate#n": "toate ({n} tip)|toate ({n} tipuri)|toate ({n} de tipuri)",

  // --- STRUCTURĂ · numele layerelor 3D -----------------------------------
  "struct.layere.clasic": "Clasic",
  "struct.layere.realist": "Realist",

  // --- STRUCTURĂ · ce NU e în cazurile de încărcare (Pasul 8) ------------
  "struct.am.incarcari_titlu": "Ce NU e în cazurile de încărcare",
  "struct.am.incarcari_atentie": "de partea neacoperitoare",
  "struct.am.incarcari_intro": "Catalogul de mai sus e tot ce apasă pe structură în acest calcul. Aici sunt acțiunile și ipotezele pe care normativul le cere și care NU au ajuns în el — cu impactul lor măsurat pe proiectul acesta. Marcate sunt cele de partea neacoperitoare (lipsește o solicitare); restul sunt alegeri mai grele decât cere norma. Împingerea pământului pe cutia de subsol e declarată la Pasul 6.",

  // --- STRUCTURĂ · titlul și explicația unei verificări ------------------
  "struct.ver.sursa_foaie": "foaia de calcul a structuristului",
  "struct.ver.sursa_ro": "legislația din România",
  "struct.ver.sursa_ec": "Eurocod",
  "struct.ver.ce_verifica": "Ce verifică",
  "struct.ver.formula": "Formula",
  "struct.ver.simboluri": "Ce înseamnă fiecare simbol",
  "struct.ver.divergenta": "⚠ Aici metoda diferă de {fata_de}",
  "struct.ver.implementat": "Implementat:",
  "struct.ver.normativul_cere": "Normativul cere:",
  "struct.ver.efectul": "Efectul:",
  "struct.ver.ce_ascunde": "Ce problemă ascunde",
  "struct.ver.solutii": "Soluții, de la cea mai ieftină la cea mai scumpă",
  "struct.ver.automat": "bucla o încearcă singură: {cum}",
  "struct.ver.marker_metoda": "⚠ metodă",
  "struct.ver.marker_metoda_titlu": "metoda diferă de normativul românesc — vezi explicația la hover",

  // --- STRUCTURĂ · proveniența unui simbol -------------------------------
  "struct.info.de_unde_prefix": "de unde vine: ",

  // --- STRUCTURĂ · pagina unui TIP de verificare -------------------------
  "struct.tipver.sursa_foaie": "foaia structuristului",
  "struct.tipver.sursa_ro": "legislația RO",
  "struct.tipver.sursa_ec": "Eurocod",
  "struct.tipver.verificari": "Verificări",
  "struct.tipver.prioritate": "prioritatea formulelor: foaie → legislație RO → Eurocod",
  "struct.tipver.divergenta": "⚠ metoda diferă de normativ",
  "struct.tipver.divergenta_text": "{implementat} (normativ: {normativ}) — {efect}",
  "struct.tipver.care_pica": "Elementele care o pică",
  "struct.tipver.niciunul": "niciunul",
  "struct.tipver.dupa_deficit": "ordonate după deficit",
  "struct.tipver.col_re": "R/E",
  "struct.tipver.col_deficit": "Deficit",
  "struct.tipver.col_detaliu": "Detaliu",
  "struct.tipver.toate_la#n": "toate {n} la {nivel}|toate {n} la {nivel}|toate {n} la {nivel}",
  "struct.tipver.tipar": "→ tiparul comun sugerează că o singură decizie le poate rezolva pe toate",
  "struct.tipver.solutii": "Soluții, de la ieftin la scump",
  "struct.tipver.automat": "bucla o încearcă singură",
  "struct.tipver.cand": "Când se aplică",
  "struct.tipver.link": "{eticheta} →",

  // --- STRUCTURĂ · detaliul unei verificări ------------------------------
  "struct.det.da": "da",
  "struct.det.nu": "nu",
  "struct.det.comparatia": "Comparația",
  "struct.det.fata_de": " față de {prag}",
  "struct.det.re": " → R/E = {re}",
  "struct.det.rezerva": " (rezervă {n} %)",
  "struct.det.lipsesc": " (lipsesc {n} %)",
  "struct.det.marja_chip": "acceptată cu marja practicii",
  "struct.det.marja": "R/E e sub 1, dar în marja de {n} % pe care biroul o acceptă la dimensionare.",
  "struct.det.fara_categorie": "Verificarea nu are (încă) o categorie în catalogul de explicații — cifrele de mai sus sunt cele emise de pas.",
  "struct.det.valorile": "Valorile din calcul",
  "struct.det.vezi_desenele": "vezi desenele și tabelele complete →",
  "struct.det.metoda_titlu": "metoda diferă de normativ — vezi explicația completă",
  "struct.det.ascunde": "▾ ascunde explicația",
  "struct.det.explicatia": "▸ explicația completă",

  // --- STRUCTURĂ · numele valorilor brute dintr-o verificare -------------
  "struct.brut.combo": "combinația",
  "struct.brut.loc": "locul",
  "struct.brut.punct": "punctul",
  "struct.brut.nivel": "nivelul",
  "struct.brut.M_cap": "M capabil [kNm]",
  "struct.brut.H_liber_m": "H liber [m]",
  "struct.brut.alpha_foaie": "α (foaia)",
  "struct.brut.indice_foaie": "indicele foii",
  "struct.brut.pas_cm": "pasul [cm]",
  "struct.brut.rho_eff": "ρ efectiv",
  "struct.brut.masa_x": "masa adunată pe X [%]",
  "struct.brut.masa_y": "masa adunată pe Y [%]",
  "struct.brut.masa_totala": "masa seismică totală [t]",
  "struct.brut.moduri_calculate": "moduri calculate",
  "struct.brut.moduri_folosite": "moduri folosite în analiza seismică",
  "struct.brut.moduri_min": "minimul de moduri cerut",
  "struct.brut.masurat_pe": "măsurat pe",
  "struct.brut.total_aplicat": "încărcare aplicată [kN]",
  "struct.brut.suma_reactiuni": "sumă reacțiuni [kN]",
  "struct.brut.dezechilibru_kn": "pierdut din încărcare [kN]",
  "struct.brut.dezechilibru_pct": "pierdut din încărcare [%]",
  "struct.brut.prag_pct": "pragul [%]",
  "struct.brut.valoare_pct": "măsurat [%]",
  "struct.brut.deficit_pct": "deficit [%]",
  "struct.brut.v_baza": "tăietoare de bază, analiza spectrală [kN]",
  "struct.brut.f_b_echivalent": "tăietoare de bază, metoda simplificată [kN]",
  "struct.brut.raport_v_fb": "raportul celor două",
  "struct.brut.T_fundamental": "perioada fundamentală [s]",
  "struct.brut.caz": "cazul de încărcare",

  // --- STRUCTURĂ · inventarul de bare și costurile elementului -----------
  "struct.inv.titlu": "Inventarul de bare & costuri",
  "struct.inv.kg_otel": "{n} kg oțel",
  "struct.inv.m3_beton": "{n} m³ beton",
  "struct.inv.precizie_titlu": "precizia se declară pe articol: exact / parțial / forfetar",
  "struct.inv.kg_m3": "{n} kg/m³",
  "struct.inv.kg_m3_titlu": "reperul proiectului de referință e 165 kg/m³",
  "struct.inv.eroare": "Extrasul nu s-a putut aduce (rulează Pasul 19 / devizul).",
  "struct.inv.se_aduce": "se aduce extrasul…",
  "struct.inv.fara_pozitii": "Extrasul n-are poziții pe elementul ăsta — armătura lui intră în articolul forfetar al capitolului.",
  "struct.inv.col_poz": "Poz.",
  "struct.inv.col_rol": "Rolul barei",
  "struct.inv.col_lungime": "Lungimea, din ce se compune",
  "struct.inv.col_buc": "Buc.",
  "struct.inv.col_kg": "kg",
  "struct.inv.cost_titlu": "Costul, cu rețeta de calcul",
  "struct.inv.derivat_titlu": "cantitate derivată din geometria elementului",
  "struct.inv.sumar": "material {material} · manoperă {manopera} · prețuri unitare din: {sursa}",
  "struct.inv.inca_pozitii": "+ {n} poziții",
  "struct.inv.nota_lungimi": "fiecare lungime își arată din ce se compune (ancoraj + deschidere + ancoraj) — nu o singură cifră opacă",
  "struct.inv.kg_pe_element": "{n} kg pe element",
  "struct.inv.pierderi": " (+{n} % pierderi la aprovizionare)",

  // --- STRUCTURĂ · costul stâlpului întreg -------------------------------
  "struct.stiva.titlu": "Costul stâlpului întreg",
  "struct.stiva.se_aduna": "se adună extrasul stivei…",
  "struct.stiva.fara_deviz": "Devizul nu s-a putut citi (rulează Pasul 19 / devizul).",
  "struct.stiva.titlu_cu_element": "Costul stâlpului întreg — {element}",
  "struct.stiva.col_beton": "Beton",
  "struct.stiva.col_cofraj": "Cofraj",
  "struct.stiva.col_otel": "Oțel",
  "struct.stiva.col_material": "Material",
  "struct.stiva.col_manopera": "Manoperă",
  "struct.stiva.col_total": "Total",
  "struct.stiva.infra": "infrastructură",
  "struct.stiva.infra_titlu": "se toarnă cu fundația, deci se plătește la infrastructură",
  "struct.stiva.tot_stalpul": "{element} — tot stâlpul",
  "struct.stiva.nota": "Aceeași rețetă ca la un singur nivel, însumată pe stivă: oțelul din extras (cu înnădirile și sporul de pierderi), betonul și cofrajul derivate din geometria fiecărui nivel. Mustățile apar o singură dată, la baza stivei. Prețuri unitare din: {sursa}.",
  "struct.stiva.densitate": " Densitatea de armare a stâlpului: {n} kg/m³.",
  "struct.stiva.neatribuit": "{n} kg din extrasul stivei n-au nimerit niciun nivel al ei",
  "struct.stiva.neatribuit_dupa": " — sunt numărați în total, dar verifică id-urile de plan.",

  // --- STRUCTURĂ · natura unei mărimi ------------------------------------
  "struct.natura.valoare": "valoare aplicată",
  "struct.natura.valoare_titlu": "SOLICITAREA — cifra pe care o produce structura pe proiectul acesta. Se compară cu o limită.",
  "struct.natura.limita": "limită",
  "struct.natura.limita_titlu": "LIMITA — pragul pe care valoarea aplicată nu are voie să-l depășească. Vine din normativ sau din metoda de calcul.",
  "struct.natura.capacitate": "capacitate",
  "struct.natura.capacitate_titlu": "CAPACITATEA — cât duce elementul așa cum e alcătuit. Se compară cu efortul cerut.",
  "struct.natura.geometrie": "dimensiune",
  "struct.natura.geometrie_titlu": "DIMENSIUNE — o mărime de geometrie decisă de pas; intră mai departe în desenul de execuție.",
  "struct.natura.intrare": "dată de intrare",
  "struct.natura.intrare_titlu": "DATĂ DE INTRARE — preluată ca atare din documente, din normativ sau din setări. Motorul nu o alege și nu o compară cu nimic; ea intră în calculele de mai departe.",
  "struct.natura.derivat": "derivată",
  "struct.natura.derivat_titlu": "MĂRIME DERIVATĂ — nu se caută și nu se alege: rezultă din altele, și se recalculează după fiecare schimbare a lor.",
  "struct.marime.lipsa": "valoarea nu a fost transmisă de pagină",

  // --- STRUCTURĂ · harta gropilor de pământ ------------------------------
  "struct.gropi.exact_contur": "conturul parcelei, din acte",
  "struct.gropi.exact_punct": "punct din acte",
  "struct.gropi.exact_strada": "aproximativ — geocodat după stradă",
  "struct.gropi.exact_localitate": "aproximativ — geocodat după localitate, deci undeva în zona asta",
  "struct.gropi.lotul": "lotul",
  "struct.gropi.tooltip": "{nume}<br>{km} km · {cost}",
  "struct.gropi.folosita": " · folosită",
  "struct.gropi.drum_sosea": "drum pe șosea · {km} km",
  "struct.gropi.linie_dreapta": "linie dreaptă × 1,3 · {km} km (estimare)",
  "struct.gropi.se_incarca": "se încarcă harta…",
  "struct.gropi.col_groapa": "Groapă",
  "struct.gropi.col_distanta": "Distanță",
  "struct.gropi.col_curse": "Curse",
  "struct.gropi.col_transport": "Transport",
  "struct.gropi.col_depozitare": "Depozitare",
  "struct.gropi.col_total": "Total",
  "struct.gropi.estimare_titlu": "estimare: linie dreaptă × 1,3 — routerul n-a răspuns pentru groapa asta",
  "struct.gropi.masurat_titlu": "drum măsurat pe rețeaua de șosele",

  // --- STRUCTURĂ · barele longitudinale și înfășurătoarea ----------------
  "struct.bare.fibra_sus": "Armătura de sus",
  "struct.bare.fibra_jos": "Armătura de jos",
  "struct.bare.suprapunere": "suprapunere {bare} · l₀ = {l0} m la s = {s} m",
  "struct.bare.zona": "\\nzona: {zona}",
  "struct.bare.fortata": "\\nFORȚATĂ — n-a existat nicio zonă liberă la îndemână",
  "struct.bare.petrecere": "petrecere {fata} · {bare} · l₀ = {l0} m la {s} m · {zona}",
  "struct.bare.fara_zona": "fără zonă liberă",

  // --- STRUCTURĂ · planul din Studio -------------------------------------
  "struct.plan.fundatie": "Fundație — talpa sub {nivel}",
  "struct.plan.model": "Model structural — {nivel}",
  "struct.plan.link_ax": "verificările axului →",
  "struct.plan.nivel_titlu": "{stalpi} stâlpi · {grinzi} grinzi",
  "struct.plan.fundatie_buton": "fundație",
  "struct.plan.fundatie_titlu": "talpa la lățimea ei reală (B = {B} m, D_f = {D} m) și axele denumite ale Pasului 6, peste planul nivelului de jos — click pe un ax pentru verificările lui",

  // --- STRUCTURĂ · desenul cotat al unui element -------------------------
  "struct.desen.cota_sapatura": "cota de la care se sapă",
  "struct.desen.talpa": "talpă {n}",
  "struct.desen.umplutura": "umplutură {n}",
  "struct.desen.inima": "inimă {n}",
  "struct.desen.balast": "balast {n} cm, apoi pământ",
  "struct.desen.plasa": "plasă",
  "struct.desen.la_mijloc": "la mijloc",
  "struct.desen.plasa_mijloc": "plasa stă la mijlocul grosimii: betonul simplu duce momentul, iar ea lucrează la contracția împiedicată",
  "struct.desen.plasa_jos": "plasa coboară la fața de jos: acolo e întinderea sub încărcare, iar betonul simplu nu duce momentul",
  "struct.desen.moment_nota": " (M = {med} kNm/m, beton simplu {mrd} kNm/m)",

  // --- STRUCTURĂ · localizarea elementului în clădire --------------------
  "struct.loccl.cere_fem": "Localizarea în clădire cere modelul Pasului 7 (FEM) — rulează-l și revino.",
  "struct.loccl.fara_pas": "<b>{ref}</b> — element fără pas de armare (intră în model doar cu greutatea lui)",
  "struct.loccl.aceeasi_pagina": "click → selectează <b>{ref}</b> în pagina asta",
  "struct.loccl.alt_pas": "click → <b>{pas} · {ref}</b>",

  // --- STRUCTURĂ · lista elementelor (capitolul 5) -----------------------
  "struct.lista.titlu_gol": "Elementele",
  "struct.lista.gol": "Lista se umple după rularea pașilor de armare (13–16).",
  "struct.lista.pipeline": "pipeline →",
  "struct.lista.titlu": "Capitolul 5 — Elementele",
  "struct.lista.sub": "opțiunea din listă poartă verdictul — sortat: întâi ce pică, apoi rezerva cea mai mică",
  "struct.lista.filtru_tip": "Tip",
  "struct.lista.tip_toate": "toate",
  "struct.lista.tip_grinzi": "grinzi",
  "struct.lista.tip_stalpi": "stâlpi",
  "struct.lista.tip_pereti": "pereți",
  "struct.lista.tip_lamele": "lamele",
  "struct.lista.tip_ochiuri": "ochiuri de placă",
  "struct.lista.filtru_verdict": "Verdict",
  "struct.lista.neconforme": "neconforme · {n}",
  "struct.lista.la_limita": "de revizuit · {n}",
  "struct.lista.doar_probleme": "doar problemele",
  "struct.lista.doar_probleme_titlu": "ascunde elementele conforme",
  "struct.lista.filtru_nivel": "Nivel",
  "struct.lista.col_tip": "Tip",
  "struct.lista.col_sectiune": "Secțiune",
  "struct.lista.col_re": "R/E min",
  "struct.lista.col_verdict": "Verdict",
  "struct.lista.col_criteriu": "Criteriul care guvernează",
  "struct.lista.deschide": "deschide →",
  "struct.lista.ascunse": "+ {n} elemente conforme — ",
  "struct.lista.arata_toate": "arată-le pe toate",

  // --- STRUCTURĂ · panoul axului de fundație din Studio ------------------
  "struct.drax.inchide": "închide",
  "struct.drax.doar_predim": "Fundația e doar predimensionată (Pasul 6) — verificarea pe reacțiunile reale vine după Pașii 7–12.",
  "struct.drax.dupa_p17": "Verificările axului apar după rularea Pasului 17.",
  "struct.drax.pagina_fundatiei": "pagina fundației →",
  "struct.drax.ax": "ax",
  "struct.drax.antet": "{directie} · {stalpi} stâlpi",
  "struct.drax.latit": " · lățit local",
  "struct.drax.tasare": " · tasare {n} cm",
  "struct.drax.lectura_metoda": "p_ef metodă",
  "struct.drax.lectura_np112": "p_ef NP 112",
  "struct.drax.pagina_axului": "pagina axului (secțiune, context) →",
  "struct.drax.verificarile": "Verificările axului",
  "struct.drax.in_tablou": "Verificările axului apar în tabloul global — ",
  "struct.drax.verificari_link": "Verificări →",

  // --- STRUCTURĂ · Studio, vederea «Componente» (tipuri și clase) --------
  "struct.comp.tab_stalpi": "Elemente verticale",
  "struct.comp.tab_grinzi": "Grinzi",
  "struct.comp.tab_fundatie": "Grinzi de fundare",
  "struct.comp.tab_placa": "Ochiuri de placă",
  "struct.comp.tab_bare": "Bare",
  "struct.comp.tab_etrieri": "Etrieri",
  "struct.comp.tab_cofrare": "Cofrare",
  "struct.comp.tab_gol": "nimic de arătat încă: pasul care produce familia n-a rulat pe soluția asta",
  "struct.comp.fam_placa": "Ochiuri de placă (panouri)",
  "struct.comp.fam_placa_ce": "un tip = gabaritul ochiului (la 5 cm), grosimea plăcii și cele patru plase, jos și sus",
  "struct.comp.ochiuri#n": "{n} ochi|{n} ochiuri|{n} de ochiuri",
  "struct.comp.desface_nota": "Clic pe un tip ca să-i vezi elementele; fiecare element deschide pagina lui.",
  "struct.comp.desface_tot": "Desface toate",
  "struct.comp.strange_tot": "Strânge toate",
  "struct.comp.titlu": "Componentele structurii",
  "struct.comp.intro": "Din câte lucruri diferite e făcută structura. Un tip se fasonează sau se cofrează o dată și se repetă; fiecare tip în plus e un șablon în plus pe șantier. Costul e cel din articolele devizului, repartizat pe tip — suma tipurilor unei familii e suma articolelor ei. Aceleași id-uri le găsești în scena 3D, la «Evidențiază».",
  "struct.comp.fara_tip": "{pozitii} poziții calculate ({kg} kg, în {elemente} elemente) nu poartă un tip scris de pasul lor — rulează din nou pașii de armare ca să le primească.",
  "struct.comp.fam_bare": "Bare",
  "struct.comp.fam_bare_ce": "un tip = forma și diametrul; lungimea nu intră — se taie, nu se fasonează altfel",
  "struct.comp.fam_etrieri": "Etrieri și agrafe",
  "struct.comp.fam_etrieri_ce": "un tip = forma, diametrul și laturile ochiului: doi etrieri cu aceeași desfășurată și alt ochi sunt două șabloane",
  "struct.comp.fam_stalpi": "Stâlpi și lamele (segmente de nivel)",
  "struct.comp.fam_stalpi_ce": "un tip = clasa de execuție: aceeași secțiune, aceeași formă, aceeași carcasă",
  "struct.comp.fam_grinzi": "Grinzi (segmente)",
  "struct.comp.fam_grinzi_ce": "un tip = clasa de execuție: secțiunea și toată armarea; deschiderea nu intră",
  "struct.comp.fam_fundatie": "Grinzi de fundare (axe)",
  "struct.comp.fam_fundatie_ce": "un tip = clasa de execuție a axului: secțiunea și armarea întreagă",
  "struct.comp.peste_tinta": "peste ținta biroului de {tinta}: fiecare tip în plus e un cofraj sau un șablon de fasonare în plus",
  "struct.comp.in_tinta": "în ținta biroului de cel mult {tinta} tipuri",
  "struct.comp.nr_tipuri#n": "{n} tip · țintă {tinta}|{n} tipuri · țintă {tinta}|{n} de tipuri · țintă {tinta}",
  "struct.comp.gol_bare": "— niciun tip: pașii de armare n-au rulat —",
  "struct.comp.gol_clase": "— nicio clasă: pasul de armare n-a rulat —",
  "struct.comp.col_tip": "Tip",
  "struct.comp.col_clasa": "Clasă",
  "struct.comp.col_ce": "Ce e",
  "struct.comp.col_utilizari": "Utilizări",
  "struct.comp.col_otel": "Oțel",
  "struct.comp.col_material": "Material",
  "struct.comp.col_manopera": "Manoperă",
  "struct.comp.col_cost": "Cost",
  "struct.comp.col_beton": "Beton",
  "struct.comp.col_cofraj": "Cofraj",
  "struct.comp.buc": "{n} buc.",
  "struct.comp.in_elemente": " · în {n} elemente",
  "struct.comp.kg_m": " · {n} m",
  "struct.comp.deschideri": " · deschideri {min}–{max} m",
  "struct.comp.membri_titlu": "arată elementele clasei",
  "struct.comp.axe#n": "{n} ax|{n} axe|{n} de axe",
  "struct.comp.elemente#n": "{n} element|{n} elemente|{n} de elemente",
  "struct.comp.sectiuni_titlu": "Elementele verticale — tipuri de secțiune",
  "struct.comp.sectiuni_nr#n": "{n} tip · țintă {tinta}|{n} tipuri · țintă {tinta}|{n} de tipuri · țintă {tinta}",
  "struct.comp.sectiuni_ce": "Cofrajul b × L al fiecărei piese de stâlp sau de lamelă, pe fiecare nivel — stâlpul de 30 × 30 se numără și el. Ținta biroului e cel mult {tinta} tipuri, {exceptie} numai excepțional.",
  "struct.comp.sectiuni_peste": "peste ținta biroului de {tinta} tipuri (excepția: {exceptie})",
  "struct.comp.sectiuni_in": "în ținta biroului de cel mult {tinta} tipuri",
  "struct.comp.col_sectiune": "Secțiunea",
  "struct.comp.col_piese": "Piese",
  "struct.comp.col_elemente": "Elemente",
  "struct.comp.col_de_ce": "De ce rămâne",
  "struct.comp.piese#n": "{n} piesă|{n} piese|{n} de piese",
  "struct.comp.piese_titlu": "o piesă = elementul pe un nivel",
  "struct.comp.sectiuni_fara_armare": "Clasele de execuție — armarea, cofrajul pe înălțimi și costul fiecărui tip — apar după pașii de armare, în calculul de detaliu.",

  // --- STRUCTURĂ · planul de armare (colile, mărcile, DXF / DWG) ----------
  "struct.studio.vedere.plan_armare": "Plan de armare",
  "struct.studio.gol_plan_armare": "Planul de armare se desenează din pașii de armare, care n-au rulat pe rândul ăsta — pe o schiță nu rulează.",
  "struct.studio.gol_armare_macro": "Rândul privit e «{macro}»; armarea rulează pe «{detaliu}» — rândul lui de detaliu e în meniul soluției.",
  "struct.studio.gol_armare_macro_fara": "Rândul privit e «{macro}»; armarea rulează pe «{detaliu}», care nu a pornit încă pe soluția asta.",
  "struct.pa.titlu": "Planul de armare",
  "struct.pa.gol": "Nicio coală încă: planșele apar după ce rulează pașii de armare.",
  "struct.pa.coli_grinzi": "Grinzi",
  "struct.pa.coli_esv": "Elemente verticale",
  "struct.pa.coli_fundatie": "Fundație",
  "struct.pa.coli_placa": "Plăci",
  "struct.pa.set_intreg": "Setul întreg",
  "struct.pa.coala_aleasa": "Coala aleasă",
  "struct.pa.descarca_coli_titlu": "descarcă coala aleasă sau setul întreg, ca DXF sau DWG",
  "struct.pa.link_element": "pagina elementului",
  "struct.pa.se_descarca": "Se descarcă…",
  "struct.pa.dxf_coala_titlu": "descarcă coala ca fișier DXF — formatul exact, așa cum a fost desenată",
  "struct.pa.dwg_coala_titlu": "descarcă coala ca fișier DWG, convertit din DXF pe server",
  "struct.pa.dxf_tot_titlu": "descarcă toate colile într-un singur fișier DXF",
  "struct.pa.dwg_tot_titlu": "descarcă toate colile într-un singur fișier DWG, convertit din DXF pe server",
  "struct.pa.dwg_indisponibil": "convertorul DXF → DWG nu e instalat pe server; descarcă DXF-ul",
  "struct.pa.dwg_pierdute": "DWG-ul s-a descărcat, dar conversia a pierdut {n} entități — DXF-ul e fișierul exact. {mesaj}",
  "struct.pa.descarcare_esuata": "Fișierul nu s-a putut descărca.",
  "struct.pa.el_titlu": "Plan de armare",
  "struct.pa.el_desen": "planul de armare al elementului {ref}",
  "struct.pa.descarca": "Descarcă",
  "struct.pa.descarca_titlu": "descarcă planul de armare al lui {ref}",
  "struct.pa.fel_dxf": "DXF — exact, cum e desenat",
  "struct.pa.fel_dwg": "DWG — convertit din DXF",
  "struct.pa.dxf_element_titlu": "desenul elementului ca fișier DXF — formatul exact, cum e desenat",
  "struct.pa.dwg_element_titlu": "desenul elementului ca fișier DWG, convertit din DXF pe server",
  "struct.pa.ecran_complet": "Ecran complet",
  "struct.pa.iesi_ecran_complet": "Ieși din ecranul complet",
  "struct.pa.deschide": "Deschide în Plan de armare",
  "struct.pa.deschide_titlu": "coala întreagă, în vederea «Plan de armare» a Studioului",
  "struct.pa.fam_grinda": "bară de grindă",
  "struct.pa.fam_fundatie": "bară de grindă de fundare",
  "struct.pa.fam_placa_sus": "bară de placă, la partea superioară",
  "struct.pa.fam_placa_jos": "bară de placă, la partea inferioară",
  "struct.pa.fam_vertical": "bară verticală (stâlp, lamelă)",
  "struct.pa.fam_orizontal": "bară orizontală de perete",
  "struct.pa.fam_etrier": "etrier",
  "struct.pa.fam_agrafa": "agrafă / călăreț",
  "struct.pa.marca_eticheta": "marca {marca}: pagina barei",
  "struct.pa.marca_deschide": "clic → pagina mărcii: forma cotată și elementele care o folosesc",
  "struct.pa.marca_tip": "tipul {tip} din registrul componentelor",
  "struct.pa.marca_cifre": "{nr} bucăți în {elemente} elemente · {kg} kg · {m} m",
  "struct.pa.marca_fara_tip": "Tipul nu e în registrul componentelor al rândului ăsta — reruleaza pașii de armare ca să-l scrie.",
  "struct.pa.marca_necunoscuta": "Marcă necunoscută",
  "struct.pa.marca_necunoscuta_nota": "«{marca}» nu are forma unei mărci: numărul tipului și sufixul familiei (3g, 7gF, 1s, 2i) sau familia și numărul (e1, c2, v3, o1).",
  "struct.pa.forma_titlu": "Forma cotată",
  "struct.pa.forma_desen": "forma mărcii {marca}",
  "struct.pa.forma_lipsa": "Forma nu e desenată încă pentru marca asta.",
  "struct.pa.unde_titlu": "Unde se folosește",
  "struct.pa.unde_sub": "{elemente} elemente · {buc} bucăți · {kg} kg",
  "struct.pa.unde_gol": "Nicio poziție din extras nu poartă tipul ăsta.",
  "struct.pa.col_element": "Elementul",
  "struct.pa.col_nivel": "Nivel",
  "struct.pa.col_rol": "Rol",
  "struct.pa.col_marca": "Marcă",
  "struct.studio.vedere.plan_cofraj": "Plan de cofraj",
  "struct.studio.gol_plan_cofraj": "Planul de cofraj se desenează din modelul structural (Pasul 7), care n-a rulat pe rândul ăsta.",
  "struct.pc.titlu": "Planul de cofraj",
  "struct.pc.gol": "Nicio coală încă: planul de cofraj apare după ce rulează modelul structural.",
  "struct.pc.coli_niveluri": "Coli",
  "struct.studio.vedere.plan_sapatura": "Plan de săpătură",
  "struct.studio.gol_plan_sapatura": "Planul de săpătură se desenează din modelul structural (Pasul 7), care n-a rulat pe rândul ăsta.",
  "struct.psap.titlu": "Planul de săpătură",
  "struct.psap.gol": "Nicio coală încă: planul de săpătură apare după ce rulează modelul structural cu o fundație în el.",
  "struct.psap.coli": "Coli",

  // --- STRUCTURĂ · planul de cofrare -------------------------------------
  "struct.cof.intro": "Din câte cofraje diferite se toarnă structura: {total} în total, ținta biroului fiind cel mult {tinta} de fiecare fel. Un cofraj se confecționează o dată și se montează de câte ori are utilizări; fiecare tip în plus e un panou în plus de făcut, depozitat și mutat. Suprafețele și costul sunt cele din articolele de cofraj ale devizului, repartizate pe tip.",
  "struct.cof.fam_stalpi": "Cofraje de stâlp",
  "struct.cof.fam_stalpi_ce": "un tip = secțiunea (și forma, la cei în L/T) pe înălțimea nivelului; patru fețe",
  "struct.cof.fam_grinzi": "Cofraje de grindă",
  "struct.cof.fam_grinzi_ce": "un tip = secțiunea inimii de sub placă pe LUMINA dintre reazeme — două deschideri egale înseamnă același cofraj",
  "struct.cof.fam_fundatie": "Cofraje de grindă de fundare",
  "struct.cof.fam_fundatie_ce": "un tip = secțiunea inimii cofrate; talpa se toarnă în șanț, lungimea nu intră",
  "struct.cof.fam_pereti": "Cofraje de perete",
  "struct.cof.fam_pereti_ce": "un tip = grosimea pe înălțimea nivelului, două fețe",
  "struct.cof.fam_placa": "Panouri de planșeu",
  "struct.cof.fam_placa_ce": "un tip = gabaritul ochiului dintre grinzi (la 5 cm) și grosimea plăcii",
  "struct.cof.peste_tinta": "peste ținta biroului de {tinta}: fiecare cofraj în plus se confecționează și se depozitează separat",
  "struct.cof.in_tinta": "în ținta biroului de cel mult {tinta} cofraje diferite",
  "struct.cof.nr_cofraje#n": "{n} cofraj · țintă {tinta}|{n} cofraje · țintă {tinta}|{n} de cofraje · țintă {tinta}",
  "struct.cof.m2_cost": "{m2} m² · {cost}",
  "struct.cof.gol": "— niciun cofraj: elementele familiei nu sunt încă în cantități —",
  "struct.cof.col_cofraj": "Cofraj",
  "struct.cof.col_ce": "Ce e",
  "struct.cof.col_montari": "Montări",
  "struct.cof.col_suprafata": "Suprafață",
  "struct.cof.membri_titlu": "arată elementele turnate cu cofrajul ăsta",
  "struct.cof.montari#n": "{n} montare|{n} montări|{n} de montări",
  "struct.cof.fara_cofraj": "Ce nu se cofrează",
  "struct.grila.nemasurata": "Grila nu s-a putut măsura: modelul n-are nicio travee între doi stâlpi.",
  "struct.grila.titlu": "Grila de deschideri (lumina dintre fețe)",
  "struct.grila.pe_modul": "{peModul} din {nr} travee cu lumina pe modulul de {modul} m",
  "struct.grila.distincte#n": "{n} deschidere distinctă|{n} deschideri distincte|{n} de deschideri distincte",
  "struct.grila.nota": "o travee = distanța LIBERĂ dintre fețele a doi stâlpi vecini de pe aceeași grindă, o dată pe plan; pe modul = un număr întreg de locuri de parcare între fețe (acolo încap mașinile, nu între axe), cu cel mult 2 cm pierduți; deschiderile egale sunt același cofraj de grindă refolosit",
  "struct.grila.col_deschidere": "Lumina",
  "struct.grila.col_travee": "Travee",
  "struct.grila.col_pe_modul": "Pe modul",
  "struct.grila.col_grinzi": "Grinzi",
  "struct.grila.multiplu": "✓ {multiplu} locuri × {modul} m",

  // --- STRUCTURĂ · reazemul articulat (pila pe grinda-gazdă) -------------
  "struct.rez.pila": "pilă",
  "struct.rez.M_sus": "M intră în grinda de sus",
  "struct.rez.V_planseu": "V → în planșeu",
  "struct.rez.reazem_i": "reazem i",
  "struct.rez.reazem_j": "reazem j",
  "struct.rez.gazda_transfer": "grinda-gazdă (transfer)",
  "struct.rez.titlu_pila": "Reazem articulat — pilă pe grinda {gazda}",
  "struct.rez.link_element": "pagina elementului {ref}",
  "struct.rez.pila_text": "<b>{stalp}</b> nu coboară la fundație: se reazemă pe grinda {gazda} a nivelului de dedesubt, cu baza <b>articulată</b> (M = 0). În gazdă intră doar <b>N</b>",
  "struct.rez.pila_text_v": "; forța tăietoare <b>V</b> a pilei pleacă în planșeu, nu în grindă.",
  "struct.rez.rigiditate": "Rigiditatea ei laterală în cadru: ",
  "struct.rez.rigiditate_nota": " — articulată la bază, pila e o pârghie pe grinda de deasupra, deci ce contează e grinda de sus (k̄ = Σ(I_b/L_b)/(I_c/h)), nu lungimea pilei.",
  "struct.rez.fara_p13": "Cifrele reacțiunii vin din Pasul 13 (armarea grinzii-gazdă), care n-a rulat pe rezultatul ăsta.",
  "struct.rez.titlu_gazda#n": "Reazem articulat — grinda poartă pila|Reazem articulat — grinda poartă pilele|Reazem articulat — grinda poartă pilele",
  "struct.rez.gazda_text": "Grinda e <b>de transfer</b>: pe ea stă un stâlp al nivelului de deasupra, cu reazem articulat. Din el primește o forță concentrată <b>N = R_d</b> pe care n-o avea din planșeu; <b>V</b> al pilei intră în placă, nu în grindă.",
  "struct.rez.col_pila": "Pila",
  "struct.rez.col_R_titlu": "reacțiunea din analiză",
  "struct.rez.col_Rd_titlu": "reacțiunea de proiectare, amplificată cu f",
  "struct.rez.col_a_titlu": "brațul de la reazemul i",
  "struct.rez.col_b_titlu": "brațul de la reazemul j",
  "struct.rez.col_spor": "spor de moment R·a·b/L·f",
  "struct.rez.col_spor_titlu": "sporul de moment în câmpul grinzii, din forța concentrată a pilei",
  "struct.rez.nota_f": "f = {f} e factorul de amplificare al reacțiunii (răspunsul dinamic al pilei purtate); R·a·b/L e momentul unei forțe concentrate pe o grindă simplu rezemată de deschidere L.",
  "struct.rez.nota_fara_p13": " Cifrele vin din Pasul 13, care n-a rulat pe rezultatul ăsta.",

  // --- STRUCTURĂ · bara de secțiune a scenei 3D --------------------------
  "struct.sect.prin_nivel": "{cota} · prin {nivel}",
  "struct.sect.titlu_x": "Planul de tăiere e perpendicular pe axa X a grilei: ce rămâne e o secțiune care merge de-a lungul lui Y. Axele sunt ale GRILEI clădirii (Pasul 2), deci pe o clădire rotită tăietura merge tot pe lângă pereți.",
  "struct.sect.titlu_y": "Planul de tăiere e perpendicular pe axa Y a grilei: ce rămâne e o secțiune care merge de-a lungul lui X.",
  "struct.sect.titlu_z": "Taie ORIZONTAL, la o cotă: ce rămâne e un plan de nivel — exact vederea din care se citește unde cad stâlpii și pereții. Cursorul se prinde de MIJLOCUL fiecărui nivel: tăiat chiar la cota plăcii, planșeul întreg ar deveni o față tăiată opacă peste tot ce e dedesubt.",
  "struct.sect.buton": "Secțiune",
  "struct.sect.aprinde_titlu": "Taie clădirea cu un plan și ascunde ce e dincoace de el: singurul fel în care se vede un nod, o intrare de grindă în stâlp sau armătura dintr-un stâlp, fără să stingi jumătate din model.",
  "struct.sect.stinge": "stinge secțiunea",
  "struct.sect.axa_grup": "Axa secțiunii",
  "struct.sect.intoarce": "întoarce sensul: rămâne cealaltă jumătate",
  "struct.sect.cursor": "Poziția planului de tăiere",

  // --- STRUCTURĂ · legenda cazurilor de încărcare ------------------------
  "struct.caz.permanenta": "permanentă (G)",
  "struct.caz.variabila": "variabilă (Q)",
  "struct.caz.seismica": "seismică (E)",
  "struct.caz.torsiune": "seismică — torsiune",
  "struct.caz.titlu": "Cazurile de încărcare — ce înseamnă fiecare simbol",
  "struct.caz.info_titlu": "Caz elementar de încărcare",
  "struct.caz.info_ce": "Un «caz» e o singură încărcare, aplicată singură pe model și rulată separat. Rezultatul lui (M, V, N în fiecare bară) se păstrează în tensorul F. O combinație NU e o analiză nouă: e suma cazurilor înmulțite cu niște coeficienți, R = Σ cᵢ·Fᵢ.",
  "struct.caz.info_de_ce": "Structura e liniar-elastică, deci răspunsul la o sumă de încărcări e suma răspunsurilor. Așa se pot genera zeci de combinații din câteva analize, în loc să rulezi FEM de zeci de ori.",
  "struct.caz.intro": "Litera spune NATURA acțiunii: <b>G</b> = permanentă (există mereu, nu se poate lua jos), <b>Q</b> = utilă (poate fi acolo sau nu, cu ce valoare — probabilistic), <b>S</b> = zăpada (tot variabilă, dar cu propriii ψ), <b>E</b> = cutremurul, <b>T_acc</b> = torsiunea accidentală. Cifra sau litera de după ea NU e un indice de normativ, ci sursa fizică ținută separat: G1 betonul structurii, G2a/G2b/G2c pereții nestructurali după cum descarcă (pe grindă, pe placă, pe fundație), G3 finisajele, G4 infrastructura, Q1 și Q2 utila după categoria zonei. Sursele stau despărțite fiindcă se combină diferit: una poate intra favorabil într-o verificare și defavorabil în alta, iar Q1 și Q2 au ψ diferiți.",
  "struct.caz.col_simbol": "Simbol",
  "struct.caz.col_tip": "Tip",
  "struct.caz.col_fizic": "Ce este fizic",
  "struct.caz.col_calcul": "Din ce se calculează (cifrele proiectului)",
  "struct.caz.col_unde": "Unde se aplică pe model",
  "struct.caz.col_cat": "Cât iese pe proiect",
  "struct.caz.col_rol": "Cum intră în combinații",
  "struct.caz.col_normativ": "Normativ",
  "struct.caz.de_unde": "de unde vine:",
  "struct.caz.total_aplicat": "total aplicat",

  // --- STRUCTURĂ · fișa unei încărcări -----------------------------------
  "struct.caz.necunoscut": "—",

  // --- STRUCTURĂ · fișa unei încărcări și a masei seismice ---------------
  "struct.fisai.inchide": "închide fișa",
  "struct.fisai.nivel_n": "nivel {n}",
  "struct.fisai.info": "ales mai acoperitor",
  "struct.fisai.lipsa": "ce nu e în model",
  "struct.fisai.subtitlu": "caz elementar de încărcare",
  "struct.fisai.total": "totalul aplicat",
  "struct.fisai.kn_cladire": "kN pe toată clădirea",
  "struct.fisai.cum": "cum se calculează",
  "struct.fisai.unde": "unde se aplică",
  "struct.fisai.expus": "suprafața de sub cer se măsoară pe mesh la Pasul 7: o celulă e acoperiș dacă n-are altă placă deasupra ei.",
  "struct.fisai.pe_planse": "pe planșee",
  "struct.fisai.nota_expus": "{expusa} m² sub cer din {total} m²",
  "struct.fisai.nota_planseu": "{n} m² de planșeu",
  "struct.fisai.opensees": "presiunea intră în OpenSees ca forțe nodale p·A/4, în colțurile fiecărei celule de mesh.",
  "struct.fisai.link_p8": "pagina Pasului 8 →",
  "struct.masa.titlu": "Masa seismică",
  "struct.masa.subtitlu": "a doua contabilitate a aceleiași clădiri",
  "struct.masa.chip_nod": "masă în nod",
  "struct.masa.chip_nu_incarcare": "nu e o încărcare",
  "struct.masa.totala": "masa totală",
  "struct.masa.info_ce": "Masa care oscilează, lumpată în noduri: greutatea proprie, finisajele, pereții și o parte din încărcările variabile.",
  "struct.masa.info_de_ce": "Nu e greutatea împărțită la g: utila intră cu ψE = φ·ψ2, stâlpii și pereții se împart pe jumătate între planșee, iar infrastructura e exclusă — ea nu se mișcă față de teren (EN 1998-1 §4.3.3.2.2).",
  "struct.masa.infra": "infrastructura ({n} t) e greutate, nu masă seismică: nodurile ei apar goale în scenă.",
  "struct.masa.compus": "din ce se compune",
  "struct.masa.c_structura": "placa, grinzile și stâlpii",
  "struct.masa.c_finisaje": "finisajele (SDL)",
  "struct.masa.c_pereti": "pereții nestructurali",
  "struct.masa.c_utila": "ψE·utila",
  "struct.masa.c_zapada": "ψ₂·zăpada",
  "struct.masa.nota_zapada": "din care {n} t zăpadă",
  "struct.masa.link_p9": "Pasul 9 — seismul →",

  // --- STRUCTURĂ · panoul gropilor de pământ -----------------------------
  "struct.gpan.no_site": "Lotul n-are coordonate încă. Geocodează adresa în „Localizare”, apoi revino — distanța până la groapă se măsoară de acolo.",
  "struct.gpan.no_volume": "Săpătura nu evacuează nimic: tot pământul se refolosește ca umplutură pe loc.",
  "struct.gpan.no_options": "Nu e nicio groapă în bază pentru care să se poată socoti un cost. Se adaugă în „Furnizori de servicii”.",
  "struct.gpan.fara_motiv": "Nu se poate alege o groapă.",
  "struct.gpan.aleasa_tine": "aleasă de tine",
  "struct.gpan.cea_ieftina": "cea mai ieftină",
  "struct.gpan.sumar": "{m3} m³ · {km} km · {curse} curse · transport {transport} + depozitare {depozitare} = ",
  "struct.gpan.pierdut": "cu {suma} mai mult decât {nume}",
  "struct.gpan.regen_titlu": "recalculează devizul cu groapa aleasă",
  "struct.gpan.regen_nimic": "nimic de regenerat — devizul e la zi",
  "struct.gpan.se_regenereaza": "se regenerează…",
  "struct.gpan.regenereaza": "regenerează costul",
  "struct.gpan.harta": "harta gropilor de pământ",
  "struct.gpan.nr_gropi": " · {n} gropi",
  "struct.gpan.inchisa": ", închisă",
  "struct.gpan.schimbat": "Groapa s-a schimbat, dar devizul de mai sus e încă cel vechi — apasă „regenerează costul”.",
  "struct.gpan.localitate": "Lotul e cunoscut doar la nivel de <b>localitate</b> — cercul de pe hartă e zona, nu parcela. Distanțele pornesc din centrul ei, deci au o eroare de ordinul kilometrilor: gropi apropiate ca total pot să-și schimbe ordinea. Pentru un răspuns ferm e nevoie de adresa cu stradă, din cadastru sau din certificatul de urbanism.",
  "struct.gpan.rutat_tot": "Distanțele sunt <b>drum rutier</b>, măsurat pe rețeaua de șosele. Ultimii kilometri rămân aproximativi: punctul unei gropi e de obicei centrul localității, nu poarta rampei.",
  "struct.gpan.estimat_tot": "Rutarea n-a răspuns, deci distanțele sunt <b>estimate</b> (linie dreaptă × 1,3) — marcate cu „≈” în tabel. O estimare poate răsturna ordinea a două gropi apropiate ca total, așa că merită reîncărcat ecranul înainte de o decizie.",
  "struct.gpan.estimat_unele#n": "Distanțele sunt drum rutier, în afară de <b>{n}</b> groapă, marcată cu „≈” în tabel: pentru ea routerul n-a răspuns și a rămas estimarea (linie dreaptă × 1,3).|Distanțele sunt drum rutier, în afară de <b>{n}</b> gropi, marcate cu „≈” în tabel: pentru ele routerul n-a răspuns și a rămas estimarea (linie dreaptă × 1,3).|Distanțele sunt drum rutier, în afară de <b>{n}</b> de gropi, marcate cu „≈” în tabel: pentru ele routerul n-a răspuns și a rămas estimarea (linie dreaptă × 1,3).",
  "struct.gpan.tarife": " Tarifele gropilor sunt ordine de mărime până le confirmă cineva cu o ofertă.",

  // --- STRUCTURĂ · centrul de activitate ---------------------------------
  "struct.act.buton_liber": "centrul de activitate — nu rulează nimic",
  "struct.act.buton_lucru": "centrul de activitate — {n} în lucru",
  "struct.act.acum": "Acum",
  "struct.act.nimic": "Nu rulează nimic pe server.",
  "struct.act.link_pipeline": "pipeline →",
  "struct.act.link_solutii": "soluțiile →",

  // --- STRUCTURĂ · sumarul selecției din Studio --------------------------
  "struct.fel.stalp": "Stâlpul",
  "struct.fel.grinda": "Grinda",
  "struct.fel.perete_beton": "Peretele de beton",
  "struct.fel.perete_zidarie": "Peretele nestructural",
  "struct.fel.panou": "Ochiul de placă",
  "struct.fel.fundatie": "Grinda de fundare",
  "struct.fel.fereastra": "Fereastra",
  "struct.fel.usa": "Ușa",
  "struct.fel.parapet": "Parapetul",
  "struct.fel.placa_sol": "Placa pe sol",
  "struct.fel.zidarie_confinata": "Peretele de zidărie confinată",
  "struct.sumar.inchide": "închide panoul",
  "struct.sumar.picate#n": "{n} picată|{n} picate|{n} de picate",
  "struct.sumar.la_limita": "{n} de revizuit",
  "struct.sumar.trec": "{n} trec",
  "struct.sumar.sari_titlu": "toate verificările lui, cu drum spre {pas}",
  "struct.sumar.sari": "sari la verificări →",
  "struct.sumar.nu_e": "elementul nu e în rezultatele pașilor de armare",
  "struct.sumar.se_incarca": "se încarcă verificările…",
  "struct.sumar.cost": "Costul elementului",
  "struct.sumar.se_calculeaza": "se calculează…",
  "struct.sumar.fara_deviz": "Devizul nu s-a putut citi (rulează Pasul 19 / rețetele).",
  "struct.sumar.derivat_titlu": "cantitatea e derivată din geometria elementului — pașii de armare nu o publică pentru tipul ăsta",
  "struct.sumar.material_manopera": "material {material} · manoperă {manopera}",
  "struct.sumar.deviz_titlu": "prețurile unitare vin din: {sursa}",
  "struct.sumar.deviz": "devizul →",
  "struct.sumar.nota_derivat": "«~\» = cantitate derivată din geometrie (betonul și cofrajul nu se publică per element); prețurile unitare sunt cele calibrate din deviz.",
  "struct.sumar.pagina": "pagina elementului →",

  // --- STRUCTURĂ · vocabularul explicațiilor din pași --------------------
  "struct.expl.intrare": "INTRARE",
  "struct.expl.decizie": "DECIZIE",
  "struct.expl.masurat": "MĂSURAT",
  "struct.expl.intrare_titlu": "valoare preluată ca atare — din documente, din pașii anteriori sau din setări; motorul nu o alege",
  "struct.expl.decizie_titlu": "valoare pe care o STABILEȘTE acest pas, după un criteriu explicat alături",
  "struct.expl.masurat_titlu": "valoare rezultată din calcul (model sau formulă), nu aleasă",
  "struct.expl.legenda_titlu": "Ce înseamnă fiecare coloană",
  "struct.expl.nr_coloane": " ({n} coloane)",
  "struct.expl.col_coloana": "Coloana",
  "struct.expl.col_ce": "Ce reprezintă",
  "struct.expl.col_cum": "Cum se calculează",
  "struct.expl.col_validare": "Cum se validează",
  "struct.expl.sursa": "Sursa: ",
  "struct.expl.informativ": "informativ, fără prag",
  "struct.expl.din_limita": "din limită",
  "struct.expl.bara_titlu": "{valoare} {unitate} din {limita} {unitate}",
  "struct.expl.pct_eticheta": "{pct} % {eticheta}",
  "struct.expl.trece_eticheta": "Verificarea trece — explicație",
  "struct.expl.pica_eticheta": "Verificarea nu trece — explicație",
  "struct.expl.trece": "Verificarea trece",
  "struct.expl.pica": "Verificarea NU trece",
  "struct.expl.ce_se_verifica": "Ce se verifică",
  "struct.expl.comparatia": "Comparația făcută — <b>valoarea din proiect</b> față de <b>limită</b>",
  "struct.expl.rezerva": "mai e o rezervă de {n} % până la prag",
  "struct.expl.depasit": "pragul e depășit cu {n} %",
  "struct.expl.de_unde_prag": "De unde vine pragul",
  "struct.expl.ce_inseamna": "Ce înseamnă",
  "struct.expl.ce_inseamna_text": "Geometria actuală de fundație nu acoperă această solicitare. Bucla locală din acest pas caută o geometrie care o acoperă — vezi secțiunea «Căutarea geometriei\».",

  // --- STRUCTURĂ · cele trei modele de rigiditate ------------------------
  "struct.mod.fundatie_nume": "fundație — beton întreg",
  "struct.mod.fundatie_ce": "E_c real (1,0) pe tot. Din el ies reacțiunile (Pașii 6, 17) și eforturile INFRASTRUCTURII: grinzile de fundare, stâlpii și pereții subterani, panourile de subsol (Pașii 12, 14, 18).",
  "struct.mod.eforturi_nume": "eforturi — fisurat pe familii",
  "struct.mod.eforturi_ce": "0,80·E_c la stâlpi și pereți, 0,50·E_c la grinzi, h_placă[m]·E_c la placă (15 cm ⇒ 0,15); infrastructura la E_c. Din el ies M/V/N pe SUPRASTRUCTURĂ (Pașii 11–16).",
  "struct.mod.drift_nume": "drift — 0,5 uniform",
  "struct.mod.drift_ce": "0,50·E_c pe toată suprastructura, placa inclusiv, indiferent de grosime; infrastructura la E_c. Din el ies d_re, factorul c, θ și α (Pasul 10).",
  "struct.mod.incastrat_nume": "eforturi — baza ÎNCASTRATĂ",
  "struct.mod.incastrat_ce": "profilul «eforturi» cu baza încastrată: perioade mai scurte, eforturi mai mari. Suprastructura se dimensionează pe el când ΔT₁ depășește pragul.",
  "struct.mod.cutie_nume": "cutia rigidă (I2m) — beton întreg, baza încastrată",
  "struct.mod.cutie_ce": "doar deplasările: condiția I2m măsoară deformarea cutiei subsolului fără complianța terenului, sub o împingere statică per direcție cu forțele de nivel ale lui M1 — nu un RSA propriu. Pe beton întreg deliberat — pe un profil fisurat raportul ar ieși mai bun exact fiindcă a fost declarată cutie.",
  "struct.mod.secunde": "{n} s",
  "struct.mod.mb": " · {n} MB",
  "struct.mod.proces_separat": " · proces separat",
  "struct.mod.in_proces": " · în proces",
  "struct.mod.al_patrulea": "Al patrulea model.",
  "struct.mod.decizie": " ΔT₁ se măsoară pe <b>M1</b> (beton întreg): baza pe teren elastic față de baza încastrată, la Pasul 7 — partea acoperitoare, fiindcă așa decizia se declanșează mai des.",
  "struct.mod.prag": " ({n} %)",
  "struct.mod.decizie2": " Când ΔT₁ depășește pragul, suprastructura se dimensionează pe <b>M4</b> = «eforturi» cu baza ÎNCASTRATĂ; infrastructura și reacțiunile rămân pe M1, pe teren elastic. Driftul (<b>M2</b>) are baza ÎNCASTRATĂ când strategia urmărește cutia rigidă la subsol — deasupra cutiei clădirea e ca încastrată, iar rotirea cutiei pe terenul elastic nu e deformare a structurii; fără cutie cerută, M2 stă pe teren. Baza folosită e scrisă pe rândul lui M2.",
  "struct.mod.pe_proiect": "Pe proiectul ăsta: ",
  "struct.mod.m4_activ": "M4 activ",
  "struct.mod.fara_m4": "fără M4",
  "struct.mod.delta": " — ΔT₁ = {n} %",
  "struct.mod.col_model": "model",
  "struct.mod.col_rigiditate": "rigiditatea",
  "struct.mod.eroare": "nu s-a calculat: {eroare}",
  "struct.mod.col_t1_dir": "T₁ (fundamentala direcției)",
  "struct.mod.col_moduri": "moduri",
  "struct.mod.col_masa90": "≥ 90 % masă",
  "struct.mod.col_eigen": "eigen",
  "struct.mod.sub7": "Eigen-urile lui M2 și M3 rulează în procese separate, deodată cu cel al lui M1 (paralelism {paralelism}); cache-urile lor modale scutesc Pasul 9 de câte un eigen. Perioadele afișate în restul paginii — gate-ul modal, ΔT₁, comparația cu lean — sunt ale lui <b>M1</b>.",
  "struct.mod.col_tensor": "tensor",
  "struct.mod.col_echilibru": "echilibru (T3)",
  "struct.mod.col_sarite": "cazuri sărite",
  "struct.mod.col_statice": "statice",
  "struct.mod.sub8": "M2 («drift») n-are nevoie de cazuri gravitaționale — el intră doar la Pasul 9. Echilibrul afișat pe pagină e al lui M1, care are reacțiunile.",
  "struct.mod.col_fb": "F_b echivalent",
  "struct.mod.col_vbaza": "V_bază",
  "struct.mod.col_rsa": "RSA",
  "struct.mod.xy_kn": "X {x} · Y {y} kN",
  "struct.mod.xy_s": "X {x} s · Y {y} s",
  "struct.mod.baza_incastrata": "Baza: ÎNCASTRATĂ",
  "struct.mod.baza_elastica": "Baza: pe teren elastic",
  "struct.mod.impingere": "împingere statică",
  "struct.mod.din_cache": "din cache",
  "struct.mod.recalculat": "recalculat",
  "struct.mod.sub9": "Fiecare model e coerent în el însuși: perioadele lui, Γ-urile lui, S_d pe perioadele lui, F_b-ul lui, tăietoarea lui de nivel. <b>Reacțiunile din M1 nu echilibrează eforturile din M3</b> — nu sunt de pe același model. Spectrul, tabelul modal și direcțiile de mai jos sunt ale lui M1; suprastructura se dimensionează pe <b>{model}</b>.",
  "struct.mod.factorul_c": "factorul c (E.3)",
  "struct.mod.i2m": "I2m (cutia rigidă)",
  "struct.mod.bici": "efectul de bici",
  "struct.mod.sub10": "Tot ce amplifică sau împarte d_re vine de pe același model ca d_re: un c de pe beton întreg peste un d_re de pe fisurat ar fi două modele într-o singură formulă.",
  "struct.mod.suprastructura": "suprastructura",
  "struct.mod.infrastructura": "infrastructura (sub secțiunea de încastrare)",
  "struct.mod.reactiunile": "reacțiunile",
  "struct.mod.alpha": "amplificarea α (θ)",
  "struct.mod.nr_elemente": " · {n} elemente",
  "struct.mod.nr_taieturi": " · {n} tăieturi de placă",
  "struct.mod.nr_panouri": " · {n} panouri de subsol",
  "struct.mod.cadere": "Cădere: {motiv} — tot tensorul combinat e pe M1 (acoperitor, dar nu ce a cerut structuristul). Rulează din nou Pașii 8 și 9, apoi 11.",
  "struct.mod.titlu": "Cele trei modele de rigiditate",
  "struct.mod.subtitlu": " — aceeași geometrie, aceleași mase, trei rigidități de calcul, câte una pentru fiecare întrebare.",

  // --- STRUCTURĂ · divergențele față de Eurocod --------------------------
  "struct.div.marker_titlu": "divergență {cod} față de Eurocod — vezi explicația de mai jos",
  "struct.div.titlu": "Unde metoda diferă de Eurocod",
  "struct.div.puncte#n": " — {n} punct, cu cifra pe proiectul acesta| — {n} puncte, fiecare cu cifra pe proiectul acesta| — {n} de puncte, fiecare cu cifra pe proiectul acesta",
  "struct.div.intro": "Verificările de mai sus urmează <b>P100-1/2013</b> și foaia de calcul a structuristului. Unde SR EN 1998-1 cere altceva, diferența e marcată în formulă și explicată aici — cu ce ar ieși dacă am urma Eurocodul.",
  "struct.div.urmam": "urmăm: {ce}",
  "struct.div.implementat": "implementat",
  "struct.div.normativ": "SR EN 1998-1",
  "struct.div.de_ce": "De ce: {motiv}",
  "struct.div.impact": "pe proiectul acesta",

  // --- STRUCTURĂ · titlul etapei unui pas care rulează -------------------
  "struct.etapa.pas_din": "{pas} ({k}/{n})",
  "struct.etapa.minute": "{n} min",

  // --- STRUCTURĂ · vederea 3D a unui ochi de placă -----------------------
  "struct.ochi.fara_contur": "Conturul ochiului nu e în rezultatul Pasului 7 (rulare veche) — vederea 3D se construiește din contur.",
  "struct.ochi.legenda": "Placă de {h} cm, acoperire {acoperire} cm. Plasa de jos: ",
  "struct.ochi.dir_scurta": " — direcția scurtă ({dir}) stă dedesubt. ",
  "struct.ochi.calareti": "■ călăreți",
  "struct.ochi.calareti_text": " pe 0,25·l de la fiecare capăt rezemat. Sub laturi: ",
  "struct.ochi.grinda": "■ grindă",
  "struct.ochi.perete": "■ perete",
  "struct.ochi.fara_reazem": "; linia roșie întreruptă = latură fără reazem.",
  "struct.ochi.rarit": " Desenul arată o bară din {n}, ca să rămână citibil; pasul din text e cel real.",

  // --- STRUCTURĂ · rețeta de cost a unui element -------------------------
  "struct.cost.kg_otel": "{n} kg oțel",
  "struct.cost.material_kg": "material {pret} €/kg",
  "struct.cost.pierderi": " · include {n} % pierderi la aprovizionare",
  "struct.cost.ore_fierari": "{n} ore fierari",
  "struct.cost.ore_detaliu": "{bucati} × {tarif} €/h",
  "struct.cost.ore_familie": "{ore} h/kg × {kg} kg {familie}",
  "struct.cost.montaj": "montaj carcasă",
  "struct.cost.manopera_kg": "manoperă {pret} €/kg × {kg} kg",
  "struct.cost.m3_beton": "{n} m³ beton",
  "struct.cost.beton_pret": "{articol} {pret} €/m³",
  "struct.cost.turnare": "turnare + vibrare",
  "struct.cost.turnare_pret": "{pret} €/m³ × {m3} m³",
  "struct.cost.m2_cofraj": "{n} m² cofraj",
  "struct.cost.panou": "panou {pret} €/m²",
  "struct.cost.montat": "montat + demontat",
  "struct.cost.dulgheri": "dulgheri {pret} €/m² × {m2} m²",
  "struct.cost.mustati": "mustăți din fundație",
  "struct.cost.mustati_nivel": "se toarnă cu fundația · {element}",

  // --- STRUCTURĂ · Studio (modelul 3D) -----------------------------------
  "struct.studio.gol_componente": "Componentele apar după pașii de armare, care n-au rulat pe rândul ăsta — pe o schiță nu rulează.",
  "struct.studio.gol_model": "Modelul structural nu e disponibil.",
  "struct.studio.corp_sarit": "Corpul {cod} a fost sărit: calculul lui s-a oprit, iar soluția a mers mai departe fără el, deci nu are model.",
  "struct.studio.corp_exclus": "Corpul {cod} e exclus din calcul, deci nu are model.",
  "struct.studio.corp_motiv": "Motivul: {motiv}",
  "struct.studio.gol_complex": "Modelul complexului nu e disponibil: niciun corp n-a ajuns încă la modelul structural.",
  "struct.studio.complex_nota": "Întregul complex: fiecare corp e analizat separat — verdictele, armarea și paginile pieselor sunt pe corpul lui.",
  "struct.studio.complex_corp": "Corpul {corp}",
  "struct.studio.complex_parcare": "Peretele exterior al parcării: desenat pe conturul subsolului întreg, cu grosimea pereților de contur — nu e calculat.",
  "struct.studio.complex_deschide": "Deschide corpul {corp}",
  "struct.studio.complex_element": "Pagina piesei {ref}",
  "struct.studio.complex_radier_corp": "Radierul corpului {corp}",
  "struct.studio.complex_radier": "Radierul corpului: desenat din amprenta lui, cu grosimea din Pasul 6, de la pardoseala lui până sub radier — verificările și armarea lui stau pe corp.",
  "struct.studio.complex_placa_parcare": "Placa pe sol a parcării: desenată pe conturul subsolului întreg, în afara corpurilor, cu grosimea plăcii pe sol și balastul ei — aceeași presupunere din care se sapă groapa sub parcare. Nu e calculată; dacă parcarea cere radier, e de hotărât.",
  "struct.studio.deschide_pipeline": "deschide pipeline-ul →",
  "struct.studio.caz_generic": "cazul de încărcare {caz} — presiuni pe placă + încărcări liniare",
  "struct.studio.permanente": "permanente",
  "struct.studio.variabile": "variabile",
  "struct.studio.cazuri": "cazuri",
  "struct.studio.gol_moduri": "Modurile proprii ies din analiza modală, deci apar după Pasul 7. Ce se vede acum e geometria, construită fără analiză.",
  "struct.studio.seism": "seism",
  "struct.studio.masa_titlu": "masele seismice pe noduri (sferele) — din ele se calculează forțele",
  "struct.studio.masa": "masa seismică",
  "struct.studio.detalii_incarcari": "detaliile coborârii încărcărilor — diagramele pe niveluri, echilibrul per caz — sunt în ",
  "struct.studio.pagina_p8": "pagina Pasului 8",
  "struct.studio.gol_incarcari": "Încărcările apar după rularea Pasului 8.",
  "struct.studio.pipeline": "pipeline →",
  "struct.studio.tab_moduri_titlu": "modurile proprii de vibrație — perioade, mase participante, formele modale",
  "struct.studio.vedere.model": "Model 3D",
  "struct.studio.vedere.moduri": "Moduri",
  "struct.studio.vedere.incarcari": "Încărcări",
  "struct.studio.vedere.componente": "Componente",
  "struct.studio.vedere.lant": "Lanțul de calcul",
  "struct.studio.vedere.setari": "Setări de calcul",
  "struct.rez.drift_sls": "Drift SLS",
  "struct.rez.drift_uls": "Drift ULS",
  "struct.rez.bici": "Efectul de bici",
  "struct.rez.modal": "Decuplarea modurilor",
  "struct.rez.limita": "limita {v}",
  "struct.rez.sursa.preferinta": "limita din preferința proiectului",
  "struct.rez.sursa.arhitectura": "limita din compartimentările și fațada arhitecturii",
  "struct.rez.sursa.llm_guess": "limita estimată (LLM), cu motivul notat",
  "struct.rez.sursa.default": "limita implicită: zidărie",
  "struct.rez.esv_nivel": "{n} ESV pe nivel ({corp})",
  "struct.rez.fundare": "Fundare",
  "struct.studio.2d_titlu": "planul nivelului: propunerea Pasului 4 peste desenul arhitecturii",
  "struct.studio.3d_titlu": "volumul: modelul FEM cu stâlpi, grinzi, plăci și pereți",
  "struct.studio.reguli_titlu": "regulile de amplasare, cu elementele lor, în tabloul de verificări",
  "struct.studio.reguli_incalcate": "{n} din {total} reguli încălcate",
  "struct.studio.reguli_trec": "toate cele {n} reguli de amplasare trec",
  "struct.studio.stalpi_grinzi": "{stalpi} stâlpi · {grinzi} grinzi",
  "struct.studio.fund_titlu": "fundația e layerul de dedesubt al planului: banda tălpii la lățimea ei reală, cu axele denumite. Click pe un ax din desen → verificările lui; aici → pagina fundației, cu verdictele globale (tasare, ridicare)",
  "struct.studio.fund": "fundație B {B} m · D_f {D} m · ",
  "struct.studio.axe_pica": "{n} din {total} axe pică",
  "struct.studio.axe_limita": "{n} axe de revizuit",
  "struct.studio.axe_trec": "toate cele {n} axe trec",
  "struct.studio.p4_titlu": "pagina Pasului 4 — propunerea completă, istoricul de soluționare, auditul",
  // --- editorul soluției de structură ------------------------------------
  "struct.editor.se_incarca": "Se deschide editorul…",
  "struct.editor.titlu_nou": "Soluția {n}, în lucru",
  "struct.editor.salveaza": "Salvează",
  "struct.editor.salveaza_titlu": "Naște soluția nouă cu geometria ta. Calculul de detaliu nu pornește singur: îl pornești tu, când ai terminat. Sursa rămâne cum era.",
  "struct.editor.salveaza_blocat": "Geometria are greșeli — corectează-le întâi",
  "struct.editor.se_salveaza": "Se salvează…",
  "struct.editor.inchide": "Închide editorul",
  "struct.editor.renunti": "Renunți la ce ai desenat? Nimic nu s-a salvat.",
  "struct.editor.pleci_fara_salvare": "Pleci din editor fără să salvezi? Ce ai desenat se pierde.",
  "struct.editor.tipuri_esv": "Tipuri ESV folosite: {n}",
  "struct.editor.tipuri_esv_titlu": "Perechi (grosime, lungime) distincte pe corp. În editor sunt libere; solverul nu trece de 5, sau de câte ai lăsat tu.",
  "struct.editor.clase": "Clase pe nivel",
  "struct.editor.clase_titlu": "Elementele cu aceeași secțiune și formă la nivelul de pe ecran: un tip de cofraj. Clasa nu se memorează — un element schimbat trece singur în altă clasă. Mouse-ul peste un rând le aprinde pe plan, clic alege primul.",
  "struct.editor.clasa_cip": "Clasa {c} · {n} elemente",
  "struct.editor.clasa_singur": "Singur în clasa lui ({c})",
  "struct.editor.clasa_cip_titlu": "Elementele cu aceeași secțiune și formă la nivelul ăsta; mouse-ul peste cip le aprinde pe plan",
  "struct.editor.clasa_doar_el": "Doar elementul",
  "struct.editor.clasa_toata": "Toată clasa · {n}",
  "struct.editor.clasa_domeniu_titlu": "Pe câte elemente se scrie secțiunea: numai pe ăsta, sau pe toate cele cu aceeași secțiune și formă la nivelul ăsta. Mutarea, ștergerea, rotirea și nivelul rămân pe element.",
  "struct.editor.clasa_nota_el": "Numai pe {id}: iese din clasa {c}.",
  "struct.editor.clasa_nota_toata": "Pe toate cele {n} elemente din clasa {c}. Mutarea, ștergerea și rotirea rămân pe element.",
  "struct.editor.creare_titlu": "Adaugă un element: ESV (C), grindă (B) sau placă (P). Esc se întoarce la selecție.",
  "struct.editor.grinda_cip_copie": "{s} din copie · Esc",
  "struct.editor.grinda_din_copie": "Unealta Grindă a pornit cu secțiunea grinzii copiate ({s}): clic pe primul element, apoi pe al doilea.",
  "struct.editor.copiat": "Copiat: {c}. ⌘V pune unul la fel sub cursor, ⇧⌘V îi scrie secțiunea pe elementul ales.",
  "struct.editor.lipit": "{id} a intrat pe plan, copie a lui {s}.",
  "struct.editor.lipit_fara_nivel": "Elementul copiat nu există pe niciun nivel al corpului ăstuia.",
  "struct.editor.lipit_prop": "Secțiunea lui {s} e scrisă pe {n} elemente.",
  "struct.editor.lipit_prop_unu": "Secțiunea lui {s} e scrisă pe {id}.",
  "struct.editor.meniu_copiaza": "Copiază",
  "struct.editor.meniu_lipeste": "Lipește {c}",
  "struct.editor.meniu_lipeste_gol": "Lipește",
  "struct.editor.meniu_copiaza_prop": "Copiază proprietățile",
  "struct.editor.meniu_lipeste_prop": "Lipește proprietățile ({c})",
  "struct.editor.meniu_lipeste_prop_gol": "Lipește proprietățile",
  "struct.editor.meniu_lipeste_prop_alta": "Ce e copiat e din altă familie: un ESV nu-și scrie secțiunea pe o grindă, nici invers.",
  "struct.editor.adauga": "Adaugă",
  "struct.editor.strat_zidarie": "Zidărie confinată",
  "struct.editor.zc_titlu": "{id}: perete de zidărie confinată, {cm} cm, {n} stâlpișori — structura proeminenței; nu se editează aici",
  "struct.editor.gemeni": "Oglindit cu {ids}",
  "struct.editor.gemeni_titlu": "Gemenii lui din simetria clădirii (oglindă, rând de celule): ce schimbi aici se duce și la ei, oglindit",
  "struct.editor.simetric": "Simetric",
  "struct.editor.simetric_titlu": "Aprins: gemenii urmează mutarea, secțiunea și rotirea, oglindite față de axa clădirii. Stins: se schimbă numai elementul ăsta.",
  "struct.editor.ajutor": "Cum se lucrează",
  "struct.editor.grupuri": "Grupuri de simetrie",
  "struct.editor.grupuri_titlu": "Grupurile din care face parte elementul în simetria clădirii; clic pe un grup îi selectează membrii pe plan",
  "struct.editor.grup_orbita": "Orbita {o}",
  "struct.editor.grup_clasa": "Clasa de oglindă",
  "struct.editor.grup_pereche": "Pereche cu {id}",
  "struct.editor.grup_geaman": "Geamăn cu {id}",
  "struct.editor.grup_orbita_titlu": "Elementele care sunt imaginea unul altuia prin operațiile simetriei clădirii (oglinzi, rânduri de celule)",
  "struct.editor.grup_clasa_titlu": "Bucata, geamănul ei de vizavi pe axa lungă și perechile amândurora față de axa dintre frontoane",
  "struct.editor.grup_pereche_titlu": "Oglinda elementului față de axa dintre frontoane",
  "struct.editor.grup_geaman_titlu": "Celălalt capăt al aceleiași linii de zid, oglindit față de axa lungă a blocului",
  "struct.editor.grup_op_oglinda": "oglindă pe {d}",
  "struct.editor.grup_op_translatie": "pas {m} m pe {d}",
  "struct.editor.grup_cu_abateri": "cu abateri",
  "struct.editor.grup_selectat": "{n} elemente selectate pe plan",
  "struct.editor.verif_verificat": "verificată",
  "struct.editor.verif_de_verificat": "se verifică în curând…",
  "struct.editor.verif_se_verifica": "se verifică…",
  "struct.editor.verif_eroare": "verificarea n-a mers",
  "struct.editor.grinda_oblica": "{g} iese oblică: capetele de pe {a} și {b} nu stau pe același ax. Trage de un capăt pe o piesă a celuilalt element ca s-o îndrepți — sau las-o așa, dacă vrei s-o reancorezi altfel.",
  "struct.editor.fara_linie_comuna": "{g} iese oblică: {a} și {b} n-au nicio linie comună pe care să stea dreaptă — betonul lor comun nu ține toată lățimea grinzii, lipsesc {d} cm pe {axa}. Mută unul din ele cu atât, sau trage de un capăt.",
  "struct.editor.capat_fara_linie": "{g} iese oblică și nu se poate îndrepta de aici: betonul lui {esv} nu acoperă linia capătului de pe {alt}. Mută {esv} pe linia aia sau reancorează capătul de pe {alt}.",
  "struct.editor.grinda_exista": "Între {a} și {b} există deja o grindă pe nivelul ăsta.",
  "struct.editor.grinda_fara_nivel": "Cele două elemente nu există pe niciun nivel comun.",
  "struct.editor.unealta_alege": "Selectează",
  "struct.editor.unealta_alege_titlu": "Alege, mută (tras) și redimensionează elemente — V",
  "struct.editor.unealta_esv": "ESV",
  "struct.editor.unealta_esv_titlu": "Pune un element vertical: clic pe plan; în zid cade pe axa lui — C",
  "struct.editor.unealta_grinda": "Grindă",
  "struct.editor.unealta_grinda_titlu": "Leagă două elemente: clic pe piesa primului, apoi pe a celui de-al doilea; grinda se așază pe linia lor comună, paralelă sau perpendiculară pe piese, dreaptă. Cu Alt, capătul se prinde unde dai clic, lipit de punctele elementului — B",
  "struct.editor.domeniu_titlu": "Pe ce niveluri lucrează adăugarea, ștergerea și redimensionarea",
  "struct.editor.domeniu_nivel": "Nivelul ăsta",
  "struct.editor.domeniu_toate": "Toate nivelurile",
  "struct.editor.doar_citire": "se calculează — geometria nu se mai schimbă",
  "struct.editor.legenda_nr": "ESV · grinzi · ochiuri de placă pe nivel",
  "struct.editor.axe_arh_titlu": "Axele desenate de arhitect (grila modulară): pe ele se centrează elementele",
  "struct.editor.axe_arh_arata": "Axe",
  "struct.editor.axe_arh_ascunde": "Axe ✓",
  "struct.editor.axe_derivate_titlu": "Axele clădirii, derivate de structură din zidurile ei (planșa n-are axe desenate): pe ele se așază nodurile, reazemele de fațadă și grinzile ochiurilor de placă; zidurile rămân unde le-a desenat arhitectul",
  "struct.editor.axe_derivate_arata": "Axe derivate",
  "struct.editor.axe_derivate_ascunde": "Axe derivate ✓",
  "struct.editor.calc_arh": "Planul arhitecturii",
  "struct.editor.calc_arh_arata": "Arată",
  "struct.editor.calc_arh_ascunde": "Ascunde",
  "struct.editor.calc_arh_opacitate": "Cât se vede planul arhitecturii peste geometrie",
  "struct.editor.calc_arh_se_incarca": "se citește documentul arhitecturii…",
  "struct.editor.calc_arh_lipsa": "documentul arhitecturii nu s-a putut citi",
  "struct.editor.calc_arh_fara_nivel": "documentul n-are planșeul nivelului ăsta",
  "struct.editor.calc_plansa_se_incarca": "se citește planșa arhitectului…",
  "struct.editor.calc_plansa_lipsa": "planșa arhitectului nu s-a putut citi, se arată planul documentului",
  "struct.editor.calc_plansa_stearsa": "planșa arhitectului («{fisier}») a fost ștearsă din dosar după import; se arată planul documentului",
  "struct.editor.greseli": "{n} greșeli de geometrie — calculul așteaptă",
  "struct.editor.corp_indisponibil": "{cod} — fără Pasul 4, nu se poate edita",
  "struct.editor.plus_picior": "Lungește elementul cu {m} m, pe zid",
  "struct.editor.plus_brat_nou": "Braț nou de {m} m, în zidul de alături",
  "struct.editor.plus_brat": "Lungește brațul cu {m} m, pe zid",
  "struct.editor.forma": "Formă: {f}",
  "struct.editor.forma_compusa": "compusă",
  "struct.editor.brat_spre": "Braț {dir}, la {m} m de nod",
  "struct.editor.lungime_brat": "Cât iese brațul din picior",
  "struct.editor.trage_picior": "Trage ca să lungești sau să scurtezi elementul; în fața altui element se unesc",
  "struct.editor.trage_brat": "Trage ca să lungești sau să scurtezi brațul; până în picior, dispare",
  "struct.editor.unire_indiciu": "Lasă aici: {a} se unește cu {b}",
  "struct.editor.unite": "{b} a intrat în {a}: un singur element",
  "struct.editor.unite_grinzi": "{b} a intrat în {a}: un singur element; grinda dintre ele ({g}) a plecat",
  "struct.editor.unire_forma": "{a} și {b} nu se pot uni: un element are un singur picior, cu brațe numai pe axa cealaltă",
  "struct.editor.unire_niveluri": "{a} și {b} nu se pot uni: nu pornesc de pe aceeași bază, sau cel care ar deveni braț urcă mai sus",
  "struct.editor.unire_plantat": "{a} și {b} nu se pot uni: {esv} stă pe grinda dintre ele sau pe {b}",
  "struct.editor.unire_amprenta": "{a} și {b} nu se pot uni: unul are amprenta purtată din calcul, nu picior cu brațe",
  "struct.editor.sterge_brat": "Scoate brațul",
  "struct.editor.brate_nota": "Capetele pieselor se trag. Cercurile «+» cresc elementul pe zidurile arhitecturii: lângă un zid de pe cealaltă direcție îi pun un braț — L, T, + —, iar la un colț trec piciorul peste braț. Creșterea se face și pe nivelurile de dedesubt, scurtarea și pe cele de deasupra.",
  "struct.editor.brate_nota_fara": "Capetele pieselor se trag; zidurile arhitecturii nu mai au unde să-i pună un braț.",
  "struct.editor.iesiri": "{n} ESV ies din zidurile arhitecturii la {nivel}",
  "struct.editor.iesire_cm": "{id} iese {cm} cm din zid",
  "struct.editor.iesire_afara": "{id} stă în afara zidurilor",
  "struct.editor.iesire_gol": "{id} trece prin golul {gol} ({tip})",
  "struct.editor.iesire_camera": "{id}: {cm2} cm² din secțiune în interiorul camerelor",
  "struct.editor.iesiri_verdict": "{n} ESV refuzate de verdictul de amplasare la {nivel}",
  "struct.editor.din": "copie din {s}",
  "struct.editor.esv_axa": "pe axa {axa}",
  "struct.editor.sectiune_la": "Secțiunea la {nivel}",
  "struct.editor.grosime": "grosimea (b)",
  "struct.editor.lungime": "latura lungă (L)",
  "struct.editor.latime": "lățimea (b)",
  "struct.editor.inaltime": "înălțimea (h)",
  "struct.editor.aplica_toate": "Se aplică pe toate nivelurile elementului.",
  "struct.editor.aplica_nivel": "Se aplică pe nivelul ăsta; dedesubt secțiunea crește cel puțin cât el, deasupra nu trece de el.",
  "struct.editor.esv_lipsa_nivel": "Elementul nu există pe nivelul ăsta.",
  "struct.editor.niveluri": "Niveluri",
  "struct.editor.pana_la": "de la fundație până la {nivel}",
  "struct.editor.plantat": "rezemat pe grinda {grinda}",
  "struct.editor.roteste": "Rotește (R)",
  "struct.editor.sterge_tot": "Șterge elementul",
  "struct.editor.sterge_de_aici": "Șterge de aici în sus",
  "struct.editor.sectiune_grinda": "Secțiunea grinzii",
  "struct.editor.capat_ajutor": "Trage de cercurile de la capete ca să muți ancorarea pe alt element sau pe altă piesă a aceluiași: grinda se așază pe linia comună a pieselor, dreaptă. Cu Alt, capătul se prinde unde îl lași, lipit de punctele elementului.",
  "struct.editor.capat_titlu": "Capăt ancorat pe {esv} — trage-l unde vrei să se prindă",
  "struct.editor.capat_acelasi": "{g} are deja celălalt capăt pe {esv}",
  "struct.editor.capat_niveluri": "{esv} lipsește de pe {niveluri}, unde {g} are nevoie de reazem",
  "struct.editor.grinda_pe": "Pe nivelurile: {niveluri}",
  "struct.editor.sterge_grinda_tot": "Șterge grinda",
  "struct.editor.sterge_grinda_nivel": "Șterge de pe nivelul ăsta",
  "struct.editor.unealta_placa": "Placă",
  "struct.editor.unealta_placa_titlu": "Desenează o placă nouă colț cu colț, lipită de placa nivelului (o consolă, un tavan) — P",
  "struct.editor.placa_trei_colturi": "O placă are cel puțin trei colțuri.",
  "struct.editor.placa_desenata": "Placa nouă a intrat în placa nivelului; ochiurile ei vin la verificare.",
  "struct.editor.placa_colt_nou": "Adaugă un colț aici (sau trage de el)",
  "struct.editor.placa_colt_titlu": "Trage colțul · Alt-clic îl scoate",
  "struct.editor.straturi": "Straturi",
  "struct.editor.strat_fortat": "Ascuns, dar unealta aleasă îl arată",
  "struct.editor.strat_ochiuri": "Ochiuri de placă",
  "struct.editor.strat_esv": "ESV",
  "struct.editor.strat_grinzi": "Grinzi",
  "struct.editor.strat_pereti": "Pereții arh.",
  "struct.editor.strat_etichete": "Etichete",
  "struct.editor.semnale_ochiuri": "Semnale pe ochiuri · {n}",
  "struct.editor.semnal_prea_mare": "lumina de {m} m trece de panoul cel mai mare; Pasul 4 l-ar închide cu încă o grindă",
  "struct.editor.semnal_fara_reazem": "{pct} % din contur fără reazem (nici grindă, nici zid)",
  "struct.editor.semnal_mic": "ochi de {m2} m²: firimitură între grinzi și zid",
  "struct.editor.tavan_pus": "Tavanul peste balconul {id} a intrat în placă, ca o consolă; conturul i se poate edita din ochiul lui.",
  "struct.editor.tavan_titlu": "Balconul {id} de dedesubt rămâne sub cer ({m2} m² fără placă): clic ca să-l acoperi",
  "struct.editor.tavan_plus": "+ tavan {id}",
  "struct.editor.ochi_nou": "Ochi nou",
  "struct.editor.ochi_peste": "ochi de placă · peste {nivel}",
  "struct.editor.ochi_arie": "Arie",
  "struct.editor.ochi_gabarit": "Gabarit",
  "struct.editor.ochi_lumina": "Lumina (cercul înscris)",
  "struct.editor.ochi_deschidere": "Deschiderea mică",
  "struct.editor.ochi_reazeme_titlu": "Cum se sprijină conturul ochiului",
  "struct.editor.ochi_pe_grinzi": "grinzi {pct} %",
  "struct.editor.ochi_pe_pereti": "pereți {pct} %",
  "struct.editor.ochi_fara_reazem": "fără reazem {pct} %",
  "struct.editor.ochi_previzualizare": "Previzualizare: ochiul e tăiat aici, din grinzile de pe ecran. Serverul îl numește și îi clasifică laturile la verificare.",
  "struct.editor.ochi_scoate": "Scoate placa din ochi",
  "struct.editor.ochi_scoate_tot": "Scoate placa din ochi, pe toate nivelurile",
  "struct.editor.ochi_nota": "Ochiul nu se desenează de mână: îl fac grinzile. O grindă trasă peste el îl împarte în două, una ștearsă îl unește cu vecinul. În ochi se poate doar scoate sau pune placa; conturul se schimbă numai la console.",
  "struct.editor.consola_om": "Placă desenată în editor",
  "struct.editor.consola_arh": "Consola {id}",
  "struct.editor.consola_iese": "iese {m} m",
  "struct.editor.consola_gata": "Gata",
  "struct.editor.consola_editeaza": "Editează conturul",
  "struct.editor.consola_scoate": "Scoate consola",
  "struct.editor.consola_ajutor": "Trage colțurile: se lipesc pe 5 cm și se aliniază cu vecinii. «+» de pe mijlocul unei laturi adaugă un colț, Alt-clic pe colț îl scoate, Enter termină. Pe «Toate nivelurile» schimbarea merge și pe consolele de pe celelalte etaje.",
  "struct.editor.gol_titlu": "Placă scoasă",
  "struct.editor.gol_nota": "Aici omul a scos placa. Calculul nu mai pune nimic aici: nici placă, nici masă.",
  "struct.editor.gol_pune": "Pune placa la loc",
  "struct.editor.gol_pune_tot": "Pune placa la loc, pe toate nivelurile",
  "struct.studio.p4": "detaliile modelului (P4) →",

  // --- STRUCTURĂ · desenul cotat al stâlpului ----------------------------
  "struct.dsc.fara_nivel": "Nivelul cerut nu e în rezultatul pasului.",
  "struct.dsc.placa": "placă {n}",
  "struct.dsc.grinda": "grindă {n}",
  "struct.dsc.h_b": "h = {h} cm  (b = {b} în adâncime)",
  "struct.dsc.talpa": "talpă {n}",
  "struct.dsc.umplutura": "umplutură {n}",
  "struct.dsc.leg_beton": "beton stâlp",
  "struct.dsc.leg_placa": "placă",
  "struct.dsc.leg_placa_m": "placă {n} m",
  "struct.dsc.leg_grinda": "grindă la nod",
  "struct.dsc.leg_critica": "l_cr (etrieri îndesiți)",
  "struct.dsc.leg_lap": "înnădire l₀",
  "struct.dsc.leg_musta": "mustăți din fundație",
  "struct.dsc.fara_petrecere": "Nivelul ăsta NU are petrecere: bara ține două etaje și trece prin el întreagă, ca petrecerea să nu cadă în zona plastică de la baza structurii (comentariul P100-1 C5.7.3).",
  "struct.dsc.petrecere": "Petrecerea de <b>l₀ = {n} m</b> ",
  "struct.dsc.in_critica": "a rămas în zona critică de la baza nivelului — între cele două zone critice nu încape l₀ —, deci poartă k_s = 1,25 (P100-1 §5.7.3(4)). Acolo unde mecanismul de plastificare cere deformații plastice semnificative, §5.7.3(1) n-o admite deloc.",
  "struct.dsc.peste_critica": "e așezată PESTE zona critică l_cr, fiindcă în ea normativul n-o vrea (P100-1 §5.7.1(2) și §5.7.3(1)).",
  "struct.dsc.fara_grinda": " În nodul de sus nu intră nicio grindă, deci banda planșeului e chiar placa de {placa} m — de aici înălțimea liberă de {liber} m.",
  "struct.dsc.cu_grinda": " Banda planșeului la nod e de {banda} m, din care placa {placa} m — de aici înălțimea liberă de {liber} m, mai mică decât înălțimea de nivel.",
  "struct.dsc.stiva": "Stiva întreagă, la cotele ei absolute",
  "struct.dsc.cu_fundatie": ", cu fundația de sub stâlp: talpă {B}×{hT} m + inimă {bI}×{hI} m",
  "struct.dsc.axul": " (axul {ax})",
  "struct.dsc.axul_global": " (axul {ax} — lățimea globală)",
  "struct.dsc.umplutura_text": ", betonul pornind sub {n} m de umplutură. Mustățile urcă din talpă și se înnădesc cu barele stâlpului.",
  "struct.dsc.subsol": " Cota ±0,00 a desenului e <b>pardoseala subsolului</b>: D′_f = {df} m se măsoară de la ea, iar terenul sistematizat e cu {sus} m mai sus, deci de la teren talpa e la {dext} m",
  "struct.dsc.fiecare_nivel": ". Fiecare nivel își poartă cota H și înălțimea liberă.",
  "struct.dsc.la_scara": "La scara stivei întregi{ce} nu încap în desen — treci pe un singur nivel ca să le vezi, sau citește-le din tabelul de mai jos.",
  "struct.dsc.etrierii": " etrierii",
  "struct.dsc.si": " și",
  "struct.dsc.cotele": " cotele de nivel",
  "struct.dsc.estimat": "Rulare de dinainte de grosimea plăcii, banda grinzii și înnădirea sunt ESTIMATE (pasul nu le publica încă). Rerulează Pasul 15 ca să vină din calcul.",
  "struct.dsc.fara_fundatie": "Fundația nu se desenează: Pasul 6 n-a rulat, deci adâncimea de fundare nu se știe. (Nu punem o talpă inventată sub stâlp.)",

  // --- STRUCTURĂ · terenul și săpătura în 3D -----------------------------
  "struct.teren.strat": "[{de_la}–{pana_la} m] {nume}",
  "struct.teren.apa": "[{n} m sub CTN] APĂ SUBTERANĂ",
  "struct.teren.mal_vertical": "malul {ce} rămâne vertical: {adancime} m în {eticheta}, sub cei {h} m care stau nesprijiniți",
  "struct.teren.mal_taluz": "malul {ce} se taluzează {panta} — {sursa}",
  "struct.teren.mal_gropii": "gropii",
  "struct.teren.mal_santurilor": "șanțurilor",
  "struct.teren.mal_sapaturii": "săpăturii",
  "struct.teren.locale": "{n} adânciri ale gropii sub radierele corpurilor: {volum} m³",
  "struct.teren.corpuri_suma": "suma gropilor corpurilor, săpate fiecare pe secțiunea lui: {n} m³",
  "struct.teren.umplutura": "Săpătură generală: {n} m³ se pun la loc ca umplutură compactată",
  "struct.teren.volum": "Săpătura: {n} m³",
  "struct.teren.volum_detaliu": " (groapa cutiei de subsol {groapa} m³ + șanțurile de sub axe {santuri} m³)",
  "struct.teren.spatiu_lucru": "Săpătura nu e cât betonul: {n} m de spațiu de lucru lângă cofraj, pe fiecare parte, și minimum cât cupa excavatorului. Șanțurile (beton → săpătură): {latimi}",
  "struct.teren.taluz": "Din {total} m³, {taluz} m³ sunt pana de taluz: pământul ăsta se sapă și se pune la loc, deci intră în umplutură, nu în evacuare",
  "struct.teren.straturi": "Terenul: {n} straturi din studiul geotehnic, până la {adancime} m sub CTN. Punctele sunt mai dese acolo unde pământul e mai îndesat; culoarea e a clasei de terasament. Golul din nor e chiar săpătura.",
  "struct.teren.fara_straturi": "Fără stratificație (Pasul 1 nu a fost rulat): se desenează numai săpătura.",

  // --- STRUCTURĂ · stările comune ale unei pagini de pas -----------------
  "struct.pas.ruleaza": "Pasul rulează…",
  "struct.pas.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga.",
  "struct.pas.esuat": "Ultima rulare a eșuat: {eroare}",
  "struct.pas.eroare_necunoscuta": "eroare necunoscută",
  "struct.pas.ruleaza_din_nou": "Rulează din nou din meniul din stânga.",
  "struct.pas.rulat_la": "rulat la {cand}",

  // --- STRUCTURĂ · Pasul 1 — studiul geotehnic ---------------------------
  "struct.geo.ruleaza": "Studiul geotehnic (PDF, inclusiv scanat) este citit de LLM și se calculează presiunea convențională corectată. Durează ~30 de secunde pentru un singur document; pe un dosar cu mai multe piese, un triaj pe titluri alege întâi ce merită citit.",
  "struct.geo.p_conv": "Presiune convențională corectată",
  "struct.geo.p_conv_sub": "p̄conv {p} kPa + CD {cd} + CB {cb} · la Df={df} m, B={b} m",
  "struct.geo.praguri": "Praguri de verificare",
  "struct.geo.praguri_sub": "static (1,10×) · dinamic {n} kPa (1,35×)",
  "struct.geo.seism_inghet": "Seism & îngheț",
  "struct.geo.seism_sub": "Tc {tc} · adâncime îngheț {inghet} · apă subterană {apa}",
  "struct.geo.stratificatia": "Stratificația terenului",
  "struct.geo.col_strat": "Strat",
  "struct.geo.col_adancime": "Adâncime",
  "struct.geo.col_tip": "Tip",
  "struct.geo.unitati": "γ [kN/m³] · φ [°] · c [kPa] · E [kPa] · n [%] — extrase din ",
  "struct.geo.faza11": "Calculul Faza 1.1 (STAS 3300/2)",
  "struct.geo.strat_fundare": "Strat fundare",
  "struct.geo.la_df": "(la Df = {df} m{strat})",
  "struct.geo.stratul_de_la": ", stratul de la {de_la} la {pana_la} m sub CTN",
  "struct.geo.coeficienti": "Coeficienți",
  "struct.geo.de_unde_k": "De unde vin K1 și K2",
  "struct.geo.de_unde_k_text": "Nu din studiul geotehnic și nu din calcul: sunt <b>valori tabelare de normativ</b>. Din studiu vine numai <b>tipul stratului</b> în care cade talpa — el alege rândul din tabel.",
  "struct.geo.lant1": "Studiul geotehnic ",
  "struct.geo.lant1b": " (PDF) → stratificația din tabelul de mai sus.",
  "struct.geo.lant2": "Talpa la Df = {df} m cade în stratul ",
  "struct.geo.lant2b": " ({de_la}–{pana_la} m sub CTN)",
  "struct.geo.lant3": "Stratul e clasificat ",
  "struct.geo.neclasificat": "neclasificat",
  "struct.geo.plasticitate": ", plasticitate {ce}",
  "struct.geo.sursa_tip_implicit": "din descrierea stratului în studiul geotehnic",
  "struct.geo.lant4": "Tipul alege rândul din tabelele de mai jos → ",
  "struct.geo.k1_titlu": "K1 — corecția de lățime (CB)",
  "struct.geo.k2_titlu": "K2 — corecția de adâncime (CD, la Df ≥ 2 m)",
  "struct.geo.sursa_tabele": "Sursa tabelelor: {sursa}.",
  "struct.geo.fara_tabele": "Tabelele complete apar după o rulare nouă a pasului (rezultatul salvat e dintr-o versiune anterioară).",
  "struct.geo.col_teren": "Teren de fundare",
  "struct.geo.rand_aplicat": "← rândul aplicat în acest proiect",
  "struct.geo.formule": "Formule",
  "struct.geo.f_pbar": "Presiunea convențională de bază (din studiu, la valorile de referință ale tabelului: B = 1,00 m, Df = {df}):",
  "struct.geo.df_referinta_implicit": "2,00 m",
  "struct.geo.f_cd": "Corecția de adâncime (Df = {df} m {semn}):",
  "struct.geo.f_cb": "Corecția de lățime (B = {b} m {semn}):",
  "struct.geo.f_pconv": "Presiunea convențională corectată:",
  "struct.geo.f_static": "Pragul de verificare static (gruparea fundamentală, SLUF):",
  "struct.geo.f_dinamic": "Pragul de verificare dinamic (combinațiile seismice):",
  "struct.geo.f_extrase": "Extrase direct din studiu (fără calcul):",
  "struct.geo.info_citite_titlu": "Valorile citite, nu calculate",
  "struct.geo.info_citite_ce": "Acestea nu ies din nicio formulă — le-am citit ca atare din studiul geotehnic. Ele intră ca date de intrare în pașii următori.",
  "struct.geo.p_ag": "accelerația terenului la cutremurul de proiectare (fracțiune din g)",
  "struct.geo.p_ag_sursa": "harta de zonare P100-1, citată în studiu",
  "struct.geo.p_tc": "perioada de control a spectrului seismic, în secunde",
  "struct.geo.p_inghet": "îngheț",
  "struct.geo.p_inghet_nume": "adâncimea până la care îngheață pământul iarna — talpa trebuie să fie sub ea, altfel gheața umflă și mișcă fundația",
  "struct.geo.p_inghet_sursa": "STAS 6054-77, citat în studiu",
  "struct.geo.p_apa": "apă",
  "struct.geo.p_apa_nume": "adâncimea apei subterane",
  "struct.geo.p_apa_sursa": "măsurată în forajele studiului",
  "struct.geo.extrase_text": "zona seismică ag = {ag}, Tc = {tc} (P100-1) · adâncime îngheț {inghet} (STAS 6054-77) · apă subterană {apa}",
  "struct.geo.ks": "Ks recomandat",
  "struct.geo.ks_nota": "(doar informativ — nu se folosește direct; se recalculează pe bază de tasări în Pasul 6)",
  "struct.geo.observatii": "Observații",

  // --- STRUCTURĂ · zonarea seismică a amplasamentului --------------------
  "struct.zon.titlu": "Zonarea seismică a amplasamentului",
  "struct.zon.info_titlu": "De ce harta bate studiul, la a_g și T_C",
  "struct.zon.info_ce": "a_g și T_C nu sunt măsurători de teren: sunt valori citite din figurile 3.1 și 3.2 ale P100-1/2013, indexate după localitate. Un studiu geotehnic le transcrie — și transcrierea poate greși.",
  "struct.zon.info_de_ce": "Restul parametrilor geotehnici (stratificația, p_conv, nivelul apei, adâncimea de îngheț) rămân ai studiului: acolo studiul e singura sursă, fiindcă sunt măsurate pe amplasamentul acesta. Inversarea ordinii surselor e numai pentru cele două valori de zonare.",
  "struct.zon.p_ag": "accelerația terenului pentru IMR = 225 ani, în g",
  "struct.zon.p_ag_sursa": "zonarea P100-1/2013, figura 3.1, după localitate",
  "struct.zon.p_tc": "perioada de control a spectrului, în s (numai 0,7 / 1,0 / 1,6)",
  "struct.zon.p_tc_sursa": "zonarea P100-1/2013, figura 3.2, după localitate",
  "struct.zon.amplasament": "amplasament",
  "struct.zon.necunoscut": "necunoscut",
  "struct.zon.identificat": "identificat în tabelul de localități: {localitate}, jud. {judet}",

  // --- STRUCTURĂ · dosarul geotehnic -------------------------------------
  "struct.dos.titlu": "Dosarul geotehnic — {citite} document(e) citite din {total}",
  "struct.dos.info_titlu": "De ce nu se citesc toate documentele",
  "struct.dos.info_ce": "Un studiu geotehnic de proiect mare are raportul de sinteză plus anexe: fișe de foraj, buletine de laborator, planuri de amplasare, fotografii. Parametrii de care avem nevoie stau în raport și în câteva anexe.",
  "struct.dos.info_de_ce": "Fiecare document citit înseamnă un apel LLM cu PDF-ul întreg atașat: timp și cost. Un triaj pe titluri decide întâi ce merită deschis. Documentele sărite rămân în listă, cu motivul — dacă triajul a greșit, se vede aici.",
  "struct.dos.stare_citit": "citit",
  "struct.dos.stare_ignorat": "sărit la triaj",
  "struct.dos.stare_necitit": "peste limită",
  "struct.dos.stare_neacceptat": "format necitibil",
  "struct.dos.stare_eroare": "eroare la citire",
  "struct.dos.p_citit_nume": "documentul a fost trimis la extracție",
  "struct.dos.p_citit_sursa": "triajul l-a considerat relevant",
  "struct.dos.p_sarit_nume": "nu conține parametri de proiectare",
  "struct.dos.p_sarit_sursa": "decizia triajului, cu motivul din coloana alăturată",
  "struct.dos.p_format_nume": "extracția atașează documentul ca PDF",
  "struct.dos.p_format_sursa": "un .docx/.xlsx nu ajunge la model — încarcă-l ca PDF dacă are parametri",
  "struct.dos.rol_parametri": "parametri de calcul",
  "struct.dos.rol_raport": "raport principal",
  "struct.dos.rol_foraje": "anexă foraje",
  "struct.dos.rol_laborator": "buletin laborator",
  "struct.dos.rol_seismicitate": "seismicitate",
  "struct.dos.col_document": "Document",
  "struct.dos.col_rol": "Rol",
  "struct.dos.col_stare": "Stare",
  "struct.dos.col_motiv": "Motiv",
  "struct.dos.provenienta": "De unde vine fiecare parametru",
  "struct.dos.completari": "Straturi completate din alte piese ale dosarului",
  "struct.dos.completari_text": "Dosarul se citește ca UN studiu: fișa de foraj dă geometria straturilor, buletinul de laborator dă γ, φ, c, E și I_C pe aceleași adâncimi. Un câmp gol din coloana de bază se ia din piesa care acoperă aceeași adâncime — coloana nu se schimbă, doar golurile se umplu.",
  "struct.dos.col_de_la": "De la",
  "struct.dos.col_camp": "Câmp",
  "struct.dos.col_valoare": "Valoare",
  "struct.dos.col_din": "Din",
  "struct.dos.conflicte": "Valori diferite între documente",
  "struct.dos.conflicte_text": "Fiecare parametru se ia din piesa potrivită PENTRU EL: presiunea convențională din raport sau din fișa parametrilor de calcul, nivelul apei din fișa de foraj (acolo se măsoară), a_g și T_C din piesa de seismicitate. O valoare dintr-un buletin de laborator nu devine presiune convențională doar pentru că e o presiune. Restul valorilor se listează aici, ca diferența să fie o decizie văzută, nu una ascunsă.",
  "struct.dos.col_parametru": "Parametru",
  "struct.dos.col_folosit": "Folosit",
  "struct.dos.col_alternativ": "Alternativ",
  "struct.dos.par_straturi": "stratificația",
  "struct.dos.par_df_ref": "Df de referință pentru p̄conv",
  "struct.dos.par_apa": "nivelul apei subterane",
  "struct.dos.par_inghet": "adâncimea de îngheț",
  "struct.dos.par_ks": "Ks recomandat",
  "struct.dos.par_df": "Df recomandat",
  "struct.dos.par_b": "B minim recomandat",

  // --- STRUCTURĂ · Pasul 12 — eforturile finale --------------------------
  "struct.ef.ruleaza": "Se citesc eforturile combinate (R = C·F) din tensorul Pasului 11 și se extrag punctele de verificare: 5 stații per grindă, baza și vârful fiecărui stâlp, plus reacțiunile la bază — cu combinația care dă extremul și componentele concomitente.",
  "struct.ef.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga (după Pasul 11).",
  "struct.ef.punct_r1_sus": "fața reazemului 1 — momentul minim (fibra de sus întinsă)",
  "struct.ef.punct_r1_jos": "fața reazemului 1 — momentul maxim (fibra de jos întinsă)",
  "struct.ef.punct_camp": "câmp — extremul de moment din interiorul deschiderii (stațiile + punctul analitic V2 = 0)",
  "struct.ef.punct_camp_v": "câmp — extremul de tăietoare pe tăieturile din interiorul panoului de perete (acolo unde nu stă la fața unui stâlp)",
  "struct.ef.punct_r2_sus": "fața reazemului 2 — momentul minim (fibra de sus întinsă)",
  "struct.ef.punct_r2_jos": "fața reazemului 2 — momentul maxim (fibra de jos întinsă)",
  "struct.ef.punct_baza": "baza stâlpului (deasupra zonei rigide de la fundație/placă)",
  "struct.ef.punct_virf": "vârful stâlpului = secțiunea de sub grindă (nu mijlocul nodului)",

  "struct.ef.scurt_r1_sus": "R1 sus",
  "struct.ef.scurt_r1_jos": "R1 jos",
  "struct.ef.scurt_camp": "câmp",
  "struct.ef.scurt_camp_v": "câmp V",
  "struct.ef.scurt_r2_sus": "R2 sus",
  "struct.ef.scurt_r2_jos": "R2 jos",
  "struct.ef.scurt_baza": "bază",
  "struct.ef.scurt_virf": "vârf",
  "struct.ef.h_element": "ID-ul unic global din Pasul 4 (GR7.1 = grinda 7, nivelul 1); aceeași poziție are același număr pe toate nivelurile",
  "struct.ef.h_nivel": "nivelul pe care stă elementul (grinzile: planșeul peste acel nivel)",
  "struct.ef.h_grupare": "familia de combinații din care s-a extras extremul: fundamentală (1,35G + 1,5Q…) sau seismică (G + ψ2·Q ± E)",
  "struct.ef.h_punct": "punctul de verificare: grinzi = fețele celor două reazeme (sus/jos) + câmpul; stâlpi = baza și vârful",
  "struct.ef.h_criteriu": "ce extrem s-a căutat la stâlp: P_min/P_max (axialul extrem) sau M2_max/M3_max (momentul maxim în modul) — restul componentelor rândului sunt cele CONCOMITENTE",
  "struct.ef.h_x": "poziția stației, în metri, măsurată din AXUL stâlpului de la capătul 1 al grinzii (la stâlpi: de la nodul de jos); stațiile țin cont de zonele rigide",
  "struct.ef.h_combinatia": "combinația de încărcări care dă extremul — toate valorile rândului vin din EA (sunt concomitente, nu o înfășurătoare)",
  "struct.ef.h_P": "forța axială [kN]; negativ = compresiune",
  "struct.ef.h_V2": "forța tăietoare verticală [kN] (grinzi) / pe axa locală 2 (stâlpi)",
  "struct.ef.h_V2GS": "tăietoarea în aceeași stație din combinația GS = G + ψ2·Q + ψ2·S, fără seism — intră în V_Ed asociat capacității la armare",
  "struct.ef.h_V3": "forța tăietoare pe cealaltă axă locală [kN] (grinzi: orizontală)",
  "struct.ef.h_T": "momentul de torsiune [kN·m]",
  "struct.ef.h_M2": "momentul de încovoiere pe axa locală 2 [kN·m] (grinzi: în plan orizontal)",
  "struct.ef.h_M3": "momentul de încovoiere principal [kN·m]; la grinzi pozitiv = fibra de jos întinsă",
  "struct.ef.h_L": "lungimea grinzii între AXELE stâlpilor [m]",
  "struct.ef.h_l0": "deschiderea LIBERĂ [m] — între fețele reazemelor (L minus semi-gabaritele stâlpilor); ea intră în calculul capabil la armare",
  "struct.ef.legenda": "Ce înseamnă fiecare coloană",
  "struct.ef.livrabil": "Livrabilul: M / V / N per element",
  "struct.ef.info_titlu": "Ce conține tabelul",
  "struct.ef.info_ce": "Pentru fiecare grindă și stâlp (cu ID-ul din plan): momentele de încovoiere, forțele tăietoare și forța axială în punctele de verificare, cu combinația care dă extremul.",
  "struct.ef.info_de_ce": "Componentele unui rând sunt CONCOMITENTE (din aceeași combinație) — nu o înfășurătoare anonimă. Asta permite verificarea corectă P–M–M la stâlpi și armarea economică a grinzilor.",
  "struct.ef.p_M3": "momentul de încovoiere principal (kN·m)",
  "struct.ef.p_M3_sursa": "tensorul combinat al Pasului 11",
  "struct.ef.p_V2": "forța tăietoare verticală (kN)",
  "struct.ef.p_idem": "idem",
  "struct.ef.p_P": "forța axială (kN; negativ = compresiune)",
  "struct.ef.p_V2GS": "tăietoarea din combinația GS (G + ψ2·Q, fără seism) — pentru V_Ed asociat capacității la armare",
  "struct.ef.p_V2GS_sursa": "combinația GS a Pasului 11",
  "struct.ef.p_l0": "deschiderea liberă a grinzii (între fețele reazemelor)",
  "struct.ef.p_l0_sursa": "geometria stâlpilor din Pasul 4",
  "struct.ef.sub": "grinzi + stâlpi, pe {n} combinații (fundamentale + seismice + GS)",
  "struct.ef.export": "Exportul complet",
  "struct.ef.export_sub": "toate combinațiile × toate punctele de verificare ({fisier})",
  "struct.ef.descarca": "Descarcă CSV",
  "struct.ef.sanatate#n": "Verificări de sănătate — {n} avertisment|Verificări de sănătate — {n} avertismente|Verificări de sănătate — {n} de avertismente",
  "struct.ef.tab_grinzi": "Grinzi ({n})",
  "struct.ef.tab_stalpi": "Stâlpi și lamele ({n})",
  "struct.ef.tab_reactiuni": "Reacțiuni la bază ({n})",
  "struct.ef.toate": "toate",
  "struct.ef.fundamentala": "fundamentală",
  "struct.ef.seismica": "seismică",
  "struct.ef.cauta": "ex. GR7 sau ST3",
  "struct.ef.conventii": "Convențiile de semn și de raportare",
  "struct.ef.fara_randuri": "Niciun rând nu trece de filtre.",
  "struct.ef.fara_reactiuni": "Nicio reacțiune raportată.",
  "struct.ef.col_nod": "Nod",
  "struct.ef.col_comb_fz": "Combinația (FZ extrem)",
  "struct.ef.nota_reactiuni": "Reacțiunile la bază intră în dimensionarea fundațiilor — CSV-ul conține valorile pentru toate combinațiile.",

  // --- STRUCTURĂ · capetele de coloană ale tabelelor de eforturi ---------
  "struct.ef.c_grupare": "Grupare",
  "struct.ef.c_punct": "Punct",
  "struct.ef.c_criteriu": "Criteriu",
  "struct.ef.c_combinatia": "Combinația",

  // --- STRUCTURĂ · Pasul 8 — încărcările ---------------------------------
  "struct.inc.ruleaza": "Se construiesc cazurile de încărcare gravitaționale (G1–G3, Q1, Q2, S), se aplică pe modelul FEM din Pasul 7 și se verifică echilibrul global per caz. Rezultatele se stochează în tensorul de eforturi pentru Pașii 9–12.",
  "struct.inc.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga (după Pasul 7).",
  "struct.inc.greutate": "Greutatea permanentă totală",
  "struct.inc.info_g_titlu": "Greutatea permanentă (G1 + G2a + G2b + G3)",
  "struct.inc.info_g_ce": "Tot ce stă mereu pe structură: betonul (G1), pereții nestructurali (G2a + G2b) și finisajele (G3), însumate pe toată clădirea.",
  "struct.inc.info_g_de_ce": "E fundalul peste care vin încărcările variabile (utilă, zăpadă) și baza masei seismice. Fiecare caz e păstrat separat, ca la combinații să primească propriul coeficient.",
  "struct.inc.p_g1": "greutatea proprie a betonului (25 kN/m³)",
  "struct.inc.p_g1_sursa": "geometria Pasului 7",
  "struct.inc.p_g2": "pereții nestructurali, pe grinzi / pe placă",
  "struct.inc.p_g2_sursa": "pereții din Pasul 2 + preferința g_perete",
  "struct.inc.p_g3": "finisajele (SDL)",
  "struct.inc.p_g3_sursa": "tabul «Date clădire»",
  "struct.inc.cazuri_sub": "{cazuri} cazuri de încărcare pe {elemente} elemente",
  "struct.inc.echilibru": "Echilibrul global",
  "struct.inc.info_e_titlu": "Verificarea de echilibru (T3)",
  "struct.inc.info_e_ce": "Pentru fiecare caz se compară totalul aplicat pe structură cu suma reacțiunilor verticale din reazeme. Cele două trebuie să coincidă (dezechilibru sub 0,1%).",
  "struct.inc.info_e_de_ce": "Dacă o parte din încărcare «se pierde» (elemente nelegate, mapare greșită a pereților), suma reacțiunilor nu mai iese — verificarea prinde exact acest tip de eroare de model.",
  "struct.inc.echilibru_ok": "✓ OK",
  "struct.inc.echilibru_nu": "✗ NU",
  "struct.inc.echilibru_ok_sub": "suma reacțiunilor = totalul aplicat, pentru toate cazurile",
  "struct.inc.echilibru_nu_sub": "cel puțin un caz are dezechilibru peste toleranță — vezi tabelul",
  "struct.inc.date_intrare": "Datele de intrare ale încărcărilor",
  "struct.inc.info_d_titlu": "De unde vine fiecare cifră",
  "struct.inc.info_d_ce": "Toate valorile din care se construiesc cazurile: greutăți specifice, finisaje, utila categoriei, zăpada localității, coeficienții ψ.",
  "struct.inc.info_d_de_ce": "Un total de kN nu se poate verifica dacă nu se vede din ce s-a făcut. Coloana «de unde vine» spune cine a ales valoarea — tema de proiectare, harta de zonare, arhitectura sau metoda — iar coloana «articol» cu ce drept.",
  "struct.inc.col_marime": "Mărimea",
  "struct.inc.col_simbol": "Simbol",
  "struct.inc.col_valoare": "Valoarea",
  "struct.inc.col_de_unde": "De unde vine",
  "struct.inc.col_articol": "Articol",
  "struct.inc.nota_panouri": "din care {n} kN sunt panourile de subsol, aplicate nodal pe fâșiile lor de shell (nu ca linie pe o bară)",
  "struct.inc.echilibru_titlu": "Verificarea de echilibru per caz",
  "struct.inc.col_caz": "Caz",
  "struct.inc.col_total": "Total aplicat",
  "struct.inc.col_reactiuni": "Suma reacțiunilor",
  "struct.inc.col_dezechilibru": "Dezechilibru",
  "struct.inc.echilibru_final_ok": "✓ Echilibrul global e îndeplinit pentru toate cazurile.",
  "struct.inc.echilibru_final_nu": "• Echilibrul global NU e îndeplinit pentru toate cazurile — verifică maparea încărcărilor.",
  "struct.inc.pereti": "Pereții nestructurali",
  "struct.inc.info_p_titlu": "Cum se împart pereții pe structură",
  "struct.inc.info_p_ce": "Pereții din arhitectură (Pasul 2) se mapează pe grinzile de sub ei — încărcare liniară q_perete pe metru de grindă (G2a). Ce nu are grindă dedesubt devine încărcare uniformă echivalentă pe placă (G2b).",
  "struct.inc.info_p_de_ce": "Un perete pe o grindă o încarcă direct pe ea; un perete «pe câmp» se sprijină pe placă și se distribuie. Separarea păstrează eforturile corecte în grinzi.",
  "struct.inc.p_q": "greutatea peretelui pe metru liniar (g_perete × înălțimea liberă)",
  "struct.inc.p_q_sursa": "stratificația peretelui (g_perete_kn_m2)",
  "struct.inc.p_aria": "arie C",
  "struct.inc.p_aria_nume": "zonele de circulații comune (cat. C) ale nivelului",
  "struct.inc.p_aria_sursa": "Pasul 2 — funcțiunile",
  "struct.inc.col_pe_grinzi": "Pe grinzi",
  "struct.inc.col_pe_placa": "Pe placă",
  "struct.inc.col_q": "q perete",
  "struct.inc.col_arie_c": "Arie C",

  // --- STRUCTURĂ · Pasul 5 — fundația estimată ---------------------------
  "struct.fnd.ruleaza": "Selecție fișier și layere cu LLM, apoi calculul conturului. Prima rulare poate dura ~1 minut dacă desenul nu a fost încă interpretat.",
  "struct.fnd.lungime": "Lungime estimată fundație",
  "struct.fnd.nr_axe": "{n} axe continue — ",
  "struct.fnd.sursa_implicita": "lungimea cumulată a axului pereților de structură (linie continuă, și pe sub goluri)",
  "struct.fnd.intra_p6": " — intră ca parametru în Pasul 6",
  "struct.fnd.axe_grila": "{axe} axe denumite, {peGrila} pe grila clădirii",
  "struct.fnd.rotire": " (rotire maximă {n}°)",
  "struct.fnd.abatere": "grinzile se abat de dreapta axului cu cel mult ",
  "struct.fnd.info_axe_titlu": "De ce sunt axele drepte",
  "struct.fnd.info_axe_de_ce": "Un ax de fundație e o dreaptă, iar talpa are lățimea B (0,6–2,5 m): o abatere de zeci de centimetri stă tot sub ea. Una de METRI înseamnă că axul chiar nu e drept, iar cauza e mai devreme — la extragerea pereților sau la amplasarea stâlpilor.",
  "struct.fnd.p_theta": "unghiul grilei clădirii",
  "struct.fnd.p_theta_sursa": "Pasul 2, măsurat pe PEREȚI (nu pe grinzi)",
  "struct.fnd.p_abatere": "abatere",
  "struct.fnd.p_abatere_nume": "cât rătăcesc grinzile față de dreapta care le-a înlocuit [m]",
  "struct.fnd.p_abatere_sursa": "calculat aici",
  "struct.fnd.p_toleranta": "toleranță",
  "struct.fnd.p_toleranta_nume": "sub cât se consideră două drepte același ax [m]",
  "struct.fnd.p_toleranta_sursa": "{n} m — cea mai îngustă talpă pe care o poate alege Pasul 6",
  "struct.fnd.regim": "Regim de înălțime",
  "struct.fnd.info_regim_titlu": "Regimul de înălțime",
  "struct.fnd.info_regim_ce": "Prescurtarea uzuală pentru câte niveluri are clădirea: P = parter, P+1 = parter plus un etaj, S+P+2 = subsol, parter și două etaje.",
  "struct.fnd.info_regim_de_ce": "Numărul de niveluri intră în greutatea totală a clădirii (fiecare nivel adaugă greutate pe fundație). Se preia din Pasul 2 (analiza arhitecturii), ca toți pașii să folosească aceeași listă de niveluri.",
  "struct.fnd.p_niveluri": "niveluri",
  "struct.fnd.p_niveluri_nume": "planurile de nivel identificate",
  "struct.fnd.p_niveluri_sursa": "Pasul 2 (sau, fără el, identificate aici din denumirile fișierelor)",
  "struct.fnd.nr_niveluri": "{n} niveluri — ",
  "struct.fnd.suprafata": "Suprafață desfășurată",
  "struct.fnd.suprafata_sub": "suma suprafețelor nivelurilor · gabarit {x} × {y} m",
  "struct.fnd.per_nivel": "Suprafețe per nivel",
  "struct.fnd.col_fisier": "Fișier",
  "struct.fnd.col_suprafata": "Suprafață",
  "struct.fnd.col_sursa": "Sursa",
  "struct.fnd.eroare_nivel": "eroare: {eroare}",
  "struct.fnd.identificat": "Am identificat pereții de structură",
  "struct.fnd.fisier": "Fișier",
  "struct.fnd.geometria": "Geometria",
  "struct.fnd.layere_pereti": "Layere pereți",
  "struct.fnd.layere_goluri": "Layere goluri",
  "struct.fnd.goluri_nota": "ferestre/uși — fundația continuă drept pe sub aceste goluri",
  "struct.fnd.desen": "Pereți de structură + ax fundație",

  // --- STRUCTURĂ · colectorul de verificări ------------------------------
  "struct.col.placa": "placă",
  "struct.sev.critica": "critică",
  "struct.sev.critica_ce": "driftul și efectul de bici — deplasările pe care structuristul le cere trecute fără excepție. Se repară înaintea oricărei alte verificări, iar o soluție care le pică nu poate bate una care le trece, oricât de bună ar fi în rest.",
  "struct.sev.globala": "globală",
  "struct.sev.globala_ce": "validitatea analizei și restul controlului deplasărilor (θ, rotirea de coardă, cutia rigidă, separarea modurilor) — cât timp una din astea pică, toate cifrele de dedesubt sunt calculate pe altă structură, iar remediul nu e armătura, ci conformarea. Se repară imediat după cele critice.",
  "struct.sev.importanta": "importantă",
  "struct.sev.importanta_ce": "capacitatea elementelor verticale, fundația, amplasarea și decuplarea modurilor — repararea cere secțiuni mai mari, adică o conformare nouă, deci se propagă.",
  "struct.sev.locala": "locală",
  "struct.sev.locala_ce": "se rezolvă cu armătură, cu o redistribuire sau cu o decizie de arhitect, fără să miște restul soluției. Grinzile și nodurile sunt aici anume: proiectarea la capacitate VREA articulațiile plastice în grinzi.",
  "struct.tem.fara": "Fără tematică (categorie nouă)",
  "struct.tem.fara_ce": "Verificări a căror categorie nu e (încă) prinsă de nicio tematică din catalog. Se arată aici ca să nu dispară din tablou.",

  // --- STRUCTURĂ · tabloul de verificări ---------------------------------
  "struct.vp.pastila_pica": "pică",
  "struct.vp.chip_pica": "pică",
  "struct.vp.pastila_limita": "de revizuit",
  "struct.vp.chip_limita": "de revizuit",
  "struct.vp.pastila_trec": "trec",
  "struct.vp.chip_trece": "trece",
  "struct.vp.pastila_nu_se_cer": "nu se cer",
  "struct.vp.chip_nu_se_cere": "nu se cere",
  "struct.vp.chip_informativ": "informativ",
  "struct.vp.grup_tematica": "Tematică",
  "struct.vp.grup_verdict": "Verdict",
  "struct.vp.grup_severitate": "Severitate",
  "struct.vp.titlu": "Verificări",
  "struct.vp.gol": "Tabloul verificărilor se umple după rularea lanțului.",
  "struct.vp.esec": "Verificările n-au putut fi citite. Reîncarcă pagina; dacă se repetă, serviciul structurii nu răspunde.",
  "struct.vp.esec_randuri": "Verificările acestui tip n-au putut fi citite. Închide cardul și deschide-l din nou.",
  "struct.vp.corp_ansamblu": "infrastructura comună: pereții de subsol, fundația, cutia",
  "struct.vp.corp_titlu": "verificările corpului {corp}, inclusiv cele globale ale lui (moduri, drift, cutia rigidă)",
  "struct.vp.corp": "corp {corp}",
  "struct.vp.solutie_titlu": "Structură — soluția {solutie}",
  "struct.vp.disciplina": "Structură",
  "struct.vp.solutia": "soluția {solutie}",
  "struct.vp.filtre": "Filtre",
  "struct.vp.filtre_ce": "se combină: rămâne ce trece prin toate",
  "struct.vp.verdict_ce": "ce a ieșit din calcul",
  "struct.vp.arata_numai": "Arată numai ce {ce}",
  "struct.vp.severitate_ce": "cât de departe se propagă o picată — ce se repară întâi",
  "struct.vp.sev_titlu": "{cod} — {ce}",
  "struct.vp.tematica_ce": "subiectul verificat",
  "struct.vp.toate_temele_titlu": "Toate tematicile, una sub alta",
  "struct.vp.toate_temele": "Toate tematicile",
  "struct.vp.toate": "toate",
  "struct.vp.din": "{n} din {total}",
  "struct.vp.verificari#n": "verificare|verificări|verificări",
  "struct.vp.si": "și",
  "struct.vp.scoate": "Scoate filtrul de {grup}",
  "struct.vp.niciun_filtru": "— niciun filtru, se arată tot",
  "struct.vp.desfa": "desfă filtrele",
  "struct.vp.tema_sumar#n": "{n} verificare, {tipuri} tipuri|{n} verificări, {tipuri} tipuri|{n} de verificări, {tipuri} tipuri",
  "struct.vp.tema_pica": " · {n} pică",
  "struct.vp.nimic": "Nicio verificare nu trece prin toate filtrele de mai sus.",
  "struct.vp.cadran": "{trec} din {masurate} verificări măsurate trec",
  "struct.vp.globale#n": "{n} picată globală|{n} picate globale|{n} de picate globale",
  "struct.vp.fata_de": "față de {prag}",
  "struct.vp.dir_tip": "direcția {dir}{detaliu} · {verdict}",
  "struct.vp.dir_detaliu": " — {ce}",
  "struct.vp.pe_directii#n": " · pe direcția {lista}| · pe direcțiile {lista}| · pe direcțiile {lista}",
  "struct.vp.masurat_card": " · {E}",
  "struct.vp.masurat_card_prag": " · {E} față de {R}",
  "struct.vp.raportata": "raportată",
  "struct.vp.raportata_titlu": "verificare RAPORTATĂ: se numără și se arată, dar nu oprește livrarea — nu e cerință de normativ, iar structuristul a admis să nu treacă",
  "struct.vp.informative": "{n} informative",
  "struct.vp.ce_se_face": "Ce se face",
  "struct.vp.bucla": " · bucla o încearcă singură",
  "struct.vp.fara_categorie": "Tipul ăsta nu are (încă) o categorie în catalogul de explicații — cifrele de mai jos sunt cele emise de pas.",
  "struct.vp.col_verificarea": "Verificarea / elementul",
  "struct.vp.col_directie": "Direcție",
  "struct.vp.col_masurat": "Măsurat față de prag",
  "struct.vp.se_arata": "se arată {n} din {total}, cele mai strânse întâi — ",
  "struct.vp.incarca": "încarcă încă 200",
  "struct.vp.toate_care_pica": "toate elementele care pică verificarea asta →",
  "struct.vp.trasa_titlu": "De unde vin cifrele — «0 înseamnă zero\»",
  "struct.vp.trasa_ce": "Câte verificări s-au putut citi din fiecare calcul. Un calcul necitit înseamnă verdicte nevăzute, deci un «0 picate\» incomplet.",
  "struct.vp.col_calculul": "Calculul",
  "struct.vp.col_verificari": "Verificări",
  "struct.vp.col_picate": "Picate",
  "struct.vp.col_citit": "Citit",
  "struct.vp.necitit": "necitit",
  "struct.vp.vezi_calculul": "vezi calculul →",

  // --- STRUCTURĂ · pagina unui element -----------------------------------
  "struct.elp.nota_completa": "Nota de calcul completă",
  "struct.elp.nota_sub": "tot ce calculează {pas} pe elementul ăsta: secțiunile, formulele, armarea aleasă și de ce.",
  "struct.elp.nota_pagina_pasului": "pagina pasului →",
  "struct.elp.nota_pas.armare_grinzi": "Pasul 13 (armarea grinzilor)",
  "struct.elp.nota_pas.armare_stalpi": "Pasul 15 (armarea stâlpilor)",
  "struct.elp.nota_pas.armare_pereti": "Pasul 14 (armarea pereților)",
  "struct.elp.nota_pas.armare_placa": "Pasul 16 (armarea plăcii)",
  "struct.elp.nota_pas.armare_fundatie": "Pasul 18 (armarea fundației)",
  "struct.elp.negasit": "Elementul nu e (încă) în indexul rezultatelor — rulează pașii de armare sau verifică referința.",
  "struct.elp.inapoi": "înapoi la listă →",
  "struct.elp.titlu_3d": "{tip} {ref} — 3D",
  "struct.elp.restrange_titlu": "înapoi în coloană, lângă verificări",
  "struct.elp.extinde_titlu": "pe toată lățimea paginii — verificările coboară sub planșă",
  "struct.elp.restrange": "restrânge planșa",
  "struct.elp.extinde": "extinde planșa",
  "struct.elp.doar_nivel_stalp": "numai bucata de stâlp de la nivelul ăsta",
  "struct.elp.doar_deschidere": "numai deschiderea asta",
  "struct.elp.doar_stalpul": "Doar stâlpul {ref}",
  "struct.elp.doar_grinda": "Doar grinda {ref}",
  "struct.elp.stiva_titlu": "stiva întreagă, din talpa fundației până la ultimul planșeu",
  "struct.elp.ax_titlu": "axul coliniar întreg — {n} deschideri, cap la cap",
  "struct.elp.tot_stalpul": "Tot stâlpul {ref}",
  "struct.elp.tot_axul": "Tot axul ({n})",
  "struct.elp.capitolul5": "Capitolul 5 — Elementul",
  "struct.elp.urmatoarea_titlu": "următorul element neconform, după rezerva cea mai mică",
  "struct.elp.urmatoarea": "{ref} (următoarea care pică) →",
  "struct.elp.re_minim": "Verificarea care guvernează",
  "struct.elp.verificarile": "Verificările lui",
  "struct.elp.picate": "{n} picate",
  "struct.elp.cantitati": "Cantități",
  "struct.elp.ver_titlu": "Verificările elementului",
  "struct.elp.ver_sub": "click pe o verificare → detaliul complet în {pas}",
  "struct.elp.col_verificarea": "Verificarea",
  "struct.elp.col_punct_grinda": "Punctul pe grindă",
  "struct.elp.col_punct": "Punct",
  "struct.elp.col_valoare": "Valoare (E)",
  "struct.elp.col_capabil": "Capabil (R)",
  "struct.elp.col_sursa": "Sursa",
  "struct.elp.col_efort": "Efort → rezistență",
  "struct.elp.rand_titlu": "deschide detaliul aici: formula, articolul, valorile din calcul, soluțiile",
  "struct.elp.marja_titlu": "acceptată cu marja practicii: R/E sub 1, dar în {n}%",
  "struct.elp.marja": "marjă {n}%",
  "struct.elp.nota_tabel": "click pe un rând = detaliul lui aici (formula, articolul, valorile din calcul, soluțiile); linkul din detaliu duce în pagina pasului, pentru desene și tabele complete",
  "struct.de_hotarat.titlu": "De hotărât de proiectant",
  "struct.de_hotarat.sub": "nu sunt verificări: nu trec și nu pică, iar verdictul elementului nu ține de ele",
  "struct.elp.infasuratoare": "Înfășurătoarea pe lungimea axului",
  "struct.elp.vedere_cotata": "Vederea cotată — {ce}",
  "struct.elp.toate_nivelurile": "{stem}, toate nivelurile",
  "struct.elp.doar_nivelul": "numai nivelul elementului",
  "struct.elp.doar": "Doar {ref}",
  "struct.elp.sectiunea": "Secțiunea cotată",
  "struct.elp.contextul": "Contextul în clădire",
  "struct.elp.istoric": "Istoricul lui (Pasul 19)",
  "struct.elp.istoric_rand": "{de_ce}: {de_la} → {la} ",
  "struct.elp.istoric_re": "(R/E {n})",

  // --- STRUCTURĂ · pagina elementului: verificarea care guvernează, membrii
  //     claselor, fundația axului, desenele lamelei -------------------------
  "struct.elp.guverneaza_titlu": "verificarea cu cea mai mică rezervă R/E de pe element: ea decide verdictul",
  "struct.membri.col_element": "Elementul",
  "struct.fel.lamela": "Lamela",
  "struct.tca.fara_combinatii": "Axul n-are combinații cu presiune calculată.",
  "struct.cfa.titlu": "Fundația (Pasul 17)",
  "struct.cfa.sub": "talpa axului, combinațiile verificate și citirea presiunilor",
  "struct.cfa.valori": "L = {l} m · B = {b} m · D_f = {d} m · A = {a} m² · W_long = {wl} m³ · W_transv = {wt} m³",
  "struct.cfa.kexc": " · k_exc = {k}",
  "struct.cfa.stalpi": " · {n} stâlpi",
  "struct.lam.sect_titlu": "Secțiunea {id} — {t}×{L} cm",
  "struct.lam.leg_capete": "capete: 2 × {n}Ø{phi} pe {l} cm",
  "struct.lam.leg_etrieri": "etrieri capete Ø{phi}/{pas} cm, ochi {a}×{b} cm, confinat {lconf} cm",
  "struct.lam.leg_inima": "inimă: {n}Ø{phi}/{pas} mm vertical, pe două fețe",
  "struct.lam.leg_oriz": "orizontal Ø{phi}/{pas} mm · agrafe Ø{phia}, {na}/m²",
  "struct.lam.vedere_titlu": "Elevația stivei {stack} — L = {L} m, t = {t} cm",
  "struct.lam.s4_explicatie": "Nivelul {el} ({zona}): secțiunea cotată cu carcasele de capăt și inima, elevația stivei cu zonele A/B și l_cr, barele cu mărcile lor și «ceapa» P–M–M a secțiunii adoptate.",
  "struct.lam.th_rol": "Rolul",
  "struct.lam.th_bare": "Barele",
  "struct.lam.th_unde": "Detalii",
  "struct.lam.th_marca": "Marca",
  "struct.lam.rol_capete": "carcasele de capăt",
  "struct.lam.rol_etrieri": "etrierii capetelor",
  "struct.lam.rol_vertical": "inima, vertical",
  "struct.lam.rol_orizontal": "inima, orizontal",
  "struct.lam.rol_agrafe": "agrafe",
  "struct.lam.rol_agrafe_conf": "agrafe de confinare",
  "struct.lam.unde_capete": "pe {l} cm la fiecare capăt, ρ = {rho} %",
  "struct.lam.unde_etrieri": "ochi {a} × {b} cm, {n} pe capăt, lungime confinată {lconf} cm",
  "struct.lam.unde_inima": "ρ = {rho} %",
  "struct.lam.unde_agrafe": "{n} pe m²",
  "struct.lam.unde_agrafe_conf": "{k} pe set de etrieri, câte una pe rând de bare din zona confinată",

  // --- STRUCTURĂ · registrul de soluții ----------------------------------

  // --- STRUCTURĂ · fișa unei soluții -------------------------------------
  "struct.fs.stare_aplicata": "aplicată",
  "struct.fs.stare_acoperita": "acoperită de altă modificare",
  "struct.fs.stare_epuizata": "catalog epuizat — cere decizie de om",
  "struct.fs.stare_refuzata": "refuzată — înghețat de conformare",
  "struct.fs.titlu": "Fișa soluției",
  "struct.fs.gol": "Fișa se scrie la Pasul 19 — rulează lanțul până la capăt.",
  "struct.fs.solutii": "Soluții",
  "struct.fs.fisa_nume": "Fișa — {nume}",
  "struct.fs.din_solutia": "din soluția {solutie}",
  "struct.fs.rezolutie": " · rezoluție h = {n} m",
  "struct.fs.durata": " · {n} min",
  "struct.fs.picate": "Picate",
  "struct.fs.din_total": " din {n}",
  "struct.fs.cost": "Cost structură",
  "struct.fs.fata_de_plecare": " · {semn}{suma} € față de plecare",
  "struct.fs.scor": "Scor",
  "struct.fs.verdict": "Verdict",
  "struct.fs.picatele": "picatele ei →",
  "struct.fs.raport": "raportul complet (P17) →",
  "struct.fs.modificat": "Ce s-a modificat efectiv",
  "struct.fs.op_uri": "op-urile, în română",
  "struct.fs.aplicate": "{n} aplicate",
  "struct.fs.acoperite": "{n} acoperite",
  "struct.fs.epuizate": "{n} catalog epuizat",
  "struct.fs.refuzate": "{n} refuzate",
  "struct.fs.col_verificarea": "Verificarea care a cerut",
  "struct.fs.col_lipsea": "Cât lipsea",
  "struct.fs.col_abordarea": "Abordarea",
  "struct.fs.col_schimbat": "Ce s-a schimbat",
  "struct.fs.col_stare": "Stare",
  "struct.fs.abordare_titlu": "a câta pârghie din catalogul tipului de verificare",
  "struct.fs.abordare": "a {n}-a din {total}",
  "struct.fs.promis_livrat": "Promis vs livrat",
  "struct.fs.promis_sub": "severitate înainte → prezisă; mecanismul de auto-corecție al solverului",
  "struct.fs.col_parghia": "Pârghia",
  "struct.fs.col_promis": "Promis → livrat",
  "struct.fs.demotata_titlu": "a livrat sub un sfert din promisiune de două ori pe aceeași clasă — nu se mai încearcă pe proiectul ăsta",
  "struct.fs.demotata": "demotată",
  "struct.fs.amanate": "Amânate · {n}",
  "struct.fs.netratate": "Netratate · {n}",
  "struct.fs.de_ce_oprit": "De ce s-a oprit aici",

  // --- STRUCTURĂ · Pasul 7, modelul FEM ----------------------------------
  "struct.fem.ruleaza": "Pasul rulează…",
  "struct.fem.ruleaza_sub": "Se construiește modelul FEM (grinzi T cu b_eff conform EC2, rigidități fisurate, diafragme rigide cu masele seismice) și se rulează analiza modală de verificare în OpenSees.",
  "struct.fem.nerulat": "Pasul nu a fost rulat încă. Apasă «Run» în meniul din stânga (după Pasul 4).",
  "struct.fem.schita_titlu": "Se construiește modelul 3D…",
  "struct.fem.schita_sub": "Din geometria Pasului 4, fără nicio analiză. Pe o clădire mare ține câteva zeci de secunde; se face o dată și rămâne.",
  "struct.fem.esec": "Ultima rulare a eșuat: {motiv}",
  "struct.fem.eroare_necunoscuta": "eroare necunoscută",
  "struct.fem.reruleaza": "Rulează din nou din meniul din stânga.",
  "struct.fem.t1": "Perioada fundamentală",
  "struct.fem.t1_titlu": "Perioada fundamentală T₁",
  "struct.fem.t1_ce": "Dacă împingi clădirea și îi dai drumul, ea se leagănă. T₁ e durata unei legănări complete pe direcția în care clădirea e cea mai moale.",
  "struct.fem.t1_dece": "Perioada decide cât de tare «simte» clădirea cutremurul (se citește din spectrul de răspuns la T₁). Se calculează din modelul cu rigidități fisurate — betonul crăpat e mai moale, deci T mai mare, mai realist.",
  "struct.fem.t1_ei": "rigiditățile fisurate (grinzi / stâlpi)",
  "struct.fem.t1_ei_sursa": "P100-1; constante ale metodei",
  "struct.fem.t1_m": "masa seismică per etaj (D + SDL + ψE·Utilă)",
  "struct.fem.t1_m_sursa": "calculată în acest pas, lumpată în CM",
  "struct.fem.t1_sub": "f₁ = {f} Hz · mod {mod} din {total}",
  "struct.fem.t1_sub_local": " (modurile dinainte sunt locale, cu masă neglijabilă)",
  "struct.fem.modal_nerulat": "verificarea modală nu a rulat",
  "struct.fem.masa": "Masă seismică totală",
  "struct.fem.masa_titlu": "Masa seismică — ce se leagănă la cutremur",
  "struct.fem.masa_ce": "Formula: M = (D + SDL + ψE·Utilă) / g. D = greutatea proprie a betonului (placă + grinzi + stâlpi), SDL = finisajele și compartimentările, iar din încărcarea utilă (oameni, mobilă) intră doar fracțiunea ψE — restul probabil nu e acolo în timpul cutremurului.",
  "struct.fem.masa_dece": "Forța seismică = masă × accelerație, deci fiecare tonă contează direct. Împărțim greutatea (kN) la accelerația gravitațională g = 9,81 m/s² ca să obținem masa (tone). ψE ≈ 0,24 spune că, statistic, doar un sfert din încărcarea utilă normată chiar există în clădire la un moment dat.",
  "struct.fem.masa_d": "greutatea proprie a structurii de beton",
  "struct.fem.masa_d_sursa": "calculată din geometria Pasului 4 (25 kN/m³) și înălțimile din Pasul 2",
  "struct.fem.masa_sdl": "greutatea finisajelor pe metru pătrat",
  "struct.fem.masa_sdl_sursa": "Date clădire → finisaj",
  "struct.fem.masa_psi": "fracțiunea din utilă prezentă la cutremur",
  "struct.fem.masa_psi_sursa": "constantă a metodei (P100-1/CR0: φ·ψ2 ≈ 0,24 rezidențial)",
  "struct.fem.masa_g": "accelerația gravitațională (9,81 m/s²)",
  "struct.fem.masa_g_sursa": "constantă fizică",
  "struct.fem.masa_sub": "{kn} kN = D + SDL + ψE·Utilă (ψE = {psi})",
  "struct.fem.varianta": "Model FEM — varianta {varianta}",

  "struct.fem.sub_shell": "shell-uri (mesh {mesh} m) în {ochiuri} ochiuri de placă{fasii} + elemente de bară · {noduri} noduri · placă flexibilă, masă distribuită",
  "struct.fem.sub_fasii": " + {n} fâșii de perete de subsol",
  "struct.fem.sub_lean": "elemente de bară · {noduri} noduri ({puncte} puncte de împărțire) · {diafragme} diafragme rigide",
  "struct.fem.acoperire": "Cât din clădire e placă",
  "struct.fem.acoperire_titlu": "Acoperirea plăcii",
  "struct.fem.acoperire_ce": "Aria totală a poligoanelor de planșeu, raportată la suprafața construită a nivelurilor (amprentele din Pasul 2) și la suprafața înscrisă între stâlpii marginali.",
  "struct.fem.acoperire_dece": "Toate încărcările gravitaționale și toată masa seismică se aplică pe aria shell-urilor: ce nu e placă nu are nici greutate, nici masă, nici utilă. Verificarea veche («acoperire mesh») compara mesh-ul cu poligonul de placă, deci ieșea ~100 % și când poligonul acoperea 28 % din nivel (proiectul 2).",
  "struct.fem.acoperire_amprenta": "amprentă",
  "struct.fem.acoperire_amprenta_nume": "suprafața construită a nivelurilor",
  "struct.fem.acoperire_amprenta_sursa": "Pasul 2 — conturul închis al pereților + golurile + plăcile în consolă",
  "struct.fem.acoperire_stalpi": "între stâlpi",
  "struct.fem.acoperire_stalpi_nume": "înfășurătoarea stâlpilor fiecărui nivel",
  "struct.fem.acoperire_stalpi_sursa": "Pasul 4, prin geometria modelului",
  "struct.fem.acoperire_sub": "{placa} m² de placă din {construit} m² construiți (Pasul 2) · {hull} % din suprafața dintre stâlpi · mesh {mesh} %",
  "struct.fem.intrari": "Date de intrare",
  "struct.fem.intrari_titlu": "De unde vine fiecare dată de intrare",
  "struct.fem.intrari_ce": "Modelul de analiză combină date din pașii precedenți și din setările proiectului — fiecare cu sursa ei, ca totul să fie corelat pe tot lanțul.",
  "struct.fem.intrari_geom": "stâlpii, grinzile și pozițiile lor",
  "struct.fem.intrari_geom_sursa": "Pasul 4 (modelul structural, pe pereții persistenți din Pasul 2)",
  "struct.fem.intrari_h": "înălțimile fiecărui etaj (lungimea stâlpilor, cotele planșeelor)",
  "struct.fem.intrari_h_sursa": "Pasul 2 — cotele de nivel citite din fațade, prin Pasul 4",
  "struct.fem.intrari_beton": "clasa de beton și modulul de elasticitate (cât de «tare» e materialul)",
  "struct.fem.intrari_beton_sursa": "Date clădire (EN 1992-1-1, tabelul claselor)",
  "struct.fem.intrari_finisaj": "greutatea finisajelor pe metru pătrat",
  "struct.fem.intrari_finisaj_sursa": "Date clădire",
  "struct.fem.intrari_dest": "încărcarea utilă normată (oameni, mobilă)",
  "struct.fem.intrari_dest_sursa": "Date clădire (SR EN 1991-1-1)",
  "struct.fem.intrari_placa": "grosimea plăcii de beton a planșeului",
  "struct.fem.intrari_placa_sursa": "Pasul 7 — aleasă de solver",
  "struct.fem.intrari_sub": "E = {e} GPa · finisaj {finisaj} ({sdl} kN/m²) · {destinatie} ({q} kN/m²) · placă {placa} cm",
  "struct.fem.intrari_etaje": " · etaje {lista} m (Pasul 2)",
  "struct.fem.scena": "Reprezentarea 3D a modelului",
  "struct.fem.scena_sub": "rotește cu mouse-ul, zoom cu scroll · click pe o grindă, un stâlp sau pe un ochi de placă pentru proprietăți",
  "struct.fem.leg_stalpi": "stâlpi",
  "struct.fem.leg_grinzi_inima": "grinzi (inimă sub placă)",
  "struct.fem.leg_grinzi_t": "grinzi T",
  "struct.fem.leg_brate": "brațe rigide (de la nodul stâlpului la capătul real al grinzii; linie întreruptă)",
  "struct.fem.leg_placa_mesh": "placă (mesh ShellMITC4)",
  "struct.fem.leg_placa_diafragma": "placă (diafragmă rigidă)",
  "struct.fem.leg_noduri": "puncte FEM",
  "struct.fem.leg_pereti_beton": "pereți beton (subsol + laturile de balcon cerute de arhitectură)",
  "struct.fem.leg_balcoane": "balcoane și terase (beton)",
  "struct.fem.leg_logii": "logii (nu ies din amprentă)",
  "struct.fem.leg_reazem": "reazem stâlp pe grindă",
  "struct.fem.leg_cm": "CM / master diafragmă",

  "struct.fem.schita_nota": "modelul e construit din geometria Pasului 4, nu analizat: perioadele, masele participante și verificarea modală vin din rularea Pasului 7",
  "struct.fem.rulat_la": "rulat la {data}",
  "struct.fem.subsol": "Subsol rigid (cutia rigidă)",
  "struct.fem.subsol_titlu": "Subsolul rigid",
  "struct.fem.subsol_ce": "La clădirile P+2 sau peste, cu subsol, între stâlpii subsolului conectați prin pereți se toarnă pereți de beton armat (~20 cm, la fața exterioară a stâlpului). Infrastructura devine o «cutie rigidă», iar suprastructura se poate considera încastrată la fața plăcii peste subsol.",
  "struct.fem.subsol_dece": "P100-1 §4.4.1.7 + C5.8 recomandă infrastructura de tip cutie rigidă; criteriul de practică al structuristului: rigiditatea laterală a subsolului cu ≥50 % peste cea a oricărui nivel suprateran (raportul de mai jos, pe ambele direcții). Stâlpii păstrează aceeași secțiune în subsol — rigiditatea vine din pereți.",
  "struct.fem.subsol_pereti": "{n} pereți de beton",
  "struct.fem.subsol_grosime": " de {cm} cm",
  "struct.fem.subsol_raport": "k_subsol / max(k etaje) = {x}× pe X, {y}× pe Y",
  "struct.fem.subsol_prag_ok": "≥ {prag}×",
  "struct.fem.subsol_prag_nu": "— pragul e {prag}×",
  "struct.fem.subsol_nivel": "nivel",
  "struct.fem.subsol_nota": "Rigiditatea per nivel: stâlpii cu 12·E·I/h³ (tensorul rotit pe direcția laturii lungi), pereții de beton cu 1/(h³/12EI + 1,2·h/GA) pe direcția lor — E brut peste tot, contează raportul dintre niveluri.",
  "struct.fem.dir_torsiune": "torsiune",
  "struct.fem.dir_mixt": "mixt",
  "struct.fem.forme": "Formele modale",
  "struct.fem.forme_se_aduc": "Se aduc formele modale…",
  "struct.fem.forme_lipsa": "Rezultatul curent nu conține formele modale — rulează din nou Pasul 7 (rezultatele mai vechi nu le aveau salvate).",
  "struct.fem.moduri": "Moduri de vibrație",
  "struct.fem.forma_titlu": "Forma modală",
  "struct.fem.forma_ce": "Cum se leagănă clădirea în fiecare mod propriu: deformata e animată și exagerată (amplitudinea reală depinde de cutremur, nu de mod). Culoarea arată cât de mult se mișcă fiecare zonă (albastru = puțin, roșu = mult).",
  "struct.fem.forma_dece": "Modurile joase (T mare) domină răspunsul seismic: primele două sunt de regulă translații pe X/Y, al treilea torsiune. Formele sunt reconstruite exact din condensarea statică — deformata statică sub forțele de inerție ale modului.",
  "struct.fem.tab_mod": "Mod {mod} · {t}s · {tip}",
  "struct.fem.mod_sub": "T = {t} s · f = {f} Hz · masă participantă: {x}% X, {y}% Y, {rz}% torsiune",
  "struct.fem.mod_puritate": " · puritate {p}",
  "struct.fem.mase_titlu": "Masele implicate în fiecare mod",
  "struct.fem.mase_total": "masa seismică totală {t} t",
  "struct.fem.mase_criteriu": "criteriul de ≥ 90 % masă participantă cumulată, pe fiecare direcție (P100-1)",
  "struct.fem.mase_cumulat": "cumulat {x} X · {y} Y",
  "struct.fem.col_mod": "Mod",
  "struct.fem.col_masa_x": "masa X",
  "struct.fem.col_masa_y": "masa Y",
  "struct.fem.col_torsiune": "torsiune",
  "struct.fem.col_cum_x": "cumulat X",
  "struct.fem.col_cum_y": "cumulat Y",

  "struct.fem.lay.stalpi": "stâlpi",
  "struct.fem.lay.grinzi": "grinzi",
  "struct.fem.lay.placa": "placă (ochiuri)",
  "struct.fem.lay.armatura": "armătură",
  "struct.fem.lay.armatura_n": "armătură ({n} elemente)",
  "struct.fem.lay.armatura_nerulat": "armătură (pașii n-au rulat)",
  "struct.fem.lay.mesh": "rețea FEM (placă)",
  "struct.fem.lay.noduri": "noduri FEM (notație)",
  "struct.fem.lay.cm": "centru de masă",
  "struct.fem.lay.pereti": "pereți nestructurali",
  "struct.fem.lay.pereti_beton": "pereți beton",
  "struct.fem.lay.zidarie_confinata": "zidărie confinată",
  "struct.fem.zc_titlu": "Peretele de zidărie confinată {id}",
  "struct.fem.zc_sursa": "etajul retras-proeminență",
  "struct.fem.zc_material": "zidărie confinată (ZC)",
  "struct.fem.zc_material_sub": "blocuri ceramice cu mortar, cu stâlpișori și centură de beton armat",
  "struct.fem.zc_capete_sub": "stâlpii de beton de la capete; «—» e un capăt de zid, cu stâlpișor propriu",
  "struct.fem.zc_sect_sub": "grosimea zidului din arhitectură × înălțimea de sub grinda sau placa de deasupra",
  "struct.fem.zc_info_titlu": "De ce e zidăria structură aici",
  "struct.fem.zc_info_ce": "Etajul retras are cel mult 20 % din aria nivelului de sub el și nu e mai înalt decât el: e o proeminență (P100-1 §8.3.2.2(5)), nu un nivel. Zidurile lui de cel puțin 24 cm sunt pereți de zidărie confinată, pe grinzile nivelului de dedesubt, iar stâlpii care urcă de jos continuă cu 30 × 30.",
  "struct.fem.zc_info_dece": "Efectul de bici nu i se mai aplică. În schimb pereții lui duc de două ori partea lui din forța seismică a clădirii (rel. 8.2), iar modelul îi ține ca plăci de zidărie cu jumătate din modulul de elasticitate (zidărie fisurată, §8.4.1(4)).",
  "struct.fem.zc_greutate": "greutate",
  "struct.fem.zc_greutate_sub": "zidăria cu tencuiala ei, pe metrul de perete — stă pe grinzile de dedesubt",
  "struct.fem.lay.balcoane": "balcoane",
  "struct.fem.lay.fundatie": "fundație (beton)",
  "struct.fem.lay.fundatie_afara": "fundație (beton, nu e în calcul)",
  "struct.fem.lay.placa_sol": "placă pe sol (nu ține structura)",
  "struct.fem.lay.radier": "radier (beton)",
  "struct.fem.lay.ferestre": "ferestre ({n})",
  "struct.fem.lay.usi": "uși ({n})",
  "struct.fem.lay.parapete": "parapeți ({n})",
  "struct.fem.lay.nuclee": "scări și lifturi ({n})",
  "struct.fem.leg_scara": "casa scării (din arhitectură, doar afișată)",
  "struct.fem.leg_lift": "puțul liftului (din arhitectură, doar afișat)",
  "struct.fem.lay.cote": "cote",
  "struct.fem.lay.teren": "teren și săpătură",
  "struct.fem.psol_titlu": "Placa pe sol{nivel}: {arie} m² × {grosime} cm{clasa}{balast}. Se toarnă (e în deviz), dar NU e element în modelul de calcul: se reazemă direct pe teren. De asta e gri, ca zidăria. Fața de sus la cota 0; între ea și fața de sus a fundației rămân balastul și umplutura, care nu se desenează.",
  "struct.fem.psol_nivel": ", pardoseala nivelului «{nivel}»",
  "struct.fem.psol_clasa": ", {clasa}",
  "struct.fem.psol_balast": ", pe {cm} cm de balast",
  "struct.fem.rad_lay_titlu": "Radier de {cm} cm pe toată amprenta ({arie} m², {n} radiere): placa groasă pe care stă clădirea, de la pardoseala nivelului de jos în jos, pe balast. Se desenează numai betonul, la cotele lui reale; resoartele de teren sunt cifre, nu simboluri.",
  "struct.fem.rad_titlu": "Radierul",
  "struct.fem.rad_sub": "{arie} m² × {cm} cm",
  "struct.fem.rad_id_corp": "RADIER · {corp}",
  "struct.fem.rad_sursa": "radier · fundația întregii amprente",
  "struct.fem.rad_modelare": "grilaj de fâșii pe pat de resoarte",
  "struct.fem.rad_modelare_sub": "în modelul de calcul radierul e un grilaj de fâșii de placă pe resoarte de teren; aici se vede placa întreagă, cât se toarnă",
  "struct.fem.fnd_titlu": "{detaliu}{cota}. Se desenează numai BETONUL, la cotele lui reale: talpa, elevația, și porțiunea de stâlp care coboară în elevație. Umplutura de pământ nu e desenată. Resoartele de teren sunt cifre în panoul axului, nu simboluri peste clădire.",
  "struct.fem.fnd_sectiune": "secțiunea Pasului 6",
  "struct.fem.fnd_cota": " · cota de fundare −{m} m sub pardoseală",

  "struct.fem.mai_multe_straturi": "Mai multe straturi",
  "struct.fem.lay_toate": "toate",
  "struct.fem.lay_toate_titlu": "aprinde toate layerele",
  "struct.fem.lay_nimic": "nimic",
  "struct.fem.lay_nimic_titlu": "stinge toate layerele",
  "struct.fem.lay_doar": "doar",
  "struct.fem.lay_doar_titlu": "doar layerul ăsta: le stinge pe celelalte",
  "struct.fem.help_noduri": "NOTAȚIE, nu materie: punctele în care e împărțit modelul de calcul — capetele barelor, nodurile de împărțire ale grinzilor și nodurile de bază (cele mai mari, închise, la cota 0). Acolo se citesc deplasările și reacțiunile.",
  "struct.fem.help_cote": "Cotele care se citesc dintr-o privire, și numai ele: laturile exterioare ale amprentei, înălțimea fiecărui etaj ca lanț pe un colț (cu H total lângă el) și cotele de nivel — ±0,00, terenul natural și cota de fundare. Traveele, secțiunile și grosimile NU sunt aici: sunt în planurile și în secțiunile pașilor lor, iar pe model ar fi zgomot. Repere oblice și martori punctați, ca pe planșe.",
  "struct.fem.help_stalpi": "Stâlpii și lamelele, ca volum. Se pot stinge ca să se vadă ce e sub ei — fundația, săpătura, cotele.",
  "struct.fem.help_grinzi": "Grinzile: INIMA de sub placă, nu toată înălțimea T-ului (placa e desenată separat, cu volumul ei).",
  "struct.fem.baza_incastrata": "bază încastrată (fundația nu e în model)",
  "struct.fem.baza_motiv": "modelul are baza încastrată perfect: nodurile de la cota 0 nu se pot nici deplasa, nici roti",
  "struct.fem.baza_beton": ". Betonul fundației se poate totuși vedea: bifează layerul «fundație (beton, nu e în calcul)» — e geometria Pașilor 5–6, desenată la cotele ei reale, fără resoarte și fără elemente de calcul",
  "struct.fem.clasa": "Clasă",
  "struct.fem.clasa_titlu": "Clasa de execuție",
  "struct.fem.clasa_ce": "Elementele identice — aceeași secțiune, aceeași formă, aceeași armare și aceiași etrieri — formează o clasă. Ea se cofrează o dată și se fasonează în serie.",
  "struct.fem.clasa_dece": "Cu cât o structură are mai puține clase, cu atât e mai ușor de executat și de controlat pe șantier, iar scorul soluției o numără: un sfert din el măsoară câte tipuri diferite de element are.",
  "struct.fem.simetrie": "Grup de simetrie",
  "struct.fem.simetrie_titlu": "Grupul cu potențial de simetrie",
  "struct.fem.simetrie_ce": "Stâlpii oglindiți față de axele clădirii și cei de pe aceeași fațadă, la pas egal, au aceeași arhitectură deasupra — deci ar trebui să fie același stâlp. Grupul spune cu cine ar trebui să fie identică piesa asta și câți din grup au ieșit chiar în aceeași clasă de execuție.",
  "struct.fem.simetrie_dece": "Un grup respectat (cel puțin patru din cinci identici) ia zece la sută din partea de calitate a scorului: căutarea preferă soluția cu elemente identice pe contur, nu lamela lungă de pe latura cu zidul lung.",
  "struct.fem.simetrie_respectata": "respectat — bonus în scor",
  "struct.fem.simetrie_nerespectata": "nerespectat — membrii nu sunt în aceeași clasă",
  "struct.simetrie.identici": "{grup} · {k} din {n} identici",
  "struct.simetrie.nemasurat": "{grup} · {n} stâlpi, încă nemăsurat",

  "struct.fem.gol_grinda": "grindă",
  "struct.fem.gol_stalp": "stâlp",
  "struct.fem.gol_ochi": "ochi de placă",
  "struct.fem.gol_click": "Click pe o {grinda} sau un {stalp} pentru proprietățile lui de calcul.",
  "struct.fem.gol_click_ochi": "Click pe un {ochi} pentru id-ul lui, deschideri, grosime și cum i s-a închis conturul.",
  "struct.fem.p_ochi": "Ochiul de placă {id}",
  "struct.fem.p_nivel": "nivelul {n}",
  "struct.fem.p_inchis_grinzi": "{n}% grinzi",
  "struct.fem.p_inchis_pereti": "{n}% pereți",
  "struct.fem.p_inchis_contur": "{n}% marginea clădirii",
  "struct.fem.p_modelare": "Modelare",
  "struct.fem.p_modelare_sub": "elemente finite de placă pe o secțiune ElasticMembranePlateSection, {cm} cm grosime",
  "struct.fem.p_shell_titlu": "Shell, nu membrană",
  "struct.fem.p_shell_ce": "Fiecare element e un ShellMITC4 pe o secțiune ElasticMembranePlateSection: are ȘI rigiditate de membrană (în planul plăcii), ȘI rigiditate de încovoiere. Formularea MITC4 evită shear locking la plăci subțiri.",
  "struct.fem.p_shell_dece": "Cerința structuristului e shell peste tot. O membrană sau o diafragmă rigidă ar transmite numai eforturile din planul plăcii: placa n-ar duce încărcarea gravitațională la grinzi și n-ar apărea momentele din care se armează.",
  "struct.fem.p_deschideri": "Deschideri",
  "struct.fem.p_deschideri_sub": "gabaritul pe axele dominante ale clădirii; raport laturi {raport} — {fel}",
  "struct.fem.p_doua_directii": "placă pe două direcții",
  "struct.fem.p_o_directie": "lucrează practic pe o direcție",
  "struct.fem.p_deschidere_mica": "Deschiderea mică",
  "struct.fem.p_deschidere_mica_sub": "diametrul celui mai mare cerc înscris în ochi — deschiderea care guvernează încovoierea, definită și pentru un ochi în L, unde gabaritul minte",
  "struct.fem.p_suprafata": "Suprafață",
  "struct.fem.p_suprafata_sub": "din ea ies greutatea proprie, finisajele, utila și masa seismică aferente ochiului; mesh-ul îi atribuie {mesh} m²",
  "struct.fem.p_grosime": "Grosime",
  "struct.fem.p_grosime_sub": "grosimea plăcii aleasă de solver — aceeași pe tot planșeul",
  "struct.fem.p_contur": "Cum se închide conturul",
  "struct.fem.p_contur_sub": "cât din perimetrul ochiului stă pe o grindă, pe un perete de arhitectură, sau pe marginea clădirii",
  "struct.fem.p_contur_titlu": "Ochiul nu are nevoie de grinzi pe tot conturul",
  "struct.fem.p_contur_ce": "Ochiurile se obțin tăind amprenta nivelului cu axele grinzilor ȘI cu axele pereților din Pasul 2. Un perete întrerupt de o ușă sau de o fereastră nu separă, deci cele două camere rămân un singur ochi.",
  "struct.fem.p_contur_dece": "Poligonizarea clasică cere inele PERFECT închise: pe proiectul 2, la parter, rețeaua de grinzi închidea 82 m² din 295 construiți, iar restul plăcii rămânea un singur câmp. Regula e a lui Stefan: «în cazul în care ochiul nu e perfect închis cu grinzi admitem să se închidă și cu pereți de zidărie și uși și geamuri».",
  "struct.fem.p_categorie": "Categoria de funcțiune",
  "struct.fem.p_cat_c": "C — circulații / spații comune",
  "struct.fem.p_cat_a": "A — locuit",
  "struct.fem.p_cat_sub": "din zonele de funcțiuni ale Pasului 2; decide încărcarea utilă{detaliu}",
  "struct.fem.p_cat_detaliu": " ({m2} m² din ochi sunt cat. C)",
  "struct.fem.p_rigiditate": "Rigiditate",
  "struct.fem.p_rig_fisurat": "E-ul betonului scalat cu rigiditate_analiza_placa = {fis} (izotrop — afectează și membrana)",
  "struct.fem.p_rig_nefisurat": "placă nefisurată (rigiditate_analiza_placa = 1,0), simplificarea obișnuită la modelul modal",

  "struct.fem.ps_titlu": "Placa pe sol · {ref}",
  "struct.fem.ps_sub": "{arie} m² · {cm} cm{clasa} · nu ține structura",
  "struct.fem.ps_clasa": " · {clasa}",
  "struct.fem.ps_sursa": "placă pe sol",
  "struct.fem.ps_cote": "Cotele",
  "struct.fem.ps_cote_sub": "fața de sus e pardoseala nivelului de jos{balast}",
  "struct.fem.ps_balast": "; dedesubt, {cm} cm de balast, desenat",
  "struct.fem.ps_modelare": "Cum e modelată",
  "struct.fem.ps_rezemata": "rezemată pe teren",
  "struct.fem.ps_rezemata_sub": "pat elastic pe toată suprafața, nu deschideri între reazeme",
  "struct.fem.ps_info_titlu": "Placă PE SOL, nu planșeu",
  "struct.fem.ps_info_ce": "Se reazemă pe teren pe toată suprafața, deci nu are ochiuri și nu se dimensionează la moment între reazeme. Nu intră în modelul seismic: masa ei se descarcă direct în teren.",
  "struct.fem.ps_info_dece": "Armătura ei se calculează totuși, din ce o îndoaie: contracția împiedicată (EC2 §7.3.2), pereții care nu cad peste un ax de fundație și descarcă pe ea (placa pe mediu Winkler, M = q/(4λ)) și, la un nivel de garaj, roata unui autoturism (Westergaard, socotită la rost). Cifrele sunt la Pasul 18.",
  "struct.fem.detalii": "Detalii",
  "struct.fem.link_element": "pagina elementului {ref} →",
  "struct.fem.link_armare": "Pasul 18 — armarea ei →",
  "struct.fem.link_sub": "acolo sunt verificările cu E/R, secțiunea desenată, inventarul de bare și prețul",

  "struct.fem.gf_titlu": "Grinda de fundare · {ax}",
  "struct.fem.gf_sub": "{n} tronsoane · L = {l} m{b}{afara}",
  "struct.fem.gf_b": " · B = {b} m",
  "struct.fem.gf_afara": " · nu e în modelul de calcul",
  "struct.fem.gf_sursa": "grindă de fundare · {n} tronsoane",
  "struct.fem.gf_sectiune": "Secțiunea de execuție",
  "struct.fem.gf_sectiune_sub": "detaliul «{detaliu}» din Pasul 6 — din el ies ȘI rigiditatea din model, ȘI greutatea care apasă terenul, ȘI costul",
  "struct.fem.gf_altfel_titlu": "Fundația e altfel decât o grindă de suprastructură",
  "struct.fem.gf_altfel_ce": "Secțiunea nu conlucrează cu placa (nu e T cu b_eff), stă pe un pat continuu de resoarte în loc de noduri, iar terenul nu poate ÎNTINDE: talpa se poate desprinde.",
  "struct.fem.gf_altfel_dece": "NP 112-2014 §III și anexa K: infrastructurile din grinzi de fundare se modelează ca grinzi pe mediu elastic tip Winkler. Grosimea tălpii nu e liberă — consola cere h_t ≥ (B − b_inimă)/2 și ≥ 0,30·B, deci un ax lățit e și mult mai rigid.",
  "struct.fem.gf_cote": "fața de sus −{sus} m · fundare −{df} m",
  "struct.fem.gf_cote_sub": "măsurate de la cota 0 = pardoseala nivelului de jos, nu de la teren (D_f din Pasul 6). În cei {cm} cm de deasupra feței de sus intră placa pe sol și pardoseala — între axe umplutură, sub stâlpi stâlpul însuși, care coboară în elevație",
  "struct.fem.gf_bara_titlu": "În model bara e la cota 0, nu la cota betonului",
  "struct.fem.gf_bara_ce": "Betonul desenat atârnă între cele două cote de mai sus, dar elementul de calcul e o bară ÎNTRE NODURILE DE BAZĂ ale stâlpilor, la cota 0, cu offset vertical ZERO (`offset_i = offset_j = [0,0,0]`). Nu există nicio «gaură» în model: nodul de bază al stâlpului ȘI capătul grinzii de fundare sunt ACELAȘI nod. Axele barelor nu se desenează — la cota 0 trec prin beton, deci n-ar fi vizibile.",
  "struct.fem.gf_bara_dece": "Idealizarea neglijează excentricitatea dintre axa barei (cota 0) și centrul de greutate al secțiunii de beton (cu ~0,8 m mai jos) — la fel cum grinzile de suprastructură au axa în planul plăcii, nu la centrul de greutate al secțiunii T. Consecința: momentul din grinda de fundare nu conține efectul brațului de pârghie față de fața stâlpului. Placa pe sol nu e element de calcul nicăieri: ea apare în deviz și în ipoteza de încărcare (pereții parterului care nu cad pe un ax descarcă prin ea direct în teren).",
  "struct.fem.gf_armatura": "Armătura",
  "struct.fem.gf_armatura_link": "Pasul 18 — armarea grinzii de fundare pe {ax} →",
  "struct.fem.gf_armatura_sub": "barele longitudinale, etrierii și plasa tălpii se aleg acolo, pe secțiunea de mai sus; în 3D nu se desenează (aici intră doar ce e fizic ȘI lizibil)",
  "struct.fem.gf_bare3d_titlu": "De ce nu se desenează barele în 3D",
  "struct.fem.gf_bare3d_ce": "Convenția vederii 3D e că se desenează numai ce e FIZIC și se poate vedea. Barele unei grinzi de fundare stau îngropate în beton, la 1–2 m sub cota 0, într-o piesă lungă de zeci de metri: la scara la care se vede clădirea n-ar fi decât zgomot.",
  "struct.fem.gf_bare3d_dece": "Secțiunea armată, cotată, e în pagina Pasului 18 — acolo scara e a secțiunii, nu a clădirii, deci barele chiar se citesc.",
  "struct.fem.gf_nefisurat_titlu": "De ce nefisurată, când grinzile de sus sunt la 0,5·EI",
  "struct.fem.gf_nefisurat_ce": "În grinzile de fundare se urmărește EXPLICIT evitarea deformațiilor plastice, deci se lucrează cu secțiunea întreagă (fisurare = 1,0), nu cu cea fisurată din P100-1.",
  "struct.fem.gf_nefisurat_dece": "NP 112-2014 §II.7.5.2. Rigiditatea grinzii de fundare decide cum se redistribuie presiunile pe teren — o fisurare presupusă degeaba ar muta presiunile spre stâlpi.",
  "struct.fem.gf_ei": "E·I_y = {ei} MN·m² pe încovoierea verticală",
  "struct.fem.gf_resoarte": "Patul de resoarte",
  "struct.fem.gf_resoarte_v": "{n} resoarte · k_v = {min}…{max} kN/m",
  "struct.fem.gf_resoarte_sub": "K_s = {ks} daN/cm³ ({sursa}, Pasul 6) · pas {pas} m · k_h = {raport}·k_v",
  "struct.fem.gf_resort_titlu": "Cum arată un resort în OpenSees",
  "struct.fem.gf_resort_ce": "Sub fiecare nod al rețelei stă un nod de sol ÎNCASTRAT, iar între ele un element `zeroLength` — de lungime nulă, în nodul de la cota 0 — cu k_v = K_s·A_aferentă pe direcția 3 și k_h pe direcțiile 1 și 2. Rotirile rămân LIBERE: rigiditatea la rotire a tălpii o dau resoartele vecine, iar un arc de rotire ar dubla-o. Simbolul de resort din scenă e desenat sub talpă, unde e pământul pe care îl înlocuiește.",
  "struct.fem.gf_resort_dece": "Pasul resoartelor se plafonează la π/4 din lungimea elastică λ⁻¹ = {lambda} m (NP 112 anexa K.3.2) — sub ea, covorul discret de arcuri se comportă ca unul continuu. ",
  "struct.fem.gf_ent": "Resoartele sunt FĂRĂ ÎNTINDERE (ENT): modelul e neliniar, deci combinațiile nu mai sunt riguros suprapozabile.",
  "struct.fem.gf_liniar": "Resoartele sunt liniare, ca suprapunerea de efecte din Pasul 11 (R = C·F) să rămână exactă; desprinderea se citește oricum din semnul reacțiunilor.",
  "struct.fem.gf_greutate": "Greutatea proprie",
  "struct.fem.gf_greutate_sub": "beton + pământul de pe umerii tălpii; intră în cazul gravitațional G4. Masa infrastructurii ({t} t, {pct} % din total) {verb} în masa seismică",
  "struct.fem.gf_intra": "INTRĂ",
  "struct.fem.gf_nu_intra": "NU intră",

  "struct.fem.gf_masa_titlu": "De ce masa fundației nu e masă seismică",
  "struct.fem.gf_masa_ce": "EN 1998-1 §4.3.3.2.2(1)P definește masa seismică drept masa clădirii DEASUPRA fundației. Greutatea grinzilor de fundare rămâne integral în cazul G4 — reacțiunile, presiunile pe teren și devizul o văd.",
  "struct.fem.gf_masa_dece": "Masa care rămâne la nivelul terenului nu produce forțe de inerție pe care structura să le transmită, iar modurile ei de lunecare pe k_h (~17 Hz) diluau criteriul de 90 % din Pasul 9.",
  "struct.fem.zid_titlu": "Peretele nestructural {id}",
  "struct.fem.zid_sub": "nu intră în rigiditate",
  "struct.fem.zid_sursa": "peretele simplificat al Pasului 2",
  "struct.fem.sectiune": "Secțiune",
  "struct.fem.brate": "Brațe",
  "struct.fem.brate_v": "{n} × {h} cm pe {axa}",
  "struct.fem.brate_sub": "piciorul de pe axa cealaltă, turnat cu stâlpul (T, L sau +); FEM-ul vede inerția întregului poligon",
  "struct.fem.zid_grosime": "{cm} cm grosime",
  "struct.fem.zid_grosime_sub": "grosimea peretelui simplificat, așa cum a măsurat-o Pasul 2",
  "struct.fem.lungime": "Lungime",
  "struct.fem.rol": "Rol în model",
  "struct.fem.zid_rol": "încărcare, nu element",
  "struct.fem.zid_rol_sub": "greutatea lui intră pe grinda de sub el (G2a) sau, dacă n-are grindă, uniform pe placă (G2b); rigiditatea zidăriei se neglijează",
  "struct.fem.zid_info_titlu": "De ce apar pereții nestructurali în 3D?",
  "struct.fem.zid_info_ce": "Sunt pereții simplificați ai Pasului 2 — dreptunghiurile în care s-au distilat layerele de pereți ale arhitectului. Id-ul (S7, E14…) e același cu cel din Pasul 2, deci peretele se poate căuta acolo.",
  "struct.fem.zid_info_dece": "Layerul gri arată EXACT pereții simplificați, nu banda brută de pe layerele de pereți: altfel apărea perete și acolo unde niciun perete simplificat nu există (haloul liniilor, conturul hașurilor, tăietura zonei de interes). Porțiunile turnate din beton sunt scoase de aici — o bucată de zid e ori beton, ori nestructurală. Layerul se numește după ROL, nu după material: ce rămâne aici nu duce încărcare, indiferent din ce e făcut.",
  "struct.fem.zid_material_declarat": "declarat de arhitectură",
  "struct.fem.zid_material_presupus": "presupus — planșa nu declară materialul nicăieri",
  "struct.fem.zid_material_titlu": "De unde se știe materialul?",
  "struct.fem.zid_material_ce": "Din ce declară arhitectura pentru peretele ăsta: «beton», «zidărie» sau «polistiren» (stratul de termoizolație desenat ca perete). Documentele generate de solverul de arhitectură o declară; o planșă DWG nu scrie materialul nicăieri, iar atunci aici se citește zidăria presupusă.",
  "struct.fem.zid_material_dece": "Layerul spune ROLUL — peretele ăsta nu duce încărcare —, nu din ce e făcut. Sunt două întrebări diferite: o zidărie de 30 cm între două camere nu poartă nimic, iar un perete de beton de pe latura unui balcon poartă. Materialul se scrie separat tocmai ca «nestructural» să nu fie citit drept «de zidărie».",
  "struct.fem.zid_turnat": "Turnat din beton",
  "struct.fem.zid_turnat_v": "{pct} % din perete — {piese}",
  "struct.fem.zid_turnat_sub": "restul peretelui e beton și se desenează pe layerul pieselor de structură; aici a rămas doar partea nestructurală",
  "struct.fem.beton_clasa": "Beton armat {clasa}",
  "struct.fem.beton_material_sub": "clasa de beton a modelului de calcul",
  "struct.fem.st_peste_zid": "Turnat peste",
  "struct.fem.st_peste_zid_v": "peretele {id} din Pasul 2 ({pct} %)",
  "struct.fem.st_peste_zid_sub": "de aceea peretele nu mai apare pe layerul de pereți nestructurali — aici e beton, nu zidărie",
  "struct.fem.st_peste_zid_titlu": "Unde s-a dus peretele?",
  "struct.fem.st_peste_zid_ce": "Piesa asta stă pe amprenta unui perete simplificat al Pasului 2. Un perete e ori beton, ori nestructural, nu amândouă: partea acoperită iese din layerul gri și se desenează aici, ca element de structură.",
  "struct.fem.st_peste_zid_dece": "Fără rândul ăsta, un perete înghițit de o lamelă dispărea din 3D fără nicio urmă — pe «Olteniței P + 4», peretele E64 de 6,95 m de la etajul 4 nu se mai vedea nicăieri, deși lamela de 30 × 690 cm care îl înlocuise era chiar în locul lui.",
  "struct.fem.gol_usa": "Ușa",
  "struct.fem.gol_fereastra": "Fereastra",
  "struct.fem.gol_sub": "{nivel} · {l} m · arhitectură (nu e în calcul)",
  "struct.fem.gol_sursa": "golul din Pasul 2",
  "struct.fem.gol_latime": "Lățime",
  "struct.fem.gol_latime_sub": "pe TOC, cât a măsurat importul gaura din zid",
  "struct.fem.gol_grosime_sub": "grosimea zidului străpuns",
  "struct.fem.gol_hp": "Parapet (HP)",
  "struct.fem.gol_hp_necotat": "necotat pe planșă",
  "struct.fem.gol_hp_sub": "de la PARDOSEALA FINITĂ a nivelului — reperul arhitectului și al normei (STAS 6131 măsoară tot de acolo)",
  "struct.fem.gol_hp_fara": "planul nu are marcaj «HP=» lângă golul ăsta",
  "struct.fem.gol_hp_titlu": "De unde vine parapetul",
  "struct.fem.gol_hp_ce": "Din marcajul «HP=0.90m» scris pe planșă lângă gol. Marcajele nu stau pe un layer de tâmplărie — la blocul din Olteniței sunt pe layerul de texte al planșei —, deci se caută în tot desenul, iar fiecare merge la UN singur gol, cel mai apropiat.",
  "struct.fem.gol_hp_dece": "Un gol fără marcaj rămâne fără parapet, nu primește unul «obișnuit»: un parapet presupus arată în 3D exact ca unul măsurat, iar verificarea de siguranță (STAS 6131) l-ar folosi ca pe o cifră din dosar.",
  "struct.fem.gol_h": "Înălțimea golului",
  "struct.fem.gol_h_necunoscuta": "nemăsurabilă",
  "struct.fem.gol_h_sub": "buiandrugul la {m} m peste pardoseală",
  "struct.fem.gol_h_fara": "planurile nu cotează buiandrugul, iar fațada nu s-a putut măsura",
  "struct.fem.gol_h_titlu": "De ce se măsoară pe fațadă",
  "struct.fem.gol_h_ce": "Planul cotează unde ÎNCEPE golul («HP=») și niciodată unde se termină. Singura piesă din dosar care arată buiandrugul e planșa de fațade/secțiuni, unde golurile sunt desenate la scară. Acolo, pe fiecare nivel, golurile ies în familii curate — la Olteniței 2,18 m (ușile-ferestre, HP=0,00) și 1,43 m (ferestrele, HP=0,90).",
  "struct.fem.gol_h_dece": "Se măsoară ÎNĂLȚIMEA, nu cota: cota ar cere ca datumul fațadei să fie calibrat, iar textele de cotă stau lângă linia de nivel, nu pe ea. Înălțimea e o scădere, deci offsetul dispare. Reperul de jos rămâne «HP=», citit de pe plan, unde e cotat explicit.",
  "struct.fem.gol_3d": "În 3D",
  "struct.fem.gol_3d_v": "fâșie subțire pe pardoseală",
  "struct.fem.gol_3d_sub": "poziția și lățimea sunt măsurate; înălțimea nu se cunoaște, deci nu se desenează o cutie cu cote presupuse",
  "struct.fem.gol_gazda": "Peretele-gazdă",
  "struct.fem.gol_gazda_sub": "peretele simplificat în care stă golul",
  "struct.fem.gol_gazda_fara": "golul nu s-a putut lipi de un perete simplificat",
  "struct.fem.gol_rol": "niciunul",
  "struct.fem.gol_rol_sub": "golurile nu intră în FEM; ele spun pe unde poate trece o grindă fără să strice arhitectura (buiandrug peste gol)",

  "struct.fem.par_sursa": "marginea nestructurală a Pasului 2",
  "struct.fem.par_grosime_sub": "măsurată din desen, sau nominală când parapetul e desenat cu o singură linie",
  "struct.fem.inaltime": "Înălțime",
  "struct.fem.par_h": "{m} m",
  "struct.fem.par_h_presupusa": "{m} m (presupusă)",
  "struct.fem.par_h_necotata": "necotată în plan",
  "struct.fem.par_h_sub_presupus": "planul nu cotează parapetul; se presupune minimul parapetului de siguranță (STAS 6131), cu care intră în încărcări și mase",
  "struct.fem.par_h_sub_dosar": "cota din dosar",
  "struct.fem.par_h_sub_vechi": "rezultat de dinaintea înălțimii presupuse — rulează din nou Pasul 7",
  "struct.fem.par_h_titlu": "De unde vine înălțimea",
  "struct.fem.par_h_ce": "În plan un parapet e o fâșie, ca orice perete: desenul spune unde e și cât e de gros, nu cât e de înalt. Când dosarul n-o dă, se presupune 0,90 m — minimul parapetului de siguranță și înălțimea obișnuită a parapetului de balcon.",
  "struct.fem.par_h_dece": "Fără înălțime parapetul n-ar avea greutate și n-ar intra nicăieri; cu una presupusă intră în încărcările și masele nivelului și în momentul de încastrare al consolei, iar presupunerea se vede aici și în deciziile Pasului 7. Formatul canonic poate duce cota; când importul o va măsura de pe elevație, ea bate presupunerea.",
  "struct.fem.par_rol": "încărcare liniară și masă",
  "struct.fem.par_rol_sub": "g_perete × h pe metru: pe grinda de sub el (G2a) sau pe placă (G2b); pe consolă încarcă capătul ei la Pasul 16. Nu e element în FEM și nu se verifică",
  "struct.fem.pb_titlu": "Peretele de beton {id}",
  "struct.fem.pb_sub": "{nivel} · L = {l} m · beton armat",
  "struct.fem.pb_sursa_balcon": "perete de balcon",
  "struct.fem.pb_sursa_subsol": "panou de subsol",
  "struct.fem.pb_amplasare": "Amplasare",
  "struct.fem.pb_intre_stalpi": "Între stâlpii",
  "struct.fem.pb_pe_balcon": "pe latura unui balcon exterior",
  "struct.fem.pb_balcon_sub": "arhitectura cere beton pe peretele ăsta{arh}, prin preferința «pereti_balcon_beton»; celelalte laturi de balcon rămân zidărie",
  "struct.fem.pb_balcon_arh": " ({id} în Pasul 2)",
  "struct.fem.pb_sect_balcon": "grosime × înălțimea liberă de sub placa de deasupra",
  "struct.fem.pb_sect_subsol": "grosime × înălțimea liberă de sub placa peste subsol",
  "struct.fem.pb_balcon_titlu": "De ce beton pe latura ASTA de balcon?",
  "struct.fem.pb_balcon_ce": "Peretele e trecut în preferința «pereti_balcon_beton», deci se toarnă din beton armat, monolit cu placa în consolă. Implicit, pe laturile balcoanelor NU se toarnă beton.",
  "struct.fem.pb_balcon_dece": "Regula: la un balcon în consolă se pune placa de beton, dar pereții sunt de zidărie, ca orice compartimentare — beton numai dacă arhitectura o cere acolo (pe «Olteniței P + 4» e un singur asemenea perete, desenat de 30 cm). Ce se schimbă e greutatea de pe capătul consolei: betonul intră cu γ = 25 kN/m³ × grosimea turnată, zidăria cu g_perete × înălțimea liberă.",
  "struct.fem.pb_subsol_titlu": "De ce perete de beton în subsol?",
  "struct.fem.pb_subsol_ce": "La clădirile P+2 sau peste, cu subsol, infrastructura se închide într-o «cutie rigidă»: pereți de beton armat între stâlpii subsolului, pe axele pereților de arhitectură.",
  "struct.fem.pb_subsol_dece": "P100-1 §4.4.1.7 recomandă infrastructuri de tip cutie rigidă; criteriul de practică: subsolul cu ≥50 % mai rigid decât nivelurile de deasupra. Peretele e modelat ca un PANOU de shell-uri (ca bară, rigiditatea lui de forfecare în plan nu exista în model), iar Pasul 14 îl armează pe 5 puncte, ca la grinzi.",
  "struct.fem.pb_pozitie": "Poziție în stâlp",
  "struct.fem.pb_fata": "la fața exterioară (+{cm} cm față de ax)",
  "struct.fem.pb_centrat": "centrat",
  "struct.fem.pb_pozitie_sub": "panoul merge din colțul unui stâlp în colțul celuilalt: fața lui exterioară vine în planul feței exterioare a stâlpilor, fără să-i suprapună",
  "struct.fem.pb_reazem": "Se sprijină pe",
  "struct.fem.pb_pe_fundatie": "fundație{ax}, fața de sus la {z} m",
  "struct.fem.pb_ax": " ({ax})",
  "struct.fem.pb_pe_placa_sol": "placa pe sol, fața de sus la {z} m",
  "struct.fem.pb_pe_placa_nivel": "placa nivelului de dedesubt, fața de sus la {z} m",
  "struct.fem.pb_pe_perete": "peretele de beton de dedesubt, pe toată lumina (prin placa cu fața de sus la {z} m)",
  "struct.fem.pb_pe_cota": "cota {z} m",
  "struct.fem.pb_turnat": "turnat pe {h} m, de la cota de mai sus până la fața de jos a {ce} de deasupra. Greutatea și armarea se socotesc pe înălțimea de CALCUL ({calcul} m, de sub placă în jos): diferența de {dif} cm e beton de infrastructură, care nu e nici în masa suprastructurii, nici în secțiunea fundației",
  "struct.fem.pb_grinzii": "grinzii",
  "struct.fem.pb_placii": "plăcii",
  "struct.fem.pb_nu_pluteste": "peretele de beton nu plutește: fața lui de jos e chiar fața de sus a ce-l ține",
  "struct.fem.pb_greutate": "Greutate",
  "struct.fem.pb_greutate_sub": "intră în G1; zidăria înlocuită a fost scoasă din G2c",
  "struct.fem.pb_perimetral": "pe conturul clădirii",
  "struct.fem.pb_interior": "interior",
  "struct.fem.pb_perimetral_sub": "CR 2-1-1.1 §10.4.2: peretele de contur cere ≥25 cm",
  "struct.fem.pb_nota": "Eforturile lui se extrag la Pasul 12 în 5 puncte (ca la grinzi), iar armarea — bare verticale pe înălțimea subsolului + orizontale de repartiție — se face la Pasul 14.",

  "struct.fem.st_lamela": "Lamela",
  "struct.fem.st_stalp": "Stâlpul",
  "struct.fem.st_sursa": "stâlp de calcul",
  "struct.fem.st_h_etaj": "Înălțime etaj",
  "struct.fem.st_h_etaj_sub": "înălțimea reală a acestui etaj — din Pasul 2 (cotele fațadelor)",
  "struct.fem.st_i_brut": "I brut",
  "struct.fem.st_i_fisurat": "I fisurat (×{f})",
  "struct.fem.st_ei_fisurat": "EI fisurat",
  "struct.fem.st_greutate": "Greutate proprie",
  "struct.fem.st_greutate_sub": "b × h × înălțimea etajului × 25 kN/m³ (greutatea betonului armat)",
  "struct.fem.st_rigid_sus": "Zonă rigidă sus",
  "struct.fem.st_rigid_sus_v": "½ înălțime grindă (25 cm)",
  "struct.fem.st_nota": "Rigiditatea fisurată ({f}·EI) conform P100-1 — stâlpii păstrează mai multă rigiditate decât grinzile datorită compresiunii axiale.",
  "struct.fem.gr_sursa": "grindă de calcul",
  "struct.fem.gr_inima": "Inimă (web)",
  "struct.fem.gr_inima_sub": "din grinda întreagă {bw} × {h} — fâșia de {hf} cm e în placă (shell)",
  "struct.fem.gr_inima_titlu": "De ce doar inima?",
  "struct.fem.gr_inima_ce": "Placa (shell) duce deja talpa în compresiune/membrană. Grinda primește doar betonul de SUB placă, ca talpa să nu fie numărată de două ori.",
  "struct.fem.gr_inima_dece": "Acțiunea de secțiune T iese din offsetul compozit: inima e coborâtă rigid cu e = t/2 + h_web/2, iar brațul de pârghie × rigiditatea de membrană a plăcii reface exact comportarea compozită.",
  "struct.fem.gr_offset": "Offset compozit e",
  "struct.fem.gr_offset_sub": "aplicat prin -jntOffset (coborâre rigidă), la ambele capete",
  "struct.fem.gr_a_inima": "A (inimă)",
  "struct.fem.gr_i_inima": "I inimă",
  "struct.fem.gr_q_inima": "q inimă",
  "struct.fem.gr_q_inima_sub": "doar greutatea inimii — placa și finisajele se încarcă direct pe shell-uri",
  "struct.fem.gr_noduri_placa": "Noduri comune cu placa",
  "struct.fem.gr_noduri_placa_v": "{n} (pe liniile de mesh)",
  "struct.fem.gr_zone_rigide": "Zone rigide",
  "struct.fem.gr_zone_rigide_v": "½ lățime stâlp la capetele din stâlpi",
  "struct.fem.gr_t": "Grinda T {ref}",
  "struct.fem.tip": "(tip {clasa})",
  "struct.fem.gr_titlu": "Grinda {ref}",
  "struct.fem.gr_sub": "{nivel} · L = {l} m",
  "struct.fem.gr_beff_titlu": "Lățimea activă a plăcii (EC2 §5.3.2.1)",
  "struct.fem.gr_beff_ce": "Cât din placă lucrează împreună cu grinda ca o talpă de secțiune T. Nu toată placa apucă să se încarce — doar o fâșie de lângă grindă.",
  "struct.fem.gr_beff_dece": "b_eff = bw + Σ min(0,2·bᵢ + 0,1·l₀; 0,2·l₀; bᵢ), unde bᵢ e jumătatea distanței libere până la grinda paralelă vecină, iar l₀ distanța dintre punctele de moment nul.",
  "struct.fem.gr_talpa": "talpă st. / dr.",
  "struct.fem.gr_l0": "{l} m (deschidere {tip})",
  "struct.fem.gr_a_t": "A (T)",
  "struct.fem.gr_i_t": "I puternic (T)",
  "struct.fem.gr_i_t_sub": "vs dreptunghi {brut}·10⁻⁴ — talpa aduce +{plus}%",
  "struct.fem.gr_tributara": "Lățime tributară",
  "struct.fem.gr_q_permanent": "q permanent",
  "struct.fem.gr_q_permanent_sub": "placă+inimă {dead} + finisaje {sdl}",
  "struct.fem.gr_q_util": "q util",
  "struct.fem.gr_noduri_fem": "Noduri FEM",
  "struct.fem.gr_noduri_fem_v": "{n} interne ({seg} segmente)",

  "struct.fem.mc_titlu": "Masele considerate",
  "struct.fem.mc_info_titlu": "Cum se compune masa seismică per nivel",
  "struct.fem.mc_info_ce": "Masa seismică per nivel = D (placă + inimi grinzi + ½ stâlpi jos + ½ sus) + pereți nestructurali (½ deasupra + ½ dedesubt, mapați pe grinzi sau pe placă) + finisaje + φ·ψ2·utilă (φ=0,8 curent / 1,0 ultimul; per zone A/C) + ψ2·zăpadă pe acoperiș — docs/algoritm_eforturi.md P3",
  "struct.fem.mc_col_placa": "Placă",
  "struct.fem.mc_col_grinzi": "Grinzi (inimi)",
  "struct.fem.mc_col_stalpi": "Stâlpi și lamele (½+½)",
  "struct.fem.mc_col_pereti_grinzi": "Pereți pe grinzi",
  "struct.fem.mc_col_pereti_placa": "Pereți pe placă",
  "struct.fem.mc_col_finisaje": "Finisaje (SDL)",
  "struct.fem.mc_col_utila": "ψE·Utilă",
  "struct.fem.mc_col_zapada": "ψE·Zăpadă",
  "struct.fem.mc_col_total": "Total [t]",
  "struct.fem.mc_nivel": "Nivel",
  "struct.fem.mc_nivel_diafragma": "nivel {n}",
  "struct.fem.vf_titlu": "Verificări",
  "struct.fem.vf_nerulat": "verificarea modală nu a rulat — rulează Pasul 7 din nou",
  "struct.fem.vf_masa90": "Toate modurile adună ≥ 90 % din masă, pe X și pe Y",
  "struct.fem.vf_masa90_val": "{x} % X · {y} % Y",
  "struct.fem.vf_masa90_prag": "≥ 90 % pe X și pe Y",
  "struct.fem.vf_masa90_formula": "min({x}; {y}) ≥ 90, cu {moduri} moduri reținute",
  "struct.fem.vf_numar#n": "<b>{n}</b> verificare|<b>{n}</b> verificări|<b>{n}</b> de verificări",
  "struct.fem.vf_trec": "✓ {n} trec",
  "struct.fem.vf_nu_trec": "✗ {n} nu trec",
  "struct.fem.vf_vechi": "⚠ Rezultat vechi — rerulează Pasul 7 pentru verificările detaliate (rezultatul salvat e dinainte ca gate-ul să emită cele 4 verificări numite; mai jos apare doar ce există în el).",
  "struct.fem.vf_col_verificarea": "Verificarea",
  "struct.fem.vf_col_valoarea": "Valoarea",
  "struct.fem.vf_col_pragul": "Pragul",
  "struct.fem.vf_col_verdict": "Verdict",
  "struct.fem.vf_col_formula": "Formula (cu valorile proiectului)",
  "struct.fem.vf_nedeterminat": "nedeterminat",
  "struct.fem.vf_trece": "✓ trece",
  "struct.fem.vf_pica": "✗ pică",
  "struct.fem.vf_review": "◐ de revizuit",
  "struct.fem.vf_de_revizuit": "◐ {n} de revizuit",
  "struct.fem.vf_gate_review": "◐ Verdictul gate: perioadele sunt aproape de separarea de 15 % — de revizuit. Solverul încearcă în continuare să ajungă la 15 %.",
  "struct.fem.vf_gate_ok": "✓ Verdictul gate: moduri decuplate — structura trece mai departe pe lanț.",
  "struct.fem.vf_gate_nu": "✗ Verdictul gate: moduri NEdecuplate",
  "struct.fem.vf_directie": "Pasul 19 rigidizează pe direcția recomandată {directie} (regula R11 — lungiri de stâlpi care apropie centrul de rigiditate de centrul de masă).",
  "struct.fem.vf_asimetrie": "Asimetria flexibilității (‖asimetria matricei condensate‖):",
  "struct.fem.vf_asimetrie_sub": "— informativă, nu intră în contor (doar varianta lean o raportează).",

  "struct.fem.vf_nedeterminate": "— {n} nedeterminate",
  "struct.fem.vf_ind_titlu": "Ce numără indicatorul",
  "struct.fem.vf_ind_ce": "Cele patru verificări modale ale gate-ului de decuplare (separarea perioadelor T1–T2 și T2–T3, direcția dominantă a modurilor 1 și 2) plus criteriul de ≥ 90 % masă participantă cumulată. Asimetria flexibilității e doar informativă și nu intră în contor.",
  "struct.fem.vf_ind_dece": "Gate-ul modal decide dacă structura merge mai departe pe lanț sau dacă Pasul 19 trebuie să o rigidizeze (regula R11). Tabelul complet, cu toate modurile, e mai jos, în «Verificarea modală a modelului».",
  "struct.fem.vm_titlu": "Verificarea modală a modelului",
  "struct.fem.vm_info_titlu": "De ce doar «verificare»?",
  "struct.fem.vm_info_ce": "Analiza modală de aici confirmă că modelul e sănătos: perioade plauzibile și toată masa regăsită în moduri. Vizualizarea formelor modale (cum se leagănă clădirea în fiecare mod) vine în Pasul 9 (analiza seismică).",
  "struct.fem.vm_info_dece": "Modelul lean are masa lumpată în centrul de masă al fiecărui planșeu, deci are exact 3 moduri per etaj (X, Y, torsiune). P100-1/EC8 cere ca modurile considerate să acopere ≥ 90% din masă — aici, prin construcție, acoperă 100%.",
  "struct.fem.vm_t_nume": "perioada proprie a modului (secunde)",
  "struct.fem.vm_t_sursa": "eigen pe modelul condensat static (OpenSees + numpy)",
  "struct.fem.vm_m_nume": "masa participantă pe translații și torsiune",
  "struct.fem.vm_m_sursa": "formula clasică Γ²/M din vectorii proprii",
  "struct.fem.vm_col_masa_x_titlu": "masă efectivă modală pe X, ca PROCENT DIN MASA TOTALĂ a clădirii. Suma pe COLOANĂ (peste toate modurile) tinde la 100% — suma pe rând NU are de ce să dea 100%, fiindcă fiecare coloană e raportată la altă bază.",
  "struct.fem.vm_col_masa_y_titlu": "masă efectivă modală pe Y, ca procent din masa totală a clădirii (vezi «masă X»).",
  "struct.fem.vm_col_masa_z": "masă Z",
  "struct.fem.vm_col_masa_z_titlu": "masă efectivă modală verticală, ca procent din masa totală.",
  "struct.fem.vm_col_torsiune_titlu": "masă efectivă ROTAȚIONALĂ, ca procent din inerția rotațională totală J a clădirii — altă bază decât coloanele de translație, deci nu se adună cu ele.",
  "struct.fem.vm_col_dist": "distribuția modului X/Y/T",
  "struct.fem.vm_col_dist_titlu": "cum se împarte participarea ACESTUI mod între X / Y / torsiune (+vertical) — sumă garantat 100%. Aceasta e împărțirea folosită de gate-ul de decuplare (90% pe o singură direcție).",
  "struct.fem.vm_col_tip": "tip",
  "struct.fem.vm_col_puritate": "puritate",
  "struct.fem.vm_col_puritate_titlu": "fracțiunea din participarea totală care merge pe direcția dominantă: 1,00 = mod pur (translație curată), ~0,60 = translație cuplată cu torsiune. La două moduri cu perioade practic egale (pereche cvasi-degenerată) se dă puritatea PERECHII — separat, fiecare e o combinație arbitrară a celor două, aleasă de solver.",
  "struct.fem.vm_dist_celula": "X / Y / torsiune — sumă 100%",
  "struct.fem.vm_cumulat": "Masă participantă cumulată: {x}% pe X, {y}% pe Y — criteriul de ≥ 90% (P100-1/EC8) {verdict}",
  "struct.fem.vm_indeplinit": "îndeplinit",
  "struct.fem.vm_neindeplinit": "NEîndeplinit",
  "struct.fem.vm_moduri": "cu {n} moduri reținute din {extrase} extrase (minimul cerut: {minim})",
  "struct.fem.vm_moduri_extra": " — la doar {minim} moduri masa efectivă era {m0}% pe 0° și {m90}% pe 90°, deci modurile suplimentare au fost necesare",
  "struct.fem.vm_directie_deficitara": "deficitară",
  "struct.fem.vm_pas19": "Pasul 19 propune lungiri de stâlpi pe direcția {directie} (regula R11), alese să apropie centrul de rigiditate de centrul de masă; zonele care se mișcă tare (roșu) se văd în formele modale de mai sus.",
  "struct.fem.vm_comparatie": "Comparație cu varianta lean",
  "struct.fem.vm_comparatie_sub": " (aceleași preferințe): T₁ shell = {t1s}s vs T₁ lean = {t1l}s ({semn}{delta}%) · masă {masa} t vs {masaLean} t",
  "struct.fem.vm_cmp_placa": " · placă {shell} m² vs {lean} m²",
  "struct.fem.vm_cmp_mesh": " · acoperire mesh {mesh}%",
  "struct.fem.vm_nerulat": "Verificarea nu a rulat.",

  "struct.fem.fara_armatura": "fără armătură dimensionată",
  "struct.fem.fim_titlu": "Fundația în model",
  "struct.fem.fim_incastrat": "⚠ Baza structurii e ÎNCASTRATĂ perfect — {motiv}",
  "struct.fem.fim_ce_titlu": "Ce înseamnă «bază încastrată» și de ce contează",
  "struct.fem.fim_ce_p1": "Încastrare perfectă înseamnă că nodurile de la cota 0 nu se pot nici deplasa, nici roti: modelul presupune un teren infinit de rigid. Nicio structură reală nu stă așa. Consecințele: perioadele ies mai mici decât în realitate, iar momentele de la baza stâlpilor ies mai mari, pentru că nu se poate roti nimic acolo.",
  "struct.fem.fim_ce_p2": "E o ipoteză acceptabilă pe teren foarte bun, și e reperul pe care s-a făcut calibrarea față de ETABS. Pentru a o înlocui cu terenul real, activează «fundația în model» («fundatie_in_model»).",
  "struct.fem.fim_activ_titlu": "Fundația în model — rețea de grinzi pe teren elastic",
  "struct.fem.fim_da_titlu": "Da, fundația face parte din acest model",
  "struct.fem.fim_da_p1a": "Baza nu mai e încastrată. Sub structură există o rețea de ",
  "struct.fem.fim_grinzi": "grinzi de fundare",
  "struct.fem.fim_da_p1b": " reale (elemente de bară, cu secțiunea și rigiditatea lor), iar sub ele un ",
  "struct.fem.fim_covor": "covor de resoarte",
  "struct.fem.fim_da_p1c": " care înlocuiește pământul. Geometria și rigiditatea lor vin din Pasul 6; rezultatul se întoarce tot acolo, ca presiune citită direct din reacțiunile resoartelor.",
  "struct.fem.fim_da_p2": "Ce se schimbă față de baza încastrată: nodurile de la bază se pot lăsa și roti, deci structura devine mai flexibilă (perioade mai lungi), momentele de la baza stâlpilor scad, iar o parte din ele trec în grinzile de fundare — care de aceea trebuie și ele armate.",
  "struct.fem.fim_impact": "Impactul asupra dinamicii",
  "struct.fem.fim_t1": "T₁ = {incastrat} s încastrat → {elastic} s pe teren elastic",
  "struct.fem.fim_decizie": "Decizia «încastrat vs elastic» (prag ΔT₁ = {prag} %)",
  "struct.fem.fim_doua": "2 modele",
  "struct.fem.fim_unul": "1 model",
  "struct.fem.fim_retea": "Rețeaua de fundare",
  "struct.fem.fim_retea_sub": "grinzi {b}×{h} m pe {l} m · {n} resoarte",
  "struct.fem.fim_abatere": " · lanțul se abate de la ax cel mult {m} m",
  "struct.fem.fim_transversale": ", {n} reazeme excentrice",
  "struct.fem.fim_teren": "Rigiditatea terenului",
  "struct.fem.fim_teren_sub": "K_s {sursa} din Pasul 6 · lungime elastică {lambda} m · pas resoarte {pas} m",
  "struct.fem.fim_pas_titlu": "De ce pasul resoartelor e {pas} m:",
  "struct.fem.fim_pas_text": " se plafonează la π/4 din lungimea elastică λ⁻¹ = (4EI/(K_s·B))^¼ = {lambda} m — distanța pe care se «stinge» efectul unei forțe concentrate (NP 112 anexa K.3.2). Sub ea, covorul discret de arcuri se comportă ca unul continuu. ",
  "struct.fem.fim_ent": "Resoartele sunt FĂRĂ ÎNTINDERE (ENT): modelul e neliniar.",
  "struct.fem.fim_liniar": "Resoartele sunt liniare, ca suprapunerea de efecte din Pasul 11 să rămână exactă.",

  // --- STRUCTURĂ · Pasul 17, verificarea fundației pe reacțiuni reale ---
  "struct.rzv.fundatia_are_doi": "De ce fundația are doi pași, la capetele lanțului",
  "struct.rzv.acopera_coeficientul_exc": "Ce acoperă coeficientul de excentricitate?",
  "struct.rzv.modelul_asaza_talpa": "Modelul așază talpa mereu centrat sub axul peretelui, dar pe șantier stâlpul poate apăsa excentric pe talpă: la un capăt liber de talpă, la un colț (capătul ambelor tălpi) sau la calcan, unde talpa nu poate ieși peste limita de proprietate. Excentricitatea asta CONSTRUCTIVĂ concentrează presiunea spre o margine — coeficientul o acoperă înmulțind presiunile de verificare ale axului (p₁, p_max NP 112, p din model, presiunea sub stâlpi).",
  "struct.rzv.ia_acoperitor_ax": "Se ia acoperitor PE AX — cazul cel mai defavorabil dintre stâlpii lui, nu cel mai defavorabil de pe toată casa. Practica de birou: stâlpi centrați 1,00–1,08; excentric după o axă; excentric după două axe (colț); la calcan până la ~1,4. Situația se detectează automat din geometrie; «calcan» NU se poate detecta (limita de proprietate nu e în model) — dacă axul e la calcan, scrie aici valoarea recomandată (~1,4). Presiunea medie din tasare rămâne neamplificată: tasarea e un fenomen de ansamblu.",
  "struct.rzv.numara_indicatorul": "Ce numără indicatorul",
  "struct.rzv.celula_tabelele_jos": "Fiecare celulă cu ✓/✗ din tabelele de mai jos e o verificare: presiunea pe fiecare ax (pe trei căi de calcul), desprinderea, tasarea, presiunea și străpungerea sub fiecare stâlp, cele șase verificări globale și armarea fiecărei grinzi de fundare.",
  "struct.rzv.proiect_obisnuit_ies": "Pe un proiect obișnuit ies câteva sute de verificări. Fără un contor, o singură depășire pe un singur ax se pierde între rânduri — și exact asta s-a întâmplat: un ax care trecea la pragul metodei de lucru și pica la cel normativ nu era semnalat nicăieri.",
  "struct.rzv.verifica_per_ax": "De ce se verifică per ax, nu global",
  "struct.rzv.predimensionarea_imparte": "Predimensionarea împarte greutatea totală la suprafața totală de talpă — o medie. În realitate, fiecare ax de fundație duce altceva: axele interioare adună plăci de ambele părți, cele de margine au forță axială mică dar moment mare din cutremur, iar acolo apar depășirile.",
  "struct.rzv.structura_foilor_calcul": "E structura foilor de calcul din metoda de lucru: o foaie per ax (AxA, AxB, … Ax1, Ax3), în care se însumează reacțiunile nodurilor de pe ax și se calculează presiunile la capetele tălpii cu excentricitățile din momente. Aici același lucru se face automat, pe toate combinațiile.",
  "struct.rzv.ax_fundatie_verifica": "Ce e un «ax de fundație” și de ce se verifică separat",
  "struct.rzv.p_metoda_kpa": "p metodă [kPa]",
  "struct.rzv.arata_axul_desenul": "arată axul în desenul de mai jos",
  "struct.rzv.presiunea_pune_stalp": "Presiunea pe care o pune fiecare stâlp pe fundație",
  "struct.rzv.verificarile_privesc_fun": "Verificările care privesc fundația ca întreg",
  "struct.rzv.lunecare_talpa": "Lunecare pe talpă",
  "struct.rzv.rasturnare": "Răsturnare",
  "struct.rzv.indicator_informativ_int": "Indicator informativ: nu intră în contorul de verificări și nu blochează optimizarea",
  "struct.rzv.lasa_cladirea_neuniform": "Se lasă clădirea neuniform?",
  "struct.rzv.conteaza_doar_lasa": "Nu contează doar cât se lasă clădirea, ci mai ales cât de DIFERIT se lasă de la un ax la altul: diferența de tasare împărțită la distanța dintre ele. E un INDICATOR INFORMATIV: valoarea se calculează și se afișează, dar nu e o verificare care pică — decizie de proiectare, criteriul între axe nu se folosește la cadrele acestea. Verdictul rămâne pe tasarea ABSOLUTĂ per ax.",
  "struct.rzv.np_112_tab": "NP 112 tab. H.1 dă un reper orientativ: la cadre de beton armat fără umplutură de zidărie 0,002; cu umplutură de zidărie 0,001 (zidăria fisurează mai devreme). Tasarea absolută maximă e 80 mm — aceea rămâne verificare obligatorie, per ax.",
  "struct.rzv.bucla_teren_structura": "Bucla teren–structură",
  "struct.rzv.inseamna_verificare_glob": "Ce înseamnă fiecare verificare globală",
  "struct.rzv.grinda_fundare_armeaza": "De ce grinda de fundare se armează altfel decât una obișnuită",
  "struct.rzv.modelata_fundatia_altfel": "Cum e modelată fundația — și de ce altfel decât restul",
  "struct.rzv.face_bucla_locala": "Ce face bucla locală și de ce e separată de cea globală",
  "struct.rzv.actiunile_catalog_cand": "Acțiunile din catalog și când se folosesc",
  "struct.rzv.fundatii_coef_excentrici": "fundatii.COEF_EXCENTRICITATE — un singur loc de actualizat",
  "struct.rzv.verificarile_bucla_pasul": "verificările pe care bucla Pasului 6 le poate rezolva schimbând geometria fundației; restul rămân pentru Pasul 19",
  "struct.rzv.catalogul_actiuni_f1": "catalogul de acțiuni F1–F5",
  "struct.rzv.suma_reactiunilor_noduri": "suma reacțiunilor nodurilor de pe ax",
  "struct.rzv.tensorul_combinat_pasulu": "tensorul combinat al Pasului 11",
  "struct.rzv.aria_talpii_ax": "aria tălpii pe ax",
  "struct.rzv.l_partea_acoperita": "L = partea acoperită de fundație din anvelopa axului (Pasul 5)",
  "struct.rzv.modulele_rezistenta_b": "modulele de rezistență B·L²/6 și L·B²/6",
  "struct.rzv.pasul_5_segmentele": "Pasul 5 — segmentele de fundație grupate pe dreapta-suport",
  "struct.rzv.decizia_pasului_6": "decizia Pasului 6 (Pasul 6 predimensionează, Pasul 17 lățește unde e nevoie)",
  "struct.rzv.decizie_proiectare_impli": "decizie de proiectare; implicitele într-un singur loc, până sosesc valorile lui",
  "struct.rzv.pasul_6_detaliul": "Pasul 6 — detaliul de execuție + D_f (NP 112 §II.7.5.1)",
  "struct.rzv.stalpi_lamele": "Stâlpi și lamele",
  "struct.rzv.guverneaza": "Guvernează",
  "struct.rzv.p_metoda": "p metodă",
  "struct.rzv.stalp": "Stâlp",
  "struct.rzv.pasul_4_id": "Pasul 4 (id_plan) + nodul de bază al modelului",
  "struct.rzv.reactiunea_nodului_tenso": "reacțiunea nodului, din tensorul Pasului 11",
  "struct.rzv.pozitie": "Poziție",
  "struct.rzv.diferenta_tasare_intre": "diferența de tasare între două axe",
  "struct.rzv.tasarea_calculata_per": "tasarea calculată per ax, cu presiunea lui",
  "struct.rzv.distanta_dintre_centrele": "distanța dintre centrele axelor",
  "struct.rzv.tasare_relativa": "Tasare relativă",
  "struct.rzv.sectiune": "Secțiune",
  "struct.rzv.consola_talpa": "Consolă talpă",
  "struct.rzv.f1_latirea_axelor": "F1 — lățirea axelor care pică",
  "struct.rzv.f2_latirea_intregii": "F2 — lățirea întregii fundații",
  "struct.rzv.f3_coborarea_cotei": "F3 — coborârea cotei de fundare",
  "struct.rzv.f4_grinda_fundare": "F4 — grindă de fundare mai înaltă",
  "struct.rzv.f5_portiuni_suplimentare": "F5 — porțiuni suplimentare",
  "struct.rzv.f6_ingustarea_axelor": "F6 — îngustarea axelor supradimensionate",
  "struct.rzv.fundatia_structura_condi": "Fundația și structura se condiționează reciproc, deci nu există o ordine liniară în care fiecare pas să primească date gata calculate. Lanțul rupe bucla într-un punct, iar fundația se stabilește în doi timpi, la distanță unul de altul:",
  "struct.rzv.estimata": "estimată",
  "struct.rzv.pasii_7_12": "Pașii 7…12",
  "struct.rzv.re_ruleaza_modelul": "nu re-rulează modelul",
  "struct.rzv.ruleaza_tot": "«Rulează tot»",
  "struct.rzv.salveaza": "Salvează",
  "struct.rzv.revino_implicit": "Revino la implicit",
  "struct.rzv.verificari": "verificări",
  "struct.rzv.geometria_gasita": "→ geometria găsită",
  "struct.rzv.reluarea_lantului_pasul": "reluarea lanțului din Pasul 19",
  "struct.rzv.bucla_pasului_6": "Bucla Pasului 6 a găsit o geometrie care trece, dar rezultatul afișat nu e cel final — rulează pasul din nou.",
  "struct.rzv.unde": "Unde",
  "struct.rzv.referinta": "Referința",
  "struct.rzv.pasul_6_predimensionarea": "Pasul 6 (predimensionarea de mai sus) lucrează cu o greutate estimată empiric și cu o presiune medie pe toată lungimea tălpii. Pasul 17 reia verificarea cu reacțiunile din modelul rulat, ax cu ax — acolo apar cazurile pe care media le ascunde: axele de margine, cu forță axială mică și moment mare din seism.",
  "struct.rzv.csv_per_ax": "↓ CSV per ax × combinație",
  "struct.rzv.motivul_axele_egale": "Motivul e că axele nu sunt egale. Un ax interior primește planșeu din ambele părți și e bine încărcat vertical; unul de margine primește doar dintr-o parte, deci are forță verticală mică — dar la cutremur ia același moment de răsturnare. Media pe toată clădirea (Pasul 6) ascunde exact axele astea.",
  "struct.rzv.numele_axului_literele": "Numele axului. Literele merg pe direcția transversală, cifrele pe direcția dominantă a clădirii — convenția din planurile de cofraj.",
  "struct.rzv.real_acoperita": "real acoperită",
  "struct.rzv.fundatie_distanta_dintre": "de fundație, nu distanța dintre capete.",
  "struct.rzv.constructiva": "constructivă",
  "struct.rzv.editabila_per_ax": "editabilă per ax",
  "struct.rzv.anvelopa_axului_chiar": "Cât din anvelopa axului e chiar fundație. 100 % = panglică neîntreruptă; 40 % = axul are goluri mari.",
  "struct.rzv.cate_noduri_reazem": "Câte noduri de reazem cad pe ax. Cu fundația în model numărul include și punctele intermediare de pe grinda de fundare, nu doar stâlpii.",
  "struct.rzv.combinatia_incarcari_pro": "Combinația de încărcări care produce presiunea maximă pe acest ax — cea care «decide” verdictul.",
  "struct.rzv.presiunea_maxima_margine": "Presiunea maximă la marginea tălpii, după formula din foaia de calcul a biroului: rezultanta verticală împărțită la arie, plus efectul momentului.",
  "struct.rzv.terenul_poate_trage": "terenul nu poate trage",
  "struct.rzv.coboara_terenul_sub": "Cât coboară terenul sub axul acesta, calculat cu presiunea LUI, nu cu media pe clădire.",
  "struct.rzv.incarcarea_lui": "încărcarea lui",
  "struct.rzv.sus": "în sus",
  "struct.rzv.stalpi": "Stâlpi",
  "struct.rzv.latit": "lățit",
  "struct.rzv.combinatie": "Combinație",
  "struct.rzv.arie_activa": "arie activă",
  "struct.rzv.strapunge": "străpunge",
  "struct.rzv.strapungerea": "Străpungerea",
  "struct.rzv.forta_stalpului_scade": "Din forța stâlpului se scade reacțiunea terenului din interiorul conturului: pământul de acolo împinge înapoi în sus, deci nu tot N trebuie transmis prin forfecare.",
  "struct.rzv.identificatorul_planul_c": "Identificatorul din planul de cofraj, plus poziția lui.",
  "struct.rzv.cea_mare_forta": "Cea mai mare forță verticală pe care o coboară stâlpul, pe toate combinațiile. Pozitiv = apasă în jos.",
  "struct.rzv.lungimea_talpa_tine": "Lungimea de talpă care «ține» stâlpul acesta — jumătate din distanța până la vecinii lui de pe ax.",
  "struct.rzv.apasarea_locala_teren": "Apăsarea locală pe teren, sub stâlpul acesta.",
  "struct.rzv.interior_margine_conteaz": "«interior» sau «margine» — contează la străpungere: la un stâlp de margine conturul de control e retezat de marginea tălpii, deci rezistă mai puțin.",
  "struct.rzv.efortul_forfecare_apare": "Efortul de forfecare care apare pe conturul de control — «cât de tare împinge» stâlpul prin talpă.",
  "struct.rzv.poate_duce_betonul": "Cât poate duce betonul nearmat transversal la forfecare pe acel contur.",
  "struct.rzv.rezerva_cate_ori": "Rezerva: de câte ori e capacitatea mai mare decât solicitarea.",
  "struct.rzv.aluneca": "nu alunecă",
  "struct.rzv.rastoarna": "nu se răstoarnă",
  "struct.rzv.pluteste": "nu plutește",
  "struct.rzv.smulg": "nu se smulg",
  "struct.rzv.lasa_neuniform": "nu se lasă neuniform",
  "struct.rzv.card_arata_raportul": "Fiecare card arată raportul dintre solicitare și capacitate (sau invers, după caz) pentru combinația cea mai defavorabilă; treci cu mouse-ul peste ⓘ pentru formula completă și normativul.",
  "struct.rzv.cutremurul_impinge_cladi": "Cutremurul împinge clădirea lateral. Fundația se opune prin frecarea tălpii de pământ (ca un dulap greu pe covor) plus împingerea pământului din fața ei.",
  "struct.rzv.forta_orizontala_aplicat": "Forța orizontală, aplicată la înălțimea centrului de greutate, tinde să rotească toată clădirea peste muchia fundației. Greutatea o ține pe loc.",
  "struct.rzv.daca_panza_freatica": "Dacă pânza freatică e deasupra tălpii, apa împinge fundația în sus, ca pe o barcă. Se compară cu greutatea proprie a infrastructurii — nu cu a clădirii, pentru că faza critică e execuția, când clădirea încă nu apasă.",
  "struct.rzv.doar": "doar",
  "struct.rzv.rasturnarea_ansamblu_sta": "La răsturnarea de ansamblu, stâlpii de pe o latură sunt trași în SUS. Îi ține greutatea tălpii și a pământului de deasupra ei, pe lungimea aferentă.",
  "struct.rzv.coeficientul_pat_k": "Coeficientul de pat K_s cu care s-au calibrat resoartele modelului a fost calculat din presiunea ESTIMATĂ (Pasul 6). După ce modelul a rulat, știm presiunea reală — se recalculează K_s din ea și se compară.",
  "struct.rzv.incarcarea_vine_jos": "încărcarea vine de jos",
  "struct.rzv.infasuratoarea": "înfășurătoarea",
  "struct.rzv.b_h_c": "B × H_c și înălțimea utilă d.",
  "struct.rzv.infasuratoarea_momentulu": "Înfășurătoarea momentului încovoietor pe tot axul, pe toate combinațiile: M⁺ întinde o față, M⁻ pe cealaltă.",
  "struct.rzv.cea_mare_forta2": "Cea mai mare forță tăietoare de pe ax — tendința de forfecare a secțiunii.",
  "struct.rzv.aria_armatura_longitudin": "Aria de armătură longitudinală necesară pe fiecare față. În paranteză scrie ce a decis valoarea: calculul de moment sau armarea minimă constructivă.",
  "struct.rzv.armatura_minima_construc": "Armătura minimă constructivă și procentul de armare realizat. La secțiuni mari de beton, ea depășește adesea ce cere calculul — și atunci ea guvernează.",
  "struct.rzv.duce_betonul_forfecare": "Cât duce betonul la forfecare FĂRĂ etrieri. Dacă V îl depășește, etrierii preiau diferența.",
  "struct.rzv.daca_necesari_calcul": "Dacă sunt necesari din calcul. Chiar și când nu sunt, se pun cei constructivi.",
  "struct.rzv.talpa_lata_decat": "Talpa e mai lată decât grinda; părțile care ies în afară sunt console încărcate de jos, de presiunea pe teren. Se armează transversal.",
  "struct.rzv.grosimea_talpii": "grosimea tălpii",
  "struct.rzv.trei_lucruri_fac": "Trei lucruri se fac altfel decât la suprastructură:",
  "struct.rzv.rigiditatea_nefisurata": "rigiditatea e NEfisurată",
  "struct.rzv.sectiunea_dreptunghiular": "secțiunea e dreptunghiulară",
  "struct.rzv.doar_fundatie": "doar din fundație",
  "struct.rzv.alege": "Cum alege",
  "struct.rzv.cand_opreste": "Când se oprește",
  "struct.rzv.rezerva_exact_pragul": "De ce o rezervă și nu exact pragul",
  "struct.rzv.zero_rezerva": "zero rezervă",
  "struct.rzv.variabilele_cautate": "variabilele căutate",
  "struct.rzv.latimi_diferite_axe": "Lățimi diferite pe axe:",
  "struct.rzv.jurnalul_pas_pas": "Jurnalul pas-cu-pas al căutării nu se mai păstrează : singurul istoric ținut e cel al Pasului 19, «ce s-a modificat în structură». Ce a schimbat căutarea de aici se citește din geometria inițială → finală de mai sus, iar de ce s-a oprit, din «oprire».",
  "struct.rzv.creste_b_doar": "Crește B doar pe axele cu presiune peste prag.",
  "struct.rzv.creste_b_peste": "Crește B peste tot. Se propune doar când pică ≥ 4 axe.",
  "struct.rzv.coboara_d_f": "Coboară D_f. Crește presiunea convențională și lestul de pământ de deasupra tălpii.",
  "struct.rzv.creste_h_c": "Crește H_c, deci înălțimea utilă d.",
  "struct.rzv.completeaza_golurile_axe": "Completează golurile pe axele cu acoperire sub 85 %.",
  "struct.rzv.pas_economie_rulat": "Pas de ECONOMIE, rulat doar după ce totul trece cu rezerva cerută: subțiază axele care trec cu peste 25 % rezervă.",
  "struct.rzv.celalalt_pas_economie": "Celălalt pas de ECONOMIE: încearcă să RIDICE talpa. Fără el, D_f ar fi un «ratchet» — bucla îl coboară când e nevoie, iar reluarea lanțului pornește de acolo, deci adâncimea cerută de o trecere cu model prost nu s-ar mai recupera niciodată.",
  "struct.rzv.a_ramas_nerezolvat": "Ce a rămas nerezolvat",

  "struct.rzv.valoare_invalida": "valoare invalidă — între 1,00 și 2,00",
  "struct.rzv.revenit_implicit": "revenit pe implicitul situației detectate — rerulează Pasul 6 ca să intre în calcul",
  "struct.rzv.salvat_reruleaza": "salvat — rerulează Pasul 6 ca să intre în calcul",
  "struct.rzv.eroare_salvare": "eroare la salvare: {motiv}",
  "struct.rzv.sim_situatia": "situația",
  "struct.rzv.detectare_geometrie": "detectare din geometrie",
  "struct.rzv.sim_plaja": "plaja",
  "struct.rzv.practica_birou": "practica de birou (valorile finale le trimite structuristul)",
  "struct.rzv.praguri_ambele": "ambele praguri de presiune sunt obligatorii (metoda de lucru + NP 112 tab. I.5)",
  "struct.rzv.praguri_metoda": "guvernează doar pragul metodei de lucru (1,10 / 1,35 · p_conv)",
  "struct.rzv.praguri_np112": "guvernează doar pragul normativ (NP 112 tab. I.5)",
  "struct.rzv.sim_praguri": "praguri",
  "struct.rzv.praguri_sursa": "metoda de lucru — «praguri_presiune»",
  "struct.rzv.sim_urmarite": "urmărite",
  "struct.rzv.ascunde_lista": "ascunde lista",
  "struct.rzv.arata_lista": "arată lista",
  "struct.rzv.desen": "desen",
  "struct.rzv.p_unde_nume": "{unde} — {nume}",
  "struct.rzv.nu_s_a_facut": "Verificarea pe reacțiuni reale — încă nu s-a făcut",
  "struct.rzv.stalpi_lamele2": "Stâlpi și lamele",
  "struct.rzv.cautarea_geometriei": "Căutarea geometriei",
  "struct.rzv.metoda_vs_normativ": "Metodă vs normativ",
  "struct.rzv.h_detaliu_t": "H = D_f − h_peste (detaliul «T»: talpa + inima umplu șanțul)",
  "struct.rzv.h_cu_subsol": "H = D_f − 0,05 (clădire cu subsol: numai talpa, iar D_f o dă grosimea cerută de lățime)",
  "struct.rzv.h_min": "H = min(L₀/6 ; D_f − 0,05), minim 0,50 m",
  "struct.rzv.pasul_11_combinatii": "Pasul 11 — {n} combinații (fundamentale + seismice)",
  "struct.rzv.presiunea_citita": "Presiunea citită",
  "struct.rzv.formula_resort": "p_i = R_resort,i / (B · l_aferentă,i);  se ia maximul pe ax",
  "struct.rzv.acelasi_prag_metoda2": "același prag ca la metodă (1,10 / 1,35·p_conv)",
  "struct.rzv.formula_tasare": "s = 0,8 · Σ (σ_med,i · h_i / E_i), pe felii, până unde σz < 0,2·σgz",
  "struct.rzv.latimi_distincte": "Lățimile tălpii: {n} dimensiuni distincte pe tot proiectul",
  "struct.rzv.latit_local": "lățit local peste B global = {b} m",

  "struct.rzv.col_dir_ce": "Direcția axului, raportată la <b>direcția dominantă a clădirii</b>, nu la nordul planului: o clădire rotită 30° față de nord are tot axe «X» și «Y».",
  "struct.rzv.col_dir_formula": "unghi dominant din media ponderată cu lungimea",
  "struct.rzv.col_l_ce": "Lungimea de calcul a axului — partea <b>real acoperită</b> de fundație, nu distanța dintre capete.",
  "struct.rzv.col_l_formula": "Σ lungimile tronsoanelor de pe dreapta axului",
  "struct.rzv.col_l_validare": "intră în A = L·B și în modulele de rezistență",
  "struct.rzv.col_b_ce": "Lățimea tălpii pe axul acesta — <b>grosimea benzii de beton</b> văzută pe plan. Unde scrie «lățit», Pasul 17 a mărit-o local peste lățimea globală ({b} m), pentru că axul nu trecea cu lățimea de bază.",
  "struct.rzv.col_b_formula": "A = L·B,  W_long = B·L²/6,  W_transv = L·B²/6",
  "struct.rzv.col_b_validare": "minim de execuție {min} m (cupa excavatorului); maxim din grila de căutare 2,50 m",
  "struct.rzv.col_kexc_ce": "Coeficientul de excentricitate al axului — acoperă excentricitatea <b>constructivă</b> dintre stâlp și talpă, pe care modelul nu o vede (el pune talpa mereu centrat sub ax). Presiunile de verificare ale axului (p metodă, p NP 112, p model) sunt afișate deja înmulțite cu el.",
  "struct.rzv.col_kexc_formula": "p_verificare = k_exc · p_calculat",
  "struct.rzv.col_kexc_validare": "plaja practicii: stâlpi centrați 1,00–1,08; excentric după o axă; după două axe (colț); la calcan ~1,4. Situația se detectează din geometrie (stâlpi la capete libere de talpă, colțuri, deplasări transversale), acoperitor pe ax; valoarea e <b>editabilă per ax</b> — click pe rând, apoi editorul de sub tabel. «Calcan» se setează manual",
  "struct.rzv.col_h_ce": "Înălțimea secțiunii de beton și adâncimea de fundare — aceleași pe toată fundația: H = {h} m, D_f = {df} m. Secțiunea de pe fiecare ax e {sectiune}, cu fața de jos la cota −{df} m.",
  "struct.rzv.col_h_validare": "H e <b>derivat</b>, nu o variabilă de optimizare: la reacțiuni date nu intră în p = ΣF/(L·B) ± ΣM/W. Se reface după fiecare pas care mișcă D_f",
  "struct.rzv.col_acop_formula": "L_acoperit / L_anvelopă",
  "struct.rzv.col_acop_validare": "sub <b>70 %</b> se marchează roșu: axul e «găurit», iar tratarea lui ca o talpă continuă e o aproximație — ar trebui spart în două axe",
  "struct.rzv.validare_stalp_aflat_intersectia": "un stâlp aflat la intersecția a două axe își împarte încărcarea între ele (jumătate–jumătate), altfel ar fi numărat de două ori",
  "struct.rzv.validare_p1_b_1": "p₁ ≤ <b>1,10·p_conv</b> la gruparea fundamentală, ≤ <b>1,35·p_conv</b> la cea seismică (aici {p1} / {p2} kPa)",
  "struct.rzv.ce_aceeasi_presiune_maxima": "Aceeași presiune maximă, dar pe drumul normativ: un coeficient μ care ține cont că <b>{p1}</b> de fundație — dacă excentricitatea depășește L/6, o parte din talpă se ridică și restul preia tot.",
  "struct.rzv.validare_pragul_depinde_tipul": "pragul depinde de tipul încărcării (NP 112 tab. I.5): centrică 1,0·p_conv (fundamentală) / 1,2 (seismică); excentrică pe o direcție 1,2 / 1,4; oblică 1,4 / 1,6",
  "struct.rzv.ce_presiunea_citita_b": "Presiunea citită <b>direct din modelul de calcul</b>: fiecare resort de teren de sub fundație are o reacțiune, iar aceea e chiar rezultanta presiunii de sub el. E cea mai fidelă dintre cele trei — nu presupune că talpa e rigidă.",
  "struct.rzv.validare_acelasi_prag_metoda": "același prag ca la metodă (1,10 / 1,35·p_conv)",
  "struct.rzv.validare_diferenta_dintre_axe": "diferența dintre axe (tasarea relativă) e cea care contează — vezi tabul Global",
  "struct.rzv.validare_acelasi_prag_ax": "același prag ca pe ax: 1,10·p_conv (fundamentală) / 1,35·p_conv (seismică)",
  "struct.rzv.validare_b_1_00": "<b>≥ 1,00</b>. Sub 1 se pun armături înclinate în dreptul stâlpului sau se îngroașă talpa",
  "struct.rzv.validare_raportul_h_r": "raportul H/R afișat trebuie să fie <b>≤ 1,00</b>{p1} (EC7 §6.5.3 / NP 112 rel. I.23)",
  "struct.rzv.validare_raportul_m_stab": "raportul M_stab/M_răst <b>≥ 1,00</b>. Starea limită EQU (EC7 §2.4.7.2): permanentele se iau cu 0,9 pentru că pot fi mai mici decât estimăm, iar cele destabilizatoare cu 1,1",
  "struct.rzv.validare_ruleaza_b_p1": "se rulează <b>{p1}</b> dacă apa e mai sus decât cota de fundare; altfel «n/a» (EC7 §2.4.7.4, starea limită UPL)",
  "struct.rzv.validare_verificarea_locala_acope": "verificarea e locală și acoperitoare: în realitate rețeaua de grinzi de fundare e continuă, deci un stâlp smuls e ținut de toată infrastructura. De aceea, cu fundația în model, cazurile de ridicare scad mult",
  "struct.rzv.ce_conteaza_doar_lasa": "Nu contează doar cât se lasă clădirea, ci cât de{p1} <b>diferit</b> se lasă de la un ax la altul: diferența de tasare împărțită la distanța dintre ele. Ea strâmbă structura și fisurează pereții — tasarea uniformă nu face niciun rău.",
  "struct.rzv.validare_b_0_002": "<b>0,002</b> la cadre de beton armat fără umplutură de zidărie, <b>0,001</b> cu umplutură (zidăria fisurează mai devreme). Tasarea absolută maximă: 80 mm. NP 112 tab. H.1",
  "struct.rzv.validare_abatere_b_20": "abatere <b>≤ 20 %</b>. Peste, rigiditatea patului din model nu mai corespunde realității și lanțul trebuie reluat cu K_s recalculat — asta face bucla externă (Pasul 19)",
  "struct.rzv.validare_8_mm_etrieri": "Ø ≥ 8 mm; etrieri dubli (4 ramuri) la b ≥ 400 mm. Verdictul ✓/✗ compară V cu <b>V_Rd,max</b> — plafonul bielei comprimate de beton, peste care nu mai ajută nici armătura și secțiunea trebuie mărită",
  "struct.rzv.validare_0_10_directie": "ρ ≥ 0,10 % pe direcție, Ø ≥ 10 mm, distanțe 100–250 mm (NP 112 §II.6.1.1(3)). Verdictul «panta» (S3) compară <b>{p1}</b> h_t cu L_c, nu înălțimea întregii secțiuni: la h_t ≥ L_c (pantă ≥ 45°) consola nu s-ar mai verifica separat la tăietoare — dar verificarea o facem oricum, deci un ✗ aici înseamnă doar că scutirea nu se aplică",

  "struct.opt.op.redimensioneaza_stalp": "redimensionează stâlpul",
  "struct.opt.op.redimensioneaza_grinda": "redimensionează grinda",
  "struct.opt.op.adauga_stalp": "adaugă un stâlp",
  "struct.opt.op.elimina_stalp": "elimină stâlpul",
  "struct.opt.op.adauga_grinda": "adaugă o grindă",
  "struct.opt.op.elimina_grinda": "elimină grinda",
  "struct.opt.op.uneste_stalpi": "unește stâlpii",
  "struct.opt.op.gliseaza_stalp_plantat": "glisează stâlpul plantat",
  "struct.opt.par.cu": "cu",
  "struct.opt.par.pentru": "pentru",
  "struct.opt.par.b_cm": "lățimea b",
  "struct.opt.par.h_cm": "înălțimea h",
  "struct.opt.par.L_cm": "latura",
  "struct.opt.par.directie": "pe direcția",
  "struct.opt.par.pe_grinda": "pe grinda",
  "struct.opt.par.pe_grinda_unita": "pe grinda unită din",
  "struct.opt.par.pozitie": "poziția pe grindă",
  "struct.opt.par.intre": "între",
  "struct.opt.par.nivel": "nivelul",

  "struct.rzv.rezumat_doi_pasi": "Pasul 6 predimensionează înainte să existe modelul; Pasul 17 reia verificarea pe reacțiunile reale, ax cu ax.",
  "struct.rzv.col_verificarea": "Verificarea",
  "struct.rzv.col_valoare": "Valoare",
  "struct.rzv.col_prag": "Prag",
  "struct.rzv.neaplicabile": "Neaplicabile / fără date:",
  "struct.rzv.tab_axe": "Axe",
  "struct.rzv.tab_global": "Global",
  "struct.rzv.tab_grinzi": "Grinzi de fundare",
  "struct.rzv.tab_model": "Model",
  "struct.rzv.pasul_11_comb": "Pasul 11 — {n} combinații (fundamentale + seismice)",
  "struct.rzv.latimi_talpii": "Lățimile tălpii: {n} dimensiuni distincte pe tot proiectul",
  "struct.rzv.latimea_globala": "lățimea globală a fundației",
  "struct.rzv.fara_reactiuni": "fără reacțiuni",
  "struct.rzv.o_directie": "1 direcție",
  "struct.rzv.doua_directii2": "2 direcții",
  "struct.rzv.presiune_resoarte": "presiune din reacțiunile resoartelor (Pasul 7)",
  "struct.rzv.pondere_long": "pondere {w} — proiecția direcției seismice pe lungimea tălpii",
  "struct.rzv.pondere_transv": "pondere {w} — proiecția direcției seismice pe lățimea tălpii",
  "struct.rzv.verificarea_varfului": "Verificarea vârfului, nu a mediei: sub un stâlp foarte încărcat presiunea locală poate depăși pragul chiar dacă media pe ax trece.",
  "struct.rzv.lungimea_aferenta_resort": "cu fundația în model: lungimea aferentă a resortului de sub nod",
  "struct.rzv.margine_daca": "margine dacă distanța până la conturul fundației < 1,5·B",
  "struct.rzv.global_toata_cladirea": "Lunecare, răsturnare, subpresiune, ridicare și bucla teren–structură — se verifică pe toată clădirea, nu pe un ax.",
  "struct.rzv.delta_s_l": "Δs / L, pe toate perechile de axe; se ia maximul",
  "struct.rzv.reazema_teren_nu": "Reazemă pe teren, nu pe stâlpi: momentul își schimbă semnul, deci armătura de sus și cea de jos sunt amândouă de lucru.",
  "struct.rzv.max_min_statii": "max / min pe 5 stații × fiecare element × fiecare combinație",
  "struct.rzv.max_v_z": "max |V_z| pe stații × combinații",
  "struct.rzv.o_minim": "Ø minim",
  "struct.rzv.grinzi_pat_resoarte": "Grinzi pe pat de resoarte (Winkler), cu K_s din Pasul 6 — de aceea coerența K_s se reverifică la final.",
  "struct.rzv.resoarte_intinse": "Resoarte întinse (talpă desprinsă)",
  "struct.rzv.noduri_baza_axe": "Noduri de bază pe axe",
  "struct.rzv.v_presiune_stalp": "presiunea sub stâlp",
  "struct.rzv.v_desprindere": "desprinderea tălpii",
  "struct.rzv.v_tasare_relativa": "tasarea relativă",
  "struct.rzv.v_rasturnarea": "răsturnarea",
  "struct.rzv.v_ridicarea": "ridicarea stâlpului",
  "struct.rzv.v_strapungerea": "străpungerea",
  "struct.rzv.v_taietoarea": "tăietoarea în grinda de fundare",
  "struct.rzv.bucla_misca_doar": "Bucla locală mișcă doar geometria fundației (B, D_f, h); geometria structurii o mișcă Pasul 19.",
  "struct.rzv.cu_cel_putin": "cu cel puțin",
  "struct.rzv.costul_fundatiei": "Costul fundației",
  "struct.rzv.geometria_gasita2": "Geometria găsită",
  "struct.rzv.f1_formula": "B_ax += 10 cm, până la 2,50 m",
  "struct.rzv.f3_formula": "D_f += 10 cm, până la 3,00 m",
  "struct.rzv.f5_formula": "L_ax += lungimea lipsă din anvelopă",
  "struct.rzv.f6_formula": "B_ax −= 10 cm, cât timp toate verificările rămân trecute",
  "struct.rzv.f7_formula": "D_f −= 10 cm, cât timp toate verificările rămân trecute",
  "struct.rzv.li_pasul_6": "<b>Pasul 6</b> — predimensionează talpa: B, D_f, H_c și un K_s din greutatea <i>estimată</i> empiric. Nu are de unde ști reacțiunile: modelul încă nu există.",
  "struct.rzv.li_pasii_7_12": "<b>Pașii 7…12</b> — modelul se construiește PE geometria aia (patul de resoarte Winkler are nevoie de B, H_c și K_s ca să existe), apoi ies încărcările, modurile, combinațiile și reacțiunile reale.",
  "struct.rzv.bucla_nu_reruleaza": "Bucla locală <b>nu re-rulează modelul</b>: geometria găsită la Pasul 17 e evaluată cu reacțiunile geometriei <i>precedente</i>. De asta «toate verificările trec la finalul căutării» nu e criteriul de convergență. Criteriul real este <b>0 verificări picate la iterația 0 a căutării</b> — adică pe geometria pe care s-a construit efectiv modelul. Ca lanțul să convergă în loc să oscileze în jurul pragului, căutarea își lasă o rezervă (implicit 3 %), iar rulările următoare continuă de la geometria modelată, nu de la minimul Pasului 6.",
  "struct.rzv.butonul_ruleaza_tot": "Butonul <b>«Rulează tot»</b> parcurge 1…19 în ordine, o singură dată prin fiecare pas — dacă ar trece prin Pasul 6 de două ori, iar numerotarea afișată nu mai putea fi citită ca o ordine. Bucla n-a dispărut, doar s-a întins peste lanț: Pasul 17 adoptă geometria, iar rularea următoare pornește de la ea. Dacă vrei bucla închisă până la punct fix (reacțiuni și geometrie care nu se mai schimbă), asta face Pasul 19, care reia lanțul întreg de câte ori e nevoie.",
  "struct.rzv.situatia_detectata": "situația detectată: <b>{eticheta}</b> — {detaliu}",
  "struct.rzv.plaja_implicit": " · plajă {min}–{max} · implicit {implicit}",
  "struct.rzv.valoare_per_ax": "valoare per ax (gol = implicit):",
  "struct.rzv.n_trec": "{n} trec",
  "struct.rzv.n_nu_trec": "{n} nu trec",
  "struct.rzv.n_neaplicabile": "{n} neaplicabile",
  "struct.rzv.verdicte_divergente": "{n} verdicte divergente între praguri",
  "struct.rzv.toate_trec_geometria": "Toate verificările Pasului 17 trec pe geometria de fundație curentă — {praguri}.",
  "struct.rzv.bucla_oprita_fara": "Bucla Pasului 6 s-a oprit fără să le rezolve pe toate",
  "struct.rzv.dupa_iteratii": "după {n} iterații: {oprire}.",
  "struct.rzv.urmeaza_depaseste": "Ce urmează depășește geometria fundației — se continuă din <b>Pasul 19</b> (schimbări în suprastructură, cu reluarea lanțului).",
  "struct.rzv.bucla_rezolvat_tot": "<b>Bucla Pasului 6 a rezolvat tot ce depinde de geometria fundației</b> ({n} iterații). Ce a rămas nu e în catalogul ei — se rezolvă prin <b>{pas}</b> (bucla teren–structură cere reacțiuni recalculate pe geometria nouă).",
  "struct.rzv.bucla_oprita_manual": "Bucla locală a Pasului 6 e oprită ({motiv}), deci geometria nu a fost căutată automat — verificările de mai jos rămân pe geometria propusă de Pasul 6.",
  "struct.rzv.nu_e_in_catalog": "nu e în catalogul buclei Pasului 6 — se rezolvă din Pasul 19",
  "struct.rzv.vezi": "→ vezi",
  "struct.rzv.verificarea_reactiuni_reale": "Verificarea pe reacțiuni reale",
  "struct.rzv.comb_x_axe": "— {c} combinații × {a} axe",
  "struct.rzv.ax_fundatie_verifica2": "Un ax = un tronson de fundație cu stâlpii lui; media pe toată clădirea ascunde axele de margine, cu forță verticală mică și moment mare.",
  "struct.rzv.click_rand_deschide2": "Fiecare rând e un ax; valorile afișate sunt cele ale combinației guvernante (cea care dă presiunea maximă). Click pe rând deschide toate combinațiile axului.",
  "struct.rzv.latimi_rotunjite": "Fiecare ax primește lățimea cerută de <b>încărcarea lui</b> (axele au arii aferente diferite — o lățime unică peste tot ar fi beton care nu lucrează), dar șantierul nu poate lucra cu 10 lățimi diferite: trasarea și cofrarea se complică și se greșește. De aceea lățimile necesare se rotunjesc <b>în sus</b> la un set de cel mult {n} dimensiuni distincte — <b>{lista} m</b> — ales dintre necesarele calculate așa încât betonul total (Σ L·B) să fie minim. Decizie de proiectare («maxim 3 dimensiuni folosesc»).",
  "struct.rzv.b_necesar_per_ax": "B necesar per ax = cea mai mică lățime din grila de 10 cm la care toate verificările axului trec cu rezerva de convergență, la reacțiunile curente (coeficientul de excentricitate inclus). Diferența de cost față de geometria de dinainte: {delta} €. Detaliul per ax: {detaliu}",
  "struct.rzv.per_ax_necesar_ales": "{ax}: necesar {nec} → ales {ales} m",
  "struct.rzv.th_ax": "Ax",
  "struct.rzv.th_dir": "Dir.",
  "struct.rzv.th_l_m": "L [m]",
  "struct.rzv.th_b_m": "B [m]",
  "struct.rzv.th_excentricitate": "Excentricitate",
  "struct.rzv.th_h_df": "H / Df [m]",
  "struct.rzv.th_acoperire": "Acoperire",
  "struct.rzv.th_tasare_cm": "Tasare [cm]",
  "struct.rzv.th_grupare": "Grupare",
  "struct.rzv.th_prag": "prag",
  "struct.rzv.th_tip": "tip",
  "struct.rzv.centric": "centric",
  "struct.rzv.guv_paren": "(guv. {tip})",
  "struct.rzv.editat": "editat",
  "struct.rzv.v_p1_ce": "presiunea maximă la marginea tălpii, după formula p₁ = ΣF_Z/A + ΣM/W a foii de calcul, pe combinația guvernantă ({comb})",
  "struct.rzv.v_p1_regula": "{mult} × p_conv, unde p_conv = {p} kPa e presiunea convențională corectată pentru B și D_f",
  "struct.rzv.v_np_ce": "aceeași presiune maximă, dar calculată cu μ = {mu} din tab. E.1 — care ține cont că terenul nu poate trage de fundație",
  "struct.rzv.v_np_regula": "încărcare {tip}, grupare {grupa} → multiplicatorul din tab. I.5 aplicat lui p_conv",
  "struct.rzv.fundamentala": "fundamentală",
  "struct.rzv.seismica": "seismică",
  "struct.rzv.v_model_ce": "cea mai mare presiune citită DIRECT din model: reacțiunea unui resort de teren împărțită la aria lui (B × lungimea aferentă). Nu presupune că talpa e rigidă — o citește așa cum iese din calcul",
  "struct.rzv.v_model_regula": "același prag ca la metodă: {mult} × p_conv",
  "struct.rzv.v_tasare_ce": "cât coboară terenul sub acest ax, calculat cu presiunea LUI din gruparea cvasipermanentă G + ψ₂·Q (tasarea e o stare de exploatare, de durată: nu se ia nici gruparea de rezistență, nici vârful seismic)",
  "struct.rzv.v_tasare_regula": "minimul dintre limita metodei și 80 mm — tasarea absolută maximă normată. Separat se verifică tasarea RELATIVĂ între axe (tabul Global), care e criteriul care fisurează pereții",
  "struct.rzv.ax_toate_combinatiile": "{ax} — toate combinațiile",
  "struct.rzv.talpa_detalii": " · talpă {b} × {h} m la −{d} m · L = {l} m · A = {a} m² · W_long = {wl} m³ · W_transv = {wt} m³",
  "struct.rzv.presiunile_includ_kexc": "Presiunile p₁, p_max NP și p model din tabel includ deja k_exc = {k}; p_med (tasarea) și p₂ rămân neamplificate.",
  "struct.rzv.verificarea_ax_fasia": "Verificarea pe ax spune dacă fâșia de talpă, luată în ansamblu, apasă prea tare. Dar încărcarea nu e uniformă în lungul ei: intră concentrat, prin stâlpi. Aici se privește fiecare stâlp separat — cât apasă el pe bucata de talpă de sub el, și dacă nu cumva o <b>străpunge</b>.",
  "struct.rzv.strapungerea_cedarea": "<b>Străpungerea</b> e cedarea prin care stâlpul «trece prin» talpă ca un dop, forfecând un trunchi de con în jurul lui — e cedarea tipică a plăcilor încărcate concentrat, și e casantă: se produce brusc, fără avertisment. De aceea nu se verifică la fața stâlpului, ci pe un contur mai depărtat, la 2d de el, unde fisura de forfecare ajunge de fapt să iasă la suprafață.",
  "struct.rzv.formula_strapungere": "v_Ed = β · N_red / (u₁ · d)\nN_red = N_Ed − reacțiunea terenului din interiorul conturului\nβ = 1,15 stâlpi interiori / 1,5 marginali (NP 112)\nu₁ = perimetrul conturului la 2d,  d = înălțimea utilă",
  "struct.rzv.th_xy": "x, y [m]",
  "struct.rzv.margine": "margine",
  "struct.rzv.interior": "interior",
  "struct.rzv.v_p_stalp_ce": "apăsarea locală de sub acest element vertical: forța lui verticală maximă împărțită la bucata de talpă care îl susține ({l} m × {b} m)",
  "struct.rzv.v_p_stalp_regula": "{mult} × p_conv, ca la verificarea pe ax — dar aplicat local, unde încărcarea intră concentrat",
  "struct.rzv.v_strapungere_ce": "efortul de forfecare pe conturul de control de la 2d de fața stâlpului, față de cât duce betonul acolo fără armătură transversală",
  "struct.rzv.v_strapungere_regula": "v_Rd,c = 0,12·k·(100·ρ₁·f_ck)^⅓, cu β = {beta} (stâlp {poz}) și N_red = {nred} kN după scăderea reacțiunii terenului din interiorul conturului",
  "struct.rzv.de_margine": "de margine",
  "struct.rzv.pana_aici_bucata": "Până aici totul a fost «bucată cu bucată»: axe, stâlpi. Verificările de mai jos privesc clădirea ca un corp: <b>nu alunecă</b> lateral, <b>nu se răstoarnă</b>, <b>nu plutește</b> dacă e apă, <b>nu se smulg</b> stâlpii din fundație și <b>nu se lasă neuniform</b> atât încât să crape pereții. Ultima — bucla teren–structură — verifică dacă ipoteza pe care s-a construit modelul mai stă în picioare după ce modelul a rulat.",
  "struct.rzv.global_toata_cladirea2": "Lunecare, răsturnare, subpresiune, ridicare și bucla teren–structură — se verifică pe toată clădirea, nu pe un element. Treci cu mouse-ul peste titlul fiecărui card.",
  "struct.rzv.card_lunecare_sub": "H/R la {comb} · μ = {mu} · R_pasiv {r} kN",
  "struct.rzv.card_rasturnare_sub": "M_stabil/M_răsturnare la {comb} · braț {brat} m · z_CM {z} m",
  "struct.rzv.subpresiune_plutire": "Subpresiune (plutire)",
  "struct.rzv.ridicare_uplift": "Ridicare (uplift)",
  "struct.rzv.stalpi_cu_tractiune": "stâlpi cu tracțiune peste lest, din {total}",
  "struct.rzv.tasare_relativa2": "Tasare relativă",
  "struct.rzv.informativ": "informativ",
  "struct.rzv.geometria_pasului_5": "geometria Pasului 5",
  "struct.rzv.reper_orientativ": "reper orientativ {v} ‰ (nu blochează)",
  "struct.rzv.intre_perechea": " · între {a} și {b} ({l} m)",
  "struct.rzv.tasare_absoluta_max": " · tasare absolută max {v} cm",
  "struct.rzv.ks_model_cerut": "K_s în model {model} → cerut de presiunile reale {cerut} daN/cm³",
  "struct.rzv.ks_vine_din": "K_s din model vine din: {sursa}",
  "struct.rzv.formula_lunecare": "H_d ≤ V'_d · μ + R_p,d\nμ = coeficientul de frecare (NP 112 tab. G.1, după tipul stratului)\nR_p,d = ½·K_p·γ·D_f²·L, luat la 50 % (prudent)",
  "struct.rzv.formula_rasturnare": "M_stab = 0,9 · ΣF_Z · braț   vs   M_răst = 1,1 · ΣH · z_CM\nbraț = distanța de la centrul amprentei la muchie, pe direcția forței",
  "struct.rzv.formula_subpresiune": "V_dst,d = γ_w · h_apă · A   ≤   G_stb,d = 0,9 · G_fundație",
  "struct.rzv.formula_ridicare": "tracțiune = max(−N_min, 0)   ≤   lest = 0,9 · (G_talpă + G_umplutură)",
  "struct.rzv.grinda_planseu_pe_dos": "O grindă de planșeu e încărcată de SUS și rezemată în două puncte: se lasă la mijloc, deci întinde fibra de jos în câmp și fibra de sus pe reazeme. Grinda de fundare e exact pe dos — <b>încărcarea vine de jos</b>, din reacțiunea terenului, și «reazemele» sunt stâlpii, care trag în jos. Convenția de semne se inversează, iar armătura de sus devine la fel de importantă ca cea de jos.",
  "struct.rzv.grinda_pat_continuu": "În plus, grinda nu are două reazeme, ci stă pe un pat continuu de resoarte: momentul își schimbă semnul de mai multe ori pe lungime. De aceea nu are sens «momentul de capăt» — se raportează <b>înfășurătoarea</b>: cel mai mare M pozitiv, cel mai mare M negativ și cea mai mare tăietoare, oriunde ar apărea ele pe ax și în oricare combinație.",
  "struct.rzv.grinda_a_treia_diferenta": "A treia diferență: la grinzile de fundare se urmărește <i>evitarea</i> deformațiilor plastice la cutremur (NP 112 §II.7.5.2) — infrastructura trebuie să rămână elastică, articulațiile plastice se dirijează în suprastructură. De aceea armătura minimă e mai severă decât la o grindă obișnuită, iar în model rigiditatea lor e luată NEfisurată.",
  "struct.rzv.sursa_distanta_centre": "documentul de metodă cere «distanța dintre centrele de greutate ale carcaselor», nu H_c − c ca la o secțiune obișnuită — simplificare asumată, acoperitoare",
  "struct.rzv.sursa_pasul_12_grinzi": "Pasul 12 — tabelul grinzilor de fundare",
  "struct.rzv.validare_o_minim_14": "Ø minim <b>14 mm</b> (NP 112 §II.7.5.2)",
  "struct.rzv.formula_rho_min": "ρ_min = max(0,50·f_ctm/f_yk ; 0,002) la grinzi calculate seismic\n(0,26·f_ctm/f_yk la cele nesolicitate de seism)",
  "struct.rzv.formula_v_rd_c": "V_Rd,c = 0,12·k·(100·ρ_l·f_ck)^⅓ · b · d,  minim 0,035·k^1,5·√f_ck · b·d",
  "struct.rzv.formula_etrieri": "necesari dacă V > V_Rd,c;  ρ_w ≥ max(0,001 ; 0,08·√f_ck/f_yk)",
  "struct.rzv.th_as_jos": "A_s jos [cm²]",
  "struct.rzv.th_as_sus": "A_s sus [cm²]",
  "struct.rzv.th_as_min": "A_s min",
  "struct.rzv.th_etrieri": "Etrieri",
  "struct.rzv.grinda_talpa": " · talpă {v} m",
  "struct.rzv.etrieri_necesari_rho": "necesari (ρ_w ≥ {v}%)",
  "struct.rzv.nu": "nu",
  "struct.rzv.consola_detaliu": "L_c = {lc} m · M = {m} kNm/m · A_s = {as} cm²/m",
  "struct.rzv.consola_panta": "panta: h_t = {h} m",
  "struct.rzv.armaturi_laterale": "{sus} · armături laterale minim Ø10/300 mm · etrieri Ø ≥ {phi} mm{dubli} · {referinta}",
  "struct.rzv.etrieri_dubli": ", dubli (b ≥ 400 mm)",
  "struct.rzv.rigiditatea_li": "<b>rigiditatea e NEfisurată</b> (1,0·EI, față de 0,5·EI la grinzi și 0,7·EI la stâlpi): în suprastructură contăm pe fisurare și plastificare ca să disipeze energia, în infrastructură vrem exact opusul;",
  "struct.rzv.sectiunea_li": "<b>secțiunea e dreptunghiulară</b> B×H_c, fără talpă activă de placă — nu există placă deasupra fundației;",
  "struct.rzv.resoarte_intinse2": "Resoarte întinse (talpă desprinsă)",
  "struct.rzv.resoarte_sub": "maxim la {comb} · {n} resoarte în model",
  "struct.rzv.noduri_baza_axe2": "Noduri de bază pe axe",
  "struct.rzv.noduri_sub": "noduri pe intersecții de axe (își împart încărcarea între tălpi) · {n} în afara oricărui ax",
  "struct.rzv.v_presiune_ax": "presiunea pe ax",
  "struct.rzv.v_lunecarea": "lunecarea",
  "struct.rzv.v_subpresiunea": "subpresiunea",
  "struct.rzv.bucla_locala_nu_rulat": "Bucla locală nu a rulat ({motiv}).",
  "struct.rzv.cand_verificare_nu_trece": "Când o verificare nu trece, ai două feluri de a răspunde: schimbi fundația, sau schimbi clădirea. A doua e scumpă — mută stâlpi, îngroașă grinzi, reface tot lanțul de calcul. Bucla de aici încearcă întâi tot ce se poate rezolva <b>doar din fundație</b>, la încărcări neschimbate: talpă mai lată, cotă mai jos, grindă mai înaltă, porțiuni adăugate unde lipsesc.",
  "struct.rzv.motivul_refoloseste": "Motivul pentru care are voie să refolosească reacțiunile: o clădire nu «simte» 10 cm de beton în plus sub ea — eforturile din suprastructură practic nu se schimbă. Ce se schimbă e <i>rigiditatea patului de resoarte</i>, iar asta se confirmă la reluarea lanțului în Pasul 19.",
  "struct.rzv.alege_la_fiecare_pas": "<b>Cum alege</b>: la fiecare pas calculează, pentru fiecare acțiune posibilă, cât costă și cât apropie de trecere — apoi ia acțiunea cu cel mai bun <b>raport lei / unitate de depășire rezolvată</b>. Nu cea mai ieftină: coborârea cu 10 cm e mereu ieftină, dar dacă nu mișcă nimic e bani aruncați. Coloana «alternative» arată exact ce a respins și cu ce preț.",
  "struct.rzv.cand_opreste_totul_trece": "<b>Când se oprește</b>: când totul trece {rezerva}, sau când cea mai bună acțiune rămasă costă mai mult decât pragul de eficiență ({prag} per unitate) fără să rezolve nimic. De acolo încolo, răspunsul nu mai e în fundație.",
  "struct.rzv.cu_cel_putin_rezerva": "cu cel puțin <b>{n} % rezervă</b>",
  "struct.rzv.exact_pe_prag": "(exact pe prag)",
  "struct.rzv.de_ce_rezerva": "<b>De ce o rezervă și nu exact pragul</b>: bucla nu re-rulează modelul, deci lucrează pe reacțiunile lanțului curent. Dacă s-ar opri exact pe prag, geometria ar rămâne cu <i>zero rezervă</i> — iar la reluarea lanțului reacțiunile se schimbă cu ~1 % și verificările de la limită trec înapoi peste prag. Lanțul ar cicla în jurul limitei de admisibilitate în loc să convergă. Ținta de {n} % absoarbe exact perturbația aceea; <b>verdictul afișat rămâne cel normativ</b> (rezerva e o țintă de proiectare, nu un prag de normă).",
  "struct.rzv.rezultat": "Rezultat",
  "struct.rzv.picate_in_pasi": "verificări picate, în {n} pași · oprire: {oprire}",
  "struct.rzv.cost_beton_armat_simplu": "beton armat {armat} · beton simplu {simplu} · ",
  "struct.rzv.de_la_cost": "de la {v}",
  "struct.rzv.crestere_pct": " ({v} %)",
  "struct.rzv.eur_pe_ml": " · {e} €/ml pe {l} m",
  "struct.rzv.geometria_de_la": "de la B {b} · D_f {df} m — acestea sunt <b>variabilele căutate</b>",
  "struct.rzv.axe_latite_local": " · {n} axe lățite local",
  "struct.rzv.h_derivat": "H = {h} m (de la {h0} m) e <b>derivat</b>: la reacțiuni date nu schimbă presiunea, deci nu se caută — rezultă din detaliul de execuție și din D_f",
  "struct.rzv.h_talpa_miscata": " · h_talpă = {v} m (mișcată de F4, la străpungere)",
  "struct.rzv.latimi_lista": "{lista} — restul rămân la {b} m. Lățirea locală e mult mai ieftină decât cea globală: se pune beton doar unde chiar e nevoie.",
  "struct.rzv.ax_egal_m": "{ax} = {b} m",
  "struct.rzv.f1_validare": "ținta: presiunea pe ax și sub stâlpi. Cea mai țintită acțiune — beton doar unde e nevoie",
  "struct.rzv.f2_validare": "mai scumpă ca F1, dar o talpă uniformă e mai simplu de trasat și de turnat pe șantier",
  "struct.rzv.f3_validare": "ajută la presiune, tasare, ridicare și lunecare. Ieftină la început, dar costul săpăturii crește progresiv cu adâncimea (taluzare, apoi sprijiniri)",
  "struct.rzv.f4_formula": "H_c += 10 cm, plafonat la D_f − 5 cm",
  "struct.rzv.f4_validare": "singura acțiune care rezolvă străpungerea și tăietoarea — nici lățirea, nici coborârea nu le ating",
  "struct.rzv.f5_validare": "adaugă suprafață de rezemare exact unde lipsește și leagă tronsoanele între ele",
  "struct.rzv.f6_validare": "nu coboară sub lățimea minimă de execuție (cupa excavatorului)",
  "struct.rzv.f7_nume": "F7 — ridicarea cotei de fundare",
  "struct.rzv.f7_validare": "nu e gratuită: cu D_f mai mic scade presiunea convențională (corecția C_D, NP 112 anexa D) și scade lestul de pământ de deasupra tălpii, deci pică mai repede presiunea, ridicarea și lunecarea. Planșee: adâncimea minimă a Pasului 6 (îngheț / minim legal) și D_f ≥ H_c + 5 cm, ca grinda de fundare să încapă în săpătură. La fiecare pas se alege între F6 și F7 cea care economisește mai mult",
  "struct.rzv.n_cazuri#n": "1 caz|{n} cazuri|{n} de cazuri",

  // --- STRUCTURĂ · ghidul regimurilor structurale ------------------------
  "struct.reg.gravitational": "Gravitațional",
  "struct.reg.meta_constructiv": "Constructiv",
  "struct.reg.meta_forfecare": "Forfecare",
  "struct.reg.meta_drift": "Drift",
  "struct.reg.range_constructiv": "tipic P … P+3",
  "struct.reg.range_gravitational": "tipic P+4 … P+6",
  "struct.reg.range_forfecare": "tipic P+6 … P+10",
  "struct.reg.range_drift": "tipic P+8 și peste",
  "struct.reg.ghid_eyebrow": "Ghid de implementare · proiectare structurală automatizată",
  "struct.reg.patru_regimuri_titlu": "Patru regimuri, patru strategii",
  "struct.reg.punctul_de_plecare": "Punctul de plecare",
  "struct.reg.de_ce_patru_regimuri": "De ce patru regimuri",
  "struct.reg.cladire_nu_limitata": "O clădire nu e limitată de «seism» în general. E limitată de <i>un singur lucru</i> la un moment dat, iar acel lucru se schimbă cu înălțimea. Un algoritm care nu știe care e constrângerea activă va cheltui efort de calcul și material în direcția greșită.",
  "struct.reg.formule_rho": "rho_grav   = 0,5 · n · g_grav / (nu_t · f_cd)          limita de încărcare axială\nrho_forf   = V / (A · v_Rd)                            capacitate la forța tăietoare\nrho_drift  = 12 · I_req / (A · l_typ²)                 rigiditate laterală\nrho_constr = 0,5 · (A / pas²) · A_elem / A             minime din arhitectură\n\nguvernează = argmax(rho_grav, rho_forf, rho_drift, rho_constr)",
  "struct.reg.tranzitie_doua": "{a} ({pa}%) și {b} ({pb}%) sunt la sub 15% una de alta — verifică ambele scenarii înainte să fixezi strategia.",
  "struct.reg.context_normativ": "Context normativ",
  "struct.reg.documentul_se_refera": "Documentul se referă la <b>P 100-1/2013</b> (modificat prin Ordinul 2956/2019), <b>CR 2-1-1.1/2013</b> pentru pereți, <b>NP 007-2025</b> pentru cadre și <b>CR 6-2013</b> pentru zidărie, în paralel cu <b>SR EN 1998-1</b>. Toate valorile numerice de mai jos trebuie citite direct din tabelele codurilor înainte de a fi puse în cod — aici sunt date ca ordin de mărime și ca structură de calcul.",
  "struct.reg.sageata_guverneaza": " ← guvernează",
  "struct.reg.pe_acest_proiect_guverneaza": "Pe acest proiect guvernează",
  "struct.reg.sectiunea_deschisa_jos": "— secțiunea lui e deschisă mai jos; celelalte trei se pot consulta din butoanele de mai sus.",
  "struct.reg.regim_nr_range": "Regim {nr} · {range}",
  "struct.reg.p100_2025_titlu": "P 100-1/2025 — revizuirea codului seismic",
  "struct.reg.nu_codifica_valorile": "Nu codifica valorile normative în logică. Ține spectrul, factorii de comportare, limitele de <code>nu_d</code> și limitele de drift într-un strat de date versionat, selectabil pe ediție de cod. O creștere a acțiunii seismice de ordinul celei discutate ar muta pragurile între regimuri cu unul până la două niveluri — clasificatorul rămâne valid, pragurile trebuie recalibrate. Verifică starea la zi a P 100-1/2025 înainte de a-l implementa.",
  "struct.reg.rezumat": "Rezumat",
  "struct.reg.tabelul_de_decizie": "Tabelul de decizie",
  "struct.reg.th_regim": "Regim",
  "struct.reg.rand_constructiv_structura": "cadru cu stâlpi ascunși în pereți; zidărie confinată la case",
  "struct.reg.rand_constructiv_parghie": "elimină noduri cât timp grinda încape peste ușă",
  "struct.reg.rand_constructiv_nu": "să cauți o topologie optimă — nu există una",
  "struct.reg.rand_grav_structura": "cadru, sau cadru cu nucleu la plan deschis",
  "struct.reg.rand_grav_parghie": "mai mulți stâlpi, sau clasă de beton mai mare",
  "struct.reg.rand_forf_parghie": "clasă de beton; distribuție pe mai multe elemente",
  "struct.reg.rand_drift_structura": "pereți, sau nucleu cu cadre dacă planul trebuie liber",
  "struct.reg.rand_drift_parghie": "lungește înainte să îngroși; împinge spre perimetru",
  "struct.reg.rand_drift_nu": "să mizezi pe flexibilizare — nu funcționează la <code>T_C</code> mare",
  "struct.reg.trei_constante_titlu": "Trei constante de calibrat înainte de a avea încredere în rezultat",
  "struct.reg.constanta_ltyp": "<code>l_typ</code> — lungimea tipică de perete continuu disponibilă în arhitectură. Intră la pătrat în <code>rho_drift</code>, deci o eroare de 30% dă 70% eroare în verdict.",
  "struct.reg.constanta_vrd": "<code>v_Rd</code> — efortul unitar de forfecare țintă. Calibrează-l pe proiecte reale, nu pe manual.",
  "struct.reg.constanta_concentrare": "factorul de concentrare a driftului la vârf — circa 1,6 la consolă pură, 1,2 la sistem dual, 1,0 la cadru.",
  "struct.reg.surse": "Surse",
  "struct.reg.ref_p100": "P 100-1/2013, Cod de proiectare seismică — Partea I, cu modificările aduse prin Ordinul 2956/2019.",
  "struct.reg.ref_cr2": "CR 2-1-1.1/2013, Cod de proiectare a construcțiilor cu pereți structurali de beton armat.",
  "struct.reg.ref_np007": "NP 007-2025, Cod de proiectare pentru structuri în cadre din beton armat, Monitorul Oficial nr. 630 bis / 4 iulie 2025.",
  "struct.reg.ref_comentarii_cap5": "Comentarii privind capitolul 5 din P 100-1/2013 (tabelul 5.1, valori <code>alpha_u/alpha_1</code>, factorul <code>k_w</code>).",
  "struct.reg.ref_limite_nu": "Limitele de forță axială normalizată în EN 1998-1 pentru pereți ductili și stâlpi.",
  "struct.reg.ref_zonare": "Zonarea seismică a României și valorile perioadei de colț; impactul revizuirii Eurocode 8 asupra spectrelor de proiectare.",
  "struct.reg.ref_zhang": "Zhang, Y., Mueller, C. — Shear wall layout optimization for conceptual design of tall buildings, <i>Engineering Structures</i> 140 (2017) 225–240.",
  "struct.reg.ref_doua_etape": "Optimizare în două etape, topologie apoi dimensionare, pentru structuri înalte de beton armat.",
  "struct.reg.ref_tabu": "Optimizarea dispunerii pereților prin căutare tabu, cuplată cu software de analiză structurală.",
  "struct.reg.ref_bim": "Optimizarea dispunerii pereților pornind de la modele BIM, cu algoritm genetic.",
  "struct.reg.ref_aicps": "Punctul de vedere al AICPS asupra proiectului P 100-1/2025.",
  "struct.reg.ref_oar": "Poziția Ordinului Arhitecților din România asupra proiectului P 100-1/2025.",
  "struct.reg.cererea_cubul": "Cererea de rigiditate crește cu <i>cubul</i> numărului de niveluri, pentru că forța crește liniar cu masa, brațul de pârghie crește cu înălțimea, iar deplasarea admisă crește tot cu înălțimea. La două niveluri, produsul e mic. Ce rămân sunt trei condiții care nu țin de cutremur:",
  "struct.reg.efectul_de_cutie": "Efectul de cutie.",
  "struct.reg.ce_spune_normativul": "Ce spune normativul",
  "struct.reg.th_subiect": "Subiect",
  "struct.reg.densitate_minima_p": "CR 6-2013 + tabelele din P 100-1/2013 impun o <b>densitate minimă de pereți</b> <code>p%</code> pe fiecare direcție, în funcție de accelerație și număr de niveluri",
  "struct.reg.en1996_mai_putin": "EN 1996 + EN 1998-1 cap. 9; reguli mai puțin detaliate, multe lăsate în anexa națională",
  "struct.reg.valoare_tipica_p": "Valoare tipică <code>p%</code>",
  "struct.reg.raport_goluri_plinuri": "raport limitat între lungimea golurilor și a plinurilor, diferențiat pereți interiori / exteriori",
  "struct.reg.reguli_geometrice_minime": "reguli geometrice minime pentru pereți de zidărie",
  "struct.reg.cadre_de_beton": "Cadre de beton",
  "struct.reg.np007_impreuna": "NP 007-2025 (nou din iulie 2025), împreună cu P 100-1",
  "struct.reg.densitatea_de_patru_ori": "pentru zidărie confinată la a_g = 0,30g este de aproape patru ori cât ai la un bloc P+10 din beton. Nu e o inconsecvență: zidăria are rezistența la forfecare de un ordin de mărime sub beton, deci compensezi prin arie.",
  "struct.reg.algoritm_constructiv": "INTRĂRI   graful pereților de arhitectură, persistent pe toate nivelurile\n          înălțimea liberă, înălțimea golului de ușă\nIEȘIRI    lista de elemente (poziție, formă I/L/T/+, dimensiuni), lista de grinzi\n\n1. noduri = intersecții + colțuri + capete libere + schimbări de direcție\n2. comasează nodurile mai apropiate de 1,5 m\n3. forma elementului = f(numărul de direcții care intră în nod)\n4. lungimea fiecărei aripi = max(2·grosime, cerința din ierarhizarea capacității)\n5. grinzi pe fiecare latură a grafului;  h_grinda = max(L/12, minim)\n6. VERIFICĂRI care chiar pot pica:\n     - stâlpi scurți (goluri parțiale care leagă stâlpul pe o parte din înălțime)\n     - regularitate în plan (planurile de casă sunt aproape mereu neregulate)\n     - efect de cutie: distanța între pereții transversali",
  "struct.reg.optimizarea_eliminare": "Optimizarea înseamnă eliminare, nu dimensionare",
  "struct.reg.nu_exista_spatiu_cautare": "Nu există un spațiu de căutare interesant pentru poziții: pozițiile sunt date de arhitectură. Singura variabilă reală e <i>câte noduri poți elimina</i>. Fiecare eliminare lungește o grindă; te oprești când grinda nu mai încape peste ușă.",
  "struct.reg.problema_pruning": "cu o constrângere geometrică, nu una de alocare de rigiditate. Se rezolvă lacom, în câteva milisecunde, și converge la aceeași soluție indiferent de ordinea de start dacă sortezi corect.",
  "struct.reg.hol": "hol",
  "struct.reg.densitatea_de_6": "Densitatea de <b>6% pe direcție</b> pentru zidărie confinată la a_g = 0,30g este de aproape patru ori cât ai la un bloc P+10 din beton. Nu e o inconsecvență: zidăria are rezistența la forfecare de un ordin de mărime sub beton, deci compensezi prin arie.",
  "struct.reg.problema_de_pruning": "E o problemă de <b>pruning pe graf</b> cu o constrângere geometrică, nu una de alocare de rigiditate. Se rezolvă lacom, în câteva milisecunde, și converge la aceeași soluție indiferent de ordinea de start dacă sortezi corect.",
  "struct.reg.formula_nud": "nu_d = N_Ed / (A_c · f_cd)        N_Ed  forța axială în gruparea seismică\n                                  A_c   aria secțiunii de beton\n                                  f_cd  rezistența de calcul a betonului",
  "struct.reg.fractiune_adimensionala": "E o fracțiune adimensională: cât de aproape e secțiunea de zdrobire, doar din greutate. Nu e o limită de rezistență — secțiunea nu cedează la <code>nu_d = 0,7</code>. E o limită de <b>capacitate de rotire</b>. Zona comprimată a secțiunii crește proporțional cu <code>nu_d</code>, iar curbura pe care secțiunea o poate atinge înainte să se sfărâme betonul scade invers proporțional cu adâncimea acelei zone. Un element prea comprimat se rupe fragil în loc să se îndoaie.",
  "struct.reg.svg_suprafata_aferenta": "suprafață aferentă × niveluri  →  forță axială  →  secțiune minimă",
  "struct.reg.svg_de_niveluri": "de niveluri",
  "struct.reg.figcap_aria_aferenta": "Aria aferentă rămâne aceeași; ce se schimbă e câte planșee se adună deasupra. Ca să ții <code>nu_d</code> constant, aria de beton trebuie să crească în același ritm.",
  "struct.reg.limitele_nud_coincid": "Limitele de <code>nu_d</code> sunt printre puținele valori unde Eurocode și practica românească coincid substanțial, pentru că P 100-1/2013 a fost armonizat explicit cu EN 1998-1 în această zonă.",
  "struct.reg.th_element": "Element",
  "struct.reg.perete_ductil": "Perete ductil",
  "struct.reg.discontinuitate_titlu": "Discontinuitate de implementat corect",
  "struct.reg.element_devine_perete": "Un element devine «perete» când raportul dintre latura lungă și cea scurtă depășește <b>4</b>. În acel punct limita de <code>nu_d</code> se strânge de la 0,55 la 0,35 — cu 36%. Un element de 30×115 e stâlp; 30×125 e perete și poate deveni infezabil fără să fi câștigat aproape nimic în capacitate. Nu trata pragul ca pe o lege fizică: <b>pune discontinuitatea în funcția de cost și lasă optimizatorul să o evite unde chiar strânge.</b>",
  "struct.reg.diferenta_reala_eurocode": "Diferența reală față de Eurocode nu e în limită, ci în <i>forța pe care o pui la numărător</i>: se ia din gruparea seismică, nu din gruparea fundamentală de încărcări verticale, și se caută situația cea mai defavorabilă pentru că seismul își schimbă semnul.",
  "struct.reg.de_implementat": "De implementat",
  "struct.reg.algoritm_gravitational": "INTRĂRI   suprafețe aferente per element, număr de niveluri, clasa de beton,\n          clasa de ductilitate aleasă\nIEȘIRI    secțiunea minimă admisibilă pentru fiecare element\n\nnu_tinta = 0,35   # nu limita! lasă marjă pentru cererea seismică\nA_min    = N_Ed / (nu_tinta · f_cd)\n\n# alegerea formei contează mai puțin decât aria: preferă pătrat\nb = h = ceil(sqrt(A_min), pas_catalog)\n\n# verifică UNDE se schimbă clasa elementului\nif h / b > 4: aplică limita de perete, nu de stâlp",
  "struct.reg.strategia_de_optimizare": "Strategia de optimizare",
  "struct.reg.parghia_adauga_stalp": "— adaugi un stâlp și fiecare poartă mai puțin. Costă doar cofraj suplimentar și e aproape întotdeauna mai ieftin decât să mărești secțiunile existente.",
  "struct.reg.parghia_clasa_betonului": "— <code>f_cd</code> apare la numitor, deci trecerea de la C25/30 la C35/45 reduce aria necesară cu circa 30% pentru un cost pe metru cub cu mult mai mic. Uzual la baza clădirilor înalte: clase diferențiate pe tronsoane de înălțime.",
  "struct.reg.forfecare_intro": "Elementele sunt destul de rigide, dar secțiunea totală e prea mică pentru forța orizontală care trebuie transmisă în fundație. Peretele nu se îndoaie prea mult — se fisurează diagonal. (Tipic P+6 … P+10, sau orice înălțime cu puțini pereți.)",
  "struct.reg.svg_fisuri_orizontale": "fisuri orizontale, ductil",
  "struct.reg.svg_scurt_hl": "scurt · h/l < 2",
  "struct.reg.svg_fisuri_diagonale": "fisuri diagonale, fragil",
  "struct.reg.marimea_de_control_v": "Mărimea de control e efortul unitar de forfecare, <code>v = V / (b · l)</code>. Depinde de <b>arie</b>, nu de formă. De aceea, când forfecarea guvernează, regula «puțini și lungi» nu se mai aplică: doi pereți de 3 m dau exact aceeași arie ca unul de 6 m, dar de patru ori mai puțină rigiditate — ceea ce e irelevant dacă rigiditatea nu e problema.",
  "struct.reg.forta_dimensionare_majorata": "Forța de dimensionare la forfecare nu e cea din analiză. Se majorează, ca peretele să cedeze sigur din încovoiere și nu din forfecare, ținând cont de suprarezistența reală a secțiunii de la bază și de contribuția modurilor superioare de vibrație. Poate însemna de <b>1,5 până la 3 ori</b> forța calculată. Dacă engine-ul tău dimensionează la forța din analiză, subdimensionează sistematic.",
  "struct.reg.cr2_prevederi_proprii": "CR 2-1-1.1/2013, cu prevederi proprii de calcul și alcătuire, plus anexa cu procedeu simplificat",
  "struct.reg.en1998_cap5_impreuna": "EN 1998-1 cap. 5 împreună cu EN 1992-1-1; nu există un cod separat",
  "struct.reg.kw_se_aplica": "se aplică; <code>alpha_0 = Σh_wi / Σl_wi</code>, iar <code>k_w = 1</code> dacă <code>alpha_0 ≥ 2</code>, altfel <code>k_w = (1+alpha_0)/3</code>, minim 0,5",
  "struct.reg.acelasi_mecanism_dual": "același mecanism, aplicat sistemelor cu pereți și celor duale cu pereți preponderenți",
  "struct.reg.grinzile_cuplare_30": "grinzile de cuplare trebuie să preia prin efect indirect cel puțin <b>30%</b>",
  "struct.reg.criteriu_echivalent_momente": "criteriu echivalent de reducere a momentelor la bază",
  "struct.reg.grinzi_cuplare_scurte": "Grinzi de cuplare scurte",
  "struct.reg.armare_carcase_diagonale": "armare cu carcase diagonale când raportul deschidere / înălțime e mic și forța tăietoare depășește pragul",
  "struct.reg.factorul_kw_bucla": "Factorul <code>k_w</code> e mecanismul prin care ambele coduri penalizează exact situația din acest regim: dacă ai mulți pereți scurți și groși, primești mai puțină ductilitate globală, deci un factor de comportare mai mic, deci o forță de proiectare mai mare. Este o buclă de reacție pozitivă care trebuie închisă în algoritm, nu evaluată o singură dată.",
  "struct.reg.algoritm_forfecare": "INTRĂRI   V pe fiecare direcție, lista de pereți candidați, clasa de beton\nIEȘIRI    aria totală și distribuția ei\n\n1. v_tinta = 1,5 … 2,5 MPa    (peste, armarea transversală devine dominantă)\n2. A_necesar = V_amplificat / v_tinta\n3. distribuie pe elemente de lungime MEDIE, nu maximă\n4. recalculează alpha_0 = Σh / Σl  ->  k_w  ->  q  ->  V     # buclă!\n5. repetă până q se stabilizează (tipic 2-3 iterații)",
  "struct.reg.transferul_in_perete": "Forța colectată de planșeu intră în perete pe lungimea lui: <code>V_perete / (l_w · h_placa)</code> trebuie să rămână sub capacitatea interfeței. Cu puțini pereți lungi, acest efort crește rapid și obligă la colectori sau la îngroșarea locală a plăcii.",
  "struct.reg.drift_intro": "Clădirea are destulă rezistență, dar se îndoaie prea mult. Elementele nu cedează; se degradează tot ce e prins de ele — tâmplărie, compartimentări, fațadă, instalații — și efectele de ordinul doi devin semnificative. (Tipic P+8 și peste; dominant în București.)",
  "struct.reg.factor": "Factor",
  "struct.reg.se_verifica_drift": "Se verifică <b>deplasarea relativă de nivel</b>: cât se deplasează un planșeu față de cel de sub el. Nu deplasarea totală la vârf. Un turn care se înclină rigid ca un catarg nu strică nimic; o clădire în care fiecare etaj alunecă față de următorul rupe toți pereții de compartimentare.",
  "struct.reg.cele_doua_verificari_pre": "SLS   d_r = nu · q · d_re  ≤  limita        nu = 0,5\n      cutremur frecvent, protecția componentelor nestructurale\n\nULS   d_r = c · q · d_re   ≤  0,025 · h\n      cutremur de proiectare, evitarea prăbușirii",
  "struct.reg.dre_deplasarea": "<code>d_re</code> e deplasarea din calculul elastic cu spectrul redus; înmulțirea cu <code>q</code> reface deplasarea reală. Factorul <code>c</code> din verificarea la ULS este o particularitate a ediției 2013: ține cont nu doar de perioada structurii și de perioada de colț, ci și de factorul de comportare folosit la proiectare.",
  "struct.reg.formula_ireq": "I_req = 11 · V · H³ / (60 · E_c · k_fis · D_top)      consolă cu încărcare triunghiulară\n                                                      k_fis ≈ 0,5 pentru secțiune fisurată\nrho_drift = 12 · I_req / (A · l_typ²)",
  "struct.reg.cererea_n3_oferta_l3": "Din această relație rezultă un lucru care conduce toată optimizarea: cererea crește cu <code>n³</code>, iar oferta crește cu <code>l³</code>.",
  "struct.reg.svg_dublare_beton": "fiecare dublare a numărului de pereți costă cu circa 59% mai mult beton",
  "struct.reg.figcap_eficienta_patratic": "Rigiditatea unui perete crește cu <code>l³</code>, costul doar cu <code>l</code>, deci raportul beneficiu / cost merge cu <code>l²</code>. Din același calcul rezultă că lungirea este exact de <b>trei ori</b> mai eficientă decât îngroșarea.",
  "struct.reg.perioada_de_colt": "Perioada de colț <code>T_C</code>",
  "struct.reg.trei_valori_teritoriu": "trei valori pe teritoriu: <b>0,7 / 1,0 / 1,6 s</b>",
  "struct.reg.uzual_04_08": "uzual 0,4 – 0,8 s în funcție de tipul de teren",
  "struct.reg.palierul_pana_16": "palierul de accelerație maximă se întinde până la 1,6 s, deci",
  "struct.reg.structurile_flexibile_aluneca": "structurile flexibile alunecă pe ramura descendentă și atrag forță mai mică",
  "struct.reg.bucuresti_ag_030": "București a_g = 0,30g, interval mediu de recurență 225 ani",
  "struct.reg.parametru_national_475": "parametru național, uzual raportat la 475 ani",
  "struct.reg.in_restul_europei": "În restul Europei există o strategie legitimă: faci structura mai flexibilă, perioada crește, forța seismică scade.",
  "struct.reg.valorile_alpha": "Valorile <code>alpha_u/alpha_1</code> pot fi luate din tabel pentru cazurile obișnuite: pentru cadre, 1,15 la un nivel, 1,25 la mai multe niveluri cu o singură deschidere, 1,35 la mai multe deschideri; pentru sisteme cu pereți, 1,00 cu doar doi pereți pe direcție, 1,15 cu mai mulți, 1,25 la pereți cuplați și la structuri duale cu pereți preponderenți.",
  "struct.reg.algoritm_drift": "INTRĂRI   V, H, A, l_typ, clasa de beton, limita de drift\nIEȘIRI    I_req, alocarea pe poziții, n rezultat\n\n1. I_req din formula de consolă, pe FIECARE direcție complet\n   (nu se împarte între X și Y — fiecare direcție preia forța întreagă)\n2. scade contribuția elementelor gratuite: nuclee, calcane, pereți de subsol\n   -> tipic 30-60 % din buget e deja acoperit\n3. sortează candidații după scorul de eficiență\n       scor = l_max² · (1 + (d/l_s)²)         d = brațul față de centrul de masă\n4. umple lacom, fiecare candidat cu lungimea sa MAXIMĂ\n5. n = câți au intrat.  n NU e o intrare a algoritmului.\n6. constrângeri care forțează n mai mare:\n       cota maximă de forță tăietoare a unui element  ≤ 0,35\n       transfer prin diafragmă în perete               ≤ capacitatea interfeței\n       smulgere la fundație                            ≤ capacitatea radierului",
  "struct.reg.metoda_ground_structure": "Metoda structurii de bază (ground structure)",
  "struct.reg.amprenta_discretizata": "Amprenta clădirii se discretizează într-o rețea de patrulatere; fiecare muchie a rețelei devine un perete potențial, activat sau nu. Topologia întregii structuri se codifică atunci ca un <b>șir binar</b>, ceea ce transformă o problemă geometrică continuă într-una combinatorială discretă.",
  "struct.reg.svg_1_perete_activat": "1 = perete activat",
  "struct.reg.svg_toate_constrangerile": "toate constrângerile (drift, torsiune,",
  "struct.reg.marimea_de_control_nud": "Mărimea de control se numește",
  "struct.reg.constrangerile_par_neliniare": "Constrângerile de excentricitate și de torsiune par neliniare, pentru că depind de centrul de rigiditate, care depinde la rândul lui de soluție. Dacă însă iei momentele față de <b>centrul de masă</b>, care e cunoscut dinainte, ele devin liniare în variabilele binare:",
  "struct.reg.arhitectura_pipeline": "generare candidați   din arhitectură + trama de la subsol      (o dată)\n   ↓\noptimizare discretă  MILP / CP-SAT pe constrângerile liniare   (secunde)\n   ↓\nmodel surogat        diafragme rigide, 3 GLD pe nivel          (milisecunde)\n   ↓  tăietură dacă pică o constrângere neliniară\nelemente finite      doar pe cele mai bune N soluții           (minute)\n   ↓\narmare și detaliere",
  "struct.reg.limiteaza_fapt_cladire": "Ce limitează de fapt o clădire, cum arată soluția în fiecare caz, ce diferă între normativul românesc și Eurocode, și ce metode de optimizare funcționează. Regimul rezultat din calculele acestui pas e evidențiat și preselectat mai jos.",
  "struct.reg.singur_lucru": "un singur lucru",
  "struct.reg.metoda_identificare_expr": "Metoda de identificare: exprimă fiecare constrângere ca aceeași mărime — aria de elemente verticale necesară, raportată la aria planșeului, pe o singură direcție — și ia maximul. Cea mai mare valoare numește regimul.",
  "struct.reg.cele_patru_marimi": "Cele patru mărimi comparabile",
  "struct.reg.daca_doua_valori": "Dacă două valori sunt la sub 15% una de alta, ești într-o zonă de tranziție: verifică ambele scenarii înainte să fixezi strategia.",
  "struct.reg.zona_tranzitie_proiect": "Zonă de tranziție pe acest proiect",
  "struct.reg.urmarit": "De urmărit",
  "struct.reg.cadrul_normativ_miscare": "Cadrul normativ e în mișcare",
  "struct.reg.doua_schimbari_afecteaza": "Două schimbări afectează direct orice engine construit pe P 100-1/2013.",
  "struct.reg.aprobat_prin_ordin": "Aprobat prin ordin în 23 iunie 2025 și publicat în Monitorul Oficial nr. 630 bis din 4 iulie 2025. Înlocuiește ediția anterioară și acoperă grinzi, stâlpi, noduri grindă-stâlp, infrastructuri și planșeele cu rol de diafragmă orizontală. Se aplică atât la clădiri noi, cât și la lucrări de intervenție pe clădiri existente care folosesc cadre de beton armat. Se folosește împreună cu P 100-1 și cu CR 0.",
  "struct.reg.aflat_proces_avizare": "Aflat în proces de avizare, ca parte din implementarea strategiei naționale de reducere a riscului seismic. Proiectul propune o creștere a acțiunii seismice de calcul. Atât Asociația Inginerilor Constructori Proiectanți de Structuri, cât și Ordinul Arhitecților din România au transmis puncte de vedere critice; AICPS citează studii prezentate la conferințele Prefbeton 2024 și AICPS 2025 potrivit cărora consumul de materiale la fundații și la elementele verticale seismo-rezistente ar crește cu 30% până la 200%, și consideră că aprobarea în acel moment ar fi inoportună.",
  "struct.reg.implicatie_arhitectura_s": "Implicație de arhitectură software",
  "struct.reg.structura_tipica": "Structura tipică",
  "struct.reg.parghia_functioneaza": "Pârghia care funcționează",
  "struct.reg.sa_faci": "Ce să NU faci",
  "struct.reg.cazul_tau": "cazul tău",
  "struct.reg.sa_lungesti_sectiunile": "să lungești secțiunile",
  "struct.reg.nucleu_plus_pereti": "nucleu plus pereți de lungime medie",
  "struct.reg.sa_concentrezi_putini": "să concentrezi în puțini pereți lungi",
  "struct.reg.testul_validare_ruleaza": "Testul de validare: rulează clasificatorul pe cinci până la zece proiecte deja executate și verifică dacă verdictul lui corespunde cu ce a dimensionat efectiv proiectantul. Dacă nu corespunde, problema e în calibrare, nu în structura algoritmului.",
  "struct.reg.referinte": "Referințe",
  "struct.reg.sr_en_1998": "SR EN 1998-1 / EN 1998-1:2004, Eurocode 8, cap. 5 — reguli specifice clădirilor de beton.",
  "struct.reg.comparatie_a_factorilor": "Comparație a factorilor de comportare între P 100-1 și SR EN 1998-1 pentru structuri cu pereți de beton armat.",
  "struct.reg.densitatea_minima_pereti": "Densitatea minimă de pereți pentru zidărie confinată, conform tabelelor din P 100-1/2013 și CR 6-2013.",
  "struct.reg.document_lucru_echipa": "Document de lucru pentru echipa de dezvoltare. Valorile numerice sunt date ca ordin de mărime și ca structură de calcul; înainte de implementare se citesc direct din ediția în vigoare a fiecărui cod. Nu înlocuiește verificarea de către un inginer proiectant de structuri.",
  "struct.reg.guverneaza_proiect": "guvernează pe acest proiect",
  "struct.reg.guverneaza_aici": "nu guvernează aici",
  "struct.reg.nimic_seismic_strange": "Nimic seismic nu strânge. Cerința de rigiditate calculată iese de zeci de ori sub ce rezultă oricum din minimele de alcătuire. Structura e dictată integral de geometria arhitecturii.",
  "struct.reg.intampla_fizic": "Ce se întâmplă fizic",
  "struct.reg.rezemarea_planseului": "Rezemarea planșeului.",
  "struct.reg.fara_grinzi_vizibile": "Fără grinzi vizibile, placa trebuie să găsească un reazem la fiecare 4–5 m.",
  "struct.reg.ierarhizarea_capacitatii": "Ierarhizarea capacității în noduri.",
  "struct.reg.grinda_trebuie_sa": "Grinda trebuie să cedeze înaintea stâlpului. Cu grinzi de 25×50 care intră într-un nod, un stâlp de 30×30 nu poate atinge capacitatea cerută.",
  "struct.reg.peretii_lungi_trebuie": "Pereții lungi trebuie sprijiniți transversal, altfel se încovoaie în afara planului.",
  "struct.reg.arata_structura": "Cum arată structura",
  "struct.reg.camera": "cameră",
  "struct.reg.colt_l": "colț: L",
  "struct.reg.capat_dreptunghi": "capăt: dreptunghi",
  "struct.reg.intersectie_t": "intersecție: T sau +",
  "struct.reg.elementele_urmeaza_nodur": "Elementele urmează nodurile arhitecturii.",
  "struct.reg.grosimea_fiecarui_elemen": "Grosimea fiecărui element = grosimea peretelui în care stă, deci nimic nu iese în cameră. Forma vine din câte direcții se întâlnesc în nod.",
  "struct.reg.aici_cele_doua": "Aici cele două sisteme normative se despart cel mai clar, pentru că România are un cod prescriptiv dedicat clădirilor joase de zidărie, iar Eurocode nu are un echivalent la fel de detaliat.",
  "struct.reg.romania": "România",
  "struct.reg.zidarie_confinata": "Zidărie confinată",
  "struct.reg.densitate_minima_pereti": "densitate minimă de pereți",
  "struct.reg.6_0_directie": "6,0% / direcție (P+2, a_g = 0,30g)",
  "struct.reg.parametru_national": "— (parametru național)",
  "struct.reg.goluri_perete": "Goluri în perete",
  "struct.reg.6_directie": "6% pe direcție",
  "struct.reg.cate_noduri_poti": "câte noduri poți să scoți",
  "struct.reg.pruning_graf": "pruning pe graf",
  "struct.reg.te_limiteaza_greutatea": "Te limitează greutatea proprie a clădirii, nu cutremurul. Secțiunile trebuie să fie destul de mari încât betonul să nu fie prea comprimat înainte să înceapă seismul.",
  "struct.reg.forta_axiala_normalizata": "forța axială normalizată",
  "struct.reg.aceeasi_suprafata": "aceeași suprafață",
  "struct.reg.aferenta_alt_numar": "aferentă, alt număr",
  "struct.reg.sectiunea_creste_liniar": "Secțiunea crește liniar cu numărul de niveluri.",
  "struct.reg.stalp": "Stâlp",
  "struct.reg.conteaza_doar_aria": "Contează doar aria, iar un element alungit costă același beton ca unul pătrat cu aceeași arie, dar consumă mai mult cofraj lateral și riscă să treacă peste pragul de clasificare de mai sus.",
  "struct.reg.perete_solicitat_lateral": "Un perete solicitat lateral poate ceda în două moduri complet diferite:",
  "struct.reg.forfecarea": "forfecarea nu",
  "struct.reg.avertizeaza_inainte": "avertizează înainte",
  "struct.reg.sa_cedeze": "să cedeze",
  "struct.reg.doua_mecanisme_doua": "Două mecanisme, două consecințe.",
  "struct.reg.cedarea_incovoiere_progr": "Cedarea din încovoiere e progresivă și absoarbe energie. Cedarea din forfecare e bruscă. Toată proiectarea seismică e organizată ca să o forțeze pe prima.",
  "struct.reg.amplificarea_fortei_taie": "Amplificarea forței tăietoare",
  "struct.reg.1_5_pana": "1,5 până la 2,5 ori",
  "struct.reg.cod_dedicat_peretilor": "Cod dedicat pereților",
  "struct.reg.pereti_scurti": "pentru pereți scurți",
  "struct.reg.definitia_peretelui_cupl": "Definiția peretelui cuplat",
  "struct.reg.momentele_baza_montantil": "din momentele de la baza montanților",
  "struct.reg.aceeasi_solutie": "aceeași soluție",
  "struct.reg.clasa_beton_inaintea": "Clasa de beton înaintea cantității.",
  "struct.reg.capacitatea_forfecare_cr": "Capacitatea la forfecare crește cu rezistența betonului; trecerea la o clasă superioară e aproape întotdeauna mai ieftină decât secțiuni mai mari, și nu consumă spațiu arhitectural.",
  "struct.reg.imparte_concentra": "Împarte, nu concentra.",
  "struct.reg.aria_aditiva_deci": "Aria e aditivă, deci nu câștigi nimic din elemente foarte lungi, dar pierzi la fundații și la diafragmă.",
  "struct.reg.verifica_transferul_pere": "Verifică transferul în perete.",
  "struct.reg.deplasarea_relativa_nive": "deplasarea relativă de nivel",
  "struct.reg.cele_doua_verificari": "Cele două verificări din P 100-1",
  "struct.reg.sursa_cererii_rigiditate": "Sursa cererii de rigiditate, în formă închisă:",
  "struct.reg.lungimea_elementelor_bat": "Lungimea elementelor bate numărul lor.",
  "struct.reg.acelasi_i_beton": "același ΣI · beton în pereți, pe nivel",
  "struct.reg.2_pereti_8": "2 pereți × 8,00 m",
  "struct.reg.4_pereti_6": "4 pereți × 6,35 m",
  "struct.reg.8_pereti_5": "8 pereți × 5,04 m",
  "struct.reg.16_pereti_4": "16 pereți × 4,00 m",
  "struct.reg.eficienta_scade_patratic": "Eficiența scade pătratic cu scurtarea peretelui.",
  "struct.reg.aici_cele_mari": "Aici sunt cele mai mari diferențe între România și Eurocode, și toate merg în aceeași direcție: seismul românesc este dominat de cutremurele intermediare din Vrancea, care produc mișcări cu conținut de perioade lungi.",
  "struct.reg.bucuresti_are_1": "; București are 1,6 s",
  "struct.reg.consecinta": "Consecința",
  "struct.reg.flexibilizarea_reduce_fo": "flexibilizarea nu reduce forța",
  "struct.reg.acceleratia_proiectare": "Accelerația de proiectare",
  "struct.reg.q_cadre_pereti": "q — cadre, pereți cuplați, duale, DCH",
  "struct.reg.aceleasi_dcm": "aceleași, DCM",
  "struct.reg.pereti_zvelti_necuplati": "Pereți zvelți necuplați, DCH",
  "struct.reg.neregularitate_verticala": "Neregularitate pe verticală",
  "struct.reg.q_reduce_20": "q se reduce cu 20%",
  "struct.reg.inseamna_algoritm": "Ce înseamnă asta pentru un algoritm",
  "struct.reg.bucuresti_aceasta_strate": "În București această strategie nu funcționează.",
  "struct.reg.structura_perioada_1": "O structură cu perioada de 1,2 s primește aceeași accelerație spectrală ca una cu 0,3 s. Plătești deplasările fără să câștigi nimic la forță. Orice euristică preluată din literatura vest-europeană trebuie verificată din acest punct de vedere.",
  "struct.reg.acesta_singurul_regim": "Acesta e singurul regim cu un spațiu de căutare bogat, și e singurul studiat sistematic în literatură. Metodele care apar constant:",
  "struct.reg.sir_binar": "șir binar",
  "struct.reg.retea_muchii_candidate": "rețea de muchii candidate",
  "struct.reg.bit_per_muchie": "un bit per muchie",
  "struct.reg.0_fara_perete": "0 = fără perete",
  "struct.reg.rezistenta_accesibilitat": "rezistență, accesibilitate) devin",
  "struct.reg.functii_vector": "funcții de acest vector",
  "struct.reg.structura_baza": "Structura de bază.",
  "struct.reg.formularea_publicata_zha": "Formularea publicată de Zhang și Mueller (2017) minimizează greutatea structurii cu constrângeri simultane pe torsiune, rezistență la încovoiere, rezistență la forfecare, drift și păstrarea golurilor și a accesului.",
  "struct.reg.foloseste_peste_structur": "Ce se folosește peste structura de bază",
  "struct.reg.rezolva_raporteaza": "Ce rezolvă și ce se raportează",
  "struct.reg.cea_raspandita_alegere": "Cea mai răspândită alegere pentru topologie. Se folosesc și variante cu încrucișare direcționată, care exploatează faptul că soluțiile bune împărtășesc trăsături.",
  "struct.reg.cautare_tabu_functie": "Căutare tabu cu funcție de penalizare",
  "struct.reg.aplicata_cod_binar": "Aplicată pe cod binar, cu driftul și raportul de perioade tratate ca penalizări în funcția de evaluare, cuplată cu software de analiză prin interfața de programare.",
  "struct.reg.doua_etape_topologie": "Două etape: topologie apoi dimensionare",
  "struct.reg.intai_algoritm_genetic": "Întâi algoritm genetic pentru topologie, apoi criterii de optimalitate pentru secțiuni. Pe un caz de clădire înaltă s-au raportat reduceri de 18–24% la cost de material și emisii.",
  "struct.reg.extragere_candidati_bim": "Extragere de candidați din BIM",
  "struct.reg.pozitiile_posibile_peret": "Pozițiile posibile de perete se extrag automat din modelul de arhitectură, apoi se rulează serii de analize prin interfața programului de calcul. Elimină pasul manual de generare a variantelor.",
  "struct.reg.modele_surogat_invatate": "Modele surogat învățate",
  "struct.reg.retele_neuronale_graf": "Rețele neuronale pe graf antrenate să prezică deplasări, drift de nivel și perioadă proprie; se raportează economii de circa 90% din timpul de calcul față de analiza cu elemente finite. Separat, rețele antrenate pe o bază de 165 de clădiri construite în Chile prezic grosimea și lungimea pereților pornind de la planurile de arhitectură.",
  "struct.reg.simplificarea_face_probl": "Simplificarea care face problema liniară",
  "struct.reg.centrul_masa": "centrul de masă",
  "struct.reg.coeficientii_constante_g": "Coeficienții sunt constante geometrice cunoscute înainte de optimizare. Toată etapa de topologie devine astfel un program liniar cu variabile întregi, rezolvabil exact — o alternativă la metaheuristici, care poate fi combinată cu ele: soluția exactă pe modelul simplificat, apoi rafinare pe modelul complet.",
  "struct.reg.arhitectura_recomandata": "Arhitectura recomandată a buclei",
  "struct.reg.ratiunea_impartirii_meta": "Rațiunea împărțirii: metaheuristicile au nevoie de mii de evaluări. Dacă fiecare evaluare înseamnă o analiză completă cu elemente finite, bucla nu se închide în timp util. Modelul surogat rupe această dependență, iar analiza completă rămâne pentru validare.",

  // --- STRUCTURĂ · Pasul 3, strategia structurii -------------------------
  "struct.strateg.decide": "Cum se decide?",
  "struct.strateg.constrangere_cere_anumit": "Fiecare constrângere cere o anumită cantitate de beton, exprimată ca fracțiune ρ din aria planșeului. Se calculează toate patru pe aceleași date; cea mai lacomă câștigă.",
  "struct.strateg.strategia_structurii_cad": "Strategia structurii (cadru / nucleu / pereți) depinde de CE te strânge: dacă driftul guvernează îți trebuie elemente lungi la margini; dacă forfecarea — suprafață totală; dacă gravitația — secțiuni mai groase; dacă nimic seismic — arhitectura decide.",
  "struct.strateg.masoara_l_typ": "Cum se măsoară l_typ?",
  "struct.strateg.iau_doar_peretii": "Se iau doar pereții persistenți pe toate nivelurile (Pasul 2), se taie la fiecare gol de ușă/fereastră (de pe orice nivel) și rămân «tronsoane libere». l_typ = media celor mai lungi 6 tronsoane pe direcția critică.",
  "struct.strateg.alocarea_elementelor_str": "Alocarea elementelor structurale va folosi exact tronsoanele lungi — de aceea media celor lungi, nu mediana tuturor (care ar subestima bugetul). Direcția cu l_typ mai mic e cea critică la drift.",
  "struct.strateg.h_inaltimea_totala": "H — înălțimea totală",
  "struct.strateg.formula_h_n": "Formula: H = n · h_et — numărul de niveluri înmulțit cu înălțimea medie de etaj.",
  "struct.strateg.h_intra_puterea": "H intră la puterea a 3-a în calculul de îndoire (o clădire de două ori mai înaltă se îndoaie de opt ori mai mult la aceeași rigiditate).",
  "struct.strateg.corectia_modul_vibratie": "λ — corecția pentru modul de vibrație",
  "struct.strateg.0_85_cladiri": "0,85 pentru clădiri cu peste 2 niveluri, altfel 1,0.",
  "struct.strateg.cladirile_inalte_toata": "La clădirile mai înalte nu toată masa se leagănă odată în primul mod de vibrație — forța efectivă e cu ~15% mai mică decât masa totală × accelerație. E aceeași corecție λ din metoda forțelor statice echivalente (P100-1 / Eurocod 8).",
  "struct.strateg.c_s_fractiune": "c_s — ce fracțiune din greutate împinge lateral",
  "struct.strateg.formula_c_s": "Formula: c_s = (a_g · β0 / q) · λ. Spune ce procent din greutatea clădirii devine forță orizontală la cutremurul de proiectare.",
  "struct.strateg.a_g_tare": "a_g e cât de tare zguduie terenul (fracțiune din accelerația gravitațională), β0 amplificarea în structură (constant 2,5 în România), iar q «iertarea» pe care ne-o permitem pentru că structura poate disipa energie deformându-se controlat. Împărțim la q pentru că proiectăm la forțe reduse, acceptând deformații.",
  "struct.strateg.v_impingerea_totala": "V — împingerea totală a cutremurului",
  "struct.strateg.formula_v_c": "Formula: V = c_s · A · n · g_seism — coeficientul seismic × toată greutatea seismică a clădirii (aria × niveluri × greutatea pe metru pătrat).",
  "struct.strateg.forta_orizontala_totala": "E forța orizontală totală pe care structura trebuie s-o ducă la bază — ca și cum cineva ar împinge clădirea lateral cu V kiloNewtoni. Toate elementele verticale, împreună, trebuie să o preia.",
  "struct.strateg.v_rd_duce": "v_Rd — cât duce un metru pătrat de beton la lunecare",
  "struct.strateg.tinta_practica_2000": "Ținta practică: 2000 kPa (2 MPa) de forță orizontală pe fiecare metru pătrat de secțiune de beton.",
  "struct.strateg.valoare_predimensionare": "E o valoare de predimensionare verificată în practică pentru pereți de beton armat — destul de prudentă cât să lase loc armării la fazele următoare.",
  "struct.strateg.d_top_are": "D_top — cât are voie vârful să se miște",
  "struct.strateg.formula_d_top": "Formula: D_top = δ_lim · H / f_conc — limita de drift pe nivel (1%) înmulțită cu înălțimea, împărțită la concentrarea driftului (1,6).",
  "struct.strateg.norma_limiteaza_poate": "Norma limitează cât se poate deplasa un etaj față de cel de sub el (driftul, 1% din înălțimea etajului), ca pereții de umplutură și finisajele să nu crape. Cum driftul nu e uniform (etajele de jos se deformează mai mult), împărțim la factorul de concentrare 1,6.",
  "struct.strateg.i_req_cata": "I_req — câtă rigiditate la îndoire trebuie",
  "struct.strateg.formula_i_req": "Formula: I_req = 11 · V · H³ / (60 · E_c · 0,5 · D_top) — săgeata unei console încărcate triunghiular (11·V·H³/60·EI), întoarsă ca să scoată I din deplasarea admisă.",
  "struct.strateg.cladirea_consola_vertica": "Clădirea e o consolă verticală împinsă de cutremur (mai tare sus, mai slab jos — de aceea distribuția triunghiulară). Din formula clasică de săgeată scoatem I necesar; 0,5 ține cont că betonul fisurat e cam jumătate din rigiditatea întreagă.",
  "struct.strateg.l_max_departe": "L_max — cât de departe pot fi elementele",
  "struct.strateg.formula_l_max": "Formula: L_max = 12 · h_grindă — o grindă de beton duce rezonabil o deschidere de circa 12 ori înălțimea ei.",
  "struct.strateg.grinzile_trebuie_sa": "Grinzile trebuie să rămână ASCUNSE în grosimea planșeului sau peste uși (arhitectului nu-i plac grinzile aparente). Înălțimea disponibilă peste uși limitează deschiderea — regula de zveltețe L/h ≈ 12 e pragul de la care săgețile și armarea devin neplăcute.",
  "struct.strateg.formula_pas_min": "Formula: pas = min(L_max; 5 m) — cel mai mic dintre limita grinzii și pasul practic de 5 m.",
  "struct.strateg.chiar_daca_grinda": "Chiar dacă grinda ar putea duce mai mult, peste ~5 m între stâlpi planșeele și fundațiile se scumpesc disproporționat — 5 m e pragul economic uzual la rezidențial.",
  "struct.strateg.n_elem_cate": "n_elem — câte elemente încap",
  "struct.strateg.formula_n_elem": "Formula: n_elem = A / pas² — aria nivelului împărțită la aria «deservită» de un element (un pătrat cu latura egală cu pasul).",
  "struct.strateg.daca_pui_elemente": "Dacă pui elemente pe o grilă cu pasul de mai sus, fiecare element deservește aproximativ pas × pas metri pătrați de planșeu.",
  "struct.strateg.a_elem_mare": "A_elem — cât de mare e un stâlp constructiv",
  "struct.strateg.formula_a_elem": "Formula: A_elem = max(0,09 m²; h_grindă²) — latura stâlpului cel puțin cât înălțimea grinzii, dar minim 30×30 cm.",
  "struct.strateg.regula_alcatuire_capacit": "Regulă de alcătuire (capacity design): armătura grinzii trebuie să se poată ancora în nodul cu stâlpul, deci stâlpul nu poate fi mai îngust decât grinda e de înaltă. 30×30 cm e minimul constructiv pentru un stâlp de beton armat.",
  "struct.strateg.clasa_ductilitate_alege": "Ce e clasa de ductilitate și cum se alege?",
  "struct.strateg.p100_1_2013": "P100-1/2013 lasă proiectantul să aleagă CÂTĂ energie disipă structura deformându-se controlat la cutremur: DCH (ductilitate înaltă — forțe de proiectare mici, detaliere severă), DCM (medie — forțe mai mari, detaliere simplă) sau DCL (joasă — proiectare practic elastică, permisă doar la seismicitate joasă).",
  "struct.strateg.alegerea_compromis_econo": "Alegerea e un compromis economic sub praguri normative: la a_g ≥ 0,30g codul recomandă explicit DCH (§5.2.1(3)); DCL e permisă numai la a_g ≤ 0,10g (§5.2.1(4)); între ele decide economia — dacă cutremurul oricum nu dimensionează secțiunile (guvernează constructiv), ductilitatea înaltă nu economisește beton, dar scumpește detalierea. Clasa aleasă intră în armare: lungimile zonelor critice l_cr, limitele νd în stâlpi, clasa oțelului.",
  "struct.strateg.bugetul_forfecare_re": "bugetul de forfecare re-scalat cu q-ul clasei (rezistența cerută ∝ 1/q)",
  "struct.strateg.driftul_scade_q": "driftul NU scade cu q (regula deplasării egale)",
  "struct.strateg.bugetul_gravitational": "Bugetul gravitațional",
  "struct.strateg.beton_iti_trebuie": "Cât beton îți trebuie doar ca să ții greutatea clădirii în picioare, fără să strivești stâlpii. Formula: ρ = 0,5 · n · g_grav / (νt · f_cd).",
  "struct.strateg.stalp_aduna_greutatea": "Fiecare stâlp adună greutatea etajelor de deasupra lui. Normele nu lasă betonul să fie apăsat la maxim (s-ar rupe casant la cutremur) — apăsarea medie e plafonată la fracțiunea νt din rezistența betonului. 0,5 apare pentru că elementele verticale poartă în medie cam jumătate din arie fiecare direcție de descărcare.",
  "struct.strateg.numarul_niveluri_deasupr": "numărul de niveluri de deasupra încastrării",
  "struct.strateg.incarcarea_gravitational": "încărcarea gravitațională de calcul pe metru pătrat (1,35·permanent + 1,5·util)",
  "struct.strateg.constanta_a_metodei": "constantă a metodei",
  "struct.strateg.apasarea_maxima_admisa": "apăsarea maximă admisă pe beton, ca fracțiune din rezistență (0,55 la cadre)",
  "struct.strateg.p100_1_presupunere": "P100-1 — presupunere inițială: cadru",
  "struct.strateg.rezistenta_calcul_a": "rezistența de calcul a betonului (fck împărțit la 1,5)",
  "struct.strateg.clasa_beton_date": "clasa de beton din Date clădire",
  "struct.strateg.beton_iti_trebuie2": "Cât beton îți trebuie ca pereții/stâlpii să nu «alunece» pe orizontală sub forța cutremurului. Formula: ρ = V / (A · v_Rd).",
  "struct.strateg.cutremurul_impinge_cladi": "Cutremurul împinge clădirea lateral cu forța V. Această forță se împarte pe toată suprafața de beton disponibilă; fiecare metru pătrat de beton duce practic v_Rd = 2000 kPa la lunecare. Împărțind forța la capacitate iese aria de beton necesară, raportată la aria planșeului.",
  "struct.strateg.forta_taietoare_baza": "forța tăietoare de bază (împingerea totală a cutremurului)",
  "struct.strateg.calculata_jos_v": "calculată mai jos: V = c_s · A · n · g_seism",
  "struct.strateg.tinta_practica_forfecare": "ținta practică de forfecare în pereți (2000 kPa)",
  "struct.strateg.documentul_metoda": "documentul de metodă",
  "struct.strateg.bugetul_drift_indoire": "Bugetul de drift (îndoire)",
  "struct.strateg.beton_iti_trebuie3": "Cât beton îți trebuie ca clădirea să nu se îndoaie lateral peste limita admisă. Formula: ρ = 12 · I_req / (A · l_typ²).",
  "struct.strateg.cladire_inalta_lucreaza": "O clădire înaltă lucrează ca o consolă verticală: se îndoaie sub împingerea cutremurului. Rigiditatea la îndoire crește cu PĂTRATUL lungimii elementelor (I = t·l³/12) — de aceea elementele lungi sunt mult mai eficiente decât cele groase, iar formula împarte inerția necesară I_req la pătratul lungimii tipice disponibile l_typ.",
  "struct.strateg.inertia_totala_necesara": "inerția totală necesară ca vârful să nu se deplaseze peste limită",
  "struct.strateg.calculata_jos_v2": "calculată mai jos din V, H și deplasarea admisă",
  "struct.strateg.lungimea_tipica_element": "lungimea tipică de element disponibilă în arhitectură",
  "struct.strateg.masurata_peretii_persist": "măsurată din pereții persistenți (Pasul 2)",
  "struct.strateg.beton_iese_sine": "Cât beton iese «de la sine» dacă pui câte un stâlp la fiecare întâlnire de pereți, la pasul practic. Formula: ρ = 0,5 · n_elem · A_elem / A.",
  "struct.strateg.chiar_daca_seismic": "Chiar dacă seismic nu te strânge nimic, tot pui elemente verticale acolo unde arhitectura le cere (colțuri, intersecții de pereți, sub grinzi). Dacă acest minim constructiv iese cel mai mare dintre bugete, înseamnă că arhitectura decide structura, nu cutremurul.",
  "struct.strateg.numarul_elemente_estimat": "numărul de elemente estimate (aria împărțită la pas²)",
  "struct.strateg.calculat_jos": "calculat mai jos",
  "struct.strateg.aria_unui_element": "aria unui element (latura ≥ înălțimea grinzii, minim 30×30 cm)",
  "struct.strateg.regula_alcatuire_armatur": "regulă de alcătuire: armătura grinzii trebuie să se ancoreze în stâlp",
  "struct.strateg.doar_circa_jumatate": "doar circa jumătate din elemente lucrează pe fiecare direcție",
  "struct.strateg.aria_beton_aria": "aria de beton / aria planșeului",
  "struct.strateg.formulele_a_d": "formulele A–D din documentul de metodă",
  "struct.strateg.lungimea_minima_a": "lungimea minimă a unui tronson structural",
  "struct.strateg.regula_practica": "regulă practică",
  "struct.strateg.cate_tronsoane_intra": "câte tronsoane intră în medie",
  "struct.strateg.documentul_metoda_n": "documentul de metodă (n_asteptat)",
  "struct.strateg.inaltimea_medie_etaj": "înălțimea medie de etaj",
  "struct.strateg.pasul_2_cotele": "Pasul 2 — cotele fațadelor",
  "struct.strateg.0_85_daca": "0,85 dacă n > 2, altfel 1,0",
  "struct.strateg.p100_1_metoda": "P100-1, metoda forțelor statice echivalente",
  "struct.strateg.acceleratia_terenului_cu": "accelerația terenului la cutremurul de proiectare",
  "struct.strateg.harta_zonare_a": "harta de zonare a localității (Pasul 1)",
  "struct.strateg.p100_1_constant": "P100-1, constant în România",
  "struct.strateg.constanta_a_metodei2": "constantă a metodei (se rafinează la analiză)",
  "struct.strateg.corectia_modala": "corecția modală",
  "struct.strateg.randul_sus": "rândul de mai sus",
  "struct.strateg.numarul_niveluri": "numărul de niveluri",
  "struct.strateg.greutatea_seismica_metru": "greutatea seismică pe metru pătrat (permanent + fracțiune din util)",
  "struct.strateg.capacitatea_practica_for": "capacitatea practică la forfecare",
  "struct.strateg.documentul_metoda_consta": "documentul de metodă (constanta pasului)",
  "struct.strateg.documentul_metoda_p100": "documentul de metodă (P100-1, SLS)",
  "struct.strateg.inaltimea_totala": "înălțimea totală",
  "struct.strateg.concentrarea_driftului_e": "concentrarea driftului la etajele de jos (1,6)",
  "struct.strateg.forta_taietoare_inaltime": "forța tăietoare și înălțimea",
  "struct.strateg.randurile_sus": "rândurile de mai sus",
  "struct.strateg.modulul_elasticitate_bet": "modulul de elasticitate al betonului",
  "struct.strateg.clasa_date_cladire": "clasa din Date clădire (EN 1992-1-1)",
  "struct.strateg.reducerea_rigiditate_bet": "reducerea de rigiditate pentru beton fisurat",
  "struct.strateg.deplasarea_admisa_varf": "deplasarea admisă la vârf",
  "struct.strateg.inaltimea_grinda_incape": "înălțimea de grindă care încape peste uși",
  "struct.strateg.raportul_practic_deschid": "raportul practic deschidere/înălțime",
  "struct.strateg.regula_predimensionare_d": "regulă de predimensionare (documentul de metodă)",
  "struct.strateg.deschiderea_maxima_grind": "deschiderea maximă cu grindă ascunsă",
  "struct.strateg.distanta_dintre_elemente": "distanța dintre elemente",
  "struct.strateg.inaltimea_grinzii": "înălțimea grinzii",
  "struct.strateg.aria_minima_30": "aria minimă (30×30 cm)",
  "struct.strateg.regula_constructiva": "regulă constructivă",
  "struct.strateg.factorul_comportare_redu": "factorul de comportare — cât se reduc forțele seismice de proiectare",
  "struct.strateg.redundanta_suprarezisten": "redundanța (suprarezistența de sistem)",
  "struct.strateg.acceleratia_proiectare_a": "accelerația de proiectare a terenului",
  "struct.strateg.pasul_ruleaza": "Pasul rulează…",
  "struct.strateg.masoara_l_typ2": "Măsoară l_typ din pereții persistenți (Pasul 2), citește datele seismice (Pasul 1) și calculează cele patru constrângeri.",
  "struct.strateg.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.strateg.constrangere": "Constrângere",
  "struct.strateg.intrarile_sursa_fiecarei": "Intrările și sursa fiecăreia",
  "struct.strateg.directie": "Direcție",
  "struct.strateg.cele_lungi": "Cele mai lungi",
  "struct.strateg.criteriile_ordinea_aplic": "Criteriile, în ordinea aplicării",
  "struct.strateg.referinta": "De ce (cu referința)",
  "struct.strateg.permisa_aici": "Permisă aici?",

  // --- STRUCTURĂ · Pasul 11, combinațiile de încărcări -------------------
  "struct.combina.1_1": "θ și α = 1/(1−θ)",
  "struct.combina.p_d_r": "θ = P·d_r/(V·h) măsoară cât de mult contează greutatea care «împinge» prin deplasarea laterală (efectul P-Δ). Dacă θ ≤ 0,1 se neglijează; între 0,1 și 0,2 eforturile seismice se amplifică cu α = 1/(1−θ).",
  "struct.combina.cladire_deplasata_latera": "O clădire deplasată lateral e împinsă suplimentar de propria greutate — moment adițional P·d_r. P100-1 permite să-l acoperi simplu, amplificând forțele seismice cu α, în loc de analiză neliniară.",
  "struct.combina.nicio_cifra_matrice": "Nicio cifră din matrice nu e aleasă de program",
  "struct.combina.coeficientii_fie_impusi": "Coeficienții sunt fie impuși de normativ (1,35 / 1,00 / 1,50 / 0,30 / ±1), fie constante ale metodei (ψ₀, ψ₂), fie calculați în acest pas din rezultatele analizei (α).",
  "struct.combina.combinatiile_impreuna_fo": "Toate combinațiile împreună formează «înfășurătoarea»: pentru fiecare secțiune se caută cea mai defavorabilă valoare din toate cele care pot apărea real, nu media lor.",
  "struct.combina.rand_combinatie_coloana": "Rând = combinație, coloană = caz de încărcare",
  "struct.combina.combinatie_lista_coefici": "Fiecare combinație e o listă de coeficienți: eforturile ei = suma cazurilor înmulțite cu coeficienții (R = C·F). Celulele goale înseamnă coeficient zero — cazul acela nu participă.",
  "struct.combina.gruparea_fundamentala_cr": "Gruparea fundamentală (CR 0-2012): 1,35·G + 1,5·Q_dominant + 1,5·ψ₀·restul. Gruparea seismică (P100-1): G + ψ₂·Q ± α·E ± α·T_acc. Trece cursorul peste capul unei coloane ca să vezi ce e cazul respectiv.",
  "struct.combina.face_grupa_combinatia": "Ce face grupa cu combinația",
  "struct.combina.fundamentala_seismica_in": "«fundamentala» și «seismica» intră în cele două înfășurătoare din care Pasul 12 scoate M/V/N de dimensionare. «gs» e ținută separat: e doar partea gravitațională a grupării seismice.",
  "struct.combina.verificarile_rezistenta": "Verificările de rezistență se fac separat pe cele două grupări, pentru că au coeficienți de material și cerințe de ductilitate diferite.",
  "struct.combina.infrastructura_grinzile": "Infrastructura: grinzile de fundare + umplutura de pământ +",
  "struct.combina.peretii_nestructurali_au": "Pereții nestructurali care au grindă sub ei",
  "struct.combina.peretii_nestructurali_fa": "Pereții nestructurali fără grindă sub ei (rezemați pe placă)",
  "struct.combina.peretii_parterului_fara": "Pereții parterului — fără placă dedesubt, direct pe grinzile de fundare",
  "struct.combina.finisajele_sapa_pardosea": "Finisajele (șapă, pardoseală, tencuieli) — SDL",
  "struct.combina.utila_a_spatii": "Utila cat. A (spații de locuit)",
  "struct.combina.utila_c_circulatii": "Utila cat. C (circulații și spații comune)",
  "struct.combina.zapada_acoperis": "Zăpada pe acoperiș",
  "struct.combina.cutremurul_directia_0": "Cutremurul pe direcția 0° (axa X)",
  "struct.combina.cutremurul_directia_45": "Cutremurul pe direcția 45°",
  "struct.combina.cutremurul_directia_90": "Cutremurul pe direcția 90° (axa Y)",
  "struct.combina.cutremurul_directia_135": "Cutremurul pe direcția 135°",
  "struct.combina.torsiunea_accidentala_cu": "Torsiunea accidentală, cutremur pe X",
  "struct.combina.torsiunea_accidentala_cu2": "Torsiunea accidentală, cutremur pe Y",
  "struct.combina.greutatea_totala_deasupr": "greutatea totală de deasupra nivelului (gruparea seismică)",
  "struct.combina.deplasarea_relativa_nive": "deplasarea relativă de nivel la SLU (c·q·d_re)",
  "struct.combina.deplasarile_cazurilor_0": "deplasările cazurilor E_0/E_90",
  "struct.combina.forta_taietoare_a": "forța tăietoare a nivelului",
  "struct.combina.permanentele_g1_g4": "toate permanentele (G1…G4) înmulțite cu 1,35 — presupui că",
  "struct.combina.cr_0_2012": "CR 0-2012 §6.3, rel. (6.7) — decizie a normativului, nu a",
  "struct.combina.aceleasi_permanente_dar": "aceleași permanente, dar luate cu 1,00 — pentru situațiile în",
  "struct.combina.cr_0_20122": "CR 0-2012 §6.3 — permanentele se iau în ambele ipoteze",
  "struct.combina.actiunea_variabila_consi": "acțiunea variabilă considerată dominantă în acea combinație",
  "struct.combina.celelalte_actiuni_variab": "celelalte acțiuni variabile din aceeași combinație, reduse cu ψ₀",
  "struct.combina.0_cr_0": "ψ₀ din CR 0-2012 tab. 7.1",
  "struct.combina.gruparea_seismica_variab": "în gruparea seismică variabilele intră doar cu fracțiunea",
  "struct.combina.amplificarea_ordinul_ii": "amplificarea de ordinul II, aplicată cazurilor E și T_acc.",
  "struct.combina.p100_1_2013": "P100-1/2013 §4.6.2.2 — vezi tabelele de drift de mai sus",
  "struct.combina.cutremurul_vine_niciodat": "cutremurul nu vine niciodată perfect pe o axă: se ia 100 % pe o",
  "struct.combina.cutremurul_alternant_ace": "cutremurul e alternant: aceeași combinație se ia și cu semnul",
  "struct.combina.coeficientul_importanta": "coeficientul de importanță al clădirii. NU apare în matrice,",
  "struct.combina.pasul_ruleaza": "Pasul rulează…",
  "struct.combina.genereaza_combinatiile_c": "Se generează combinațiile CR 0-2012 și se aplică pe tensorul de eforturi (R = C·F), cu amplificarea α de ordinul II primită din Pasul 10.",
  "struct.combina.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.combina.facute": "Din ce sunt făcute",
  "struct.combina.setul_redus_alegere": "Setul redus e o alegere deliberată (viteza Pașilor 13–16), nu o aproximație tăcută. Mai jos e exact ce rămâne neexplorat, ce cere normativul și cum se acoperă. Toate cazurile de încărcare se calculează oricum la Pașii 8–9 — ce lipsește sunt COMBINAȚIILE lor, deci trecerea la setul complet nu cere o rulare FEM nouă a cazurilor, doar Pașii 11–16.",
  "struct.combina.acopera": "Se acoperă cu:",
  "struct.combina.directia": "Direcția",
  "struct.combina.rezultatul_acesta_a": "Rezultatul acesta a fost calculat înainte ca pasul să întoarcă valorile pe proiect — rulează din nou Pasul 11 ca să vezi și cifrele (kN, ψ, sursa fiecărui caz).",
  "struct.combina.atentie_doua_cazuri": "Atenție la două cazuri «speciale».",
  "struct.combina.valoarea_proiect": "Valoarea pe acest proiect",
  "struct.combina.inseamna": "Ce înseamnă",
  "struct.combina.input_decizie_sursa": "Input sau decizie — sursa",
  "struct.combina.citeste_numele": "Cum se citește numele.",
  "struct.combina.explicatia_ultima_coloan": "Explicația din ultima coloană nu se citește din nume, ci din coeficienții rândului — sunt exact cifrele din tabel.",
  "struct.combina.combinatie": "Combinație",
  "struct.combina.reprezinta_combinatia": "Ce reprezintă combinația",

  // --- STRUCTURĂ · Pasul 14, armarea pereților de subsol ----------------
  "struct.arp.grinda_grinda_perete": "Grindă sau grindă-perete?",
  "struct.arp.sr_en_1992": "SR EN 1992-1-1 §5.3.1(3): element de tip GRINDĂ doar dacă deschiderea e cel puțin 3× înălțimea secțiunii. Altfel e GRINDĂ-PERETE și ipoteza secțiunii plane nu mai e valabilă.",
  "struct.arp.panourile_subsol_au": "Panourile de subsol au tipic l₀/h ≈ 1,5…2 — exact «proporțiile de grinzi scurte» pentru care CR 2-1-1.1 §10.3.2 cere mecanismul de grindă cu zăbrele. Consecința practică: armătura întinsă nu se distribuie pe toată înălțimea, ci se concentrează în banda de la fața întinsă.",
  "struct.arp.rigiditatea_laterala_a": "Rigiditatea laterală a subsolului (stâlpi + pereții de beton) raportată la cel mai rigid nivel suprateran, pe fiecare direcție.",
  "struct.arp.criteriul_practica_struc": "Criteriul de practică al structuristului: ≥1,5 (subsolul cu ≥50 % mai rigid). P100-1 cere calitativ o infrastructură cu «comportare de corp rigid» — cuantificarea de 50 % vine din practică, iar restul condițiilor cutiei (placa peste subsol, ancoraje, goluri) sunt în recomandările de mai jos.",
  "struct.arp.deschiderea_calcul_inalt": "deschiderea de calcul / înălțimea secțiunii; sub 3 e grindă-perete",
  "struct.arp.montate_inaltimea_subsol": "Montate pe înălțimea subsolului, pe ambele fețe — «etrierii» grinzii-perete: preiau tăietoarea în plan ȘI traversează rosturile de lucru (talpă–perete, perete–placă), unde lucrează ca CONECTORI.",
  "struct.arp.minim_10_distanta": "Minim Ø10, distanță max 350 mm pe orizontală, ρ ≥ 0,30 % cu ambele plase (CR 2-1-1.1 §8.4.2 + §10.4.6); la grindă-perete și ≤ min(2·t, 300 mm) (SR EN 1992-1-1 §9.7(2)). Rolul de conector e cerut explicit de CR 2-1-1.1 §10.3.2.",
  "struct.arp.barele_orizontale_repart": "Barele orizontale de repartiție",
  "struct.arp.plasa_ortogonala_ambele": "Plasa ortogonală de pe ambele fețe, pe toată lungimea panoului: preia încovoierea în plan (M+N).",
  "struct.arp.minim_8_distanta": "Minim Ø8, distanță max 250 mm pe verticală, ρ ≥ 0,30 % cu ambele plase (CR 2-1-1.1 §8.4.2 + §10.4.6); la grindă-perete plasa e obligatorie lângă FIECARE față, min. 0,1 % și 150 mm²/m (SR EN 1992-1-1 §9.7(1)).",
  "struct.arp.tirantii_banda_intinsa": "Tiranții din banda întinsă",
  "struct.arp.bare_orizontale_concentr": "Bare orizontale CONCENTRATE în banda de la fața întinsă — sus la reazeme (moment negativ), jos în câmp (moment pozitiv). Sunt armătura tirantului din mecanismul de grindă cu zăbrele.",
  "struct.arp.grinda_perete_deformatii": "La grindă-perete deformațiile nu mai variază liniar pe înălțime, deci barele de la fața opusă nu ajung să curgă: T = M/z se preia de armătura din bandă. CR 2-1-1.1 §10.3.2 cere mecanismul, SR EN 1992-1-1 §9.7(3) cere ancorarea COMPLETĂ a tirantului în nod.",
  "struct.arp.grinda_perete_sr": "grindă-perete (SR EN 1992-1-1 §5.3.1(3))",
  "struct.arp.portiunile_panou_interio": "Porțiunile de panou din interiorul stâlpilor, modelate ca RIGIDE: l₀ = L_ax − off_i − off_j.",
  "struct.arp.peretele_foarte_asemanat": "Peretele e foarte asemănător cu o grindă, deci întrebarea firească e «se aplică și verificarea X de la grinzi?». Absența unei verificări nu e un răspuns — aici fiecare are motivul și articolul.",
  "struct.arp.scutirile_pornesc_acelas": "Toate scutirile pornesc din același loc: CR 2-1-1.1 §10.4.1 și P100-1 §5.8.1(2) — infrastructura se proiectează astfel încât să rămână în domeniul ELASTIC, deformațiile postelastice fiind dirijate în suprastructură. Fără articulații plastice nu există ductilitate de secțiune, dirijare a articulației, rotiri capabile sau calcul capabil al tăietoarei.",
  "struct.arp.cutia_rigida_a": "Cutia rigidă a infrastructurii",
  "struct.arp.peretii_dintre_stalpi": "Pereții dintre stâlpi sunt doar o parte: cutia se închide cu placa peste subsol ca diafragmă, ancorajele în infrastructură, golurile bordate și nodurile tratate corect.",
  "struct.arp.p100_1_4": "P100-1 §4.4.1.7 și C5.8, CR 2-1-1.1 §10.3 și §10.4 — lista de mai jos, cu articolele ei, e ce verifică structuristul la proiectul de execuție. Solverul nu le dimensionează: sunt piese de proiect de execuție.",
  "struct.arp.1_geometria_regimul": "1. Geometria și regimul secțiunii — grindă sau grindă-perete?",
  "struct.arp.pozitia_statiei_axul": "poziția stației, din axul stâlpului 1",
  "struct.arp.momentul_calcul_planul": "momentul de calcul în planul peretelui",
  "struct.arp.fata_intinsa_rezultata": "fața întinsă rezultată din semnul lui M₃",
  "struct.arp.momentul_combinatia_cvas": "momentul din combinația cvasipermanentă GS",
  "struct.arp.combinatia_da_extremul": "combinația care dă extremul — sursa întregului rând",
  "struct.arp.3_combinatia_dimensionea": "3. Combinația care dimensionează și amplificarea infrastructurii",
  "struct.arp.4_armarea_aleasa": "4. Armarea aleasă (soluția finală + desenele de execuție)",
  "struct.arp.5_incovoierea_plan": "5. Încovoierea în plan — două modele, cel mic decide",
  "struct.arp.6_taietoarea_plan": "6. Tăietoarea în plan, biela comprimată și nodul de reazem",
  "struct.arp.7_lunecarea_rosturile": "7. Lunecarea în rosturile de lucru — barele verticale ca CONECTORI",
  "struct.arp.8_deschiderea_fisurilor": "8. Deschiderea fisurilor sub combinația cvasipermanentă (INFORMATIV)",
  "struct.arp.armatura_intinsa_conside": "armătura întinsă considerată (tirantul din bandă)",
  "struct.arp.efortul_armatura_intinsa": "efortul în armătura întinsă, stadiul II",
  "struct.arp.distanta_maxima_intre": "distanța maximă între fisuri",
  "struct.arp.9_regulile_constructive": "9. Regulile constructive — armarea trebuie să fie și LEGALĂ, și executabilă",
  "struct.arp.10_ancorarea_innadirea": "10. Ancorarea și înnădirea mustăților din fundație",
  "struct.arp.raportul_decide_regimul": "raportul care decide regimul",
  "struct.arp.bratul_parghie_grinzii": "brațul de pârghie al grinzii cu zăbrele",
  "struct.arp.banda_intinsa_aduna": "banda întinsă în care se adună tirantul",
  "struct.arp.unghiul_forta_biela": "unghiul și forța din biela de reazem",
  "struct.arp.presiunea_nod_vs": "presiunea în nod vs σ_Rd,max = k₂·ν′·f_cd",
  "struct.arp.rezistenta_v_rdi": "rezistența v_Rdi = c·f_ctd + µ·σ_n + ρ·f_yd·µ",
  "struct.arp.aderenta_proiectare_f": "aderența de proiectare f_bd = 2,25·η₁·η₂·f_ctd",
  "struct.arp.lungimea_ancorare_baza": "lungimea de ancorare de bază și cea de proiectare",
  "struct.arp.lungimea_innadire_a": "lungimea de înnădire a mustăților",
  "struct.arp.termenii_folositi_romane": "Termenii folosiți, pe românește",
  "struct.arp.pasul_ruleaza": "Pasul rulează…",
  "struct.arp.armeaza_peretii_beton": "Se armează pereții de beton ai subsolului: eforturile din cele 5 puncte (Pasul 12, cu amplificarea infrastructurii pe combinația seismică), regimul secțiunii (grindă zveltă sau grindă-perete), apoi plasele, tiranții din banda întinsă, rostul de lucru și regulile constructive.",
  "struct.arp.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.arp.panourile_nasc_pasul": "Panourile se nasc la Pasul 7, între doi stâlpi ai subsolului așezați pe ACELAȘI ax de perete din Pasul 2, cu zidul acoperind cel puțin 70 % din interax. Dacă niciunul nu îndeplinește condiția, verifică întâi pereții nivelului subteran în Pasul 2.",
  "struct.arp.pas_inactiv_proiect": "Pas inactiv pe acest proiect",
  "struct.arp.panourile": "Toate panourile",
  "struct.arp.intre_stalpii": "între stâlpii",
  "struct.arp.otel_kg": "oțel [kg]",
  "struct.arp.plasa_banda_ajunge": "plasa din bandă ajunge",
  "struct.arp.click_rand_deschide": "Click pe un rând deschide nota de calcul a panoului, mai jos.",
  "struct.arp.inseamna_verdictul": "Ce înseamnă verdictul.",
  "struct.arp.marja_subdimensionare_ac": "Marja de subdimensionare acceptată:",
  "struct.arp.verificarea_grinzi": "verificarea de la grinzi",
  "struct.arp.unde_grinzi": "unde e la grinzi",
  "struct.arp.aplica": "de ce nu se aplică",
  "struct.arp.baza_normativa": "Baza normativă",
  "struct.arp.romanesc_da_cerinta": "ROMÂNESC dă cerința",
  "struct.arp.tirantii": "tiranții",
  "struct.arp.fata_intinsa": "fața întinsă",
  "struct.arp.combinatia": "combinația",
  "struct.arp.intinsa": "ÎNTINSĂ",
  "struct.arp.plasa_verticala_ambele": "Plasă verticală (ambele fețe)",
  "struct.arp.plasa_orizontala_ambele": "Plasă orizontală (ambele fețe)",
  "struct.arp.tirant_sus_banda": "Tirant SUS (banda de la fața de sus)",
  "struct.arp.tirant_jos_banda": "Tirant JOS (banda de la fața de jos)",
  "struct.arp.aplica2": "nu se aplică",

  // --- STRUCTURĂ · Pasul 15, armarea stâlpilor --------------------------
  "struct.ars.verifica_stalp": "Cum se verifică un stâlp",
  "struct.ars.capacitatea_unei_sectiun": "Capacitatea unei secțiuni armate la (N, M2, M3) nu e un număr, ci o SUPRAFAȚĂ închisă în 3D («ceapa»): pe fiecare direcție de încovoiere există o curbă P–M. Punctele din analiză trebuie să fie în interior.",
  "struct.ars.pozitia_zonei_comprimate": "Poziția zonei comprimate depinde de efortul axial — de aceea structuristul folosea XTRACT (analiză pe fibre). Motorul nostru reimplementează acel calcul cu materialele proiectului, iar verificarea R/E = raportul radial capabil/efectiv.",
  "struct.ars.desenele_arata_numai": "desenele arată numai nivelul selectat",
  "struct.ars.stiva_intreaga_talpa": "stiva întreagă, din talpa fundației până la ultimul planșeu",
  "struct.ars.h_flex_coteaza": "De ce h_flex nu se cotează în desen",
  "struct.ars.h_flex_h": "h_flex = H − ofseturile de nod rigid, adică porțiunea de stâlp care se deformează în model.",
  "struct.ars.ofsetul_rigid_stalpului": "Ofsetul rigid al stâlpului e plafonat la min(0,25 m; 0,20·L/2) în fem.py, deci e o mărime de MODEL, nu grosimea reală a planșeului. Desenul cotează banda grinzii care intră efectiv în nod.",
  "struct.ars.explicatia_larg": "Explicația, pe larg",
  "struct.ars.plafonul_echilibru_nodul": "plafonul de echilibru al nodului de jos / de sus",
  "struct.ars.taietoarea_rezultata_ana": "tăietoarea rezultată din analiză",
  "struct.ars.latimea_inaltimea_utila": "lățimea × înălțimea utilă a secțiunii de forfecare",
  "struct.ars.efortul_nod_m": "efortul pe nod = ΣM_Eb (analiză) × Ω, cu Ω = ΣM_Rb/ΣM_Eb plafonat jos la 1",
  "struct.ars.m_rb_m": "Ω = ΣM_Rb/ΣM_Eb — coeficientul de amplificare de la grinzi; subunitar se ia 1, ca să nu reducă efortul pe nod",
  "struct.ars.v_pereti_v": "V_pereți + V_restul − V_bază: CQC nu e aditiv",
  "struct.ars.pasul_ruleaza": "Pasul rulează…",
  "struct.ars.stalp_genereaza_suprafet": "Pentru fiecare stâlp: se generează suprafețele de interacțiune P–M–M cu motorul de fibre (înlocuitorul XTRACT), se verifică toate combinațiile, νd, ierarhia nodurilor (cu M_Rb din Pasul 13), tăietoarea capabilă și detaliile de nod.",
  "struct.ars.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.ars.doar_nivelul": "Doar nivelul",
  "struct.ars.tot_stalpul": "Tot stâlpul",
  "struct.ars.armare_simetrica_contur": "Armare simetrică pe contur (colțurile mereu ocupate), aceeași marcă pe nivel — solverul pornește de la minimul constructiv (p_min al clasei de ductilitate) și urcă în gamă până când toate punctele (N, M2, M3) intră în suprafața P–M–M și ierarhia nodului se satisface. Barele desenate sunt EXACT cele cu care motorul de fibre a calculat capacitatea.",
  "struct.ars.etrieri_zonele_plastice": "Etrieri în zonele plastice",
  "struct.ars.etrieri_zona_curenta": "Etrieri în zona curentă",
  "struct.ars.zona_plastica_l": "Zona plastică l_cr (jos / sus)",
  "struct.ars.bara_trece_prin": "bara trece prin nivel (ține două etaje)",
  "struct.ars.ax_planseu_ax": "(ax planșeu → ax planșeu)",
  "struct.ars.libera": "liberă",
  "struct.ars.a_stalpului": "a stâlpului",
  "struct.ars.grinda_cea_inalta": "(grinda cea mai înaltă)",
  "struct.ars.placa": "din care placa",
  "struct.ars.innadirea_barelor_l0": "Înnădirea barelor l₀",
  "struct.ars.citeste_tabelul_jos": "Cum se citește tabelul de mai jos",
  "struct.ars.vezi_explicatia_detaliat": "— vezi explicația detaliată sub tabel.",
  "struct.ars.efortul_nod": "Efortul pe nod",
  "struct.ars.5_6_nodul": "5–6. Nodul: forfecare și ancorare",
  "struct.ars.7_confinarea_wd": "7. Confinarea (ω_wd și α·ω_wd)",
  "struct.ars.8_interaxul_barelor": "8. Interaxul barelor ținute ≤ 18 cm",
  "struct.ars.detalii_referinta": "Detalii / referința",
  "struct.ars.incovoiere": "încovoiere",
  "struct.ars.taietoare": "tăietoare",
  "struct.ars.ea_spune_intreba": "Ea spune: nu întreba analiza «ce tăietoare apare?», pentru că analiza îți dă tăietoarea de la cutremurul de proiectare, iar cutremurul real poate fi mai mare. Întreabă în schimb: «care e cea mai mare tăietoare pe care stâlpul o poate simți VREODATĂ?» — adică aceea din momentul în care se articulează plastic la ambele capete. Atunci momentele de la capete sunt cele CAPABILE, iar din echilibrul barei:",
  "struct.ars.plafonul_echilibru_nodul2": "plafonul de echilibru al nodului",
  "struct.ars.m_rc_ia": "M_Rc se ia la forța axială seismică MAXIMĂ.",
  "struct.ars.verifica_ambele_directii": "Se verifică AMBELE direcții separat.",
  "struct.ars.directia": "Direcția",
  "struct.ars.v_analiza_kn": "V_analiză [kN]",
  "struct.ars.brate": "brațe",
  "struct.ars.umfla_lateral": "umflă lateral",
  "struct.ars.deformatie_mult_mare": "deformație mult mai mare",
  "struct.ars.consecinta_practica": "Consecință practică:",
  "struct.ars.pasul_etrierilor_zona": "Pasul etrierilor în zona critică",
  "struct.ars.s_8_bara": "s ≤ 8·Ø_bară",
  "struct.ars.eficienta_confinarii": "α (eficiența confinării)",
  "struct.ars.betonul_confinat_f": "Betonul confinat (f_cc, ε_cu,c — modelul Mander) se raportează INFORMATIV: capacitățile P–M–M de mai sus se calculează pe betonul NECONFINAT de calcul, ceea ce este acoperitor.",
  "struct.ars.interax_18_cm": "interax ≤ 18 cm între barele ținute",
  "struct.ars.forfecarea_orizontala": "forfecarea orizontală",
  "struct.ars.nodul_cel_solicitat": "De ce e nodul cel mai solicitat loc din cadru.",
  "struct.ars.cutremur_intr_nod": "La cutremur, într-un nod interior armătura de SUS a grinzii din stânga este întinsă în timp ce armătura de JOS a grinzii din dreapta este tot întinsă — în sensuri opuse. Cele două forțe, plus forfecarea stâlpului, se adună într-o forță orizontală V_jhd care încearcă să «foarfece» nodul pe orizontală. Nodul o preia printr-o DIAGONALĂ COMPRIMATĂ de beton, între colțul de sus-stânga și cel de jos-dreapta. Verificarea (2) compară forța cerută cu cât poate duce acea diagonală înainte să se strivească: V_jhd ≤ η·f_cd·b_j·h_jc·√(1−ν_d/η). Termenul √(1−ν_d/η) spune că un stâlp deja foarte comprimat lasă mai puțin din beton disponibil pentru diagonală. b_j este lățimea efectivă a nodului: suprapunerea dintre grindă și stâlp, lărgită cu câte un sfert de h_c de fiecare parte (efortul difuzează la 45°), dar niciodată peste elementul mai lat dintre cele două.",
  "struct.ars.ancorarea_barelor_limite": "De ce ancorarea barelor limitează diametrul.",
  "struct.ars.bara_continua_printr": "O bară continuă printr-un nod interior intră întinsă dintr-o parte și iese comprimată în cealaltă. Diferența — practic 2·f_yd — trebuie transmisă betonului prin aderență, pe distanța h_c a stâlpului. Cu cât bara e mai groasă, cu atât are nevoie de mai multă lungime pentru aceeași forță (aria crește cu Ø², suprafața de aderență doar cu Ø). De aici limita d_bL/h_c: la un stâlp îngust nu poți trece bare groase, oricât de bine ai arma. Dacă pică, singurele soluții reale sunt un stâlp mai lat pe direcția grinzii, sau bare mai multe și mai subțiri în grindă — armarea stâlpului nu ajută deloc. Efectul favorabil al compresiunii (1+0,8·ν_d) se ia cu ν_d MINIM din stâlpul de DEASUPRA nodului, pentru că acela e cazul în care compresiunea ajută cel mai puțin; când nu există stâlp deasupra, ν_d = 0. Verificarea acoperă toate barele care ajung în nod: și straturile continue, și barele suplimentare de la reazem.",
  "struct.ars.nodul_varful_nivelului": "Nodul (vârful nivelului)",
  "struct.ars.fara_grinzi_nod": "fără grinzi în nod",
  "struct.ars.directie": "pe fiecare direcție",
  "struct.ars.taietoarea_baza": "tăietoarea de bază",
  "struct.ars.cere": "nu se cere",
  "struct.ars.nivel": "La ce nivel",
  "struct.ars.fractiunea": "Fracțiunea",
  "struct.ars.pereti": "pereți",
  "struct.ars.baza": "bază",
  "struct.ars.pasul_9_lipseste": "Pasul 9 lipsește",
  "struct.ars.directia2": "direcția",
  "struct.ars.i_pereti_m4": "ΣI pereți (m⁴)",
  "struct.ars.fractiune": "fracțiune",

  // --- STRUCTURĂ · Pasul 13, armarea grinzilor --------------------------
  "struct.arg.alege_armarea_fiecarei": "Alege armarea fiecărei grinzi și o VERIFICĂ după foaia de calcul a structuristului (GRINZI_CP.xlsm, foaia B) — momente capabile, forță axială, articulație plastică, tăietoare pe 3 zone.",
  "struct.arg.modelul_fem_contine": "Modelul FEM conține doar beton; oțelul se dimensionează astfel încât capacitatea (R) să acopere efortul (E) în fiecare punct de verificare — R/E ≥ 1. Rezultatul e intrarea pentru armarea stâlpilor (ierarhia grindă slabă – stâlp tare).",
  "struct.arg.portiunile_grinda_interi": "Porțiunile de grindă din interiorul stâlpilor, modelate ca RIGIDE: l₀ = L_ax − off_i − off_j.",
  "struct.arg.pasul_nu_rulat": "Pasul nu a fost rulat încă. Apasă «Run» în meniul din stânga (după Pasul 12).",
  "struct.arg.ultima_rulare_esuat": "Ultima rulare a eșuat: {motiv}",
  "struct.arg.eroare_necunoscuta": "eroare necunoscută",
  "struct.arg.parametrii_de_calcul": "Parametrii de calcul",
  "struct.arg.param_beton_otel": "beton {beton} (f_cd = {fcd} MPa, f_ctd = {fctd} MPa) · oțel {otel} (f_yd = {fyd} MPa) · clasa {clasa} · b_eff: {beff} · acoperiri {csus}/{cjos} cm · armare placă: {placa}",
  "struct.arg.param_gamma": "γ_Rd = {g1} la tăietoarea capabilă și {g2} la ancorarea prin nod — {sursa}. Se schimbă odată cu clasa de ductilitate, fără nicio setare.",
  "struct.arg.optiune_grinda": "{el} ({nivel}) — {verdict}",
  "struct.arg.grinda_dimensiuni": "{b}×{h} cm · L = {l} m (ax–ax) · l₀ = {l0} m · stâlpi {si} → {sj}",
  "struct.arg.rigid_off": " · rigid {i} + {j} cm",
  "struct.arg.verdictul_aduna": "<b>Ce înseamnă verdictul.</b> El adună TOATE verificările grinzii, iar cea mai severă îl dictează: încovoierea (momentele, la gruparea fundamentală și la cea seismică), <b>tăietoarea</b> pe toate zonele, <b>ductilitatea secțiunii</b> (x ≤ x_u), <b>dirijarea articulației plastice</b>, exploatarea normală (SLS: săgeata și deschiderea fisurilor) și regulile constructive (barele încap în secțiune, A_s ≤ 4 %, A_s,jos ≥ 0,5·A_s,sus la reazem). Fiecare are un raport R/E: <i>R</i> = ce poate grinda, <i>E</i> = ce i se cere. R/E ≥ 1 înseamnă că trece. «ATENTIE!!!» = trece, dar cu mai puțin de 9 % rezervă. «NU SE VERIFICA!!!» = nu trece, iar Pasul 19 o va vedea ca picată și va încerca să o rezolve.",
  "struct.arg.marja_acceptata": "<b>Marja de subdimensionare acceptată:</b> acest proiect acceptă R/E ≥ {prag} (marjă de {pct} %) — practica structuristului: o verificare la 0,95 nu oprește proiectul. Solverul țintește tot R/E = 1,00; doar verdictul verificărilor rămase în marjă devine acceptat, marcat explicit cu «prin marja», iar R/E-ul afișat rămâne cel real.",
  "struct.arg.croiala_barelor": "Croiala barelor longitudinale",
  "struct.arg.th_bara": "bara",
  "struct.arg.th_traseul": "traseul [m]",
  "struct.arg.th_suprapuneri": "suprapuneri",
  "struct.arg.innadire_la": "{s} m, l₀ = {l0} m",
  "struct.arg.innadire_zona": " ({zona})",
  "struct.arg.innadire_fara_zona": " — FĂRĂ zonă liberă",
  "struct.arg.abscisa_din_capat": "Abscisa se măsoară din capătul axului{ax} ({l} m), iar nodurile lui cad la {noduri} m. O bară care trece prin nod aparține axului, nu deschiderii: în extras intră o singură dată, pe grinda care o găzduiește.",
  "struct.arg.suprapuneri_fortate": "Unele suprapuneri n-au încăput în nicio zonă permisă",
  "struct.arg.suprapuneri_fortate_de_ce": " — deschiderea e prea lungă pentru o bară comercială fără o zonă liberă la îndemână; locul lor se decide la detaliere.",
  "struct.arg.legenda_scena": "Beton = gri transparent; placa activă (b_eff) = verde; strat continuu sus = roșu, jos = albastru; bare suplimentare = ocru (sus) / turcoaz (câmp); etrierii = linii albastre (îndesiți în zonele critice l_cr = {lcr} m); contextul (stâlpi, placă, grinzile vecine) e schițat.",
  "struct.arg.legenda_petrecere_a": "<b>Zonele prună de la capete = porțiunile RIGIDE.</b> <b>Bara DEDUBLATĂ = petrecerea</b> (aceeași bară, de două ori, cu cota l₀), iar",
  "struct.arg.legenda_petrecere_b": ", în care normativul nu admite petreceri. Rotește cu mouse-ul, zoom cu scroll.",
  "struct.arg.banda_rosie_scurt": "banda roșie de la capete e zona critică",
  "struct.arg.zona_rigida_explic": "<b>Ce e «zona rigidă».</b> Grinda nu începe la fața stâlpului, ci în axul lui — bucata dintre ax și față este înghițită de nodul de beton, care e mult mai gros decât grinda și practic nu se deformează. În modelul de calcul ea NU este bară flexibilă, ci un tronson <i>rigid</i>: transmite efortul mai departe fără să se încovoaie. Aici sunt {i} cm la capătul i și {j} cm la capătul j (semi-gabaritul secțiunii stâlpului, proiectat pe axa grinzii — la un stâlp 30×30 iese 15 cm, la o lamelă cu latura lungă în lungul grinzii poate ieși 55 cm).",
  "struct.arg.de_ce_conteaza_l0": "<b>De ce contează.</b> Momentele și tăietoarea de proiectare nu se citesc în ax (unde ar ieși artificial mari), ci la <b>FAȚA stâlpului</b> — acolo începe grinda reală. De aceea deschiderea de calcul este l₀ = L_ax − off_i − off_j = {lax} − {oi} − {oj} = <b>{l0} m</b>, și toate verificările (M_Rd, săgeata l₀/250, deschiderea de forfecare) merg pe ea, nu pe L_ax.",
  "struct.arg.termen_brat": "braț de pârghie (z)",
  "struct.arg.termen_brat_def": "distanța dintre rezultanta compresiunii din beton și armătura întinsă — momentul capabil este forța din armătură × z",
  "struct.arg.termen_d": "înălțime utilă (d)",
  "struct.arg.termen_d_def": "de la fibra comprimată până la CENTRUL armăturii întinse — nu toată înălțimea h lucrează",
  "struct.arg.termen_beff": "b_eff (lățimea activă)",
  "struct.arg.termen_beff_def": "fâșia de placă care lucrează împreună cu grinda la încovoiere; armătura plăcii din această fâșie se adaugă la capacitate",
  "struct.arg.s2_titlu": "2. Eforturile de calcul (cele 5 puncte)",
  "struct.arg.s2_explicatie": "Eforturile vin din tensorul combinat al Pasului 11, extrase per combinație (nu ca înfășurătoare anonimă): pentru fiecare punct se reține momentul extrem, combinația care îl dă, poziția x și forța axială N concomitentă. {corectie}",
  "struct.arg.deschiderea_sub_4_5": "Deschiderea e sub 4,5 m — corecția de deschidere mare (foaia B: AZ10) nu se aplică.",
  "struct.arg.s3_seismic_da": "Momentele seismice depășesc fundamentalele la reazeme (criteriul foii B, AX21: M_fund < 1,05·M_seism) ⇒ grinda se armează la COMBINAȚIA SPECIALĂ (seismică), cu contribuția plăcii redusă la {coef} și cu influența forței axiale inclusă.",
  "struct.arg.s3_seismic_nu": "Fundamentala acoperă seismicul cu marjă ≥ 5 % la ambele reazeme (foaia B, AX21) ⇒ «NU E CAZUL ARMĂRII LA COMBINAȚIA SPECIALĂ» — se armează cu capacitatea din gruparea fundamentală.",
  "struct.arg.s4_explicatie": "Solverul pornește de la minimul constructiv (2 bare continue sus și jos — P100-1 le cere pe toată lungimea) și repară iterativ verificarea picată cu corecția cea mai ieftină; barele suplimentare de câmp NU se prelungesc în reazem (nu cresc V_Ed,cap și cererea pe stâlpi).",
  "struct.arg.carcasa_sus_axul": "Carcasa de sus e aceeași pe tot axul {ax}: barele trec prin nodurile intermediare, deci sunt aceeași bară. S-a luat cea mai mare de pe ax.",
  "struct.arg.sus_continuu": "Sus continuu",
  "struct.arg.sus_supl_r1": "Sus suplimentar la R1",
  "struct.arg.randul_2": "(rândul 2)",
  "struct.arg.jos_continuu": "Jos continuu",
  "struct.arg.bara_retezata_drept": "bara se retează drept, la punctul teoretic + deviația a_l (EC2 §9.2.1.3)",
  "struct.arg.bara_ridicata_45": "bara nu se retează: urcă la 45° pe înălțimea secțiunii și se ancorează pe fibra de sus (EC2 §9.2.1.3)",
  "struct.arg.jos_supl_camp": "Jos suplimentar în câmp",
  "struct.arg.retezate": "(retezate)",
  "struct.arg.ridicate_45": "(ridicate la 45°)",
  "struct.arg.etrieri_pas_unic": "Etrieri (pas unic pe toată grinda)",
  "struct.arg.etrieri_doua_zone": "Etrieri (zona critică / curentă)",
  "struct.arg.armarea_se_cauta": "Armarea nu se calculează dintr-o formulă, ci se CAUTĂ: se pornește de la minimul constructiv și se corectează, pas cu pas, prima problemă găsită (aria din momente → momentele capabile → ductilitatea secțiunii → dirijarea articulației plastice → tăietoarea → SLS), iar după fiecare corecție verificarea se reia de la capăt.",
  "struct.arg.jurnalul_nu_se_pastreaza": "Jurnalul pas-cu-pas nu se mai păstrează — singurul istoric ținut e cel al Pasului 19, «ce s-a modificat în structură».",
  "struct.arg.s5_explicatie": "M_Rd = (A_s·f_yd + contribuția armăturii plăcii)·z. Placa participă cu coeficientul {cf} la fundamentală și {cs} la seismică (practica foii B — nu e valoare de normativ). La seismică se scade și momentul «consumat» de forța axială M_c: o grindă ÎNTINSĂ pierde capacitate («coeficientul prostului» — preluat de structurist din literatura americană; apare și în EC2, nu și în normativul românesc).",
  "struct.arg.th_punct": "Punct",
  "struct.arg.th_grupare": "Grupare",
  "struct.arg.th_verdict": "Verdict",
  "struct.arg.momentul_de_calcul": "momentul de calcul",
  "struct.arg.momentul_consumat_axial": "momentul consumat de axial",
  "struct.arg.s6_explicatie": "CE ESTE x. Când grinda se încovoaie, o parte din secțiune se comprimă (sus la momentul negativ de pe reazem, jos la momentul pozitiv din câmp) și restul se întinde. Granița dintre ele se numește AXA NEUTRĂ, iar x este distanța de la fibra cea mai comprimată până la ea. x mic = zonă comprimată subțire; x mare = zonă comprimată adâncă.\n\nDE CE CONTEAZĂ. O grindă bine proiectată cedează așa: armătura întinsă începe să curgă (oțelul se lungește mult, fisurile se deschid vizibil, grinda se lasă) și abia mult mai târziu se zdrobește betonul comprimat. Ai avertisment, ai deformație, structura disipează energie — exact ce ai nevoie la cutremur. Dacă x e prea adânc, secțiunea are prea multă armătură întinsă față de cât beton comprimat există: betonul se zdrobește PRIMUL, brusc, fără ca oțelul să fi curs. Ruperea e casantă. De aceea P100-1 limitează x la un sfert din înălțimea utilă: x_u = 0,25·d = {xu} cm.\n\nCUM SE CALCULEAZĂ. Efortul real din betonul comprimat este distribuit după o curbă (parabolă–dreptunghi), pe care nimeni nu o integrează manual. Normele o înlocuiesc cu un DREPTUNGHI ECHIVALENT care dă aceeași forță. Atenție: există două convenții, și ele numesc lucruri diferite «x». EC2 §3.1.7 folosește un dreptunghi de înălțime 0,8·x la efort f_cd, unde x e axa neutră reală. STAS și foaia de calcul a biroului folosesc un dreptunghi de înălțime x la efort f_cd — adică «x» ESTE dreptunghiul. Aici se lucrează în convenția foii de birou, din echilibrul forțelor pe secțiune:\n\n    x·b·f_cd  +  A_comprimat·f_yd  =  A_întins·f_yd  +  N\n\nÎn stânga: forța din dreptunghiul de beton comprimat plus armătura de pe fața comprimată. În dreapta: armătura întinsă plus efortul axial N de întindere. Rezolvat după x:\n\n    x = [ (A_întins − A_comprimat)·f_yd − N ] / (b·f_cd)\n\nNumeric, acest x este 0,8 din axa neutră în convenția EC2, iar pragul x ≤ 0,25·d se citește în aceeași convenție (echivalent cu x_EC2/d ≤ 0,31). Dacă compari cu un calcul făcut după EC2, ține minte factorul.\n\nN pozitiv = ÎNTINDERE. La cutremur planșeul trage de grindă, deci N > 0 și x crește — o grindă întinsă axial are nevoie de mai mult beton comprimat ca să se echilibreze.\n\nx NEGATIV nu e o eroare: înseamnă că fața presupusă comprimată nu e de fapt comprimată (secțiunea are mai multă armătură pe fața aceea decât pe cealaltă). Se verifică x-ul cel mai MARE dintre toate cele 5 puncte × toate grupările.\n\nCUM SE REPARĂ. Armătură în plus pe fața COMPRIMATĂ: ea preia o parte din compresiune, deci betonul are nevoie de mai puțină înălțime și axa neutră urcă. Armătură pe fața ÎNTINSĂ face exact invers — adâncește axa neutră. Dacă pe fața comprimată nu mai încap bare (maxim 2 rânduri), singura soluție reală e o secțiune de beton mai mare.",
  "struct.arg.s7_explicatie": "La cutremur grinda trebuie să se «rupă» controlat DOAR la capete (articulații plastice la reazeme). Dacă s-ar forma o a treia articulație în câmp, cele trei rupturi coliniare devin mecanism — placa «face burtă» și cade. Criteriul foii B (BD15): articulația în câmp e posibilă dacă momentul de câmp concomitent depășește 0,85·momentul de câmp maxim și pe cel de la celălalt capăt; e DIRIJATĂ spre reazeme dacă M_Rd,câmp ≥ 1,45·M_Rd,jos la AMBELE reazeme.",
  "struct.arg.s8_explicatie": "CE ESTE. Tăietoarea «taie» grinda transversal și produce fisuri OBLICE (la ~45°), nu verticale ca încovoierea. Cedarea din tăietoare este CASANTĂ: fisura oblică se deschide brusc, fără avertisment și fără deformație plastică. De aceea grinda trebuie să fie MAI TARE la tăietoare decât la încovoiere — vrem să cedeze la încovoiere, controlat.\n\nCALCULUL CAPABIL. Tocmai de asta, în zona critică V_Ed NU se ia din analiză. Se pune întrebarea inversă: «dacă grinda chiar se articulează plastic la ambele capete, ce tăietoare apare?» — V_Ed,cap = γ_Rd·(M_Rd,i + M_Rd,j)/l_as, plus tăietoarea din încărcările gravitaționale. Așa tăietoarea rămâne mereu peste ce poate livra încovoierea.\n\nCELE TREI ZONE. «Zona critică» e capătul grinzii, pe lungimea unde se poate forma articulația plastică — acolo etrierii sunt cei mai deși. «Zona curentă» e mijlocul, unde tăietoarea din analiză e mai mică. «Nod» e porțiunea din interiorul stâlpului.\n\nCE MAI TREBUIE VERIFICAT. Etrierii preiau întinderea din fisura oblică, dar între fisuri betonul lucrează la COMPRESIUNE, ca diagonalele unei grinzi cu zăbrele. Dacă acele diagonale de beton se zdrobesc, etrierii nu mai ajută — de aceea se verifică și V_Rd,max (bielele comprimate).\n\nVerificarea se face pe metoda românească (STAS — foaia B) ȘI pe EC2, luând acoperitor. Toate zonele intră în verdictul grinzii.",
  "struct.arg.nicio_parte": "nicio parte",
  "struct.arg.o_parte": "o parte",
  "struct.arg.ambele_parti": "ambele părți",
  "struct.arg.articulatie_praguri": "M_Rd,câmp = {m} kNm față de pragurile 1,45·M_Rd,jos = {praguri} kNm →",
  "struct.arg.articulatie_nu_e_cazul": "Momentul de câmp concomitent nu depășește 0,85 din referință — articulația nu poate apărea în câmp; nu e necesară dirijarea.",
  "struct.arg.inclinate_necesare": "tăietoarea își schimbă semnificativ sensul (ζ = {zeta} ≤ −0,5) → se adaugă {n}Ø{phi} la 45° care preiau {v} kN",
  "struct.arg.inclinate_nu_e_cazul": "nu e cazul (ζ = {zeta} > −0,5) — inversarea tăietoarei e moderată (foaia B: BT52–BT54).",
  "struct.arg.s9_explicatie": "Verificările de EXPLOATARE (nu de rezistență): sub încărcarea de zi cu zi — combinația cvasipermanentă GS (G + ψ₂·Q) — grinda nu are voie să se lase vizibil și fisurile trebuie să rămână închise capilar. Săgeata se calculează integrând curbura M/EI pe deschidere, cu rigiditatea INTERPOLATĂ între secțiunea nefisurată (stadiul I) și cea fisurată (stadiul II, EC2 §7.4.3, ζ = 1 − 0,5·(M_cr/M)²) și cu fluajul betonului: E_eff = Ecm/(1+φ) = {e} MPa (φ = {phi}).",
  "struct.arg.momentul_de_fisurare": "momentul de fisurare M_cr = f_ctm·b·h²/6",
  "struct.arg.sageata_eticheta": "Săgeata:",
  "struct.arg.otelul_nu_mai_ajuta": " — oțelul nu mai ajută semnificativ: mărește înălțimea grinzii (buclă externă, manuală)",
  "struct.arg.wk_formula": "w_k = s_r,max·(ε_sm − ε_cm), cu s_r,max = 3,4·c + 0,425·k₁·k₂·Ø/ρ_eff (EC2 §7.3.4; k₁ = 0,8 bare profilate, k₂ = 0,5 încovoiere, k_t = 0,4 durată). «Nefisurat» = momentul nu atinge M_cr.",
  "struct.arg.s10_explicatie": "Cât de mult se poate ROTI fiecare capăt de grindă înainte să-și piardă capacitatea (formula EC8-3 anexa A, cu rezistențe MEDII: f_cm = 1,75·f_cd, f_ym = 1,35·f_yd; factorul de confinare α = {alpha} din dispunerea etrierilor). {nota}.",
  "struct.arg.lv_deschiderea_forfecare": "L_v (deschiderea de forfecare, capăt → moment nul): R1 = {r1} m, R2 = {r2} m · ρ_sw = {rho}",
  "struct.arg.s10b_explicatie": "Un calcul poate cere o arie de armătură care, pe hârtie, verifică perfect — dar care nu încape în cofraj sau nu se poate betona. Regulile de mai jos sunt cele care transformă «aria necesară» în «armătură reală».\n\nBARELE TREBUIE SĂ ÎNCAPĂ. Pe lățimea unei fețe, spațiul util este b − 2·acoperire − 2·Ø_etrier = {spatiu} cm. Între axele a două bare vecine trebuie să rămână cel puțin {imin} cm și cel mult {imax} cm: sub minim nu mai trece betonul cu pervibratorul și se formează cuiburi de pietriș, iar peste maxim armătura se strânge în câteva bare groase, pe care un singur defect le scoate din lucru. Pe o față se acceptă cel mult 2 rânduri de bare — al treilea rând ar coborî prea mult centrul de greutate al armăturii și ar reduce brațul de pârghie.\n\nA_s ≤ 4 % DIN ARIA DE BETON (EC2 §9.2.1.1). Peste 4 %, secțiunea devine dominată de oțel: betonul nu se mai poate compacta printre bare, iar comportarea nu mai este cea a unui element de beton armat. Practic, dacă ajungi acolo, grinda e subdimensionată — nu îi lipsește armătură, îi lipsește beton.\n\nA_s,jos ≥ 0,5·A_s,sus LA REAZEM (P100-1 §5.3.4.1.2). La cutremur momentul de la capătul grinzii își schimbă semnul de la o secundă la alta: acum întinde fibra de sus, imediat pe cea de jos. Armătura de jos de la reazem nu e un moft — ea preia momentul pozitiv al ciclului inversat. Minimul de jumătate din armătura de sus asigură că grinda are capacitate în ambele sensuri.\n\nØ MINIM ȘI PLAFONUL PRIN NOD. Barele nu pot fi oricât de subțiri (Ø {phimin} minim, constructiv) și nici oricât de groase: o bară care trece printr-un nod trebuie să apuce să-și transmită efortul betonului pe grosimea stâlpului, altfel lunecă. Plafonul de aici este {plafon}, calculat cu Ø ≤ h_c·7,5·f_ctm/(γ_Rd·f_yd)·(1+0,8·ν_d,min), cu γ_Rd = {gamma} ({sursa}). Este EXACT aceeași funcție, cu aceleași valori, pe care o folosește verificarea de ancorare de la Pasul 15 — dacă plafonul de aici ar fi mai strict decât verificarea de acolo, ai primi avertismente fără nicio verificare picată în spate, iar solverul ar fi împins spre bare mai groase, adică fix în direcția greșită.",
  "struct.arg.plafon_dezactivat": "dezactivat",
  "struct.arg.plafon_mm": "{v} mm",
  "struct.arg.th_verificarea": "Verificarea",
  "struct.arg.th_e_cerut": "E (cerut / existent)",
  "struct.arg.th_r_limita": "R (limita)",
  "struct.arg.plafon_depasit": "Barele au fost alese PESTE plafonul de diametru prin nod{plafon}: aria necesară nu încăpea sub el. Ancorarea nodului se judecă la Pasul 15 (categoria «Nod: ancorarea barelor grinzii»), iar pârghia e acolo — stâlpi mai lați pe direcția grinzii, sau grinda mai înaltă ca să scadă aria necesară.",
  "struct.arg.plafon_paren": " ({v} mm)",
  "struct.arg.armarea_efectiva": "Armarea efectivă: sus {sus}{suplr1}{suplr2} · jos {jos}{suplcamp} · etrieri Ø{phi}/{critic} cm (zona critică) și /{curent} cm (zona curentă)",
  "struct.arg.supl_reazem_1": " + {n}Ø{phi} (reazem 1)",
  "struct.arg.supl_reazem_2": " + {n}Ø{phi} (reazem 2)",
  "struct.arg.supl_camp_scurt": " + {n}Ø{phi} (câmp)",
  "struct.arg.s11_explicatie": "Ce «exportă» grinda pentru dimensionarea stâlpilor (ierarhia grindă slabă – stâlp tare, ΣM_Rc ≥ γ·ΣM_Rb la fiecare nod) — bucla completă grindă↔stâlp se închide la pasul următor.",
  "struct.arg.strange": "▴ strânge",
  "struct.arg.arata_tot": "▾ arată tot",
  "struct.arg.corectia_4_5": " (din {m} + corecția 4,5 m)",
  "struct.arg.formula_exemplu": "Exemplu, punctul R1_sus (fundamentală): M_Rd = (A_s·f_yd + c·A_pl·f_yd,pl)·z = ({as} cm²·{fyd} MPa {placa})·{z} cm / 1000 = ",
  "struct.arg.formula_exemplu_placa": "+ {coef}·A_placă·f_yd,pl",
  "struct.arg.formula_exemplu_fara_placa": "+ 0 (fără placă în zona întinsă)",
  "struct.arg.formula_exemplu_sursa": "(foaia B: AX15; A_s = {bare}).",
  "struct.arg.sectiunea_la": "Secțiunea la {unde}",
  "struct.arg.la_reazem_r1": "reazem (R1)",
  "struct.arg.la_mijlocul_campului": "mijlocul câmpului",
  "struct.arg.cota_placa": "placă {v}",
  "struct.arg.valori_mcr": "M_cr = {mcr} kNm; I_I = {ii} cm⁴; I_II(câmp) = {iii} cm⁴ (x_II = {x} cm, ζ = {zeta})",
  "struct.arg.incercari#n": "1 încercare|{n} încercări|{n} de încercări",
  "struct.arg.taie_bara": "De ce se taie bara",
  "struct.arg.otelul_livreaza_bare": "Oțelul se livrează în bare de 12 m. Un traseu mai lung se croiește din bucăți care se petrec una peste alta pe lungimea de înnădire l₀ (EC2 §8.7.3: l₀ = 1,5·l_bd când peste jumătate din bare se înnădesc în aceeași secțiune).",
  "struct.arg.lungimea_suprapunerii_ba": "Pe lungimea suprapunerii bara nu transmite efortul prin secțiunea ei, ci prin aderența la beton — de aceea înnădirea se pune acolo unde bara e cel mai puțin solicitată: barele de SUS în câmp (fibra de sus e comprimată acolo), cele de JOS lângă reazem.",
  "struct.arg.1_geometria_sectiunea": "1. Geometria și secțiunea activă",
  "struct.arg.3_combinatia_dimensionea": "3. Combinația care dimensionează",
  "struct.arg.4_armarea_aleasa": "4. Armarea aleasă (soluția finală + cum s-a ajuns la ea)",
  "struct.arg.pasul_pune_multipli": "Pasul se pune la multipli de 2,5 cm; plafoanele normative se rotunjesc ÎN JOS la cuanta asta.",
  "struct.arg.5_momentele_capabile": "5. Momentele capabile și verificarea R/E",
  "struct.arg.forta_axiala_concomitent": "forța axială concomitentă",
  "struct.arg.6_ductilitatea_sectiunii": "6. Ductilitatea secțiunii: x ≤ x_u",
  "struct.arg.7_dirijarea_articulatiei": "7. Dirijarea articulației plastice (regula 1,45)",
  "struct.arg.8_forta_taietoare": "8. Forța tăietoare — trei zone",
  "struct.arg.q_10_v": "Q̄ = 10·V/(b·d·f_ctd) — intensitatea relativă a tăietoarei",
  "struct.arg.9_sls_sageata": "9. SLS — săgeata și deschiderea fisurilor (exploatare)",
  "struct.arg.momentul_cvasipermanent": "momentul cvasipermanent (GS) în secțiune",
  "struct.arg.efortul_armatura_intinsa": "efortul în armătura întinsă în stadiul II",
  "struct.arg.distanta_maxima_intre": "distanța maximă între fisuri",
  "struct.arg.deschiderea_caracteristi": "deschiderea caracteristică a fisurii",
  "struct.arg.10_rotirile_capabile": "10. Rotirile capabile ale articulațiilor (INFORMATIV)",
  "struct.arg.10b_reguli_constructive": "10b. Reguli constructive — armarea trebuie să fie și EXECUTABILĂ",
  "struct.arg.11_interfata_catre": "11. Interfața către pasul stâlpilor",
  "struct.arg.momentul_calcul_negativ": "momentul de calcul; negativ = fibra de sus întinsă",
  "struct.arg.pozitia_statiei_axul": "poziția stației, din axul stâlpului 1",
  "struct.arg.forta_axiala_concomitent2": "forța axială concomitentă (negativ = compresiune)",
  "struct.arg.combinatia_da_extremul": "combinația care dă extremul — sursa întregului rând",
  "struct.arg.raportul_capabil_efectiv": "raportul capabil / efectiv — sub 1 nu se verifică",
  "struct.arg.constanta_a_metodei": "constantă a metodei",
  "struct.arg.acoperirea_utila_sus": "acoperirea utilă sus (a_sus = c + Ø/2 [+1,5 cm rândul 2])",
  "struct.arg.inaltimea_utila_d": "înălțimea utilă d = h − a_sus",
  "struct.arg.distanta_intre_armaturi": "distanța între armături ds = d − a_jos",
  "struct.arg.bratul_parghie_z": "brațul de pârghie z (corectat cu poziția armăturii din placă)",
  "struct.arg.sageata_durata_vs": "săgeata de durată δ vs limita l₀/250 (totală) și l₀/500 (informativ, după finisaje)",
  "struct.arg.pasul_ruleaza": "Pasul rulează…",
  "struct.arg.grinda_extrag_eforturile": "Pentru fiecare grindă: se extrag eforturile per combinație din tensorul Pasului 11, se alege armarea în buclă, se verifică momentele capabile, axa neutră, dirijarea articulației plastice și forța tăietoare pe 3 zone — după foaia de verificare a structuristului (GRINZI_CP).",
  "struct.arg.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.arg.inseamna_verdictul": "Ce înseamnă verdictul.",
  "struct.arg.taietoarea": "tăietoarea",
  "struct.arg.ductilitatea_sectiunii": "ductilitatea secțiunii",
  "struct.arg.marja_subdimensionare_ac": "Marja de subdimensionare acceptată:",
  "struct.arg.bucati": "bucăți",
  "struct.arg.otel_bara_m": "oțel / bară [m]",
  "struct.arg.zonele_portocalii_capete": "Zonele prună de la capete = porțiunile RIGIDE.",
  "struct.arg.bara_dedublata_petrecere": "Bara DEDUBLATĂ = petrecerea",
  "struct.arg.banda_rosie_capete": "banda roșie de la capete e zona critică",
  "struct.arg.zona_rigida": "Ce e «zona rigidă».",
  "struct.arg.conteaza": "De ce contează.",
  "struct.arg.fata_stalpului": "FAȚA stâlpului",
  "struct.arg.consecinta_practica": "Consecința practică.",
  "struct.arg.zona_rigida_lunga": "Cu cât zona rigidă e mai lungă (stâlpi lați, lamele), cu atât grinda «lucrează» pe o deschidere mai mică — momentul de câmp scade și o grindă la limită poate trece verificările doar pentru că stâlpul s-a lățit. Dar câștigul nu e gratuit: același stâlp mai lat SCURTEAZĂ lungimea de forfecare L_as, deci CREȘTE tăietoarea de calcul capabil V_Ed,cap = γ_Rd·ΣM_Rd/L_as (secțiunea 8), și strânge ancorarea barelor prin nod — vezi plafonul de Ø din secțiunea 10b și verificarea de la Pasul 15.",
  "struct.arg.ax": "de pe ax",
  "struct.arg.sus_suplimentar_r2": "Sus suplimentar la R2",
  "struct.arg.bare_inclinate_45": "Bare înclinate 45°",
  "struct.arg.zona_comprimata_prea": "Zona comprimată e prea adâncă și armătura de pe fața comprimată nu mai poate fi mărită (pe o față încap cel mult 2 rânduri de bare). Asta NU se rezolvă cu mai mult oțel — secțiunea de beton este prea mică pentru momentul care i se cere. Soluții, în ordinea costului: grindă mai înaltă (h mai mare crește d și deci x_u), grindă mai lată (b mai mare face zona comprimată mai eficientă), sau redistribuirea momentului către alte elemente. Vezi jurnalul de iterații de mai jos pentru punctul exact unde se depășește.",
  "struct.arg.v_rd_s": "V_Rd,s după EC2 (informativ)",
  "struct.arg.bare_inclinate": "Bare înclinate:",
  "struct.arg.sectiunea": "Secțiunea",
  "struct.arg.termenii_folositi_romane": "Termenii folosiți, pe românește",
  "struct.arg.combinatia": "Combinația",

  // --- STRUCTURĂ · Pasul 16, armarea plăcii -----------------------------
  "struct.arpl.unde_vin_momentele": "De unde vin momentele",
  "struct.arpl.conturul_ochiului_rezult": "Conturul ochiului nu e în rezultatul Pasului 7 (rezultat vechi) — desenul se face din contur, deci rulează din nou Pasul 7.",
  "struct.arpl.grinda": "■ grindă",
  "struct.arpl.perete_sub_placa": "■ perete de sub placă",
  "struct.arpl.fara_reazem": "■ fără reazem",
  "struct.arpl.rosu_x": "roșu = X",
  "struct.arpl.incastrat_continuu": "încastrat (continuu)",
  "struct.arpl.pasul_ruleaza": "Pasul rulează…",
  "struct.arpl.dimensioneaza_ochiurile": "Se dimensionează ochiurile de placă: schema de reazem din laturile Pasului 7, încărcarea din feliile Pasului 8, momentele din repartiția pe două direcții, apoi plasele și verificările.",
  "struct.arpl.infasuratoarea": "înfășurătoarea",
  "struct.arpl.ochiurile_placa": "Ochiurile de placă",
  "struct.arpl.ochi_panoul_placa": "Un «ochi» e panoul de placă dintre reazemele lui — grinzi, pereți, sau marginea clădirii. Alege ochiul din listă (sau click pe el în clădire): mai jos e nota lui de calcul completă, desenată.",
  "struct.arpl.dreapta_cladirea_intreag": "În dreapta e clădirea întreagă, cu ochiul ales aprins în GALBEN: ochiurile de placă sunt suprafețe, iar click pe oricare îl alege aici. Click pe o grindă sau pe un stâlp deschide pasul care îl armează.",
  "struct.arpl.directie": "Direcție",
  "struct.arpl.capatul_i": "Capătul i",
  "struct.arpl.capatul_j": "Capătul j",
  "struct.arpl.incarcarea": "Încărcarea",
  "struct.arpl.coeficienti": "Coeficienți",
  "struct.arpl.m_camp": "M câmp",
  "struct.arpl.directia_duce_incarcare": "direcția nu duce încărcare",
  "struct.arpl.fem_guverneaza": "· FEM guvernează",
  "struct.arpl.pozitie": "Poziție",
  "struct.arpl.peste_gama": "(peste gamă)",
  "struct.arpl.consola_are_alta": "Consola are ALTĂ schemă statică decât ochiul: se încastrează în placă, deci armătura ei e SUS și continuă în câmpul plăcii, iar săgeata se verifică cu K = 0,4. Peretele de pe latura balconului (de zidărie, sau de beton dacă arhitectura îl cere acolo) apasă la capăt, unde brațul e cel mai mare.",
  "struct.arpl.verificarile": "Verificările",
  "struct.arpl.iesire": "Ieșire",
  "struct.arpl.prindere_placa": "Prindere în placă",
  "struct.arpl.armatura_sus": "Armătura de sus",
  "struct.arpl.nicio_consola_pasul": "Nicio consolă: Pasul 2 nu a găsit plăci în consolă (balcoane) pe nivelurile modelate.",
  "struct.arpl.transferul_diafragma_per": "Transferul de la diafragmă la pereți",
  "struct.arpl.armatura_conectare": "Armătură de conectare",
  "struct.arpl.strapungerea": "Străpungerea",
  "struct.arpl.stalp": "Stâlp",
  "struct.arpl.v_ed_prin": "V_Ed prin placă",
  "struct.arpl.ochiuri_casa_scarii": "Ochiuri cu casa scării / lift / ghenă",
  "struct.arpl.acolo_placa_are": "Acolo placa are în realitate GOL, dar Pasul 2 dă zona (cu eticheta din desen), nu conturul golului: placa e modelată continuă, deci masa și rigiditatea sunt supraevaluate local, iar marginea golului nu se verifică.",
  "struct.arpl.verifica_pasul_inca": "Ce NU verifică pasul (încă)",

  // --- STRUCTURĂ · Pasul 18, armarea fundației --------------------------
  "struct.arf.pasul_ruleaza": "Pasul rulează…",
  "struct.arf.armeaza_grinzile_fundare": "Se armează grinzile de fundare, ax cu ax: barele longitudinale din înfășurătoarea de momente a Pasului 12, etrierii din modelul de grindă cu zăbrele, plasa tălpii din momentul consolei.",
  "struct.arf.b_h_inima": "B × H · inimă",
  "struct.arf.otel": "Oțel",
  "struct.arf.piesa_spatiu": "Piesa în spațiu",
  "struct.arf.albastru_carcasa_continu": "Albastru = carcasa continuă (merge cap la cap), chihlimbar = barele suplimentare, fiecare pe intervalul ei — capetele estompate sunt decalarea a_l plus ancorarea l_bd. Etrierii sunt desenați chiar la pasul zonei lor; verde = plasa transversală și repartiția din talpă. Cutiile gri de deasupra sunt stâlpii.",
  "struct.arf.barele_suplimentare_unde": "Barele suplimentare și unde se taie",
  "struct.arf.fata": "Fața",
  "struct.arf.lucreaza": "Lucrează pe",
  "struct.arf.bara_croita": "Bara croită",
  "struct.arf.randul_2": "· rândul 2",
  "struct.arf.etrierii_zone": "Etrierii, pe zone",
  "struct.arf.pana": "De la … până la",
  "struct.arf.v_maxim_zona": "V maxim în zonă",
  "struct.arf.eforturile_au_cerut": "Eforturile care au cerut armătura",
  "struct.arf.m_fibra_jos": "M⁺ (fibra de jos întinsă)",
  "struct.arf.m_fibra_sus": "M⁻ (fibra de sus întinsă)",
  "struct.arf.starea_verifica_fisura": "(starea în care se verifică fisura)",
  "struct.arf.armatura_aleasa": "Armătura aleasă",
  "struct.arf.pozitia": "Poziția",
  "struct.arf.aleasa": "Aleasă",
  "struct.arf.observatii": "Observații",
  "struct.arf.etrieri_inima": "etrieri în inimă",
  "struct.arf.transversale_talpa": "transversale în talpă",
  "struct.arf.consola_talpii_np": "consola tălpii (NP 112 §II.6.1.1)",
  "struct.arf.repartitie_talpa": "repartiție în talpă",
  "struct.arf.armaturi_laterale": "armături laterale",
  "struct.arf.verificarile_axului": "Verificările axului",
  "struct.arf.unde_ax": "Unde pe ax",
  "struct.arf.otelul_axului_pozitii": "Oțelul axului, pe poziții",
  "struct.arf.bucati": "Bucăți",
  "struct.arf.aplica_grinzii_fundare": "Ce NU se aplică grinzii de fundare",
  "struct.arf.cerinte_le_are": "Cerințe pe care le are o grindă de etaj și pe care aici NU le verificăm — declarate explicit, ca lipsa lor din tabel să nu arate a scăpare.",

  // --- STRUCTURĂ · preferințele de calcul --------------------------------
  "struct.pref.incarca": "Se încarcă…",
  "struct.pref.setari_calcul": "Setări de calcul",
  "struct.pref.valori_alese_cautare": "Valori alese de căutare pentru soluția curentă (lățirea tălpii, îngroșarea plăcii, plafonul unei grinzi). Ele se folosesc în calcul PESTE setările tale, dar nu le înlocuiesc: se șterg la reset și se refac la rularea următoare.",
  "struct.pref.reglat": "Reglat la",
  "struct.pref.executia_armaturii": "Execuția armăturii",

  // --- STRUCTURĂ · Pasul 4, modelul structural ---------------------------
  "struct.modl.nivel_infrastructura_sal": "nivel de infrastructură: saltul față de suprastructură e cel urmărit de cutia rigidă, nu o neregularitate",
  "struct.modl.sub_prag_nivelul": "sub prag: nivelul e mai moale decât permite §4.4.3.3(2)",
  "struct.modl.12ei_h3_stalpii": "Σ12EI/h³ pe stâlpii nivelului, cu nodurile blocate la rotire — informativ; ignoră grinzile",
  "struct.modl.raportul_rigiditate_cadr": "raportul de rigiditate de cadru față de nivelul de dedesubt",
  "struct.modl.unde_punem_stalpii": "Unde punem stâlpii?",
  "struct.modl.stalp_picior_masa": "Un stâlp e ca un picior de masă: ține planșeul sus. Punem câte unul în fiecare colț al fiecărei camere și oriunde două grinzi se întâlnesc sau își schimbă direcția.",
  "struct.modl.grinda_duce_greutatea": "Grinda duce greutatea planșeului către capete — acolo trebuie să o aștepte un stâlp care s-o ducă mai departe, în jos, până la fundație. Un colț fără stâlp e ca o masă fără picior în colțul acela.",
  "struct.modl.unde_punem_grinzile": "Unde punem grinzile?",
  "struct.modl.grinda_bara_beton": "Grinda e o bară de beton culcată, ascunsă în perete deasupra ușilor și ferestrelor. Ea prinde marginea planșeului și îi duce greutatea spre stâlpi. Punem grinzi pe axele pereților persistenți (cei care există pe toate nivelurile), ca fiecare cameră să fie înrămată.",
  "struct.modl.daca_grinda_sta": "Dacă grinda stă pe perete, nu se vede în cameră (arhitectului nu-i plac grinzile aparente). Fiecare cameră devine un «ochi de placă”: o ramă închisă de grinzi pe care stă planșeul, ca o pânză întinsă pe un cadru.",
  "struct.modl.unde_vin_inaltimile": "De unde vin înălțimile etajelor?",
  "struct.modl.etaj_model_are": "Fiecare etaj din model are exact înălțimea lui reală, preluată din Pasul 2: acolo s-au citit cotele de nivel scrise pe fațade (ex. «COTA BETON ETAJ 1 +3.35”), iar înălțimea unui etaj e diferența dintre două cote consecutive: h_etaj = cota_nivel_superior − cota_nivel.",
  "struct.modl.inaltimea_etajului_lungi": "Înălțimea etajului e lungimea stâlpilor — intră direct în rigiditatea lor (care scade cu puterea a 3-a a lungimii!), în greutatea structurii și în cotele la care stau planșeele. O valoare presupusă greșit ar strâmba toate analizele următoare.",
  "struct.modl.daca_doi_stalpi": "Dacă doi stâlpi legați de o grindă sunt la mai mult de 6 m unul de altul, grinda ar trebui să care prea mult singură. Punem un stâlp la mijloc; dacă nici așa nu ajunge, doi stâlpi la treimi — până când nicio bucată nu depășește 6 m.",
  "struct.modl.grinda_scandura_intre": "O grindă e ca o scândură între două scaune: cu cât scaunele sunt mai depărtate, cu atât se îndoaie mai tare la mijloc (săgeata crește cu puterea a 4-a a deschiderii!). La beton, peste ~6 m grinda ar trebui să fie mult mai înaltă și mai scumpă — e mai ieftin un stâlp în plus.",
  "struct.modl.sectiunea_stalpului_cm": "secțiunea stâlpului, în cm",
  "struct.modl.presupusa_initial_pasul": "presupusă inițial (Pasul 4); se redimensionează la calculul de rezistență",
  "struct.modl.distanta_maxima_intre": "distanța maximă între doi stâlpi pe aceeași grindă",
  "struct.modl.regula_practica_document": "regulă practică din documentul de metodă — peste 6 m se adaugă stâlpi intermediari (1 la mijloc sau 2 la treimi)",
  "struct.modl.latimea_inaltimea_grinzi": "lățimea × înălțimea grinzii, în cm",
  "struct.modl.liniile_stau_grinzile": "liniile pe care stau grinzile (mijlocul pereților persistenți)",
  "struct.modl.peretii_persistenti_nive": "pereții persistenți pe toate nivelurile, din analiza arhitecturii (Pasul 2)",
  "struct.modl.inaltimea_fiecarui_etaj": "înălțimea fiecărui etaj, în metri",
  "struct.modl.pasul_2_cotele": "Pasul 2 — cotele de nivel citite din fațade",
  "struct.modl.cota_fiecarui_planseu": "cota fiecărui planșeu (înălțimile cumulate: z₁ = h₁, z₂ = h₁ + h₂ …)",
  "struct.modl.calculata_pas_inaltimile": "calculată în acest pas din înălțimile Pasului 2",
  "struct.modl.inaltime_rezerva_folosit": "înălțime de rezervă, folosită doar dacă Pasul 2 nu a găsit cota unui nivel",
  "struct.modl.valoare_implicita_apare": "valoare implicită — apare avertisment când e folosită",
  "struct.modl.deschiderea_maxima_admis": "deschiderea maximă admisă între stâlpi",
  "struct.modl.regula_practica_document2": "regulă practică din documentul de metodă (Faza 2)",
  "struct.modl.stalpi_adaugati_aceasta": "stâlpi adăugați de această regulă la etajul curent",
  "struct.modl.calculati_automat_pas": "calculați automat în acest pas",
  "struct.modl.modul": "Pe modul",
  "struct.modl.pasul_ruleaza": "Pasul rulează…",
  "struct.modl.structura_propune_pereti": "Structura se propune pe pereții persistenți din Pasul 2 (aceiași stâlpi și grinzi la fiecare etaj), apoi se desenează diagrama fiecărui etaj cu pereții lui simplificați și pereții persistenți.",
  "struct.modl.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.modl.presupuneri_initiale_rev": "Presupuneri inițiale (revenim la ele)",
  "struct.modl.clasa": "Clasă",
  "struct.modl.pereti_proprii_m": "Pereți proprii [m]",
  "struct.modl.stalpi_noi": "Stâlpi noi",
  "struct.modl.stalpi_plantati": "Stâlpi plantați",
  "struct.modl.stalpi_placa": "Stâlpi pe placă",
  "struct.modl.stalpi_liberi": "Stâlpi liberi",
  "struct.modl.fara_structura_m": "Fără structură [m]",
  "struct.modl.toate": "toate",
  "struct.modl.stalpii_plantati_element": "Stâlpii PLANTAȚI (elemente seismice PRINCIPALE — decizia din element seismic PRINCIPAL): există doar la etaj, cu baza pe o grindă de transfer/gazdă de la nivelul de jos, nu pe fundație. Grinda-gazdă primește cerințe amplificate la Pasul 13 (calcul capabil: γ_Rd plus componenta verticală a seismului) și armătură de suspendare (EC2 §9.2.5), iar baza stâlpului se verifică la Pasul 15 ca ancorare în grindă.",
  "struct.modl.stalp": "Stâlp",
  "struct.modl.exista_doar_nivelul": "Există doar la nivelul",
  "struct.modl.plantat_grinda": "Plantat pe grinda",
  "struct.modl.verificarile_amplasare": "Verificările de amplasare",
  "struct.modl.regulile_respectate": "✓ toate regulile respectate",
  "struct.modl.regula_incalcata_desfaso": "Fiecare regulă încălcată se desfășoară: click pe un element din listă deschide etajul lui și îl selectează pe planșa de mai jos (albastru). Linkul e adresabil — îl poți copia sau trimite.",
  "struct.modl.regula": "Regulă",
  "struct.modl.incalcarile_una_cate": "Încălcările, una câte una",
  "struct.modl.peste_propunerea_automat": "Peste propunerea automată de mai sus se aplică overlay-ul persistent «modificari» al Pasului 19. Secțiunile stâlpilor de mai jos NU mai sunt cele 30×30 presupuse inițial — ele sunt cele care intră în Pasul 7 (FEM) și în Pasul 15. Fiecare op este validat contra benzii pereților persistenți: stâlpul lungit/lățit trebuie să rămână în perete (garanția «nu modificăm arhitectura»). «Alunecarea» este deplasarea centrului stâlpului (pe axa lungă, pe cea scurtă) necesară ca amprenta nouă să încapă în perete.",
  "struct.modl.sectiunea_rezultata_cm": "Secțiunea rezultată [cm]",
  "struct.modl.op_uri_sarite": "Op-uri SĂRITE — cerute de Pasul 19, dar geometria pereților nu le permite. Ele rămân în overlay (se reîncearcă la fiecare rulare) și NU sunt aplicate în model. Același tabel, grupat pe cauză, se vede și în raportul Pasului 19:",
  "struct.modl.maxim_x_cm": "Maxim pe X [cm]",
  "struct.modl.maxim_y_cm": "Maxim pe Y [cm]",
  "struct.modl.propunerea_naste_dintr": "Propunerea nu se naște dintr-o singură dată: pasul 1 e generatorul naiv (o grindă pe fiecare perete, stâlpi la capete), iar fiecare pas următor adaugă EXACT o reparare deterministă peste starea de dinaintea lui. Fiecare stare e înghețată într-o clonă vizitabilă («breakpoint»), ca să se vadă imediat care pas introduce o problemă — o grindă oblică, un colț în cameră. Soluția continuă cu ULTIMUL pas: el e geometria pe care merg Pașii 5→16, iar pagina de deasupra o arată pe ea.",
  "struct.modl.adauga": "Ce adaugă",
  "struct.modl.stalpi": "Stâlpi",
  "struct.modl.starea_inghetata": "Starea înghețată",
  "struct.modl.a_esuat": "✗ a eșuat",
  "struct.modl.geometria_ecran": "✓ e geometria de pe ecran",
  "struct.modl.fara_clona": "fără clonă",

  // --- STRUCTURĂ · Pasul 2, citirea arhitecturii -------------------------
  "struct.arh.descarca_dwg": "Descarcă DWG",
  "struct.arh.unde_vin_inaltimile": "De unde vin înălțimile?",
  "struct.arh.fatadele_au_scrise": "Fațadele au scrise cotele fiecărui nivel (ex. «COTA BETON PARTER -0.15”, «COTA BETON ETAJ 1 +3.35”). Formula: h_etaj = cota nivelului de deasupra − cota nivelului. Ex.: +3.35 − (−0.15) = 3,50 m.",
  "struct.arh.inaltimea_etaj_intra": "Înălțimea de etaj intră direct în modelul structural (Pasul 4: lungimea stâlpilor și cotele planșeelor) și în calculul greutății clădirii. Cotele BETON (structurale) sunt preferate celor FINIT, pentru că măsoară exact între plăcile de beton — pe ele stau stâlpii.",
  "struct.arh.peretii_simplificati": "Ce sunt pereții simplificați?",
  "struct.arh.peretii_plan_redusi": "Pereții din plan, reduși la dreptunghiuri drepte. Un perete în T sau L devine două dreptunghiuri care se suprapun; bucățile tăiate de stâlpi se unesc într-un singur dreptunghi continuu. Se detectează și pereții desenați de mână doar din linii — spațiul dintre două linii paralele.",
  "struct.arh.analiza_structurala_are": "Analiza structurală are nevoie de geometrie simplă și robustă: dreptunghiuri cu axă și grosime, nu conturul zimțat din desenul de arhitectură. Criteriul de calitate: cel puțin 90% din punctele layerului de pereți trebuie să cadă în dreptunghiuri — procentul e afișat per nivel.",
  "struct.arh.golurile_fasii_coliniare": "Golurile ca fâșii coliniare cu peretele",
  "struct.arh.usa_fereastra_devine": "Fiecare ușă și fereastră devine o fâșie subțire, pe axa peretelui în care stă și cu grosimea lui — aceeași formă ca pereții simplificați, ca să poată fi folosită la fel. Tipul vine din rolul layerului (uși / ferestre), iar peretele-gazdă se atașează când există unul coliniar.",
  "struct.arh.peste_gol_poate": "Peste un gol se poate trece cu o grindă fără să deranjezi arhitectura — dar numai dacă știi unde e golul. Până acum Pasul 2 nu exporta nimic despre ele: Pasul 4 își deducea singur câteva, doar pe cele care leagă doi pereți coliniari.",
  "struct.arh.zonele_afara": "Zonele «de afară»",
  "struct.arh.terasele_balcoanele_logi": "Terasele, balcoanele și logiile nivelului, cu conturul lor. Vin din două locuri care se completează: eticheta de zonă a arhitectului (dă numele și conturul camerei) și plăcile în consolă măsurate geometric (dau ce nu e etichetat).",
  "struct.arh.suprafata_construita_dec": "Sunt suprafață construită, deci intră în planșeu — dar nu sunt camere: pe o terasă nu se pune stâlp în mijloc, iar un balcon sub 2 m se face placă de beton simplă (pereții de pe laturile lui rămân de zidărie). Fără ele, cele 32 m² de terasă ale etajului 1 ajungeau ochiuri obișnuite de placă în Pasul 7.",
  "struct.arh.cotele_unde_luate": "Cotele — de unde sunt luate",
  "struct.arh.rand_text_existent": "Fiecare rând e un TEXT existent în desenul de fațadă, citit ca atare: nivelul la care se referă, cota în metri și textul exact din DWG. Coloana «Sursă” spune din ce fișier — se poate deschide desenul și verifica textul.",
  "struct.arh.cota_valoare_citita": "O cotă e o valoare citită, nu calculată: dacă interpretarea e greșită, tot ce urmează (înălțimile de etaj, lungimile stâlpilor, greutatea clădirii) e greșit. De aceea se afișează textul-sursă și fișierul din care vine.",
  "struct.arh.inseamna_coloana": "Ce înseamnă fiecare coloană",
  "struct.arh.datele_masurate_nivel": "Datele măsurate pentru fiecare nivel — ele se preiau mai departe în Pașii 3, 4, 5 și 7, ca toate calculele să folosească aceleași valori.",
  "struct.arh.a_vs_c": "A vs C — cine primește ce încărcare utilă",
  "struct.arh.etichetele_spatiilor_pla": "Etichetele spațiilor de pe plan sunt clasificate: A = spații de locuit (q = 1,5 kN/mp), C = circulații și spații comune la clădiri colective — casa scării, holuri comune, balcoane (q = 3,0 kN/mp). La case totul rămâne A.",
  "struct.arh.pasul_8_aplica": "Pasul 8 aplică încărcarea utilă diferențiat: cazul Q1 pe zonele A și Q2 pe zonele C — aria C a fiecărui nivel decide unde cade încărcarea mai mare (SR EN 1991-1-1).",
  "struct.arh.inaltimea_unui_nivel": "înălțimea unui nivel față de reperul ±0.00 al clădirii, în metri",
  "struct.arh.textele_fatade_citite": "textele din fațade, citite de LLM",
  "struct.arh.inaltimea_etajului_difer": "înălțimea etajului = diferența dintre două cote consecutive",
  "struct.arh.calculata_aici_folosita": "calculată aici; folosită de Pașii 3, 4 și 7",
  "struct.arh.inaltimea_rezerva_cand": "înălțimea de rezervă când nu se găsesc cote",
  "struct.arh.valoare_implicita_apare": "valoare implicită — apare avertisment când e folosită",
  "struct.arh.acoperirea_punctelor_lay": "acoperirea punctelor layerului de pereți",
  "struct.arh.criteriul_acceptare_extr": "criteriul de acceptare al extracției — sub prag apare avertisment",
  "struct.arh.toleranta_unirea_bucatil": "toleranța la unirea bucăților coliniare",
  "struct.arh.unghiuri_180_acelasi": "unghiuri de ~180° = același perete, prelungit până în colțuri",
  "struct.arh.nivelul_refera_cota": "nivelul la care se referă cota",
  "struct.arh.potrivit_llm_numele": "potrivit de LLM cu numele nivelurilor din planurile de arhitectură",
  "struct.arh.inaltimea_fata_reperul": "înălțimea față de reperul ±0.00, în metri",
  "struct.arh.numarul_textul_fatada": "numărul din textul de fațadă",
  "struct.arh.textul_exact_dwg": "textul exact din DWG",
  "struct.arh.entitatea_tip_text": "entitatea de tip text din desenul de fațadă",
  "struct.arh.fisierul_dwg_s": "fișierul DWG din care s-a extras nivelul",
  "struct.arh.planurile_arhitectura_in": "planurile de arhitectură încărcate — se deschide din butonul «vezi desenul”",
  "struct.arh.nivelul_foloseste_planul": "nivelul folosește planul unui etaj de dedesubt — la blocuri, etajele identice au un singur plan desenat",
  "struct.arh.titlul_planului_plan": "titlul planului («PLAN ETAJ 1÷3”) sau, dacă nu scrie nimic, presupunerea că etajul 1 se repetă până iese numărul de niveluri din fațadă",
  "struct.arh.cati_milimetri_are": "câți milimetri are o unitate a planului (1 = mm, 1000 = m)",
  "struct.arh.dedusa_inaltimea_textelo": "dedusă din înălțimea textelor — antetul DXF o dă greșit pe multe planuri; toate lungimile de mai jos sunt calculate după aducerea la milimetri",
  "struct.arh.inaltimea_etajului_dista": "înălțimea etajului (distanța pe verticală între placa lui și placa de deasupra)",
  "struct.arh.diferenta_cotelor_fatade": "diferența cotelor din fațade — scăderea exactă apare sub cifră; folosită de modelul structural (Pasul 4)",
  "struct.arh.suprafata_construita_a": "suprafața construită a nivelului (conturul exterior al pereților)",
  "struct.arh.masurata_aici_folosita": "măsurată aici; folosită de strategia structurală (Pasul 3) și fundație (Pașii 5–6)",
  "struct.arh.criteriul_calitate_proce": "criteriul de calitate: ce procent din punctele desenului de pereți cad în dreptunghiurile simplificate (ținta ≥ 90%)",
  "struct.arh.masurat_aici_sub": "măsurat aici — sub prag apare avertisment",
  "struct.arh.cati_pereti_simplificati": "câți pereți simplificați au rezultat pe nivel",
  "struct.arh.extractia_pas": "extracția din acest pas",
  "struct.arh.suma_lungimilor_peretilo": "suma lungimilor pereților simplificați",
  "struct.arh.calculata_dreptunghiuri": "calculată din dreptunghiuri",
  "struct.arh.clasificarea_llm_a": "clasificarea LLM a etichetelor de spații",
  "struct.arh.circulatii_comune_balcoa": "circulații comune / balcoane la blocuri — q = 3,0 kN/mp",
  "struct.arh.idem_zona_camera": "idem; zona = camera care conține eticheta",
  "struct.arh.poligonul_desenat_diagra": "poligonul desenat pe diagramă",
  "struct.arh.camera_ingradita_intre": "camera îngrădită între pereții simplificați; la spațiile deschise, marcaj cu aria din stamp-ul de zonă, decupat pe aceiași pereți",
  "struct.arh.sursa_necunoscuta": "sursă necunoscută",
  "struct.arh.unde_vine_cifra": "De unde vine fiecare cifră a pasului: pe ce layere s-a găsit structura, cu cât s-a închis o amprentă întreruptă de uși, ce s-a presupus în lipsa etichetelor. Nu sunt verificări — pasul ăsta citește planurile, nu judecă structura, deci nimic de aici nu «pică» sau «trece». Ce PICĂ se vede la pașii cu criterii, adunat în Pasul 19.",
  "struct.arh.toata_cladirea": "toată clădirea",
  "struct.arh.pasul_ruleaza": "Pasul rulează…",
  "struct.arh.identificarea_nivelurilo": "Identificarea nivelurilor și fațadelor (LLM), citirea cotelor de nivel din fațade, apoi pentru fiecare etaj: alegerea layerelor și calculul pereților simplificați. Prima rulare poate dura câteva minute (desenele se interpretează pe rând).",
  "struct.arh.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.arh.regim_inaltime": "Regim de înălțime",
  "struct.arh.cota": "Cotă",
  "struct.arh.text_sursa": "Text sursă",
  "struct.arh.sursa": "Sursă",
  "struct.arh.cotele_nivel_s": "Cotele de nivel — nu s-au găsit",
  "struct.arh.fatada_incercata": "Fațada încercată",
  "struct.arh.plan_sursa_dwg": "Plan-sursă (DWG)",
  "struct.arh.inaltime": "Înălțime",
  "struct.arh.lungime_totala": "Lungime totală",
  "struct.arh.peretii_simplificati2": "pereții simplificați",
  "struct.arh.tip_cladire": "Tip clădire",

  // --- STRUCTURĂ · devizul, rețetele de execuție și prețurile ------------
  "struct.ret.incarca": "Se încarcă…",
  "struct.ret.deviz_retete_executie": "Deviz, rețete de execuție & costuri",
  "struct.ret.afiseaza_sumele": "Afișează sumele în",
  "struct.ret.devizul_apare_dupa": "Devizul apare după ce au rulat pașii care dau cantitățile (7, 6, 12, 13, 14, 16).",
  "struct.ret.componentele_apar_odata": "Componentele apar odată cu devizul, după ce au rulat pașii de armare.",
  "struct.ret.planul_cofrare_apare": "Planul de cofrare apare odată cu devizul, după ce au rulat pașii care dau geometria (4, 7, 12, 13).",
  "struct.ret.apasa_articol_sa": "Apasă pe un articol ca să vezi din ce e făcut. La armătură, expandul merge până la extrasul de bare.",
  "struct.ret.p_u_manopera": "P.U. manoperă",
  "struct.ret.total_manopera": "Total manoperă",
  "struct.ret.total_cost_direct": "TOTAL COST DIRECT (fără TVA)",
  "struct.ret.cost_direct_pret": "De la cost direct la preț",
  "struct.ret.procente_aplicate_dupa": "Procente, aplicate DUPĂ partea exactă. Ordonarea soluțiilor (Pasul 6, Pasul 19) rămâne pe costul direct: procentele sunt multiplicatori care nu depind de mutare, deci ar umfla fiecare deltă fără să schimbe ordinea.",
  "struct.ret.deviz_declarat_ascuns": "Ce NU e în deviz (declarat, nu ascuns)",
  "struct.ret.articolele_jos_exista": "Articolele de mai jos există într-un deviz real, dar nu le putem calcula încă din model. Nu se acoperă cu procente: un articol lipsă care nu se vede face devizul să pară complet exact acolo unde nu e.",
  "struct.ret.unde_vine_pretul": "De unde vine prețul:",
  "struct.ret.extrasul_armatura_bara": "Extrasul de armătură — bară cu bară",
  "struct.ret.lungimile_includ_ancorar": "Lungimile includ ancorările (EC2 §8.4), înnădirile (§8.7), deviația diagramei de momente (§9.2.1.3) și cârligele de 10·Ø (P100-1 §5.7.1(5)). Apasă pe un element ca să vezi pozițiile lui.",
  "struct.ret.compune_lungimea": "Din ce se compune lungimea",
  "struct.ret.derivat_norme": "Derivat din norme",
  "struct.ret.pret_referinta": "Preț de referință",
  "struct.ret.k_manopera": "k manoperă",
  "struct.ret.retetele_stabilesc_nivel": "Rețetele nu mai stabilesc NIVELUL prețului (îl dă referința): ele spun cum se execută elementul și, prin norme, cum se repartizează prețul pe elemente. Dau și durata și echipa.",
  "struct.ret.retetele": "← toate rețetele",
  "struct.ret.activitatile_normele_lor": "Activitățile și normele lor",
  "struct.ret.plateste": "Se plătește ca",
  "struct.ret.unde_vin_cantitatile": "De unde vin cantitățile",
  "struct.ret.folosesc_preturile_refer": "Cum se folosesc prețurile de referință",
  "struct.ret.preturile_referinta_eur": "Prețurile de referință (EUR fără TVA)",
  "struct.ret.modelul_transport_ramane": "Modelul de transport rămâne FIZIC unde km-ul se simte (betonul și pământul) și devine un singur procent unde nu se simte (oțel, cofraj, accesorii — 1,4 % din preț). Prețurile de material ale referinței sunt franco șantier în zona ei, deci formulele de mai jos adaugă numai DIFERENȚA față de ea.",
  "struct.ret.otelul_structura_pretulu": "Oțelul — structura prețului",
  "struct.ret.referinta_da_singur": "Referința dă un singur preț pentru tot oțelul. Scara de mai jos îl diferențiază pe clase de diametru, normalizată pe compoziția reală a proiectului (media ponderată rămâne prețul de referință). Fasonarea per BUCATĂ e implicit 0: pe devizul de referință ar fi ~1,6 % din costul oțelului — măsurabil, dar neglijabil față de incertitudinea celorlalte prețuri.",
  "struct.ret.manopera_raportul_dintre": "Manoperă (raportul dintre specializări)",
  "struct.ret.nivelul_decide_pretul": "Nivelul nu mai decide prețul — îl decide referința. Raportul dintre specializări decide însă cum se împarte manopera pe elemente.",
  "struct.ret.utilaje_operator_unde": "Utilaje (cu operator, unde e cazul)",
  "struct.ret.materiale_fara_reper": "Materiale fără reper în referință",
  "struct.ret.cursul_afisare": "Cursul de afișare",
  "struct.ret.salveaza": "Salvează",
  "struct.ret.revino_valorile_implicit": "Revino la valorile implicite",
  "struct.ret.intro": "Cantitățile vin din geometria și armarea calculate de pași — inclusiv din extrasul de armătură, bară cu bară. Nivelul prețurilor vine din <b>{referinta}</b>, repartizat pe elemente cu normele de execuție ale rețetelor: referința spune «10\u00a0€/m³ manoperă la orice beton», normele știu că turnarea unui stâlp de 2\u00a0m³ costă mai mult pe m³ decât a unei plăci de 25\u00a0m³. Din aceleași cifre ies prețurile unitare pe care Pasul\u00a06 și Pasul\u00a017 ordonează intervențiile.",
  "struct.ret.moneda_eur": "EUR (moneda de calcul)",
  "struct.ret.moneda_ron": "lei (curs {curs} din {la})",
  "struct.ret.deviz_incomplet": "Devizul e incomplet — mai trebuie: {lipsa}.",
  "struct.ret.tab_deviz": "Devizul",
  "struct.ret.tab_retete": "Rețete",
  "struct.ret.modificate": " (modificate)",
  "struct.ret.card_cost_direct": "Cost direct al structurii",
  "struct.ret.card_cost_direct_sub": "material + manoperă, fără TVA",
  "struct.ret.card_materiale": "Materiale",
  "struct.ret.card_materiale_sub": "beton pe clase, oțel pe diametre, cofraje",
  "struct.ret.card_manopera": "Manoperă",
  "struct.ret.card_manopera_sub": "inclusiv utilajele de punere în operă, ca în referință",
  "struct.ret.card_cu_indirecte": "Preț cu indirecte",
  "struct.ret.repere": "Repere de sănătate: <b>{kg} kg oțel/m³</b> de beton și <b>{cofraj} m² cofraj/m³</b> (pe devizul de referință ies {kg_ref} kg/m³ și {cofraj_ref} m²/m³).",
  "struct.ret.repere_in_afara": "<b>⚠ în afara benzii uzuale (100–220 kg/m³, 3–7 m²/m³) — semnal, nu eroare: se verifică armarea și geometria, nu prețul.</b>",
  "struct.ret.repere_total": "Total: {beton} m³ beton · {otel} kg oțel · {cofraj} m² cofraj.",
  "struct.ret.th_nr": "Nr",
  "struct.ret.th_articol": "Articol",
  "struct.ret.th_um": "U.M.",
  "struct.ret.th_cantitate": "Cantitate",
  "struct.ret.th_pu_material": "P.U. material",
  "struct.ret.th_total_material": "Total material",
  "struct.ret.cost_direct": "Cost direct",
  "struct.ret.total": "Total",
  "struct.ret.material_pu": "material {pu}",
  "struct.ret.manopera_pu": "manoperă {pu}",
  "struct.ret.ore_om_kg_paren": "({v} ore-om/kg)",
  "struct.ret.categoria_element": "Categoria de element",
  "struct.ret.extras_sumar#n": "1 poziție în categoria aleasă, din {total} pe proiect · {kg} kg cu sporul de pierderi de croire ({spor} %)|{n} poziții în categoria aleasă, din {total} pe proiect · {kg} kg cu sporul de pierderi de croire ({spor} %)|{n} de poziții în categoria aleasă, din {total} pe proiect · {kg} kg cu sporul de pierderi de croire ({spor} %)",
  "struct.ret.extras_calculat": " · {pct} % din oțel e calculat, restul e cotă forfetară",
  "struct.ret.th_poz": "Poz.",
  "struct.ret.th_rol": "Rol",
  "struct.ret.th_forma": "Forma",
  "struct.ret.th_buc": "Buc.",
  "struct.ret.th_lungime_bara": "Lungimea unei bare",
  "struct.ret.calibrare_titlu": "Calibrarea normelor pe prețul de referință",
  "struct.ret.calibrare_explicatie": "k = preț\u00a0de\u00a0referință × cantitate ÷ cost\u00a0derivat\u00a0din\u00a0norme. Media ponderată iese exact prețul de referință, iar diferențele dintre elemente rămân cele fizice. Un k în afara intervalului 0,5…2,5 e semn că norma e greșită, nu că piața e ciudată.",
  "struct.ret.th_familie": "Familia de lucrare",
  "struct.ret.th_k_material": "k material",
  "struct.ret.calibrare_otel": "Oțelul: prețul de referință e unul singur (0,79\u00a0€/kg), diferențiat pe diametru cu o scară normalizată (factor {factor}), plus suplimentul de fasonare al fiecărei familii de formă.",
  "struct.ret.th_activitate": "Activitate",
  "struct.ret.th_echipa": "Echipa",
  "struct.ret.th_utilaje": "Utilaje",
  "struct.ret.th_ore_om_um": "Ore-om / U.M.",
  "struct.ret.ore_din_extras": "după armătură",
  "struct.ret.ore_din_extras_t": "Nu e o normă pe kg: orele de montaj vin din extrasul de armătură al proiectului, pe familii de formă — bare drepte, drepte cu ciocuri, etrieri, agrafe, plase —, fiecare cu norma ei (ore-om/kg) din «Prețuri, zonă & norme → oțel». Un stâlp cu etrieri deși cere mai multe ore pe kg decât o placă cu bare drepte.",
  "struct.ret.din_extras": "din extrasul de armătură (per Ø și familie de formă)",
  "struct.ret.coduri_deviz": "Coduri de deviz",
  "struct.ret.flux": "Flux",
  "struct.ret.tarife_intro": "<b>{nume}</b> — {sursa}. Valorile sunt implicite la nivel de aplicație; ce salvezi aici e valabil doar pentru proiectul curent.",
  "struct.ret.mod_calcul": "Mod de calcul",
  "struct.ret.mod_calibrat": "calibrat — referința dă media, normele dau împrăștierea (recomandat)",
  "struct.ret.mod_referinta": "referință — preț plat, pentru comparație directă cu o ofertă",
  "struct.ret.mod_norme": "numai normele noastre — pentru diagnostic",
  "struct.ret.beton_material": "Beton {clasa} — material",
  "struct.ret.articol_material": "{articol} — material",
  "struct.ret.zona_proiectului": "Zona proiectului",
  "struct.ret.presetare": "Presetare",
  "struct.ret.spor_aprovizionare": "Spor de aprovizionare",
  "struct.ret.ori_pret_referinta": "× prețul de referință",
  "struct.ret.fasonare_familie": "Fasonare — {forma}",
  "struct.ret.montaj_familie": "Montaj — {forma}",
  "struct.ret.curs_leu_euro": "Curs leu/euro",
  "struct.ret.um_cursa": "€/cursă",
  "struct.ret.um_tona": "€/tonă",
  "struct.ret.um_ora_om": "€/oră-om",
  "struct.ret.um_ora": "€/oră",
  "struct.ret.um_buc": "€/buc",
  "struct.ret.um_ore_om_kg": "ore-om/kg",
  "struct.ret.salvat": "✓ salvat",
  "struct.ret.spec.dulgheri": "Dulgheri",
  "struct.ret.spec.fierari": "Fierari-betoniști",
  "struct.ret.spec.betonisti": "Betoniști",
  "struct.ret.spec.muncitori_necalificati": "Muncitori necalificați",
  "struct.ret.utilaj.excavator": "Excavator",
  "struct.ret.utilaj.pompa_beton": "Pompă beton",
  "struct.ret.utilaj.placa_compactoare": "Placă compactoare",
  "struct.ret.utilaj.vibrator_beton": "Vibrator beton",
  "struct.ret.forma.dreapta": "bară dreaptă",
  "struct.ret.forma.dreapta_cu_ciocuri": "bară cu ciocuri",
  "struct.ret.forma.etrier": "etrier",
  "struct.ret.forma.agrafa": "agrafă",
  "struct.ret.forma.plasa": "plasă",
  "struct.ret.forma.spirala": "spirală",
  "struct.ret.categorie.fundatie": "fundații",
  "struct.ret.categorie.placa_sol": "placă pe sol",
  "struct.ret.categorie.stalpi": "stâlpi",
  "struct.ret.categorie.grinzi": "grinzi",
  "struct.ret.categorie.pereti": "pereți",
  "struct.ret.categorie.placa": "planșee",
  "struct.ret.precizie.partial": "parțial",
  "struct.ret.precizie.forfetar": "forfetar",
  "struct.ret.precizie_text.exact": "cantitate calculată integral",
  "struct.ret.precizie_text.partial": "o parte din cantitate e cotă forfetară pe volum",
  "struct.ret.precizie_text.forfetar": "cantitate estimată cu o cotă pe volum, nu calculată",
  "struct.ret.art.sapatura": "Săpătură",
  "struct.ret.art.umplutura": "Umplutură",
  "struct.ret.art.beton": "Turnare beton",
  "struct.ret.art.elicopterizat": "Elicopterizat",
  "struct.ret.art.cordon_bentonitic": "Cordon bentonitic",
  "struct.ret.art.armatura": "Armătură",
  "struct.ret.art.oprire_betonare": "Oprire betonare",
  "struct.ret.art.cofraj": "Cofraj",
  "struct.ret.art.probe_beton": "Probe beton",
  "struct.ret.art.probe_fier": "Probe fier",
  "struct.ret.art.accesorii": "Accesorii",
  "struct.ret.mat.cofraj_fundatie_m2": "Cofraj fundație, per m²",
  "struct.ret.mat.cofraj_elevatie_m2": "Cofraj elevație — stâlpi, grinzi, pereți, per m²",
  "struct.ret.mat.cofraj_planseu_m2": "Cofraj planșeu, per m², cu popii",
  "struct.ret.mat.balast_m3": "Balast, per m³",
  "struct.ret.mat.folie_pe_m2": "Folie polietilenă, per m²",
  "struct.ret.mat.accesorii_armare_kg": "Accesorii armare — distanțieri, sârmă, per kg",
  "struct.ret.ind.organizare_santier": "Organizare de șantier",
  "struct.ret.ind.utilaje_ridicare": "Utilaje de ridicare (macara, transport vertical)",
  "struct.ret.ind.indirecte_profit": "Indirecte + profit antreprenor",
  "struct.ret.ind.diverse_neprevazute": "Diverse și neprevăzute",
  "struct.ret.ind.tva": "TVA",

  // --- STRUCTURĂ · Pasul 10, deplasările laterale ------------------------
  "struct.dr.rigiditatea_cadru_d": "rigiditatea de cadru (D-ul lui Muto) — VERDICTUL",
  "struct.dr.raportul_cadru_fata": "raportul de cadru față de nivelul de dedesubt — VERDICTUL",
  "struct.dr.12ei_h3_stalpi": "Σ12EI/h³ pe stâlpi, informativ",
  "struct.dr.raportul_rigiditatilor_p": "raportul rigidităților proprii, informativ",
  "struct.dr.raportul_rigiditatilor_s": "raportul rigidităților secante, informativ",
  "struct.dr.stalpii_nivelului_parant": "stâlpii nivelului; în paranteză câți au baza articulată (pile)",
  "struct.dr.nivel_infrastructura_sal": "nivel de infrastructură: saltul de rigiditate față de suprastructură e cel URMĂRIT de cutia rigidă (C5.8.1), nu o neregularitate",
  "struct.dr.stalpi_baza_articulata": "stâlpi cu baza articulată (pile rezemate pe o grindă)",
  "struct.dr.pasul_10_deplasari": "Pasul 10 — Deplasări laterale (drift)",
  "struct.dr.pasul_10_deplasari2": "Pasul 10 — Deplasări laterale (drift), P100-1/2013 Anexa E",
  "struct.dr.rigiditatea_laterala_cad": "rigiditatea laterală de CADRU a nivelului — VERDICTUL",
  "struct.dr.geometria_modelului_pasu": "geometria modelului (Pasul 4) pe BETON ÎNTREG; aceeași mărime pe care Pasul 4 o arată înainte de lanț",
  "struct.dr.ramane_rigiditatea_cadru": "cât rămâne din rigiditatea de cadru a nivelului de dedesubt",
  "struct.dr.rigiditatea_stalpilor_si": "rigiditatea stâlpilor singuri, cu nodurile blocate la rotire",
  "struct.dr.k_secanta": "K secantă",
  "struct.dr.rigiditatea_sistemului_v": "rigiditatea sistemului văzută la nivelul ăsta",
  "struct.dr.v_pasul_9": "V din Pasul 9 și d_re din blocul DR, amândouă pe modelul cu BETON ÎNTREG",
  "struct.dr.masa_seismica_a": "masa seismică a nivelului",
  "struct.dr.acceleratia_nivel_biciui": "accelerația de nivel — biciuirea propriu-zisă",
  "struct.dr.retrage_nivelul_plan": "cât se retrage nivelul în plan față de cel de dedesubt",
  "struct.dr.stalpi": "stâlpi",
  "struct.dr.cati_stalpi_are": "câți stâlpi are nivelul, și câți dintre ei au baza ARTICULATĂ (pile rezemate pe o grindă)",
  "struct.dr.deplasarea_relativa_elas": "deplasarea relativă elastică a nivelului, în punctul cel mai defavorabil din plan",
  "struct.dr.blocul_dr_tensorului": "blocul DR al tensorului (Pașii 8+9)",
  "struct.dr.punctul_plan_s": "punctul din plan în care s-a atins maximul",
  "struct.dr.deplasarea_relativa_star": "deplasarea relativă la starea limită de serviciu, raportată la înălțimea de nivel",
  "struct.dr.idem_starea_limita": "idem, la starea limită ultimă",
  "struct.dr.driftul_sls_s": "driftul SLS din care s-a scos rotirea rigidă a etajului — valoarea pe care o cere litera (E.1)",
  "struct.dr.coeficientul_sensibilita": "coeficientul de sensibilitate al deplasării relative (efectul P–Δ), pe deplasările MEDII",
  "struct.dr.atat": "de ce atât",
  "struct.dr.costa_fisurarea_masurat": "Cât costă fisurarea, măsurat:",
  "struct.dr.unde_guverneaza": "Unde guvernează",
  "struct.dr.peste": "peste",
  "struct.dr.consecinta": "consecință",
  "struct.dr.masurat": "măsurat",
  "struct.dr.conditia": "Condiția",
  "struct.dr.verifica_deplasarea_rela": "Se verifică deplasarea relativă de nivel la ambele stări limită (P100-1/2013 Anexa E) și coeficientul θ de ordinul II (§4.6.2.2). Rulează Pașii 8 și 9 înainte — driftul se citește din tensorul lor.",
  "struct.dr.parametrii_intra_relatii": "Parametrii care intră în relații",
  "struct.dr.0_4_clase": "ν = 0,4 la clase de importanță",
  "struct.dr.verificarile": "Verificările",
  "struct.dr.niveluri": "Pe niveluri",
  "struct.dr.infrastructura": "(infrastructură)",

  // --- STRUCTURĂ · Pasul 19, analiza soluției ----------------------------
  "struct.opt.reperul_devizului_referi": "reperul devizului de referință: 165 kg/m³ și 4,4 m² cofraj/m³",
  "struct.opt.a_ales_algoritmul": "Cum a ales algoritmul",
  "struct.opt.aplicata": "aplicată",
  "struct.opt.acoperita_alta_modificar": "acoperită de altă modificare",
  "struct.opt.refuzata_element_ingheat": "refuzată — element îngheațat de conformare",
  "struct.opt.verificari_citite": "Verificări citite",
  "struct.opt.limita": "De revizuit",
  "struct.opt.pasii_lantului_emit": "Pașii lanțului care nu emit verdicte",
  "struct.opt.prioritate_ridicata": "prioritate ridicată",
  "struct.opt.fara_date_despre": "— fără date despre verificări —",
  "struct.opt.0_verificari_picate": "✓ 0 verificări picate",
  "struct.opt.cate_pica": "Câte pică",
  "struct.opt.verificarea_a_cerut": "Verificarea care a cerut modificarea",
  "struct.opt.lipsea": "Cât lipsea",
  "struct.opt.abordarea_aleasa": "Abordarea aleasă",
  "struct.opt.abordari_sarite_inainte": "Abordări sărite înainte",
  "struct.opt.algoritmul_abordarii_ale": "Algoritmul abordării alese",
  "struct.opt.a_ales": "cum a ales",
  "struct.opt.solutia": "Soluția",
  "struct.opt.verificari_picate": "Verificări picate",
  "struct.opt.cost_structura": "Cost structură",
  "struct.opt.pasul_19_ruleaza": "Pasul 19 rulează…",
  "struct.opt.pasul_a_rulat": "Pasul nu a rulat încă. Pasul 19 e ANALIZA unei soluții: adună verificările picate ale tuturor pașilor, le dă un scor (un singur număr, mai mic e mai bun) și spune ce merită încercat mai departe.",
  "struct.opt.2_unde_a": "2. De unde a plecat și ce s-a modificat",
  "struct.opt.parghia": "pârghia",
  "struct.opt.mutare_promite_scadere": "Fiecare mutare promite o scădere de severitate; dacă livrează sub un sfert din ea de două ori pe aceeași clasă de problemă, pârghia se demotează pe proiectul ăsta — de aici vine auto-corecția solverului.",
  "struct.opt.grinda_in_afara": "{m} m de grindă în afara pereților",
  "struct.opt.grinda_pe_nivel": " — {lista}",
  "struct.opt.grinda_nivel_metri": "{nume}: {m} m",
  "struct.opt.grinda_exceptate": " (fără {lista}, acceptate din preferințe)",
  "struct.opt.ce_s_a_centralizat": "Ce s-a centralizat: {total} de verificări din {citite} din {toti} pași cu verdicte{fara}{lipsa}",
  "struct.opt.din_pasi_lantului": " (din {n} pași ai lanțului — restul nu emit verdicte)",
  "struct.opt.atentie_pasi_lipsa": " — ATENȚIE, {n} pas(i) fără rezultat citit",
  "struct.opt.th_pasul": "Pasul",
  "struct.opt.th_picate": "Picate",
  "struct.opt.rezultat_lipsa": " — rezultat lipsă la colectare",
  "struct.opt.enumerati_explicit": "— enumerați explicit, ca «0 pași neacoperiți» să însemne ceva verificabil:",
  "struct.opt.lista_nu_e_in_raport": "— lista detaliată nu e în raportul acestei soluții (a fost rulată de o versiune veche); rerulează Pasul 19 ca s-o vezi —",
  "struct.opt.th_categoria_hover": "Categoria verificării (treci cu mouse-ul peste titlu)",
  "struct.opt.vezi_din_cele": "vezi {n} din cele {total} (restul nu au încăput în raportul salvat)",
  "struct.opt.vezi_verificarea_picata": "vezi verificarea picată",
  "struct.opt.deviz_indisponibil": "— devizul nu e disponibil pentru această stare —",
  "struct.opt.deviz_vechi": "Devizul acestei stări e din calibrarea VECHE (lei, pe rețete): {lei} lei ≈ {eur}. Devizul se face pe articole, în EUR, cu prețurile devizului de referință — rulează din nou soluția ca să apară în forma nouă (cele două cifre NU sunt comparabile).",
  "struct.opt.cost_direct": " cost direct",
  "struct.opt.arie_desfasurata": " · {v} m² desfășurați",
  "struct.opt.cu_indirecte": " · cu indirecte {v}",
  "struct.opt.materiale_manopera": "materiale {mat} · manoperă {man}",
  "struct.opt.kg_otel_m3": " · {v} kg oțel/m³ beton",
  "struct.opt.cofraj_m2_m3": " · {v} m² cofraj/m³",
  "struct.opt.in_afara_benzii": " ⚠ în afara benzii uzuale",
  "struct.opt.nicio_modificare": "Nicio modificare în această iterație — iterația de pornire și soluția finală rulează doar lanțul, fără să schimbe geometria.",
  "struct.opt.probleme_tratate": "{probleme} tratate: {aplicate} cu modificare aplicată{epuizate}{refuzate}{rest}",
  "struct.opt.cu_catalogul_epuizat": ", {n} cu catalogul epuizat",
  "struct.opt.pe_elemente_inghetate": ", {n} pe elemente înghețate de conformare",
  "struct.opt.de_alte_modificari": ", {n} de alte modificări",
  "struct.opt.ce_s_a_schimbat": "Ce s-a schimbat efectiv",
  "struct.opt.pica_in_puncte": "pică în {n} puncte",
  "struct.opt.precedenta": "precedentă —",
  "struct.opt.starea_de_plecare": "starea de plecare a etapei",
  "struct.opt.curenta": "curentă —",
  "struct.opt.porneste": "pornește…",
  "struct.opt.detaliu_acum": " — {acum}",
  "struct.opt.eroare": "Eroare: {motiv}",
  "struct.opt.scor_val": " · scor {v}",
  "struct.opt.motiv_val": " · {v}",
  "struct.opt.raport_apare_cand": "Raportul soluției apare când se termină lanțul ei.",
  "struct.opt.stuck_titlu": "De ce s-a oprit căutarea",
  "struct.opt.modificari_facute_titlu": "Modificări făcute de bucla externă ({n})",
  "struct.opt.recomandari_geo_titlu": "Ce ar fi schimbat la geometria macro — recomandări, nu se aplică în detaliu ({n})",
  "struct.opt.recomandare_impact": "impact {n}",
  "struct.opt.solutia_fara_raport": "Soluția asta nu are raport (s-a oprit înainte de lanț — motivul e în eticheta din listă).",
  "struct.opt.h3_picate_curenta": "1. Verificările picate pe soluția curentă{verdict}{scor}",
  "struct.opt.verdict_dash": " — {v}",
  "struct.opt.durata_min": "Soluția a durat {n} min",
  "struct.opt.rezolutia_lantului": "{sep}rezoluția lanțului: h = {h} m{fel}",
  "struct.opt.rezolutia_plina": " (rezoluția plină a proiectului)",
  "struct.opt.rezolutia_proba": " (probă, mesh grosier)",
  "struct.opt.costul_curente": "Costul soluției curente (pe rețete și cantități)",
  "struct.opt.atentie_comparatie": "Atenție la comparație: soluția din care s-a plecat poate fi o PROBĂ (mesh grosier), iar asta e măsurată la rezoluția plină (h = {h} m) — deci diferența nu e neapărat un regres, poate fi mesh-ul mai fin care scoate la iveală ce cel grosier nu vedea.",
  "struct.opt.ce_se_recomanda": "Ce se recomandă mai departe ({n})",
  "struct.opt.reason_dash": " — {v}",
  "struct.opt.ce_s_a_modificat": "Ce s-a modificat",
  "struct.opt.amanate_titlu": "Amânate pentru iterațiile următoare ({n}) — fiecare cu motivul ei",
  "struct.opt.amanat_rand": "{verificare} ({sev} %){motiv}",
  "struct.opt.amanat_motiv": ": {v}",
  "struct.opt.netratate_titlu": "Netratate de acest algoritm ({n})",
  "struct.opt.netratat_rand": "{verificare}: {motiv}",
  "struct.opt.registru_titlu": "Ce a promis soluția precedentă vs ce a livrat ({n})",
  "struct.opt.th_problema": "problema",
  "struct.opt.th_promis": "promis",
  "struct.opt.th_livrat": "livrat",
  "struct.opt.th_verdict": "verdict",
  "struct.opt.rateu": "rateu",
  "struct.opt.livrat": "livrat",
  "struct.opt.demotata": " · demotată",
  "struct.opt.picate_precedenta": "Verificările picate pe soluția precedentă{n}",
  "struct.opt.paren_n": " ({n})",
  "struct.opt.a_plecat_din": "A plecat din: {v}",
  "struct.opt.a_plecat_din_etapa": "A plecat din starea de plecare a etapei",
  "struct.opt.nota_dash": " · {v}",
  "struct.opt.costul_precedente": "Costul soluției precedente (pe rețete și cantități)",
  "struct.opt.probleme#n": "1 problemă|{n} probleme|{n} de probleme",
  "struct.opt.refuzate#n": "1 refuzată|{n} refuzate|{n} de refuzate",
  "struct.opt.acoperite#n": "1 acoperită|{n} acoperite|{n} de acoperite",

  // --- STRUCTURĂ · îmbunătățirile viitoare -------------------------------
  "struct.imb.mesh_grosier_lanturile": "Mesh grosier pentru lanțurile exploratorii (LOD)",
  "struct.imb.mutarea_unui_stalp": "Mutarea unui stâlp pe ALT perete + grosimea plăcii în catalog",
  "struct.imb.unirea_a_doi": "Unirea a doi stâlpi vecini într-un singur element",
  "struct.imb.reducerea_ec2_6": "Reducerea EC2 §6.2.2(6) pentru încărcări concentrate lângă reazem",
  "struct.imb.excentricitatea_cm_cr": "Excentricitatea CM–CR la departajarea țintelor de cost egal",
  "struct.imb.driftul_nivel_sls": "Driftul de nivel (SLS/ULS) ca verificare a pipeline-ului",
  "struct.imb.vantul_cr_1": "Vântul (CR 1-1-4) ca încărcare a modelului",
  "struct.imb.imbunatatiri_viitoare": "Îmbunătățiri viitoare",

  // --- STRUCTURĂ · Pasul 9, analiza seismică -----------------------------
  "struct.seism.curba_s_d": "Curba S_d(T): ce accelerație «simte» o structură cu perioada T, la cutremurul de proiectare — platou β0·a_g/q între TB și TC, apoi descrescător.",
  "struct.seism.structurile_rigide_t": "Structurile rigide (T mic) și cele de pe platou primesc amplificarea maximă β0 = 2,5; peste TC răspunsul scade cu 1/T. Împărțim la q pentru că proiectăm la forțe reduse, acceptând deformații plastice controlate.",
  "struct.seism.citeste_graficul": "Cum se citește graficul",
  "struct.seism.orizontala_perioada_t": "Pe orizontală perioada T (s), pe verticală accelerația spectrală S_d (m/s²). Liniile verticale marchează perioadele fundamentale ale clădirii pe fiecare direcție — acolo se citește accelerația care o lovește.",
  "struct.seism.daca_t1_cade": "Dacă T₁ cade pe platou (TB–TC), clădirea primește amplificarea maximă; dacă e la dreapta lui TC, forțele scad cu 1/T — de aceea structurile flexibile «scapă» mai ieftin, plătind cu deplasări mai mari.",
  "struct.seism.4_directii": "De ce 4 direcții?",
  "struct.seism.cutremurul_vine_dintr": "Cutremurul nu vine dintr-o direcție anume — răspunsul se calculează pe 0°, 45°, 90° și 135°, fiecare devenind un caz de încărcare (E_0..E_135).",
  "struct.seism.testul_t7_compara": "Testul T7 compară forța tăietoare de bază CQC cu forța statică echivalentă (F_b = m·S_d(T₁)·λ): raportul trebuie să fie ~0,7–1,05 pe direcțiile principale. Pe 45°/135° masa se împarte între moduri și raportul scade natural — acolo e doar informativ.",
  "struct.seism.momentele_torsiune_accid": "Momentele de torsiune accidentală (P100-1)",
  "struct.seism.masa_reala_niciodata": "Masa reală nu e niciodată exact unde o pune modelul — norma cere mutarea ei cu e1 = ±5% din dimensiunea clădirii perpendiculară pe cutremur. Rezultatul: un moment de torsiune Mt = F_i · e1 pe fiecare nivel.",
  "struct.seism.excentricitatea_accident": "Excentricitatea accidentală acoperă compartimentări mutate, încărcări neuniforme, incertitudinea rigidităților. Cazurile T_accX / T_accY intră cu ±1 în combinațiile seismice.",
  "struct.seism.s_d_t": "S_d(T_n) — cât primește fiecare mod",
  "struct.seism.mod_propriu_are": "Fiecare mod propriu are perioada lui T_n și citește propria accelerație din spectru. Modurile joase (T mare) sunt de regulă la dreapta platoului, cele înalte pe platou.",
  "struct.seism.raspunsul_total_combinar": "Răspunsul total e combinarea CQC a răspunsurilor modale — modurile cu masă participantă mare și S_d mare domină.",
  "struct.seism.perioadele_colt_spectrul": "perioadele de colț ale spectrului",
  "struct.seism.tc_pasul_1": "TC din Pasul 1; TB = 0,2·TC; TD normat",
  "struct.seism.amplificarea_maxima_2": "amplificarea maximă (2,5)",
  "struct.seism.factorul_importanta_seis": "factorul de importanță seismic",
  "struct.seism.clasa_importanta_a": "clasa de importanță a clădirii",
  "struct.seism.amortizarea_critica_core": "amortizarea critică (corelarea modurilor în CQC)",
  "struct.seism.constanta_a_metodei": "constantă a metodei",
  "struct.seism.forta_taietoare_baza": "forța tăietoare de bază din combinarea CQC",
  "struct.seism.calculata_aici": "calculată aici",
  "struct.seism.forta_statica_echivalent": "forța statică echivalentă de referință",
  "struct.seism.masa_efectiva_cumulata": "masa efectivă cumulată a modurilor pe direcție",
  "struct.seism.tinta_90_p100": "ținta ≥ 90% (P100-1/EC8)",
  "struct.seism.forta_seismica_a": "forța seismică a nivelului (distribuția lui F_b)",
  "struct.seism.excentricitatea_accident2": "excentricitatea accidentală (5% din latura perpendiculară)",
  "struct.seism.pasul_ruleaza": "Pasul rulează…",
  "struct.seism.construieste_spectrul_pr": "Se construiește spectrul de proiectare (a_g, TC din Pasul 1), se citesc modurile proprii din Pasul 7, se calculează răspunsul modal pe 4 direcții (combinare CQC) și torsiunea accidentală, apoi cazurile seismice se adaugă în tensorul de eforturi.",
  "struct.seism.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.seism.acceleratia_terenului": "(accelerația terenului)",
  "struct.seism.0_amplificarea_maxima": "β0 (amplificarea maximă)",
  "struct.seism.p100_1_constant": "P100-1 — constant în România",
  "struct.seism.i_factorul_importanta": "γI,e (factorul de importanță)",
  "struct.seism.amortizarea_critica": "ξ (amortizarea critică)",
  "struct.seism.numarul_moduri_considera": "Numărul de moduri considerate",
  "struct.seism.masa_efectiva_cumulata2": "Masă efectivă cumulată (0° / 90°)",
  "struct.seism.directie": "Direcție",
  "struct.seism.v_baza": "V bază",
  "struct.seism.spectrul_disponibil_rezu": "Spectrul nu e disponibil în rezultat.",

  // --- STRUCTURĂ · setările de calcul, câmp cu câmp ----------------------
  "struct.pref.mod_intrerupere.eticheta": "Terminarea barelor din câmp",
  "struct.pref.mod_intrerupere.ajutor": "«îndoite» = bara nu se retează: la punctul teoretic urcă la 45° pe înălțimea secțiunii și se ancorează pe fibra de sus, deci rămâne în lucru peste fisura de forfecare, iar extrasul îi numără diagonala (√2·h) și ancorarea. «întrerupte» = retezată drept, la punctul teoretic plus deviația a_l. EC2 §9.2.1.3 le admite pe amândouă — alege atelierul.",
  "struct.pref.mod_intrerupere.opt_indoite": "îndoite la 45° (implicit)",
  "struct.pref.mod_intrerupere.opt_intrerupte": "întrerupte drept",
  "struct.pref.etrieri_pas_unic.eticheta": "Pasul etrierilor pe grindă",
  "struct.pref.etrieri_pas_unic.ajutor": "un singur pas pe toată grinda (implicit) înseamnă că fierarul numără o singură distanță; pe două zone, critică și curentă, se economisește oțel dar se citește mai greu pe șantier. Pasul se pune oricum la multipli de 2,5 cm, iar plafoanele normative se rotunjesc ÎN JOS la cuanta asta, deci alegerea nu poate încălca norma.",
  "struct.pref.etrieri_pas_unic.opt_1": "un singur pas, pe toată grinda (implicit)",
  "struct.pref.etrieri_pas_unic.opt_0": "două zone — critică și curentă",
  "struct.pref.allow_odd_bars.eticheta": "Număr impar de bare permis",
  "struct.pref.allow_odd_bars.ajutor": "implicit NU: structuristul armează simetric, cu număr PAR de bare — bara de mijloc complică fasonarea și nu aduce nimic. Permis, bara centrală impară se prinde cu agrafă și contează în factorul de confinare α.",
  "struct.pref.allow_odd_bars.opt_0": "nu — numai număr par de bare (implicit)",
  "struct.pref.allow_odd_bars.opt_1": "da — se admite și bara centrală, cu agrafă",
  "struct.pref.interax_min_cm.eticheta": "Distanța minimă între bare, pe un rând",
  "struct.pref.interax_min_cm.ajutor": "din centru în centru, ca și maximul de mai jos: 5 cm e regula biroului. Sub ea, distanța LIBERĂ a normativului (EC2 §8.2: max(Ø, d_agregat + 5 mm, 20 mm)) rămâne podeaua și urcă singură la barele groase, ca să treacă betonul și pervibratorul.",
  "struct.pref.s_max_bare_cm.eticheta": "Distanța maximă între bare, pe un rând",
  "struct.pref.s_max_bare_cm.ajutor": "din centru în centru: norma admite 25 cm, biroul lucrează la 18. Din regula asta iese un NUMĂR MINIM de bare, independent de aria necesară — o grindă lată nu se armează cu două bare groase la colțuri. La arie egală, solverul preferă oricum barele subțiri: una cu defect scoate din lucru mai puțin din secțiune.",
  "struct.pref.niveluri_plan_liber.eticheta": "Niveluri cu plan liber",
  "struct.pref.niveluri_plan_liber.ajutor": "nivelurile pe care NU există compartimentări — parcarea deschisă de la parter, holul, sala. Acolo structura poate pune stâlpi și lamele oriunde în amprentă, nu doar în pereții desenați. Calculul n-are de unde s-o știe: el vede că nu sunt pereți și citește «n-are loc», exact pe dos — un nivel liber e cel mai ușor loc unde încape o lamelă. Se scriu numele nivelurilor din Pasul 2, separate prin virgulă. Gol = fiecare nivel își cere pereții lui.",
  "struct.pref.niveluri_plan_liber.exemplu": "parter",
  "struct.pref.infrastructura_libera.eticheta": "Subsolul e liber pentru structură",
  "struct.pref.infrastructura_libera.ajutor": "nivelurile SUBTERANE n-au arhitectură proprie: parcarea de sub bloc se proiectează DUPĂ structură, deci stâlpii coboară oriunde la fundație și pereții, lamelele și locurile desenate acolo sunt provizorii. «auto» = după document: un subsol ai cărui pereți sunt toți copii coborâte de la etaje (arhitectura generată) e liber, unul desenat în planșă nu. «da» îl eliberează oricum; «nu» îl respectă așa cum e desenat, chiar dacă structura are mai puține locuri unde să coboare.",
  "struct.pref.infrastructura_libera.opt_auto": "după document (implicit)",
  "struct.pref.infrastructura_libera.opt_da": "da — structura coboară oriunde în subsol",
  "struct.pref.infrastructura_libera.opt_nu": "nu — subsolul rămâne cum e desenat",
  "struct.pref.modul_grila_m.eticheta": "Modulul grilei de stâlpi",
  "struct.pref.modul_grila_m.ajutor": "lățimea unui loc de parcare: 2,50 m. Interaxul stâlpilor se așază pe multiplii lui (stâlpii intermediari ai zidurilor lungi cad la 5,0 m), ca între doi stâlpi să încapă un număr ÎNTREG de locuri și ca traveele să fie EGALE — două deschideri egale înseamnă un singur cofraj de grindă, refolosit. Cât din grilă stă pe modul și câte deschideri diferite are cadrul intră în scor, 5 % fiecare. Poate fi și 2,60 dacă terenul o cere.",
  "struct.pref.distante_ideale_m.eticheta": "Distanțele ideale între elemente",
  "struct.pref.distante_ideale_m.exemplu": "2,5; 5; 7,5",
  "struct.pref.distante_ideale_m.ajutor": "luminile pe care structura le caută între FEȚELE a doi stâlpi vecini, în metri. Gol înseamnă multiplii modulului grilei (2,5 și 5,0 m): atâtea locuri de parcare întregi. Regula se urmărește NUMAI când subsolul e al nostru — o arhitectură generată, cu infrastructura liberă. Când parcarea e deja desenată de arhitect, structura are de urmat ce există, iar termenul de grilă al scorului nu mai penalizează proiectul pentru o regulă care nu-l privește.",
  "struct.pref.h_grinda_max_m.eticheta": "Înălțimea maximă a grinzilor",
  "struct.pref.h_grinda_max_m.ajutor": "cât de înaltă are voie să fie o grindă, ca să încapă peste golurile de uși și în tavanul cerut de arhitect: 0,65 m e cererea structuristului. Calculul n-are de unde s-o afle — o grindă de 0,90 m peste 5 m trece toate verificările și rigidizează frumos, dar nu se execută dacă biroul n-o acceptă. Plafonul se plătește în altă parte: sub el, rigiditatea care deschide ΔT₁₂ și strânge driftul trebuie să vină din stâlpi lungiți și lamele, nu din grinzi mai înalte.",
  "struct.pref.h_grinda_fatada_max_m.eticheta": "Înălțimea maximă a grinzilor de fațadă",
  "struct.pref.h_grinda_fatada_max_m.ajutor": "fațada poate avea un plafon mai JOS decât al proiectului: dată, coboară plafonul grinzilor de fațadă sub «înălțimea maximă a grinzilor»; nu îl ridică — biroul face grinzi de cel mult 0,65 m și peste ferestre sau uși. Lăsată goală, fațada ține plafonul proiectului, iar golurile de pe axă îl coboară când buiandrugul de deasupra ferestrei sau parapetul de sub ea e mai mic decât el.",
  "struct.pref.drift_pe_baza.eticheta": "Baza modelului de drift",
  "struct.pref.drift_pe_baza.ajutor": "pe ce bază stă modelul din care se citește d_re al anexei E. «Automat» = baza încastrată când strategia urmărește cutia rigidă la subsol (condițiile ei se verifică la Pasul 10): deasupra cutiei clădirea e ca încastrată, iar rotirea cutiei pe teren nu e deformare a structurii; fără cutie cerută, driftul se măsoară pe teren, cu complianța fundației. Varianta folosită e scrisă la Pasul 9 (cardul modelelor) și la Pasul 10.",
  "struct.pref.drift_pe_baza.opt_auto": "automat — încastrată când se urmărește cutia rigidă",
  "struct.pref.drift_pe_baza.opt_incastrat": "încastrată, întotdeauna",
  "struct.pref.drift_pe_baza.opt_elastic": "pe teren elastic, întotdeauna",
  "struct.pref.h_radier_m.eticheta": "Grosimea radierului",
  "struct.pref.h_radier_m.ajutor": "grosimea radierului general decis la geometria macro (de la P+6 în sus). Lăsată goală, macro ia estimarea de 0,80 m; detaliul verifică grosimea pe zone.",
  "struct.pref.phi_min_long_mm.eticheta": "Ø minim al barelor longitudinale",
  "struct.pref.phi_min_long_mm.ajutor": "minimul constructiv al biroului la grinzi (Ø14). Plafonul de sus îl dă nodul: barele trebuie să se poată ancora prin stâlpii de la capete. Dacă plafonul nodului coboară sub valoarea de aici, pasul emite avertisment, iar solverul lățește stâlpul pe direcția grinzii.",
  "struct.dwg.inchide_conturul_enter": "Închide conturul (Enter, sau click pe primul punct)",
  "struct.dwg.pasii_analiza_vad": "Pașii de analiză văd doar reuniunea zonelor marcate. Editează-le sau șterge-le ca să schimbi.",
  "struct.dwg.complex_imobiliar_alege": "Complex imobiliar: alege corpul de analizat — pașii de analiză văd doar reuniunea zonelor salvate. Conturul se pune punct cu punct (poți da zoom între puncte), iar vârfurile și laturile se mută după aceea.",
  "struct.dwg.incadreaza_extents_urile": "Încadrează extents-urile complete, cu tot cu entitățile rătăcite departe de planșe",
  "struct.dwg.inapoi_dosar": "← Înapoi la dosar",
  "struct.dwg.inapoi_proiect": "← Înapoi la proiect",
  "struct.dwg.inapoi_punct": "Înapoi un punct",
  "struct.dwg.inchide_conturul": "Închide conturul",
  "struct.dwg.sterge_ultima_zona": "Șterge ultima zonă",
  "struct.dwg.renunta": "Renunță",
  "struct.dwg.sterge_zonele": "Șterge zonele",
  "struct.dwg.incadreaza": "Încadrează",
  "struct.dwg.grupa_structura": "Structură",
  "struct.dwg.grupa_arhitectura": "Din arhitectură",
  "struct.dwg.toate": "Toate",
  "struct.dwg.directie": "Direcție",
  "struct.dwg.sectiune_talpa": "Secțiune talpă",
  "struct.dwg.punct_stanga": "Punct stânga",
  "struct.dwg.latime": "Lățime",
  "struct.dwg.inaltime": "Înălțime",
  "struct.dwg.continut": "Conținut",
  "struct.dwg.pozitie": "Poziție",
  "struct.rz.limita_seismica": "din limita seismică",
  "struct.rz.pasul_ruleaza": "Pasul rulează…",
  "struct.rz.ruleaza_nou_meniul": "Rulează din nou din meniul din stânga.",
  "struct.rz.rigida": "rigidă",
  "struct.rz.flexibila": "flexibilă",
  "struct.rz.cotele_fundare_ax": "Cotele de fundare, ax cu ax",
  "struct.rz.impune": "Ce o impune",
  "struct.cob.masa_seismica_greutatea": "De ce masa seismică nu e greutatea împărțită la g",
  "struct.cob.masele_ops_mass": "Masele (ops.mass) — bilele din noduri",
  "struct.cob.stalpi": "stâlpi",
  "struct.cob.pereti_grinzi": "pereți pe grinzi",
  "struct.cob.pereti_placa": "pereți pe placă",
  "struct.cob.utila_a": "utilă cat. A",
  "struct.cob.utila_c": "utilă cat. C",
  "struct.cob.zapada": "zăpadă",
  "struct.cob.coborarea_incarcarilor": "Coborârea încărcărilor",
  "struct.cob.niveluri_kn": "Pe niveluri (kN)",
  "struct.cob.1_m2_planseu": "1 m² de planșeu (kN/m²)",
  "struct.cob.incarcare_vs_masa": "Încărcare vs masă seismică",
  "struct.cob.3d_ajung_opensees": "3D — cum ajung în OpenSees",
  "struct.cob.bara_totalul_apasa": "Fiecare bară e totalul care apasă pe planșeul acelui nivel, descompus pe surse. Coloana din dreapta adună de sus în jos: cât trece prin nivelul respectiv în drumul spre fundație.",
  "struct.cob.descompunerea_surse": "Descompunerea pe surse",
  "struct.cob.cumulat_spre_fundatie": "Cumulat spre fundație",
  "struct.cob.aici_verifica_valorile": "Aici se verifică valorile: fiecare felie e o cifră din normativ sau din stratificația peretelui, cu formula ei. Pereții pe grinzi lipsesc din coloană — ei nu sunt o încărcare pe metru pătrat de planșeu, ci pe metru liniar de grindă.",
  "struct.cob.vine": "Din ce vine",
  "struct.cob.per_nivel_metru": "Per nivel, pe metru pătrat",
  "struct.cob.doua_contabilitati_acele": "Sunt două contabilități ale aceleiași structuri, și diferă intenționat:",
  "struct.cob.stalpii_peretii": "stâlpii și pereții",
  "struct.cob.incarcare_pasul_8": "Încărcare (Pasul 8)",
  "struct.cob.masa_seismica_pasul": "Masă seismică (Pasul 7)",
  "struct.cob.bilele_goale_gri": "Bilele goale (gri), la cota 0",
  "struct.cob.deja_impachetat_bile": "Ce e deja «împachetat» în bile: placa și finisajele integral, stâlpii și pereții pe jumătate între planșeul de deasupra și cel de dedesubt, iar utila doar cu fracțiunea ψ_E — vezi tabelul din fila «Încărcare vs masă seismică».",
  "struct.dgf.distribuie_presiunea_sub": "Cum se distribuie presiunea sub talpă, funcție de excentricitate",
  "struct.dgf.lunecarea_impinge_latera": "Lunecarea: ce împinge lateral și ce se opune",
  "struct.dgf.rasturnarea_rotirea_juru": "Răsturnarea: rotirea în jurul muchiei fundației",
  "struct.dgf.subpresiunea_apa_impinge": "Subpresiunea: apa împinge fundația în sus",
  "struct.dgf.ridicarea_stalpul_latura": "Ridicarea: stâlpul de pe latura întinsă e tras în sus",
  "struct.dgf.strapungerea_stalpul_tre": "Străpungerea: stâlpul «trece prin” talpă, forfecând un trunchi de con",
  "struct.dgf.tasarea_felie_pamant": "Tasarea: fiecare felie de pământ se turtește după apăsarea care ajunge la ea",
  "struct.dgf.modelul_winkler_terenul": "Modelul Winkler: terenul devine un covor de arcuri independente",
  "struct.dgf.grinda_fundare_incarcare": "Grinda de fundare: încărcarea vine de JOS, deci semnele se inversează",
  "struct.dgf.tasarea_uniforma_strica": "Tasarea uniformă nu strică nimic; cea DIFERENȚIALĂ fisurează",
  "struct.dgf.desprinde": "se desprinde",
  "struct.dgf.frecare_talpa_v": "frecare pe talpă = V · μ",
  "struct.dgf.impingerea": "împingerea",
  "struct.dgf.pasiva_r_p": "pasivă R_p",
  "struct.dgf.brat": "braț",
  "struct.dgf.w_h_apa": "γ_w · h_apă",
  "struct.dgf.n_lt_0": "N &lt; 0 (întindere)",
  "struct.dgf.umplutura": "umplutură",
  "struct.dgf.lungimea_aferenta": "lungimea aferentă",
  "struct.dgf.slabeste_adancimea": "slăbește cu adâncimea",
  "struct.dgf.m_camp_intinde": "M în câmp întinde fibra de SUS",
  "struct.dgf.m_reazem": "M pe reazem",
  "struct.pg.numai_deschiderea_cotele": "numai deschiderea asta, cu toate cotele ei",
  "struct.pg.punct_gruparea_r": "pentru fiecare punct, gruparea cu R/E minim — cea care îl decide",
  "struct.pg.1_35g_1": "1,35G + 1,5Q — fără seism",
  "struct.pg.g_q_seism": "G + ψQ ± seism, pe cele două direcții",
  "struct.pg.rezultatul_grinzii_poart": "Rezultatul grinzii nu poartă stațiile de verificare (rulare mai veche).",
  "struct.pg.gruparea_decide": "gruparea care decide",
  "struct.pg.fundamentala": "fundamentală",
  "struct.pg.seismica": "seismică",
  "struct.pg.fata_stalpului_aici": "–– fața stâlpului (de aici se ia M_Ed)",
  "struct.pg.f_fundamentala_s": "(F) fundamentală · (S) seismică",
  "struct.pg.trec_dar_intr": "nu trec, dar nu într-un punct:",
  "struct.pg.punct_deseneaza_fibra": "Fiecare punct se desenează pe fibra lui, cu |M_Ed| și M_Rd pe aceeași scară: reazemele deasupra grinzii, câmpul dedesubt. Stațiile R1/R2 stau pe FEȚELE stâlpilor, nu în axele lor, iar câmpul se caută între fețe — de aceea poziția lui se mută de la o grupare la alta. Capacitatea de la reazem e desenată ca prag pe zona critică: între fețe pasul nu raportează momentul. Tăietoarea nu se verifică într-un punct, ci pe zone.",
  "struct.dse.vederea_3d_poate": "Vederea 3D nu se poate reconstitui din rezultatul ăsta.",
  "struct.dse.desenul_poate_reconstitu": "Desenul nu se poate reconstitui din rezultatul ăsta (rulare mai veche).",
  "struct.dse.fara_desen_tipul": "Fără desen pentru tipul ăsta de element.",
  "struct.imb.parghia_lipseste_grinzil2": "Pârghia care lipsește pentru grinzile-BUTURUGĂ: două stâlpi la mai puțin de ~1 m unul de altul, cu o grindă între ei, dau o deschidere liberă de câțiva centimetri, iar tăietoarea CAPABILĂ (V = γ_Rd·ΣM_Rd/L_as) explodează. Nici secțiunea nu ajută — la V capabil M_Rd crește cu înălțimea, deci Q̄ nu scade —, iar acum lungirea stâlpilor de la capete e (corect) PLAFONATĂ ca să nu strângă și mai mult deschiderea. Soluția de proiectant e să facă din cei doi stâlpi UNUL (un perete scurt) și să scoată grinda dintre ei. Op-ul `elimina_stalp` existent nu acoperă cazul: el cere exact 2 grinzi coliniare pe stâlpul eliminat, iar cazul real (ST23 + ST27 la 0,70 m pe proiectul 2) are 3 grinzi incidente pe fiecare, deci grinzile rămase trebuie RE-LEGATE la elementul unit. Cere un op nou în `model._aplica_modificari` + o regulă care îl propune din exact diagnosticul ăsta.",
  "struct.imb.h_mesh_02": "h_mesh 0,40 m → ~0,8 m în tentativele fazei de economie (de ~4× mai puține necunoscute, eigen de 4–6× mai ieftin), cu un lanț de CONFIRMARE la rezoluția plină înainte ca o mutare să fie păstrată — verdictul raportat rămâne cel la precizie normală. Diferența tipică pe T₁/eforturi între 0,4 și 0,8 e de ordinul câtorva procente: suficientă pentru triaj, nu pentru verdict. Punctul de altoire există deja: fiecare tentativă din faza_economie e «aplică overlay → rulează pași → citește starea» — evaluatorul ieftin intră acolo, iar confirmarea devine un candidat cu prioritate maximă în aceeași coadă. Cu LOD, cele 6 lanțuri per ramură devin ~15–20 în același buget — de-abia atunci coada ajunge la candidații de coadă (azi mut:ST17 rămâne neîncercat pe proiectul 6 când bugetul se termină).",
  "struct.imb.stalp_plantat_cade2": "Un stâlp plantat care cade la mai puțin de 2·d de fața reazemului pune practic toată reacțiunea în tăietoarea acelui capăt — pe proiectul 2, GR22.1 primește 406 kN de la ST47.2 aflat la 0,53 m, și nicio secțiune de 30 cm lățime nu o duce. EC2 §6.2.2(6) permite reducerea contribuției cu β = a_v/(2d) exact pentru situația asta (încărcarea se transmite direct în reazem prin bielă comprimată), dar nu e implementată. Alternativa deja în catalog e glisarea stâlpului plantat peste stâlpul de dedesubt (R4b) — care schimbă geometria, în loc să recunoască un mecanism real.",
  "struct.imb.calculeaza_raporteaza_de2": "Se calculează și se raportează deja; nu e încă folosită drept criteriu de alegere între două intervenții cu același preț (cea care apropie centrul de rigiditate de centrul maselor ar trebui să câștige).",
  "struct.imb.mutarea_a_lungul2": "Mutarea de-a lungul aceleiași axe există (eliminare + re-adăugare pe grinda unită); lipsesc mutarea pe un alt perete (criteriul CM–CR) și grosimea plăcii ca variabilă de optimizare.",
  "struct.imb.abaterea_peste_202": "Abaterea peste 20 % intră azi în verificările picate (tip «fundatie_ks»), dar reluarea lanțului cu K_s actualizat rămâne manuală — bucla ar putea să o facă singură.",
  "struct.imb.deplasarile_relative_niv2": "Deplasările relative de nivel nu sunt încă o verificare, deci nu pot intra în bucla de optimizare (P100-1 anexa E).",
  "struct.imb.inca_incarcare_deci2": "Nu e încă o încărcare, deci nu poate fi nici verificat, nici optimizat pe el.",
  "struct.ret.implicit_0_santier": "implicit 0: pe șantier pământul pleacă adesea ca umplutură la un teren vecin",
  "struct.ret.0_oprita_aprinde": "0 = oprită; se aprinde dacă furnizorul chiar facturează pe bucată",

  // --- STRUCTURĂ · frazele cu cifre în ele și cele cu accent -------------
  "struct.cob.peretii_parterului_p1": "+ pereții parterului ({p1} kN)",
  "struct.cob.sectiunea_p1": "— secțiunea: {p1}",
  "struct.cob.cazul_p1_primeste": "Cazul {p1} — ce primește solverul",
  "struct.cob.numai_zonele_p1": ", numai pe zonele cat. {p1}",
  "struct.dwg.salveaza_p1_p2": "Salvează ({p1} {p2})",
  "struct.dwg.fundatie_p1_m": "(fundație {p1} m)",
  "struct.dwg.axele_cladirii_x": "axele clădirii · X {p1} · Y {p2}",
  "struct.dwg.cauta_p1_layere": "Caută în {p1} layere…",
  "struct.dwg.fisierul_nu_exista": "Fișierul nu există în proiect",
  "struct.dwg.se_incarca": "Se încarcă…",
  "struct.dwg.se_interpreteaza": "Se interpretează desenul… (prima deschidere poate dura)",
  "struct.dwg.confirma_sterge_zone": "Ștergi toate zonele de interes? Pașii de analiză vor vedea din nou tot desenul.",
  "struct.dwg.unitati": "unități: {u}",
  "struct.dwg.se_salveaza": "Se salvează…",
  "struct.dwg.salveaza_fara_zone": "Salvează (fără zone)",
  "struct.dwg.scoate_ultimul_punct": "Scoate ultimul punct pus (Backspace)",
  "struct.dwg.scoate_ultimul_poligon": "Scoate ultimul poligon desenat",
  "struct.dwg.editeaza_zonele": "Editează zonele",
  "struct.dwg.selecteaza_zone": "Selectează zone de interes",
  "struct.dwg.vezi_in_tabel": "↑ Vezi în tabel",
  "struct.dwg.puncte_inchis": " (închis)",
  "struct.dwg.banner_puncte": "{n} — click pe primul punct (sau Enter) închide conturul; Backspace scoate ultimul punct, Esc renunță la contur. Între puncte poți da zoom cu rotița și muta planul trăgând de el.",
  "struct.dwg.banner_primul": "Click = un punct al conturului. Dă zoom cu rotița, pune punctele exact pe colțuri (se lipesc singure de desen — ține Shift dacă nu vrei), iar la final click pe primul punct ca să închizi poligonul.",
  "struct.dwg.banner_zone": "{n} — trage de vârfuri sau de laturi ca să le potrivești; dublu-click pe o latură adaugă un vârf, Alt+click pe un vârf îl scoate. Click în gol începe un contur nou. Nimic nu e salvat până nu apeși «Salvează».",
  "struct.dwg.tip_linie": "Linie",
  "struct.dwg.tip_polilinie": "Polilinie",
  "struct.dwg.tip_cerc": "Cerc",
  "struct.dwg.tip_arc": "Arc",
  "struct.dwg.tip_elipsa": "Elipsă",
  "struct.dwg.tip_spline": "Spline",
  "struct.dwg.tip_hasura": "Hașură",
  "struct.dwg.tip_text": "Text",
  "struct.dwg.tip_atribut": "Atribut",
  "struct.dwg.tip_solid": "Solid",
  "struct.dwg.tip_fata_3d": "Față 3D",
  "struct.dwg.tip_contur_calculat": "Contur calculat",
  "struct.dwg.tip_ax_fundatie": "Ax fundație",
  "struct.dwg.tip_volum_fundatie": "Volum fundație",
  "struct.dwg.tip_stalp_propus": "Stâlp propus",
  "struct.dwg.tip_grinda_propusa": "Grindă propusă",
  "struct.dwg.tip_perete_simplificat": "Perete simplificat",
  "struct.dwg.tip_perete_persistent": "Perete persistent",
  "struct.dwg.tip_eticheta_perete": "Etichetă perete",
  "struct.dwg.tip_eticheta_perete_persistent": "Etichetă perete persistent",
  "struct.dwg.tip_ax_fundatie_denumit": "Ax de fundație (denumit)",
  "struct.dwg.tip_eticheta_ax": "Etichetă de ax",
  "struct.dwg.entitati#n": "1 entitate|{n} entități|{n} de entități",
  "struct.dwg.zone_salveaza#n": "Salvează 1 zonă|Salvează {n} zone|Salvează {n} de zone",
  "struct.dwg.zone_active#n": "zonă de interes activă|{n} zone de interes active|{n} de zone de interes active",
  "struct.dwg.puncte_puse#n": "1 punct pus|{n} puncte puse|{n} de puncte puse",
  "struct.dwg.zone_desenate#n": "1 zonă|{n} zone|{n} de zone",
  "struct.ret.informativ_afisare_p1": "informativ, pentru afișare; la {p1} ({p2})",
  "struct.ret.preturi_zona_norme": "Prețuri, zonă & norme{p1}",
  "struct.ret.p1_desfasurat": "{p1} desfășurat",
  "struct.ret.manopera_p1_um": "manoperă {p1}/UM",
  "struct.ret.p1_manopera": "{p1} — manoperă",
  "struct.arh.pereti_desenati_intrerup": "pereți desenați cu întreruperi: închis cu {p1} m (fără închidere: {p2} m²)",
  "struct.arh.contur_rupt_nici": "contur RUPT — nici cu {p1} m de închidere nu ajunge la controlul de ~{p2} m²",
  "struct.arh.peretii_suprapun_p1": "— pereții se suprapun {p1}%",
  "struct.arh.am_gasit_cote": "nu am găsit cote în fațade — valori presupuse de {p1} m",
  "struct.arh.p1_pereti_persistenti": "· {p1} pereți persistenți cross-nivel (PP)",
  "struct.arh.p1": "· din {p1}",
  "struct.arg.grinda_p1_are": "Grinda {p1} are secțiunea {p2}×{p3} cm și lucrează împreună cu placa de {p4} cm («secțiune T/L»): placă pe {p5} la R1 și pe {p6} la R2 (detectat geometric din modelul plăcii). Lățimea activă de placă considerată: {p7} de fiecare parte — convenția structuristului (conservatoare); formula completă din EC2 §5.3.2.1 depinde și de deschidere și dă valori apropiate (listată informativ, neimplementată).",
  "struct.arg.deschiderea_depaseste_4": "Deschiderea depășește 4,5 m ⇒ CORECȚIA DE DESCHIDERE MARE (foaia B: AZ10): momentul de câmp a fost majorat de la {p1} la {p2} kNm cu 0,2·|M_reazem,sus| — acoperă redistribuțiile pe deschideri lungi.",
  "struct.arg.r_sub_1": "R/E este sub 1, dar peste pragul de acceptare 1 − {p1}% — marja de subdimensionare acceptată a proiectului (constanta «acceptare_grinzi_pct»). R/E afișat rămâne cel real.",
  "struct.arg.suprarezistenta_calcul_c": "suprarezistența la calcul capabil: {p1} — {p2}",
  "struct.arp.conteaza_grinda_zvelta": "DE CE CONTEAZĂ. La o grindă zveltă deformațiile variază liniar pe înălțimea secțiunii, deci și barele de la fața opusă ajung să curgă și pot fi puse la socoteală. La o grindă-perete asta nu mai e adevărat: efortul «curge» pe diagonale comprimate direct de la încărcare la reazem, iar întinderea se adună într-un TIRANT lângă fața întinsă. Exact de aceea CR 2-1-1.1 §10.3.2 scrie că elementele infrastructurii «prezintă de multe ori comportare de elemente scurte de beton armat» și că «în cazul unor proporții de grinzi scurte se vor aplica metodele de calcul specifice grinzilor pereți sau metode bazate pe mecanismul de grindă cu zăbrele». CONSECINȚA ÎN ARMARE. Secțiunea se verifică pe AMBELE modele și decide cel mic: modelul de secțiune plană (cu brațul 0,8·h = {p1} m) și modelul de grindă cu zăbrele (cu brațul redus z = {p2} m și armătura din banda de {p3} cm). În plus, pasul plasei se strânge la min(2·t, 300 mm) — SR EN 1992-1-1 §9.7(2).",
  "struct.arp.modelul_grinda_zabrele": "MODELUL DE GRINDĂ CU ZĂBRELE (CR 2-1-1.1 §10.3.2 + SR EN 1992-1-1 §6.5/§9.7). Aici întinderea se adună într-un tirant, iar capacitatea e T_Rd·z: tot ce e în banda de {p1} cm de la fața întinsă, înmulțit cu brațul redus z = {p2} m. Barele de dincolo de bandă NU se pun la socoteală — la un element scurt ele nu ajung să curgă. DE CE E MAI SEVER. Secțiunea plană «vede» toată înălțimea, deci iese cu un M_Rd optimist; zăbreaua vede doar tirantul. Diferența dintre cele două R/E-uri de mai jos este exact prețul ipotezei greșite — motivul pentru care CR 2-1-1.1 nu lasă alegerea la latitudinea proiectantului.",
  "struct.arp.r_sub_1": "R/E este sub 1, dar peste pragul de acceptare 1 − {p1}% — marja de subdimensionare acceptată a proiectului. R/E afișat rămâne cel real.",
  "struct.arp.pasul_nu_rulat": "Pasul nu a fost rulat încă. Apasă «Run» în meniul din stânga (după Pașii 7, 11 și 12).",
  "struct.arp.ultima_rulare_esuat": "Ultima rulare a eșuat: {motiv}",
  "struct.arp.eroare_necunoscuta": "eroare necunoscută",
  "struct.arp.subsol_cerut_fara_perete": "Subsol rigid cerut, dar fără niciun perete",
  "struct.arp.rulat_la": "rulat la {data}",
  "struct.arp.nu_cere_subsol_rigid": "Clădirea nu cere subsol rigid.",
  "struct.arp.peretii_doar_p2": "Pereții de beton se pun doar la clădirile P+2 sau peste care au subsol — acolo infrastructura se închide în «cutie rigidă» (P100-1 §4.4.1.7).",
  "struct.arp.pereti_armati": "Pereți armați",
  "struct.arl.titlu": "Lamelele — pereții structurali ai clădirii",
  "struct.arl.intro": "Elementele verticale cu latura lungă de cel puțin {raport} ori cea scurtă sunt pereți, nu stâlpi: se armează aici, cu regulile pereților ductili (P100-1 §5.3.4.3), și nu mai apar la Pasul 15. Fiecare perete are carcase de tip stâlp la capete, două plase în inimă și etrieri de confinare la capete.",
  "struct.arl.card_nr": "Lamele armate",
  "struct.arl.card_regim": "Regimul de proiectare",
  "struct.arl.regim_sub": "q = {q}, k_M = {km}, k_V = {kv}, γ_Rd = {grd}",
  "struct.arl.card_materiale": "Oțel în lamele",
  "struct.arl.materiale_sub": "{beton} m³ de beton",
  "struct.arl.card_carcase": "Carcase de execuție",
  "struct.arl.carcase_sub": "{n} în catalogul cofrajelor, +{surplus} % oțel; {ref} poziții rămase cu carcasa lor",
  "struct.arl.pozitii": "Pe poziție: baza, zona critică, Ω și ε",
  "struct.arl.th_pozitie": "Poziția",
  "struct.arl.th_sectiune": "Lungime × grosime [m]",
  "struct.arl.th_inaltime": "Înălțimea H_w [m]",
  "struct.arl.th_zona_critica": "Zona critică l_cr [m]",
  "struct.arl.th_omega": "Suprarezistența Ω / amplificarea ε",
  "struct.arl.th_taietoare_baza": "Tăietoarea la bază V_Ed,0 [kN]",
  "struct.arl.baza": "baza {el}",
  "struct.arl.scurt": "(perete scurt)",
  "struct.arl.niveluri": "Pe nivel: capetele, etrierii și inima",
  "struct.arl.th_element": "Elementul",
  "struct.arl.th_zona": "Zona",
  "struct.arl.th_capete": "Carcasele de capăt",
  "struct.arl.th_etrieri": "Etrierii capetelor (lungimea confinată)",
  "struct.arl.th_inima": "Inima: vertical + orizontal",
  "struct.arl.zona_a": "critică (A)",
  "struct.arl.zona_b": "curentă (B)",
  "struct.arl.zona_infra": "infrastructură",
  "struct.arl.click": "Clic pe un rând ca să vezi verificările nivelului.",
  "struct.arl.detaliu": "Verificările lamelei {el} ({nivel})",
  "struct.arl.detaliu_sub": "Zona {zona}; Ω = {om}, ε = {eps}; x_u = {xu} cm față de limita {lim} cm; ν_d = {nud} (reper).",
  "struct.arl.nu_se_aplica": "Ce nu se preia de la stâlpi și ce e simplificat",
  "struct.arl.limite": "Simplificări scrise în rezultat:",
  "struct.arl.fara_panouri": "Clădirea nu are panouri de perete în subsol; pasul armează doar lamelele.",
  "struct.arp.regimul_sectiunii": "Regimul secțiunii",
  "struct.arp.panouri_grinzi_pereti": "panouri cu l₀/h < {raport} ⇒ grinzi-pereți (grindă cu zăbrele + tirant în bandă)",
  "struct.arp.subsol_rigid": "Subsol rigid",
  "struct.arp.criteriul_subsolului": "Criteriul subsolului rigid",
  "struct.arp.k_subsol_sub": "k subsol / max(k etaje), pe X / Y · prag {prag}×",
  "struct.arp.materiale": "Materiale",
  "struct.arp.materiale_sub": "oțel ({otel}) · {beton} m³ beton {clasa}{fcd}",
  "struct.arp.materiale_fcd": " (f_cd = {fcd} MPa, f_ctd = {fctd} MPa)",
  "struct.arp.th_panou": "panou",
  "struct.arp.plasa_verticala": "plasă verticală",
  "struct.arp.barele_verticale": "Barele verticale",
  "struct.arp.plasa_orizontala": "plasă orizontală",
  "struct.arp.tiranti_sus_jos": "tiranți sus / jos",
  "struct.arp.panoul_eticheta": "Panoul",
  "struct.arp.optiune_panou": "{el} ({nivel}) — {verdict}",
  "struct.arp.panou_dimensiuni": "{t}×{h} cm · L = {l} m (ax–ax) · l₀ = {l0} m · stâlpi {si} → {sj}",
  "struct.arp.rigid_off": " · rigid {i} + {j} cm",
  "struct.arp.verdictul_aduna": "El adună TOATE verificările panoului, iar cea mai severă îl dictează: încovoierea în plan (pe două modele — secțiune plană și grindă cu zăbrele), tăietoarea în plan, biela comprimată, nodul de reazem, lunecarea în rosturile de lucru și regulile constructive (procente minime, diametre, pași, grosime, A_s ≤ 4 %). Deschiderea fisurilor e calculată dar INFORMATIVĂ, deci nu intră în verdict — relațiile §7.3.4 sunt scrise pentru elemente încovoiate zvelte.",
  "struct.arp.marja_proiect": "proiectul acceptă R/E ≥ {prag} (marjă de {pct} %). Solverul țintește tot R/E = 1,00; doar verdictul verificărilor rămase în marjă devine acceptat, marcat explicit cu «prin marja».",
  "struct.arp.ce_nu_se_preia": "Ce NU se preia de la grinzi — și articolul care scutește",
  "struct.arp.de_ce_lista_asta": "De ce e nevoie de lista asta",
  "struct.arp.th_articolul": "articolul",
  "struct.arp.ce_cere_cutia": "Ce mai cere «cutia rigidă» la subsol",
  "struct.arp.ierarhia_normativ": "Ierarhia: normativul <b>românesc dă cerința</b>, iar SR EN 1992-1-1 (adoptarea românească a EC2) dă metoda de calcul — exact cum trimite P100-1 §5.3.4.1.1. Acoperire {acop} cm · amplificarea infrastructurii ×{ampl} · w_max = {wmax} mm.",
  "struct.arp.legenda_3d": "Panoul are {h} cm înălțime liberă (de la fața grinzii de fundare până sub placă) și {t} cm grosime. Beton = gri transparent; barele verticale — plasă pe ambele fețe, pe toată înălțimea, coborâte încă ~35 cm SUB panou, în grinda de fundare, ca mustăți (nu ies lateral din perete: stau în planul fiecărei fețe, la acoperirea de {acop} cm); barele orizontale de repartiție; tiranții din banda întinsă (sus la reazeme, jos în câmp); agrafele care leagă plasele. Contextul (stâlpii de capăt, placa peste subsol, grinda de fundare) e schițat — el NU intră în calcul, panoul se verifică singur, pe secțiunea lui. <b>Rosturile de lucru</b> sunt marcate cu portocaliu la baza și la vârful panoului: acolo barele verticale lucrează ca CONECTORI (CR 2-1-1.1 §10.3.2, secțiunea 7). Rotește cu mouse-ul, zoom cu scroll.",
  "struct.arp.s1_explicatie": "Panoul {el} are secțiunea {t}×{h} cm și lucrează ca element de bară între stâlpii {si} și {sj}. Ca la grinzi, eforturile nu se citesc în axul stâlpului, ci la FAȚA lui: l₀ = L_ax − off_i − off_j = {lax} − {oi} − {oj} = {l0} m.\n\nCE ESTE h = {h} cm. E înălțimea LIBERĂ a panoului, nu înălțimea nivelului: Pasul 7 o calculează ca înălțimea subsolului minus ce e ocupat deasupra — grosimea plăcii peste subsol, sau inima grinzii dacă între aceiași doi stâlpi există și o grindă (altfel betonul ei ar fi numărat de două ori). Panoul se toarnă deci de la fața superioară a grinzii de fundare până sub placă (sau sub grindă). În modelul de calcul h e ÎNĂLȚIMEA SECȚIUNII elementului de bară — ea preia încovoierea în plan, la fel cum înălțimea unei grinzi preia momentul vertical.\n\nNU E ANALIZAT ÎMPREUNĂ CU FUNDAȚIA. În modelul FEM panoul e o bară între nodurile din capul celor doi stâlpi de subsol (la cota plăcii), coborâtă rigid cu excentricitatea ei; nu are noduri pe muchia de jos, iar rețeaua de grinzi de fundare e un sistem separat. Consecința: capacitatea de mai jos se calculează pe secțiunea t × h a panoului SINGUR, fără să se conteze pe conlucrarea cu grinda de fundare sau cu placa — acoperitor. Mustățile desenate intrând în fundație sunt o piesă de EXECUȚIE (ancorarea și rolul de conector din secțiunile 7 și 10), nu un reazem pe care se sprijină calculul.\n\nCE DECIDE RAPORTUL l₀/h. SR EN 1992-1-1 §5.3.1(3) spune că un element e GRINDĂ doar dacă deschiderea e cel puțin 3× înălțimea secțiunii; altfel e GRINDĂ-PERETE. Aici l₀/h = {raport}, deci panoul {regim}.\n\n{urmare}",
  "struct.arp.este_grinda_perete": "ESTE grindă-perete",
  "struct.arp.e_grinda_obisnuita": "e o grindă obișnuită",
  "struct.arp.panou_zvelt": "Panoul e suficient de zvelt ca ipoteza secțiunii plane să fie valabilă, deci se verifică doar pe modelul de secțiune plană și nu i se cere tirant concentrat în bandă. Plafonul de pas §9.7(2) și verificarea de grindă cu zăbrele nu se aplică.",
  "struct.arp.valori_l0h": "l₀/h = {l0} / {h} = {raport} < {prag}",
  "struct.arp.valori_z": "z = 0,2·(l₀ + 2h) = 0,2·({l0} + {h2}) = {z} m (plafonat la 0,8·h = {zb} m)",
  "struct.arp.ref_conventia_grinzi_pereti": "convenția grinzilor-pereți — vezi nota de mai jos",
  "struct.arp.valori_banda": "banda = {frac} % · h = {cm} cm; în ea cad {inb} din {tot} rânduri ale plasei (A_s = {as} cm²)",
  "struct.arp.ref_tirantul_ancorat": "SR EN 1992-1-1 §9.7(3) (tirantul se ancorează complet în nod)",
  "struct.arp.termen_grinda_perete": "grindă-perete",
  "struct.arp.termen_grinda_perete_def": "element încovoiat la care deschiderea nu ajunge la 3× înălțimea secțiunii; efortul se transmite pe diagonale comprimate, nu prin încovoiere clasică",
  "struct.arp.termen_tirant": "tirant",
  "struct.arp.termen_tirant_def": "armătura întinsă a mecanismului de grindă cu zăbrele — «coarda» de jos (sau de sus) a zăbrelei",
  "struct.arp.termen_brat": "braț de pârghie (z)",
  "struct.arp.termen_brat_def": "distanța dintre rezultanta compresiunii și tirant; momentul capabil este forța din tirant × z",
  "struct.arp.termen_zona_rigida": "zonă rigidă (off)",
  "struct.arp.termen_zona_rigida_def": "bucata de panou din interiorul stâlpului: nodul de beton nu se deformează, deci eforturile de proiectare se citesc la FAȚA stâlpului",
  "struct.arp.s2_titlu": "2. Eforturile de calcul (cele 5 puncte)",
  "struct.arp.s2_explicatie": "Eforturile vin din tensorul combinat al Pasului 11, extrase per combinație (nu ca înfășurătoare anonimă), în EXACT aceleași 5 puncte ca la grinzi: R1 sus/jos și R2 sus/jos la fețele stâlpilor, câmpul = extremul de moment din interiorul deschiderii libere. Pentru fiecare punct se reține momentul extrem, combinația care îl dă, poziția x și componentele concomitente.\n\nCONVENȚIA DE SEMN. M₃ e încovoierea ÎN PLANUL peretelui, preluată de înălțimea h a panoului; pozitiv = fibra de JOS întinsă, deci tirantul lucrează jos. Negativ = fibra de sus întinsă (tipic la reazeme), deci tirantul lucrează sus. V₂ e tăietoarea în plan, P efortul normal în lungul panoului (negativ = compresiune).\n\nColoanele «_GS» sunt tripleta din combinația cvasipermanentă (G + ψ₂·Q, fără seism): din ea se citesc deschiderea fisurilor și efortul normal care închide rostul de lucru.",
  "struct.arp.th_punct": "punct",
  "struct.arp.th_grupare": "grupare",
  "struct.arp.negativ_compresiune": "negativ = compresiune",
  "struct.arp.amplificat_omega": " (×Ω)",
  "struct.arp.fata_sus": "sus",
  "struct.arp.fata_jos": "jos",
  "struct.arp.s3_explicatie": "La grinzi întrebarea e «fundamentala sau seismica?». La un panou de infrastructură se pune și una în plus: cu CE valori intră seismica.\n\nCR 2-1-1.1 §10.3.1 cere ca forțele de legătură dintre suprastructură și infrastructură să fie luate «asociate mecanismului de plastificare al suprastructurii» — adică nu forțele din analiza elastică, ci cele care apar când suprastructura chiar se plastifică. Aici asta se face simplificat: eforturile grupării SEISMICE se amplifică global cu Ω·γ_Rd = ×{ampl}. Amplificarea se aplică ACOPERITOR pe toată combinația, fiindcă descompunerea G/E nu mai e disponibilă în tensorul combinat al Pasului 11 (partea gravitațională e oricum mică față de cea seismică la M și V în planul panoului).\n\nGruparea fundamentală intră nemodificată, iar combinația cvasipermanentă GS (fără seism) la fel — ea servește fisurilor și rostului, unde amplificarea n-ar avea sens.\n\nAtenție la consecința inversă: fiindcă mecanismul de disipare e în suprastructură, tăietoarea NU se mai deduce din momentele capabile ale panoului (calculul capabil γ_Rd·ΣM_Rd/L_as de la grinzi nu se aplică) — vine din analiză, amplificată.",
  "struct.arp.s4_explicatie": "Solverul pornește de la minimele normative — ρ ≥ {rho} % pe fiecare direcție cu ambele plase (CR 2-1-1.1 §10.4.6), Ø ≥ 10 vertical / 8 orizontal, distanțe ≤ 350 mm pe orizontală / 250 mm pe verticală (§8.4.2) — și îndesește DIRECȚIA care pică: plasa orizontală când pică secțiunea plană, tiranții din bandă când pică grinda cu zăbrele, plasa verticală când pică tăietoarea sau rostul de lucru.{incercari}\n\nUn tabel spune «Ø10/250 pe ambele fețe»; desenele arată CE înseamnă asta la cofraj — două plase, acoperirea, agrafele care le leagă, banda în care se adună tirantul și cele două rosturi de lucru.",
  "struct.arp.s4_incercari": " Aici a luat {n}.",
  "struct.arp.legenda_randuri_oriz": "● {n} rânduri orizontale Ø{phi}/{pas} pe fiecare față",
  "struct.arp.legenda_bare_vert": "│ bare verticale Ø{phi}/{pas}, câte una pe fiecare față, prelungite ca mustăți în grinda de fundare",
  "struct.arp.legenda_tirant": "● tirant sus {sus} / jos {jos}, în banda hașurată de {banda} cm",
  "struct.arp.numai_plasa_banda": "(numai plasa din bandă)",
  "struct.arp.legenda_rosturi": "┄ barele verticale cos ambele rosturi de lucru (CR 2-1-1.1 §10.3.2)",
  "struct.arp.legenda_elev_vert": "│ bare verticale Ø{phi}/{pas}",
  "struct.arp.legenda_elev_oriz": "─ rânduri orizontale Ø{phi}/{pas}",
  "struct.arp.legenda_elevatie": "{otel} kg oțel, {beton} m³ beton. Bulina albastră arată fața <b>întinsă</b> în punctul respectiv (gruparea seismică amplificată, dacă există), iar cifra de sub ea e M₃ în kN·m — de aici se vede direct de ce tirantul lucrează SUS la reazeme și JOS în câmp. Zonele prună de la capete sunt porțiunile RIGIDE din stâlpi (l₀ = L_ax − off_i − off_j); liniile întrerupte orizontale sunt cele două rosturi de lucru.",
  "struct.arp.val_plasa": "Ø{phi}/{pas} mm — {n} bare, ρ = {rho} %",
  "struct.arp.val_plasa_randuri": "Ø{phi}/{pas} mm — {n} rânduri, ρ = {rho} %",
  "struct.arp.val_tirant": "{n}Ø{phi} ({as} cm²) + {plasa} cm² din plasă",
  "struct.arp.val_tirant_doar_plasa": "numai plasa din bandă: {plasa} cm²",
  "struct.arp.s5_explicatie": "MODELUL DE SECȚIUNE PLANĂ (SR EN 1992-1-1 §6.1). Se scrie echilibrul secțiunii t×h cu ε_cu = 3,5 ‰ la fibra comprimată, betonul pe bloc rectangular 0,8·x, oțelul elastic – perfect plastic, iar axa neutră se caută prin bisecție pe echilibrul axial. Toate rândurile plasei orizontale intră la socoteală, fiecare cu efortul lui, plus tirantul. Efortul normal concomitent P participă: o compresiune moderată CREȘTE momentul capabil, o întindere îl scade.\n\n{urmare}",
  "struct.arp.panou_zvelt_5": "Panoul e zvelt (l₀ ≥ 3·h), deci ipoteza secțiunii plane e valabilă și nu se mai cere al doilea model.",
  "struct.arp.th_verificarea": "verificarea",
  "struct.arp.momentul_de_calcul": "momentul de calcul",
  "struct.arp.momentul_capabil": "momentul capabil",
  "struct.arp.th_verdict": "verdict",
  "struct.arp.exemplu_tirant": "Exemplu de calcul al tirantului, în punctul cel mai solicitat: T_Ed = M_Ed/z, iar T_Rd = A_s,bandă·f_yd. Cu A_s,bandă = {as} cm² și f_yd = {fyd} MPa ⇒ T_Rd = {trd} kN, deci M_Rd = T_Rd·z = {mrd} kN·m.",
  "struct.arp.s6_explicatie": "CINE PREIA TĂIETOAREA. La un panou de subsol rolul etrierilor îl joacă barele VERTICALE: ele traversează fisura înclinată. Se verifică pe modelul de grindă cu zăbrele al SR EN 1992-1-1 §6.2.3, cu cotθ = 1 (diagonale la 45°) și brațul z = {z} m. Termenul de beton V_Rd,c NU se adună — dimensionarea merge integral pe armătură, acoperitor; el e listat mai jos doar informativ ({vrdc} kN).\n\nCR 2-1-1.1 §10.3.2 precizează că, «în funcție de proporțiile pereților și de distanțele dintre punctele de contact cu elementele suprastructurii, armăturile verticale sau cele orizontale sunt, după caz, cele mai eficiente». La l₀/h = {raport} {care}.\n\nBIELA COMPRIMATĂ. Între fisurile înclinate betonul lucrează la compresiune, ca diagonalele unei zăbrele. Dacă acele diagonale se strivesc (V_Rd,max, §6.2.3(3)), barele nu mai ajută deloc: soluția e GROSIME, nu armătură.\n\nNODUL DE REAZEM. Biela care coboară spre stâlp trebuie să aibă pe ce se sprijini. §6.5.4 limitează presiunea în nod la σ_Rd,max = k₂·ν′·f_cd, cu k₂ = 0,85 pentru un nod comprimat-întins (CCT) — suprafața de contact e semigabaritul stâlpului × grosimea peretelui. Și aici pârghia e geometria: perete mai gros sau stâlp mai lat pe direcția panoului.\n\nSR EN 1992-1-1 §6.5.2(3) permite explicit ca, pentru «bielele dintre zone încărcate direct, cum sunt consolele scurte sau grinzile-pereți scurte», să se folosească metodele din §6.2.2/§6.2.3 — de aceea nu se construiește un model de biele separat pentru tăietoare.",
  "struct.arp.verticale_mai_eficiente": "diagonala comprimată e mai lungă decât înaltă, deci barele VERTICALE sunt cele care o leagă",
  "struct.arp.orizontale_devin_eficiente": "panoul e mai înalt decât lung, deci și barele orizontale devin eficiente — verificarea de aici rămâne pe cele verticale, acoperitor",
  "struct.arp.s7_explicatie": "CERINȚA E ROMÂNEASCĂ, EXPLICITĂ. CR 2-1-1.1 §10.3.2: «Armăturile verticale care traversează rosturile de lucru dintre talpa (cuzinetul) fundației și perete, precum și rostul de lucru de sub planșeu vor fi dimensionate pentru rolul de conectare a zonelor de betoane cu vârste diferite.» Panoul se toarnă între două betoane deja întărite — grinda de fundare dedesubt și placa peste subsol deasupra — deci are DOUĂ rosturi, iar barele verticale sunt singurul lucru care le cusă.\n\nMODELUL. Rosturile sunt exact situația din SR EN 1992-1-1 §6.2.5: interfețe între betoane turnate la vârste diferite, paralele cu axa elementului. Se ia β = 1 și z al panoului SINGUR, adică acoperitor: tot efortul longitudinal al panoului se consideră trecând prin rost. Nu se contează pe nicio conlucrare cu grinda de fundare sau cu placa — dacă ele ar fi luate ca talpă a unei secțiuni compuse, brațul ar crește și v_Edi ar SCĂDEA, deci ipoteza de aici e cea mai severă.\n\nREZISTENȚA. v_Rdi = c·f_ctd + µ·σ_n + ρ·f_yd·µ, plafonat la 0,5·ν·f_cd. Suprafața se consideră RUGOASĂ (c = {c}, µ = {mu}) — rostul se lasă cu asperități, nu se toarnă peste beton neted. La gruparea seismică §6.2.5(5) cere înjumătățirea lui c (încărcări dinamice), deci în cazul guvernant de mai jos c = {cguv}.\n\nDE CE σ_n = 0. §6.2.5(1) cere efortul normal MINIM care poate acționa concomitent, pe direcția NORMALĂ la rost. Rosturile sunt plane orizontale, deci normala lor e verticala — iar «P» al elementului de bară e forța axială pe direcția LUNGULUI panoului, nu pe verticală. Partea verticală (greutatea panoului + ce coboară din placă) nu e disponibilă per panou în tensorul Pasului 11, iar creditarea greșită a lui P ar umfla artificial capacitatea rostului. Se merge deci acoperitor, cu σ_n = 0: rostul se duce numai pe conectori și pe frecarea suprafeței rugoase. Compresiunea reală, necreditată, e o rezervă în plus.\n\nPractic: barele verticale se toarnă cu MUSTĂȚI din fundație, cu lungimile din secțiunea 10.",
  "struct.arp.din_capabili": "Din cei {mpa} MPa capabili, {pct} % vin din barele verticale și restul din frecarea pe rostul rugos + compresiunea de pe el. Cu alte cuvinte: conectorii sunt cei care duc rostul, nu asperitatea betonului.",
  "struct.arp.s8_explicatie": "DE CE CONTEAZĂ LA UN PERETE DE SUBSOL. Fața exterioară stă în contact cu terenul (clasa de expunere XC2), deci SR EN 1992-1-1 tab. 7.1N cere w_max = {wmax} mm pentru elemente de beton armat. O fisură mai deschisă nu e o problemă de rezistență, ci de etanșeitate și de durabilitate a armăturii.\n\nCUM SE CALCULEAZĂ. w_k = s_r,max·(ε_sm − ε_cm), cu s_r,max = 3,4·c + 0,425·k₁·k₂·Ø/ρ_eff (§7.3.4; k₁ = 0,8 bare profilate, k₂ = 0,5 încovoiere, k_t = 0,4 durată). Momentul e cel din combinația cvasipermanentă GS (G + ψ₂·Q, fără seism și fără amplificarea infrastructurii), iar armătura întinsă considerată e tirantul din banda de la fața întinsă — consistent cu modelul de grindă cu zăbrele. Fluajul intră prin E_eff = E_cm/(1+φ) = {eeff} MPa (φ = {fi}).\n\nDE CE E MARCAT «INFORMATIV». Relațiile §7.3 sunt scrise pentru elemente încovoiate ZVELTE; la o grindă-perete distribuția fisurilor e alta. De aceea cifra se calculează și se arată, dar NU intră în verdictul panoului și nu ajunge în lista de picate a Pasului 19. Dacă depășește w_max apare avertisment explicit.\n\n«Nefisurat» înseamnă că momentul cvasipermanent nu atinge momentul de fisurare M_cr = f_ctm·t·h²/6 = {mcr} kN·m — la un panou de 2,8 m înălțime M_cr e foarte mare, deci e cazul obișnuit.",
  "struct.arp.momentul_cvasipermanent": "momentul cvasipermanent",
  "struct.arp.th_limita": "limita",
  "struct.arp.s9_explicatie": "Un calcul poate cere o arie de armătură care verifică perfect pe hârtie, dar care e sub minimul normativ sau nu încape în cofraj. Fiecare regulă de mai jos e o verificare cu R/E și cu articolul ei, nu o notă la marginea paginii.\n\nPROCENTELE MINIME. CR 2-1-1.1 §10.4.6 e categoric: «Procentele de armare orizontală și verticală în inima pereților considerând ambele plase vor fi cel puțin 0,30 %.» E mai sever decât Tabelul de la armarea în câmp a suprastructurii (0,20–0,30 % după zonă și oțel) și decât SR EN 1992-1-1 §9.6 (0,2 % vertical / 0,1 % orizontal) — deci el guvernează. La grindă-perete se adaugă §9.7(1): plasă ortogonală lângă FIECARE față, minim 0,1 % din aria de beton și cel puțin 150 mm²/m pe fiecare față și direcție.\n\nDIAMETRE ȘI DISTANȚE. §8.4.2: Ø ≥ 8 mm orizontal, Ø ≥ 10 mm vertical, armătura din DOUĂ plase câte una la fiecare față, distanțe maxime 350 mm pe orizontală și 250 mm pe verticală. La grindă-perete SR EN 1992-1-1 §9.7(2) strânge la min(2·t, 300 mm), deci decide limita mai severă.\n\nGROSIMEA. §10.4.2: pereții de CONTUR ai subsolului au cel puțin 250 mm, cei interiori cel puțin 200 mm. Panoul de aici e {fel}, deci minimul lui e {minim} cm.\n\nDISTANȚA ÎNTRE PUNCTELE DE ÎNCĂRCARE VERTICALĂ. §10.4.5: «La alegerea deschiderilor și traveelor se va urmări ca distanțele dintre punctele de încărcare verticală a infrastructurii să nu depășească, de regulă, 6 m.» Peste atât, rețeaua de grinzi de fundare se încovoaie între reazeme și infrastructura încetează să lucreze ca o CUTIE. Un «punct de încărcare verticală» e locul în care SUPRASTRUCTURA descarcă în infrastructură: un stâlp care există numai în subsol face parte din infrastructură (§10.4.1) și nu o încarcă, deci nu contează ca reazem. De aceea E nu e neapărat lungimea panoului — panourile mărginite de asemenea stâlpi se leagă de vecinii lor coliniari până la primul stâlp care URCĂ, iar dacă pe axă nu există un al doilea, verificarea nu se aplică și rândul spune de ce. Remediul, când chiar se depășește, e ARHITECTURAL (un stâlp la mijlocul deschiderii), nu un recalcul.\n\nA_s ≤ 4 %. SR EN 1992-1-1 §9.6.2(1): peste 4 % oțel în aria de beton, betonul nu se mai poate compacta printre bare — dacă ajungi acolo, panoului nu îi lipsește armătură, îi lipsește beton.",
  "struct.arp.perete_de_contur": "de CONTUR",
  "struct.arp.perete_interior": "INTERIOR",
  "struct.arp.th_e_adoptat": "E (adoptat / cerut)",
  "struct.arp.th_r_limita": "R (limita)",
  "struct.arp.s10_explicatie": "Barele verticale nu se pot turna dintr-o bucată cu fundația: din grinda de fundare ies MUSTĂȚI, iar plasa peretelui se înnădește peste ele. Lungimea de suprapunere e ce face din două bare una.\n\nCE ARTICOL DECIDE. P100-1 §5.7.1(1) și (3) trimit la capitolul 8 din SR EN 1992-1-1 pentru ancoraje și înnădiri în afara zonelor critice. Infrastructura NU e zonă critică — CR 2-1-1.1 §10.4.1 o proiectează în domeniul elastic — deci NU se aplică sporul de 20 % din P100-1 §5.7.1(4), care e scris pentru zonele critice ale structurilor DCH. Rămâne calculul curat din EC2.\n\nCUM SE CALCULEAZĂ. f_bd = 2,25·η₁·η₂·f_ctd cu η₁ = 1 (aderență bună) și η₂ = 1 (Ø ≤ 32 mm); l_b,rqd = (Ø/4)·(σ_sd/f_bd). Coeficienții α din §8.4.4 se iau 1,0 (bare drepte, fără presiune transversală), iar α₆ = {alfa6} fiindcă mustățile se înnădesc TOATE în aceeași secțiune (§8.7.3, tab. 8.3).\n\nBarele astea au și un al doilea rol, verificat în secțiunea 7: sunt conectorii rostului talpă–perete (CR 2-1-1.1 §10.3.2).",
  "struct.arp.val_fbd": "f_bd = 2,25·1,0·1,0·{fctd} = {fbd} MPa",
  "struct.arp.val_lb": "l_b,rqd = (Ø{phi}/4)·({fyd}/{fbd}) = {lb} cm ⇒ l_bd = {lbd} cm",
  "struct.arp.ref_minime_ancorare": "§8.4.3–§8.4.4, cu minimele max(10Ø; 100 mm)",
  "struct.arp.val_l0": "l₀ = α₆·l_b,rqd = {a6}·{lb} = {l0} cm",
  "struct.arp.ref_innadite_aceeasi": "§8.7.3, tab. 8.3 (100 % din bare înnădite în aceeași secțiune)",
  "struct.arp.practic_plansa": "Practic, pe planșa de execuție: mustăți Ø{phi}/{pas} mm din grinda de fundare, cu <b>{l0} cm</b> de suprapunere în perete, pe ambele fețe. Înălțimea liberă a panoului ({h} cm) o permite cu {rezerva} cm de rezervă.",
  "struct.arp.agrafe_legare": "Agrafe de legare a plaselor",
  "struct.arp.val_agrafe": "{n}Ø{phi}/m² — {buc} buc{carlig}",
  "struct.arp.val_agrafe_carlig": ", cârlig {c}",
  "struct.arp.val_materiale": "{otel} kg oțel · {beton} m³ beton · {rap} kg/m³",
  "struct.arp.svg_a_sectiune_grosime": "a) Secțiune prin grosime (vedere de sus) — {t} cm, două plase",
  "struct.arp.cota_pas": "pas {v} mm",
  "struct.arp.cota_fasie": "fâșie {v} cm",
  "struct.arp.svg_acoperire_panou": "acoperire {c} cm pe fiecare față · panou l₀ = {l0} m × h = {h} m",
  "struct.arp.svg_verticale": "● verticale Ø{phi}/{pas}",
  "struct.arp.svg_orizontale": "● orizontale Ø{phi}/{pas}",
  "struct.arp.svg_agrafe": "│ agrafe {n}Ø{phi}/m²",
  "struct.arp.svg_b_sectiune_verticala": "b) Secțiune verticală — {t} × {h} cm",
  "struct.arp.rost_perete_placa": "rost perete–placă",
  "struct.arp.rost_talpa_perete": "rost talpă–perete",
  "struct.arp.svg_c_elevatia": "c) Elevația panoului — {l} × {h} m, între {si} și {sj} · cele 5 puncte de verificare",
  "struct.arp.eticheta_banda_tirant": "bandă tirant {v} cm",
  "struct.arp.incercari#n": "1 încercare|{n} încercări|{n} de încercări",
  "struct.arpl.reazemul_comun_ia": "· reazemul comun se ia pe {p1} m (vecinul)",
  "struct.arpl.p1_stalpi": "({p1} stâlpi)",
  "struct.arpl.schema_doua_directii": "pe două direcții",
  "struct.arpl.schema_una_directie": "pe o direcție",
  "struct.arpl.schema_consola": "consolă",
  "struct.arpl.schema_nerezemat": "NEREZEMAT",
  "struct.arpl.din_2": "{n} din 2",
  "struct.arpl.reazem_m": "reazem {v} m",
  "struct.arpl.continuu": " · continuu",
  "struct.arpl.simplu": " · simplu",
  "struct.arpl.vecini": " ({lista})",
  "struct.arpl.fara_reazem_liberi": "fără reazem ({v} m liberi)",
  "struct.arpl.eticheta_grinda": "grindă",
  "struct.arpl.eticheta_perete": "perete",
  "struct.arpl.eticheta_fara_reazem": "fără reazem",
  "struct.arpl.deschidere_cerc": "{v} m (cercul înscris)",
  "struct.arpl.legenda_ochi": "· gri gros = perete care stă PE placă (fără grindă dedesubt) · hașurat = gol de placă. Plasa de JOS e desenată bară cu bară la pasul real:",
  "struct.arpl.desenul_rarit": " — desenul arată o bară din {n} ca să rămână citibil; pasul din text e cel real.",
  "struct.arpl.directia_scurta_e": " Direcția scurtă e {dir} ({l} m), deci barele ei stau dedesubt, cu acoperirea cea mai mică.",
  "struct.arpl.directia_nu_duce": "Direcția {dir} nu duce încărcare (fâșiile o dau descărcată, iar FEM-ul n-a cerut mai mult).",
  "struct.arpl.m_camp_diag": "M_câmp = {v} kNm/m",
  "struct.arpl.fasii_fem": "fâșii: câmp {a} · FEM: câmp {b}",
  "struct.arpl.fem_guverneaza_diag": "⚠ metodă: FEM-ul guvernează — se dimensionează pe el",
  "struct.arpl.fasii_guverneaza": "fâșiile guvernează (acoperitor față de FEM)",
  "struct.arpl.numai_fasii": "numai metoda de fâșii (FEM-ul nu a produs tăieturi pe direcția asta)",
  "struct.arpl.armatura_sus_lipseste": "armătura de sus lipsește",
  "struct.arpl.prindere_fatada": "prindere pe fațadă {v} m",
  "struct.arpl.armatura_sus_ancorata": "armătura de SUS, ancorată în placă; săgeata cu K = 0,4",
  "struct.arpl.pasul_nu_rulat": "Pasul nu a fost rulat încă. Apasă «Run» în meniul din stânga (după Pașii 7, 8 și 14).",
  "struct.arpl.ochiuri_de_placa": "ochiuri de placă ·",
  "struct.arpl.verificari_dot": "verificări ·",
  "struct.arpl.placa_de_cm": " · placă de {v} cm · {otel} kg oțel · {beton} m³ beton",
  "struct.arpl.metode_fem": "celor două metode: fâșii (Grashof–Marcus + coeficienți) și {n} tăieturi de dimensionare din FEM. Pe {noc} direcții de ochi guvernează FEM-ul — ⚠ metodă.",
  "struct.arpl.numai_metoda_fasii": "Momentele vin NUMAI din metoda de fâșii:",
  "struct.arpl.gabarit_deschidere": "{lx} × {ly} m · deschiderea de calcul {d} m (cercul înscris)",
  "struct.arpl.albastru_y": "albastru = Y",
  "struct.arpl.sus_mrd": "SUS: {text} (M_Rd {v} kNm/m)",
  "struct.arpl.jos_mrd": "JOS: {text} (M_Rd {v} kNm/m)",
  "struct.arpl.acoperirea_nominala": "acoperirea nominală {c} cm; d = h − c − Ø/2, exact valoarea cu care s-a calculat M_Rd — direcția {dir} (scurtă)",
  "struct.arpl.rezumat_ochi": "{arie} m² · cat. {cat} · placă de {h} cm · deschiderea de calcul {d} m · {schema}{raport} · q_Ed {q} kN/m² · {otel} kg oțel",
  "struct.arpl.raport_l": " (l_lung/l_scurt = {v})",
  "struct.arpl.perimetrul_laturi": "Perimetrul de {p} m se împarte în {n} laturi omogene:",
  "struct.arpl.continuitatea_nu": ". Continuitatea nu se presupune: o latură e continuă numai dacă de partea cealaltă a reazemului CHIAR începe alt ochi — de aceea vecinii sunt scriși pe desen, iar click pe ei mută selecția.",
  "struct.arpl.directia_dir": "Direcția {dir}",
  "struct.arpl.scurta_moment_mare": " (scurtă — ea duce momentul mare)",
  "struct.arpl.pereti_pe_ochi": "Pereți care stau PE ochi (fără grindă dedesubt):",
  "struct.arpl.fasii_fem_scurt": "fâșii {a} · FEM {b}",
  "struct.arpl.incercari": "Încercări:",
  "struct.arpl.istoric_rand": "{de_la} → {la} ({de_ce}, R/E {re})",
  "struct.arpl.nu_se_aplica": "Nu se aplică: {motiv}",
  "struct.arpl.niciun_stalp": "Niciun stâlp de verificat: în toate nodurile forța ajunge la stâlp prin grinzi, pe două direcții perpendiculare",
  "struct.arpl.unde_vin_ce": "Nu din shell-urile de placă ale Pasului 7: tensorul Pasului 8 nu le înregistrează. Vin din repartiția încărcării pe două direcții (fâșia scurtă ia partea mare) și din coeficienți de moment.",
  "struct.arpl.unde_vin_de_ce": "Tranșa 2 le înlocuiește cu rezultantele FEM (Wood–Armer) și păstrează metoda de acum ca verificare încrucișată; divergențele se marchează «⚠ metodă», ca la Pasul 10.",
  "struct.ars.fundatia_desenata_adanci": "Fundația e desenată la adâncimea ei reală (talpa la {p1} m, B = {p2} m).",
  "struct.ars.procentul_armare_ar": "(procentul de armare ar fi cerut doar {p1})",
  "struct.ars.n_p1_kn": "N = {p1} kN (compresiune pură)",
  "struct.ars.n_p1_kn2": "N = {p1} kN (întindere pură)",
  "struct.ars.toata_verticala_stack": "pe toată verticala (stack-ul {p1})",
  "struct.ars.p1_fasii": "+ {p1} fâșii",
  "struct.ars.p1_nivelurile": "{p1}, toate nivelurile",
  "struct.combina.p1_p2_0": "; {p1} {p2} cu ψ₀ (×{p3})",
  "struct.combina.defavorabil_p1_favorabil": "(defavorabil) sau {p1} (favorabil);",
  "struct.combina.p1_0_30": "(α = {p1}) și ±α·0,30 în regula celor 30 %; nu apare deloc",
  "struct.combina.p1_p2_p3": "{p1}·{p2} = {p3} (zăpada)",
  "struct.combina.seismica_2_p1": "seismică: ×ψ₂ = {p1} — doar fracțiunea cvasipermanentă",
  "struct.combina.actiunea_variabila_domin": "Acțiunea variabilă dominantă: {p1} (×1,50)",
  "struct.combina.fundamentala_g_p1": "fundamentală: γ_G = {p1}",
  "struct.combina.p1_0_p2": "×{p1}·ψ₀ = {p2} când nu e (ψ₀ = {p3});",
  "struct.combina.p1_fortei_seismice": "{p1} cu al forței seismice",
  "struct.combina.p1_p2_peste": "{p1}{p2}, peste încărcările",
  "struct.combina.numarul_mare_combinatii": "numărul mare de combinații seismice ({p1})",
  "struct.combina.gruparea_fundamentala_fa": "Gruparea fundamentală (fără cutremur). {p1}{p2}.",
  "struct.combina.p1_p2": "{p1} % pe {p2}°",
  "struct.combina.torsiunea_accidentala_p1": "Torsiunea accidentală pe {p1}, semn {p2} —",
  "struct.combina.fundamentala_p1_cand": "fundamentală: ×{p1} când e acțiunea dominantă,",
  "struct.combina.gravitationale_g_2": "gravitaționale G + ψ₂·Q. {p1}",
  "struct.combina.arata_cele_p1": "Arată toate cele {p1}",
  "struct.combina.pasul_nu_rulat": "Pasul nu a fost rulat încă. Apasă «Run» în meniul din stânga (după Pașii 8 și 9).",
  "struct.combina.ultima_rulare_esuat": "Ultima rulare a eșuat: {motiv}",
  "struct.combina.eroare_necunoscuta": "eroare necunoscută",
  "struct.combina.combinatii_generate": "Combinații generate",
  "struct.combina.card_sub_fund_seism": "{f} fundamentale + {s} seismice{gs} (CR 0-2012){set}",
  "struct.combina.card_sub_gs": " + {n} GS",
  "struct.combina.card_sub_set": " — {nume}",
  "struct.combina.compozitie_implicita": "<b>Fundamentale</b> (situația de zi cu zi, fără cutremur): γ_G·G + 1,5·Q_dominant + 1,5·ψ₀·Q_restul.",
  "struct.combina.compozitie_seismice": "<b>Seismice</b> — regula celor 30 %: 100 % pe o direcție simultan cu 30 % pe cealaltă.",
  "struct.combina.compozitie_gs": "<b>GS</b> — partea gravitațională a grupării seismice (G + ψ₂·Q), păstrată separat: din ea se ia tăietoarea gravitațională la calculul capabil.",
  "struct.combina.alpha_amplificarea": "α — amplificarea de ordinul II",
  "struct.combina.masele_pasului_7": "masele Pasului 7",
  "struct.combina.tensorul_de_eforturi": "tensorul de eforturi",
  "struct.combina.alpha_sub": "pe direcțiile X / Y — aplicat cazurilor seismice",
  "struct.combina.ce_nu_acopera": "Ce NU acoperă setul folosit",
  "struct.combina.limitari_cunoscute": "— {n} limitări cunoscute",
  "struct.combina.normativul_eticheta": "Normativul:",
  "struct.combina.efectul_eticheta": "Efectul:",
  "struct.combina.cum_se_schimba": "Cum se schimbă: <b>{cum}</b>.",
  "struct.combina.alpha_vine_din_10": "Amplificarea de ordinul II vine din Pasul 10",
  "struct.combina.deplasari_laterale": "— deplasări laterale (drift)",
  "struct.combina.driftul_s_a_mutat": "Driftul de nivel și coeficientul θ s-au mutat la <b>Pasul 10</b>: sunt verificări de deplasare, nu combinații. Aici se aplică doar α pe cazurile seismice. Tabelul pe niveluri, punctul din plan care guvernează și verdictele Anexei E se văd la Pasul 10.",
  "struct.combina.sursa_alpha": " Sursa: {sursa}.",
  "struct.combina.th_alpha_aplicat": "α aplicat",
  "struct.combina.rol_permanenta": "fundamentală: γ_G = {gd} (defavorabil) sau {gf} (favorabil); seismică: 1,00 — permanentele sunt sigur acolo când vine cutremurul",
  "struct.combina.rol_variabila": "fundamentală: ×{gq} când e acțiunea dominantă, ×{gq}·ψ₀ = {nedom} când nu e (ψ₀ = {psi0}); seismică: ×ψ₂ = {psi2} — doar fracțiunea cvasipermanentă e prezentă statistic în momentul cutremurului",
  "struct.combina.rol_seismica": "numai în gruparea seismică: ±α·1,00 pe direcția proprie (α = {a}) și ±α·0,30 în regula celor 30 %; nu apare deloc în gruparea fundamentală",
  "struct.combina.rol_torsiune": "însoțește fiecare combinație seismică de pe axa ei, cu ambele semne: ±α·1,00 (α e același ca la cazul E de pe aceeași axă)",
  "struct.combina.subsol_e_theta": "La cazurile <code>E_θ</code> cifra din coloana «cât iese» este forța tăietoare de bază (combinată CQC), nu o greutate — forțele seismice sunt deja împărțite la factorul de comportare q{q} și conțin deja coeficientul de importanță γ_I,e, de aceea în matrice nu mai apare niciun coeficient pentru ele în afară de ±α. La <code>T_acc</code> cifra este suma momentelor de torsiune pe niveluri (kNm), nu o forță.",
  "struct.combina.q_egal": " = {v}",
  "struct.combina.ce_gg_defav": "toate permanentele (G1…G4) înmulțite cu 1,35 — presupui că betonul, pereții și finisajele cântăresc mai mult decât ai socotit",
  "struct.combina.sursa_gg_defav": "CR 0-2012 §6.3, rel. (6.7) — decizie a normativului, nu a proiectantului",
  "struct.combina.ce_gg_fav": "aceleași permanente, dar luate cu 1,00 — pentru situațiile în care greutatea «ajută» (răsturnare, întindere în stâlpii marginali, desprinderea fundației). O combinație cu 1,35 ar ascunde exact aceste cazuri",
  "struct.combina.ce_gq_dom": "acțiunea variabilă considerată dominantă în acea combinație (pe rând Q1, Q2, S) intră cu valoarea ei caracteristică × 1,50",
  "struct.combina.ce_gq_nedom": "celelalte acțiuni variabile din aceeași combinație, reduse cu ψ₀ — e improbabil ca și utila maximă, și zăpada maximă să cadă în aceeași zi",
  "struct.combina.valoare_psi0": "{gq}·{psi0u} = {u} (utila), {gq}·{psi0z} = {z} (zăpada)",
  "struct.combina.valoare_psi2": "Q1: {q1} · Q2: {q2} · S: {s}",
  "struct.combina.ce_psi2": "în gruparea seismică variabilele intră doar cu fracțiunea cvasipermanentă: partea din utilă/zăpadă care e statistic prezentă în clădire în momentul cutremurului. Aceleași ψ₂ au fost folosite și la masele din analiza modală (Pasul 7) — de aceea forțele seismice și greutatea din combinație sunt consecvente",
  "struct.combina.valoare_alpha_xy": "X: {x} · Y: {y}",
  "struct.combina.ce_alpha": "amplificarea de ordinul II, aplicată cazurilor E și T_acc. Când θ ≤ 0,10 iese exact 1,000 și coeficienții seismici rămân ±1",
  "struct.combina.ce_regula_30": "cutremurul nu vine niciodată perfect pe o axă: se ia 100 % pe o direcție simultan cu 30 % pe cealaltă, în toate combinațiile de semn",
  "struct.combina.ce_semne": "cutremurul e alternant: aceeași combinație se ia și cu semnul plus, și cu minus, pentru că nu știi din ce parte vine. De aici numărul mare de combinații seismice ({n})",
  "struct.combina.ce_gamma_ie": "coeficientul de importanță al clădirii. NU apare în matrice, pentru că e deja înmulțit în spectrul de proiectare la Pasul 9",
  "struct.combina.coeficientii_titlu": "Coeficienții din matrice — de unde vine fiecare cifră",
  "struct.combina.th_coeficient": "Coeficient",
  "struct.combina.descrie_gs": "Numai partea gravitațională a grupării seismice: G + ψ₂·Q + ψ₂·S, fără cutremur. Nu intră în înfășurătoare — din ea se ia tăietoarea gravitațională pentru forța asociată capacității (Pasul 13).",
  "struct.combina.gg_defavorabil": "defavorabil — greutatea proprie mărește eforturile",
  "struct.combina.gg_favorabil": "favorabil — cazul în care greutatea «ajută»: răsturnare, întindere în stâlpi, desprinderea fundației",
  "struct.combina.nicio_dominanta": "Nicio acțiune variabilă dominantă",
  "struct.combina.descrie_fundamentala": "Gruparea fundamentală (fără cutremur). {dom}{rest}. Permanentele: γ_G = {gg} — {fav}.",
  "struct.combina.parte_seismica": "{pct} % pe {grade}° (semn {semn})",
  "struct.combina.torsiune_pe_axa": "Torsiunea accidentală pe {ax}, semn {semn} — {relatie} cu al forței seismice dominante",
  "struct.combina.acelasi_semn": "același",
  "struct.combina.semn_opus": "opus",
  "struct.combina.fara_torsiune": "Fără torsiune accidentală în această combinație.",
  "struct.combina.regula_30_prefix": "Regula celor 30 % (cutremurul nu vine perfect pe o axă): ",
  "struct.combina.o_singura_directie": "Cutremur pe o singură direcție: ",
  "struct.combina.simultan_cu": " simultan cu ",
  "struct.combina.descrie_seismica": "{reg}{parti}, peste încărcările gravitaționale G + ψ₂·Q. {tors}",
  "struct.combina.rol_fundamentala": "intră în înfășurătoarea fundamentală (SLU, fără cutremur)",
  "struct.combina.rol_seismica_grupa": "intră în înfășurătoarea seismică (SLU, gruparea specială)",
  "struct.combina.rol_gs": "combinație de serviciu internă — nu intră în înfășurătoare",
  "struct.combina.matricea_combinatiilor": "Matricea combinațiilor",
  "struct.combina.nr_comb_sub": "{f} combinații fundamentale și {s} seismice, plus combinația <code>GS</code> (gravitațională, pentru Pasul 13).",
  "struct.combina.th_grupa": "Grupă",
  "struct.combina.ascunde": "Ascunde",
  "struct.combina.citeste_numele_lung": "<code>SLUF_…_1.35</code> = grupare fundamentală (SLU), acțiunea dominantă din mijloc, permanentele cu γ_G = 1,35. <code>ES30_XPM</code> = regula celor 30 % cu X dominant: primul semn e al direcției de 100 %, al doilea al celei de 30 %. În <b>setul complet</b> numele mai are o literă mică la coadă (<code>ES30_XPMp</code> / <code>…m</code>) — semnul torsiunii accidentale, care acolo se ia în ambele sensuri; în setul redus torsiunea urmează semnul forței seismice, deci litera lipsește. Tot în setul complet apare familia direcțiilor rotite, <code>ES45Pp</code> = seism pe 45°, semnul forței apoi semnul torsiunii. <code>GS</code> = partea gravitațională a grupării seismice, luată singură.",
  "struct.combina.simbol_psi2": "ψ₂ (gruparea seismică)",
  "struct.combina.rest_reduse#n": "; {lista} intră redusă cu ψ₀ (×{val})|; {lista} intră reduse cu ψ₀ (×{val})|; {lista} intră reduse cu ψ₀ (×{val})",
  "struct.dr.termen_neaplicat_metoda": "termen NEAPLICAT (metoda biroului) — cu el, driftul SLS maxim ar fi {p1} % în loc de {p2} %",
  "struct.dr.p1_p2_d": "{p1}·{p2}·d_re pe X, {p3}·{p4}·d_re pe Y",
  "struct.dr.raportul_masoara_p1": "raportul se măsoară {p1}",
  "struct.modl.30_30_cm": "30×30 cm propus, din care {p1} redimensionări aplicate de bucla externă (Pasul 19) — tabelul e la finalul paginii",
  "struct.modl.p1_p2_m": "pe {p1} la {p2} m (segment nou {p3})",
  "struct.modl.stalpi_orfani_eliminati": "stâlpi orfani eliminați: {p1}",
  "struct.modl.p1_perechi_stalpi": "· {p1} perechi de stâlpi turnate ca un element",
  "struct.modl.grinzile_unesc_p1": "grinzile se unesc în {p1} ({p2} m)",
  "struct.modl.vezi_cele_p1": "vezi toate cele {p1} încălcări",
  "struct.modl.intre_p1_p2": "între {p1}, {p2} m",
  "struct.modl.selecteaza_p1_plansa": "selectează {p1} pe planșa etajului",
  "struct.modl.p1": "→ pe {p1}",
  "struct.modl.bp_titlu": "Pasul 4, pasul geometric {bp} — stare înghețată",
  "struct.modl.bp_text": "un breakpoint din istoricul de soluționare al soluției: geometria de după pasul {bp}, fără pașii de după el. Lanțul continuă cu ULTIMUL pas —",
  "struct.modl.bp_text_din": "un breakpoint din istoricul de soluționare al soluției: geometria de după pasul {bp} din {n}, fără pașii de după el. Lanțul continuă cu ULTIMUL pas —",
  "struct.modl.bp_inapoi": "înapoi la geometria livrată",
  "struct.rz.geometria_minima_b": "geometria minimă (B={p1} m, Df={p2} m) nu respecta verificările — mărită la volumul minim fezabil",
  "struct.rz.minimul_legal_b": "minimul legal (B={p1} m, Df={p2} m) respectă presiunea și tasarea — rămâne",
  "struct.rz.g4_beton_25": "G4 = beton·25 + pământ·γ + B·q_CTN = {p1} kN/ml\n",
  "struct.rz.pamant_p1_m3": "pământ {p1} m³/ml\n",
  "struct.rz.fundatie_b_p1": "Fundație B = {p1} m · Df = {p2} m",
  "struct.rz.p1_m_p2": "{p1} m pe {p2} m",
  "struct.rz.unde_vine_h": "De unde vine H = {p1} m",
  "struct.seism.retinute_p1_extrase": "reținute din {p1} extrase — atâtea cât cere criteriul de masă modală de 90% (P100-1 §4.5.3.3.1); minimul cerut: {p2}",
  "struct.seism.arata_cele_p1": "Arată toate cele {p1} moduri",
  "struct.cob.masa_aplica_elemente": "Masa nu se aplică pe elemente, ci pe <b>noduri</b>: câte o valoare în cele trei translații (rotirile rămân fără inerție). Raza bilei e proporțională cu rădăcina cubică a masei, ca volumul desenat să fie proporțional cu ea.",
  "struct.cob.b_utila_b": "<b>utila</b> intră în masă doar cu fracțiunea ψ_E = φ·ψ₂ (tipic 0,24), nu integral: probabilitatea ca toată mobila și toți oamenii să fie prezenți fix în secunda cutremurului e mică;",
  "struct.cob.b_infrastructura_b": "<b>infrastructura</b> apare doar la încărcări: EN 1998-1 §4.3.3.2.2(1)P definește masa seismică drept masa clădirii DEASUPRA fundației.",
  "struct.ars.b_1_p": "<b>1. P–M–M</b> — un stâlp e comprimat (N) și încovoiat pe două direcții (M2, M3) în același timp. Cele trei mărimi nu se verifică separat: capacitatea secțiunii este o SUPRAFAȚĂ în spațiul (N, M2, M3) — «ceapa». Fiecare combinație de încărcări dă un punct; toate punctele trebuie să cadă în interiorul cepei. Compresiunea moderată AJUTĂ la încovoiere (închide fisurile), de aceea ceapa se umflă spre compresiune și se închide în vârf, unde betonul se zdrobește fără moment.",
  "struct.ars.b_n_s": "<b>α = α_n · α_s</b> este eficiența confinării, nu toată armătura transversală «prinde» betonul la fel. α_n = 1 − Σb_i²/(6·b₀·h₀) ține cont că între două bare ținute betonul se scurge pe o boltă — cu cât barele sunt mai rare, cu atât se confinează mai puțin (de aici și regula interaxului de 18 cm). α_s = (1 − s/2b₀)(1 − s/2h₀) ține cont de aceeași boltă, dar pe verticală, între două niveluri de etrieri.",
  "struct.ars.b_rd_b": "<b>γ_Rd</b> acoperă faptul că oțelul real e mai tare decât cel de calcul și se consolidează după curgere. Valoarea vine din normativ, după clasa de ductilitate a proiectului — cifra folosită aici e în tabelul γ_Rd din capul filei, iar detaliul fiecărei verificări de tăietoare o poartă cu el.",
  "struct.ars.b_d_b": "<b>ν_d</b> apare pentru că un stâlp mai comprimat are zona de beton zdrobit mai mare, deci are nevoie de mai multă confinare. Sub ν_d ≤ 0,20 cerința nu se aplică: betonul nu e în pericol de zdrobire, iar minimul ω_wd e suficient.",
  "struct.ars.b_perete_b": "<b>Ce e «perete»</b> (EC8 §5.1.2): element vertical cu latura de-a lungul direcției peste cea transversală de mai mult de 4 ori (l_w/b_w &gt; 4). Se judecă PE DIRECȚIE — o lamelă de 30×200 e perete pe direcția lungă și stâlp pe cealaltă.",
  "struct.ars.b_etrierii_orizontali": "<b>etrierii orizontali din nod ca DIMENSIONARE</b> (A_sh din echilibrul diagonalei întinse) + armătura verticală de nod — acum se verifică doar compresiunea diagonalei;",
  "struct.ars.verificarile_b_geometric": "verificările <b>geometrice</b>: b_grindă ≤ min(b_stâlp + h_grindă; 2·b_stâlp), excentricitatea ax grindă / ax stâlp ≤ b_stâlp/4;",
  "struct.ars.b_v_c": "<b>V_c real</b> (tăietoarea stâlpului de deasupra) în V_jhd — acum se ia 0, conservator;",
  "struct.ars.pasul_nu_rulat": "Pasul nu a fost rulat încă. Apasă «Run» (după Pasul 13).",
  "struct.ars.ultima_rulare_esuat": "Ultima rulare a eșuat: {motiv}",
  "struct.ars.eroare_necunoscuta": "eroare necunoscută",
  "struct.ars.stalpi_lamele_armate": "Stâlpi și lamele armate",
  "struct.ars.clasa_ductilitate_pas3": "clasa de ductilitate (Pasul 3)",
  "struct.ars.gamma_nod_nume": "{v} — {sursa}",
  "struct.ars.stalpi_pe_niveluri": "{n} stâlpi pe niveluri · {verdicte}",
  "struct.ars.verdict_x": "{n} × {v}",
  "struct.ars.parametrii_de_calcul": "Parametrii de calcul",
  "struct.ars.param_beton": "beton {beton} (f_cd = {fcd} MPa — din «Date clădire») · oțel f_yd = {fyd} MPa · clasa {clasa} · νd ≤ {nud} · p ∈ [{pmin}%, {pmax}%]",
  "struct.ars.param_gamma": "γ_Rd = {nod} la ierarhia nodului, {forf} la forfecarea lui, {taie} la tăietoarea capabilă și {anc} la ancorarea prin nod — toate din normativ, după clasa {clasa}.",
  "struct.ars.avertismente": "Avertismente",
  "struct.ars.vederea_cotata": "Vederea cotată — {ce}",
  "struct.ars.a_nivelului": "a nivelului {id}",
  "struct.ars.carcasa_legenda": "beton = gri transparent; barele longitudinale = roșu (dispunerea pe perimetru — exact cea folosită de motorul de fibre); etrierii = linii albastre, îndesiți în zonele plastice l_cr la baza și vârful fiecărui nivel; la fiecare nod se schițează grinzile care intră EFECTIV în el, pe partea lor (un stâlp de margine are două-trei brațe, nu patru) — verde = toate verificările de nod trec, roșu = cel puțin una pică. Pe rulările de dinainte de nodul rămâne fără schiță: rezultatul lor nu spune pe ce parte a nodului intră fiecare grindă.{fundatie} Rotește cu mouse-ul, zoom cu scroll.",
  "struct.ars.carcasa_de_armare": "Carcasa de armare {ce}:",
  "struct.ars.ceapa_legenda": "«Ceapa» P–M–M a secțiunii {b}×{h} cu {n}Ø{phi} (suprafața verde translucidă; axa verticală = N, planul orizontal = M2/M3) și punctele (N, M2, M3) din TOATE combinațiile la bază și vârf (roșu = în afara suprafeței). Rotește cu mouse-ul.",
  "struct.ars.armarea_aleasa_sectiune": "Armarea aleasă — secțiunea transversală ({id})",
  "struct.ars.longitudinal": "Longitudinal",
  "struct.ars.val_longitudinal": "{n}Ø{phi} (p = {p}%)",
  "struct.ars.petrecerea_barelor": "Petrecerea barelor",
  "struct.ars.val_petrecere": "l₀ {l0} m la {z} m{etrieri}{ks}",
  "struct.ars.val_petrecere_etrieri": " · etrieri Ø{phi}/{pas} cm",
  "struct.ars.val_petrecere_ks": " · k_s 1,25",
  "struct.ars.acoperirea": "Acoperirea",
  "struct.ars.inaltimea_de_nivel": "Înălțimea de nivel",
  "struct.ars.inaltimea_a_stalpului": "Înălțimea",
  "struct.ars.banda_planseului": "Banda planșeului la nod",
  "struct.ars.grosimea_sectiunii": "Grosimea secțiunii",
  "struct.ars.inaltimea_flexibila": "Înălțimea flexibilă din FEM",
  "struct.ars.nota_l0": "{nota} — se așază PESTE zona critică l_cr, fiindcă în ea înnădirea nu e permisă (P100-1 §5.6.3).",
  "struct.ars.val_m": "{v} m",
  "struct.ars.val_bh_cm": "{b}×{h} cm",
  "struct.ars.verificarile_nivelului": "Verificările nivelului {id}",
  "struct.ars.rezumat_nivel": "Secțiunea {b}×{h} cm, H = {H} m, armare {n}Ø{phi} (p = {p}%), etrieri Ø{et}/{pas} cm în zonele plastice (l_cr = {lcrj} m la bază și {lcrs} m sub nod — P100-1 §5.3.4.2.1(5), relațiile (5.22) și (5.23)) și /{pascur} cm în rest. Momente capabile pe axe la N seismic maxim: {mh} / {mb} kNm.",
  "struct.ars.cele_8_familii": "— cele 8 familii de verificări ale unui stâlp, pe înțelesul unui începător",
  "struct.ars.fiecare_rand_compara": "Fiecare rând compară <b>R</b> (ce POATE stâlpul) cu <b>E</b> (ce i se CERE). Raportul R/E ≥ 1 înseamnă că trece. Primele două verificări privesc rezistența secțiunii, următoarele două protecția împotriva ruperii casante, apoi nodul, apoi detalierea.",
  "struct.ars.ceapa_nu_e_simetrica": "Ceapa NU e simetrică față de N = 0, și nici nu ar putea fi: betonul nu duce întindere, așa că spre jos capacitatea axială e doar cea a oțelului (N = {jos} kN = A_s·f_yd), iar spre sus e beton + oțel (N = {sus} kN). În desen, planul N = 0 e marcat cu conturul albastru închis, iar cea mai largă secțiune a cepei e deasupra lui — la compresiunea «balansată».",
  "struct.ars.nud_explicatie": "<b>2. ν_d ≤ {lim}</b> — ν_d = N/(A_c·f_cd) este compresiunea normalizată: cât de mult din capacitatea la compresiune pură a betonului e deja consumată. Un stâlp foarte comprimat se rupe casant, prin zdrobirea betonului, fără să se poată deforma. De aceea codul pune un plafon. (Denumirea informală «cazul Venezuela» vine de la colapsurile din 1967, unde stâlpii supra-comprimați au cedat exploziv.)",
  "struct.ars.taietoarea_capabil_titlu": "3. Tăietoarea din calcul capabil, pe fiecare direcție",
  "struct.ars.ierarhia_nodului_titlu": "4. Ierarhia nodului (ΣM_Rc ≥ γ_Rd·max(Ω; 1)·ΣM_Eb)",
  "struct.ars.ierarhia_explicatie_a": "— principiul «grindă slabă, stâlp tare». Într-o clădire, dacă cedează grinzile, ai avarii locale reparabile; dacă cedează stâlpii unui nivel, tot ce e deasupra coboară — colaps. Deci stâlpii dintr-un nod trebuie să fie mai tari decât grinzile, cu o rezervă γ_Rd.",
  "struct.ars.ierarhia_explicatie_b": "este ΣM_Eb (suma momentelor grinzilor din ANALIZĂ), înmulțit cu coeficientul de amplificare venit de la grinzi Ω = ΣM_Rb/ΣM_Eb — cât de mult depășește armarea lor reală cerința analizei. Regula structuristului: dacă Ω iese <b>subunitar</b> (grinzile pot fi acceptate la Pasul 13 cu o marjă de subdimensionare de ~5 %), se merge mai departe cu <b>Ω = 1</b> — capacitatea lipsă a grinzii nu are voie să reducă artificial efortul din aval — dar valoarea reală a lui Ω se afișează în tabel (coloanele coef_amplificare / coef_folosit). Echivalent: cerința = γ_Rd·max(ΣM_Rb; ΣM_Eb). Excepție: la ultimul nivel ierarhia nu se cere, pentru că nu mai există nimic deasupra care să cadă.",
  "struct.ars.vezi_sectiunea_noduri": "— vezi secțiunea «Nodurile stack-ului» mai jos.",
  "struct.ars.vezi_explicatia_sub_tabel": "— vezi explicația detaliată sub tabel.",
  "struct.ars.interax_explicatie": "— fiecare bară longitudinală trebuie prinsă de un colț de etrier sau de o agrafă. O bară neprinsă, comprimată, flambează spre exterior la prima incursiune plastică și aruncă stratul de acoperire. Consecință practică: la stâlpii alungiți numărul de bare NU e dat de procentul de armare, ci de această regulă geometrică. Aici: {nb} bare pe latura de {b} cm × {nh} pe cea de {h} cm = {n} bare efectiv{procent}, interax maxim {interax} cm.",
  "struct.ars.punct_vulnerabil": "Punctul vulnerabil: {loc}, combinația {combo} — N = {N} kN, M2 = {M2} kNm, M3 = {M3} kNm → R/E = {re}. Comparativ, indicele biaxial al foii P (α = {alpha}, interpolat pe νd): {indice}.",
  "struct.ars.th_verificarea_hover": "Verificarea (treci cu mouse-ul peste titlu)",
  "struct.ars.th_verdict": "Verdict",
  "struct.ars.omega_subunitar": "Ω = ΣM_Rb/ΣM_Eb = {om} e subunitar (grinzile din nod au fost acceptate cu marjă de subdimensionare la Pasul 13). Efortul pe nod NU se reduce: s-a mers mai departe cu Ω = 1, adică cerința = γ_Rd·ΣM_Eb — valoarea reală a lui Ω rămâne afișată.",
  "struct.ars.taietoarea_titlu": "Tăietoarea stâlpului — de ce nu se ia din analiză",
  "struct.ars.taietoarea_rezumat": "Tăietoarea de proiectare nu vine din analiză, ci din momentele CAPABILE ale capetelor (calcul capabil): V_Ed = γ_Rd·(M_Rc,jos·k_jos + M_Rc,sus·k_sus)/H_liber.",
  "struct.ars.stalp_care_cedeaza_a": "se articulează: se rotește, fisurează, avertizează, disipează energie. Un stâlp care cedează la",
  "struct.ars.stalp_care_cedeaza_b": "se rupe oblic, dintr-o dată, și își pierde instantaneu și capacitatea de a duce greutatea de deasupra. Prima cedare e reparabilă, a doua înseamnă colaps. Regula de proiectare care ne ferește de a doua se numește <b>calcul capabil</b> (capacity design).",
  "struct.ars.un_stalp_care_cedeaza": "Un stâlp care cedează la",
  "struct.ars.plafonul_k_explicatie": ", și e partea care se uită cel mai des. Un stâlp nu poate dezvolta mai mult moment decât îi transmite nodul, iar nodul nu poate transmite mai mult decât îi dau grinzile. Dacă stâlpul e mult mai tare decât grinzile (exact ce urmărim la punctul 4!), articulațiile plastice se vor forma în GRINZI, stâlpul rămâne elastic, iar tăietoarea lui reală e limitată de capacitatea grinzilor — nu de a lui. Fără acest plafon, orice lungire de stâlp i-ar crește artificial tăietoarea de calcul și s-ar intra într-un cerc vicios: lungești stâlpul ca să treacă ancorarea → îi crește M_Rc → îi crește V_Ed → pică la tăietoare → îngroși etrierii la nesfârșit.",
  "struct.ars.mrc_compresiune": "Sub punctul de balans, compresiunea crește momentul capabil; dacă am lua compresiunea minimă am subestima momentul, deci și tăietoarea, iar stâlpul ar putea ceda casant. (La verificarea 4 — ierarhia nodului — e exact invers: acolo un moment capabil MIC e defavorabil, deci se ia compresiunea minimă. Aceeași mărime, două cazuri defavorabile opuse.)",
  "struct.ars.doua_directii_explicatie": "Un stâlp alungit 35×105 este două elemente diferite: pe direcția lungă e foarte tare la încovoiere (deci dezvoltă o tăietoare mare) dar are și secțiune generoasă s-o preia; pe direcția scurtă e slab la încovoiere (tăietoare mică) dar și subțire. Secțiunea de forfecare are lățimea laturii PERPENDICULARE pe direcția de acțiune și înălțimea utilă pe latura PARALELĂ. Brațele de etrier care taie fisura oblică sunt cele paralele cu direcția — câte una în dreptul fiecărei linii de bare de pe latura perpendiculară, adică inclusiv agrafele intermediare (aici între {min} și {max} brațe, după direcție).",
  "struct.ars.ved_max_explicatie": "V_Ed = max(V_cap; V_analiză) — calculul capabil e de obicei mult mai mare, dar dacă analiza dă o valoare și mai mare (stâlp scurt, efect de «coloană captivă»), aceea guvernează. H_liber = {h} m este înălțimea FLEXIBILĂ a stâlpului, adică între fețele grinzilor, nu între axele planșeelor — un stâlp e cu atât mai încărcat la tăietoare cu cât e mai scurt.",
  "struct.ars.confinarea_titlu": "Confinarea miezului — de ce sunt etrierii atât de deși",
  "struct.ars.confinarea_rezumat": "Etrierii împiedică miezul de beton să se umfle lateral; betonul confinat suportă deformații de câteva ori mai mari, iar stâlpul devine ductil.",
  "struct.ars.betonul_comprimat_a": "Betonul comprimat se scurtează pe direcția forței și se",
  "struct.ars.betonul_comprimat_b": "(efectul Poisson). Când umflarea depășește ce poate suporta, betonul crapă longitudinal și se sfărâmă. Dacă însă îl ții strâns într-o «cutie» de etrieri, nu se mai poate umfla — și atunci suportă un efort mai mare și, mult mai important, o",
  "struct.ars.betonul_comprimat_c": "înainte să cedeze. Asta e confinarea, și e singurul motiv pentru care un stâlp de beton poate avea comportare ductilă la cutremur.",
  "struct.ars.miezul_confinat_explicatie": "Acoperirea din exteriorul etrierilor se desprinde la primele incursiuni plastice — nu te poți baza pe ea. Ce rămâne este <b>miezul confinat</b>, măsurat între axele etrierilor perimetrali: aici b₀ × h₀ = {b0} × {h0} cm, față de secțiunea brută {b} × {h} cm.",
  "struct.ars.cantitatea_confinare": "Cantitatea de confinare se măsoară cu <b>ω_wd = (volumul etrierilor / volumul miezului) · f_ywd/f_cd</b> — cât oțel de confinare ai, raportat la betonul pe care îl ții. Codul cere un minim absolut (0,08 la DCM, 0,12 la DCH), indiferent de solicitare.",
  "struct.ars.peste_minim_vine": "Peste acest minim vine cerința legată de <b>ductilitatea pe care ai cerut-o structurii</b>:",
  "struct.ars.muphi_explicatie": "<b>μ_φ</b> este cerința de ductilitate de curbură. Ea vine direct din factorul de comportare q: dacă ai împărțit forțele seismice la q, structura trebuie să poată prelua diferența deformându-se plastic. μ_φ = 2q − 1 la clădirile flexibile (T₁ ≥ T_C), și μ_φ = 1 + 2(q − 1)·T_C/T₁ la cele rigide (T₁ < T_C), unde regula deplasării egale nu mai e valabilă și cerința CREȘTE mult.",
  "struct.ars.muphi_consecinta": "o clădire rigidă proiectată cu un q mare plătește scump la confinare — dacă verificarea asta pică pe multe elemente, soluția corectă nu e mai multă armătură transversală, ci un q mai mic (forțe seismice mai mari, dar cerință de ductilitate mult mai mică).",
  "struct.ars.pasul_etrierilor_explicatie": "rezultă din trei condiții simultane, se ia cea mai mică: s ≤ b₀/2 (ca bolta de beton dintre etrieri să nu lase miezul nesprijinit), s ≤ 175 mm (plafon absolut) și",
  "struct.ars.pasul_etrierilor_flambaj": "— termenul de FLAMBAJ: bara longitudinală comprimată se comportă ca o bară dublu articulată între doi etrieri, iar peste 8 diametre flambează înainte să-și atingă rezistența. La DCH valorile sunt mai severe: b₀/3, 125 mm, 6·Ø. La bare Ø14–Ø20 ultimul termen guvernează aproape întotdeauna — de aceea pasul iese aici {pas} cm, nu 17,5.",
  "struct.ars.miezul_confinat_b0h0": "Miezul confinat b₀ × h₀",
  "struct.ars.val_cm_x_cm": "{a} × {b} cm",
  "struct.ars.stalpul_eticheta": "Stâlpul",
  "struct.ars.optiune_stalp": "{el} — {verdict}",
  "struct.ars.etrieri": "Etrieri",
  "struct.ars.val_etrieri": "Ø{phi} / {pas} cm în zona critică · {min}–{max} brațe",
  "struct.ars.rho_omega": "ρ_s (raport volumetric) / ω_wd (mecanic)",
  "struct.ars.confinarea_model_titlu": "Confinarea — ce model s-a folosit",
  "struct.ars.confinarea_model_text": "{model}: din etrierii aleși (ρ_w = {rho}, presiunea efectivă f_l = {fl} MPa) rezultă betonul confinat al miezului cu f_cc = {fcc} MPa și deformația ultimă ε_cu,c = {eps} (față de 0,0035 neconfinat). {nota}.",
  "struct.ars.cautarea_armarii": "Armarea longitudinală a stack-ului se caută iterativ, pe toate nivelurile odată: se pornește de la cel mai mic candidat care satisface simultan procentul minim al clasei de ductilitate ȘI numărul minim de bare impus geometric, apoi se corectează prima problemă găsită — un punct (N, M2, M3) în afara suprafeței P–M–M sau un nod la care ierarhia «grindă slabă – stâlp tare» nu se respectă. La problemele de nod armarea se propagă și la nivelul de deasupra. Bucla se oprește când nu mai găsește probleme sau la procentul maxim de 4 % — caz în care secțiunea de beton trebuie mărită, nu armătura. Etrierii se dimensionează separat, la final, per nivel: Ø urcă 8 → 10 → 12 până trec și tăietoarea (pe ambele direcții) și confinarea minimă a miezului.",
  "struct.ars.aici_a_luat": " Aici a luat {n}.",
  "struct.ars.jurnalul_nu_se_pastreaza": "Jurnalul pas-cu-pas nu se mai păstrează — singurul istoric ținut e cel al Pasului 19, «ce s-a modificat în structură».",
  "struct.ars.coaja_titlu": "«Coaja» pe înălțime — capacitate vs efort per nivel",
  "struct.ars.coaja_legenda": "verde = capacitatea (min. pe axe); roșu = momentul rezultant maxim din combinații — verdele trebuie să «îmbrace» roșul (docx §5.3)",
  "struct.ars.sectiunea_titlu": "Secțiunea {id} — {b}×{h} cm{alungit}",
  "struct.ars.sectiunea_alungita": " (alungită, orientată după plan)",
  "struct.ars.nodurile_titlu": "Nodurile grindă–stâlp — strategia de verificare",
  "struct.ars.nodul_rigid_a": "Nodul trebuie să rămână RIGID — unghiul de 90° dintre grindă și stâlp se păstrează, deformata se produce în afara nodului (docx §5.4). La fiecare nod al stack-ului se verifică trei lucruri: (1)",
  "struct.ars.ierarhia_cuvant": "ierarhia",
  "struct.ars.nodul_rigid_b": "«grindă slabă – stâlp tare» (ΣM_Rc ≥ γ_Rd·max(ΣM_Rb; ΣM_Eb), cu momentele capabile REALE ale grinzilor din Pasul 13, per direcție — efortul pe nod din analiză se înmulțește cu coeficientul de amplificare de la grinzi Ω = ΣM_Rb/ΣM_Eb, dar MINIM 1: un Ω subunitar, posibil când grinzile sunt acceptate cu marjă de subdimensionare, nu reduce cerința; valoarea reală a lui Ω se afișează; exceptată la ultimul nivel — P100-1 §5.2.3.3.2); (2)",
  "struct.ars.nodul_rigid_c": "a nodului vs compresiunea diagonalei (V_jhd = γ_Rd·(A_s1+A_s2)·f_yd − V_c ≤ η·f_cd·b_j·h_jc·√(1−ν_d/η), §5.3.4.3.2); (3)",
  "struct.ars.ancorarea_barelor_grinzii": "ancorarea barelor grinzii",
  "struct.ars.nodul_rigid_d": "prin nod (limita d_bL/h_c, §5.3.4.3.3). Doar ierarhia se poate repara din armarea stâlpului — solverul o face automat (și propagă armarea la nivelul de deasupra); forfecarea și ancorarea depind de geometrie și de grinzi, așa că rămân verdicte cu recomandări pentru bucla externă (stâlp mai lat, bare mai subțiri și mai multe în grinzi, sau clasă DCM).",
  "struct.ars.toate_trei_directii_titlu": "Toate cele trei verificări se fac PE FIECARE DIRECȚIE cu grinzi (X / Y)",
  "struct.ars.toate_trei_directii_text": ", nu o singură dată pe nod: h_c din formule este latura stâlpului PARALELĂ cu barele grinzii, iar caracterul interior/exterior se judecă pe direcție. <i>Interior</i> înseamnă grinzi pe AMBELE PĂRȚI ale nodului pe acea direcție — nu «două grinzi»: două grinzi care pleacă în aceeași parte nu fac un nod interior. La un stâlp alungit 35×105 direcția scurtă vede h_c = 35 cm, nu 105 — de obicei ea guvernează. Coloanele de mai jos listează fiecare direcție separat; când apare o singură direcție, nodul are grinzi doar pe ea.",
  "struct.ars.th_forfecare_diagonala": "Forfecare / diagonala",
  "struct.ars.th_ancorarea_barelor": "Ancorarea barelor grinzii",
  "struct.ars.th_ierarhia": "Ierarhia ΣM_Rc ≥ γ_Rd·max(ΣM_Rb; ΣM_Eb)",
  "struct.ars.exceptat_ultimul_nivel": "exceptat (ultimul nivel — P100-1 §5.2.3.3.2)",
  "struct.ars.fara_grinzi_in_nod": "fără grinzi în nod",
  "struct.ars.noduri_picate_evidentiate": "nodurile picate evidențiate pe planul structurii",
  "struct.ars.noduri_picate_acum": "(acum: colorarea grinzilor din carcasa 3D + tabelul de mai sus).",
  "struct.ars.sistemul_titlu": "Tipul sistemului pe direcții — și de ce se cere (sau nu) ierarhia nodului",
  "struct.ars.nivelul_baza_text": ": la baza SUPRASTRUCTURII (etajul {n}). Cu infrastructura închisă în pereți de beton, acolo e secțiunea de încastrare, deci pereții de subsol nu intră în socoteală.",
  "struct.ars.taietoarea_masurata_titlu": "Tăietoarea, măsurată din analiza spectrală",
  "struct.ars.taietoarea_masurata_text": "(Pasul 9): pentru fiecare mod se însumează forfecările elementelor de la bază — proiectate pe direcție, cu axele locale ale fiecărui element — și abia apoi se combină modurile prin CQC. Ordinea contează: CQC dă numai valori pozitive, deci combinat pe fiecare element și însumat pe urmă ar supraestima tăietoarea.",
  "struct.ars.cqc_nu_e_aditiv": "nu iese exact",
  "struct.ars.diferenta_in_tabel": "; diferența e scrisă în tabel, ca să se vadă cât înseamnă.",
  "struct.ars.pasul9_lipseste_text": ", deci tăietoarea nu s-a putut măsura. Se arată doar fracțiunea de rigiditate Σ b·h³/12, ca orientare — și clasificarea rămâne «cadre», deci ierarhia se cere oricum. Motivul: proxy-ul pe rigiditate SUPRAEVALUEAZĂ pereții (I ∝ l³, iar peretele lucrează ca o consolă pe toată clădirea, nu pe un etaj), iar o clasificare falsă «pereți» ar renunța tăcut la o cerință de siguranță.",
  "struct.ars.th_elemente_perete": "elemente «perete» / total",
  "struct.ars.pereti_predominanti": "pereți predominanți",
  "struct.ars.cadre": "cadre",
  "struct.ars.nu_se_cere_informativ": "nu se cere (se afișează informativ)",
  "struct.ars.se_cere_fiecare_nod": "se cere la fiecare nod",
  "struct.ars.elementele_ca_pereti": "Elementele numărate ca pereți: {lista}",
  "struct.ars.sursa_fractiunii": "Sursa fracțiunii: {sursa}",
  "struct.ars.restul": "restul",
  "struct.ars.ce_urmeaza_noduri": "Ce urmează la noduri (planificat)",
  "struct.ars.clasifica_sistemul": "P100-1 §5.2.1 și SR EN 1998-1 §5.1.2 + §5.2.2.1 clasifică sistemul",
  "struct.ars.dupa_cat_din": ", după cât din",
  "struct.ars.preiau_peretii": "preiau pereții. Peste prag = «pereți predominanți», iar acolo ierarhia nodului (ΣM_Rc ≥ γ_Rd·ΣM_Eb, P100-1 §5.3.3.3(2), EC8 §4.4.2.3(4))",
  "struct.ars.regula_cadrelor": ": ea e regula cadrelor. Sub prag = «cadre» și ierarhia se cere la fiecare nod.",
  "struct.ars.ambele_cqc": ", amândouă combinate CQC. Fiindcă CQC nu e aditiv,",
  "struct.ars.incercari#n": "1 încercare|{n} încercări|{n} de încercări",
  "struct.dr.perioada_control_a": "perioada de control a spectrului, din <b>zonarea P100-1/2013</b> (fig. 3.2) pentru localitatea proiectului. Nu se citește din studiul geotehnic: e o valoare de hartă, iar transcrierea din studiu poate greși — divergența, dacă există, e scrisă în Pasul 1.",
  "struct.dr.directia_nivelul": "direcția {dir}, nivelul {niv}",
  "struct.dr.punctul_cazul": "punctul «{punct}», cazul {caz}",
  "struct.dr.directia_val": "direcția {dir}:",
  "struct.dr.deficit_pct": " (−{v} %)",
  "struct.dr.nivelul_n": "nivelul {n}",
  "struct.dr.virgula_punctul": ", punctul «{punct}»",
  "struct.dr.virgula_cazul": ", cazul {caz}",
  "struct.dr.pica_amandoua": "pică {lista} — se rigidizează amândouă (valoarea de sus e maximul, pe {dir})",
  "struct.dr.rigiditatea_titlu": "Rigiditatea de calcul a deplasărilor: modelul «drift» (M2), 0,5 uniform",
  "struct.dr.rigiditatea_text": "Deplasările de aici — d_re, factorul <code>c</code>, θ și α — vin dintr-o analiză spectrală <b>proprie</b>, pe un model cu 0,50·E_c pe toată suprastructura, placa inclusiv, indiferent de grosimea ei (litera tabelului E.1 și a §E.1(2)); infrastructura rămâne la E_c întreg. Sub cutremur betonul fisurează și structura se deplasează mai mult; aceeași înmuiere ar lungi perioada și ar micșora forțele — de asta eforturile suprastructurii se iau de pe alt model («eforturi», M3), iar reacțiunile de pe beton întreg («fundație», M1).",
  "struct.dr.ancora_normativa": " Ancora normativă: <b>{articol}</b>.",
  "struct.dr.cifra_raspunde": ". Cifra asta răspunde la «de ce nu mai trece driftul»: spune cât din depășire vine din trecerea pe modelul înmuiat și cât era acolo dinainte.",
  "struct.dr.perioada_fundamentala": "Perioada fundamentală pe modelul de drift e mai lungă (X: {x} s, Y: {y} s) decât pe beton întreg — și <b>ea</b> intră în <code>c</code>: factorul care amplifică deplasările se calculează pe T₁ al aceluiași model din care vine d_re, ca formula să nu amestece două modele. Unde plafonul √(T_C·q)/1,7 guvernează, alegerea nu schimbă nicio cifră.",
  "struct.dr.sectiunea_incastrare": "Secțiunea de încastrare — nivelul {n}",
  "struct.dr.baza_drift_titlu": "Baza modelului de drift",
  "struct.dr.baza_incastrata": "d_re e măsurat pe modelul cu baza ÎNCASTRATĂ",
  "struct.dr.baza_elastica": "d_re e măsurat pe modelul rezemat pe teren elastic",
  "struct.dr.baza_mod_auto": "decizie automată",
  "struct.dr.baza_mod_fortat": "forțat din preferințe (drift_pe_baza = {mod})",
  "struct.dr.cota_m": " (cota {v} m)",
  "struct.dr.incastrare_text": "{motiv}. Driftul se verifică numai <b>peste</b> secțiunea asta: sub ea e infrastructură, iar deplasarea ei nu strâmbă pereți de compartimentare. Încastrarea la planșeul peste subsol nu e o alegere, e o <i>consecință</i> a condițiilor de mai jos — {articol}.",
  "struct.dr.raport_rigiditate": "Raport de rigiditate <b>măsurat</b> pe drift (suprateran maxim / ultimul subteran): <b>{v}×</b>",
  "struct.dr.pe_modelul_elastic": " — pe modelul elastic, deci CU flexibilitatea fundației inclusă",
  "struct.dr.th_valoare": "Valoare",
  "struct.dr.th_sursa": "Sursa",
  "struct.rzv.grinzile_stalpii_suprast": "Grinzile și stâlpii suprastructurii au ambele capete legate de structură. Fundația nu: ea stă pe pământ, care se comprimă sub ea. Modelul clasic pentru asta se numește <b>Winkler</b> — terenul se înlocuiește cu un covor de arcuri independente, fiecare respectând p = K_s·z: cu cât apeși mai tare, cu atât coboară mai mult, proporțional. K_s (coeficientul de pat) e «tăria» unui arc și vine din tasarea calculată în Pasul 6.",
  "struct.rzv.ax_primeste_b": "Fiecare ax primește <b>trei citiri ale aceleiași presiuni</b>, ca să se vadă cât de mult depinde rezultatul de ipoteza de calcul: formula de talpă rigidă a foii de calcul, formula normativă cu talpă care se poate desprinde, și presiunea citită direct din resoartele modelului. Când cele trei sunt apropiate, rezultatul e robust; când diferă mult, ipoteza contează și merită privită.",
  "struct.rzv.arcurile_b_liniare": "Arcurile sunt <b>liniare</b>, nu «fără întindere». E o alegere deliberată: dacă ar fi neliniare, combinațiile din Pasul 11 (care se obțin prin suprapunere de efecte, R = C·F) n-ar mai fi exacte. Cât din pat ar ieși din lucru într-un model fără întindere se citește oricum gratis, din semnul reacțiunilor: un arc cu reacțiune negativă a fost tras, deci în realitate s-ar fi desprins.",
  "struct.rzv.panglica_fundatie_verifi": "Panglica de fundație nu se verifică pe bucăți de câte un metru, ci pe <b>axe</b>: tot ce stă pe aceeași dreaptă în plan formează un ax, chiar dacă e întrerupt de goluri. Așa lucrează și proiectantul cu creionul — o foaie de calcul per ax (AxA, AxB, … Ax1, Ax2), în care adună reacțiunile tuturor stâlpilor de pe linia aceea și verifică fâșia de talpă de sub ei.",
  "struct.rzv.b_pasul_resoartelor": "<b>pasul resoartelor</b> nu e ales arbitrar: se plafonează la π/4 din lungimea elastică λ⁻¹ = (4EI/(K_s·B))^¼, distanța pe care se «stinge» efectul unei forțe concentrate (NP 112 anexa K.3.2). Sub ea, covorul discret de arcuri se comportă ca unul continuu.",
  "struct.rzv.b_pasul_17": "<b>Pasul 17</b> — abia acum fundația se verifică pe reacțiunile ei adevărate, ax cu ax și combinație cu combinație: presiuni, desprindere, tasare, străpungere. Dacă ceva pică, bucla locală caută o geometrie care trece, alegând de fiecare dată acțiunea cea mai ieftină în euro.",
  "struct.ret.otel_cofraj_accesorii": "oțel, cofraj, accesorii — 0 în zona de referință, e deja în preț",
  "struct.ret.1_00_bucuresti": "1,00 București–Ilfov · 0,92 oraș mare · 0,85 urban mic/rural",
  "struct.ret.include_utilajele_punere": "include utilajele de punere în operă, ca în referință",
  "struct.ret.franco_santier_zona": "franco șantier în zona de referință",
  "struct.ret.sub_el_plateste": "sub el se plătește cifa incompletă",
  "struct.ret.raza_transport_inclus": "Rază cu transport inclus în preț",
  "struct.ret.distanta_statia_betoane": "Distanța la stația de betoane",
  "struct.ret.distanta_groapa_autoriza": "Distanța la groapa autorizată",
  "struct.ret.indice_manopera_zonei": "Indice de manoperă al zonei",
  "struct.ret.taxa_depozitare_pamant": "Taxă depozitare pământ",
  "struct.ret.tarif_cifa_peste": "Tarif cifă peste rază",
  "struct.ret.taxa_cifa_incompleta": "Taxă cifă incompletă",
  "struct.ret.fasonare_per_bucata": "Fasonare per bucată",
  "struct.ret.prag_turnare_mica": "Prag turnare mică",
  "struct.ret.tarif_basculanta": "Tarif basculantă",

  "struct.reg.fara_limita": "fără limită",
  "struct.reg.forta_pui_numarator": "ce forță pui la numărător",
  "struct.reg.doua_parghii_ordinea": "Două pârghii, în ordinea eficienței:",
  "struct.reg.redu_suprafata_aferenta": "Redu suprafața aferentă",
  "struct.reg.creste_clasa_betonului": "Crește clasa betonului",
  "struct.reg.lungirea_sectiunii_ajuta": "Lungirea secțiunii nu ajută aici.",



  // --- ecranele structurii: textele care erau scrise direct în cod ---
  "struct.arf.ancorare_innadire": "ancorare {a} m · înnădire {i} m",
  "struct.arf.aria_sectiune": "Secțiunea armată a grinzii de fundare pe {ax}",
  "struct.arf.atinge_capatul": "· atinge capătul axului",
  "struct.arf.axe_armate": "<b>{n}</b> axe de fundare armate ·",
  "struct.arf.axele_de_fundare": "Axele de fundare",
  "struct.arf.cauza_incastrata": "Cauza obișnuită e o bază ÎNCASTRATĂ: fără coeficient de pat, Pasul 7 nu construiește patul de resoarte, deci nu există grinzi de fundare de armat. Verdictul acela e la",
  "struct.arf.clasa_expunere": "Clasa de expunere a fundației: {clasa}",
  "struct.arf.constructivi": "· constructivi",
  "struct.arf.constructivi_vrdc": "· constructivi (V_Ed ≤ V_Rd,c)",
  "struct.arf.cota_axului": "Cota de fundare e a AXULUI ăstuia, nu a clădirii: iese din deschiderea LUI (H ≥ L₀/6, iar la detaliul «T» secțiunea umple șanțul).",
  "struct.arf.detaliere_aici": "{regula}. Aici: a_l = {al} m (cotθ = {cot}), zona de reazem a etrierilor {z} m de-o parte și de alta a fiecărui stâlp.",
  "struct.arf.eforturile_din": ", eforturile din",
  "struct.arf.etrier_montaj": "etrier de montaj, pachetul de {fata}",
  "struct.arf.etrieri_ramuri": "Ø{phi}/{pas} mm · {ramuri} ramuri",
  "struct.arf.expunere_de_ce": "{motiv}. Fundația NU e în clasa de expunere a suprastructurii: betonul stă direct pe pământ, iar sub nivelul apei subterane e umed permanent. Peste acoperirea de durabilitate, SR EN 1992-1-1 §4.4.1.3(4) cere minim 40 mm la turnarea pe beton de egalizare și 75 mm la turnarea direct pe teren nepregătit.",
  "struct.arf.fara_rezultate": "Pasul nu a produs rezultate.",
  "struct.arf.fetele_inimii": "pe fețele inimii înalte (NP 112 §II.7.5.2)",
  "struct.arf.fisura_wk": "w_k = {wk} mm · σ_s = {sigma} MPa · fața {fata}",
  "struct.arf.geometria_vine_din": "Geometria vine din",
  "struct.arf.grinda_fundare_ax": "Grinda de fundare · {ax}",
  "struct.arf.iar_cauza_lui_la": ", iar cauza lui la",
  "struct.arf.infasuratoarea_lungime": "Înfășurătoarea pe lungime și armătura care o îmbracă",
  "struct.arf.laterale_la": "{n}Ø{phi} la {pas} mm",
  "struct.arf.longitudinale_jos": "longitudinale jos",
  "struct.arf.longitudinale_sus": "longitudinale sus",
  "struct.arf.m_cvasipermanenta": "M la gruparea cvasipermanentă",
  "struct.arf.montaj_leaga": "leagă {bare} bare ({pe_rand} pe rând × {straturi} straturi la {interax} cm) într-un pachet · desfășurata {desf} m · nu intră în rezistență: ține poziția carcasei, iar centrul lui e punctul între care se măsoară brațul de pârghie",
  "struct.arf.nerulat": "Pasul nu a fost rulat încă. Are nevoie de eforturile Pasului 12 și de geometria adoptată de Pasul 17.",
  "struct.arf.otel_pe_beton": "· {otel} kg oțel pe {beton} m³ beton ({kgm3} kg/m³)",
  "struct.arf.prelungire_fiecare_parte": "{al} + {lbd} = {p} m de fiecare parte",
  "struct.arf.randuri": "· {n} rânduri",
  "struct.arf.rho_pas_maxim": "ρ_w = {rho} % · pas maxim {pas} mm",
  "struct.arf.rulat": "rulat {data}",
  "struct.arf.sectiune_acoperire": ". Acoperire {c} mm, d = {d} m.",
  "struct.arf.sectiune_cap": "Secțiunea axului <b>{ax}</b> la cota −{df} m: jos {jn}Ø{jphi}, sus {sn}Ø{sphi}, etrieri Ø{ephi}/{epas} mm ({ramuri} ramuri)",
  "struct.arf.sectiune_plasa": "· plasa tălpii Ø{phi}/{pas} mm",
  "struct.arf.supl": "+ {n} supl.",
  "struct.arf.th_as_cerut_acolo": "A_s cerut acolo",
  "struct.arf.th_as_efectiv": "A_s efectiv",
  "struct.arf.th_as_necesar": "A_s necesar",
  "struct.arf.th_asw_efectiv": "A_sw/s efectiv",
  "struct.arf.th_asw_necesar": "A_sw/s necesar",
  "struct.arf.th_bara": "Bara",
  "struct.arf.th_cota": "Cota",
  "struct.arf.th_e_cerut": "E (cerut)",
  "struct.arf.th_lungimea_barei": "Lungimea barei",
  "struct.arf.th_prelungirea": "Prelungirea (a_l + l_bd)",
  "struct.arf.th_r_capabil": "R (capabil)",
  "struct.arf.tin_transversalele": "țin transversalele la pas, pe lungimea tălpii",
  "struct.arf.zone": "· {n} zone",
  "struct.arg.ce_face_pasul": "Ce face pasul",
  "struct.arg.foaia_b": "foaia B",
  "struct.arg.foaia_b_ref": "foaia B: {ref}",
  "struct.arg.grinzi_armate": "Grinzi armate",
  "struct.arg.lbl_grinda": "Grinda",
  "struct.arg.simbol_marja": "marjă",
  "struct.arg.strivirea_diagonalelor": "strivirea diagonalelor (EC2)",
  "struct.arg.svg_etr": "etr. Ø{phi}",
  "struct.arg.svg_h_include_placa": "h include placa",
  "struct.arg.svg_jos": "jos: {arm}",
  "struct.arg.svg_sus": "sus: {arm}",
  "struct.arg.th_limita": "Limita",
  "struct.arg.th_pas_etrieri": "pas etrieri",
  "struct.arg.zona_critica": "zona critica",
  "struct.arg.zona_curenta": "zona curenta",
  "struct.arg.zona_fundamentala": "fundamentala",
  "struct.arh.acoperire_puncte": "Acoperire puncte",
  "struct.arh.aliniat_peste": "aliniat peste celelalte niveluri cu ({dx}, {dy}) m",
  "struct.arh.arhitectul_a_desenat": "arhitectul a desenat pe acest nivel <b>{st} stâlpi</b>{sst}, <b>{d} diafragme</b>{sd} și <b>{g} grinzi</b>{sg} — citit ca reper, propunerea structurii rămâne a Pasului 4",
  "struct.arh.arie_a": "Arie A",
  "struct.arh.conturul_se_inchide": "conturul pereților se închide singur",
  "struct.arh.conturul_zonei_urmeaza": "Conturul fiecărei zone urmează <b>{pereti}</b>: la o cameră închisă zona este exact spațiul dintre pereți, iar la un spațiu deschis (open-space, pereți vitrați) este un marcaj cu aria din stamp-ul de zonă, orientat pe direcția pereților și decupat în ei. Zonele se văd pe diagrama de mai jos, layerul „Funcțiuni utilă (A/C)”.",
  "struct.arh.cotele_de_nivel_gasite": "Cotele de nivel găsite",
  "struct.arh.deschide_desenul": "Deschide desenul {fisier}",
  "struct.arh.desen_in_centimetri": "desen în centimetri — adus la milimetri (×{f})",
  "struct.arh.desen_in_metri": "desen în metri — adus la milimetri (×{f})",
  "struct.arh.diagrama_per_nivel": "Diagrama per nivel",
  "struct.arh.din_cotele_fatadei": "din cotele fațadei",
  "struct.arh.dreptunghiuri": "Dreptunghiuri",
  "struct.arh.dreptunghiuri_pe_niveluri": "dreptunghiuri pe {n} niveluri",
  "struct.arh.etaj_repetat_nota": "etaj repetat — același plan ca etajul de dedesubt",
  "struct.arh.fatade_incercate": "Fațade încercate, în ordine:",
  "struct.arh.fisiere_fatade": "Fișiere identificate ca fațade:",
  "struct.arh.functiunile_spatiilor": "Funcțiunile spațiilor (categoriile de încărcare utilă)",
  "struct.arh.goluri_nivel": "{n} goluri — {usi} uși, {ferestre} ferestre; lățimi {min}–{max} m",
  "struct.arh.goluri_usi_ferestre": "Goluri (uși + ferestre)",
  "struct.arh.inaltimi_de_etaj": "Înălțimi de etaj",
  "struct.arh.inclusiv_placi_consola": "inclusiv {n} plăci în consolă (balcoane/terase) de {arie} m² — categoria C la utilă",
  "struct.arh.jurnalul_extractiei": "Jurnalul extracției ({n})",
  "struct.arh.latimi": "(lățimi {l})",
  "struct.arh.lay_balcoane": "în vedere / balcoane:",
  "struct.arh.lay_etichete": "etichete:",
  "struct.arh.lay_goluri": "goluri:",
  "struct.arh.lay_pereti": "pereți:",
  "struct.arh.lay_structura_arhitect": "structura arhitectului:",
  "struct.arh.leg_click_perete": "click pe un perete = punctul din stânga + dimensiunile lui (lungime × grosime × înălțimea etajului)",
  "struct.arh.leg_layere_aprinse": "layerele pot fi aprinse/stinse din panoul diagramei",
  "struct.arh.leg_pereti_persistenti": "pereți persistenți cross-nivel (aceeași listă PP pe fiecare nivel)",
  "struct.arh.leg_pereti_simplificati": "pereți simplificați (dreptunghiuri)",
  "struct.arh.leg_placi_consola": "plăci în consolă BC (balcoane, terase — fără pereți pe contur)",
  "struct.arh.locuit_q": "locuit — q = 1,5 kN/mp",
  "struct.arh.m2_in_total": "{arie} m² în total",
  "struct.arh.n_niveluri": "{n} niveluri — ",
  "struct.arh.nicio_fatada": "Nicio fațadă nu a dat cote de nivel utilizabile, deci înălțimile de etaj sunt valoarea de rezervă de {h} m (apare și la Avertismente).",
  "struct.arh.nivelurile": "Nivelurile",
  "struct.arh.pereti_simplificati_card": "Pereți simplificați",
  "struct.arh.separare_ales": "{n} desene de dimensiunea unui plan pe foaie; ales",
  "struct.arh.separare_cel_de": "cel de {a}×{b} m",
  "struct.arh.simbol_conturul_zonei": "conturul zonei",
  "struct.arh.simbol_etaj_repetat": "etaj repetat",
  "struct.arh.simbol_plan_sursa": "Plan-sursă",
  "struct.arh.simbol_unitatea_desenului": "unitatea desenului",
  "struct.arh.sursa_doua_puncte": "Sursă:",
  "struct.arh.terase_balcoane_logii": "Terase, balcoane, logii",
  "struct.arh.titlu_desen": "Analiză arhitectură — {nivel}",
  "struct.arh.usi_ferestre_gazda": "{usi} uși · {ferestre} ferestre · {gazda} cu perete-gazdă",
  "struct.arh.vezi_desenul": "vezi desenul",
  "struct.arh.zone_exterioare": "{n} zone exterioare:",
  "struct.arh.zonele_c": "Zonele C",
  "struct.arp.contur": "contur",
  "struct.arp.efortul_lunecare_vedi": "efortul de lunecare v_Edi = β·V_Ed/(z·b_i)",
  "struct.arp.prin_marja": "prin marja {marja}%",
  "struct.arp.ref_nod_cct": "k₂ = 0,85 (nod CCT), ν′ = 1 − f_ck/250",
  "struct.arp.ref_rost_vedi": "SR EN 1992-1-1 rel. (6.24); punctul guvernant {punct} ({grupa})",
  "struct.arp.ref_rost_vrdi": "rel. (6.25); ρ = A_s/A_i = {rho} % (barele verticale Ø{phi}/{pas}, ambele plase), σ_n = {sigma} MPa",
  "struct.arp.th_agrafe": "agrafe",
  "struct.arpl.arie_din": "{a} m² din {b} m²",
  "struct.arpl.consolele_balcoanele": "Consolele (balcoanele)",
  "struct.arpl.consolele_ochiului": "Consolele ochiului (balcoane)",
  "struct.arpl.continuu_spre": "· continuu → {vecin}",
  "struct.arpl.ipotezele_metodei": "Ipotezele metodei",
  "struct.arpl.laturile": "Laturile:",
  "struct.arpl.liber": "liber",
  "struct.arpl.momentele_de_proiectare": "Momentele de proiectare",
  "struct.arpl.momentele_se_iau_pe": "Momentele se iau pe",
  "struct.arpl.n_picate": "{n} picate",
  "struct.arpl.ochiul": "Ochiul",
  "struct.arpl.plasele_alese": "Plasele alese",
  "struct.arpl.reazem_de_la_vecin": "(reazem: {v} m de la vecin)",
  "struct.arpl.schema_de_reazem": "Schema de reazem",
  "struct.arpl.simplu_rezemat": "simplu rezemat",
  "struct.arpl.th_adus_grinzi": "Adus de grinzi",
  "struct.arpl.th_armare": "Armare",
  "struct.arpl.th_as_minim": "A_s minim",
  "struct.arpl.th_capete_continue": "Capete continue",
  "struct.arpl.th_deschidere": "Deschidere",
  "struct.arpl.th_m_reazem_i": "M reazem i",
  "struct.arpl.th_m_reazem_j": "M reazem j",
  "struct.arpl.th_ochi": "Ochi",
  "struct.arpl.th_salt_axial": "Salt de axial",
  "struct.ars.betonul_confinat_rezultat": "Betonul confinat rezultat",
  "struct.ars.folosit_1": " → folosit 1",
  "struct.ars.k_este_plafon": "<b>k = min(1; ΣM_Rb/ΣM_Rc)</b> este <i>{plafon}</i>{explicatie}",
  "struct.ars.m_pe_latura": "M pe latura {l}",
  "struct.ars.neaditivitate_cqc": "neaditivitate CQC",
  "struct.ars.simbol_beton": "beton",
  "struct.ars.simbol_gamma_nod": "γ_Rd ierarhia nodului",
  "struct.ars.sub_restul": "restul",
  "struct.ars.th_ierarhia_nodului": "ierarhia nodului",
  "struct.ars.th_sistem": "sistem",
  "struct.cob.bare_beam_uniform": "{n} elemente cu <code>-beamUniform</code>, între {min} și {max} kN/ml. Culoarea închisă = kN/ml mai mare. Atenție la detaliu: OpenSees integrează încărcarea distribuită doar pe lungimea FLEXIBILĂ a barei (fără zonele rigide <code>-jntOffset</code>), deci w se scalează cu L_nod/L_flex ca totalul aplicat să fie exact cel fizic — de aici închiderea echilibrului sub 0,1 %.",
  "struct.cob.bare_nimic": "nicio bară nu primește încărcare liniară în acest caz.",
  "struct.cob.barele": "Barele",
  "struct.cob.bile_goale_text": "{t} t de infrastructură: greutatea grinzilor de fundare există în cazul gravitațional G4, în reacțiuni și în deviz, dar NU e masă seismică (EN 1998-1 §4.3.3.2.2(1)P: masa e cea de deasupra fundației). Comută preferința <code>masa_infrastructura_seismica</code> dacă vrei să intre și ele.",
  "struct.cob.bile_pline": "<b>Bilele pline (albastru)</b> — {t} t care intră în <code>ops.mass</code> și deci în analiza modală și în forța seismică.",
  "struct.cob.finisaje_sdl": "finisaje (SDL)",
  "struct.cob.infra_componente": "grinzile de fundare + umplutura + suprasarcina de la CTN",
  "struct.cob.infra_nu_masa": "Infrastructura ({kn} kN) apare în încărcări (cazurile G4 și G2c) și în reacțiuni, dar nu în tabelul de mai sus: nu e masă seismică.",
  "struct.cob.infrastructura": "infrastructura",
  "struct.cob.masele_ops": "Masele (ops.mass)",
  "struct.cob.nivel_n": "nivel {n}",
  "struct.cob.placa": "Placa",
  "struct.cob.placa_beton": "placa de beton",
  "struct.cob.placa_forte_nodale": ". OpenSees nu poate primi „kN/m²” pe un shell: fiecare element primește patru forțe nodale <code>p·A/4</code>, câte una în fiecare colț (<code>ops.load</code>). De asta faţa se colorează, dar forțele stau în noduri.",
  "struct.cob.placa_nimic": "nu primește nimic în acest caz.",
  "struct.cob.presiune_de": "presiune de {lista}",
  "struct.cob.presiune_pe_nivel": "{p} kN/m² pe nivelul {n}",
  "struct.cob.raport": "Raport",
  "struct.cob.se_aplica_grinzi_fundare": "Se aplică pe <b>grinzile de fundare</b> (cota 0), nu pe suprastructură",
  "struct.cob.stalpii_peretii_jumatate": "<b>stâlpii și pereții</b> se împart pe jumătate între planșeul de deasupra și cel de dedesubt (masele de nivel, P100-1), în timp ce ca ÎNCĂRCARE greutatea unui stâlp se duce integral la planșeul pe care îl susține;",
  "struct.cob.ultima_cifra": "Ultima cifră — <b>{kn} kN</b> — e tot ce ajunge la teren, nefactorizat. Ea trebuie să iasă și din suma reacțiunilor verticale (verificarea de echilibru de mai jos), iar împărțită la aria tălpilor dă ordinul de mărime al presiunii de la Pasul 6.",
  "struct.combina.caz_g1": "Greutatea proprie a structurii de beton",
  "struct.combina.caz_g4": "Infrastructura: grinzile de fundare + umplutura de pământ + suprasarcina de la cota terenului",
  "struct.combina.p_articolul_aplicat": "articolul aplicat",
  "struct.combina.p_normativ": "normativ",
  "struct.combina.p_proiectul_curent": "proiectul curent",
  "struct.combina.p_sursa_datelor": "sursa datelor",
  "struct.combina.pe_proiect_mt": "Pe acest proiect: ΣM_t = {v} kNm.",
  "struct.combina.pe_proiect_total": "Pe acest proiect: {eticheta} = {v} kN.",
  "struct.combina.simbol_gg_defav": "γ_G defavorabil",
  "struct.combina.simbol_gg_fav": "γ_G favorabil",
  "struct.combina.simbol_gq_dom": "γ_Q dominant",
  "struct.combina.simbol_gq_nedom": "γ_Q·ψ₀ nedominant",
  "struct.combina.simbol_regula_30": "0,30 (regula celor 30 %)",
  "struct.combina.simbol_semne": "± (semnele)",
  "struct.dgf.criteriul_panta": "criteriul e panta: Δs / L ≤ 0,002 (cadre) sau 0,001 (cu zidărie) — NP 112 tab. H.1",
  "struct.dgf.desprins": "desprins",
  "struct.dgf.fiecare_arc": "fiecare arc: k_v = K_s · B · l_aferentă  →  p = K_s · z",
  "struct.dgf.g_lest": "G (lest)",
  "struct.dgf.grinda_fundare_ei": "grinda de fundare (B × H_c, EI nefisurat)",
  "struct.dgf.h_cutremur": "H (cutremur)",
  "struct.dgf.muchie": "muchie",
  "struct.dgf.nivelul_apei": "nivelul apei",
  "struct.dgf.reactiunea_arc_aria": "reacțiunea unui arc ÷ aria lui = presiunea reală de sub el (coloana „p model”)",
  "struct.dgf.reactiunea_incarca_jos": "reacțiunea terenului — încarcă grinda de jos",
  "struct.dgf.reactiunea_se_scade": "reacțiunea terenului din interiorul conturului se SCADE din N_Ed",
  "struct.dgf.tasare_diferentiala": "diferențială — structura se strâmbă",
  "struct.dgf.tasare_uniforma": "uniformă — clădirea coboară întreagă, fără eforturi",
  "struct.dgf.trapez": "trapez",
  "struct.dgf.v_greutatea": "V (greutatea)",
  "struct.dgf.zona_activa_inchide": "zona activă se închide unde σz < 0,2 · σgz — mai jos, terenul nici nu „simte” casa",
  "struct.dr.amplificare_max": "· accelerația se amplifică de cel mult {v} ori",
  "struct.dr.amplificare_titlu": "Amplificarea răspunsului pe verticală («efectul de bici»)",
  "struct.dr.arie": "arie",
  "struct.dr.articulati#n": "({n} articulat)|({n} articulați)|({n} de articulați)",
  "struct.dr.beton_intreg_text": "<b>Măsurat pe BETON ÎNTREG</b> (E_c, I_g), nu pe modelul E_c,ef din care iese driftul de mai sus. Criteriul e un <b>raport</b>: la o reducere uniformă de rigiditate ar ieși identic pe ambele modele, iar sensibil devine numai din factorii pe familii de elemente (0,80 stâlpi / 0,50 grinzi / grosime la placă), care sunt o convenție de birou, nu o prevedere de cod. Măsurat pe E_c,ef, aceeași clădire ar putea ieși regulată sau neregulată pe verticală după o convenție de birou — iar din clasificarea aia ies metoda de calcul admisă și q. Când verificarea pică, lanțul reduce q cu 20 % (P100-1 §4.4.3.1); explicația reducerii stă la Pasul 7, unde se alege q.",
  "struct.dr.c_propriu": "factor propriu P100-1, absent din Eurocod",
  "struct.dr.ca_mai_sus": "ca mai sus",
  "struct.dr.cerere_text": "Pe fiecare direcție se ia cazul spectral al direcției plus torsiunea accidentală a ei — echivalentul cazurilor <code>ESXP/ESXM</code> din ETABS, cum le filtrează foaia structuristului:",
  "struct.dr.cererea_deplasare": "Cererea de deplasare",
  "struct.dr.coloane_informative": "Celelalte două coloane sunt INFORMATIVE, și fiecare are un motiv să nu fie verdict. <b>K proprie</b> (Σ12EI/h³ pe stâlpi) ignoră grinzile: pe o clădire P+4 cu etaj retras dădea 0,014 acolo unde cadrul dă 0,175 — nivelul retras părea de 12 ori mai moale decât e. <b>K secantă</b> (V/d_re) e a SISTEMULUI văzută la etaj: driftul unui nivel moștenește rotirea nivelurilor de dedesubt, deci raportul scade urcând chiar pe o clădire regulată — pe una regulată dădea 0,69 la parter, adică o neregularitate care nu există.",
  "struct.dr.distorsiune": "distorsiune",
  "struct.dr.drift_total": "— driftul e cel TOTAL al punctului, nu numai distorsiunea pe care o cere litera (E.1)",
  "struct.dr.f_acceleratie": "a_i = F_i/m_i, cu F_i = V_i − V_i+1 forța de inerție a nivelului",
  "struct.dr.f_d_re": "|E_θ| + |T_acc,θ|, combinat CQC per mod",
  "struct.dr.f_distorsiune": "din blocul DRD",
  "struct.dr.f_k_cadru": "K = Σ D_stâlp, cu D = a·12EI_c/h³, k̄ = Σ(I_b/L_b)/(I_c/h) din grinzile de la capetele stâlpului; a = k̄/(2+k̄) la etaj curent, (0,5+k̄)/(2+k̄) la bază încastrată, 0,5·k̄/(1+2·k̄) la bază articulată",
  "struct.dr.f_k_proprie": "Σ12EI_c/h³ pe stâlpii nivelului",
  "struct.dr.f_k_secanta": "K_i = V_i / d_re,i, cu driftul în CENTROID (nu în punctul defavorabil, ca să nu intre rotirea din torsiunea accidentală)",
  "struct.dr.f_masa": "G + ψ₂·Q + ψ₂·S, lumpată la diafragmă",
  "struct.dr.f_punct": "câmpul de corp rigid al planșeului, evaluat în centroid și în cele patru extreme",
  "struct.dr.f_raport_cadru": "raportul celor două rigidități de cadru",
  "struct.dr.f_retragere": "1 − √(A_i/A_i−1), echivalentul liniar al retragerii",
  "struct.dr.f_stalpi": "numărați în model; o pilă intră în K cadru cu a = 0,5·k̄/(1+2·k̄)",
  "struct.dr.fatada_agatata": " · fațadă agățată: +30 % (E.1(5))",
  "struct.dr.in_loc_de_sls": " : {a} % în loc de {b} % la SLS",
  "struct.dr.infrastructura_rand": "infrastructura",
  "struct.dr.intro": "Structura a fost calculată cu forțe seismice împărțite la <code>q</code>, deci în model se deformează de <code>q</code> ori mai puțin decât în realitate. Verificarea de drift readuce deplasările la realitate și le compară cu cât suportă <i>pereții de compartimentare</i> (starea limită de serviciu) și cu marja față de prăbușire (starea limită ultimă). Deplasarea se ia în <b>punctul cel mai defavorabil din plan</b>, nu în centrul de mase: panoul care crapă e cel care se distorsionează cel mai mult (comentariul C E.2 al codului).",
  "struct.dr.k_cadru": "K cadru",
  "struct.dr.k_proprie": "K proprie",
  "struct.dr.la_nume": "la «{nume}»",
  "struct.dr.limita_sls": "limita SLS",
  "struct.dr.limita_uls": "limita ULS",
  "struct.dr.masa": "masa",
  "struct.dr.modul_n": "(modul {n})",
  "struct.dr.muto_text": "<b>Verdictul e pe rigiditatea de CADRU.</b> Rigiditatea laterală a unui nivel nu e suma stâlpilor lui: la capătul fiecărui stâlp nodul se rotește, iar cât se rotește o hotărăsc grinzile. Formula lui Muto scrie exact asta — <i>D = a·12EI_c/h³</i>, cu <i>k̄ = Σ(I_b/L_b)/(I_c/h)</i> raportul dintre rigiditatea grinzilor de la nod și a stâlpului, și <i>a = k̄/(2+k̄)</i> la un etaj curent, <i>(0,5+k̄)/(2+k̄)</i> la baza încastrată, <i>0,5·k̄/(1+2·k̄)</i> la baza ARTICULATĂ (pilele de pod, rezemate pe o grindă). Un stâlp de 30×115 cu grinzi de 30×65 de 6,5 m are în cadru cam 5 % din 12EI/h³ al lui: grinzile plafonează, nu secțiunea stâlpului.",
  "struct.dr.nu_alternativa": "(EC8: 0,4 la clasele III–IV)",
  "struct.dr.nu_se_cere": "nu se cere: {nota}",
  "struct.dr.nu_text": "factorul de reducere pentru SLS — <b>0,5 fix</b>, P100-1 §E.1(2).",
  "struct.dr.pasul_7": "Pasul 7",
  "struct.dr.q_text": "factorul de comportare cu care s-au redus forțele (Pasul 9)",
  "struct.dr.rap": "rap.",
  "struct.dr.raport_minim": "— cel mai mic raport de rigiditate (cadru): {v}",
  "struct.dr.retragere": "retragere",
  "struct.dr.se_transmite_11": "(se transmite Pasului 11)",
  "struct.dr.si": " și ",
  "struct.dr.t1_directie": "perioada fundamentală <b>a fiecărei direcții</b> — modul cu masa efectivă maximă pe ea",
  "struct.dr.t1_litera": ". Litera (E.3) spune „perioada proprie fundamentală de vibrație a <i>clădirii</i>\" (modul 1: {t1} s), dar un T₁ unic se rupe acolo unde direcțiile au rigidități diferite — iar modul 1 poate fi un mod LOCAL, cu masă efectivă neglijabilă.",
  "struct.dr.t1_moduri": "(modul {x} pe X, modul {y} pe Y)",
  "struct.dr.tabelul_e2": "tabelul E.2 — {cns}",
  "struct.dr.termen_neaplicat": "termen NEAPLICAT (metoda biroului)",
  "struct.dr.th_e_calcul": "E de calcul",
  "struct.dr.th_familia": "familia de elemente",
  "struct.dr.th_verificarea": "Verificarea (treci cu mouse-ul peste titlu)",
  "struct.dr.titlu_k_secanta": "V/d_re, informativ",
  "struct.dr.uls_text": "Anexa E.2(2) — cerință proprie P100-1, Eurocodul nu are limită de drift la ULS",
  "struct.dr.v_acceleratie": "informativ — creșterea spre vârf e normală; anormală e discontinuitatea",
  "struct.dr.v_distorsiune": "informativ — vezi divergența ⓔ6",
  "struct.dr.v_k_cadru": "raportul ei față de nivelul de dedesubt ≥ 0,70",
  "struct.dr.v_k_proprie": "informativ — ignoră grinzile, deci exagerează saltul la un nivel cu stâlpi puțini",
  "struct.dr.v_k_secanta": "informativ — moștenește rotirea nivelurilor de dedesubt, deci scade urcând și pe o clădire regulată",
  "struct.dr.v_raport_cadru": "≥ 0,70 (§4.4.3.3(2): reducere de cel mult 30 %)",
  "struct.dr.v_sls": "≤ {v} % (tabelul E.2)",
  "struct.dr.v_theta": "≤ 0,10 (§4.6.2.2)",
  "struct.dr.v_tot_theta": "V_tot pentru θ: {sursa}",
  "struct.dr.v_uls": "≤ {v} % (Anexa E.2)",
  "struct.dwg.cardinal_vest": "V",
  "struct.dwg.contur": "Contur",
  "struct.dwg.culoare": "Culoare",
  "struct.dwg.lungime_ax": "Lungime ax",
  "struct.dwg.niciunul": "Niciunul",
  "struct.dwg.puncte": "Puncte",
  "struct.dwg.tot_desenul": "Tot desenul",
  "struct.dwg.vizibile": "{n}/{total} vizibile",
  "struct.editor.msg_grinda_oblica": "{id}: grindă oblică între {i} și {j}",
  "struct.fem.ce_se_vede": "Ce se vede",
  "struct.fem.coloanele_masa_baze": "Coloanele „masa X/Y/torsiune” sunt raportate la baze diferite, deci nu sumează 100 % pe rând; cumulatele sunt cele pe care se verifică criteriul de 90 %.",
  "struct.fem.decuplare_ok": "primele moduri au perioadele separate cu ≥ {sep}%, iar modurile 1–2 sunt translații cu ≥ {dir}% pe câte o singură direcție — îndeplinit",
  "struct.fem.ebc_nefisurat": "elasticBeamColumn, E NEfisurat",
  "struct.fem.gol_click_ochi_placa": "Click pe un <b>ochi de placă</b> pentru id-ul lui, deschideri, grosime și cum i s-a închis conturul. Cât timp placa e bifată, ea are prioritate la click — debifeaz-o ca să ajungi la grinzile și stâlpii de sub ea.",
  "struct.fem.gol_puncte_mici": "Punctele mici de pe grinzi sunt nodurile de împărțire pentru metoda elementului finit; sfera galbenă e centrul de masă al fiecărui planșeu (acolo e lumpată masa seismică a diafragmei).",
  "struct.fem.gol_sub_cladire": "Sub clădire e <b>fundația</b>: betonul la cotele lui reale — talpa, elevația și porțiunea de stâlp care coboară în ea. Click pe talpă pentru secțiunea axului, cotele lui, patul de resoarte și unde stă bara în modelul de calcul. Umplutura de pământ nu se desenează.",
  "struct.fem.inima_sub_placa": "inimă sub placă",
  "struct.fem.moduri_decuplate_gate": "Moduri decuplate (gate):",
  "struct.fem.nestructural": "nestructural",
  "struct.fem.parapet_titlu": "Parapetul {id}",
  "struct.fem.reper_calibrare": "Reperul de calibrare rămâne varianta ÎNCASTRATĂ: {nota}",
  "struct.fem.simb_beton_e": "beton, E",
  "struct.fem.simb_destinatie": "destinație",
  "struct.fem.simb_geometrie": "geometrie",
  "struct.fem.simb_h_etaje": "h etaje",
  "struct.gpan.se_socotesc": "se socotesc gropile…",
  "struct.imb.cat_incarcari": "încărcări",
  "struct.imb.cat_optimizator": "optimizator",
  "struct.imb.cat_performanta": "performanță",
  "struct.imb.intro": "Lista de lucru de după Pasul 19: ce știm că mai avem de făcut, cu destul context cât să poată fi reluat oricând. Se întreține în <code>ui/src/Imbunatatiri.tsx</code> — un element implementat se șterge de aici.",
  "struct.imb.ks_recalculat_reimpus": "K_s recalculat de Pasul 6, re-impus automat modelului",
  "struct.marime.formula_cu_valori": "Formula, cu valorile proiectului:",
  "struct.modl.acum_xy": "Acum (X × Y) [cm]",
  "struct.modl.afara_modul": "✗ {a} din {n} travee în afara modulului",
  "struct.modl.alunecare_cm": "Alunecare [cm]",
  "struct.modl.buget_nota": "(cei 12 stâlpi cu cea mai mică rezervă, din {n}; grinzile au și ele o lățime maximă în peretele lor, folosită de regula R3 a Pasului 19)",
  "struct.modl.buget_text": "Pentru fiecare stâlp, cât de mult poate crește pe fiecare direcție fără să iasă din pereții persistenți — căutat în pași de 5 cm, cu aceeași probă de încadrare (inclusiv alunecarea centrului) pe care o face aplicarea overlay-ului. Bucla externă (Pasul 19) își plafonează țintele la valorile astea <i>înainte</i> de a cheltui o iterație: fără ele ar afla că o lungire nu încape abia după ce rerulează tot lanțul de analiză. Un stâlp la maxim pe ambele direcții nu mai are pârghie geometrică — acolo soluția trebuie căutată în altceva (armare, secțiunea grinzilor, clasa de ductilitate).",
  "struct.modl.buget_titlu": "Cât loc mai este în pereți (bugetul geometric) — pentru depanare",
  "struct.modl.deschide_pasul": "deschide pasul {k}",
  "struct.modl.diagrama_etaj": "Diagrama per etaj",
  "struct.modl.elemente_schimbate": "Elemente schimbate",
  "struct.modl.etaj": "Etaj",
  "struct.modl.etaj_rezumat": "{s} stâlpi ({a} adăugați de regula celor 6 m) · {g} grinzi · {L} m de grinzi · deschidere maximă {d} m",
  "struct.modl.etaje_modelate": "Etaje modelate",
  "struct.modl.fara_gazda": " (fără grindă-gazdă)",
  "struct.modl.fasii_30_50": "fâșii de 30 cm lățime × 50 cm înălțime, pe axele pereților",
  "struct.modl.grila_dominanta": ", cea mai deasă {m} m ({n} travee)",
  "struct.modl.grila_intermediari": "; propunerea a pus {n} stâlpi intermediari pe modul",
  "struct.modl.grila_text": "O travee e distanța LIBERĂ dintre fețele a doi stâlpi vecini de pe aceeași grindă, numărată o dată pe plan — acolo încap mașinile, nu între axe. Pe modul = un număr întreg de locuri de {modul} m în lumină, cu cel mult {tol} mm pierduți. Deschiderile EGALE sunt același cofraj de grindă refolosit — cadrul are {distincte}",
  "struct.modl.grila_titlu": "Grila pe modulul de parcare ({m} m)",
  "struct.modl.grinzi_noi": "Grinzi noi",
  "struct.modl.grinzi_propuse": "Grinzi propuse",
  "struct.modl.grinzi_scoase": " · {n} grinzi de mijloc scoase (3 paralele sub 6 m)",
  "struct.modl.ierarhie_titlu": "Niveluri diferite — ierarhia surselor de structură (A/B/C)",
  "struct.modl.inaltime_etaj": "înălțime etaj {h} m",
  "struct.modl.inca_valori": "… și încă {n} valori.",
  "struct.modl.istoric_nota": "★ = pasul cu care continuă soluția; peste el se aplică apoi overlay-ul Pasului 19 (tabelul «Modificări din bucla externă»), deci după o promovare geometria de pe ecran e ultimul pas PLUS op-urile lui. „Deschide\" arată starea înghețată a pasului, pe pagina asta (`?bp=`); întoarcerea e linkul din capul ei. Istoricul se reface la fiecare rulare a Pasului 4, deci clonele de acum sunt ale geometriei de acum.",
  "struct.modl.istoric_titlu": "Istoricul de soluționare — cei {n} pași geometrici ai Pasului 4",
  "struct.modl.k_cadru_titlu": "K cadru = {v} kN/mm",
  "struct.modl.leg_arhitectura": "pereții, ferestrele și ușile vin din planul de arhitectură",
  "struct.modl.leg_click": "click pe un element = punctul din stânga + dimensiunile lui (lungime × lățime × înălțime)",
  "struct.modl.leg_grinzi": "grinzi 30 cm lățime",
  "struct.modl.leg_pereti_pers": "pereți persistenți (toate nivelurile)",
  "struct.modl.leg_pereti_simpl": "pereți simplificați (etajul curent)",
  "struct.modl.leg_stalpi": "stâlpi 30×30",
  "struct.modl.leg_stalpi_redim": "stâlpi (30×30 propus + redimensionările Pasului 19)",
  "struct.modl.liberi_text": "Stâlpi LIBERI ({n}): <code>{lista}</code> — coboară până la fundație prin AFARA clădirii de dedesubt (terasă/curte), deci sunt vizibili în arhitectură; validează-i.",
  "struct.modl.modificari_titlu": "Modificări din bucla externă (Pasul 19) — pentru depanare",
  "struct.modl.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga (după Pasul 2).",
  "struct.modl.patrate_30": "pătrate 30×30 cm — dimensiune presupusă inițial, revenim la ea",
  "struct.modl.pe_placa_text": "Stâlpi rezemați PE PLACĂ ({n}): <code>{lista}</code> — pereții lor de etaj nu au sub ei nici stâlp, nici grindă, iar un stâlp nou ar fi ieșit în mijlocul unei camere de la nivelul inferior. Placa îi susține (bazele lor sunt noduri ale plăcii în modelul FEM), dar STRĂPUNGEREA plăcii sub ei nu e încă verificată automat: reacțiunea stâlpului trece prin placă, iar străpungerea ei (EC2 §6.4.6) rămâne de verificat manual pentru stâlpii listați.",
  "struct.modl.pereti_persistenti_rand": "pereții persistenți — stâlpii propuși pe ei se refolosesc identic la fiecare nivel (parterul complet dă și axele de fundație)",
  "struct.modl.primul_nivel": "primul nivel: n-are sub el cu ce se compara",
  "struct.modl.raport_titlu": "K cadru al nivelului / K cadru al nivelului de dedesubt; prag {prag}",
  "struct.modl.rarire_capete": "{n} capete de despărțitor",
  "struct.modl.rarire_fara_stalp": "au rămas fără stâlp — Pasul 19 le readuce acolo unde o direcție e slabă sau o grindă pică.",
  "struct.modl.rarire_iar": ", iar",
  "struct.modl.rarire_text": "Propunerea pe modul: {linii} linii de zid portante și-au pus stâlpii pe multiplii modulului ({noi} intermediari noi, {lipiti} lipiți), scheletul de cadre transversale ține {schelet} despărțitori",
  "struct.modl.refuzate_amplasare": "Refuzate de amplasare",
  "struct.modl.regim_inaltimi": "regim {regim} · înălțimi {h} m — din Pasul 2 (cotele fațadelor)",
  "struct.modl.regula_6m": "Regula celor 6 m",
  "struct.modl.reguli_incalcate#n": "{n} regulă încălcată|{n} reguli încălcate|{n} de reguli încălcate",
  "struct.modl.rig_text": "E aceeași mărime pe care Pasul 10 o verifică — rigiditatea de <b>cadru</b> a nivelului, D = a·12EI_c/h³ cu a din raportul k̄ al grinzilor de la nod față de stâlp —, calculată aici <b>fără FEM</b>, din secțiunile și deschiderile propuse, ca să se vadă înainte de lanț cât lipsește nivelului retras. Bara e proporțională cu K cadru; raportul e față de nivelul de dedesubt și pică sub {prag} (P100-1 §4.4.3.3(2)). K proprie (Σ12EI/h³) e informativă: ignoră grinzile.",
  "struct.modl.rig_titlu": "Rigiditatea laterală pe nivel (efectul de bici, din geometrie)",
  "struct.modl.simbol_axe": "axe",
  "struct.modl.stalpi_lamele_propuse": "Stâlpi și lamele propuse",
  "struct.modl.th_pas": "Pas",
  "struct.modl.toate_pe_modul": "✓ toate cele {n} travee pe modul",
  "struct.modl.vezi_incalcarea": "vezi încălcarea",
  "struct.opt.abordarea_din": "a {n}-a din {total}: ",
  "struct.opt.neschimbat": " (neschimbat)",
  "struct.opt.precizie": " · precizie: {p}",
  "struct.opt.reglaj": "reglaj",
  "struct.opt.th_elementul": "Elementul",
  "struct.opt.vezi_toate_cele": "vezi toate cele {n}",
  "struct.pg.ax_cota#n": "axul {directie} · L = {L} m · 1 deschidere|axul {directie} · L = {L} m · {n} deschideri|axul {directie} · L = {L} m · {n} de deschideri",
  "struct.pg.ax_deschiderea_pagina": "{element} — deschiderea din pagină",
  "struct.pg.bara_consumat": "efortul {e} din capacitatea {r} — {p} % consumat",
  "struct.pg.explicatie": "{m} și M_Rd pe fibra întinsă, la aceeași scară — capacitatea trebuie s-o îmbrace pe cerere. Ilustrează cele 5 puncte de verificare ale grinzii.",
  "struct.pg.explicatie_ax": "{m} și M_Rd pe fibra întinsă, la aceeași scară — capacitatea trebuie s-o îmbrace pe cerere. Ilustrează cele 5 puncte de verificare ale grinzii, pe deschiderea curentă sau pe tot axul.",
  "struct.pg.fara_zona_libera": "fără zonă liberă",
  "struct.pg.leg_banda": "banda dintre ele = rezerva",
  "struct.pg.leg_efort": "● efortul {m}",
  "struct.pg.leg_rezistenta": "▬ rezistența M_Rd — trebuie s-o îmbrace pe cerere",
  "struct.pg.leg_zona_fete": "zona critică = l_cr {l} m de la fiecare față",
  "struct.pg.leg_zona_toata": "zona critică = toată deschiderea (l_cr {l} m ≥ l₀)",
  "struct.pg.mini_zona_curenta": "zona curentă, între zonele critice",
  "struct.pg.mini_zone_critice": "zonele critice, l_cr = {l} m de la fiecare față",
  "struct.pg.petrecere_jos": "petrecere jos · Ø{phi} · l₀ = {l0} m · {zona}",
  "struct.pg.petrecere_sus": "petrecere sus · Ø{phi} · l₀ = {l0} m · {zona}",
  "struct.pg.punct_camp": "câmpul: stația cu momentul pozitiv maxim dintre fețe (fibra de jos)",
  "struct.pg.punct_r1_jos": "fibra de JOS pe fața primului stâlp — reazemul poate întinde și jos, la seism",
  "struct.pg.punct_r1_sus": "fibra de SUS pe fața primului stâlp — momentul negativ al reazemului",
  "struct.pg.punct_r2_jos": "fibra de JOS pe fața celuilalt stâlp",
  "struct.pg.punct_r2_sus": "fibra de SUS pe fața celuilalt stâlp",
  "struct.pg.tab_ax#n": "tot axul (1 deschidere)|tot axul ({n} deschideri)|tot axul ({n} de deschideri)",
  "struct.pg.tab_ax_titlu#n": "deschiderea coliniară a axului, pe aceeași scară|toate cele {n} deschideri coliniare ale axului, pe aceeași scară|toate cele {n} de deschideri coliniare ale axului, pe aceeași scară",
  "struct.pg.tab_deschiderea": "deschiderea",
  "struct.pg.titlu_combinatia": ", combinația {combo}",
  "struct.pg.titlu_diagrama": "Diagrama de acoperire a momentelor",
  "struct.pg.titlu_gruparea": "gruparea {grupa}",
  "struct.plan.gol": "Planul apare după rularea Pasului 4 (modelul structural).",
  "struct.pref.arunca_reglajele": "Aruncă reglajele — calculul revine pe setările mele",
  "struct.pref.chei#n": "{n} cheie|{n} chei|{n} de chei",
  "struct.pref.de_cine": "De cine",
  "struct.pref.doar_strange": "Fiecare setare de aici poate doar <b>strânge</b> față de normativ, niciodată să-l încalce: minimele codului rămân plafon de jos în calcul.",
  "struct.pref.et.adancime_minima": "Adâncimea minimă de fundare",
  "struct.pref.et.amprente_incercate": "Planurile deja încercate",
  "struct.pref.et.beton": "Clasa de beton",
  "struct.pref.et.coef_excentricitate": "Coeficientul de excentricitate, per ax",
  "struct.pref.et.grosime_perete_subsol": "Grosimea pereților interiori de subsol",
  "struct.pref.et.grosime_perete_subsol_contur": "Grosimea pereților de subsol, la contur",
  "struct.pref.et.grosime_placa": "Grosimea plăcii",
  "struct.pref.et.h_grinda_fundare": "Înălțimea grinzii de fundare",
  "struct.pref.et.h_mesh": "Dimensiunea mesh-ului plăcii",
  "struct.pref.et.h_mesh_baza": "Mesh-ul de bază al proiectului",
  "struct.pref.et.latime_minima": "Lățimea minimă a tălpii de fundație",
  "struct.pref.et.plafon_grosime_placa": "Plafonul de grosime al plăcii",
  "struct.pref.et.plafon_h_grinda": "Plafonul de înălțime al grinzilor",
  "struct.pref.et.plafon_h_grinda_fatada": "Plafonul de înălțime al grinzilor de fațadă",
  "struct.pref.et.rigidizare_directie": "Direcția rigidizată la separarea T₁–T₂",
  "struct.pref.et.solver_memorie": "Memoria solverului",
  "struct.pref.flux_automat": "flux automat",
  "struct.pref.intrari#n": "{n} intrare|{n} intrări|{n} de intrări",
  "struct.pref.intro": "Ce dictează <b>atelierul de fasonat, șantierul și arhitectura</b> — singurele alegeri pe care calculul n-are de unde să le afle. Restul nu se setează aici, fiindcă nu sunt preferințe: proprietățile clădirii vin din temă, arhitectură și studiul geotehnic; conformarea, secțiunile și clasa de beton le alege optimizarea, pe scor; iar coeficienții normativului și practica de birou stau în cod, cu sursa lângă ei. Pașii care le folosesc trebuie rulați din nou după modificare.",
  "struct.pref.reglaje_optimizare": "Reglaje puse de optimizare",
  "struct.pref.valoarea_ta": "Valoarea ta",
  "struct.reg.algoritmi_evolutivi": "Algoritmi evolutivi / genetici",
  "struct.reg.np007_cod_nou": "NP 007-2025 — cod nou pentru cadre de beton armat",
  "struct.reg.svg_zvelt": "zvelt · h/l > 2",
  "struct.reg.th_metoda": "Metoda",
  "struct.rz.calc_adoptat": "→ H_c adoptat pe cota de bază = {v} m",
  "struct.rz.calc_cota": "grinda stă cu talpa la cota de fundare, deci H_c ≤ Df − 0,05 = {v} m",
  "struct.rz.calc_interval": "NP 112 §II.7.5.1:  H_c ∈ [L₀/6 ; L₀/3] = [{a} ; {b}] m,  dar minim 0,50 m",
  "struct.rz.calc_l0": "L₀ de calcul = {L0} m (deschiderea axului cel mai puțin solicitat; maximul pe clădire e {L0_max} m, pe alt ax)",
  "struct.rz.calc_marginea_jos": "se alege marginea de JOS (cea mai economică) → {v} m",
  "struct.rz.cat_duce_terenul": "Cât duce terenul",
  "struct.rz.coeficient_pat": "Coeficient de pat Ks",
  "struct.rz.consecinta_flexibila": "<b>Consecința:</b> H_c/L₀ = {h} / {L0} = {r} < 0,125 → grinda e <b>flexibilă</b>. NP 112 §II.7.5.2 spune că atunci NU se mai admit metodele aproximative: grinda se încovoaie sesizabil între stâlpi, iar presiunea reală nu mai e o dreaptă. Eforturile trebuie luate din modelul pe mediu elastic — exact ce face Pasul 7, unde fundația stă pe resoarte. Dacă vrei totuși o grindă rigidă, remediul e fie coborârea cotei de fundare (loc pentru o grindă mai înaltă), fie un stâlp intermediar care să scurteze deschiderea de {L0} m.",
  "struct.rz.consecinta_rigida": "<b>Consecința:</b> H_c/L₀ = {h} / {L0} = {r} > 0,125 → grinda e <b>rigidă</b>. NP 112 §II.7.5.2 permite atunci metode aproximative de calcul și ipoteza că presiunile pe teren se distribuie liniar sub ea.",
  "struct.rz.criteriu_sectiune": "secțiunea (H ≥ L₀/6)",
  "struct.rz.criteriu_terenul": "terenul",
  "struct.rz.descrisa_pentru": " — descrisă pentru talpa de {b} m; axele mai late au talpa mai groasă (consola cere h_t ≥ (B−b_i)/2)",
  "struct.rz.dimensiunile_fundatiei": "Dimensiunile fundației (rezultatul pasului)",
  "struct.rz.din_cuantizare": " (+{v} din cuantizare)",
  "struct.rz.doua_variabile": "<b>lățimea tălpii × adâncimea de fundare</b> — cele două variabile pe care le caută optimizarea",
  "struct.rz.f_apasarea": "Apăsarea în adâncime și zona activă:",
  "struct.rz.f_cat_duce": "Cât duce terenul, la B = {B} m și Df = {Df} m:",
  "struct.rz.f_coeficientul_pat": "Coeficientul de pat (arcul de teren):",
  "struct.rz.f_greutatea": "Greutatea clădirii (estimare de practică):",
  "struct.rz.f_presiunea_efectiva": "Presiunea efectivă pe talpă (Pasul 6 — medie pe toată panglica):",
  "struct.rz.f_presiunea_neta": "Presiunea netă (cea care chiar tasează terenul):",
  "struct.rz.f_s": "s = 0,8 · Σ (σmed,i · hi / Es,i) = <b>{s} cm</b> {rel} {max} cm admis",
  "struct.rz.f_sigma_z": "σz(z) = α0(z/B, L/B) · p_net · zona activă până unde σz < 0,2 · σgz → <b>{z} m sub talpă</b>",
  "struct.rz.f_tasarea": "Tasarea (metoda însumării pe straturi elementare):",
  "struct.rz.formula_flexibila": "< 0,125 → flexibilă",
  "struct.rz.formula_h_nec": "H_nec = max(L₀/6 ; 0,50 m ; h_străpungere)          NP 112 §II.7.5.1\n",
  "struct.rz.formula_rigida": "> 0,125 → RIGIDĂ",
  "struct.rz.formulele_pasului": "Formulele pasului, cu valorile proiectului",
  "struct.rz.fundare_in": "fundare în {strat}",
  "struct.rz.fundatia_continua": "Fundația continuă nu e doar o talpă lată turnată pe pământ: peste talpă merge o <b>grindă de beton armat</b> care leagă stâlpii între ei. Ea face ca o încărcare mare pe un stâlp să nu apese doar sub el, ci să se distribuie pe o porțiune din panglică — cu cât grinda e mai înaltă, cu atât împrăștie mai departe. De aceea înălțimea ei se leagă de distanța dintre stâlpi.",
  "struct.rz.fundatia_propusa": "Fundația propusă (optimizată la volum minim)",
  "struct.rz.greutate_cladire": "Greutate clădire",
  "struct.rz.hc_retezat": "H_c a fost <b>retezată de adâncimea de fundare</b>: grinda nu poate fi mai înaltă decât săpătura în care stă, altfel ar ieși din pământ (cei 5 cm scăzuți sunt betonul de egalizare de sub talpă). Remediul e fie coborârea cotei de fundare, fie un stâlp intermediar care să scurteze deschiderea de {L0} m.",
  "struct.rz.hc_sub_l0": "⚠ H_c = {h} m e sub L₀/6 = {l6} m, <b>deși adâncimea de fundare ar permite {df} m</b>. Înălțimea a rămas cea cu care fundația a fost verificată pe reacțiuni reale (căutarea o crește doar când pică străpungerea sau tăietoarea). Săpătura e deja plătită, deci o grindă mai înaltă e ieftină și ar aduce H_c/L₀ peste 0,125 — adică o grindă rigidă. Vezi verificarea S2d.",
  "struct.rz.ks_dinamic": "dinamic {ks} daN/cm³ (× {c})",
  "struct.rz.ks_estimare": "Din greutatea estimată ar fi ieșit <b>{ks} daN/cm³</b> ({dif} diferență) — de aceea nu se mai folosește estimarea odată ce presiunile reale există.",
  "struct.rz.ks_estimat": "<b>De unde vine:</b> la prima trecere prin lanț modelul nu există încă, deci apăsarea se estimează — greutatea empirică a clădirii (g/m² × suprafața desfășurată) întinsă uniform pe toată talpa. <b>Se actualizează singur:</b> după ce Pasul 17 rulează o dată, Pasul 6 recalculează K_s din presiunile reale pe fiecare ax (k_s = p_ef/s, NP 112 anexa K.3.1.4) și modelul se rezeamă pe acela la următoarea trecere. Coerența celor două se verifică explicit — vezi „Bucla teren–structură\" în tabul Global.",
  "struct.rz.ks_reale": "<b>De unde vine:</b> din presiunile <b>reale</b> pe axe, nu din greutatea estimată — k_s = p_ef/s calculat pe fiecare ax și mediat ponderat cu aria lui de talpă („calcul invers\", NP 112 anexa K.3.1.4). Pe cele {n} axe verificate valorile merg de la {min} la {max} daN/cm³.",
  "struct.rz.l_cumulat": " · L = {L} m cumulat",
  "struct.rz.la_cutremur": "la cutremur (gruparea seismică): <b>{p} kPa</b> = 1,35 · p_conv",
  "struct.rz.latime_medie": " (Σ L_ax·B_ax·D_f; o lățime medie de {b} m ar da același volum — cifră orientativă, nu o dimensiune de execuție)",
  "struct.rz.latimi_talpa": "<b>{n} lățimi de talpă</b> (maximum 3 pe proiect), fiecare ax pe lățimea cerută de încărcarea LUI — vezi coloana „B” din tabelul „Axe”. Adâncimea de fundare e una singură pe clădire.",
  "struct.rz.legenda_desen": "Fundația e desenată <b>galben</b> (banda = talpa la lățimea ei reală, B = {B} m; linia și eticheta = axul denumit, cu lățimea lui). Click pe un element îl selectează și îl colorează <b>turcoaz</b>, fără să te mute de pe desen — pentru verificările axului există butonul din panoul de informații.",
  "struct.rz.limita_exploatare_formula": "<b>limita în exploatare</b> (gruparea fundamentală) = 1,10 · p_conv",
  "struct.rz.limita_paranteza": " (limita {limita})",
  "struct.rz.marime_derivata": "mărime <b>derivată</b>, nu variabilă de optimizare — vezi „Ce caută optimizarea și ce rezultă determinist\" mai sus",
  "struct.rz.marimi_derivate": "Mărimile derivate, cu cifrele proiectului",
  "struct.rz.media_pas6": "media pe toată panglica, din Pasul 6 de predimensionare: {p} kPa — orientativă, nu dă verdictul",
  "struct.rz.medie_estimata": "<b>medie pe toată panglica</b>, din greutatea estimată (Pasul 6) — Pasul 17, pe axe, n-a rulat încă",
  "struct.rz.optimizare": "Optimizare",
  "struct.rz.p_conv_corectat": "p_conv = {p} kPa, corectat pentru B = {B} m și D_f = {D} m",
  "struct.rz.presiune_neta": " · presiune netă {p} kPa",
  "struct.rz.presiune_teren": "Presiune pe teren",
  "struct.rz.presiunea_calcul": "<b>presiunea de calcul</b> = maximul pe axe din Pasul 17, din reacțiunile modelului",
  "struct.rz.presiunea_calcul_ax": "<b>presiunea de calcul</b> = maximul pe axe din Pasul 17 (pe {ax}), din reacțiunile modelului",
  "struct.rz.repartitia": "Repartiția: {lista}.",
  "struct.rz.ruleaza_predim": "Presiuni, lățime necesară și tasare prin metoda însumării pe straturi.",
  "struct.rz.ruleaza_verificare": "Presiuni ax cu ax pe reacțiunile reale, pe toate combinațiile.",
  "struct.rz.sapatura": " · săpătură {v} m³",
  "struct.rz.sapatura_strat": " · săpătură {v} m³ · strat de fundare: {strat}",
  "struct.rz.sect_beton_armat": "beton armat   {v} m³/ml\n",
  "struct.rz.sect_beton_simplu": "beton simplu  {v} m³/ml\n",
  "struct.rz.sect_cofraj": "cofraj        {v} m²/ml\n",
  "struct.rz.sect_nota": "A și I_y intră direct în Pasul 7 (elementele de grindă de fundare de pe patul de resoarte); G4 în Pasul 8. Verificările se fac pe partea care chiar lucrează: consola transversală și distribuția pe lățime pe <b>talpă</b>, încovoierea și tăietoarea longitudinală pe <b>inimă</b>, rigiditatea pe secțiunea întreagă.",
  "struct.rz.sectiune_detaliul": "secțiune (<b>derivată</b>, detaliul",
  "struct.rz.sectiunea_aleasa": "Secțiunea aleasă",
  "struct.rz.stratul_cota_df": "stratul de la cota Df",
  "struct.rz.t_mp_desfasurat": "{g} t/mp × {A} m² desfășurat",
  "struct.rz.talpa_inima": " (talpă {B}×{h_t} m + inimă {b_i}×{h_i} m)",
  "struct.rz.tasare_estimata": "Tasare estimată",
  "struct.rz.th_df_adoptat": "D_f adoptat",
  "struct.rz.th_df_necesar": "D_f necesar",
  "struct.rz.th_h_necesar": "H necesar",
  "struct.rz.trepte_cel_mult#n": "{n} treaptă, cel mult {max}|{n} trepte, cel mult {max}|{n} de trepte, cel mult {max}",
  "struct.rz.valoarea_calculata_limita": "<b>valoarea calculată</b>; limita: {l} cm (ținta metodei)",
  "struct.rz.verif_predim": "<b>Verificările de predimensionare a secțiunii</b> — condiții constructive din NP 112, verificate înainte de orice calcul de eforturi:",
  "struct.rz.vezi_verificarile_axului": "↑ Vezi verificările axului",
  "struct.rz.zona_activa": "zonă activă {z} m sub talpă",
  "struct.rzv.coef_exc_egal": "Coeficient de excentricitate k_exc = {k}",
  "struct.rzv.col_as_jos_sus": "A_s jos / sus",
  "struct.rzv.col_tasare": "Tasare",
  "struct.rzv.formula_consola": "L_c = (B − b_element)/2,   M = p_max · L_c²/2  [kNm pe metru liniar]",
  "struct.rzv.formula_ks_invers": "k_s = p_ef / s   (calcul invers, NP 112 anexa K.3.1.4)",
  "struct.rzv.formula_p_np112": "p_max = μ · ΣF_Z/(L·B),  μ = f(e_L/L, e_B/B) din NP 112 tab. E.1",
  "struct.rzv.nod_n": "nod {n}",
  "struct.rzv.ref_metoda_02": "metoda de lucru (02.calcul presiune conventionala)",
  "struct.rzv.ref_metoda_np112": "metoda de lucru + NP 112",
  "struct.rzv.ref_np112_i5_anexa_e": "NP 112-2014 tab. I.5 + anexa E",
  "struct.rzv.sim_implicit": "implicit",
  "struct.seism.acceleratia_spectrala_mod": "Accelerația spectrală per mod",
  "struct.seism.arata_primele_10": "Arată doar primele 10",
  "struct.seism.aria_spectrul": "Spectrul de proiectare Sd(T)",
  "struct.seism.cazuri_seismice_adaugate": "Cazuri seismice adăugate",
  "struct.seism.constanta_cqc": "constantă a metodei — intră în corelarea CQC",
  "struct.seism.constanta_presupus_armare": "constantă a metodei — presupus, de confirmat la armare",
  "struct.seism.criteriu_90_indeplinit": "criteriul ≥ 90% îndeplinit · la numărul minim de moduri ({n}) era {x}% / {y}%",
  "struct.seism.criteriu_90_neindeplinit": "criteriul ≥ 90% NEîndeplinit · la numărul minim de moduri ({n}) era {x}% / {y}%",
  "struct.seism.din_analiza_modala_p7": "din analiza modală a Pasului 7",
  "struct.seism.fb_echiv": "F_b echiv.",
  "struct.seism.intra_combinatii_p11": "{lista} — intră în combinațiile Pasului 11",
  "struct.seism.lu_rar_multifrontal": "LU rar (multifrontal) pe K·u = f — aceeași soluție exactă ca BandGen, dar ~124× mai repede pe modelul shell",
  "struct.seism.meff_cumulat": "m_eff cumulat",
  "struct.seism.meff_sd_metoda_a": "m_eff · S_d(T₁) — P100-1, metoda A",
  "struct.seism.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga (după Pașii 7 și 8).",
  "struct.seism.parametrii_spectrului": "Parametrii spectrului de proiectare",
  "struct.seism.pe_proiectul_acesta": "Pe proiectul acesta: {sursa}.",
  "struct.seism.perioada_fundamentala_x": "Perioada fundamentală (X)",
  "struct.seism.perioadele_de_colt": "(perioadele de colț)",
  "struct.seism.q_factorul_comportare": "q (factorul de comportare)",
  "struct.seism.raspunsul_pe_directii": "Răspunsul pe direcții",
  "struct.seism.sd_t1_mod": "S_d(T₁) = {sd} m/s² · mod {mod}",
  "struct.seism.simbol_v_baza": "V_bază",
  "struct.seism.solverul_liniar": "Solverul sistemului liniar",
  "struct.seism.spectrul_p100_1": "Spectrul de proiectare P100-1",
  "struct.seism.spectrul_proiectare_sd": "Spectrul de proiectare S_d(T)",
  "struct.seism.tc_din_zonare": "T_C din zonarea P100-1/2013 (fig. 3.2) după localitatea proiectului — v. Pasul 1; T_B = 0,2·T_C, T_D normat",
  "struct.seism.torsiunea_accidentala": "Torsiunea accidentală",
  "struct.strateg.aria_unui_nivel": "aria unui nivel",
  "struct.strateg.bugetul_constructiv": "Bugetul constructiv",
  "struct.strateg.bugetul_forfecare": "Bugetul de forfecare",
  "struct.strateg.ce_implica_clasa": "Ce implică clasa {clasa} mai departe",
  "struct.strateg.proeminenta_titlu": "Etajul retras ({nivel}): proeminență sau nivel",
  "struct.strateg.proeminenta_da": "proeminență din zidărie confinată",
  "struct.strateg.proeminenta_nu": "nivel de cadre",
  "struct.strateg.cele_patru_bugete": "Cele patru bugete de beton (ρ)",
  "struct.strateg.clasa_ductilitate_titlu": "Clasa de ductilitate (P100-1/2013)",
  "struct.strateg.clasa_selectata": "Clasa selectată",
  "struct.strateg.coeficientul_seismic": "coeficientul seismic",
  "struct.strateg.col_clasa": "Clasa",
  "struct.strateg.col_rho_forfecare": "ρ forfecare",
  "struct.strateg.comparatia_claselor": "Comparația claselor ({sistem}, αu/α1 = {alfa})",
  "struct.strateg.constrangerea_guverneaza": "Constrângerea care guvernează",
  "struct.strateg.driftul_real_admis": "driftul de nivel real admis ({delta})",
  "struct.strateg.factorul_amplificare": "factorul de amplificare (2,5)",
  "struct.strateg.factorul_comportare": "Factorul de comportare",
  "struct.strateg.factorul_comportare_presupus": "factorul de comportare presupus",
  "struct.strateg.l_typ_directii": "l_typ pe direcții",
  "struct.strateg.nepermisa_ag": "nu (a_g > 0,10g)",
  "struct.strateg.nerulat": "Pasul nu a fost rulat încă. Apasă „Run” în meniul din stânga (după Pașii 1 și 2).",
  "struct.strateg.pasul_dintre_elemente": "Pasul dintre elementele verticale",
  "struct.strateg.pasul_practic_maxim": "pasul practic maxim",
  "struct.strateg.q_max_pereti": "q = q0 · k_w · αu/α1 (P100-1 tab. 5.1, pereți; k_w = {k_w})",
  "struct.strateg.rand_a_elem": "A_elem (aria unui element)",
  "struct.strateg.rand_c_s": "c_s (coeficientul seismic)",
  "struct.strateg.rand_d_top": "D_top (deplasarea admisă la vârf)",
  "struct.strateg.rand_h": "H (înălțimea totală a clădirii)",
  "struct.strateg.rand_i_req": "I_req (inerția totală necesară)",
  "struct.strateg.rand_l_max": "L_max (deschiderea cu grindă ascunsă)",
  "struct.strateg.rand_lambda": "λ (factor de corecție modal)",
  "struct.strateg.rand_n_elem": "n_elem (elemente verticale estimate)",
  "struct.strateg.rand_nu_t": "νt (apăsarea maximă admisă pe stâlpi)",
  "struct.strateg.rand_pas": "pas (distanța practică între elemente)",
  "struct.strateg.rand_v": "V (forța tăietoare de bază)",
  "struct.strateg.rand_v_rd": "v_Rd (ținta de forfecare)",
  "struct.strateg.rho_constructiv": "Constructiv (arhitectura decide)",
  "struct.strateg.rho_drift": "Drift (clădirea se îndoaie)",
  "struct.strateg.rho_forfecare": "Forfecare (pereții ar aluneca)",
  "struct.strateg.rho_gravitational": "Gravitațional (limita νd)",
  "struct.strateg.sageata_guverneaza": " ← guvernează",
  "struct.strateg.sageata_selectata": " ← selectată",
  "struct.strateg.sim_h_grinda": "h_grindă",
  "struct.strateg.structura_recomandata": "Structura recomandată",
  "struct.strateg.sursa_pasul_1_zonare": "Pasul 1 (zonarea P100-1)",
  "struct.strateg.sursa_pasul_2": "Pasul 2",
  "struct.strateg.sursa_pasul_2_media": "Pasul 2 (media)",
  "struct.strateg.sursa_pasul_2_media_niv": "Pasul 2 (media nivelurilor)",
  "struct.strateg.sursa_tab51_nota": "P100-1/2013 tab. 5.1, nota — {nota}",
  "struct.strateg.tronsoane": "Tronsoane",
  "struct.strateg.valori_intermediare": "Valori intermediare — cu formula și sursa fiecăreia",
  // programul de execuție (`viewer/cost/PanouProgram.tsx`)
  "costuri.tab.program": "Program",
  "costuri.tab.piata": "Vânzări în zonă",
  "prog.sub.grafic": "Grafic",
  "prog.sub.resurse": "Resurse",
  "prog.sub.reguli": "Reguli și calendar",
  "prog.kpi.inceput": "Început",
  "prog.kpi.sfarsit": "Sfârșit",
  "prog.kpi.durata": "Durată",
  "prog.kpi.luni": "{n} luni",
  "prog.kpi.zile_lucratoare": "{n} zile lucrătoare",
  "prog.kpi.muncitori": "Muncitori",
  "prog.kpi.la_varf": "{n} la vârf",
  "prog.kpi.in_medie": "{n} în medie · {m} meserii",
  "prog.kpi.macarale": "Macarale",
  "prog.kpi.luni_macara": "{n} luni-macara",
  "prog.kpi.max_simultan": "cel mult {n} deodată",
  "prog.kpi.fronturi": "{n} fronturi de structură · plafon {p} macarale",
  "prog.kpi.start_implicit": "importul + 3 luni",
  "prog.kpi.start_pus": "pusă pe proiect",
  "prog.zoom.luna": "Lună",
  "prog.zoom.saptamana": "Săptămână",
  "prog.zoom.titlu": "Scara timpului",
  "prog.zoom.tot": "Tot proiectul",
  "prog.desfa_tot": "Desfă toate",
  "prog.strange_tot": "Strânge toate",
  "prog.desfa": "Desfă {n}",
  "prog.strange": "Strânge {n}",
  "prog.doar_ritmul": "Doar lanțul critic",
  "prog.santier": "Șantier",
  "prog.corp_nivel": "Corp · nivel",
  "prog.detaliu.interval": "Interval",
  "prog.detaliu.muncitori": "Muncitori pe etapă",
  "prog.detaliu.ore": "{n} ore-om",
  "prog.detaliu.ore_macara": "{n} ore de macara",
  "prog.detaliu.impins": "pornire amânată {n} zile: front de lucru insuficient",
  "prog.detaliu.ciclu": "Ciclul nivelului",
  "prog.detaliu.ciclu_text": "{n} zile lucrătoare, dat de {de}",
  "prog.ritm.minim": "ciclul minim",
  "prog.ritm.macara": "macara",
  "prog.ritm.echipa": "echipa structurii, cât încape pe nivel",
  "prog.ritm.urmasi": "meseriile care urmează, cât încap pe nivel",
  "prog.ritm.beton": "betonul pe zi (pompa sau stația)",
  "prog.detaliu.plafon": "Plafon pe nivel",
  "prog.detaliu.plafon_text": "{n} oameni ({a} m²)",
  "prog.detaliu.articole": "Articole",
  "prog.detaliu.gol": "Apasă pe o bară ca să vezi etapa, sau pe un corp ca să-l vezi întreg.",
  "prog.detaliu.inchide": "Închide detaliul",
  "prog.lant.structura": "Structura",
  "prog.lant.niveluri": "{n} niveluri",
  "prog.corp.amprenta": "{a} m² amprentă",
  "prog.corp.macarale": "{b} × {l} luni",
  "prog.corp.asteptat": "A așteptat macarale",
  "prog.corp.asteptat_text": "{n} zile lucrătoare după macarale libere (plafon {p}); a pornit pe {d}, când s-a eliberat {c}.",
  "prog.corp.asteptat_text_fara": "{n} zile lucrătoare după macarale libere (plafon {p}); a pornit pe {d}.",
  "prog.corp.lucrari": "Lucrările de șantier",
  "prog.corp.pe_subsol": "Stă pe subsol",
  "prog.corp.pe_subsol_text": "Structura pornește pe placa de deasupra lui {s}, gata pe {d}.",
  "prog.subsol.regim": "subsol comun · {n} niveluri",
  "prog.subsol.pe_el": "Blocurile de pe el",
  "prog.subsol.pe_el_sub": "pornesc după placa de deasupra ultimului nivel",
  "prog.avertismente": "Avertismente",
  "prog.explicatii": "Cum s-au așezat corpurile",
  "prog.etape.titlu": "Etapele",
  "prog.etape.th.etapa": "Etapă",
  "prog.etape.th.inceput": "Început",
  "prog.etape.th.sfarsit": "Sfârșit",
  "prog.etape.th.muncitori": "Muncitori",
  "prog.etape.th.ore": "Ore-om",
  "prog.etape.th.decalaj": "Decalaj la sfârșit",
  "prog.etape.th.unitati": "Unități",
  "prog.etape.decalaj_text": "{n} zile după {de}",
  "prog.etape.da_ritmul": "dă ritmul",
  "prog.hist.titlu": "Muncitori pe șantier, pe săptămâni",
  "prog.hist.sub": "vârf {v} · medie {m} · {s} săptămâni",
  "prog.hist.saptamana": "săptămâna {n} ({d}): {t} muncitori",
  "prog.resurse.intro": "Efectivele recomandate ies din ritmul structurii și din lag-uri; ce schimbi aici devine un scenariu nou.",
  "prog.meserii.titlu": "Muncitori pe categorie",
  "prog.meserii.sub": "un calendar pentru toți · {z} · {h} h/zi · productivitate {p}",
  "prog.meserii.th.categorie": "Categorie",
  "prog.meserii.th.recomandat": "Recomandat",
  "prog.meserii.th.folosit": "Folosit",
  "prog.meserii.th.varf": "Vârf",
  "prog.meserii.th.ore": "Ore-om",
  "prog.meserii.th.zile": "Zile pe șantier",
  "prog.meserii.th.utilizare": "Utilizare",
  "prog.meserii.th.stare": "Stare",
  "prog.stare.impusa": "impus",
  "prog.stare.la_ritm": "la ritm",
  "prog.stare.standby": "multe zile în așteptare",
  "prog.stare.putin": "puțin folosit",
  "prog.revino": "Revino la recomandat",
  "prog.reprogrameaza": "Reprogramează ca scenariu nou",
  "prog.scenariu_resurse": "Efective schimbate",
  "prog.scenariu_nota": "efectivele puse pe ecranul Resurse",
  "prog.macarale.titlu": "Macarale turn",
  "prog.macarale.sub": "pe corp, după amprentă; numără la plafon cât ține structura, stau până la fațadă",
  "prog.macarale.th.corp": "Corp",
  "prog.macarale.th.buc": "Macarale",
  "prog.macarale.th.pe_santier": "Pe șantier",
  "prog.macarale.th.luni": "Luni-macara",
  "prog.macarale.th.structura": "Structura",
  "prog.macarale.th.asteptat": "Așteptare",
  "prog.macarale.asteptat": "{n} zile, după {c}",
  "prog.macarale.asteptat_fara": "{n} zile",
  "prog.macarale.santier": "lucrările de șantier: {n} macarale",
  "prog.macarale.total": "Total",
  "prog.macarale.plafon": "cel mult {n} în structură, {m} cu fațadele · plafon {p}",
  "prog.reguli.intro": "Regulile sunt ale proiectului; o schimbare reface programul tuturor scenariilor.",
  "prog.reguli.titlu": "Etapele și ordinea lor",
  "prog.reguli.sub": "fiecare etapă pornește după etapa dinainte de pe aceeași unitate, la distanța minimă, și o ține până la sfârșit",
  "prog.reguli.th.cod": "Cod",
  "prog.reguli.th.etapa": "Etapă",
  "prog.reguli.th.unitate": "Unitate",
  "prog.reguli.th.dupa": "Pornește după",
  "prog.reguli.th.lag": "Lag (zile)",
  "prog.reguli.catalog.titlu": "Regulile de planificare",
  "prog.reguli.catalog.sub": "ce ține programul în frâu: fiecare regulă cu parametrii ei și de ce există; o regulă legată de un material nu se aplică altui material",
  "prog.reguli.inactiva": "inactivă",
  "prog.reguli.categorie.lag": "distanță între etape",
  "prog.reguli.categorie.asteptare": "așteptare tehnologică",
  "prog.reguli.categorie.capacitate": "capacitate",
  "prog.reguli.categorie.resursa": "resursă",
  "prog.reguli.categorie.succesiune": "succesiune",
  "prog.reguli.categorie.calendar": "calendar",
  "prog.reguli.categorie.fereastra": "fereastră de sezon",
  "prog.set.material": "Materialul structurii",
  "prog.set.material_sub": "betonul turnat are întărire și decofrare (ciclul minim); prefabricatele nu",
  "prog.material.beton": "beton turnat",
  "prog.material.prefab": "prefabricate",
  "prog.sub.parghii": "Restricții și pârghii",
  "prog.kpi.cost_parghii": "Costul pârghiilor",
  "prog.kpi.cost_parghii_sub": "{n} costuri suplimentare în program",
  "prog.kpi.restrictii": "Restricții atinse",
  "prog.kpi.restrictii_atinse": "{n} atinse",
  "prog.parghii.fara": "Programul ăsta n-are restricții și pârghii (motor vechi): refă-l.",
  "prog.parghii.intro": "Restricțiile se verifică pe planul de situație, pe arhitectură și pe program; o pârghie scurtează programul pe un cost și se oprește la o restricție. O pârghie aleasă face un scenariu nou.",
  "prog.restrictii.titlu": "Restricțiile fizice",
  "prog.restrictii.sub": "ce cere proiectul față de cât încape; «atinsă» = programul s-a lovit de ea",
  "prog.restrictii.atinsa": "atinsă",
  "prog.restrictii.ok": "verificată",
  "prog.restrictii.fara_date": "fără date",
  "prog.restrictii.valoare": "{v} din {l} {um}",
  "prog.costuri.titlu": "Costurile suplimentare",
  "prog.costuri.sub": "ce costă setările active (pârghii puse de om sau de asistent) și restricțiile atinse; intră în business case la construcții",
  "prog.costuri.niciunul": "Nicio pârghie activă, nicio restricție cu cost: programul merge pe setările de bază.",
  "prog.costuri.total": "Total",
  "prog.costuri.macarale": "Macaralele programului: {l} luni-macara × {pl} € + {b} mobilizări × {pm} € = {eur} € (sunt deja în listă, articolul S.MAC).",
  "prog.parghii.titlu": "Pârghiile",
  "prog.parghii.sub": "ce scurtează programul, cu ce câștigă, ce costă și de ce se oprește; refuzată = s-ar lovi de o restricție sau n-ar câștiga nimic acum",
  "prog.parghii.aplicata": "aplicată",
  "prog.parghii.disponibila": "disponibilă",
  "prog.parghii.refuzata": "refuzată",
  "prog.parghii.neverificata": "limita neverificată",
  "prog.parghii.aplica": "Scenariu cu pârghia",
  "prog.parghii.motiv": "Refuzată: {m}",
  "prog.parghii.cost": "Cost:",
  "prog.parghii.risc": "Risc:",
  "prog.scenariu_parghie": "Pârghie: {n}",
  "prog.scenariu_parghie_nota": "pârghia «{n}» pusă pe ecranul Pârghii",
  "prog.reguli.categorie.logistica": "logistică",
  "prog.set.pompa": "Pompă de beton",
  "prog.set.pompa_sub": "betonul merge cu pompa; macaraua ridică doar cofrajul și armătura",
  "prog.set.pompa_da": "cu pompă",
  "prog.set.statie": "Betonul livrat pe zi",
  "prog.set.statie_sub": "cât livrează stația pe șantier într-o zi, cu traficul; ipoteză de proiect",
  "prog.set.brat": "Brațul macaralei",
  "prog.set.brat_sub": "catargele stau la braț + 5 m unul de altul; de aici câte încap pe lot",
  "prog.set.schimburi": "Schimburile la structură",
  "prog.set.schimburi_sub": "în două schimburi macaraua și echipa fac dublu pe zi; întărirea rămâne; spor de noapte",
  "prog.schimburi.unu": "un schimb",
  "prog.schimburi.doua": "două schimburi",
  "prog.set.cofraje_rapide": "Cofraje rapide",
  "prog.set.cofraje_rapide_sub": "cofraj de masă și aditivi: ciclul minim 5 zile (8 la subsol), +15 % la cofraj",
  "prog.set.cofraje_rapide_da": "cofraj de masă și aditivi",
  "prog.set.lift": "Lift de șantier",
  "prog.set.lift_sub": "finisajele corpurilor înalte urcă cu liftul; fără el merg la 80 % din ritm",
  "prog.set.lift_da": "există, în organizarea de șantier",
  "prog.set.lift_etaj": "Liftul de la etajul",
  "prog.set.lift_etaj_sub": "peste atâtea etaje finisajele cer lift de șantier",
  "prog.um.m3_zi": "m³/zi",
  "prog.um.m": "m",
  "prog.sub.tinta": "Țintă",
  "prog.tinta.intro": "Optimizatorul încearcă pârghiile pas cu pas, pe program și pe business case: alege de fiecare dată pasul cu cel mai mic cost pe lună câștigată (sau cu cel mai mare câștig de ROI anual), până la țintă sau până când nimic nu mai ajută. Drumul se vede întreg; scenariul se face din plan.",
  "prog.tinta.titlu": "Ce vrem",
  "prog.tinta.sub": "programul de acum: {n} luni",
  "prog.tinta.mod_luni": "să dureze cel mult",
  "prog.tinta.luni": "luni, cât mai ieftin",
  "prog.tinta.mod_roi": "cel mai bun ROI anual",
  "prog.tinta.cauta": "Caută pârghiile",
  "prog.tinta.cauta_acum": "Se caută…",
  "prog.tinta.de_la_la": "{a} → {b} luni",
  "prog.tinta.atins": "ținta e atinsă",
  "prog.tinta.neatins": "sub {n} luni nu se ajunge cu pârghiile disponibile",
  "prog.tinta.cel_mai_bun": "cel mai bun ROI anual găsit",
  "prog.tinta.roi_an": "ROI anual",
  "prog.tinta.tic": "TIC {a} → {b} €",
  "prog.tinta.cost_extra": "Bani în plus",
  "prog.tinta.cost_extra_sub": "pârghii {s} € · macarale {m} € față de acum",
  "prog.tinta.pasi": "Pași",
  "prog.tinta.plan": "Planul",
  "prog.tinta.plan_sub": "pârghiile în ordinea găsită; fiecare cu lunile câștigate, banii în plus și ROI-ul anual",
  "prog.tinta.scenariu": "Scenariu din plan",
  "prog.tinta.scenariu_luni": "Plan: {n} luni",
  "prog.tinta.scenariu_roi": "Plan: cel mai bun ROI anual",
  "prog.tinta.scenariu_nota": "pârghiile găsite de optimizator: {p}",
  "prog.tinta.niciun_pas": "Nicio pârghie nu mai ajută: programul de acum e cel mai bun pe criteriul ales.",
  "prog.tinta.th.parghie": "Pârghie",
  "prog.tinta.th.luni": "Luni",
  "prog.tinta.th.cost": "Bani în plus",
  "prog.tinta.th.roi": "ROI anual",
  "prog.tinta.th.dupa": "Luni după",
  "prog.tinta.refuzate": "Ce n-a intrat în plan",
  "prog.tinta.refuzate_sub": "refuzate = s-ar lovi de o restricție; fără câștig = încercate pe ultimul program, n-au adus nimic",
  "prog.tinta.nimic_refuzat": "Toate pârghiile au intrat în plan.",
  "prog.tinta.fara_castig": "fără câștig",
  "prog.tinta.fara_castig_sub": "ar da {l} luni pe {c} € ({r} pp ROI anual)",
  "prog.unitate.nivel": "nivel",
  "prog.unitate.corp": "corp",
  "prog.unitate.santier": "șantier",
  "prog.mod.acelasi": "același nivel",
  "prog.mod.corp": "corpul",
  "prog.mod.ultimul": "ultimul nivel",
  "prog.mod.toate": "toate",
  "prog.ritm.titlu": "Ritmul și dimensionarea",
  "prog.set.ciclu_min": "Ciclu minim pe nivel curent",
  "prog.set.ciclu_min_sub": "structura nu merge mai repede, oricâți oameni",
  "prog.set.ciclu_subsol": "Ciclu minim la subsol și parter",
  "prog.set.ciclu_subsol_sub": "niveluri mai grele: radier, pereți",
  "prog.set.marja": "Marja de siguranță la sfârșit",
  "prog.set.marja_sub": "fiecare meserie termină la lag + marjă după cea dinainte",
  "prog.set.productivitate": "Productivitate",
  "prog.set.productivitate_sub": "rețetele și tarifele orare sunt deja la 1,0",
  "prog.set.ore_macara": "Norma de macara a structurii",
  "prog.set.ore_macara_sub": "ore de macara pe m³ de beton",
  "prog.set.amprenta_macara": "Macarale pe corp",
  "prog.set.amprenta_macara_sub": "o macara la fiecare atâția m² de amprentă (începuți); stau până la fațadă",
  "prog.set.macarale_max": "Macarale pe șantier, cel mult",
  "prog.set.macarale_max_sub": "plafonul: corpurile cu structura în lucru deodată; se verifică la pornirea fiecărui corp",
  "prog.set.m2_macara": "Ritmul lucrărilor de șantier",
  "prog.set.m2_macara_sub": "m² pe zi pe fiecare macara, la terasamente, fundații și subsolul comun (o zonă pe macara)",
  "prog.perioade.titlu": "Plafon de macarale pe perioade",
  "prog.perioade.sub": "un corp în plus pornește într-o perioadă cu plafon mai mare și își ține macaralele până îi e gata structura",
  "prog.perioade.maxim": "plafon",
  "prog.perioade.adauga": "+ Adaugă perioadă",
  "prog.um.m2_zi": "m²/zi",
  "prog.set.densitate": "Densitate de verificare",
  "prog.set.densitate_sub": "m² de nivel pe muncitor; când o meserie nu încape, structura încetinește",
  "prog.set.min_om": "Cel puțin atâția oameni pe nivel",
  "prog.set.min_om_sub": "plafonul unui nivel mic",
  "prog.um.zl": "zile lucr.",
  "prog.um.h_m3": "h/m³",
  "prog.um.m2": "m²",
  "prog.um.m2_om": "m²/om",
  "prog.calendar.titlu": "Calendar",
  "prog.calendar.sub": "unul singur, pentru toate meseriile",
  "prog.calendar.start": "Data de început",
  "prog.calendar.start_sub": "implicit: importul proiectului + 3 luni ({d})",
  "prog.calendar.zile": "Zile lucrătoare",
  "prog.calendar.zile_sub": "{h} ore pe zi",
  "prog.calendar.sarbatori": "Sărbătorile legale (România)",
  "prog.calendar.sarbatori_sub": "Paștele și Rusaliile se calculează pe an",
  "prog.calendar.sarbatori_da": "se sar",
  "prog.calendar.libere": "Zile libere ale proiectului",
  "prog.calendar.libere_sub": "închideri de șantier, concedii colective",
  "prog.calendar.adauga": "+ Adaugă",
  "prog.calendar.de_la": "de la",
  "prog.calendar.pana_la": "până la",
  "prog.calendar.sterge": "Șterge",
  "prog.zi.0": "L",
  "prog.zi.1": "Ma",
  "prog.zi.2": "Mi",
  "prog.zi.3": "J",
  "prog.zi.4": "V",
  "prog.zi.5": "S",
  "prog.zi.6": "D",
  "prog.luna.0": "ian",
  "prog.luna.1": "feb",
  "prog.luna.2": "mar",
  "prog.luna.3": "apr",
  "prog.luna.4": "mai",
  "prog.luna.5": "iun",
  "prog.luna.6": "iul",
  "prog.luna.7": "aug",
  "prog.luna.8": "sep",
  "prog.luna.9": "oct",
  "prog.luna.10": "noi",
  "prog.luna.11": "dec",
  "prog.salveaza": "Salvează regulile",
  "prog.revino_global": "Revino la valorile implicite",
  "prog.salvat": "Regulile s-au salvat; programul se reface.",
  "prog.rev_vechi": "Altcineva a schimbat regulile între timp; ecranul a trecut pe ale lui.",
  "prog.eroare": "Programul nu s-a putut calcula: {m}",
  "prog.fara_solutie": "Programul are nevoie de o soluție cu lista de cantități.",
  "prog.refa": "Refă programul",
  "prog.scenariul": "scenariul «{n}»",
  "prog.pe_baza": "pe lista și regulile proiectului",
  "prog.m.necalificat": "necalificați",
  "prog.m.zidar": "zidari",
  "prog.m.zugrav": "zugravi",
  "prog.m.faiantar": "faianțari",
  "prog.m.parchetar": "parchetari",
  "prog.m.rigipsar": "rigipsari",
  "prog.m.montator": "montatori",
  "prog.m.instalator": "instalatori",
  "prog.m.electrician": "electricieni",
  "prog.m.lacatus": "lăcătuși",
  "prog.m.izolator": "izolatori",
  "prog.m.mecanic_lift": "montatori de ascensoare",
  "prog.m.pavator": "pavatori",
  "prog.m.peisagist": "peisagiști",
  "prog.m.dulgher": "dulgheri",
  "prog.m.fierar": "fierari",
  "prog.m.betonist": "betoniști",
  "sc.th.durata": "Durată",
  "sc.th.sfarsit": "Sfârșit",
  "sc.luni": "{n} luni",
  "sc.ax_durata": "durata, luni",
  "sc.axa_roi": "TIC × ROI/an",
  "sc.axa_durata": "TIC × durată",
  "sc.durata_se_calculeaza": "se calculează…",
  "bc.r.durata.obs_program": "din programul de execuție: {n} luni",
  "bc.r.durata.de_unde_program": "Durata programului de execuție al scenariului (fila «Program»), în luni: nu e o ipoteză. Se scurtează prin program — macarale pe perioade, efective, lag-uri —, nu din cifra asta.",
  // --- Planificare → Vânzări în zonă (`viewer/cost/PanouPiata.tsx`) ---------
  "pz.niciuna": "Nicio căutare încă pentru terenul ăsta. Căutarea strânge anunțurile de vânzare din jurul lui: preț pe m², camere, suprafață, anul blocului, finisaje și fațadă.",
  "pz.niciuna_cititor": "Nicio căutare încă pentru terenul ăsta. Un editor al proiectului o poate porni.",
  "pz.cauta_prima": "Caută ofertele din zonă",
  "pz.reimprospateaza": "Reîmprospătează",
  "pz.cauta_acum": "Caută acum",
  "pz.cauta_acum_t": "Caută din nou pe site-uri, chiar dacă ofertele sunt mai noi de {zile}",
  "pz.din_cache": "Ofertele sunt din {data}, mai noi de {zile}, deci nu s-a căutat din nou. După {pana} butonul caută iar; până atunci, «Caută acum» caută oricum.",
  "pz.fara_locatie": "Terenul n-are încă un punct pe hartă. El vine din actele terenului (certificatul de urbanism, planul cadastral) sau din localizarea proiectului.",
  "pz.colector_mut": "Colectorul de prețuri nu răspunde acum. Încearcă din nou în câteva momente.",
  "pz.se_arata_vechi": "Se caută din nou; până termină, rămân pe ecran ofertele căutării de dinainte.",
  "pz.zona": "{raza} km în jurul terenului, blocuri din {an} încoace",
  "pz.zona_orice": "{raza} km în jurul terenului, blocuri de orice vechime",
  "pz.cautat_la": "căutat la {data}",
  "pz.sursa.interzis": "acces refuzat",
  "pz.stare.in_asteptare": "în coadă",
  "pz.stare.ruleaza": "se caută",
  "pz.stare.eroare": "eroare",
  "pz.trepte": "Zona s-a lărgit pe trepte, ca eșantionul să fie destul de mare: {lista}.",
  "pz.treapta_item": "{raza} km și {ani} → {oferte}",
  "pz.treapta_item_orice": "{raza} km, orice vechime → {oferte}",
  "pz.regula": "Regula: se adună până la {esantion}, cât zona rămâne în {tkm} km și {ani} de la construire; sub {min}, zona se lărgește mai departe. Ofertele mai depărtate și mai vechi cântăresc mai puțin.",
  "pz.n_oferte#n": "o ofertă|{n} oferte|{n} de oferte",
  "pz.n_ani#n": "un an|{n} ani|{n} de ani",
  "pz.n_zile#n": "o zi|{n} zile|{n} de zile",
  "pz.suspect": "suspect",
  "pz.suspect.pret_mp_prea_mic": "Prețul pe m² e sub 300 €: nu e o vânzare de apartament.",
  "pz.suspect.pare_inchiriere": "Anunțul pare o chirie pusă la vânzare.",
  "pz.material.concrete": "beton",
  "pz.material.brick": "cărămidă",
  "pz.material.reinforced_concrete": "beton armat",
  "pz.material.concrete_plate": "panouri prefabricate",
  "pz.material.cellular_concrete": "BCA",
  "pz.material.breezeblock": "blocuri de zidărie",
  "pz.material.wood": "lemn",
  "pz.material.other": "altul",
  "pz.incalzire.gas": "centrală pe gaz",
  "pz.incalzire.urban": "termoficare",
  "pz.incalzire.boiler_room": "centrală de bloc",
  "pz.incalzire.other": "altul",
  "pz.sursa.neconfigurat": "neconfigurată",
  "pz.stare_c.in_constructie": "în construcție",
  "pz.si_pe": "și pe",
  "pz.d.dubluri": "Același apartament e anunțat și pe",
  "pz.f.surse": "Sursa",
  "pz.f.toate_sursele": "Toate sursele",
  "pz.progres.locatii": "se caută cartierele din jurul terenului",
  "pz.progres.cautare": "se citesc listele: {n} anunțuri",
  "pz.progres.detalii": "se citesc anunțurile: {facut} din {total}",
  "pz.f.camere": "Camere",
  "pz.f.toate": "Toate",
  "pz.f.camere.1": "Garsoniere",
  "pz.f.camere.2": "2 camere",
  "pz.f.camere.3": "3 camere",
  "pz.f.camere.4": "4+ camere",
  "pz.f.camere.necunoscut": "Fără nr. de camere",
  "pz.f.vechi": "și blocurile mai vechi de {ani} ({n})",
  "pz.f.sortare": "Ordonează după",
  "pz.sort.distanta": "distanță",
  "pz.sort.pondere": "pondere",
  "pz.sort.pret_mp": "preț pe m²",
  "pz.sort.pret": "preț",
  "pz.sort.suprafata": "suprafață",
  "pz.sort.an": "anul blocului",
  "pz.th.anunt": "Anunț",
  "pz.th.pret_mp": "€/m²",
  "pz.th.pret": "Preț",
  "pz.th.camere": "Cam.",
  "pz.th.etaj": "Etaj",
  "pz.th.an": "An",
  "pz.th.finisaje": "Finisaje",
  "pz.th.fatada": "Fațadă",
  "pz.th.distanta": "km",
  "pz.th.pondere": "Pondere",
  "pz.pondere_t": "Cât cântărește oferta în profilul zonei: jumătate la fiecare {km} km de teren și la fiecare {ani} de vechime a blocului.",
  "pz.aprox_t": "Distanța până la cartierul anunțului: pagina lui nu s-a citit încă, deci pinul de pe hartă nu se știe.",
  "pz.mai_multe": "Arată încă {n} (din {tot})",
  "pz.etaj.parter": "P",
  "pz.etaj.demisol": "D",
  "pz.vechi": "vechi",
  "pz.vechi_t": "Bloc din {an}: mai vechi de {ani}, deci nu spune cât se vinde azi un bloc nou.",
  "pz.fin.low": "scăzute",
  "pz.fin.standard": "standard",
  "pz.fin.premium": "premium",
  "pz.fin.luxury": "lux",
  "pz.fat.umeda": "umedă",
  "pz.fat.ventilata": "ventilată",
  "pz.fat.placata": "placată",
  "pz.fat.cortina": "cortină",
  "pz.fat.umeda_t": "Fațadă umedă: termosistem (polistiren sau vată minerală, cu tencuială)",
  "pz.fat.ventilata_t": "Fațadă ventilată: placaj prins pe o structură, cu aer între el și izolație",
  "pz.fat.placata_t": "Fațadă placată: ceramică, piatră, HPL sau cărămidă aparentă",
  "pz.fat.cortina_t": "Perete cortină: fațadă de sticlă pe montanți",
  "pz.din_text": "estimat din textul anunțului: «{dovezi}»",
  "pz.ansamblu": "ansamblu",
  "pz.piata.primara": "primară (de la dezvoltator)",
  "pz.piata.secundara": "secundară (revânzare)",
  "pz.stare_c.gata": "gata de locuit",
  "pz.stare_c.de_finisat": "de finisat",
  "pz.stare_c.de_renovat": "de renovat",
  "pz.d.deschide": "Deschide anunțul pe {sursa} ↗",
  "pz.d.inchide": "Închide",
  "pz.d.pret": "Preț",
  "pz.d.pret_mp": "Preț pe m²",
  "pz.d.suprafata": "Suprafață",
  "pz.d.camere": "Camere",
  "pz.d.etaj": "Etaj",
  "pz.d.an": "Anul blocului",
  "pz.d.piata": "Piață",
  "pz.d.stare": "Stare",
  "pz.d.material": "Structură",
  "pz.d.incalzire": "Încălzire",
  "pz.d.cartier": "Cartier",
  "pz.d.adresa": "Adresă",
  "pz.d.agentie": "Agenție",
  "pz.d.distanta": "Distanța până la teren",
  "pz.d.pondere": "Pondere în zonă",
  "pz.d.publicat": "Publicat",
  "pz.d.citit": "Citit de noi",
  "pz.d.necitit": "pagina anunțului nu s-a citit încă",
  "pz.d.finisaje": "Finisaje",
  "pz.d.fatada": "Fațadă",
  "pz.d.fara_semne": "anunțul nu spune nimic despre asta",
  "pz.d.caracteristici": "Toate caracteristicile din anunț",
  "pz.d.descriere": "Descrierea",
  "pz.d.tot_textul": "Tot textul",
  "pz.d.mai_putin": "Mai puțin",
  "pz.nota": "Sursele: Storia (citită direct), imobiliare.ro și OLX (prin Zyte); un apartament anunțat pe mai multe surse sau de mai multe agenții apare o singură dată, cu legături spre celelalte anunțuri. Finisajele și fațada sunt estimate din textul anunțului, după reguli fixe, și arată frazele pe care s-a sprijinit estimarea: ghicitul din poze ar cere un model AI, iar Storia nu permite ca anunțurile ei să ajungă la AI. Ponderea unei oferte: jumătate la fiecare {km} km de teren și la fiecare {ani} de vechime a blocului.",
  "pz.tva_fara": "+ TVA",
  "pz.tva_fara_t": "Anunțul spune că prețul e fără TVA: «{dovezi}». Profilul zonei îl ia ca preț net.",
  "pz.p.provizoriu": "provizoriu",
  "pz.p.provizoriu_t": "Se caută încă: profilul e făcut din ofertele găsite până acum.",
  "pz.p.pe_ce": "pe {oferte} cu preț și pin pe hartă; fiecare cântărește după distanța până la teren și vechimea blocului",
  "pz.p.ponderat": "media ponderată a prețurilor cerute",
  "pz.p.plaja": "mediana {mediana} · 80 % dintre oferte între {p10} și {p90}",
  "pz.p.excluse": "Nu intră: {lista}.",
  "pz.p.ex.suspect#n": "o ofertă suspectă|{n} oferte suspecte|{n} de oferte suspecte",
  "pz.p.ex.ansamblu#n": "un ansamblu fără preț|{n} ansambluri fără preț|{n} de ansambluri fără preț",
  "pz.p.ex.fara_pret#n": "o ofertă fără preț|{n} oferte fără preț|{n} de oferte fără preț",
  "pz.p.ex.alta_moneda#n": "o ofertă în altă monedă|{n} oferte în altă monedă|{n} de oferte în altă monedă",
  "pz.p.aprox": "{oferte} fără pin pe hartă stau deoparte: distanța lor e până la cartier, deci nu se știe dacă sunt în zonă. La ele: {ponderat} ponderat, mediana {mediana}.",
  "pz.p.camere": "Pe camere",
  "pz.p.parte": "Parte din zonă",
  "pz.p.pret_mp": "€/m² ponderat",
  "pz.p.suprafata": "Suprafață tipică",
  "pz.p.oferte": "Oferte",
  "pz.p.finisaje": "Finisaje, estimate din text",
  "pz.p.fatade": "Fațade, estimate din text",
  "pz.p.fara_semne#n": "o ofertă fără semne nu intră în împărțire|{n} oferte fără semne nu intră în împărțire|{n} de oferte fără semne nu intră în împărțire",
  "pz.p.piata": "Piața",
  "pz.p.mediana": "mediana {v}",
  "pz.p.tva#n": "TVA: o ofertă scrie «+ TVA», deci prețul ei e fără TVA|TVA: {n} oferte scriu «+ TVA», deci prețul lor e fără TVA|TVA: {n} de oferte scriu «+ TVA», deci prețul lor e fără TVA",
  "pz.p.tva_rest": "«TVA inclus»: {cu}; fără nicio mențiune: {nespus}.",
  "pz.p.inele": "Pe distanță",
  "pz.p.inel": "{de_la}–{pana_la} km",
  "pz.p.inel_sub": "sub {km} km",
  "pz.p.g.1": "garsoniere",
  "pz.p.g.2": "2 camere",
  "pz.p.g.3": "3 camere",
  "pz.p.g.4": "4+ camere",
  "pz.p.rec.mix_pe": "Împărțirea ponderată a {oferte} din zonă, cu suprafața tipică a fiecărei grupe. Ofertele arată ce se oferă — ce au ales dezvoltatorii și ce se revinde —, nu cât de repede se vinde.",
  "pz.p.rec.finisaje_pe": "Clasa cu cea mai mare parte ({pct}) dintre cele {estimate} cu finisajul estimat din text: {n}.",
  "pz.p.rec.fata_de": "Celelalte clase cer: {lista}.",
  "pz.p.rec.pret_pe_finisaj": "Media ponderată a celor {oferte} cu finisaje {clasa} ({cerut}/m² cerut), fără TVA: {fara} scriu deja «+ TVA», celelalte se împart la {factor}.",
  "pz.p.rec.pret_pe_toate": "Media ponderată a celor {oferte} ({cerut}/m² cerut), fără TVA: {fara} scriu deja «+ TVA», celelalte se împart la {factor}.",
  "pz.p.rec.cerute": "Sunt prețuri cerute în anunțuri, nu prețuri de vânzare încheiate.",
  "pz.p.rec.putine": "Pentru o recomandare trebuie cel puțin {min} cu preț și pin pe hartă; zona are {n}.",
  "pz.p.rec.fara_oferte": "Nicio ofertă cu preț și pin pe hartă încă; profilul apare după ce se găsesc.",
  "cp.pana_acum": "din {oferte} găsite până acum",
  "cp.se_cauta": "Se caută ofertele din zonă: mai durează {cat}. Cifrele de mai jos sunt din ofertele găsite până acum.",
  "cp.mix": "Mixul care se oferă în zonă",
  "cp.seg_t": "{pct} % {grupa} · ~{suprafata} m² · {pret}/m² cerut · {oferte}",
  "cp.standard": "Standardul care se vinde",
  "cp.standard_pe": "{pct} din cele {estimate} cu finisajul estimat",
  "cp.pret": "Prețul, pentru business case",
  "cp.pret_net": "{pret}/m² fără TVA",
  "cp.pret_pe": "Prețul final mediu ponderat din anunțuri {cerut}/m², cu TVA",
  "cp.fara_punct": "Încă nu știm ce se vinde în zonă: terenul n-are un punct pe hartă. El vine din certificatul de urbanism sau din planul cadastral, iar căutarea pornește când apare.",
  "cp.asteapta": "Poți merge mai departe: când căutarea se termină, mixul și standardul pieței intră singure în temă, dacă nu le-ai schimbat tu.",
  "cp.aplicat": "Aplicat în temă",
  "cp.aplicat_t": "Mixul și suprafețele din temă vin din piață cât timp nu le schimbi tu.",
  "cp.egal_t": "Tema ta are deja mixul pieței.",
  "cp.tema_ta": "Tema ta",
  "cp.piata": "Piața",
  "cp.aplica": "Aplică în temă",
  "cp.aplica_provizoriu_t": "Pune în temă procentele și suprafețele găsite până acum; când căutarea se termină, se actualizează cu cifrele finale, dacă nu le-ai schimbat tu.",
  "cp.detalii": "Vezi detalii",
  "cp.detalii_t": "Tot ce s-a găsit: profilul zonei, toate ofertele, fiecare anunț",
  "cp.din_piata": "din piața zonei",
  "cp.cifrele": "Cifrele zonei",
  "cp.cifrele_arata": "Arată pe camere, finisaje, fațade și distanță",
  "cp.cifrele_ascunde": "Ascunde cifrele",
  "cp.pe_ce_sta": "Pe ce stă recomandarea",
} as const;

export type Cheie = keyof typeof ro;

/** Forma pe care o are ORICE catalog: exact cheile de mai sus, toate. */
export type Catalog = Record<Cheie, string>;
